import { combineReducers } from 'redux';
import { createAction, getType } from 'typesafe-actions';
import { getTypedTools, all } from 'async-saga';
import adapter$1 from 'webrtc-adapter';
import { sendParent as sendParent$1, forwardTo as forwardTo$1, assign, Machine, actions as actions$1, send as send$1, interpret } from 'xstate';
import md5 from 'md5';
import { choose as choose$1 } from 'xstate/lib/actions';
import React__default, { useRef, useEffect, useState, forwardRef, createElement, useCallback } from 'react';
import { useSelector as useSelector$1, useDispatch } from 'react-redux';
import classNames from 'classnames';

var initApp = /*#__PURE__*/createAction('INIT_APP')();
var endpointStatusChanged = /*#__PURE__*/createAction('ENDPOINT_STATUS_CHANGED')();
var connectEndpoint = /*#__PURE__*/createAction('CONNECT_ENDPOINT', function (extension, pin) {
  return {
    extension: extension,
    pin: pin
  };
})();
var connectEndpointGuest = /*#__PURE__*/createAction('CONNECT_ENDPOINT_GUEST', function (guestId, guestPasskey, displayName) {
  return {
    guestId: guestId,
    guestPasskey: guestPasskey,
    displayName: displayName
  };
})();
var disconnectEndpoint = /*#__PURE__*/createAction('DISCONNECT_ENDPOINT')();
var configureEndpoint = /*#__PURE__*/createAction('CONFIG_ENDPOINT')();
var lineStatusChanged = /*#__PURE__*/createAction('LINE_STATUS_CHANGED')(); // export const register = createAction('REGISTER')()
// export const unregister = createAction('UNREGISTER')()

var configureMediaConstraints = /*#__PURE__*/createAction('CONFIGURE_MEDIA_CONSTRAINTS')();
var configureSecondaryRinger = /*#__PURE__*/createAction('CONFIGURE_SECONDARY_RINGER')();
var callStatusChanged = /*#__PURE__*/createAction('CALL_STATUS_CHANGED', function (focusCallIndex, calls) {
  return {
    focusCallIndex: focusCallIndex,
    calls: calls
  };
})();
var dial = /*#__PURE__*/createAction('DIAL')();
var hangUp = /*#__PURE__*/createAction('HANG_UP')();
var muteMicrophone = /*#__PURE__*/createAction('MUTE_MICROPHONE', function (mute) {
  return mute;
})();
var muteSpeaker = /*#__PURE__*/createAction('MUTE_SPEAKER', function (mute) {
  return mute;
})();
var dtmf = /*#__PURE__*/createAction('DTMF')();
var answer = /*#__PURE__*/createAction('ANSWER')();
var hold = /*#__PURE__*/createAction('HOLD')();
var resume = /*#__PURE__*/createAction('RESUME')();
var toggleVideo = /*#__PURE__*/createAction('TOGGLE_VIDEO', function (enable, videoSource) {
  return {
    enable: enable,
    videoSource: videoSource
  };
})();
var setVideoPan = /*#__PURE__*/createAction('SET_VIDEO_PAN')();
var setVideoTilt = /*#__PURE__*/createAction('SET_VIDEO_TILT')();
var setVideoZoom = /*#__PURE__*/createAction('SET_VIDEO_ZOOM')();
var transfer = /*#__PURE__*/createAction('TRANSFER')();
var getCallStats = /*#__PURE__*/createAction('CALL_GET_STATS')();

var actions = {
  __proto__: null,
  initApp: initApp,
  endpointStatusChanged: endpointStatusChanged,
  connectEndpoint: connectEndpoint,
  connectEndpointGuest: connectEndpointGuest,
  disconnectEndpoint: disconnectEndpoint,
  configureEndpoint: configureEndpoint,
  lineStatusChanged: lineStatusChanged,
  configureMediaConstraints: configureMediaConstraints,
  configureSecondaryRinger: configureSecondaryRinger,
  callStatusChanged: callStatusChanged,
  dial: dial,
  hangUp: hangUp,
  muteMicrophone: muteMicrophone,
  muteSpeaker: muteSpeaker,
  dtmf: dtmf,
  answer: answer,
  hold: hold,
  resume: resume,
  toggleVideo: toggleVideo,
  setVideoPan: setVideoPan,
  setVideoTilt: setVideoTilt,
  setVideoZoom: setVideoZoom,
  transfer: transfer,
  getCallStats: getCallStats
};

function secondaryRingerDeviceId(state, action) {
  if (state === void 0) {
    state = '';
  }

  switch (action.type) {
    case getType(configureSecondaryRinger):
      return action.payload;
  }

  return state;
}

var devices = /*#__PURE__*/combineReducers({
  secondaryRingerDeviceId: secondaryRingerDeviceId
});
function selectSecondaryRingerDeviceId(state) {
  return state.janus.devices.secondaryRingerDeviceId;
}

function endpoint(state, action) {
  if (state === void 0) {
    state = {
      canConnect: false,
      canDisconnect: false,
      status: 'offline'
    };
  }

  switch (action.type) {
    case getType(endpointStatusChanged):
      return action.payload;
  }

  return state;
}

function line(state, action) {
  if (state === void 0) {
    state = {
      canRegister: false,
      canUnregister: false,
      status: 'unregistered'
    };
  }

  switch (action.type) {
    case getType(endpointStatusChanged):
      if (action.payload.status === 'offline') {
        return {
          canRegister: false,
          canUnregister: false,
          status: 'unregistered'
        };
      } else {
        return state;
      }

    case getType(lineStatusChanged):
      return action.payload;
  }

  return state;
} // defaulted values so that the ui doesn't have to null check


var noCalls = [{
  callId: '',
  status: 'idle',
  // statusError?: string
  // localStream?: MediaStream
  // remoteStream?: MediaStream
  peerUsername: '',
  peerDisplayName: '',
  canDial: false,
  canRingOut: false,
  canHangUp: false,
  canAnswer: false,
  answerRequested: false,
  featureHoldResume: false,
  canHold: false,
  canResume: false,
  canBlindXfer: false,
  canXfer: false,
  canSendDtmf: false,
  isMuted: false,
  hasRemoteVideo: false,
  hasLocalVideo: false,
  videoSource: undefined,
  canPlayBusyTone: false,
  canPlayReorderTone: false,
  canPlayNuTone: false,
  lastHangupCode: 0,
  isSlowAudioDownlink: false,
  isSlowAudioUplink: false,
  isScreenSharing: function isScreenSharing() {
    return false;
  }
}, {
  callId: '',
  status: 'idle',
  // statusError?: string
  // localStream?: MediaStream
  // remoteStream?: MediaStream
  peerUsername: '',
  peerDisplayName: '',
  canDial: false,
  canRingOut: false,
  canHangUp: false,
  canAnswer: false,
  answerRequested: false,
  featureHoldResume: false,
  canHold: false,
  canResume: false,
  canBlindXfer: false,
  canXfer: false,
  canSendDtmf: false,
  isMuted: false,
  hasRemoteVideo: false,
  hasLocalVideo: false,
  videoSource: undefined,
  canPlayBusyTone: false,
  canPlayReorderTone: false,
  canPlayNuTone: false,
  lastHangupCode: 0,
  isSlowAudioDownlink: false,
  isSlowAudioUplink: false,
  isScreenSharing: function isScreenSharing() {
    return false;
  }
}];

function calls(state, action) {
  if (state === void 0) {
    state = {
      focusCallIndex: 0,
      calls: [].concat(noCalls)
    };
  }

  switch (action.type) {
    case getType(endpointStatusChanged):
      if (action.payload.status === 'offline') {
        return {
          focusCallIndex: 0,
          calls: [].concat(noCalls)
        };
      } else {
        return state;
      }

    case getType(callStatusChanged):
      return action.payload;
  }

  return state;
}

var empty = {
  sipDomain: undefined,
  turnServer: '',
  turnServerUdpPort: '3478',
  turnServerTcpPort: '3478',
  janus: ''
};

function settings(state, action) {
  if (state === void 0) {
    state = empty;
  }

  switch (action.type) {
    case getType(configureEndpoint):
      return action.payload;
  }

  return state;
}

function mediaConstraint(state, action) {
  if (state === void 0) {
    state = {
      autoGainControl: true,
      echoCancellation: true,
      noiseSuppression: true,
      sampleRate: 16000,
      sampleSize: 16,
      channelCount: 1
    };
  }

  switch (action.type) {
    case getType(configureMediaConstraints):
      return action.payload;
  }

  return state;
}

var janus = /*#__PURE__*/combineReducers({
  mediaConstraint: mediaConstraint,
  endpoint: endpoint,
  line: line,
  calls: calls,
  settings: settings,
  devices: devices
});

function getRoot(state) {
  return state.janus;
}

function selectEndpoint(state) {
  return getRoot(state).endpoint;
}
function selectLine(state) {
  return getRoot(state).line;
}
function selectCall(state) {
  var root = getRoot(state).calls;
  return root.calls[root.focusCallIndex];
}
function selectSettings(state) {
  return getRoot(state).settings;
}

function createRootReducer() {
  return janus;
}
function selectJanus(state) {
  return state.janus;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[Symbol.iterator]();
  return it.next.bind(it);
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}
});

var _getTypedTools = /*#__PURE__*/getTypedTools(),
    takeEvery = _getTypedTools.takeEvery;

/* eslint-disable */
Janus.sessions = {};

Janus.isExtensionEnabled = function () {
  if (navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia) {
    // No need for the extension, getDisplayMedia is supported
    return true;
  }

  if (window.navigator.userAgent.match('Chrome')) {
    var chromever = parseInt(window.navigator.userAgent.match(/Chrome\/(.*) /)[1], 10);
    var maxver = 33;
    if (window.navigator.userAgent.match('Linux')) maxver = 35; // "known" crash in chrome 34 and 35 on linux

    if (chromever >= 26 && chromever <= maxver) {
      // Older versions of Chrome don't support this extension-based approach, so lie
      return true;
    }

    return Janus.extension.isInstalled();
  } else {
    // Firefox and others, no need for the extension (but this doesn't mean it will work)
    return true;
  }
};

var defaultExtension = {
  // Screensharing Chrome Extension ID
  extensionId: 'hapfgfdkleiggjjpfpenajgdnfckjpaj',
  isInstalled: function isInstalled() {
    return document.querySelector('#janus-extension-installed') !== null;
  },
  getScreen: function getScreen(callback) {
    var pending = window.setTimeout(function () {
      var error = new Error('NavigatorUserMediaError');
      error.name = 'The required Chrome extension is not installed: click <a href="#">here</a> to install it. (NOTE: this will need you to refresh the page)';
      return callback(error);
    }, 1000);
    this.cache[pending] = callback;
    window.postMessage({
      type: 'janusGetScreen',
      id: pending
    }, '*');
  },
  init: function init() {
    var cache = {};
    this.cache = cache; // Wait for events from the Chrome Extension

    window.addEventListener('message', function (event) {
      if (event.origin != window.location.origin) return;

      if (event.data.type == 'janusGotScreen' && cache[event.data.id]) {
        var callback = cache[event.data.id];
        delete cache[event.data.id];

        if (event.data.sourceId === '') {
          // user canceled
          var error = new Error('NavigatorUserMediaError');
          error.name = 'You cancelled the request for permission, giving up...';
          callback(error);
        } else {
          callback(null, event.data.sourceId);
        }
      } else if (event.data.type == 'janusGetScreenPending') {
        console.log('clearing ', event.data.id);
        window.clearTimeout(event.data.id);
      }
    });
  }
};

Janus.useDefaultDependencies = function (deps) {
  var f = deps && deps.fetch || fetch;
  var p = deps && deps.Promise || Promise;
  var socketCls = deps && deps.WebSocket || WebSocket;
  return {
    newWebSocket: function newWebSocket(server, proto) {
      return new socketCls(server, proto);
    },
    extension: deps && deps.extension || defaultExtension,
    isArray: function isArray(arr) {
      return Array.isArray(arr);
    },
    webRTCAdapter: deps && deps.adapter || adapter,
    httpAPICall: function httpAPICall(url, options) {
      var fetchOptions = {
        method: options.verb,
        headers: {
          'Accept': 'application/json, text/plain, */*'
        },
        cache: 'no-cache'
      };

      if (options.verb === "POST") {
        fetchOptions.headers['Content-Type'] = 'application/json';
      }

      if (options.withCredentials !== undefined) {
        fetchOptions.credentials = options.withCredentials === true ? 'include' : options.withCredentials ? options.withCredentials : 'omit';
      }

      if (options.body) {
        fetchOptions.body = JSON.stringify(options.body);
      }

      var fetching = f(url, fetchOptions)["catch"](function (error) {
        return p.reject({
          message: 'Probably a network error, is the server down?',
          error: error
        });
      });
      /*
       * fetch() does not natively support timeouts.
       * Work around this by starting a timeout manually, and racing it agains the fetch() to see which thing resolves first.
       */

      if (options.timeout) {
        var timeout = new p(function (resolve, reject) {
          var timerId = setTimeout(function () {
            clearTimeout(timerId);
            return reject({
              message: 'Request timed out',
              timeout: options.timeout
            });
          }, options.timeout);
        });
        fetching = p.race([fetching, timeout]);
      }

      fetching.then(function (response) {
        if (response.ok) {
          if (typeof options.success === typeof Janus.noop) {
            return response.json().then(function (parsed) {
              try {
                options.success(parsed);
              } catch (error) {
                Janus.error('Unhandled httpAPICall success callback error', error);
              }
            }, function (error) {
              return p.reject({
                message: 'Failed to parse response body',
                error: error,
                response: response
              });
            });
          }
        } else {
          return p.reject({
            message: 'API call failed',
            response: response
          });
        }
      })["catch"](function (error) {
        if (typeof options.error === typeof Janus.noop) {
          options.error(error.message || '<< internal error >>', error);
        }
      });
      return fetching;
    }
  };
};

Janus.useOldDependencies = function (deps) {
  var jq = deps && deps.jQuery || jQuery;
  var socketCls = deps && deps.WebSocket || WebSocket;
  return {
    newWebSocket: function newWebSocket(server, proto) {
      return new socketCls(server, proto);
    },
    isArray: function isArray(arr) {
      return jq.isArray(arr);
    },
    extension: deps && deps.extension || defaultExtension,
    webRTCAdapter: deps && deps.adapter || adapter,
    httpAPICall: function httpAPICall(url, options) {
      var payload = options.body !== undefined ? {
        contentType: 'application/json',
        data: JSON.stringify(options.body)
      } : {};
      var credentials = options.withCredentials !== undefined ? {
        xhrFields: {
          withCredentials: options.withCredentials
        }
      } : {};
      return jq.ajax(jq.extend(payload, credentials, {
        url: url,
        type: options.verb,
        cache: false,
        dataType: 'json',
        async: options.async,
        timeout: options.timeout,
        success: function success(result) {
          if (typeof options.success === typeof Janus.noop) {
            options.success(result);
          }
        },
        error: function error(xhr, status, err) {
          if (typeof options.error === typeof Janus.noop) {
            options.error(status, err);
          }
        }
      }));
    }
  };
};

Janus.noop = function () {};

Janus.dataChanDefaultLabel = "JanusDataChannel"; // Note: in the future we may want to change this, e.g., as was
// attempted in https://github.com/meetecho/janus-gateway/issues/1670

Janus.endOfCandidates = null; // Stop all tracks from a given stream

Janus.stopAllTracks = function (stream) {
  try {
    // Try a MediaStreamTrack.stop() for each track
    var tracks = stream.getTracks();

    for (var _iterator = _createForOfIteratorHelperLoose(tracks), _step; !(_step = _iterator()).done;) {
      var mst = _step.value;
      Janus.log(mst);

      if (mst) {
        mst.stop();
      }
    }
  } catch (e) {// Do nothing if this fails
  }
}; // Initialization


Janus.init = function (options) {
  options = options || {};
  options.callback = typeof options.callback == "function" ? options.callback : Janus.noop;

  if (Janus.initDone) {
    // Already initialized
    options.callback();
  } else {
    if (typeof console.log == "undefined") {
      console.log = function () {};
    } // Console logging (all debugging disabled by default)


    Janus.trace = Janus.noop;
    Janus.debug = Janus.noop;
    Janus.vdebug = Janus.noop;
    Janus.log = Janus.noop;
    Janus.warn = Janus.noop;
    Janus.error = Janus.noop;

    if (options.debug === true || options.debug === "all") {
      // Enable all debugging levels
      Janus.trace = console.trace.bind(console);
      Janus.debug = console.debug.bind(console);
      Janus.vdebug = console.debug.bind(console);
      Janus.log = console.log.bind(console);
      Janus.warn = console.warn.bind(console);
      Janus.error = console.error.bind(console);
    } else if (Array.isArray(options.debug)) {
      for (var _iterator2 = _createForOfIteratorHelperLoose(options.debug), _step2; !(_step2 = _iterator2()).done;) {
        var d = _step2.value;

        switch (d) {
          case "trace":
            Janus.trace = console.trace.bind(console);
            break;

          case "debug":
            Janus.debug = console.debug.bind(console);
            break;

          case "vdebug":
            Janus.vdebug = console.debug.bind(console);
            break;

          case "log":
            Janus.log = console.log.bind(console);
            break;

          case "warn":
            Janus.warn = console.warn.bind(console);
            break;

          case "error":
            Janus.error = console.error.bind(console);
            break;

          default:
            console.error("Unknown debugging option '" + d + "' (supported: 'trace', 'debug', 'vdebug', 'log', warn', 'error')");
            break;
        }
      }
    }

    Janus.log("Initializing library");
    var usedDependencies = options.dependencies || Janus.useDefaultDependencies();
    Janus.isArray = usedDependencies.isArray;
    Janus.webRTCAdapter = usedDependencies.webRTCAdapter;
    Janus.httpAPICall = usedDependencies.httpAPICall;
    Janus.newWebSocket = usedDependencies.newWebSocket;
    Janus.extension = usedDependencies.extension;
    Janus.extension.init(); // Helper method to enumerate devices

    Janus.listDevices = function (callback, config) {
      callback = typeof callback == "function" ? callback : Janus.noop;
      if (config == null) config = {
        audio: true,
        video: true
      };

      if (Janus.isGetUserMediaAvailable()) {
        navigator.mediaDevices.getUserMedia(config).then(function (stream) {
          navigator.mediaDevices.enumerateDevices().then(function (devices) {
            Janus.debug(devices);
            callback(devices); // Get rid of the now useless stream

            Janus.stopAllTracks(stream);
          });
        })["catch"](function (err) {
          Janus.error(err);
          callback([]);
        });
      } else {
        Janus.warn("navigator.mediaDevices unavailable");
        callback([]);
      }
    }; // Helper methods to attach/reattach a stream to a video element (previously part of adapter.js)


    Janus.attachMediaStream = function (element, stream) {
      try {
        element.srcObject = stream;
      } catch (e) {
        try {
          element.src = URL.createObjectURL(stream);
        } catch (e) {
          Janus.error("Error attaching stream to element");
        }
      }
    };

    Janus.reattachMediaStream = function (to, from) {
      try {
        to.srcObject = from.srcObject;
      } catch (e) {
        try {
          to.src = from.src;
        } catch (e) {
          Janus.error("Error reattaching stream to element");
        }
      }
    }; // Detect tab close: make sure we don't loose existing onbeforeunload handlers
    // (note: for iOS we need to subscribe to a different event, 'pagehide', see
    // https://gist.github.com/thehunmonkgroup/6bee8941a49b86be31a787fe8f4b8cfe)


    var iOS = ['iPad', 'iPhone', 'iPod'].indexOf(navigator.platform) >= 0;
    var eventName = iOS ? 'pagehide' : 'beforeunload';
    var oldOBF = window["on" + eventName];
    window.addEventListener(eventName, function () {
      Janus.log("Closing window");

      for (var s in Janus.sessions) {
        if (Janus.sessions[s] && Janus.sessions[s].destroyOnUnload) {
          Janus.log("Destroying session " + s);
          Janus.sessions[s].destroy({
            unload: true,
            notifyDestroyed: false
          });
        }
      }

      if (oldOBF && typeof oldOBF == "function") {
        oldOBF();
      }
    }); // If this is a Safari Technology Preview, check if VP8 is supported

    Janus.safariVp8 = false;

    if (Janus.webRTCAdapter.browserDetails.browser === 'safari' && Janus.webRTCAdapter.browserDetails.version >= 605) {
      // Let's see if RTCRtpSender.getCapabilities() is there
      if (RTCRtpSender && RTCRtpSender.getCapabilities && RTCRtpSender.getCapabilities("video") && RTCRtpSender.getCapabilities("video").codecs && RTCRtpSender.getCapabilities("video").codecs.length) {
        for (var _iterator3 = _createForOfIteratorHelperLoose(RTCRtpSender.getCapabilities("video").codecs), _step3; !(_step3 = _iterator3()).done;) {
          var codec = _step3.value;

          if (codec && codec.mimeType && codec.mimeType.toLowerCase() === "video/vp8") {
            Janus.safariVp8 = true;
            break;
          }
        }

        if (Janus.safariVp8) {
          Janus.log("This version of Safari supports VP8");
        } else {
          Janus.warn("This version of Safari does NOT support VP8: if you're using a Technology Preview, " + "try enabling the 'WebRTC VP8 codec' setting in the 'Experimental Features' Develop menu");
        }
      } else {
        // We do it in a very ugly way, as there's no alternative...
        // We create a PeerConnection to see if VP8 is in an offer
        var testpc = new RTCPeerConnection({});
        testpc.createOffer({
          offerToReceiveVideo: true
        }).then(function (offer) {
          Janus.safariVp8 = offer.sdp.indexOf("VP8") !== -1;

          if (Janus.safariVp8) {
            Janus.log("This version of Safari supports VP8");
          } else {
            Janus.warn("This version of Safari does NOT support VP8: if you're using a Technology Preview, " + "try enabling the 'WebRTC VP8 codec' setting in the 'Experimental Features' Develop menu");
          }

          testpc.close();
          testpc = null;
        });
      }
    } // Check if this browser supports Unified Plan and transceivers
    // Based on https://codepen.io/anon/pen/ZqLwWV?editors=0010


    Janus.unifiedPlan = false;

    if (window.citrixVdaSupport === true) {
      Janus.unifiedPlan = false;
    } else if (Janus.webRTCAdapter.browserDetails.browser === 'firefox' && Janus.webRTCAdapter.browserDetails.version >= 59) {
      // Firefox definitely does, starting from version 59
      Janus.unifiedPlan = true;
    } else if (Janus.webRTCAdapter.browserDetails.browser === 'chrome' && Janus.webRTCAdapter.browserDetails.version >= 72) {
      // Chrome does, but it's only usable from version 72 on
      Janus.unifiedPlan = true;
    } else if (!window.RTCRtpTransceiver || !('currentDirection' in RTCRtpTransceiver.prototype)) {
      // Safari supports addTransceiver() but not Unified Plan when
      // currentDirection is not defined (see codepen above).
      Janus.unifiedPlan = false;
    } else {
      // Check if addTransceiver() throws an exception
      var tempPc = new RTCPeerConnection();

      try {
        tempPc.addTransceiver('audio');
        Janus.unifiedPlan = true;
      } catch (e) {}

      tempPc.close();
    }

    Janus.initDone = true;
    options.callback();
  }
}; // Helper method to check whether WebRTC is supported by this browser


Janus.isWebrtcSupported = function () {
  return !!window.RTCPeerConnection;
}; // Helper method to check whether devices can be accessed by this browser (e.g., not possible via plain HTTP)


Janus.isGetUserMediaAvailable = function () {
  return navigator.mediaDevices && navigator.mediaDevices.getUserMedia;
}; // Helper method to create random identifiers (e.g., transaction)


Janus.randomString = function (len) {
  var charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var randomString = '';

  for (var i = 0; i < len; i++) {
    var randomPoz = Math.floor(Math.random() * charSet.length);
    randomString += charSet.substring(randomPoz, randomPoz + 1);
  }

  return randomString;
};

Janus.setUnifiedPlan = function (unifiedPlan) {
  Janus.debug("Unified Plan changed from " + Janus.unifiedPlan + " --> " + unifiedPlan);
  Janus.unifiedPlan = unifiedPlan;
};

function Janus(gatewayCallbacks) {
  gatewayCallbacks = gatewayCallbacks || {};
  gatewayCallbacks.success = typeof gatewayCallbacks.success == "function" ? gatewayCallbacks.success : Janus.noop;
  gatewayCallbacks.error = typeof gatewayCallbacks.error == "function" ? gatewayCallbacks.error : Janus.noop;
  gatewayCallbacks.destroyed = typeof gatewayCallbacks.destroyed == "function" ? gatewayCallbacks.destroyed : Janus.noop;

  if (!Janus.initDone) {
    gatewayCallbacks.error("Library not initialized");
    return {};
  }

  if (!Janus.isWebrtcSupported()) {
    gatewayCallbacks.error("WebRTC not supported by this browser");
    return {};
  }

  Janus.log("Library initialized: " + Janus.initDone);

  if (!gatewayCallbacks.server) {
    gatewayCallbacks.error("Invalid server url");
    return {};
  }

  var websockets = false;
  var ws = null;
  var wsHandlers = {};
  var wsKeepaliveTimeoutId = null;
  var servers = null;
  var serversIndex = 0;
  var server = gatewayCallbacks.server;

  if (Janus.isArray(server)) {
    Janus.log("Multiple servers provided (" + server.length + "), will use the first that works");
    server = null;
    servers = gatewayCallbacks.server;
    Janus.debug(servers);
  } else {
    if (server.indexOf("ws") === 0) {
      websockets = true;
      Janus.log("Using WebSockets to contact Janus: " + server);
    } else {
      websockets = false;
      Janus.log("Using REST API to contact Janus: " + server);
    }
  }

  var iceServers = gatewayCallbacks.iceServers || [{
    urls: "stun:stun.l.google.com:19302"
  }];
  var iceTransportPolicy = gatewayCallbacks.iceTransportPolicy;
  var bundlePolicy = gatewayCallbacks.bundlePolicy; // Whether IPv6 candidates should be gathered

  var withCredentials = false;
  if (gatewayCallbacks.withCredentials !== undefined && gatewayCallbacks.withCredentials !== null) withCredentials = gatewayCallbacks.withCredentials === true; // Optional max events

  var maxev = 10;
  if (gatewayCallbacks.max_poll_events !== undefined && gatewayCallbacks.max_poll_events !== null) maxev = gatewayCallbacks.max_poll_events;
  if (maxev < 1) maxev = 1; // Token to use (only if the token based authentication mechanism is enabled)

  var token = null;
  if (gatewayCallbacks.token !== undefined && gatewayCallbacks.token !== null) token = gatewayCallbacks.token; // API secret to use (only if the shared API secret is enabled)

  var apisecret = null;
  if (gatewayCallbacks.apisecret !== undefined && gatewayCallbacks.apisecret !== null) apisecret = gatewayCallbacks.apisecret;
  var janusServerUsername = null;
  var janusServerPassword = null;

  if (gatewayCallbacks.janusServerUsername && gatewayCallbacks.janusServerPassword) {
    janusServerUsername = gatewayCallbacks.janusServerUsername;
    janusServerPassword = gatewayCallbacks.janusServerPassword;
  } // Whether we should destroy this session when onbeforeunload is called


  this.destroyOnUnload = true;
  if (gatewayCallbacks.destroyOnUnload !== undefined && gatewayCallbacks.destroyOnUnload !== null) this.destroyOnUnload = gatewayCallbacks.destroyOnUnload === true; // Some timeout-related values

  var keepAlivePeriod = 25000;
  if (gatewayCallbacks.keepAlivePeriod !== undefined && gatewayCallbacks.keepAlivePeriod !== null) keepAlivePeriod = gatewayCallbacks.keepAlivePeriod;
  if (isNaN(keepAlivePeriod)) keepAlivePeriod = 25000;
  var longPollTimeout = 60000;
  if (gatewayCallbacks.longPollTimeout !== undefined && gatewayCallbacks.longPollTimeout !== null) longPollTimeout = gatewayCallbacks.longPollTimeout;
  if (isNaN(longPollTimeout)) longPollTimeout = 60000; // overrides for default maxBitrate values for simulcasting

  function getMaxBitrates(simulcastMaxBitrates) {
    var maxBitrates = {
      high: 900000,
      medium: 300000,
      low: 100000
    };

    if (simulcastMaxBitrates !== undefined && simulcastMaxBitrates !== null) {
      if (simulcastMaxBitrates.high) maxBitrates.high = simulcastMaxBitrates.high;
      if (simulcastMaxBitrates.medium) maxBitrates.medium = simulcastMaxBitrates.medium;
      if (simulcastMaxBitrates.low) maxBitrates.low = simulcastMaxBitrates.low;
    }

    return maxBitrates;
  }

  var connected = false;
  var sessionId = null;
  var pluginHandles = {};
  var that = this;
  var retries = 0;
  var transactions = {};
  createSession(gatewayCallbacks); // Public methods

  this.getServer = function () {
    return server;
  };

  this.isConnected = function () {
    return connected;
  };

  this.reconnect = function (callbacks) {
    callbacks = callbacks || {};
    callbacks.success = typeof callbacks.success == "function" ? callbacks.success : Janus.noop;
    callbacks.error = typeof callbacks.error == "function" ? callbacks.error : Janus.noop;
    callbacks["reconnect"] = true;
    createSession(callbacks);
  };

  this.getSessionId = function () {
    return sessionId;
  };

  this.getInfo = function (callbacks) {
    getInfo(callbacks);
  };

  this.destroy = function (callbacks) {
    destroySession(callbacks);
  };

  this.attach = function (callbacks) {
    createHandle(callbacks);
  };

  function eventHandler() {
    if (sessionId == null) return;
    Janus.debug('Long poll...');

    if (!connected) {
      Janus.warn("Is the server down? (connected=false)");
      return;
    }

    var longpoll = server + "/" + sessionId + "?rid=" + new Date().getTime();
    if (maxev) longpoll = longpoll + "&maxev=" + maxev;
    if (token) longpoll = longpoll + "&token=" + encodeURIComponent(token);
    if (apisecret) longpoll = longpoll + "&apisecret=" + encodeURIComponent(apisecret);
    Janus.httpAPICall(longpoll, {
      verb: 'GET',
      withCredentials: withCredentials,
      success: handleEvent,
      timeout: longPollTimeout,
      error: function error(textStatus, errorThrown) {
        Janus.error(textStatus + ":", errorThrown);
        retries++;

        if (retries > 3) {
          // Did we just lose the server? :-(
          connected = false;
          gatewayCallbacks.error("Lost connection to the server (is it down?)");
          return;
        }

        eventHandler();
      }
    });
  } // Private event handler: this will trigger plugin callbacks, if set


  function handleEvent(json, skipTimeout) {
    retries = 0;
    if (!websockets && sessionId !== undefined && sessionId !== null && skipTimeout !== true) eventHandler();

    if (!websockets && Janus.isArray(json)) {
      // We got an array: it means we passed a maxev > 1, iterate on all objects
      for (var i = 0; i < json.length; i++) {
        handleEvent(json[i], true);
      }

      return;
    }

    if (json["janus"] === "keepalive") {
      // Nothing happened
      Janus.vdebug("Got a keepalive on session " + sessionId);
      return;
    } else if (json["janus"] === "server_info") {
      // Just info on the Janus instance
      Janus.debug("Got info on the Janus instance");
      Janus.debug(json);
      var _transaction = json["transaction"];

      if (_transaction) {
        var _reportSuccess = transactions[_transaction];
        if (_reportSuccess) _reportSuccess(json);
        delete transactions[_transaction];
      }

      return;
    } else if (json["janus"] === "ack") {
      // Just an ack, we can probably ignore
      Janus.debug("Got an ack on session " + sessionId);
      Janus.debug(json);
      var reconnect = json["reconnect"];

      if (reconnect) {
        Janus.debug("Got a reconnect indication on session " + sessionId);

        for (var handleId in pluginHandles) {
          pluginHandles[handleId].onreconnect();
        }
      }

      var _transaction2 = json["transaction"];

      if (_transaction2) {
        var _reportSuccess2 = transactions[_transaction2];
        if (_reportSuccess2) _reportSuccess2(json);
        delete transactions[_transaction2];
      }

      return;
    } else if (json["janus"] === "success") {
      // Success!
      Janus.debug("Got a success on session " + sessionId);
      Janus.debug(json);
      var _transaction3 = json["transaction"];

      if (_transaction3) {
        var _reportSuccess3 = transactions[_transaction3];
        if (_reportSuccess3) _reportSuccess3(json);
        delete transactions[_transaction3];
      }

      return;
    } else if (json["janus"] === "trickle") {
      // We got a trickle candidate from Janus
      var sender = json["sender"];

      if (!sender) {
        Janus.warn("Missing sender...");
        return;
      }

      var pluginHandle = pluginHandles[sender];

      if (!pluginHandle) {
        Janus.debug("This handle is not attached to this session");
        return;
      }

      var candidate = json["candidate"];
      Janus.debug("Got a trickled candidate on session " + sessionId);
      Janus.debug(candidate);
      var config = pluginHandle.webrtcStuff;

      if (config.pc && config.remoteSdp) {
        // Add candidate right now
        Janus.debug("Adding remote candidate:", candidate);

        if (!candidate || candidate.completed === true) {
          // end-of-candidates
          config.pc.addIceCandidate(Janus.endOfCandidates);
        } else {
          // New candidate
          config.pc.addIceCandidate(candidate);
        }
      } else {
        // We didn't do setRemoteDescription (trickle got here before the offer?)
        Janus.debug("We didn't do setRemoteDescription (trickle got here before the offer?), caching candidate");
        if (!config.candidates) config.candidates = [];
        config.candidates.push(candidate);
        Janus.debug(config.candidates);
      }
    } else if (json["janus"] === "webrtcup") {
      // The PeerConnection with the server is up! Notify this
      Janus.debug("Got a webrtcup event on session " + sessionId);
      Janus.debug(json);
      var _sender = json["sender"];

      if (!_sender) {
        Janus.warn("Missing sender...");
        return;
      }

      var _pluginHandle = pluginHandles[_sender];

      if (!_pluginHandle) {
        Janus.debug("This handle is not attached to this session");
        return;
      }

      _pluginHandle.webrtcState(true);

      return;
    } else if (json["janus"] === "hangup") {
      // A plugin asked the core to hangup a PeerConnection on one of our handles
      Janus.debug("Got a hangup event on session " + sessionId);
      Janus.debug(json);
      var _sender2 = json["sender"];

      if (!_sender2) {
        Janus.warn("Missing sender...");
        return;
      }

      var _pluginHandle2 = pluginHandles[_sender2];

      if (!_pluginHandle2) {
        Janus.debug("This handle is not attached to this session");
        return;
      }

      _pluginHandle2.webrtcState(false, json["reason"]);

      _pluginHandle2.hangup();
    } else if (json["janus"] === "detached") {
      // A plugin asked the core to detach one of our handles
      Janus.debug("Got a detached event on session " + sessionId);
      Janus.debug(json);
      var _sender3 = json["sender"];

      if (!_sender3) {
        Janus.warn("Missing sender...");
        return;
      }

      var _pluginHandle3 = pluginHandles[_sender3];

      if (!_pluginHandle3) {
        // Don't warn here because destroyHandle causes this situation.
        return;
      }

      _pluginHandle3.ondetached();

      _pluginHandle3.detach();
    } else if (json["janus"] === "media") {
      // Media started/stopped flowing
      Janus.debug("Got a media event on session " + sessionId);
      Janus.debug(json);
      var _sender4 = json["sender"];

      if (!_sender4) {
        Janus.warn("Missing sender...");
        return;
      }

      var _pluginHandle4 = pluginHandles[_sender4];

      if (!_pluginHandle4) {
        Janus.debug("This handle is not attached to this session");
        return;
      }

      _pluginHandle4.mediaState(json["type"], json["receiving"]);
    } else if (json["janus"] === "slowlink") {
      Janus.debug("Got a slowlink event on session " + sessionId);
      Janus.debug(json); // Trouble uplink or downlink

      var _sender5 = json["sender"];

      if (!_sender5) {
        Janus.warn("Missing sender...");
        return;
      }

      var _pluginHandle5 = pluginHandles[_sender5];

      if (!_pluginHandle5) {
        Janus.debug("This handle is not attached to this session");
        return;
      }

      _pluginHandle5.slowLink(json["uplink"], json["lost"]);
    } else if (json["janus"] === "inlink_status") {
      Janus.debug("Got a inlink_status event on session " + sessionId);
      Janus.debug(json); // Trouble uplink or downlink

      var _sender6 = json["sender"];

      if (!_sender6) {
        Janus.warn("Missing sender...");
        return;
      }

      var _pluginHandle6 = pluginHandles[_sender6];

      if (!_pluginHandle6) {
        Janus.debug("This handle is not attached to this session");
        return;
      }

      _pluginHandle6.inLinkStatus(json["status"], json["media"]);
    } else if (json["janus"] === "error") {
      // Oops, something wrong happened
      Janus.error("Ooops: " + json["error"].code + " " + json["error"].reason); // FIXME

      Janus.debug(json);
      var transaction = json["transaction"];

      if (transaction) {
        var reportSuccess = transactions[transaction];

        if (reportSuccess) {
          reportSuccess(json);
        }

        delete transactions[transaction];
      }

      return;
    } else if (json["janus"] === "event") {
      Janus.debug("Got a plugin event on session " + sessionId);
      Janus.debug(json);
      var _sender7 = json["sender"];

      if (!_sender7) {
        Janus.warn("Missing sender...");
        return;
      }

      var plugindata = json["plugindata"];

      if (!plugindata) {
        Janus.warn("Missing plugindata...");
        return;
      }

      Janus.debug("  -- Event is coming from " + _sender7 + " (" + plugindata["plugin"] + ")");
      var data = plugindata["data"];
      Janus.debug(data);
      var _pluginHandle7 = pluginHandles[_sender7];

      if (!_pluginHandle7) {
        Janus.warn("This handle is not attached to this session");
        return;
      }

      var jsep = json["jsep"];

      if (jsep) {
        Janus.debug("Handling SDP as well...");
        Janus.debug(jsep);
      }

      var callback = _pluginHandle7.onmessage;

      if (callback) {
        Janus.debug("Notifying application..."); // Send to callback specified when attaching plugin handle

        callback(data, jsep);
      } else {
        // Send to generic callback (?)
        Janus.debug("No provided notification callback");
      }
    } else if (json["janus"] === "timeoutpending") {
      Janus.debug("Timeout nudge on session " + sessionId + ".", json);

      if (wsKeepaliveTimeoutId) {
        clearTimeout(wsKeepaliveTimeoutId);
      }

      keepAlive();
      return;
    } else if (json["janus"] === "timeout") {
      Janus.error("Timeout on session " + sessionId);
      Janus.debug(json);

      if (websockets) {
        ws.close(3504, "Gateway timeout");
      }

      return;
    } else {
      Janus.warn("Unknown message/event  '" + json["janus"] + "' on session " + sessionId);
      Janus.debug(json);
    }
  } // Private helper to send keep-alive messages on WebSockets


  function keepAlive() {
    if (!server || !websockets || !connected) return;
    wsKeepaliveTimeoutId = setTimeout(keepAlive, keepAlivePeriod);
    var request = {
      "janus": "keepalive",
      "session_id": sessionId,
      "transaction": Janus.randomString(12)
    };
    if (token) request["token"] = token;
    if (apisecret) request["apisecret"] = apisecret;

    if (janusServerUsername && janusServerPassword) {
      request["auth_username"] = janusServerUsername;
      request["auth_password"] = janusServerPassword;
    }

    ws.send(JSON.stringify(request));
  } // Private method to create a session


  function createSession(callbacks) {
    var transaction = Janus.randomString(12);
    var request = {
      "janus": "create",
      "transaction": transaction
    };

    if (callbacks["reconnect"]) {
      // We're reconnecting, claim the session
      connected = false;
      request["janus"] = "claim";
      request["session_id"] = sessionId; // If we were using websockets, ignore the old connection

      if (ws) {
        ws.onopen = null;
        ws.onerror = null;
        ws.onclose = null;

        if (wsKeepaliveTimeoutId) {
          clearTimeout(wsKeepaliveTimeoutId);
          wsKeepaliveTimeoutId = null;
        }
      }
    }

    if (token) request["token"] = token;
    if (apisecret) request["apisecret"] = apisecret;

    if (janusServerUsername && janusServerPassword) {
      request["auth_username"] = janusServerUsername;
      request["auth_password"] = janusServerPassword;
    }

    if (!server && Janus.isArray(servers)) {
      // We still need to find a working server from the list we were given
      server = servers[serversIndex];

      if (server.indexOf("ws") === 0) {
        websockets = true;
        Janus.log("Server #" + (serversIndex + 1) + ": trying WebSockets to contact Janus (" + server + ")");
      } else {
        websockets = false;
        Janus.log("Server #" + (serversIndex + 1) + ": trying REST API to contact Janus (" + server + ")");
      }
    }

    if (websockets) {
      ws = Janus.newWebSocket(server, 'janus-protocol');
      wsHandlers = {
        'error': function error() {
          Janus.error("Error connecting to the Janus WebSockets server... " + server);

          if (Janus.isArray(servers) && !callbacks["reconnect"]) {
            serversIndex++;

            if (serversIndex === servers.length) {
              // We tried all the servers the user gave us and they all failed
              callbacks.error("Error connecting to any of the provided Janus servers: Is the server down?");
              return;
            } // Let's try the next server


            server = null;
            setTimeout(function () {
              createSession(callbacks);
            }, 200);
            return;
          }

          callbacks.error("Error connecting to the Janus WebSockets server: Is the server down?");
        },
        'open': function open() {
          // We need to be notified about the success
          transactions[transaction] = function (json) {
            Janus.debug(json);

            if (json["janus"] !== "success") {
              Janus.error("Ooops: " + json["error"].code + " " + json["error"].reason); // FIXME

              callbacks.error(json["error"].reason);
              return;
            }

            wsKeepaliveTimeoutId = setTimeout(keepAlive, keepAlivePeriod);
            connected = true;
            sessionId = json["session_id"] ? json["session_id"] : json.data["id"];

            if (callbacks["reconnect"]) {
              Janus.log("Claimed session: " + sessionId);
            } else {
              Janus.log("Created session: " + sessionId);
            }

            Janus.sessions[sessionId] = that;
            callbacks.success();
          };

          ws.send(JSON.stringify(request));
        },
        'message': function message(event) {
          handleEvent(JSON.parse(event.data));
        },
        'close': function close() {
          if (!server || !connected) {
            return;
          }

          connected = false; // FIXME What if this is called when the page is closed?

          gatewayCallbacks.error("Lost connection to the server (is it down?)");
        }
      };

      for (var eventName in wsHandlers) {
        ws.addEventListener(eventName, wsHandlers[eventName]);
      }

      return;
    }

    Janus.httpAPICall(server, {
      verb: 'POST',
      withCredentials: withCredentials,
      body: request,
      success: function success(json) {
        Janus.debug(json);

        if (json["janus"] !== "success") {
          Janus.error("Ooops: " + json["error"].code + " " + json["error"].reason); // FIXME

          callbacks.error(json["error"].reason);
          return;
        }

        connected = true;
        sessionId = json["session_id"] ? json["session_id"] : json.data["id"];

        if (callbacks["reconnect"]) {
          Janus.log("Claimed session: " + sessionId);
        } else {
          Janus.log("Created session: " + sessionId);
        }

        Janus.sessions[sessionId] = that;
        eventHandler();
        callbacks.success();
      },
      error: function error(textStatus, errorThrown) {
        Janus.error(textStatus + ":", errorThrown); // FIXME

        if (Janus.isArray(servers) && !callbacks["reconnect"]) {
          serversIndex++;

          if (serversIndex === servers.length) {
            // We tried all the servers the user gave us and they all failed
            callbacks.error("Error connecting to any of the provided Janus servers: Is the server down?");
            return;
          } // Let's try the next server


          server = null;
          setTimeout(function () {
            createSession(callbacks);
          }, 200);
          return;
        }

        if (errorThrown === "") callbacks.error(textStatus + ": Is the server down?");else if (errorThrown && errorThrown.error) callbacks.error(textStatus + ": " + errorThrown.error.message);else callbacks.error(textStatus + ": " + errorThrown);
      }
    });
  } // Private method to get info on the server


  function getInfo(callbacks) {
    callbacks = callbacks || {}; // FIXME This method triggers a success even when we fail

    callbacks.success = typeof callbacks.success == "function" ? callbacks.success : Janus.noop;
    callbacks.error = typeof callbacks.error == "function" ? callbacks.error : Janus.noop;
    Janus.log("Getting info on Janus instance");

    if (!connected) {
      Janus.warn("Is the server down? (connected=false)");
      callbacks.error("Is the server down? (connected=false)");
      return;
    } // We just need to send an "info" request


    var transaction = Janus.randomString(12);
    var request = {
      "janus": "info",
      "transaction": transaction
    };
    if (token) request["token"] = token;
    if (apisecret) request["apisecret"] = apisecret;

    if (janusServerUsername && janusServerPassword) {
      request["auth_username"] = janusServerUsername;
      request["auth_password"] = janusServerPassword;
    }

    if (websockets) {
      transactions[transaction] = function (json) {
        Janus.log("Server info:");
        Janus.debug(json);

        if (json["janus"] !== "server_info") {
          Janus.error("Ooops: " + json["error"].code + " " + json["error"].reason); // FIXME
        }

        callbacks.success(json);
      };

      ws.send(JSON.stringify(request));
      return;
    }

    Janus.httpAPICall(server, {
      verb: 'POST',
      withCredentials: withCredentials,
      body: request,
      success: function success(json) {
        Janus.log("Server info:");
        Janus.debug(json);

        if (json["janus"] !== "server_info") {
          Janus.error("Ooops: " + json["error"].code + " " + json["error"].reason); // FIXME
        }

        callbacks.success(json);
      },
      error: function error(textStatus, errorThrown) {
        Janus.error(textStatus + ":", errorThrown); // FIXME

        if (errorThrown === "") callbacks.error(textStatus + ": Is the server down?");else callbacks.error(textStatus + ": " + errorThrown);
      }
    });
  } // Private method to destroy a session


  function destroySession(callbacks) {
    callbacks = callbacks || {}; // FIXME This method triggers a success even when we fail

    callbacks.success = typeof callbacks.success == "function" ? callbacks.success : Janus.noop;
    callbacks.error = typeof callbacks.error == "function" ? callbacks.error : Janus.noop;
    var unload = callbacks.unload === true;
    var notifyDestroyed = true;
    if (callbacks.notifyDestroyed !== undefined && callbacks.notifyDestroyed !== null) notifyDestroyed = callbacks.notifyDestroyed === true;
    var cleanupHandles = callbacks.cleanupHandles === true;
    Janus.log("Destroying session " + sessionId + " (unload=" + unload + ")");

    if (!sessionId) {
      Janus.warn("No session to destroy");
      callbacks.success();
      if (notifyDestroyed) gatewayCallbacks.destroyed();
      return;
    }

    if (cleanupHandles) {
      for (var handleId in pluginHandles) {
        destroyHandle(handleId, {
          noRequest: true
        });
      }
    }

    if (!connected) {
      Janus.warn("Is the server down? (connected=false)");
      sessionId = null;
      callbacks.success();
      return;
    } // No need to destroy all handles first, Janus will do that itself


    var request = {
      "janus": "destroy",
      "transaction": Janus.randomString(12)
    };
    if (token) request["token"] = token;
    if (apisecret) request["apisecret"] = apisecret;

    if (janusServerUsername && janusServerPassword) {
      request["auth_username"] = janusServerUsername;
      request["auth_password"] = janusServerPassword;
    }

    if (unload) {
      // We're unloading the page: use sendBeacon for HTTP instead,
      // or just close the WebSocket connection if we're using that
      if (websockets) {
        ws.onclose = null;
        ws.close();
        ws = null;
      } else {
        navigator.sendBeacon(server + "/" + sessionId, JSON.stringify(request));
      }

      Janus.log("Destroyed session:");
      sessionId = null;
      connected = false;
      callbacks.success();
      if (notifyDestroyed) gatewayCallbacks.destroyed();
      return;
    }

    if (websockets) {
      request["session_id"] = sessionId;

      var unbindWebSocket = function unbindWebSocket() {
        for (var eventName in wsHandlers) {
          ws.removeEventListener(eventName, wsHandlers[eventName]);
        }

        ws.removeEventListener('message', onUnbindMessage);
        ws.removeEventListener('error', onUnbindError);

        if (wsKeepaliveTimeoutId) {
          clearTimeout(wsKeepaliveTimeoutId);
        }

        ws.close();
      };

      var onUnbindMessage = function onUnbindMessage(event) {
        var data = JSON.parse(event.data);

        if (data.session_id == request.session_id && data.transaction == request.transaction) {
          unbindWebSocket();
          callbacks.success();
          if (notifyDestroyed) gatewayCallbacks.destroyed();
        }
      };

      var onUnbindError = function onUnbindError() {
        unbindWebSocket();
        callbacks.error("Failed to destroy the server: Is the server down?");
        if (notifyDestroyed) gatewayCallbacks.destroyed();
      };

      ws.addEventListener('message', onUnbindMessage);
      ws.addEventListener('error', onUnbindError);

      if (ws.readyState === 1) {
        ws.send(JSON.stringify(request));
      } else {
        onUnbindError();
      }

      return;
    }

    Janus.httpAPICall(server + "/" + sessionId, {
      verb: 'POST',
      withCredentials: withCredentials,
      body: request,
      success: function success(json) {
        Janus.log("Destroyed session:");
        Janus.debug(json);
        sessionId = null;
        connected = false;

        if (json["janus"] !== "success") {
          Janus.error("Ooops: " + json["error"].code + " " + json["error"].reason); // FIXME
        }

        callbacks.success();
        if (notifyDestroyed) gatewayCallbacks.destroyed();
      },
      error: function error(textStatus, errorThrown) {
        Janus.error(textStatus + ":", errorThrown); // FIXME
        // Reset everything anyway

        sessionId = null;
        connected = false;
        callbacks.success();
        if (notifyDestroyed) gatewayCallbacks.destroyed();
      }
    });
  } // Private method to create a plugin handle


  function createHandle(callbacks) {
    callbacks = callbacks || {};
    callbacks.success = typeof callbacks.success == "function" ? callbacks.success : Janus.noop;
    callbacks.error = typeof callbacks.error == "function" ? callbacks.error : Janus.noop;
    callbacks.dataChannelOptions = callbacks.dataChannelOptions || {
      ordered: true
    };
    callbacks.consentDialog = typeof callbacks.consentDialog == "function" ? callbacks.consentDialog : Janus.noop;
    callbacks.iceState = typeof callbacks.iceState == "function" ? callbacks.iceState : Janus.noop;
    callbacks.mediaState = typeof callbacks.mediaState == "function" ? callbacks.mediaState : Janus.noop;
    callbacks.webrtcState = typeof callbacks.webrtcState == "function" ? callbacks.webrtcState : Janus.noop;
    callbacks.slowLink = typeof callbacks.slowLink == "function" ? callbacks.slowLink : Janus.noop;
    callbacks.inLinkStatus = typeof callbacks.inLinkStatus == "function" ? callbacks.inLinkStatus : Janus.noop;
    callbacks.onmessage = typeof callbacks.onmessage == "function" ? callbacks.onmessage : Janus.noop;
    callbacks.onlocalstream = typeof callbacks.onlocalstream == "function" ? callbacks.onlocalstream : Janus.noop;
    callbacks.onremotestream = typeof callbacks.onremotestream == "function" ? callbacks.onremotestream : Janus.noop;
    callbacks.ondata = typeof callbacks.ondata == "function" ? callbacks.ondata : Janus.noop;
    callbacks.ondataopen = typeof callbacks.ondataopen == "function" ? callbacks.ondataopen : Janus.noop;
    callbacks.oncleanup = typeof callbacks.oncleanup == "function" ? callbacks.oncleanup : Janus.noop;
    callbacks.ondetached = typeof callbacks.ondetached == "function" ? callbacks.ondetached : Janus.noop;
    callbacks.onreconnect = typeof callbacks.onreconnect == "function" ? callbacks.onreconnect : Janus.noop;

    if (!connected) {
      Janus.warn("Is the server down? (connected=false)");
      callbacks.error("Is the server down? (connected=false)");
      return;
    }

    var plugin = callbacks.plugin;

    if (!plugin) {
      Janus.error("Invalid plugin");
      callbacks.error("Invalid plugin");
      return;
    }

    var opaqueId = callbacks.opaqueId;
    var loopIndex = callbacks.loopIndex;
    var handleToken = callbacks.token ? callbacks.token : token;
    var transaction = Janus.randomString(12);
    var request = {
      "janus": "attach",
      "plugin": plugin,
      "opaque_id": opaqueId,
      "loop_index": loopIndex,
      "transaction": transaction
    };
    if (handleToken) request["token"] = handleToken;
    if (apisecret) request["apisecret"] = apisecret;

    if (janusServerUsername && janusServerPassword) {
      request["auth_username"] = janusServerUsername;
      request["auth_password"] = janusServerPassword;
    }

    if (websockets) {
      transactions[transaction] = function (json) {
        Janus.debug(json);

        if (json["janus"] !== "success") {
          Janus.error("Ooops: " + json["error"].code + " " + json["error"].reason); // FIXME

          callbacks.error("Ooops: " + json["error"].code + " " + json["error"].reason);
          return;
        }

        var handleId = json.data["id"];
        Janus.log("Created handle: " + handleId);
        var pluginHandle = {
          session: that,
          plugin: plugin,
          id: handleId,
          token: handleToken,
          detached: false,
          webrtcStuff: {
            started: false,
            myStream: null,
            streamExternal: false,
            remoteStream: null,
            mySdp: null,
            mediaConstraints: null,
            pc: null,
            dataChannelOptions: callbacks.dataChannelOptions,
            dataChannel: {},
            dtmfSender: null,
            trickle: true,
            iceDone: false,
            volume: {
              value: null,
              timer: null
            },
            bitrate: {
              value: null,
              bsnow: null,
              bsbefore: null,
              tsnow: null,
              tsbefore: null,
              timer: null
            },
            srAudioContext: null,
            srDesktopAudioStream: null
          },
          getId: function getId() {
            return handleId;
          },
          getPlugin: function getPlugin() {
            return plugin;
          },
          getVolume: function getVolume() {
            return _getVolume(handleId, true);
          },
          getRemoteVolume: function getRemoteVolume() {
            return _getVolume(handleId, true);
          },
          getLocalVolume: function getLocalVolume() {
            return _getVolume(handleId, false);
          },
          isAudioMuted: function isAudioMuted() {
            return isMuted(handleId, false);
          },
          muteAudio: function muteAudio() {
            return mute(handleId, false, true);
          },
          unmuteAudio: function unmuteAudio() {
            return mute(handleId, false, false);
          },
          isVideoMuted: function isVideoMuted() {
            return isMuted(handleId, true);
          },
          muteVideo: function muteVideo() {
            return mute(handleId, true, true);
          },
          unmuteVideo: function unmuteVideo() {
            return mute(handleId, true, false);
          },
          getBitrate: function getBitrate() {
            return _getBitrate(handleId);
          },
          send: function send(callbacks) {
            sendMessage(handleId, callbacks);
          },
          data: function data(callbacks) {
            sendData(handleId, callbacks);
          },
          dtmf: function dtmf(callbacks) {
            sendDtmf(handleId, callbacks);
          },
          consentDialog: callbacks.consentDialog,
          iceState: callbacks.iceState,
          mediaState: callbacks.mediaState,
          webrtcState: callbacks.webrtcState,
          slowLink: callbacks.slowLink,
          inLinkStatus: callbacks.inLinkStatus,
          onmessage: callbacks.onmessage,
          createOffer: function createOffer(callbacks) {
            prepareWebrtc(handleId, true, callbacks);
          },
          createAnswer: function createAnswer(callbacks) {
            prepareWebrtc(handleId, false, callbacks);
          },
          handleRemoteJsep: function handleRemoteJsep(callbacks) {
            prepareWebrtcPeer(handleId, callbacks);
          },
          onlocalstream: callbacks.onlocalstream,
          onremotestream: callbacks.onremotestream,
          ondata: callbacks.ondata,
          ondataopen: callbacks.ondataopen,
          oncleanup: callbacks.oncleanup,
          ondetached: callbacks.ondetached,
          hangup: function hangup(sendRequest) {
            cleanupWebrtc(handleId, sendRequest === true);
          },
          detach: function detach(callbacks) {
            destroyHandle(handleId, callbacks);
          },
          onreconnect: callbacks.onreconnect
        };
        pluginHandles[handleId] = pluginHandle;
        callbacks.success(pluginHandle);
      };

      request["session_id"] = sessionId;
      ws.send(JSON.stringify(request));
      return;
    }

    Janus.httpAPICall(server + "/" + sessionId, {
      verb: 'POST',
      withCredentials: withCredentials,
      body: request,
      success: function success(json) {
        Janus.debug(json);

        if (json["janus"] !== "success") {
          Janus.error("Ooops: " + json["error"].code + " " + json["error"].reason); // FIXME

          callbacks.error("Ooops: " + json["error"].code + " " + json["error"].reason);
          return;
        }

        var handleId = json.data["id"];
        Janus.log("Created handle: " + handleId);
        var pluginHandle = {
          session: that,
          plugin: plugin,
          id: handleId,
          token: handleToken,
          detached: false,
          webrtcStuff: {
            started: false,
            myStream: null,
            streamExternal: false,
            remoteStream: null,
            mySdp: null,
            mediaConstraints: null,
            pc: null,
            dataChannelOptions: callbacks.dataChannelOptions,
            dataChannel: {},
            dtmfSender: null,
            trickle: true,
            iceDone: false,
            volume: {
              value: null,
              timer: null
            },
            bitrate: {
              value: null,
              bsnow: null,
              bsbefore: null,
              tsnow: null,
              tsbefore: null,
              timer: null
            },
            srAudioContext: null,
            srDesktopAudioStream: null
          },
          getId: function getId() {
            return handleId;
          },
          getPlugin: function getPlugin() {
            return plugin;
          },
          getVolume: function getVolume() {
            return _getVolume(handleId, true);
          },
          getRemoteVolume: function getRemoteVolume() {
            return _getVolume(handleId, true);
          },
          getLocalVolume: function getLocalVolume() {
            return _getVolume(handleId, false);
          },
          isAudioMuted: function isAudioMuted() {
            return isMuted(handleId, false);
          },
          muteAudio: function muteAudio() {
            return mute(handleId, false, true);
          },
          unmuteAudio: function unmuteAudio() {
            return mute(handleId, false, false);
          },
          isVideoMuted: function isVideoMuted() {
            return isMuted(handleId, true);
          },
          muteVideo: function muteVideo() {
            return mute(handleId, true, true);
          },
          unmuteVideo: function unmuteVideo() {
            return mute(handleId, true, false);
          },
          getBitrate: function getBitrate() {
            return _getBitrate(handleId);
          },
          send: function send(callbacks) {
            sendMessage(handleId, callbacks);
          },
          data: function data(callbacks) {
            sendData(handleId, callbacks);
          },
          dtmf: function dtmf(callbacks) {
            sendDtmf(handleId, callbacks);
          },
          consentDialog: callbacks.consentDialog,
          iceState: callbacks.iceState,
          mediaState: callbacks.mediaState,
          webrtcState: callbacks.webrtcState,
          slowLink: callbacks.slowLink,
          inLinkStatus: callbacks.inLinkStatus,
          onmessage: callbacks.onmessage,
          createOffer: function createOffer(callbacks) {
            prepareWebrtc(handleId, true, callbacks);
          },
          createAnswer: function createAnswer(callbacks) {
            prepareWebrtc(handleId, false, callbacks);
          },
          handleRemoteJsep: function handleRemoteJsep(callbacks) {
            prepareWebrtcPeer(handleId, callbacks);
          },
          onlocalstream: callbacks.onlocalstream,
          onremotestream: callbacks.onremotestream,
          ondata: callbacks.ondata,
          ondataopen: callbacks.ondataopen,
          oncleanup: callbacks.oncleanup,
          ondetached: callbacks.ondetached,
          hangup: function hangup(sendRequest) {
            cleanupWebrtc(handleId, sendRequest === true);
          },
          detach: function detach(callbacks) {
            destroyHandle(handleId, callbacks);
          }
        };
        pluginHandles[handleId] = pluginHandle;
        callbacks.success(pluginHandle);
      },
      error: function error(textStatus, errorThrown) {
        Janus.error(textStatus + ":", errorThrown); // FIXME

        if (errorThrown === "") callbacks.error(textStatus + ": Is the server down?");else callbacks.error(textStatus + ": " + errorThrown);
      }
    });
  } // Private method to send a message


  function sendMessage(handleId, callbacks) {
    callbacks = callbacks || {};
    callbacks.success = typeof callbacks.success == "function" ? callbacks.success : Janus.noop;
    callbacks.error = typeof callbacks.error == "function" ? callbacks.error : Janus.noop;

    if (!connected) {
      Janus.warn("Is the server down? (connected=false)");
      callbacks.error("Is the server down? (connected=false)");
      return;
    }

    var pluginHandle = pluginHandles[handleId];

    if (!pluginHandle || !pluginHandle.webrtcStuff) {
      Janus.warn("Invalid handle");
      callbacks.error("Invalid handle");
      return;
    }

    var message = callbacks.message;
    var jsep = callbacks.jsep;
    var transaction = Janus.randomString(12);
    var request = {
      "janus": "message",
      "body": message,
      "transaction": transaction
    };
    if (pluginHandle.token) request["token"] = pluginHandle.token;
    if (apisecret) request["apisecret"] = apisecret;

    if (janusServerUsername && janusServerPassword) {
      request["auth_username"] = janusServerUsername;
      request["auth_password"] = janusServerPassword;
    }

    if (jsep) {
      request.jsep = {
        type: jsep.type,
        sdp: jsep.sdp
      };
      if (jsep.e2ee) request.jsep.e2ee = true;
      if (jsep.rid_order === "hml" || jsep.rid_order === "lmh") request.jsep.rid_order = jsep.rid_order;
      if (jsep.force_relay) request.jsep.force_relay = true;
    }

    Janus.debug("Sending message to plugin (handle=" + handleId + "):");
    Janus.debug(request);

    if (websockets) {
      request["session_id"] = sessionId;
      request["handle_id"] = handleId;

      transactions[transaction] = function (json) {
        Janus.debug("Message sent!");
        Janus.debug(json);

        if (json["janus"] === "success") {
          // We got a success, must have been a synchronous transaction
          var plugindata = json["plugindata"];

          if (!plugindata) {
            Janus.warn("Request succeeded, but missing plugindata...");
            callbacks.success();
            return;
          }

          Janus.log("Synchronous transaction successful (" + plugindata["plugin"] + ")");
          var data = plugindata["data"];
          Janus.debug(data);
          callbacks.success(data);
          return;
        } else if (json["janus"] !== "ack") {
          // Not a success and not an ack, must be an error
          if (json["error"]) {
            Janus.error("Ooops: " + json["error"].code + " " + json["error"].reason); // FIXME

            callbacks.error(json["error"].code + " " + json["error"].reason);
          } else {
            Janus.error("Unknown error"); // FIXME

            callbacks.error("Unknown error");
          }

          return;
        } // If we got here, the plugin decided to handle the request asynchronously


        callbacks.success();
      };

      ws.send(JSON.stringify(request));
      return;
    }

    Janus.httpAPICall(server + "/" + sessionId + "/" + handleId, {
      verb: 'POST',
      withCredentials: withCredentials,
      body: request,
      success: function success(json) {
        Janus.debug("Message sent!");
        Janus.debug(json);

        if (json["janus"] === "success") {
          // We got a success, must have been a synchronous transaction
          var plugindata = json["plugindata"];

          if (!plugindata) {
            Janus.warn("Request succeeded, but missing plugindata...");
            callbacks.success();
            return;
          }

          Janus.log("Synchronous transaction successful (" + plugindata["plugin"] + ")");
          var data = plugindata["data"];
          Janus.debug(data);
          callbacks.success(data);
          return;
        } else if (json["janus"] !== "ack") {
          // Not a success and not an ack, must be an error
          if (json["error"]) {
            Janus.error("Ooops: " + json["error"].code + " " + json["error"].reason); // FIXME

            callbacks.error(json["error"].code + " " + json["error"].reason);
          } else {
            Janus.error("Unknown error"); // FIXME

            callbacks.error("Unknown error");
          }

          return;
        } // If we got here, the plugin decided to handle the request asynchronously


        callbacks.success();
      },
      error: function error(textStatus, errorThrown) {
        Janus.error(textStatus + ":", errorThrown); // FIXME

        callbacks.error(textStatus + ": " + errorThrown);
      }
    });
  } // Private method to send a trickle candidate


  function sendTrickleCandidate(handleId, candidate) {
    if (!connected) {
      Janus.warn("Is the server down? (connected=false)");
      return;
    }

    var pluginHandle = pluginHandles[handleId];

    if (!pluginHandle || !pluginHandle.webrtcStuff) {
      Janus.warn("Invalid handle");
      return;
    }

    var request = {
      "janus": "trickle",
      "candidate": candidate,
      "transaction": Janus.randomString(12)
    };
    if (pluginHandle.token) request["token"] = pluginHandle.token;
    if (apisecret) request["apisecret"] = apisecret;

    if (janusServerUsername && janusServerPassword) {
      request["auth_username"] = janusServerUsername;
      request["auth_password"] = janusServerPassword;
    }

    Janus.vdebug("Sending trickle candidate (handle=" + handleId + "):");
    Janus.vdebug(request);

    if (websockets) {
      request["session_id"] = sessionId;
      request["handle_id"] = handleId;
      ws.send(JSON.stringify(request));
      return;
    }

    Janus.httpAPICall(server + "/" + sessionId + "/" + handleId, {
      verb: 'POST',
      withCredentials: withCredentials,
      body: request,
      success: function success(json) {
        Janus.vdebug("Candidate sent!");
        Janus.vdebug(json);

        if (json["janus"] !== "ack") {
          Janus.error("Ooops: " + json["error"].code + " " + json["error"].reason); // FIXME

          return;
        }
      },
      error: function error(textStatus, errorThrown) {
        Janus.error(textStatus + ":", errorThrown); // FIXME
      }
    });
  } // Private method to create a data channel


  function createDataChannel(handleId, dclabel, dcprotocol, incoming, pendingData) {
    var pluginHandle = pluginHandles[handleId];

    if (!pluginHandle || !pluginHandle.webrtcStuff) {
      Janus.warn("Invalid handle");
      return;
    }

    var config = pluginHandle.webrtcStuff;

    if (!config.pc) {
      Janus.warn("Invalid PeerConnection");
      return;
    }

    var onDataChannelMessage = function onDataChannelMessage(event) {
      Janus.log('Received message on data channel:', event);
      var label = event.target.label;
      pluginHandle.ondata(event.data, label);
    };

    var onDataChannelStateChange = function onDataChannelStateChange(event) {
      Janus.log('Received state change on data channel:', event);
      var label = event.target.label;
      var protocol = event.target.protocol;
      var dcState = config.dataChannel[label] ? config.dataChannel[label].readyState : "null";
      Janus.log('State change on <' + label + '> data channel: ' + dcState);

      if (dcState === 'open') {
        // Any pending messages to send?
        if (config.dataChannel[label].pending && config.dataChannel[label].pending.length > 0) {
          Janus.log("Sending pending messages on <" + label + ">:", config.dataChannel[label].pending.length);

          for (var _iterator4 = _createForOfIteratorHelperLoose(config.dataChannel[label].pending), _step4; !(_step4 = _iterator4()).done;) {
            var data = _step4.value;
            Janus.log("Sending data on data channel <" + label + ">");
            Janus.debug(data);
            config.dataChannel[label].send(data);
          }

          config.dataChannel[label].pending = [];
        } // Notify the open data channel


        pluginHandle.ondataopen(label, protocol);
      }
    };

    var onDataChannelError = function onDataChannelError(error) {
      Janus.error('Got error on data channel:', error); // TODO
    };

    if (!incoming) {
      // FIXME Add options (ordered, maxRetransmits, etc.)
      var dcoptions = config.dataChannelOptions;
      if (dcprotocol) dcoptions.protocol = dcprotocol;
      config.dataChannel[dclabel] = config.pc.createDataChannel(dclabel, dcoptions);
    } else {
      // The channel was created by Janus
      config.dataChannel[dclabel] = incoming;
    }

    config.dataChannel[dclabel].onmessage = onDataChannelMessage;
    config.dataChannel[dclabel].onopen = onDataChannelStateChange;
    config.dataChannel[dclabel].onclose = onDataChannelStateChange;
    config.dataChannel[dclabel].onerror = onDataChannelError;
    config.dataChannel[dclabel].pending = [];
    if (pendingData) config.dataChannel[dclabel].pending.push(pendingData);
  } // Private method to send a data channel message


  function sendData(handleId, callbacks) {
    callbacks = callbacks || {};
    callbacks.success = typeof callbacks.success == "function" ? callbacks.success : Janus.noop;
    callbacks.error = typeof callbacks.error == "function" ? callbacks.error : Janus.noop;
    var pluginHandle = pluginHandles[handleId];

    if (!pluginHandle || !pluginHandle.webrtcStuff) {
      Janus.warn("Invalid handle");
      callbacks.error("Invalid handle");
      return;
    }

    var config = pluginHandle.webrtcStuff;
    var data = callbacks.text || callbacks.data;

    if (!data) {
      Janus.warn("Invalid data");
      callbacks.error("Invalid data");
      return;
    }

    var label = callbacks.label ? callbacks.label : Janus.dataChanDefaultLabel;

    if (!config.dataChannel[label]) {
      // Create new data channel and wait for it to open
      createDataChannel(handleId, label, callbacks.protocol, false, data);
      callbacks.success();
      return;
    }

    if (config.dataChannel[label].readyState !== "open") {
      config.dataChannel[label].pending.push(data);
      callbacks.success();
      return;
    }

    Janus.log("Sending data on data channel <" + label + ">");
    Janus.debug(data);
    config.dataChannel[label].send(data);
    callbacks.success();
  } // Private method to send a DTMF tone


  function sendDtmf(handleId, callbacks) {
    callbacks = callbacks || {};
    callbacks.success = typeof callbacks.success == "function" ? callbacks.success : Janus.noop;
    callbacks.error = typeof callbacks.error == "function" ? callbacks.error : Janus.noop;
    var pluginHandle = pluginHandles[handleId];

    if (!pluginHandle || !pluginHandle.webrtcStuff) {
      Janus.warn("Invalid handle");
      callbacks.error("Invalid handle");
      return;
    }

    var config = pluginHandle.webrtcStuff;

    if (!config.dtmfSender) {
      // Create the DTMF sender the proper way, if possible
      if (config.pc) {
        var senders = config.pc.getSenders();
        var audioSender = senders.find(function (sender) {
          return sender.track && sender.track.kind === 'audio';
        });

        if (!audioSender) {
          Janus.warn("Invalid DTMF configuration (no audio track)");
          callbacks.error("Invalid DTMF configuration (no audio track)");
          return;
        }

        config.dtmfSender = audioSender.dtmf;

        if (config.dtmfSender) {
          Janus.log("Created DTMF Sender");

          config.dtmfSender.ontonechange = function (tone) {
            Janus.debug("Sent DTMF tone: " + tone.tone);
          };
        }
      }

      if (!config.dtmfSender) {
        Janus.warn("Invalid DTMF configuration");
        callbacks.error("Invalid DTMF configuration");
        return;
      }
    }

    var dtmf = callbacks.dtmf;

    if (!dtmf) {
      Janus.warn("Invalid DTMF parameters");
      callbacks.error("Invalid DTMF parameters");
      return;
    }

    var tones = dtmf.tones;

    if (!tones) {
      Janus.warn("Invalid DTMF string");
      callbacks.error("Invalid DTMF string");
      return;
    }

    var duration = typeof dtmf.duration === 'number' ? dtmf.duration : 500; // We choose 500ms as the default duration for a tone

    var gap = typeof dtmf.gap === 'number' ? dtmf.gap : 50; // We choose 50ms as the default gap between tones

    Janus.debug("Sending DTMF string " + tones + " (duration " + duration + "ms, gap " + gap + "ms)");
    config.dtmfSender.insertDTMF(tones, duration, gap);
    callbacks.success();
  } // Private method to destroy a plugin handle


  function destroyHandle(handleId, callbacks) {
    callbacks = callbacks || {};
    callbacks.success = typeof callbacks.success == "function" ? callbacks.success : Janus.noop;
    callbacks.error = typeof callbacks.error == "function" ? callbacks.error : Janus.noop;
    var noRequest = callbacks.noRequest === true;
    Janus.log("Destroying handle " + handleId + " (only-locally=" + noRequest + ")");
    cleanupWebrtc(handleId);
    var pluginHandle = pluginHandles[handleId];

    if (!pluginHandle || pluginHandle.detached) {
      // Plugin was already detached by Janus, calling detach again will return a handle not found error, so just exit here
      delete pluginHandles[handleId];
      callbacks.success();
      return;
    }

    pluginHandle.detached = true;

    if (noRequest) {
      // We're only removing the handle locally
      delete pluginHandles[handleId];
      callbacks.success();
      return;
    }

    if (!connected) {
      Janus.warn("Is the server down? (connected=false)");
      callbacks.error("Is the server down? (connected=false)");
      return;
    }

    var request = {
      "janus": "detach",
      "transaction": Janus.randomString(12)
    };
    if (pluginHandle.token) request["token"] = pluginHandle.token;
    if (apisecret) request["apisecret"] = apisecret;

    if (janusServerUsername && janusServerPassword) {
      request["auth_username"] = janusServerUsername;
      request["auth_password"] = janusServerPassword;
    }

    if (websockets) {
      request["session_id"] = sessionId;
      request["handle_id"] = handleId;
      ws.send(JSON.stringify(request));
      delete pluginHandles[handleId];
      callbacks.success();
      return;
    }

    Janus.httpAPICall(server + "/" + sessionId + "/" + handleId, {
      verb: 'POST',
      withCredentials: withCredentials,
      body: request,
      success: function success(json) {
        Janus.log("Destroyed handle:");
        Janus.debug(json);

        if (json["janus"] !== "success") {
          Janus.error("Ooops: " + json["error"].code + " " + json["error"].reason); // FIXME
        }

        delete pluginHandles[handleId];
        callbacks.success();
      },
      error: function error(textStatus, errorThrown) {
        Janus.error(textStatus + ":", errorThrown); // FIXME
        // We cleanup anyway

        delete pluginHandles[handleId];
        callbacks.success();
      }
    });
  } // WebRTC stuff


  function streamsDone(handleId, jsep, media, callbacks, stream) {
    var pluginHandle = pluginHandles[handleId];

    if (!pluginHandle || !pluginHandle.webrtcStuff) {
      Janus.warn("Invalid handle"); // Close all tracks if the given stream has been created internally

      if (!callbacks.stream) {
        Janus.stopAllTracks(stream);
      }

      callbacks.error("Invalid handle");
      return;
    }

    var config = pluginHandle.webrtcStuff;
    window.webrtcConfig = config;
    Janus.debug("streamsDone:", stream);

    if (stream) {
      Janus.debug("  -- Audio tracks:", stream.getAudioTracks());
      Janus.debug("  -- Video tracks:", stream.getVideoTracks());
    } // We're now capturing the new stream: check if we're updating or if it's a new thing


    var addTracks = false;

    if (!config.myStream || !media.update || config.streamExternal && !media.replaceAudio && !media.replaceVideo) {
      config.myStream = stream;
      addTracks = true;
    } else {
      // We only need to update the existing stream
      if ((!media.update && isAudioSendEnabled(media) || media.update && (media.addAudio || media.replaceAudio)) && stream.getAudioTracks() && stream.getAudioTracks().length) {
        config.myStream.addTrack(stream.getAudioTracks()[0]);

        if (Janus.unifiedPlan) {
          // Use Transceivers
          Janus.log((media.replaceAudio ? "Replacing" : "Adding") + " audio track:", stream.getAudioTracks()[0]);
          var audioTransceiver = null;
          var transceivers = config.pc.getTransceivers();

          if (transceivers && transceivers.length > 0) {
            for (var _iterator5 = _createForOfIteratorHelperLoose(transceivers), _step5; !(_step5 = _iterator5()).done;) {
              var t = _step5.value;

              if (t.sender && t.sender.track && t.sender.track.kind === "audio" || t.receiver && t.receiver.track && t.receiver.track.kind === "audio") {
                audioTransceiver = t;
                break;
              }
            }
          }

          if (audioTransceiver && audioTransceiver.sender) {
            audioTransceiver.sender.replaceTrack(stream.getAudioTracks()[0]);
          } else {
            config.pc.addTrack(stream.getAudioTracks()[0], stream);
          }
        } else {
          Janus.log((media.replaceAudio ? "Replacing" : "Adding") + " audio track:", stream.getAudioTracks()[0]);
          config.pc.addTrack(stream.getAudioTracks()[0], stream);
        }
      }

      if ((!media.update && isVideoSendEnabled(media) || media.update && (media.addVideo || media.replaceVideo)) && stream.getVideoTracks() && stream.getVideoTracks().length) {
        config.myStream.addTrack(stream.getVideoTracks()[0]);

        if (Janus.unifiedPlan) {
          // Use Transceivers
          Janus.log((media.replaceVideo ? "Replacing" : "Adding") + " video track:", stream.getVideoTracks()[0]);
          var videoTransceiver = null;

          var _transceivers = config.pc.getTransceivers();

          if (_transceivers && _transceivers.length > 0) {
            for (var _iterator6 = _createForOfIteratorHelperLoose(_transceivers), _step6; !(_step6 = _iterator6()).done;) {
              var _t = _step6.value;

              if (_t.sender && _t.sender.track && _t.sender.track.kind === "video" || _t.receiver && _t.receiver.track && _t.receiver.track.kind === "video") {
                videoTransceiver = _t;
                break;
              }
            }
          }

          if (videoTransceiver && videoTransceiver.sender) {
            videoTransceiver.sender.replaceTrack(stream.getVideoTracks()[0]);
          } else {
            config.pc.addTrack(stream.getVideoTracks()[0], stream);
          }
        } else {
          Janus.log((media.replaceVideo ? "Replacing" : "Adding") + " video track:", stream.getVideoTracks()[0]);
          config.pc.addTrack(stream.getVideoTracks()[0], stream);
        }
      }
    } // If we still need to create a PeerConnection, let's do that


    if (!config.pc) {
      var pc_config = {
        "iceServers": iceServers,
        "iceTransportPolicy": iceTransportPolicy,
        "bundlePolicy": bundlePolicy
      };

      if (window.citrixVdaSupport === true) {
        pc_config.enableDtlsSrtp = true;
      }

      if (Janus.webRTCAdapter.browserDetails.browser === "chrome") {
        // For Chrome versions before 72, we force a plan-b semantic, and unified-plan otherwise
        pc_config["sdpSemantics"] = Janus.webRTCAdapter.browserDetails.version < 72 ? "plan-b" : "unified-plan";
      }

      var pc_constraints = {};

      if (Janus.webRTCAdapter.browserDetails.browser === "edge") {
        // This is Edge, enable BUNDLE explicitly
        pc_config.bundlePolicy = "max-bundle";
      } // Check if a sender or receiver transform has been provided


      if (RTCRtpSender && (RTCRtpSender.prototype.createEncodedStreams || RTCRtpSender.prototype.createEncodedAudioStreams && RTCRtpSender.prototype.createEncodedVideoStreams) && (callbacks.senderTransforms || callbacks.receiverTransforms)) {
        config.senderTransforms = callbacks.senderTransforms;
        config.receiverTransforms = callbacks.receiverTransforms;
        pc_config["forceEncodedAudioInsertableStreams"] = true;
        pc_config["forceEncodedVideoInsertableStreams"] = true;
        pc_config["encodedInsertableStreams"] = true;
      }

      Janus.log("Creating PeerConnection");
      Janus.debug(pc_constraints);
      config.pc = new RTCPeerConnection(pc_config, pc_constraints);
      Janus.debug(config.pc);

      if (config.pc.getStats) {
        // FIXME
        config.volume = {};
        config.bitrate.value = "0 kbits/sec";
      }

      Janus.log("Preparing local SDP and gathering candidates (trickle=" + config.trickle + ")");

      config.pc.oniceconnectionstatechange = function () {
        if (config.pc) pluginHandle.iceState(config.pc.iceConnectionState);
      };

      config.pc.onicecandidate = function (event) {
        if (!event.candidate || Janus.webRTCAdapter.browserDetails.browser === 'edge' && event.candidate.candidate.indexOf('endOfCandidates') > 0) {
          Janus.log("End of candidates.");
          config.iceDone = true;

          if (config.trickle === true) {
            // Notify end of candidates
            sendTrickleCandidate(handleId, {
              "completed": true
            });
          } else {
            // No trickle, time to send the complete SDP (including all candidates)
            sendSDP(handleId, callbacks);
          }
        } else {
          // JSON.stringify doesn't work on some WebRTC objects anymore
          // See https://code.google.com/p/chromium/issues/detail?id=467366
          var candidate = {
            "candidate": event.candidate.candidate,
            "sdpMid": event.candidate.sdpMid,
            "sdpMLineIndex": event.candidate.sdpMLineIndex
          };

          if (config.trickle === true) {
            // Send candidate
            sendTrickleCandidate(handleId, candidate);
          }
        }
      };

      config.pc.ontrack = function (event) {
        Janus.log("Handling Remote Track");
        Janus.debug(event);
        if (!event.streams) return;
        config.remoteStream = event.streams[0];
        config.remoteTransceiver = event.transceiver;
        pluginHandle.onremotestream(config.remoteStream);
        if (event.track.onended) return;

        if (config.receiverTransforms) {
          var receiverStreams = null;

          if (RTCRtpSender.prototype.createEncodedStreams) {
            receiverStreams = event.receiver.createEncodedStreams();
          } else if (RTCRtpSender.prototype.createAudioEncodedStreams || RTCRtpSender.prototype.createEncodedVideoStreams) {
            if (event.track.kind === "audio" && config.receiverTransforms["audio"]) {
              receiverStreams = event.receiver.createEncodedAudioStreams();
            } else if (event.track.kind === "video" && config.receiverTransforms["video"]) {
              receiverStreams = event.receiver.createEncodedVideoStreams();
            }
          }

          if (receiverStreams) {
            console.log(receiverStreams);

            if (receiverStreams.readableStream && receiverStreams.writableStream) {
              receiverStreams.readableStream.pipeThrough(config.receiverTransforms[event.track.kind]).pipeTo(receiverStreams.writableStream);
            } else if (receiverStreams.readable && receiverStreams.writable) {
              receiverStreams.readable.pipeThrough(config.receiverTransforms[event.track.kind]).pipeTo(receiverStreams.writable);
            }
          }
        }

        var trackMutedTimeoutId = null;
        Janus.log("Adding onended callback to track:", event.track);

        event.track.onended = function (ev) {
          Janus.log("Remote track removed:", ev);

          if (config.remoteStream) {
            clearTimeout(trackMutedTimeoutId);
            config.remoteStream.removeTrack(ev.target);
            pluginHandle.onremotestream(config.remoteStream);
          }
        };

        event.track.onmute = function (ev) {
          Janus.log("Remote track muted:", ev);

          if (config.remoteStream && trackMutedTimeoutId == null) {
            trackMutedTimeoutId = setTimeout(function () {
              Janus.log("Removing remote track");

              if (config.remoteStream) {
                config.remoteStream.removeTrack(ev.target);
                pluginHandle.onremotestream(config.remoteStream);
              }

              trackMutedTimeoutId = null; // Chrome seems to raise mute events only at multiples of 834ms;
              // we set the timeout to three times this value (rounded to 840ms)
            }, 3 * 840);
          }
        };

        event.track.onunmute = function (ev) {
          Janus.log("Remote track flowing again:", ev);

          if (trackMutedTimeoutId != null) {
            clearTimeout(trackMutedTimeoutId);
            trackMutedTimeoutId = null;
          } else {
            try {
              config.remoteStream.addTrack(ev.target);
              pluginHandle.onremotestream(config.remoteStream);
            } catch (e) {
              Janus.error(e);
            }
          }
        };
      };

      if (window.citrixVdaSupport === true) {
        config.pc.onaddstream = function (event) {
          console.log('on add stream callback. This should be the remote stream', event);
          config.remoteStream = event.stream; // Citrix stream is always inactive although it is going.

          config.remoteStream.active = true; // pluginHandle.onremotestream(event.stream)
        };
      }
    }

    if (addTracks && stream) {
      Janus.log('Adding local stream');
      var simulcast = (callbacks.simulcast === true || callbacks.simulcast2 === true) && Janus.unifiedPlan;
      var svc = callbacks.svc;
      stream.getTracks().forEach(function (track) {
        Janus.log('Adding local track:', track);
        var sender = null;

        if (!simulcast && !svc || track.kind === 'audio') {
          sender = config.pc.addTrack(track, stream);
        } else if (simulcast) {
          Janus.log('Enabling rid-based simulcasting:', track);
          var maxBitrates = getMaxBitrates(callbacks.simulcastMaxBitrates);
          var tr = config.pc.addTransceiver(track, {
            direction: "sendrecv",
            streams: [stream],
            sendEncodings: callbacks.sendEncodings || [{
              rid: "h",
              active: true,
              maxBitrate: maxBitrates.high
            }, {
              rid: "m",
              active: true,
              maxBitrate: maxBitrates.medium,
              scaleResolutionDownBy: 2
            }, {
              rid: "l",
              active: true,
              maxBitrate: maxBitrates.low,
              scaleResolutionDownBy: 4
            }]
          });
          if (tr) sender = tr.sender;
        } else {
          Janus.log('Enabling SVC (' + svc + '):', track);

          var _tr = config.pc.addTransceiver(track, {
            direction: "sendrecv",
            streams: [stream],
            sendEncodings: [{
              scalabilityMode: svc
            }]
          });

          if (_tr) sender = _tr.sender;
        } // Check if insertable streams are involved


        if (sender && config.senderTransforms) {
          var senderStreams = null;

          if (RTCRtpSender.prototype.createEncodedStreams) {
            senderStreams = sender.createEncodedStreams();
          } else if (RTCRtpSender.prototype.createAudioEncodedStreams || RTCRtpSender.prototype.createEncodedVideoStreams) {
            if (sender.track.kind === "audio" && config.senderTransforms["audio"]) {
              senderStreams = sender.createEncodedAudioStreams();
            } else if (sender.track.kind === "video" && config.senderTransforms["video"]) {
              senderStreams = sender.createEncodedVideoStreams();
            }
          }

          if (senderStreams) {
            console.log(senderStreams);

            if (senderStreams.readableStream && senderStreams.writableStream) {
              senderStreams.readableStream.pipeThrough(config.senderTransforms[sender.track.kind]).pipeTo(senderStreams.writableStream);
            } else if (senderStreams.readable && senderStreams.writable) {
              senderStreams.readable.pipeThrough(config.senderTransforms[sender.track.kind]).pipeTo(senderStreams.writable);
            }
          }
        }
      });
    } // Any data channel to create?


    if (isDataEnabled(media) && !config.dataChannel[Janus.dataChanDefaultLabel]) {
      Janus.log("Creating default data channel");
      createDataChannel(handleId, Janus.dataChanDefaultLabel, null, false);

      config.pc.ondatachannel = function (event) {
        Janus.log("Data channel created by Janus:", event);
        createDataChannel(handleId, event.channel.label, event.channel.protocol, event.channel);
      };
    } // If there's a new local stream, let's notify the application


    if (config.myStream) {
      Janus.log('informing plugin on stream');

      if (window.citrixVdaSupport === true) {
        // Citrix stream is always inactive although it is going.
        config.myStream.active = true;
      }

      pluginHandle.onlocalstream(config.myStream);
    } // Create offer/answer now


    if (!jsep) {
      Janus.log('streamDone createoffer');
      createOffer(handleId, media, callbacks);
    } else {
      Janus.log('streamDone setRemoteDescription', jsep, jsep.sdp);
      config.pc.setRemoteDescription(jsep).then(function () {
        Janus.log("Remote description accepted!");
        config.remoteSdp = jsep.sdp; // Any trickle candidate we cached?

        if (config.candidates && config.candidates.length > 0) {
          for (var i = 0; i < config.candidates.length; i++) {
            var candidate = config.candidates[i];
            Janus.debug("Adding remote candidate:", candidate);

            if (!candidate || candidate.completed === true) {
              // end-of-candidates
              config.pc.addIceCandidate(Janus.endOfCandidates);
            } else {
              // New candidate
              config.pc.addIceCandidate(candidate);
            }
          }

          config.candidates = [];
        } // Create the answer now


        createAnswer(handleId, media, callbacks);
      }, callbacks.error);
    }
  }

  function prepareWebrtc(handleId, offer, callbacks) {
    callbacks = callbacks || {};
    callbacks.success = typeof callbacks.success == "function" ? callbacks.success : Janus.noop;
    callbacks.error = typeof callbacks.error == "function" ? callbacks.error : webrtcError;
    var jsep = callbacks.jsep;

    if (offer && jsep) {
      Janus.error("Provided a JSEP to a createOffer");
      callbacks.error("Provided a JSEP to a createOffer");
      return;
    } else if (!offer && (!jsep || !jsep.type || !jsep.sdp)) {
      Janus.error("A valid JSEP is required for createAnswer");
      callbacks.error("A valid JSEP is required for createAnswer");
      return;
    }
    /* Check that callbacks.media is a (not null) Object */


    callbacks.media = typeof callbacks.media === 'object' && callbacks.media ? callbacks.media : {
      audio: true,
      video: true
    };
    var media = callbacks.media;
    var pluginHandle = pluginHandles[handleId];

    if (!pluginHandle || !pluginHandle.webrtcStuff) {
      Janus.warn("Invalid handle");
      callbacks.error("Invalid handle");
      return;
    }

    var config = pluginHandle.webrtcStuff;
    config.trickle = isTrickleEnabled(callbacks.trickle); // Are we updating a session?

    if (!config.pc) {
      // Nope, new PeerConnection
      media.update = false;
      media.keepAudio = false;
      media.keepVideo = false;
    } else {
      Janus.log("Updating existing media session");
      media.update = true; // Check if there's anything to add/remove/replace, or if we
      // can go directly to preparing the new SDP offer or answer

      if (callbacks.stream) {
        // External stream: is this the same as the one we were using before?
        if (callbacks.stream !== config.myStream) {
          Janus.log("Renegotiation involves a new external stream");
        }
      } else {
        // Check if there are changes on audio
        if (media.addAudio) {
          media.keepAudio = false;
          media.replaceAudio = false;
          media.removeAudio = false;
          media.audioSend = true;

          if (config.myStream && config.myStream.getAudioTracks() && config.myStream.getAudioTracks().length) {
            Janus.error("Can't add audio stream, there already is one");
            callbacks.error("Can't add audio stream, there already is one");
            return;
          }
        } else if (media.removeAudio) {
          media.keepAudio = false;
          media.replaceAudio = false;
          media.addAudio = false;
          media.audioSend = false;
        } else if (media.replaceAudio) {
          media.keepAudio = false;
          media.addAudio = false;
          media.removeAudio = false;
          media.audioSend = true;
        }

        if (!config.myStream) {
          // No media stream: if we were asked to replace, it's actually an "add"
          if (media.replaceAudio) {
            media.keepAudio = false;
            media.replaceAudio = false;
            media.addAudio = true;
            media.audioSend = true;
          }

          if (isAudioSendEnabled(media)) {
            media.keepAudio = false;
            media.addAudio = true;
          }
        } else {
          if (!config.myStream.getAudioTracks() || config.myStream.getAudioTracks().length === 0) {
            // No audio track: if we were asked to replace, it's actually an "add"
            if (media.replaceAudio) {
              media.keepAudio = false;
              media.replaceAudio = false;
              media.addAudio = true;
              media.audioSend = true;
            }

            if (isAudioSendEnabled(media)) {
              media.keepAudio = false;
              media.addAudio = true;
            }
          } else {
            // We have an audio track: should we keep it as it is?
            if (isAudioSendEnabled(media) && !media.removeAudio && !media.replaceAudio) {
              media.keepAudio = true;
            }
          }
        } // Check if there are changes on video


        if (media.addVideo) {
          media.keepVideo = false;
          media.replaceVideo = false;
          media.removeVideo = false;
          media.videoSend = true;

          if (config.myStream && config.myStream.getVideoTracks() && config.myStream.getVideoTracks().length) {
            Janus.error("Can't add video stream, there already is one");
            callbacks.error("Can't add video stream, there already is one");
            return;
          }
        } else if (media.removeVideo) {
          media.keepVideo = false;
          media.replaceVideo = false;
          media.addVideo = false;
          media.videoSend = false;
        } else if (media.replaceVideo) {
          media.keepVideo = false;
          media.addVideo = false;
          media.removeVideo = false;
          media.videoSend = true;
        }

        if (!config.myStream) {
          // No media stream: if we were asked to replace, it's actually an "add"
          if (media.replaceVideo) {
            media.keepVideo = false;
            media.replaceVideo = false;
            media.addVideo = true;
            media.videoSend = true;
          }

          if (isVideoSendEnabled(media)) {
            media.keepVideo = false;
            media.addVideo = true;
          }
        } else {
          if (!config.myStream.getVideoTracks() || config.myStream.getVideoTracks().length === 0) {
            // No video track: if we were asked to replace, it's actually an "add"
            if (media.replaceVideo) {
              media.keepVideo = false;
              media.replaceVideo = false;
              media.addVideo = true;
              media.videoSend = true;
            }

            if (isVideoSendEnabled(media)) {
              media.keepVideo = false;
              media.addVideo = true;
            }
          } else {
            // We have a video track: should we keep it as it is?
            if (isVideoSendEnabled(media) && !media.removeVideo && !media.replaceVideo) {
              media.keepVideo = true;
            }
          }
        } // Data channels can only be added


        if (media.addData) {
          media.data = true;
        }
      } // If we're updating and keeping all tracks, let's skip the getUserMedia part


      if (isAudioSendEnabled(media) && media.keepAudio && isVideoSendEnabled(media) && media.keepVideo) {
        pluginHandle.consentDialog(false);
        streamsDone(handleId, jsep, media, callbacks, config.myStream);
        return;
      }
    } // If we're updating, check if we need to remove/replace one of the tracks


    if (media.update && (!config.streamExternal || config.streamExternal && (media.replaceAudio || media.replaceVideo))) {
      if (media.removeAudio || media.replaceAudio) {
        if (config.myStream && config.myStream.getAudioTracks() && config.myStream.getAudioTracks().length) {
          var at = config.myStream.getAudioTracks()[0];
          Janus.log("Removing audio track:", at);
          config.myStream.removeTrack(at);

          try {
            at.stop();
          } catch (e) {}
        }

        if (config.pc.getSenders() && config.pc.getSenders().length) {
          var ra = true;

          if (media.replaceAudio && Janus.unifiedPlan) {
            // We can use replaceTrack
            ra = false;
          }

          if (ra) {
            for (var _iterator7 = _createForOfIteratorHelperLoose(config.pc.getSenders()), _step7; !(_step7 = _iterator7()).done;) {
              var asnd = _step7.value;

              if (asnd && asnd.track && asnd.track.kind === "audio") {
                Janus.log("Removing audio sender:", asnd);
                config.pc.removeTrack(asnd);
              }
            }
          }
        }
      }

      if (media.removeVideo || media.replaceVideo) {
        if (config.myStream && config.myStream.getVideoTracks() && config.myStream.getVideoTracks().length) {
          var vt = config.myStream.getVideoTracks()[0];
          Janus.log("Removing video track:", vt);
          config.myStream.removeTrack(vt);

          try {
            vt.stop();
          } catch (e) {}
        }

        if (config.pc.getSenders() && config.pc.getSenders().length) {
          var rv = true;

          if (media.replaceVideo && Janus.unifiedPlan) {
            // We can use replaceTrack
            rv = false;
          }

          if (rv) {
            for (var _iterator8 = _createForOfIteratorHelperLoose(config.pc.getSenders()), _step8; !(_step8 = _iterator8()).done;) {
              var vsnd = _step8.value;

              if (vsnd && vsnd.track && vsnd.track.kind === "video") {
                Janus.log("Removing video sender:", vsnd);
                config.pc.removeTrack(vsnd);
              }
            }
          }
        }
      }
    } // Was a MediaStream object passed, or do we need to take care of that?


    if (callbacks.stream) {
      var stream = callbacks.stream;
      Janus.log("MediaStream provided by the application");
      Janus.debug(stream); // If this is an update, let's check if we need to release the previous stream

      if (media.update && config.myStream && config.myStream !== callbacks.stream && !config.streamExternal && !media.replaceAudio && !media.replaceVideo) {
        // We're replacing a stream we captured ourselves with an external one
        Janus.stopAllTracks(config.myStream);
        config.myStream = null;
      } // Skip the getUserMedia part


      config.streamExternal = true;
      pluginHandle.consentDialog(false);
      streamsDone(handleId, jsep, media, callbacks, stream);
      return;
    }

    if (isAudioSendEnabled(media) || isVideoSendEnabled(media)) {
      if (!Janus.isGetUserMediaAvailable()) {
        callbacks.error("getUserMedia not available");
        return;
      }

      var constraints = {
        mandatory: {},
        optional: []
      };
      pluginHandle.consentDialog(true);
      var audioSupport = isAudioSendEnabled(media);
      if (audioSupport && media && typeof media.audio === 'object') audioSupport = media.audio;
      var videoSupport = isVideoSendEnabled(media);

      if (videoSupport && media) {
        var simulcast = callbacks.simulcast === true || callbacks.simulcast2 === true;
        var svc = callbacks.svc;
        if ((simulcast || svc) && !jsep && !media.video) media.video = "hires";

        if (media.video && media.video != 'screen' && media.video != 'window') {
          if (typeof media.video === 'object') {
            videoSupport = media.video;
          } else {
            var width = 0;
            var height = 0;

            if (media.video === 'lowres') {
              // Small resolution, 4:3
              height = 240;
              width = 320;
            } else if (media.video === 'lowres-16:9') {
              // Small resolution, 16:9
              height = 180;
              width = 320;
            } else if (media.video === 'hires' || media.video === 'hires-16:9' || media.video === 'hdres') {
              // High(HD) resolution is only 16:9
              height = 720;
              width = 1280;
            } else if (media.video === 'fhdres') {
              // Full HD resolution is only 16:9
              height = 1080;
              width = 1920;
            } else if (media.video === '4kres') {
              // 4K resolution is only 16:9
              height = 2160;
              width = 3840;
            } else if (media.video === 'stdres') {
              // Normal resolution, 4:3
              height = 480;
              width = 640;
            } else if (media.video === 'stdres-16:9') {
              // Normal resolution, 16:9
              height = 360;
              width = 640;
            } else {
              Janus.log("Default video setting is stdres 4:3");
              height = 480;
              width = 640;
            }

            Janus.log("Adding media constraint:", media.video);
            videoSupport = {
              'height': {
                'ideal': height
              },
              'width': {
                'ideal': width
              }
            };
            Janus.log("Adding video constraint:", videoSupport);
          }
        } else if (media.video === 'screen' || media.video === 'window') {
          if (navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia) {
            // The new experimental getDisplayMedia API is available, let's use that
            // https://groups.google.com/forum/#!topic/discuss-webrtc/Uf0SrR4uxzk
            // https://webrtchacks.com/chrome-screensharing-getdisplaymedia/
            constraints.video = {};

            if (media.screenshareFrameRate) {
              constraints.video.frameRate = media.screenshareFrameRate;
            }

            if (media.screenshareHeight) {
              constraints.video.height = media.screenshareHeight;
            }

            if (media.screenshareWidth) {
              constraints.video.width = media.screenshareWidth;
            }

            constraints.audio = media.captureDesktopAudio;
            navigator.mediaDevices.getDisplayMedia(constraints).then(function (stream) {
              pluginHandle.consentDialog(false); // only add audio if desktopAudio capture is enabled

              if (isAudioSendEnabled(media) && !media.keepAudio && stream.getAudioTracks().length > 0) {
                navigator.mediaDevices.getUserMedia({
                  audio: true,
                  video: false
                }).then(function (audioStream) {
                  if (stream.getAudioTracks().length > 0) {
                    var desktopAudioTrack = stream.getAudioTracks()[0];
                    stream.removeTrack(desktopAudioTrack);
                    config.srAudioContext = new AudioContext();
                    config.srDesktopAudioStream = new MediaStream([desktopAudioTrack]);
                    var source1 = config.srAudioContext.createMediaStreamSource(config.srDesktopAudioStream);
                    var source2 = config.srAudioContext.createMediaStreamSource(audioStream);
                    var merger = config.srAudioContext.createChannelMerger(2);
                    source1.connect(merger, 0, 0);
                    source2.connect(merger, 0, 1);
                    var combinedStream = config.srAudioContext.createMediaStreamDestination();
                    merger.connect(combinedStream);
                    stream.addTrack(combinedStream.stream.getAudioTracks()[0]);
                    streamsDone(handleId, jsep, media, callbacks, stream);
                  }
                });
              } else {
                streamsDone(handleId, jsep, media, callbacks, stream);
              }
            }, function (error) {
              pluginHandle.consentDialog(false);
              callbacks.error(error);
            });
            return;
          } // We're going to try and use the extension for Chrome 34+, the old approach
          // for older versions of Chrome, or the experimental support in Firefox 33+


          var callbackUserMedia = function callbackUserMedia(error, stream) {
            pluginHandle.consentDialog(false);

            if (error) {
              callbacks.error(error);
            } else {
              streamsDone(handleId, jsep, media, callbacks, stream);
            }
          };

          var getScreenMedia = function getScreenMedia(constraints, gsmCallback, useAudio) {
            Janus.log("Adding media constraint (screen capture)");
            Janus.debug(constraints);
            navigator.mediaDevices.getUserMedia(constraints).then(function (stream) {
              if (useAudio) {
                navigator.mediaDevices.getUserMedia({
                  audio: true,
                  video: false
                }).then(function (audioStream) {
                  stream.addTrack(audioStream.getAudioTracks()[0]);
                  gsmCallback(null, stream);
                });
              } else {
                gsmCallback(null, stream);
              }
            })["catch"](function (error) {
              pluginHandle.consentDialog(false);
              gsmCallback(error);
            });
          };

          if (Janus.webRTCAdapter.browserDetails.browser === 'chrome') {
            var chromever = Janus.webRTCAdapter.browserDetails.version;
            var maxver = 33;
            if (window.navigator.userAgent.match('Linux')) maxver = 35; // "known" crash in chrome 34 and 35 on linux

            if (chromever >= 26 && chromever <= maxver) {
              // Chrome 26->33 requires some awkward chrome://flags manipulation
              constraints = {
                video: {
                  mandatory: {
                    googLeakyBucket: true,
                    maxWidth: window.screen.width,
                    maxHeight: window.screen.height,
                    minFrameRate: media.screenshareFrameRate,
                    maxFrameRate: media.screenshareFrameRate,
                    chromeMediaSource: 'screen'
                  }
                },
                audio: isAudioSendEnabled(media) && !media.keepAudio
              };
              getScreenMedia(constraints, callbackUserMedia);
            } else {
              // Chrome 34+ requires an extension
              Janus.extension.getScreen(function (error, sourceId) {
                if (error) {
                  pluginHandle.consentDialog(false);
                  return callbacks.error(error);
                }

                constraints = {
                  audio: false,
                  video: {
                    mandatory: {
                      chromeMediaSource: 'desktop',
                      maxWidth: window.screen.width,
                      maxHeight: window.screen.height,
                      minFrameRate: media.screenshareFrameRate,
                      maxFrameRate: media.screenshareFrameRate
                    },
                    optional: [{
                      googLeakyBucket: true
                    }, {
                      googTemporalLayeredScreencast: true
                    }]
                  }
                };
                constraints.video.mandatory.chromeMediaSourceId = sourceId;
                getScreenMedia(constraints, callbackUserMedia, isAudioSendEnabled(media) && !media.keepAudio);
              });
            }
          } else if (Janus.webRTCAdapter.browserDetails.browser === 'firefox') {
            if (Janus.webRTCAdapter.browserDetails.version >= 33) {
              // Firefox 33+ has experimental support for screen sharing
              constraints = {
                video: {
                  mozMediaSource: media.video,
                  mediaSource: media.video
                },
                audio: isAudioSendEnabled(media) && !media.keepAudio
              };
              getScreenMedia(constraints, function (err, stream) {
                callbackUserMedia(err, stream); // Workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=1045810

                if (!err) {
                  var lastTime = stream.currentTime;
                  var polly = window.setInterval(function () {
                    if (!stream) window.clearInterval(polly);

                    if (stream.currentTime == lastTime) {
                      window.clearInterval(polly);

                      if (stream.onended) {
                        stream.onended();
                      }
                    }

                    lastTime = stream.currentTime;
                  }, 500);
                }
              });
            } else {
              var error = new Error('NavigatorUserMediaError');
              error.name = 'Your version of Firefox does not support screen sharing, please install Firefox 33 (or more recent versions)';
              pluginHandle.consentDialog(false);
              callbacks.error(error);
              return;
            }
          }

          return;
        }
      } // If we got here, we're not screensharing


      if (!media || media.video !== 'screen') {
        // Check whether all media sources are actually available or not
        navigator.mediaDevices.enumerateDevices().then(function (devices) {
          var audioExist = devices.some(function (device) {
            return device.kind === 'audioinput';
          }),
              videoExist = isScreenSendEnabled(media) || devices.some(function (device) {
            return device.kind === 'videoinput';
          }); // Check whether a missing device is really a problem

          var audioSend = isAudioSendEnabled(media);
          var videoSend = isVideoSendEnabled(media);
          var needAudioDevice = isAudioSendRequired(media);
          var needVideoDevice = isVideoSendRequired(media);

          if (audioSend || videoSend || needAudioDevice || needVideoDevice) {
            // We need to send either audio or video
            var haveAudioDevice = audioSend ? audioExist : false;
            var haveVideoDevice = videoSend ? videoExist : false;

            if (!haveAudioDevice && !haveVideoDevice) {
              // FIXME Should we really give up, or just assume recvonly for both?
              pluginHandle.consentDialog(false);
              callbacks.error('No capture device found');
              return false;
            } else if (!haveAudioDevice && needAudioDevice) {
              pluginHandle.consentDialog(false);
              callbacks.error('Audio capture is required, but no capture device found');
              return false;
            } else if (!haveVideoDevice && needVideoDevice) {
              pluginHandle.consentDialog(false);
              callbacks.error('Video capture is required, but no capture device found');
              return false;
            }
          }

          var gumConstraints = {
            audio: audioExist && !media.keepAudio ? audioSupport : false,
            video: videoExist && !media.keepVideo ? videoSupport : false
          };

          if (!gumConstraints.audio && !gumConstraints.video) {
            pluginHandle.consentDialog(false);
            streamsDone(handleId, jsep, media, callbacks, stream);
          } else {
            if (window.citrixVdaSupport === true) {
              var audioInput = devices.find(function (device) {
                return device.kind === 'audioinput';
              });
              console.info('Citrix audio input device', audioInput);
              gumConstraints.audio = {};
              gumConstraints.audio.deviceId = audioInput.deviceId;

              if (videoSend) {
                var videoInput = devices.find(function (device) {
                  return device.kind === 'videoinput';
                });
                console.info('Citrix video input device', videoInput);
                gumConstraints.video = {
                  mandatory: {
                    "sourceId": videoInput.deviceId,
                    // example: "\\\\?\\usb#vid_046d&pid_0843&mi_00#a&146ac81&0&0000#{65e8773d-8f56-11d0-a3b9-00a0c9223196}\\global"
                    "minWidth": 1080,
                    "maxWidth": 1080,
                    "minHeight": 720,
                    "maxHeight": 720,
                    "maxFrameRate": 30
                  }
                };
              } else {
                // we don't use false, Citrix prefers undefined
                gumConstraints.video = undefined;
              }
            } else if (videoSend) {
              // let's add PTZ into the mix since we're doing video
              gumConstraints.video.pan = true;
              gumConstraints.video.tilt = true;
              gumConstraints.video.zoom = true;
            }

            Janus.debug("getUserMedia constraints", gumConstraints);
            navigator.mediaDevices.getUserMedia(gumConstraints).then(function (stream) {
              Janus.log('media success', stream);
              pluginHandle.consentDialog(false);
              streamsDone(handleId, jsep, media, callbacks, stream);
            })["catch"](function (error) {
              Janus.error('media failed', error);
              pluginHandle.consentDialog(false);
              callbacks.error({
                code: error.code,
                name: error.name,
                message: error.message
              });
            });
          }
        })["catch"](function (error) {
          pluginHandle.consentDialog(false);
          callbacks.error(error);
        });
      }
    } else {
      // No need to do a getUserMedia, create offer/answer right away
      streamsDone(handleId, jsep, media, callbacks);
    }
  }

  function prepareWebrtcPeer(handleId, callbacks) {
    callbacks = callbacks || {};
    callbacks.success = typeof callbacks.success == "function" ? callbacks.success : Janus.noop;
    callbacks.error = typeof callbacks.error == "function" ? callbacks.error : webrtcError;
    callbacks.customizeSdp = typeof callbacks.customizeSdp == "function" ? callbacks.customizeSdp : Janus.noop;
    var jsep = callbacks.jsep;
    var pluginHandle = pluginHandles[handleId];

    if (!pluginHandle || !pluginHandle.webrtcStuff) {
      Janus.warn("Invalid handle");
      callbacks.error("Invalid handle");
      return;
    }

    var config = pluginHandle.webrtcStuff;

    if (jsep) {
      if (!config.pc) {
        Janus.warn("Wait, no PeerConnection?? if this is an answer, use createAnswer and not handleRemoteJsep");
        callbacks.error("No PeerConnection: if this is an answer, use createAnswer and not handleRemoteJsep");
        return;
      }

      callbacks.customizeSdp(jsep);
      Janus.log('prepareWebrtcPeer', jsep, jsep.sdp);
      config.pc.setRemoteDescription(jsep).then(function () {
        Janus.log("Remote description accepted!");
        config.remoteSdp = jsep.sdp; // Any trickle candidate we cached?

        if (config.candidates && config.candidates.length > 0) {
          for (var i = 0; i < config.candidates.length; i++) {
            var candidate = config.candidates[i];
            Janus.debug("Adding remote candidate:", candidate);

            if (!candidate || candidate.completed === true) {
              // end-of-candidates
              config.pc.addIceCandidate(Janus.endOfCandidates);
            } else {
              // New candidate
              config.pc.addIceCandidate(candidate);
            }
          }

          config.candidates = [];
        } // Done


        callbacks.success();
      }, callbacks.error);
    } else {
      callbacks.error("Invalid JSEP");
    }
  }

  function createOffer(handleId, media, callbacks) {
    callbacks = callbacks || {};
    callbacks.success = typeof callbacks.success == "function" ? callbacks.success : Janus.noop;
    callbacks.error = typeof callbacks.error == "function" ? callbacks.error : Janus.noop;
    callbacks.customizeSdp = typeof callbacks.customizeSdp == "function" ? callbacks.customizeSdp : Janus.noop;
    var pluginHandle = pluginHandles[handleId];

    if (!pluginHandle || !pluginHandle.webrtcStuff) {
      Janus.warn("Invalid handle");
      callbacks.error("Invalid handle");
      return;
    }

    var config = pluginHandle.webrtcStuff;
    var simulcast = callbacks.simulcast === true;

    if (!simulcast) {
      Janus.log("Creating offer (iceDone=" + config.iceDone + ")");
    } else {
      Janus.log("Creating offer (iceDone=" + config.iceDone + ", simulcast=" + simulcast + ")");
    } // https://code.google.com/p/webrtc/issues/detail?id=3508


    var mediaConstraints = {};
    Janus.log("determining UnifiedPlan " + Janus.unifiedPlan + ", citrix " + window.citrixVdaSupport + ", citrix transceiver " + config.remoteTransceiver);

    if (Janus.unifiedPlan || window.citrixVdaSupport && config.remoteTransceiver) {
      // We can use Transceivers
      var audioTransceiver = null,
          videoTransceiver = null;

      if (window.citrixVdaSupport) {
        console.log('Using Citrix transceivers to control audio');
        audioTransceiver = config.remoteTransceiver;
      } else {
        var transceivers = config.pc.getTransceivers();

        if (transceivers && transceivers.length > 0) {
          for (var _iterator9 = _createForOfIteratorHelperLoose(transceivers), _step9; !(_step9 = _iterator9()).done;) {
            var t = _step9.value;

            if (t.sender && t.sender.track && t.sender.track.kind === "audio" || t.receiver && t.receiver.track && t.receiver.track.kind === "audio") {
              if (!audioTransceiver) {
                audioTransceiver = t;
              }

              continue;
            }

            if (t.sender && t.sender.track && t.sender.track.kind === "video" || t.receiver && t.receiver.track && t.receiver.track.kind === "video") {
              if (!videoTransceiver) {
                videoTransceiver = t;
              }

              continue;
            }
          }
        }
      } // Handle audio (and related changes, if any)


      var audioSend = isAudioSendEnabled(media);
      var audioRecv = isAudioRecvEnabled(media);

      if (!audioSend && !audioRecv) {
        // Audio disabled: have we removed it?
        if (media.removeAudio && audioTransceiver) {
          if (audioTransceiver.setDirection) {
            audioTransceiver.setDirection("inactive");
          } else {
            audioTransceiver.direction = "inactive";
          }

          Janus.log("Setting audio transceiver to inactive:", audioTransceiver);
        }
      } else {
        // Take care of audio m-line
        if (audioSend && audioRecv) {
          if (audioTransceiver) {
            if (audioTransceiver.setDirection) {
              audioTransceiver.setDirection("sendrecv");
            } else {
              audioTransceiver.direction = "sendrecv";
            }

            Janus.log("Setting audio transceiver to sendrecv:", audioTransceiver);
          }
        } else if (audioSend && !audioRecv) {
          if (audioTransceiver) {
            if (audioTransceiver.setDirection) {
              audioTransceiver.setDirection("sendonly");
            } else {
              audioTransceiver.direction = "sendonly";
            }

            Janus.log("Setting audio transceiver to sendonly:", audioTransceiver);
          }
        } else if (!audioSend && audioRecv) {
          if (audioTransceiver) {
            if (audioTransceiver.setDirection) {
              audioTransceiver.setDirection("recvonly");
            } else {
              audioTransceiver.direction = "recvonly";
            }

            Janus.log("Setting audio transceiver to recvonly:", audioTransceiver);
          } else {
            // In theory, this is the only case where we might not have a transceiver yet
            audioTransceiver = config.pc.addTransceiver("audio", {
              direction: "recvonly"
            });
            Janus.log("Adding recvonly audio transceiver:", audioTransceiver);
          }
        }
      } // Handle video (and related changes, if any)


      var videoSend = isVideoSendEnabled(media);
      var videoRecv = isVideoRecvEnabled(media);

      if (!videoSend && !videoRecv) {
        // Video disabled: have we removed it?
        if (media.removeVideo && videoTransceiver) {
          if (videoTransceiver.setDirection) {
            videoTransceiver.setDirection("inactive");
          } else {
            videoTransceiver.direction = "inactive";
          }

          Janus.log("Setting video transceiver to inactive:", videoTransceiver);
        }
      } else {
        // Take care of video m-line
        if (videoSend && videoRecv) {
          if (videoTransceiver) {
            if (videoTransceiver.setDirection) {
              videoTransceiver.setDirection("sendrecv");
            } else {
              videoTransceiver.direction = "sendrecv";
            }

            Janus.log("Setting video transceiver to sendrecv:", videoTransceiver);
          }
        } else if (videoSend && !videoRecv) {
          if (videoTransceiver) {
            if (videoTransceiver.setDirection) {
              videoTransceiver.setDirection("sendonly");
            } else {
              videoTransceiver.direction = "sendonly";
            }

            Janus.log("Setting video transceiver to sendonly:", videoTransceiver);
          }
        } else if (!videoSend && videoRecv) {
          if (videoTransceiver) {
            if (videoTransceiver.setDirection) {
              videoTransceiver.setDirection("recvonly");
            } else {
              videoTransceiver.direction = "recvonly";
            }

            Janus.log("Setting video transceiver to recvonly:", videoTransceiver);
          } else {
            // In theory, this is the only case where we might not have a transceiver yet
            videoTransceiver = config.pc.addTransceiver("video", {
              direction: "recvonly"
            });
            Janus.log("Adding recvonly video transceiver:", videoTransceiver);
          }
        }
      }

      if (window.citrixVdaSupport) {
        // citrix will still need the constraints, or else it goes and create defaults by adding more tracks.
        mediaConstraints["offerToReceiveAudio"] = audioRecv;
        mediaConstraints["offerToReceiveVideo"] = videoRecv;
      }
    } else {
      mediaConstraints["offerToReceiveAudio"] = isAudioRecvEnabled(media);
      mediaConstraints["offerToReceiveVideo"] = isVideoRecvEnabled(media);
    }

    var iceRestart = callbacks.iceRestart === true;

    if (iceRestart) {
      mediaConstraints["iceRestart"] = true;
    }

    Janus.debug('create offer media constraints', mediaConstraints); // Check if this is Firefox and we've been asked to do simulcasting

    var sendVideo = isVideoSendEnabled(media);

    if (sendVideo && simulcast && Janus.webRTCAdapter.browserDetails.browser === "firefox") {
      // FIXME Based on https://gist.github.com/voluntas/088bc3cc62094730647b
      Janus.log("Enabling Simulcasting for Firefox (RID)");
      var sender = config.pc.getSenders().find(function (s) {
        return s.track && s.track.kind === "video";
      });

      if (sender) {
        var parameters = sender.getParameters();

        if (!parameters) {
          parameters = {};
        }

        var maxBitrates = getMaxBitrates(callbacks.simulcastMaxBitrates);
        parameters.encodings = callbacks.sendEncodings || [{
          rid: "h",
          active: true,
          maxBitrate: maxBitrates.high
        }, {
          rid: "m",
          active: true,
          maxBitrate: maxBitrates.medium,
          scaleResolutionDownBy: 2
        }, {
          rid: "l",
          active: true,
          maxBitrate: maxBitrates.low,
          scaleResolutionDownBy: 4
        }];
        sender.setParameters(parameters);
      }
    }

    config.pc.createOffer(mediaConstraints).then(function (offer) {
      Janus.debug('offer created', offer, offer.sdp); // JSON.stringify doesn't work on some WebRTC objects anymore
      // See https://code.google.com/p/chromium/issues/detail?id=467366

      var jsep = {
        "type": offer.type,
        "sdp": offer.sdp
      };
      callbacks.customizeSdp(jsep);

      if (jsep.sdp.includes('usedtx=0')) {
        jsep.sdp = jsep.sdp.replace('usedtx=0', 'usedtx=1');
      } else if (!jsep.sdp.includes('usedtx=')) {
        jsep.sdp = jsep.sdp.replace('useinbandfec=1', 'useinbandfec=1;usedtx=1');
      }

      if (window.citrixVdaSupport === true) {
        // Citrix hides it modifiable sdp in sdp_, sdp is getter only
        offer.sdp_ = jsep.sdp;
      } else {
        offer.sdp = jsep.sdp;
      }

      Janus.log('setting local description', offer);

      if (sendVideo && simulcast && !Janus.unifiedPlan) {
        // We only do simulcast via SDP munging on older versions of Chrome and Safari
        if (Janus.webRTCAdapter.browserDetails.browser === "chrome" || Janus.webRTCAdapter.browserDetails.browser === "safari") {
          Janus.log("Enabling Simulcasting for Chrome (SDP munging)");
          offer.sdp = mungeSdpForSimulcasting(offer.sdp);
        }
      }

      config.mySdp = {
        type: "offer",
        sdp: offer.sdp
      };
      config.pc.setLocalDescription(offer)["catch"](callbacks.error);

      if (audioSend && audioTransceiver && audioTransceiver.sender) {
        var parameters = audioTransceiver.sender.getParameters();

        if (!parameters) {
          parameters = {};
        }

        if (!parameters.encodings || !Array.isArray(parameters.encodings)) {
          parameters.encodings = [{
            dtx: 'enabled'
          }];
        } else {
          if (parameters.encodings.length < 1) parameters.encodings.push({
            dtx: 'enabled'
          });else {
            parameters.encodings.forEach(function (o) {
              return o.dtx = "enable";
            });
          }
        }

        try {
          audioTransceiver.sender.setParameters(parameters);
        } catch (error) {
          Janus.error('Unable to change audio transceiver dtx parameter', error);
        }
      }

      config.mediaConstraints = mediaConstraints;

      if (!config.iceDone && !config.trickle) {
        // Don't do anything until we have all candidates
        Janus.log("Waiting for all candidates...");
        return;
      } // If transforms are present, notify Janus that the media is end-to-end encrypted


      if (config.senderTransforms || config.receiverTransforms) {
        offer["e2ee"] = true;
      }

      callbacks.success(offer);
    }, callbacks.error);
  }

  function createAnswer(handleId, media, callbacks) {
    callbacks = callbacks || {};
    callbacks.success = typeof callbacks.success == "function" ? callbacks.success : Janus.noop;
    callbacks.error = typeof callbacks.error == "function" ? callbacks.error : Janus.noop;
    callbacks.customizeSdp = typeof callbacks.customizeSdp == "function" ? callbacks.customizeSdp : Janus.noop;
    var pluginHandle = pluginHandles[handleId];

    if (!pluginHandle || !pluginHandle.webrtcStuff) {
      Janus.warn("Invalid handle");
      callbacks.error("Invalid handle");
      return;
    }

    var config = pluginHandle.webrtcStuff;
    var simulcast = callbacks.simulcast === true || callbacks.simulcast2 === true;

    if (!simulcast) {
      Janus.log("Creating answer (iceDone=" + config.iceDone + ")");
    } else {
      Janus.log("Creating answer (iceDone=" + config.iceDone + ", simulcast=" + simulcast + ")");
    }

    var mediaConstraints = null;

    if (Janus.unifiedPlan) {
      // We can use Transceivers
      mediaConstraints = {};
      var audioTransceiver = null,
          videoTransceiver = null;
      var transceivers = config.pc.getTransceivers();

      if (transceivers && transceivers.length > 0) {
        for (var _iterator10 = _createForOfIteratorHelperLoose(transceivers), _step10; !(_step10 = _iterator10()).done;) {
          var t = _step10.value;

          if (t.sender && t.sender.track && t.sender.track.kind === "audio" || t.receiver && t.receiver.track && t.receiver.track.kind === "audio") {
            if (!audioTransceiver) audioTransceiver = t;
            continue;
          }

          if (t.sender && t.sender.track && t.sender.track.kind === "video" || t.receiver && t.receiver.track && t.receiver.track.kind === "video") {
            if (!videoTransceiver) videoTransceiver = t;
            continue;
          }
        }
      } // Handle audio (and related changes, if any)


      var audioSend = isAudioSendEnabled(media);
      var audioRecv = isAudioRecvEnabled(media);

      if (!audioSend && !audioRecv) {
        // Audio disabled: have we removed it?
        if (media.removeAudio && audioTransceiver) {
          try {
            if (audioTransceiver.setDirection) {
              audioTransceiver.setDirection("inactive");
            } else {
              audioTransceiver.direction = "inactive";
            }

            Janus.log("Setting audio transceiver to inactive:", audioTransceiver);
          } catch (e) {
            Janus.error(e);
          }
        }
      } else {
        // Take care of audio m-line
        if (audioSend && audioRecv) {
          if (audioTransceiver) {
            try {
              if (audioTransceiver.setDirection) {
                audioTransceiver.setDirection("sendrecv");
              } else {
                audioTransceiver.direction = "sendrecv";
              }

              Janus.log("Setting audio transceiver to sendrecv:", audioTransceiver);
            } catch (e) {
              Janus.error(e);
            }
          }
        } else if (audioSend && !audioRecv) {
          try {
            if (audioTransceiver) {
              if (audioTransceiver.setDirection) {
                audioTransceiver.setDirection("sendonly");
              } else {
                audioTransceiver.direction = "sendonly";
              }

              Janus.log("Setting audio transceiver to sendonly:", audioTransceiver);
            }
          } catch (e) {
            Janus.error(e);
          }
        } else if (!audioSend && audioRecv) {
          if (audioTransceiver) {
            try {
              if (audioTransceiver.setDirection) {
                audioTransceiver.setDirection("recvonly");
              } else {
                audioTransceiver.direction = "recvonly";
              }

              Janus.log("Setting audio transceiver to recvonly:", audioTransceiver);
            } catch (e) {
              Janus.error(e);
            }
          } else {
            // In theory, this is the only case where we might not have a transceiver yet
            audioTransceiver = config.pc.addTransceiver("audio", {
              direction: "recvonly"
            });
            Janus.log("Adding recvonly audio transceiver:", audioTransceiver);
          }
        }
      } // Handle video (and related changes, if any)


      var videoSend = isVideoSendEnabled(media);
      var videoRecv = isVideoRecvEnabled(media);

      if (!videoSend && !videoRecv) {
        // Video disabled: have we removed it?
        if (media.removeVideo && videoTransceiver) {
          try {
            if (videoTransceiver.setDirection) {
              videoTransceiver.setDirection("inactive");
            } else {
              videoTransceiver.direction = "inactive";
            }

            Janus.log("Setting video transceiver to inactive:", videoTransceiver);
          } catch (e) {
            Janus.error(e);
          }
        }
      } else {
        // Take care of video m-line
        if (videoSend && videoRecv) {
          if (videoTransceiver) {
            try {
              if (videoTransceiver.setDirection) {
                videoTransceiver.setDirection("sendrecv");
              } else {
                videoTransceiver.direction = "sendrecv";
              }

              Janus.log("Setting video transceiver to sendrecv:", videoTransceiver);
            } catch (e) {
              Janus.error(e);
            }
          }
        } else if (videoSend && !videoRecv) {
          if (videoTransceiver) {
            try {
              if (videoTransceiver.setDirection) {
                videoTransceiver.setDirection("sendonly");
              } else {
                videoTransceiver.direction = "sendonly";
              }

              Janus.log("Setting video transceiver to sendonly:", videoTransceiver);
            } catch (e) {
              Janus.error(e);
            }
          }
        } else if (!videoSend && videoRecv) {
          if (videoTransceiver) {
            try {
              if (videoTransceiver.setDirection) {
                videoTransceiver.setDirection("recvonly");
              } else {
                videoTransceiver.direction = "recvonly";
              }

              Janus.log("Setting video transceiver to recvonly:", videoTransceiver);
            } catch (e) {
              Janus.error(e);
            }
          } else {
            // In theory, this is the only case where we might not have a transceiver yet
            videoTransceiver = config.pc.addTransceiver("video", {
              direction: "recvonly"
            });
            Janus.log("Adding recvonly video transceiver:", videoTransceiver);
          }
        }
      }
    } else {
      if (Janus.webRTCAdapter.browserDetails.browser === "firefox" || Janus.webRTCAdapter.browserDetails.browser === "edge") {
        mediaConstraints = {
          offerToReceiveAudio: isAudioRecvEnabled(media),
          offerToReceiveVideo: isVideoRecvEnabled(media)
        };
      } else {
        mediaConstraints = {
          mandatory: {
            OfferToReceiveAudio: isAudioRecvEnabled(media),
            OfferToReceiveVideo: isVideoRecvEnabled(media)
          }
        };
      }
    }

    Janus.debug(mediaConstraints); // Check if this is Firefox and we've been asked to do simulcasting

    var sendVideo = isVideoSendEnabled(media);

    if (sendVideo && simulcast && Janus.webRTCAdapter.browserDetails.browser === "firefox") {
      // FIXME Based on https://gist.github.com/voluntas/088bc3cc62094730647b
      Janus.log("Enabling Simulcasting for Firefox (RID)");
      var sender = config.pc.getSenders()[1];
      Janus.log(sender);
      var parameters = sender.getParameters();
      Janus.log(parameters);
      var maxBitrates = getMaxBitrates(callbacks.simulcastMaxBitrates);
      sender.setParameters({
        encodings: callbacks.sendEncodings || [{
          rid: "h",
          active: true,
          maxBitrate: maxBitrates.high
        }, {
          rid: "m",
          active: true,
          maxBitrate: maxBitrates.medium,
          scaleResolutionDownBy: 2
        }, {
          rid: "l",
          active: true,
          maxBitrate: maxBitrates.low,
          scaleResolutionDownBy: 4
        }]
      });
    }

    config.pc.createAnswer(mediaConstraints).then(function (answer) {
      Janus.debug('create answer', answer, answer.sdp); // JSON.stringify doesn't work on some WebRTC objects anymore
      // See https://code.google.com/p/chromium/issues/detail?id=467366

      var jsep = {
        "type": answer.type,
        "sdp": answer.sdp
      };
      callbacks.customizeSdp(jsep);

      if (jsep.sdp.includes('usedtx=0')) {
        jsep.sdp = jsep.sdp.replace('usedtx=0', 'usedtx=1');
      } else if (!jsep.sdp.includes('usedtx=')) {
        jsep.sdp = jsep.sdp.replace('useinbandfec=1', 'useinbandfec=1;usedtx=1');
      }

      if (window.citrixVdaSupport === true) {
        // Citrix hides it modifiable sdp in sdp_, sdp is getter only
        answer.sdp_ = jsep.sdp;
      } else {
        answer.sdp = jsep.sdp;
      }

      Janus.log("Setting local description");

      if (sendVideo && simulcast && !Janus.unifiedPlan) {
        // We only do simulcast via SDP munging on older versions of Chrome and Safari
        if (Janus.webRTCAdapter.browserDetails.browser === "chrome") {
          // FIXME Apparently trying to simulcast when answering breaks video in Chrome...
          //~ Janus.log("Enabling Simulcasting for Chrome (SDP munging)");
          //~ answer.sdp = mungeSdpForSimulcasting(answer.sdp);
          Janus.warn("simulcast=true, but this is an answer, and video breaks in Chrome if we enable it");
        }
      }

      config.mySdp = {
        type: "answer",
        sdp: answer.sdp
      };
      config.pc.setLocalDescription(answer)["catch"](callbacks.error);

      if (audioSend && audioTransceiver && audioTransceiver.sender) {
        var parameters = audioTransceiver.sender.getParameters();

        if (!parameters) {
          parameters = {};
        }

        if (!parameters.encodings || !Array.isArray(parameters.encodings)) {
          parameters.encodings = [{
            dtx: 'enabled'
          }];
        } else {
          if (parameters.encodings.length < 1) parameters.encodings.push({
            dtx: 'enabled'
          });else {
            parameters.encodings.forEach(function (o) {
              return o.dtx = "enable";
            });
          }
        }

        try {
          audioTransceiver.sender.setParameters(parameters);
        } catch (error) {
          Janus.error('Unable to change audio transceiver dtx parameter', error);
        }
      }

      config.mediaConstraints = mediaConstraints;

      if (!config.iceDone && !config.trickle) {
        // Don't do anything until we have all candidates
        Janus.log("Waiting for all candidates...");
        return;
      } // If transforms are present, notify Janus that the media is end-to-end encrypted


      if (config.senderTransforms || config.receiverTransforms) {
        answer["e2ee"] = true;
      }

      callbacks.success(answer);
    }, callbacks.error);
  }

  function sendSDP(handleId, callbacks) {
    callbacks = callbacks || {};
    callbacks.success = typeof callbacks.success == "function" ? callbacks.success : Janus.noop;
    callbacks.error = typeof callbacks.error == "function" ? callbacks.error : Janus.noop;
    var pluginHandle = pluginHandles[handleId];

    if (!pluginHandle || !pluginHandle.webrtcStuff) {
      Janus.warn("Invalid handle, not sending anything");
      return;
    }

    var config = pluginHandle.webrtcStuff;
    Janus.log("Sending offer/answer SDP...");

    if (!config.mySdp) {
      Janus.warn("Local SDP instance is invalid, not sending anything...");
      return;
    }

    config.mySdp = {
      "type": config.pc.localDescription.type,
      "sdp": config.pc.localDescription.sdp
    };
    if (config.trickle === false) config.mySdp["trickle"] = false;
    Janus.debug(callbacks);
    config.sdpSent = true;
    callbacks.success(config.mySdp);
  }

  function _getVolume(handleId, remote) {
    var pluginHandle = pluginHandles[handleId];

    if (!pluginHandle || !pluginHandle.webrtcStuff) {
      Janus.warn("Invalid handle");
      return 0;
    }

    var stream = remote ? "remote" : "local";
    var config = pluginHandle.webrtcStuff;
    if (!config.volume[stream]) config.volume[stream] = {
      value: 0
    }; // Start getting the volume, if audioLevel in getStats is supported (apparently
    // they're only available in Chrome/Safari right now: https://webrtc-stats.callstats.io/)

    if (config.pc.getStats && (Janus.webRTCAdapter.browserDetails.browser === "chrome" || Janus.webRTCAdapter.browserDetails.browser === "safari")) {
      if (remote && !config.remoteStream) {
        Janus.warn("Remote stream unavailable");
        return 0;
      } else if (!remote && !config.myStream) {
        Janus.warn("Local stream unavailable");
        return 0;
      }

      if (!config.volume[stream].timer) {
        Janus.log("Starting " + stream + " volume monitor");
        config.volume[stream].timer = setInterval(function () {
          config.pc.getStats().then(function (stats) {
            stats.forEach(function (res) {
              if (!res || res.kind !== "audio") return;
              if (remote && !res.remoteSource || !remote && res.type !== "media-source") return;
              config.volume[stream].value = res.audioLevel ? res.audioLevel : 0;
            });
          });
        }, 200);
        return 0; // We don't have a volume to return yet
      }

      return config.volume[stream].value;
    } else {
      // audioInputLevel and audioOutputLevel seem only available in Chrome? audioLevel
      // seems to be available on Chrome and Firefox, but they don't seem to work
      Janus.warn("Getting the " + stream + " volume unsupported by browser");
      return 0;
    }
  }

  function isMuted(handleId, video) {
    var pluginHandle = pluginHandles[handleId];

    if (!pluginHandle || !pluginHandle.webrtcStuff) {
      Janus.warn("Invalid handle");
      return true;
    }

    var config = pluginHandle.webrtcStuff;

    if (!config.pc) {
      Janus.warn("Invalid PeerConnection");
      return true;
    }

    if (!config.myStream) {
      Janus.warn("Invalid local MediaStream");
      return true;
    }

    if (video) {
      // Check video track
      if (!config.myStream.getVideoTracks() || config.myStream.getVideoTracks().length === 0) {
        Janus.warn("No video track");
        return true;
      }

      return !config.myStream.getVideoTracks()[0].enabled;
    } else {
      // Check audio track
      if (!config.myStream.getAudioTracks() || config.myStream.getAudioTracks().length === 0) {
        Janus.warn("No audio track");
        return true;
      }

      return !config.myStream.getAudioTracks()[0].enabled;
    }
  }

  function mute(handleId, video, mute) {
    var pluginHandle = pluginHandles[handleId];

    if (!pluginHandle || !pluginHandle.webrtcStuff) {
      Janus.warn("Invalid handle");
      return false;
    }

    var config = pluginHandle.webrtcStuff;

    if (!config.pc) {
      Janus.warn("Invalid PeerConnection");
      return false;
    }

    if (!config.myStream) {
      Janus.warn("Invalid local MediaStream");
      return false;
    }

    if (video) {
      // Mute/unmute video track
      if (!config.myStream.getVideoTracks() || config.myStream.getVideoTracks().length === 0) {
        Janus.warn("No video track");
        return false;
      }

      config.myStream.getVideoTracks()[0].enabled = !mute;
      return true;
    } else {
      // Mute/unmute audio track
      if (!config.myStream.getAudioTracks() || config.myStream.getAudioTracks().length === 0) {
        Janus.warn("No audio track");
        return false;
      }

      config.myStream.getAudioTracks()[0].enabled = !mute;
      return true;
    }
  }

  function _getBitrate(handleId) {
    var pluginHandle = pluginHandles[handleId];

    if (!pluginHandle || !pluginHandle.webrtcStuff) {
      Janus.warn("Invalid handle");
      return "Invalid handle";
    }

    var config = pluginHandle.webrtcStuff;
    if (!config.pc) return "Invalid PeerConnection"; // Start getting the bitrate, if getStats is supported

    if (config.pc.getStats) {
      if (!config.bitrate.timer) {
        Janus.log("Starting bitrate timer (via getStats)");
        config.bitrate.timer = setInterval(function () {
          config.pc.getStats().then(function (stats) {
            stats.forEach(function (res) {
              if (!res) return;
              var inStats = false; // Check if these are statistics on incoming media

              if ((res.mediaType === "video" || res.id.toLowerCase().indexOf("video") > -1) && res.type === "inbound-rtp" && res.id.indexOf("rtcp") < 0) {
                // New stats
                inStats = true;
              } else if (res.type == 'ssrc' && res.bytesReceived && (res.googCodecName === "VP8" || res.googCodecName === "")) {
                // Older Chromer versions
                inStats = true;
              } // Parse stats now


              if (inStats) {
                config.bitrate.bsnow = res.bytesReceived;
                config.bitrate.tsnow = res.timestamp;

                if (config.bitrate.bsbefore === null || config.bitrate.tsbefore === null) {
                  // Skip this round
                  config.bitrate.bsbefore = config.bitrate.bsnow;
                  config.bitrate.tsbefore = config.bitrate.tsnow;
                } else {
                  // Calculate bitrate
                  var timePassed = config.bitrate.tsnow - config.bitrate.tsbefore;
                  if (Janus.webRTCAdapter.browserDetails.browser === "safari") timePassed = timePassed / 1000; // Apparently the timestamp is in microseconds, in Safari

                  var bitRate = Math.round((config.bitrate.bsnow - config.bitrate.bsbefore) * 8 / timePassed);
                  if (Janus.webRTCAdapter.browserDetails.browser === "safari") bitRate = parseInt(bitRate / 1000);
                  config.bitrate.value = bitRate + ' kbits/sec'; //~ Janus.log("Estimated bitrate is " + config.bitrate.value);

                  config.bitrate.bsbefore = config.bitrate.bsnow;
                  config.bitrate.tsbefore = config.bitrate.tsnow;
                }
              }
            });
          });
        }, 1000);
        return "0 kbits/sec"; // We don't have a bitrate value yet
      }

      return config.bitrate.value;
    } else {
      Janus.warn("Getting the video bitrate unsupported by browser");
      return "Feature unsupported by browser";
    }
  }

  function webrtcError(error) {
    Janus.error("WebRTC error:", error);
  }

  function cleanupWebrtc(handleId, hangupRequest) {
    Janus.log("Cleaning WebRTC stuff");
    var pluginHandle = pluginHandles[handleId];

    if (!pluginHandle) {
      // Nothing to clean
      return;
    }

    var config = pluginHandle.webrtcStuff;

    if (config) {
      if (hangupRequest === true) {
        // Send a hangup request (we don't really care about the response)
        var request = {
          "janus": "hangup",
          "transaction": Janus.randomString(12)
        };
        if (pluginHandle.token) request["token"] = pluginHandle.token;
        if (apisecret) request["apisecret"] = apisecret;

        if (janusServerUsername && janusServerPassword) {
          request["auth_username"] = janusServerUsername;
          request["auth_password"] = janusServerPassword;
        }

        Janus.debug("Sending hangup request (handle=" + handleId + "):");
        Janus.debug(request);

        if (websockets) {
          request["session_id"] = sessionId;
          request["handle_id"] = handleId;
          ws.send(JSON.stringify(request));
        } else {
          Janus.httpAPICall(server + "/" + sessionId + "/" + handleId, {
            verb: 'POST',
            withCredentials: withCredentials,
            body: request
          });
        }
      } // Cleanup stack


      config.remoteStream = null;
      config.remoteTransceiver = null;

      if (config.volume) {
        if (config.volume["local"] && config.volume["local"].timer) clearInterval(config.volume["local"].timer);
        if (config.volume["remote"] && config.volume["remote"].timer) clearInterval(config.volume["remote"].timer);
      }

      config.volume = {};
      if (config.bitrate.timer) clearInterval(config.bitrate.timer);
      config.bitrate.timer = null;
      config.bitrate.bsnow = null;
      config.bitrate.bsbefore = null;
      config.bitrate.tsnow = null;
      config.bitrate.tsbefore = null;
      config.bitrate.value = null;

      if (!config.streamExternal && config.myStream) {
        Janus.log("Stopping local stream tracks");
        Janus.stopAllTracks(config.myStream);
      }

      config.streamExternal = false;
      config.myStream = null;

      if (config.srAudioContext) {
        config.srAudioContext.close();
        config.srAudioContext = null;
      }

      if (config.srDesktopAudioStream) {
        Janus.log("Stopping desktop audio local stream tracks");
        Janus.stopAllTracks(config.srDesktopAudioStream);
      } // Close PeerConnection


      try {
        config.pc.close();
      } catch (e) {// Do nothing
      }

      config.pc = null;
      config.candidates = null;
      config.mySdp = null;
      config.remoteSdp = null;
      config.iceDone = false;
      config.dataChannel = {};
      config.dtmfSender = null;
      config.senderTransforms = null;
      config.receiverTransforms = null;
    }

    pluginHandle.oncleanup();
  } // Helper method to munge an SDP to enable simulcasting (Chrome only)


  function mungeSdpForSimulcasting(sdp) {
    // Let's munge the SDP to add the attributes for enabling simulcasting
    // (based on https://gist.github.com/ggarber/a19b4c33510028b9c657)
    var lines = sdp.split("\r\n");
    var video = false;
    var ssrc = [-1],
        ssrc_fid = [-1];
    var cname = null,
        msid = null,
        mslabel = null,
        label = null;
    var insertAt = -1;

    for (var _i = 0; _i < lines.length; _i++) {
      var mline = lines[_i].match(/m=(\w+) */);

      if (mline) {
        var medium = mline[1];

        if (medium === "video") {
          // New video m-line: make sure it's the first one
          if (ssrc[0] < 0) {
            video = true;
          } else {
            // We're done, let's add the new attributes here
            insertAt = _i;
            break;
          }
        } else {
          // New non-video m-line: do we have what we were looking for?
          if (ssrc[0] > -1) {
            // We're done, let's add the new attributes here
            insertAt = _i;
            break;
          }
        }

        continue;
      }

      if (!video) continue;

      var sim = lines[_i].match(/a=ssrc-group:SIM (\d+) (\d+) (\d+)/);

      if (sim) {
        Janus.warn("The SDP already contains a SIM attribute, munging will be skipped");
        return sdp;
      }

      var fid = lines[_i].match(/a=ssrc-group:FID (\d+) (\d+)/);

      if (fid) {
        ssrc[0] = fid[1];
        ssrc_fid[0] = fid[2];
        lines.splice(_i, 1);
        _i--;
        continue;
      }

      if (ssrc[0]) {
        var match = lines[_i].match('a=ssrc:' + ssrc[0] + ' cname:(.+)');

        if (match) {
          cname = match[1];
        }

        match = lines[_i].match('a=ssrc:' + ssrc[0] + ' msid:(.+)');

        if (match) {
          msid = match[1];
        }

        match = lines[_i].match('a=ssrc:' + ssrc[0] + ' mslabel:(.+)');

        if (match) {
          mslabel = match[1];
        }

        match = lines[_i].match('a=ssrc:' + ssrc[0] + ' label:(.+)');

        if (match) {
          label = match[1];
        }

        if (lines[_i].indexOf('a=ssrc:' + ssrc_fid[0]) === 0) {
          lines.splice(_i, 1);
          _i--;
          continue;
        }

        if (lines[_i].indexOf('a=ssrc:' + ssrc[0]) === 0) {
          lines.splice(_i, 1);
          _i--;
          continue;
        }
      }

      if (lines[_i].length == 0) {
        lines.splice(_i, 1);
        _i--;
        continue;
      }
    }

    if (ssrc[0] < 0) {
      // Couldn't find a FID attribute, let's just take the first video SSRC we find
      insertAt = -1;
      video = false;

      for (var _i2 = 0; _i2 < lines.length; _i2++) {
        var _mline = lines[_i2].match(/m=(\w+) */);

        if (_mline) {
          var _medium = _mline[1];

          if (_medium === "video") {
            // New video m-line: make sure it's the first one
            if (ssrc[0] < 0) {
              video = true;
            } else {
              // We're done, let's add the new attributes here
              insertAt = _i2;
              break;
            }
          } else {
            // New non-video m-line: do we have what we were looking for?
            if (ssrc[0] > -1) {
              // We're done, let's add the new attributes here
              insertAt = _i2;
              break;
            }
          }

          continue;
        }

        if (!video) continue;

        if (ssrc[0] < 0) {
          var value = lines[_i2].match(/a=ssrc:(\d+)/);

          if (value) {
            ssrc[0] = value[1];
            lines.splice(_i2, 1);
            _i2--;
            continue;
          }
        } else {
          var _match = lines[_i2].match('a=ssrc:' + ssrc[0] + ' cname:(.+)');

          if (_match) {
            cname = _match[1];
          }

          _match = lines[_i2].match('a=ssrc:' + ssrc[0] + ' msid:(.+)');

          if (_match) {
            msid = _match[1];
          }

          _match = lines[_i2].match('a=ssrc:' + ssrc[0] + ' mslabel:(.+)');

          if (_match) {
            mslabel = _match[1];
          }

          _match = lines[_i2].match('a=ssrc:' + ssrc[0] + ' label:(.+)');

          if (_match) {
            label = _match[1];
          }

          if (lines[_i2].indexOf('a=ssrc:' + ssrc_fid[0]) === 0) {
            lines.splice(_i2, 1);
            _i2--;
            continue;
          }

          if (lines[_i2].indexOf('a=ssrc:' + ssrc[0]) === 0) {
            lines.splice(_i2, 1);
            _i2--;
            continue;
          }
        }

        if (lines[_i2].length === 0) {
          lines.splice(_i2, 1);
          _i2--;
          continue;
        }
      }
    }

    if (ssrc[0] < 0) {
      // Still nothing, let's just return the SDP we were asked to munge
      Janus.warn("Couldn't find the video SSRC, simulcasting NOT enabled");
      return sdp;
    }

    if (insertAt < 0) {
      // Append at the end
      insertAt = lines.length;
    } // Generate a couple of SSRCs (for retransmissions too)
    // Note: should we check if there are conflicts, here?


    ssrc[1] = Math.floor(Math.random() * 0xFFFFFFFF);
    ssrc[2] = Math.floor(Math.random() * 0xFFFFFFFF);
    ssrc_fid[1] = Math.floor(Math.random() * 0xFFFFFFFF);
    ssrc_fid[2] = Math.floor(Math.random() * 0xFFFFFFFF); // Add attributes to the SDP

    for (var i = 0; i < ssrc.length; i++) {
      if (cname) {
        lines.splice(insertAt, 0, 'a=ssrc:' + ssrc[i] + ' cname:' + cname);
        insertAt++;
      }

      if (msid) {
        lines.splice(insertAt, 0, 'a=ssrc:' + ssrc[i] + ' msid:' + msid);
        insertAt++;
      }

      if (mslabel) {
        lines.splice(insertAt, 0, 'a=ssrc:' + ssrc[i] + ' mslabel:' + mslabel);
        insertAt++;
      }

      if (label) {
        lines.splice(insertAt, 0, 'a=ssrc:' + ssrc[i] + ' label:' + label);
        insertAt++;
      } // Add the same info for the retransmission SSRC


      if (cname) {
        lines.splice(insertAt, 0, 'a=ssrc:' + ssrc_fid[i] + ' cname:' + cname);
        insertAt++;
      }

      if (msid) {
        lines.splice(insertAt, 0, 'a=ssrc:' + ssrc_fid[i] + ' msid:' + msid);
        insertAt++;
      }

      if (mslabel) {
        lines.splice(insertAt, 0, 'a=ssrc:' + ssrc_fid[i] + ' mslabel:' + mslabel);
        insertAt++;
      }

      if (label) {
        lines.splice(insertAt, 0, 'a=ssrc:' + ssrc_fid[i] + ' label:' + label);
        insertAt++;
      }
    }

    lines.splice(insertAt, 0, 'a=ssrc-group:FID ' + ssrc[2] + ' ' + ssrc_fid[2]);
    lines.splice(insertAt, 0, 'a=ssrc-group:FID ' + ssrc[1] + ' ' + ssrc_fid[1]);
    lines.splice(insertAt, 0, 'a=ssrc-group:FID ' + ssrc[0] + ' ' + ssrc_fid[0]);
    lines.splice(insertAt, 0, 'a=ssrc-group:SIM ' + ssrc[0] + ' ' + ssrc[1] + ' ' + ssrc[2]);
    sdp = lines.join("\r\n");
    if (!sdp.endsWith("\r\n")) sdp += "\r\n";
    return sdp;
  } // Helper methods to parse a media object


  function isAudioSendEnabled(media) {
    Janus.debug("isAudioSendEnabled:", media);
    if (!media) return true; // Default

    if (media.audio === false) return false; // Generic audio has precedence

    if (media.audioSend === undefined || media.audioSend === null) return true; // Default

    return media.audioSend === true;
  }

  function isAudioSendRequired(media) {
    Janus.debug("isAudioSendRequired:", media);
    if (!media) return false; // Default

    if (media.audio === false || media.audioSend === false) return false; // If we're not asking to capture audio, it's not required

    if (media.failIfNoAudio === undefined || media.failIfNoAudio === null) return false; // Default

    return media.failIfNoAudio === true;
  }

  function isAudioRecvEnabled(media) {
    Janus.debug("isAudioRecvEnabled:", media);
    if (!media) return true; // Default

    if (media.audio === false) return false; // Generic audio has precedence

    if (media.audioRecv === undefined || media.audioRecv === null) return true; // Default

    return media.audioRecv === true;
  }

  function isVideoSendEnabled(media) {
    Janus.debug("isVideoSendEnabled:", media);
    if (!media) return true; // Default

    if (media.video === false) return false; // Generic video has precedence

    if (media.videoSend === undefined || media.videoSend === null) return true; // Default

    return media.videoSend === true;
  }

  function isVideoSendRequired(media) {
    Janus.debug("isVideoSendRequired:", media);
    if (!media) return false; // Default

    if (media.video === false || media.videoSend === false) return false; // If we're not asking to capture video, it's not required

    if (media.failIfNoVideo === undefined || media.failIfNoVideo === null) return false; // Default

    return media.failIfNoVideo === true;
  }

  function isVideoRecvEnabled(media) {
    Janus.debug("isVideoRecvEnabled:", media);
    if (!media) return true; // Default

    if (media.video === false) return false; // Generic video has precedence

    if (media.videoRecv === undefined || media.videoRecv === null) return true; // Default

    return media.videoRecv === true;
  }

  function isScreenSendEnabled(media) {
    Janus.debug("isScreenSendEnabled:", media);
    if (!media) return false;
    if (typeof media.video !== 'object' || typeof media.video.mandatory !== 'object') return false;
    var constraints = media.video.mandatory;
    if (constraints.chromeMediaSource) return constraints.chromeMediaSource === 'desktop' || constraints.chromeMediaSource === 'screen';else if (constraints.mozMediaSource) return constraints.mozMediaSource === 'window' || constraints.mozMediaSource === 'screen';else if (constraints.mediaSource) return constraints.mediaSource === 'window' || constraints.mediaSource === 'screen';
    return false;
  }

  function isDataEnabled(media) {
    Janus.debug("isDataEnabled:", media);

    if (Janus.webRTCAdapter.browserDetails.browser === "edge") {
      Janus.warn("Edge doesn't support data channels yet");
      return false;
    }

    if (media === undefined || media === null) return false; // Default

    return media.data === true;
  }

  function isTrickleEnabled(trickle) {
    Janus.debug("isTrickleEnabled:", trickle);
    return trickle === false ? false : true;
  }
}

var isElectronClient = window.ipcRenderer !== undefined; // top 

var sipCtiSubscribeStates = {
  initial: 'inactive',
  states: {
    inactive: {
      on: {
        SUBSCRIBE: {
          target: 'tryingSubscribe',
          cond: function cond(context) {
            return context.instanceId == 0 && context.pbxPlaform !== "cucm";
          }
        }
      }
    },
    notAllowed: {},
    unsubscribed: {
      after: {
        30000: 'tryingSubscribe'
      },
      on: {
        SUBSCRIBE: 'tryingSubscribe'
      }
    },
    tryingSubscribe: {
      entry: subscribeAction,
      on: {
        SUBSCRIBING: {},
        SUBSCRIBE_FAILED: [{
          target: 'unsubscribed',
          cond: function cond(context, event) {
            return event.result["code"] !== 405;
          },
          actions: /*#__PURE__*/sendParent$1(function (context, event) {
            return {
              type: 'PLUGIN_CTI_SUBSCRIBE_FAILED',
              instanceId: context.instanceId
            };
          })
        }, {
          target: 'notAllowed'
        }],
        SUBSCRIBE_SUCCEEDED: 'subscribed'
      }
    },
    subscribed: {
      invoke: {
        id: 'notifyProcessor',
        src: function src(context, event) {
          return function (callback, onReceive) {
            onReceive(function (e) {
              processNotifyAction(e, callback);
            });
          };
        }
      },
      on: {
        SUBSCRIBE_FAILED: {
          target: 'unsubscribed',
          actions: /*#__PURE__*/sendParent$1(function (context, event) {
            return {
              type: 'PLUGIN_CTI_SUBSCRIBE_FAILED',
              instanceId: context.instanceId
            };
          })
        },
        SUBSCRIBE_SUCCEEDED: {},
        UNSUBSCRIBE: {
          actions: unsubscribeAction
        },
        NOTIFY: {
          actions: /*#__PURE__*/forwardTo$1('notifyProcessor'),
          cond: function cond(context, event) {
            return event.result["notify"] === "ipfx-cti";
          }
        },
        CTI_MWI: {
          actions: /*#__PURE__*/sendParent$1(function (context, event) {
            return event;
          })
        },
        CANCEL_PENDING_CALL: {
          actions: /*#__PURE__*/sendParent$1(function (context, event) {
            return event;
          })
        },
        CTI_ANSWER: {
          actions: /*#__PURE__*/sendParent$1(function (context, event) {
            return event;
          })
        },
        CTI_HOLD: {
          actions: /*#__PURE__*/sendParent$1(function (context, event) {
            return event;
          })
        },
        CTI_RESUME: {
          actions: /*#__PURE__*/sendParent$1(function (context, event) {
            return event;
          })
        },
        CTI_DIAL: {
          actions: /*#__PURE__*/sendParent$1(function (context, event) {
            return event;
          })
        },
        START_CAPTURE: {
          actions: /*#__PURE__*/sendParent$1(function (context, event) {
            return event;
          })
        },
        STOP_CAPTURE: {
          actions: /*#__PURE__*/sendParent$1(function (context, event) {
            return event;
          })
        },
        SUSPEND_CAPTURE: {
          actions: /*#__PURE__*/sendParent$1(function (context, event) {
            return event;
          })
        },
        RESUME_CAPTURE: {
          actions: /*#__PURE__*/sendParent$1(function (context, event) {
            return event;
          })
        }
      }
    }
  } // states

};

function subscribeAction(context, event) {
  var subscribe = {
    "request": "subscribe",
    "event": "ipfx-cti;opaque-id=" + context.opaqueId,
    "accept": "application/xml"
  };
  context.pluginHandle.send({
    message: subscribe
  });
}

function unsubscribeAction(context, event) {
  if (event.removeToken && context.pushToken) {
    var unsubscribe = {
      "request": "unsubscribe",
      "event": "ipfx-cti;opaque-id=" + context.opaqueId + ";remove-token=" + '"' + context.pushToken + '"',
      "accept": "application/xml"
    };
    context.pluginHandle.send({
      message: unsubscribe
    });
  } else {
    var _unsubscribe = {
      "request": "unsubscribe",
      "event": "ipfx-cti;opaque-id=" + context.opaqueId,
      "accept": "application/xml"
    };
    context.pluginHandle.send({
      message: _unsubscribe
    });
  }
}

function processNotifyAction(event, callback) {
  var result = event.result;
  var event_package = result["notify"];
  Janus.log("Got NOTIFY *, event package: " + result["notify"]);

  if (event_package === "ipfx-cti") {
    var content_type = result["content-type"];
    var content = result["content"];

    if (content_type === "application/xml" && content) {
      var parser = new DOMParser();
      var xmlDoc = parser.parseFromString(content, "application/xml"); //let endpointNode = xmlDoc.getElementsByTagName("Endpoint")[0];
      // let notifyExtension =
      // 	endpointNode.getElementsByTagName("Extension")[0].childNodes[0]
      // 		.nodeValue;
      // let notifyOpaqueId =
      // 	xmlDoc.getElementsByTagName("OpaqueId")[0].childNodes[0].nodeValue;

      var notifyHelperId = 0;

      if (xmlDoc.getElementsByTagName("HelperId").length > 0) {
        // ommit the first char "C", i.e. from "C1"
        var fullHelperId = xmlDoc.getElementsByTagName("HelperId")[0].childNodes[0].nodeValue;

        if (fullHelperId.length > 1) {
          notifyHelperId = fullHelperId.substring(1);
        }
      }

      var mwlValue = false;
      var hasMwlvalue = false;
      var dialTargetUri = "";
      var cancelCallId = "";

      if (xmlDoc.getElementsByTagName("MWL").length > 0) {
        var notifyMWlNodes = xmlDoc.getElementsByTagName("MWL")[0];
        var v = notifyMWlNodes.getElementsByTagName("Status")[0].childNodes[0].nodeValue;
        mwlValue = v === 'true';
        hasMwlvalue = true;
      } else if (xmlDoc.getElementsByTagName("Capture").length > 0) {
        if (isElectronClient) {
          var captureNode = xmlDoc.getElementsByTagName("Capture")[0];
          var captureStart = captureNode.getElementsByTagName("Start")[0].childNodes[0].nodeValue;

          if (captureStart === "1") {
            var captureTarget = captureNode.getElementsByTagName("CaptureTarget")[0].childNodes[0].nodeValue;
            var captureCallId = captureNode.getElementsByTagName("CaptureCallId")[0].childNodes[0].nodeValue;
            var captureFrameRate = captureNode.getElementsByTagName("CaptureFrameRate")[0].childNodes[0].nodeValue;
            var captureScreenWidth = captureNode.getElementsByTagName("CaptureScreenWidth").length > 0 ? captureNode.getElementsByTagName("CaptureScreenWidth")[0].childNodes[0].nodeValue : undefined;
            var captureScreenHeight = captureNode.getElementsByTagName("CaptureScreenHeight").length > 0 ? captureNode.getElementsByTagName("CaptureScreenHeight")[0].childNodes[0].nodeValue : undefined;
            callback({
              type: 'START_CAPTURE',
              callId: captureCallId,
              target: captureTarget,
              frameRate: captureFrameRate,
              screenWidth: captureScreenWidth,
              screenHeight: captureScreenHeight
            });
          } else {
            callback({
              type: 'STOP_CAPTURE'
            });
          }
        }
      } else if (xmlDoc.getElementsByTagName("CapturePrivacy").length > 0) {
        if (isElectronClient) {
          var node = xmlDoc.getElementsByTagName("CapturePrivacy")[0];
          var value = node.getElementsByTagName("Active")[0].childNodes[0].nodeValue;

          if (value === "0") {
            callback({
              type: 'RESUME_CAPTURE'
            });
          } else {
            callback({
              type: 'SUSPEND_CAPTURE'
            });
          }
        }
      } else if (xmlDoc.getElementsByTagName("MakeCall").length > 0) {
        var _notifyMWlNodes = xmlDoc.getElementsByTagName("MakeCall")[0];
        dialTargetUri = _notifyMWlNodes.getElementsByTagName("Target")[0].childNodes[0].nodeValue;
      } else if (xmlDoc.getElementsByTagName("PendingCallTerminated").length > 0) {
        var _notifyMWlNodes2 = xmlDoc.getElementsByTagName("PendingCallTerminated")[0];
        cancelCallId = _notifyMWlNodes2.getElementsByTagName("Call-id")[0].childNodes[0].nodeValue;
      }

      var notifyAction = "";

      if (xmlDoc.getElementsByTagName("Action").length > 0) {
        notifyAction = xmlDoc.getElementsByTagName("Action")[0].childNodes[0].nodeValue;
      }

      if (notifyAction) {
        if (notifyAction === "Hold") {
          // doCtiHold(notifyHelperId);
          callback({
            type: 'CTI_HOLD',
            instanceId: notifyHelperId
          });
        } else if (notifyAction === "Resume") {
          // doCtiResume(notifyHelperId);
          callback({
            type: 'CTI_RESUME',
            instanceId: notifyHelperId
          });
        } else if (notifyAction === "Answer") {
          //doCtiAnswer();
          callback({
            type: 'CTI_ANSWER',
            instanceId: notifyHelperId
          });
        }
      } else if (hasMwlvalue) {
        Janus.log("MWL value is [" + mwlValue + "]");
        callback({
          type: 'CTI_MWI',
          mwi: mwlValue
        });
      } else if (dialTargetUri) {
        Janus.log("MakeCall [" + dialTargetUri + "]"); // doCtiCall(dialTargetUri, false);

        callback({
          type: 'CTI_DIAL',
          dialUri: dialTargetUri
        });
      } else if (cancelCallId) {
        callback({
          type: 'CANCEL_PENDING_CALL',
          callId: cancelCallId
        });
      }
    }
  }
}

var sipRegisterStates = {
  initial: 'inactive',
  states: {
    inactive: {
      on: {
        DO_AUTOREGISTER: {
          target: 'tryingRegister',
          actions: /*#__PURE__*/assign(function (context, event) {
            return {
              registerHeaders: {
                "IPFX-CTI-Opaque-ID": context.opaqueId
              }
            };
          }),
          cond: function cond(context) {
            return context.instanceId == 0 && context.autoregister;
          }
        },
        DO_REGISTER: {
          target: 'tryingRegister',
          actions: /*#__PURE__*/assign(function (context, event) {
            return {
              registerSipserver: context.instanceId == 0 ? event.sipserver : context.registerSipserver,
              registerUsername: context.instanceId == 0 ? event.sipserver.replace("sip:", "sip:" + event.username + "@") : context.registerUsername,
              registerSecret: context.instanceId == 0 ? event.secret : context.registerSecret,
              registerIsHa1Secret: context.instanceId == 0 ? event.is_ha1_secret : context.registerIsHa1Secret,
              registerDisplayname: context.instanceId == 0 ? event.displayName : context.registerDisplayname,
              registerHeaders: {
                "IPFX-CTI-Opaque-ID": context.opaqueId
              },
              smTarget: event.smTarget
            };
          })
        }
      }
    },
    unregistered: {
      entry: /*#__PURE__*/sendParent$1(function (context) {
        return {
          type: 'PLUGIN_UNREGISTERED',
          instanceId: context.instanceId
        };
      }),
      on: {
        DO_REGISTER: 'tryingRegister',
        DO_UNREGISTER: {}
      }
    },
    tryingRegister: {
      entry: registerAction,
      on: {
        DO_UNREGISTER: 'unregistered',
        REGISTERING: {
          actions: /*#__PURE__*/sendParent$1(function (context) {
            return {
              type: 'PLUGIN_RETRYING_REGISTER',
              instanceId: context.instanceId
            };
          })
        },
        REGISTRATION_FAILED: {
          target: 'retryingRegister',
          actions: /*#__PURE__*/sendParent$1(function (context, event) {
            return {
              type: 'PLUGIN_REGISTRATION_FAILED',
              instanceId: context.instanceId,
              error: event.result["code"] + " " + event.result["reason"]
            };
          })
        },
        REGISTERED: {
          target: 'registered',
          actions: /*#__PURE__*/assign(function (context, event) {
            return {
              masterId: event.result["master_id"],
              registerDisplayname: event.result["displayname"]
            };
          })
        }
      }
    },
    tryingUnregister: {
      entry: [unregisterAction, /*#__PURE__*/sendParent$1(function (context) {
        return {
          type: 'PLUGIN_TRYING_UNREGISTER',
          instanceId: context.instanceId
        };
      })],
      on: {
        UNREGISTERED: 'unregistered'
      }
    },
    retryingRegister: {
      entry: /*#__PURE__*/sendParent$1(function (context) {
        return {
          type: 'PLUGIN_RETRYING_REGISTER',
          instanceId: context.instanceId
        };
      }),
      after: {
        30000: 'tryingRegister'
      },
      on: {
        DO_UNREGISTER: 'unregistered'
      }
    },
    registered: /*#__PURE__*/_extends({
      entry: /*#__PURE__*/sendParent$1(function (context, event) {
        return {
          type: 'PLUGIN_REGISTERED',
          instanceId: context.instanceId,
          masterId: context.masterId,
          registerUsername: context.registerUsername,
          displayName: context.registerDisplayname
        };
      }),
      on: {
        REGISTERING: {},
        REGISTERED: {},
        REGISTRATION_FAILED: {
          target: 'retryingRegister',
          actions: /*#__PURE__*/sendParent$1(function (context, event) {
            return {
              type: 'PLUGIN_REGISTRATION_FAILED',
              instanceId: context.instanceId,
              error: event.error
            };
          })
        },
        UNREGISTERED: 'unregistered',
        DO_UNREGISTER: 'tryingUnregister'
      }
    }, sipCtiSubscribeStates)
  } // states

};

function registerAction(context, event) {
  var register = {
    request: "register"
  };
  register["username"] = context.registerUsername;

  if (context.instanceId == 0) {
    register["proxy"] = context.registerSipserver;
    register["force_tcp"] = context.registerUsername.startsWith('sip:guest-');

    if (context.registerIsHa1Secret) {
      register["ha1_secret"] = context.registerSecret;
    } else {
      register["secret"] = context.registerSecret;
    }

    if (context.registerDisplayname) {
      register["display_name"] = context.registerDisplayname;
    }

    register["incoming_header_prefixes"] = ["Push-call-id", "Remote-Party-Id"];

    if (context.pushToken) {
      register["headers"] = Object.assign({}, context.registerHeaders, {
        "IPFX-Push-Token": '"' + context.pushToken + '"' + (context.alertPushToken ? ';alert="' + context.alertPushToken + '"' : '') + (context.pushPlatformName ? ';platform=' + context.pushPlatformName : '')
      });
    } else {
      register["headers"] = context.registerHeaders;
    }

    if (context.monitorTarget) {
      register["contact_params"] = {
        "ipfx-sm-target": context.monitorTarget
      };
    }
  } else {
    register["type"] = "helper";
    register["master_id"] = context.masterId;
  }

  context.pluginHandle.send({
    message: register
  });
}

function unregisterAction(context, event) {
  context.pluginHandle.send({
    message: {
      request: "unregister"
    }
  });
}

var CallStatusErrorCode;

(function (CallStatusErrorCode) {
  CallStatusErrorCode[CallStatusErrorCode["ERROR_MAKE_CALL"] = 0] = "ERROR_MAKE_CALL";
  CallStatusErrorCode[CallStatusErrorCode["ERROR_MAKE_CALL_NOT_FOUND"] = 1] = "ERROR_MAKE_CALL_NOT_FOUND";
  CallStatusErrorCode[CallStatusErrorCode["ERROR_MAKE_CALL_MEDIA_REJECTED"] = 2] = "ERROR_MAKE_CALL_MEDIA_REJECTED";
  CallStatusErrorCode[CallStatusErrorCode["ERROR_MAKE_CALL_BUSY"] = 3] = "ERROR_MAKE_CALL_BUSY";
  CallStatusErrorCode[CallStatusErrorCode["ERROR_MAKE_CALL_DECLINED"] = 4] = "ERROR_MAKE_CALL_DECLINED";
  CallStatusErrorCode[CallStatusErrorCode["ERROR_MAKE_CALL_SERVICE_ERROR"] = 5] = "ERROR_MAKE_CALL_SERVICE_ERROR";
  CallStatusErrorCode[CallStatusErrorCode["ERROR_MAKE_CALL_PERMISSION"] = 6] = "ERROR_MAKE_CALL_PERMISSION";
  CallStatusErrorCode[CallStatusErrorCode["ERROR_ANSWER_CALL"] = 7] = "ERROR_ANSWER_CALL";
  CallStatusErrorCode[CallStatusErrorCode["ERROR_ANSWER_CALL_PERMISSION"] = 8] = "ERROR_ANSWER_CALL_PERMISSION";
  CallStatusErrorCode[CallStatusErrorCode["ERROR_HANG_UP"] = 9] = "ERROR_HANG_UP";
  CallStatusErrorCode[CallStatusErrorCode["ERROR_MIDCALL"] = 10] = "ERROR_MIDCALL";
  CallStatusErrorCode[CallStatusErrorCode["ERROR_MIDCALL_PERMISSION"] = 11] = "ERROR_MIDCALL_PERMISSION";
  CallStatusErrorCode[CallStatusErrorCode["ERROR_HOLD"] = 12] = "ERROR_HOLD";
  CallStatusErrorCode[CallStatusErrorCode["ERROR_HOLD_PERMISSION"] = 13] = "ERROR_HOLD_PERMISSION";
  CallStatusErrorCode[CallStatusErrorCode["ERROR_RESUME"] = 14] = "ERROR_RESUME";
  CallStatusErrorCode[CallStatusErrorCode["ERROR_RESUME_PERMISSION"] = 15] = "ERROR_RESUME_PERMISSION";
  CallStatusErrorCode[CallStatusErrorCode["ERROR_TRANSFER"] = 16] = "ERROR_TRANSFER";
  CallStatusErrorCode[CallStatusErrorCode["ERROR_SCREEN_RECORDING"] = 17] = "ERROR_SCREEN_RECORDING";
})(CallStatusErrorCode || (CallStatusErrorCode = {}));

var escalate = actions$1.escalate,
    sendParent = actions$1.sendParent,
    send = actions$1.send,
    forwardTo = actions$1.forwardTo,
    cancel = actions$1.cancel,
    raise = actions$1.raise,
    choose = actions$1.choose;
var defaultMediaConstraints = undefined; // call events:
// - incomingcall(incoming)
// - declining (incoming)
// - declined (incoming)
// - accepting (incoming)
// - accepted (incoming, outgoing)
// - hangup (midcall, incoming, outgoing)
//
// - calling (outgoing)
// - proceeding (outgoing)
// - ringing (outgoing)
// - progress (outgoing)
// - accepted (incoming, outgoing)
// - hangingup (midcall, outgoing)
// - hangup (midcall, incoming, outgoing)
//
// - updating (midcall)
// - updated (midcall)
// - transferring (midcall)
// - transfer (midcall) // incoming REFER request
// - holding (midcall)
// - resuming (midcall)
// - hangingup (midcall)
// - dtmfsent (midcall) // SIP INFO method only
// - updatingcall (midcall)
// - hangingup (midcall, outgoing)
// - hangup (midcall, outgoing)
//
//

var callStateMachine = /*#__PURE__*/Machine({
  id: 'ipfxCallStateMachine',
  initial: 'idle',
  context: {
    sip_call_id: null,
    call_id: null,
    remote_uri: null,
    pluginHandle: null,
    opaqueId: null,
    instanceId: null,
    queuedHangup: false,
    makeCallTargetUri: null,
    incomingCallJsep: null,
    doVideoProcessed: false,
    doVideo: false,
    // requested
    videoSource: undefined,
    // requested
    videoSourceProcessed: undefined,
    // requested
    enabledVideoSource: undefined,
    // actual
    isVideoProcessingComplete: true,
    preferSendVideo: false,
    preferRecvVideo: false,
    preferSendAudio: false,
    preferRecvAudio: false,
    canSendVideo: false,
    canRecvVideo: false,
    canSendAudio: false,
    canRecvAudio: false,
    isHolding: false,
    isLastXferBlind: false,
    isLastXferSuper: false,
    incomingCallUserName: undefined,
    incomingCallDisplayName: undefined,
    isCallee: false,
    retry491Count: 0,
    isIceRestartRequired: false,
    srRequested: false,
    srCallId: undefined,
    srFrameRate: undefined,
    srScreenWidth: undefined,
    srScreenHeight: undefined,
    srTarget: undefined,
    srRetryCount: 0
  },
  on: {
    DO_START_SR: {
      actions: /*#__PURE__*/assign({
        srRequested: function srRequested() {
          return true;
        },
        srTarget: function srTarget(context, event) {
          return event.target;
        },
        srCallId: function srCallId(context, event) {
          return event.callId;
        },
        srRetryCount: function srRetryCount() {
          return 0;
        },
        srFrameRate: function srFrameRate(context, event) {
          return event.frameRate;
        },
        srScreenWidth: function srScreenWidth(context, event) {
          return event.screenWidth;
        },
        srScreenHeight: function srScreenHeight(context, event) {
          return event.screenHeight;
        }
      })
    },
    DO_STOP_SR: {
      actions: [/*#__PURE__*/assign({
        srRequested: function srRequested() {
          return false;
        },
        srRetryCount: function srRetryCount() {
          return 0;
        }
      }), /*#__PURE__*/send('DO_HANGUP')]
    },
    DO_ENABLE_VIDEO: {
      actions: /*#__PURE__*/assign({
        doVideo: function doVideo(context, event) {
          return event.doVideo;
        },
        videoSource: function videoSource(context, event) {
          return event.videoSource;
        }
      })
    },
    DO_POST_ENABLE_VIDEO: {
      // this will trigger media update when connected to get the video going
      actions: /*#__PURE__*/assign({
        doVideoProcessed: function doVideoProcessed(context, event) {
          return false;
        }
      })
    },
    DO_REJECT_REFER: {
      actions: 'declineTransferAction'
    },
    DO_BLIND_XFER: {
      actions: /*#__PURE__*/sendParent(function (context, error) {
        return {
          type: 'DO_BLIND_XFER_FAILED',
          instanceId: context.instanceId,
          message: 'Call state incompatible with transfer request'
        };
      })
    },
    DO_XFER: {
      actions: /*#__PURE__*/sendParent(function (context, error) {
        return {
          type: 'DO_XFER_FAILED',
          instanceId: context.instanceId,
          message: 'Call state incompatible with transfer request'
        };
      })
    },
    TRANSFERRING: {
      actions: /*#__PURE__*/sendParent(function (context, error) {
        return {
          type: 'CALL_STATE_DO_XFERRING',
          instanceId: context.instanceId
        };
      })
    },
    JANUS_SESSION_ENDED: {
      target: 'finalizing',
      actions: ['logJanusSessionEnded', 'doHangupAction', /*#__PURE__*/sendParent(function (context, event) {
        return {
          type: 'CALL_STATE_IDLE',
          instanceId: context.instanceId,
          code: 0,
          reason: 'End of session'
        };
      }), /*#__PURE__*/sendParent(function (context, event) {
        return {
          type: 'CALL_STATE_DEEP_IDLE',
          instanceId: context.instanceId
        };
      })]
    }
  },
  states: {
    finalizing: {
      after: {
        3000: {
          target: 'finalized'
        }
      },
      on: {
        CLEANUP: {
          target: 'finalized'
        }
      }
    },
    finalized: {
      type: 'final'
    },
    idle: {
      entry: [/*#__PURE__*/sendParent(function (context, event) {
        return {
          type: 'CALL_STATE_DEEP_IDLE',
          instanceId: context.instanceId
        };
      }, {
        delay: 3000,
        id: 'DEEP_IDLE_TIMER'
      }), /*#__PURE__*/choose([{
        // when DO_START_SR while hanging up existing SR call
        cond: function cond(context) {
          return context.srRequested && context.srRetryCount == 0;
        },
        actions: /*#__PURE__*/send(function (context, event) {
          return {
            type: 'DO_START_SR_IF',
            instanceId: context.instanceId
          };
        }, {
          delay: 250,
          id: 'START_SR_TIMER'
        })
      }, {
        // when retrying on repeated failure
        cond: function cond(context) {
          return context.srRequested && context.srRetryCount > 0;
        },
        actions: /*#__PURE__*/send(function (context, event) {
          return {
            type: 'DO_START_SR_IF',
            instanceId: context.instanceId
          };
        }, {
          delay: 15000,
          id: 'START_SR_TIMER'
        })
      }]), /*#__PURE__*/assign({
        sip_call_id: function sip_call_id() {
          return null;
        }
      }), /*#__PURE__*/assign({
        call_id: function call_id() {
          return null;
        }
      }), /*#__PURE__*/assign({
        remote_uri: function remote_uri() {
          return null;
        }
      }), /*#__PURE__*/assign({
        queuedHangup: function queuedHangup() {
          return false;
        }
      }), /*#__PURE__*/assign({
        makeCallTargetUri: function makeCallTargetUri() {
          return null;
        }
      }), /*#__PURE__*/assign({
        incomingCallJsep: function incomingCallJsep() {
          return null;
        }
      }), /*#__PURE__*/assign({
        doVideoProcessed: function doVideoProcessed(context) {
          return context.doVideo;
        }
      }), /*#__PURE__*/assign({
        enabledVideo: function enabledVideo() {
          return false;
        }
      }), /*#__PURE__*/assign({
        videoSourceProcessed: function videoSourceProcessed(context) {
          return context.videoSource;
        }
      }), /*#__PURE__*/assign({
        enabledVideoSource: function enabledVideoSource() {
          return undefined;
        }
      }), /*#__PURE__*/assign({
        isVideoProcessingComplete: function isVideoProcessingComplete() {
          return true;
        }
      }), /*#__PURE__*/assign({
        preferSendVideo: function preferSendVideo() {
          return false;
        }
      }), /*#__PURE__*/assign({
        preferRecvVideo: function preferRecvVideo() {
          return false;
        }
      }), /*#__PURE__*/assign({
        preferSendAudio: function preferSendAudio() {
          return false;
        }
      }), /*#__PURE__*/assign({
        preferRecvAudio: function preferRecvAudio() {
          return false;
        }
      }), /*#__PURE__*/assign({
        canSendVideo: function canSendVideo() {
          return false;
        }
      }), /*#__PURE__*/assign({
        canRecvVideo: function canRecvVideo() {
          return false;
        }
      }), /*#__PURE__*/assign({
        canSendAudio: function canSendAudio() {
          return false;
        }
      }), /*#__PURE__*/assign({
        canRecvAudio: function canRecvAudio() {
          return false;
        }
      }), /*#__PURE__*/assign({
        isHolding: function isHolding() {
          return false;
        }
      }), /*#__PURE__*/assign({
        isLastXferBlind: function isLastXferBlind() {
          return false;
        }
      }), /*#__PURE__*/assign({
        isLastXferSuper: function isLastXferSuper() {
          return false;
        }
      }), /*#__PURE__*/assign({
        incomingCallUserName: function incomingCallUserName() {
          return undefined;
        }
      }), /*#__PURE__*/assign({
        incomingCallDisplayName: function incomingCallDisplayName() {
          return undefined;
        }
      }), /*#__PURE__*/assign({
        isCallee: function isCallee() {
          return false;
        }
      }), /*#__PURE__*/assign({
        retry491Count: function retry491Count() {
          return 0;
        }
      }), /*#__PURE__*/assign({
        isIceRestartRequired: function isIceRestartRequired() {
          return false;
        }
      })],
      exit: [/*#__PURE__*/cancel('DEEP_IDLE_TIMER'), /*#__PURE__*/cancel('START_SR_TIMER')],
      on: {
        DO_START_SR: {
          actions: [/*#__PURE__*/assign({
            srRequested: function srRequested() {
              return true;
            },
            srTarget: function srTarget(context, event) {
              return event.target;
            },
            srCallId: function srCallId(context, event) {
              return event.callId;
            },
            srRetryCount: function srRetryCount() {
              return 0;
            },
            srFrameRate: function srFrameRate(context, event) {
              return event.frameRate;
            },
            srScreenWidth: function srScreenWidth(context, event) {
              return event.screenWidth;
            },
            srScreenHeight: function srScreenHeight(context, event) {
              return event.screenHeight;
            }
          }), /*#__PURE__*/send(function (context, event) {
            return {
              type: 'DO_MAKE_CALL',
              instanceId: event.instanceId,
              target: event.target,
              callId: event.callId
            };
          })]
        },
        DO_START_SR_IF: {
          actions: [/*#__PURE__*/choose([{
            cond: function cond(context) {
              return context.srRequested && ++context.srRetryCount <= 1;
            },
            actions: /*#__PURE__*/send(function (context, event) {
              return {
                type: 'DO_MAKE_CALL',
                instanceId: context.instanceId,
                target: context.srTarget,
                callId: context.srCallId
              };
            })
          }]), 'logContext']
        },
        DO_MAKE_CALL: {
          target: 'tryingMakeCall'
        },
        INCOMINGCALL: {
          // note Janus doesn't provide headers with replacing invite - must fix in Janus
          target: 'handlingIncomingCall',
          actions: /*#__PURE__*/assign({
            isCallee: function isCallee() {
              return true;
            },
            sip_call_id: function sip_call_id(context, event) {
              return event.call_id;
            },
            call_id: function call_id(context, event) {
              return event.result["headers"] === undefined ? event.call_id : event.result["headers"]["Push-call-id"];
            },
            remote_uri: function remote_uri(context, event) {
              return event.result["username"];
            }
          })
        },
        CALLING: {
          actions: 'doHangupAction'
        },
        RINGING: {
          actions: 'doHangupAction'
        },
        PROCEEDING: {
          actions: 'doHangupAction'
        },
        PROGRESS: {
          actions: 'doHangupAction'
        },
        ACCEPTED: {
          actions: 'doHangupAction'
        },
        '*': undefined
      }
    },
    hangingup: {
      on: {
        CLEANUP: {
          target: 'idle',
          actions: /*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_IDLE',
              instanceId: context.instanceId,
              code: 0,
              reason: 'Normal clearing'
            };
          })
        },
        HANGUP: {
          cond: function cond(context, event) {
            return context.sip_call_id !== null && event["call_id"] === context.sip_call_id;
          },
          target: 'idle',
          actions: /*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_IDLE',
              instanceId: context.instanceId,
              code: event.result["code"],
              reason: event.result["reason"]
            };
          })
        },
        DECLINED: {
          target: 'idle',
          actions: /*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_IDLE',
              instanceId: context.instanceId,
              code: event.result["code"],
              reason: event.result["reason"]
            };
          })
        }
      },
      // we have a problem with SIP plugin that doesn't handle crosstalk,
      // until it's fixed we handle it ourselves
      '*': {
        target: undefined,
        actions: function actions() {
          return Janus.warn("!!! Stuck in hangingup state, hangup from the other end !!!");
        }
      }
    },
    handlingIncomingCall: {
      invoke: {
        id: 'handleIncomingCall',
        src: 'handleIncomingCallService',
        onError: {
          target: 'idle',
          actions: ['doHangupAction', /*#__PURE__*/escalate(function (context, event) {
            return {
              reason: event.type,
              message: event.data.message
            };
          })]
        }
      },
      entry: [/*#__PURE__*/assign({
        doVideoProcessed: function doVideoProcessed(context) {
          return context.doVideo;
        },
        videoSourceProcessed: function videoSourceProcessed(context) {
          return context.videoSource;
        },
        incomingCallJsep: function incomingCallJsep(context, event) {
          return event.jsep;
        },
        call_id: function call_id(context, event) {
          return context.call_id;
        },
        incomingCallUserName: function incomingCallUserName(context, event) {
          return calculateUserName(context, event);
        },
        incomingCallDisplayName: function incomingCallDisplayName(context, event) {
          return calculateDisplayName(context, event);
        }
      }), 'logEvent', /*#__PURE__*/sendParent(function (context, event) {
        return {
          // note Janus doesn't provide headers with replacing invite - must fix in Janus
          type: 'CALL_STATE_INCOMING_CALL',
          instanceId: context.instanceId,
          callerUsername: calculateUserName(context, event),
          callerDisplay: calculateDisplayName(context, event),
          callId: event.result["headers"] === undefined ? event.call_id : event.result["headers"]["Push-call-id"],
          replaces: event.result["replaces"] // this is sip_call_id (not call_id)

        };
      }), 'messageAckIncomingCallAction'],
      exit: /*#__PURE__*/assign({
        incomingCallJsep: function incomingCallJsep() {
          return null;
        }
      }),
      on: {
        DO_ACCEPT: {
          actions: /*#__PURE__*/forwardTo('handleIncomingCall')
        },
        DO_DECLINE: {
          actions: /*#__PURE__*/forwardTo('handleIncomingCall')
        },
        DO_HANGUP: {
          actions: 'doHangupAction'
        },
        DO_ACCEPT_SUCCEEDED: /*#__PURE__*/sendParent(function (context, event) {
          return {
            type: 'CALL_STATE_CONNECTING',
            instanceId: context.instanceId
          };
        }),
        DO_ACCEPT_FAILED: {
          actions: [/*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_ERROR',
              instanceId: context.instanceId,
              errorCode: GetErrorMessage(event).toLowerCase().includes('permission') ? CallStatusErrorCode.ERROR_ANSWER_CALL_PERMISSION : CallStatusErrorCode.ERROR_ANSWER_CALL,
              errorMessage: 'Failed to answer an incoming call: ' + GetErrorMessage(event)
            };
          }), 'doHangupAction']
        },
        DO_DECLINE_SUCCEEDED: undefined,
        DO_DECLINE_FAILED: {
          actions: [/*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_ERROR',
              instanceId: context.instanceId,
              errorCode: CallStatusErrorCode.ERROR_HANG_UP,
              errorMessage: 'Failed to decline an incoming call: ' + event.message
            };
          }), 'doHangupAction']
        },
        DECLINING: {
          target: 'hangingup',
          actions: /*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_HANGINGUP',
              instanceId: context.instanceId
            };
          })
        },
        DECLINED: {
          target: 'idle',
          actions: /*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_IDLE',
              instanceId: context.instanceId,
              code: event.result["code"],
              reason: event.result["reason"]
            };
          })
        },
        ACCEPTING: {},
        ACCEPTED: {
          target: 'connected',
          actions: /*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_CONNECTED',
              instanceId: context.instanceId,
              isInitial: true,
              remoteUri: calculateUserName(context, event),
              remoteDisplay: calculateDisplayName(context, event),
              hasLocalAudio: context.canSendAudio,
              hasRemoteAudio: context.canRecvAudio,
              hasLocalVideo: context.canSendVideo,
              hasRemoteVideo: context.canRecvVideo,
              localVideoSource: context.enabledVideoSource
            };
          })
        },
        HANGUP: {
          cond: function cond(context, event) {
            return context.sip_call_id !== null && event["call_id"] === context.sip_call_id;
          },
          target: 'idle',
          actions: /*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_IDLE',
              instanceId: context.instanceId,
              code: event.result["code"],
              reason: event.result["reason"]
            };
          })
        },
        HANGINGUP: {
          target: 'hangingup',
          actions: /*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_HANGINGUP',
              instanceId: context.instanceId
            };
          })
        }
      }
    },
    tryingMakeCallTimeout: {
      always: {
        target: 'idle',
        actions: ['doHangupAction', /*#__PURE__*/escalate(function (context, error) {
          return {
            reason: 'DO_MAKE_CALL_FAILED',
            instanceId: context.instanceId,
            message: "Timeout while trying to make call"
          };
        }), /*#__PURE__*/sendParent(function (context, event) {
          return {
            type: 'CALL_STATE_IDLE',
            instanceId: context.instanceId,
            code: 408,
            reason: "Request Timeout"
          };
        })]
      }
    },
    callingOutTimeout: {
      entry: ['doHangupAction', /*#__PURE__*/sendParent(function (context, event) {
        return {
          type: 'CALL_STATE_TIMEOUT',
          instanceId: context.instanceId,
          message: "Timeout while calling out"
        };
      })],
      on: {
        CLEANUP: {
          target: 'idle',
          actions: /*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_IDLE',
              instanceId: context.instanceId,
              code: 408,
              reason: 'Request Timeout'
            };
          })
        },
        HANGUP: {
          cond: function cond(context, event) {
            return context.sip_call_id !== null && event["call_id"] === context.sip_call_id;
          },
          target: 'idle',
          actions: /*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_IDLE',
              instanceId: context.instanceId,
              code: event.result["code"],
              reason: event.result["reason"]
            };
          })
        },
        '*': undefined
      }
    },
    tryingMakeCall: {
      invoke: {
        id: 'makeCall',
        src: 'makeCallService',
        onError: {
          target: 'idle',
          actions: ['doHangupAction', /*#__PURE__*/escalate(function (context, event) {
            return {
              reason: 'DO_MAKE_CALL_FAILED',
              message: event.data.message
            };
          })]
        }
      },
      after: {
        15000: 'tryingMakeCallTimeout'
      },
      entry: [/*#__PURE__*/assign({
        doVideoProcessed: function doVideoProcessed(context) {
          return context.doVideo;
        },
        videoSourceProcessed: function videoSourceProcessed(context) {
          return context.videoSource;
        }
      }), /*#__PURE__*/assign({
        remote_uri: function remote_uri(context, event) {
          return event.target;
        }
      }), /*#__PURE__*/sendParent(function (context, event) {
        return {
          type: 'CALL_STATE_TRYING_OUT',
          instanceId: context.instanceId,
          remoteUri: event.target
        };
      })],
      on: {
        DO_HANGUP: {
          actions: 'doHangupAction'
        },
        DO_MAKE_CALL_SUCCEEDED: [{
          actions: 'doHangupAction',
          cond: function cond(context) {
            return context.queuedHangup;
          }
        }, {
          actions: /*#__PURE__*/assign({
            preferSendAudio: function preferSendAudio(context, event) {
              return event.preferSendAudio;
            },
            preferRecvAudio: function preferRecvAudio(context, event) {
              return event.preferRecvAudio;
            },
            preferSendVideo: function preferSendVideo(context, event) {
              return event.preferSendVideo;
            },
            preferRecvVideo: function preferRecvVideo(context, event) {
              return event.preferRecvVideo;
            }
          })
        }],
        DO_MAKE_CALL_FAILED: {
          target: 'idle',
          actions: [/*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_ERROR',
              instanceId: context.instanceId,
              errorCode: GetErrorMessage(event).toLowerCase().includes('permission') ? CallStatusErrorCode.ERROR_MAKE_CALL_PERMISSION : CallStatusErrorCode.ERROR_MAKE_CALL,
              errorMessage: 'Unable to dial: ' + GetErrorMessage(event)
            };
          }), 'doHangupAction', /*#__PURE__*/choose([{
            cond: function cond(context, event) {
              return context.srRequested && GetErrorMessage(event).toLowerCase().includes('permission');
            },
            actions: [/*#__PURE__*/assign({
              srRetryCount: function srRetryCount() {
                return 1000;
              }
            })]
          }]) //sendParent((context, event) => ({ type: 'CALL_STATE_IDLE', instanceId: context.instanceId, code: 403, reason: 'Permission denied' }))
          ]
        },
        CALLING: {
          target: 'ringingOut',
          actions: [/*#__PURE__*/assign({
            call_id: function call_id(context, event) {
              return event.call_id;
            },
            sip_call_id: function sip_call_id(context, event) {
              return event.call_id;
            }
          }), /*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_CALLING_OUT',
              instanceId: context.instanceId,
              remoteUri: context.remote_uri,
              callId: event.call_id
            };
          })]
        },
        RINGING: {
          target: 'ringingOut',
          actions: /*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_RINGING_OUT',
              instanceId: context.instanceId,
              remoteDisplay: event.result["todisplayname"]
            };
          })
        },
        PROCEEDING: [{
          cond: function cond(context, event) {
            return event.result["code"] === 183;
          },
          target: 'progressOut',
          actions: /*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_PROGRESS_OUT',
              instanceId: context.instanceId
            };
          })
        }, {
          target: 'ringingOut',
          actions: /*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_PROCEEDING_OUT',
              instanceId: context.instanceId
            };
          })
        }],
        PROGRESS: {
          target: 'progressOut',
          actions: /*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_PROGRESS_OUT',
              instanceId: context.instanceId,
              remoteDisplay: event.result["todisplayname"]
            };
          })
        },
        ACCEPTED: {
          target: 'connected',
          actions: /*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_CONNECTED',
              instanceId: context.instanceId,
              isInitial: true,
              remoteUri: event.result["username"] !== undefined ? event.result["username"] : context.remote_uri,
              remoteDisplay: event.result["todisplayname"],
              hasLocalAudio: context.canSendAudio,
              hasRemoteAudio: context.canRecvAudio,
              hasLocalVideo: context.canSendVideo,
              hasRemoteVideo: context.canRecvVideo,
              localVideoSource: context.enabledVideoSource
            };
          })
        },
        HANGUP: {
          cond: function cond(context, event) {
            return context.sip_call_id !== null && event["call_id"] === context.sip_call_id;
          },
          target: 'idle',
          actions: [/*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_ERROR',
              instanceId: context.instanceId,
              errorCode: event.result["code"] === 404 ? CallStatusErrorCode.ERROR_MAKE_CALL_NOT_FOUND : event.result["code"] === 488 ? CallStatusErrorCode.ERROR_MAKE_CALL_MEDIA_REJECTED : event.result["code"] === 486 ? CallStatusErrorCode.ERROR_MAKE_CALL_BUSY : event.result["code"] === 487 ? CallStatusErrorCode.ERROR_MAKE_CALL_DECLINED : CallStatusErrorCode.ERROR_MAKE_CALL,
              errorMessage: 'Could not connect: ' + event.result["reason"]
            };
          }), /*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_IDLE',
              instanceId: context.instanceId,
              code: event.result["code"],
              reason: event.result["reason"]
            };
          })]
        },
        HANGINGUP: {
          target: 'hangingup',
          actions: /*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_HANGINGUP',
              instanceId: context.instanceId
            };
          })
        },
        SIP_ERROR: {
          target: 'idle',
          actions: ['doHangupAction', /*#__PURE__*/escalate(function (context, event) {
            return {
              reason: 'DO_MAKE_CALL_FAILED',
              instanceId: context.instanceId,
              message: event.message
            };
          })]
        }
      }
    },
    ringingOut: {
      after: {
        60000: 'callingOutTimeout'
      },
      on: {
        DO_HANGUP: {
          actions: 'doHangupAction'
        },
        PROGRESS: {
          target: 'progressOut',
          actions: /*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_PROGRESS_OUT',
              instanceId: context.instanceId
            };
          })
        },
        ACCEPTED: {
          target: 'connected',
          actions: /*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_CONNECTED',
              instanceId: context.instanceId,
              isInitial: true,
              remoteUri: context.remote_uri,
              remoteDisplay: event.result["todisplayname"],
              hasLocalAudio: context.canSendAudio,
              hasRemoteAudio: context.canRecvAudio,
              hasLocalVideo: context.canSendVideo,
              hasRemoteVideo: context.canRecvVideo,
              localVideoSource: context.enabledVideoSource
            };
          })
        },
        HANGUP: {
          cond: function cond(context, event) {
            return context.sip_call_id !== null && event["call_id"] === context.sip_call_id;
          },
          target: 'idle',
          actions: [
          /*#__PURE__*/
          // exclude 487 for replacing INVITE completion
          choose([{
            cond: function cond(context, event) {
              return event.result["code"] !== 487;
            },
            actions: [/*#__PURE__*/sendParent(function (context, event) {
              return {
                type: 'CALL_STATE_ERROR',
                instanceId: context.instanceId,
                errorCode: event.result["code"] === 404 ? CallStatusErrorCode.ERROR_MAKE_CALL_NOT_FOUND : event.result["code"] === 488 ? CallStatusErrorCode.ERROR_MAKE_CALL_MEDIA_REJECTED : event.result["code"] === 486 ? CallStatusErrorCode.ERROR_MAKE_CALL_BUSY : CallStatusErrorCode.ERROR_MAKE_CALL,
                errorMessage: 'Could not connect: ' + event.result["reason"]
              };
            })]
          }]), /*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_IDLE',
              instanceId: context.instanceId,
              code: event.result["code"],
              reason: event.result["reason"]
            };
          })]
        },
        HANGINGUP: {
          target: 'hangingup',
          actions: /*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_HANGINGUP',
              instanceId: context.instanceId
            };
          })
        },
        RINGING: {
          target: undefined,
          actions: /*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_RINGING_OUT',
              instanceId: context.instanceId,
              remoteDisplay: event.result["todisplayname"]
            };
          })
        },
        PROCEEDING: [{
          cond: function cond(context, event) {
            return event.result["code"] === 183;
          },
          target: 'progressOut',
          actions: /*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_PROGRESS_OUT',
              instanceId: context.instanceId
            };
          })
        }, {
          target: undefined,
          actions: /*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_PROCEEDING_OUT',
              instanceId: context.instanceId
            };
          })
        }]
      }
    },
    progressOut: {
      invoke: {
        id: 'handleRemoteEarlyMedia',
        src: 'handleRemoteMediaService',
        onError: {
          target: 'idle',
          actions: ['doHangupAction', /*#__PURE__*/escalate(function (context, event) {
            return {
              reason: 'REMOTE_EARLY_MEDIA_HANDLING_FAILED',
              message: event.data.message
            };
          }), /*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_IDLE',
              instanceId: context.instanceId,
              code: 488,
              reason: 'Media error'
            };
          })]
        }
      },
      after: {
        60000: 'callingOutTimeout'
      },
      on: {
        DO_HANGUP: {
          actions: 'doHangupAction'
        },
        PROGRESS: {
          target: undefined,
          actions: /*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_PROGRESS_OUT',
              instanceId: context.instanceId
            };
          })
        },
        ACCEPTED: {
          target: 'connected',
          actions: /*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_CONNECTED',
              instanceId: context.instanceId,
              isInitial: true,
              remoteUri: context.remote_uri,
              remoteDisplay: event.result["todisplayname"],
              hasLocalAudio: context.canSendAudio,
              hasRemoteAudio: context.canRecvAudio,
              hasLocalVideo: context.canSendVideo,
              hasRemoteVideo: context.canRecvVideo,
              localVideoSource: context.enabledVideoSource
            };
          })
        },
        HANGUP: {
          cond: function cond(context, event) {
            return context.sip_call_id !== null && event["call_id"] === context.sip_call_id;
          },
          target: 'idle',
          actions: [
          /*#__PURE__*/
          // exclude 487 for replacing INVITE completion
          choose([{
            cond: function cond(context, event) {
              return event.result["code"] !== 487;
            },
            actions: [/*#__PURE__*/sendParent(function (context, event) {
              return {
                type: 'CALL_STATE_ERROR',
                instanceId: context.instanceId,
                errorCode: event.result["code"] === 404 ? CallStatusErrorCode.ERROR_MAKE_CALL_NOT_FOUND : event.result["code"] === 488 ? CallStatusErrorCode.ERROR_MAKE_CALL_MEDIA_REJECTED : event.result["code"] === 486 ? CallStatusErrorCode.ERROR_MAKE_CALL_BUSY : CallStatusErrorCode.ERROR_MAKE_CALL,
                errorMessage: 'Could not connect: ' + event.result["reason"]
              };
            })]
          }]), /*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_IDLE',
              instanceId: context.instanceId,
              code: event.result["code"],
              reason: event.result["reason"]
            };
          })]
        },
        HANGINGUP: {
          target: 'hangingup',
          actions: /*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_HANGINGUP',
              instanceId: context.instanceId
            };
          })
        },
        RINGING: {
          target: 'ringingOut',
          actions: /*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_RINGING_OUT',
              instanceId: context.instanceId,
              remoteDisplay: event.result["todisplayname"]
            };
          })
        },
        PROCEEDING: [{
          cond: function cond(context, event) {
            return event.result["code"] === 183;
          },
          target: 'progressOut',
          actions: /*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_PROGRESS_OUT',
              instanceId: context.instanceId
            };
          })
        }, {
          target: 'ringingOut',
          actions: /*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_PROCEEDING_OUT',
              instanceId: context.instanceId
            };
          })
        }],
        REMOTE_SDP_HANDLING_SUCCEEDED: {
          actions: /*#__PURE__*/assign({
            isVideoProcessingComplete: function isVideoProcessingComplete() {
              return true;
            },
            canSendAudio: function canSendAudio(context, event) {
              return event.canSendAudio;
            },
            canRecvAudio: function canRecvAudio(context, event) {
              return event.canRecvAudio;
            },
            canSendVideo: function canSendVideo(context, event) {
              return event.canSendVideo;
            },
            canRecvVideo: function canRecvVideo(context, event) {
              return event.canRecvVideo;
            },
            enabledVideoSource: function enabledVideoSource(context, event) {
              return event.canSendVideo && context.videoSourceProcessed;
            },
            isIceRestartRequired: function isIceRestartRequired(context) {
              return false;
            }
          })
        },
        REMOTE_SDP_HANDLING_FAILED: {
          actions: [/*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_ERROR',
              instanceId: context.instanceId,
              errorCode: GetErrorMessage(event).toLowerCase().includes('permission') ? CallStatusErrorCode.ERROR_MAKE_CALL_PERMISSION : CallStatusErrorCode.ERROR_MAKE_CALL,
              errorMessage: 'Unable to connect an outgoing call:' + GetErrorMessage(event)
            };
          }), 'doHangupAction']
        }
      }
    },
    connected: {
      initial: 'notHold',
      invoke: [{
        id: 'handleRemoteMedia',
        src: 'handleRemoteMediaService',
        onError: {
          target: 'idle',
          actions: ['doHangupAction', /*#__PURE__*/escalate(function (context, event) {
            return {
              reason: 'REMOTE_MEDIA_HANDLING_FAILED',
              message: event.data.message
            };
          })]
        }
      }, {
        id: 'executeBlindXfer',
        src: 'executeXferService',
        onError: {
          target: 'idle',
          actions: /*#__PURE__*/sendParent(function (context, error) {
            return {
              type: 'DO_BLIND_XFER_FAILED',
              instanceId: context.instanceId,
              message: error.data.message
            };
          })
        }
      }, {
        id: 'executeXfer',
        src: 'executeXferService',
        onError: {
          target: 'idle',
          actions: /*#__PURE__*/sendParent(function (context, error) {
            return {
              type: 'DO_XFER_FAILED',
              instanceId: context.instanceId,
              message: error.data.message
            };
          })
        }
      }],
      entry: /*#__PURE__*/assign({
        remote_uri: function remote_uri(context, event) {
          return event.result["username"] !== undefined ? event.result["username"] : context.remote_uri;
        },
        retry491Count: function retry491Count() {
          return 0;
        },
        isVideoProcessingComplete: function isVideoProcessingComplete() {
          return false;
        },
        isIceRestartRequired: function isIceRestartRequired() {
          return false;
        }
      }),
      on: {
        DO_ICE_RESTART: {
          actions: /*#__PURE__*/assign({
            isIceRestartRequired: function isIceRestartRequired() {
              return true;
            }
          })
        },
        DO_HANGUP: {
          actions: 'doHangupAction'
        },
        DO_SEND_DTMF: {
          actions: 'doSendDtmfAction'
        },
        HANGUP: {
          cond: function cond(context, event) {
            return context.sip_call_id !== null && event["call_id"] === context.sip_call_id;
          },
          target: 'idle',
          actions: /*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_IDLE',
              instanceId: context.instanceId,
              code: event.result["code"],
              reason: event.result["reason"]
            };
          })
        },
        HANGINGUP: {
          target: 'hangingup',
          actions: /*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_HANGINGUP',
              instanceId: context.instanceId
            };
          })
        },
        UPDATINGCALL: {
          actions: [/*#__PURE__*/assign({
            isVideoProcessingComplete: function isVideoProcessingComplete() {
              return false;
            }
          }), /*#__PURE__*/send(function (context, event) {
            return {
              type: 'UPDATINGCALL_WRAPPED',
              event: event,
              context: context
            };
          })]
        },
        UPDATINGCALL_WRAPPED: {
          actions: /*#__PURE__*/forwardTo('handleRemoteMedia')
        },
        ACCEPTED: {
          actions: /*#__PURE__*/send(function (context, event) {
            return {
              type: 'ACCEPTED_WRAPPED',
              event: event,
              context: context
            };
          })
        },
        ACCEPTED_WRAPPED: {
          actions: /*#__PURE__*/forwardTo('handleRemoteMedia')
        },
        UPDATING: {
          actions: function actions(context) {
            Janus.log("Context=", context);
          }
        },
        UPDATINGCALL_SUCCEEDED: {
          actions: [/*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_CONNECTED',
              instanceId: context.instanceId,
              isInitial: false,
              hasLocalAudio: event.canSendAudio,
              hasRemoteAudio: event.canRecvAudio,
              hasLocalVideo: event.canSendVideo,
              hasRemoteVideo: event.canRecvVideo,
              localVideoSource: event.enabledVideoSource
            };
          }), /*#__PURE__*/assign({
            preferSendAudio: function preferSendAudio(context, event) {
              return event.preferSendAudio;
            },
            preferRecvAudio: function preferRecvAudio(context, event) {
              return event.preferRecvAudio;
            },
            preferSendVideo: function preferSendVideo(context, event) {
              return event.preferSendVideo;
            },
            preferRecvVideo: function preferRecvVideo(context, event) {
              return event.preferRecvVideo;
            },
            canSendAudio: function canSendAudio(context, event) {
              return event.canSendAudio;
            },
            canRecvAudio: function canRecvAudio(context, event) {
              return event.canRecvAudio;
            },
            canSendVideo: function canSendVideo(context, event) {
              return event.canSendVideo;
            },
            enabledVideoSource: function enabledVideoSource(context, event) {
              return event.canSendVideo && context.videoSourceProcessed;
            }
          })]
        },
        UPDATINGCALL_FAILED: {
          actions: [/*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_ERROR',
              instanceId: context.instanceId,
              errorCode: GetErrorMessage(event).toLowerCase().includes('permission') ? CallStatusErrorCode.ERROR_MIDCALL_PERMISSION : CallStatusErrorCode.ERROR_MIDCALL,
              errorMessage: 'Mid-call signalling failure:' + GetErrorMessage(event)
            };
          }), 'doHangupAction']
        },
        REMOTE_SDP_HANDLING_SUCCEEDED: {
          actions: [/*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_CONNECTED',
              instanceId: context.instanceId,
              isInitial: false,
              hasLocalAudio: event.canSendAudio,
              hasRemoteAudio: event.canRecvAudio,
              hasLocalVideo: event.canSendVideo,
              hasRemoteVideo: event.canRecvVideo,
              localVideoSource: event.enabledVideoSource
            };
          }), /*#__PURE__*/assign({
            isVideoProcessingComplete: function isVideoProcessingComplete() {
              return true;
            },
            canSendAudio: function canSendAudio(context, event) {
              return event.canSendAudio;
            },
            canRecvAudio: function canRecvAudio(context, event) {
              return event.canRecvAudio;
            },
            canSendVideo: function canSendVideo(context, event) {
              return event.canSendVideo;
            },
            canRecvVideo: function canRecvVideo(context, event) {
              return event.canRecvVideo;
            },
            enabledVideoSource: function enabledVideoSource(context, event) {
              return event.canSendVideo && context.videoSourceProcessed;
            },
            isIceRestartRequired: function isIceRestartRequired(context) {
              return false;
            }
          })]
        },
        REMOTE_SDP_HANDLING_FAILED: {
          actions: [/*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_ERROR',
              instanceId: context.instanceId,
              errorCode: GetErrorMessage(event).toLowerCase().includes('permission') ? CallStatusErrorCode.ERROR_MIDCALL_PERMISSION : CallStatusErrorCode.ERROR_MIDCALL,
              errorMessage: 'Mid-call signalling failure:' + GetErrorMessage(event)
            };
          }), 'doHangupAction']
        },
        TRANSFER: {
          actions: 'declineTransferAction'
        },
        NOTIFY: [{
          actions: 'doHangupAction',
          cond: 'xferOk'
        }, {
          actions: /*#__PURE__*/sendParent(function (context, error) {
            return {
              type: 'DO_BLIND_XFER_FAILED',
              instanceId: context.instanceId,
              message: 'Transfer failed'
            };
          }),
          cond: 'blindXferFailed'
        }, {
          actions: /*#__PURE__*/sendParent(function (context, error) {
            return {
              type: 'DO_XFER_FAILED',
              instanceId: context.instanceId,
              message: 'Transfer failed'
            };
          }),
          cond: 'xferFailed'
        }, {
          target: undefined,
          cond: 'xferProgress'
        }]
      },
      states: {
        notHold: {
          entry: /*#__PURE__*/choose([{
            cond: function cond(context) {
              return context.doVideo !== context.doVideoProcessed || context.doVideo && context.videoSource !== context.videoSourceProcessed;
            },
            actions: /*#__PURE__*/send('DO_CHECK_VIDEO')
          }, {
            cond: function cond(context) {
              return context.isIceRestartRequired;
            },
            actions: /*#__PURE__*/send('DO_ICE_RESTART')
          }]),
          on: {
            DO_CHECK_VIDEO: {
              target: 'updatingVideo',
              cond: function cond(context) {
                return context.doVideo !== context.doVideoProcessed || context.doVideo && context.videoSource !== context.videoSourceProcessed;
              }
            },
            DO_ENABLE_VIDEO: {
              target: 'updatingVideo',
              actions: [/*#__PURE__*/assign({
                doVideo: function doVideo(context, event) {
                  return event.doVideo;
                },
                videoSource: function videoSource(context, event) {
                  return event.videoSource;
                }
              })],
              cond: function cond(context, event) {
                return !context.isVideoProcessingComplete || event.doVideo !== context.doVideoProcessed || event.doVideo && event.videoSource !== context.videoSourceProcessed;
              }
            },
            DO_ICE_RESTART: 'restartingIce',
            DO_HOLD: 'tryingHold',
            DO_RESUME: undefined,
            TRANSFER: {
              actions: /*#__PURE__*/sendParent(function (context, event) {
                return {
                  type: 'HANDLE_REFER',
                  instanceId: context.instanceId,
                  refer_event: event
                };
              })
            }
          }
        },
        restartingIce: {
          invoke: {
            id: 'restartIce',
            src: 'restartIceService',
            onError: {
              target: 'notHold',
              actions: /*#__PURE__*/sendParent(function (context, event) {
                return {
                  type: 'CALL_STATE_CONNECTED',
                  instanceId: context.instanceId,
                  isInitial: false,
                  hasLocalAudio: context.canSendAudio,
                  hasRemoteAudio: context.canRecvAudio,
                  hasLocalVideo: context.canSendVideo,
                  hasRemoteVideo: context.canRecvVideo,
                  localVideoSource: context.enabledVideoSource
                };
              })
            }
          },
          entry: [/*#__PURE__*/assign({
            isIceRestartRequired: function isIceRestartRequired() {
              return false;
            }
          }), /*#__PURE__*/assign({
            retry491Count: function retry491Count(context, event) {
              return event.type == 'RETRY_491' ? context.retry491Count + 1 : 0;
            }
          }), /*#__PURE__*/send(function (context, event) {
            return {
              type: 'DO_HANGUP',
              reason: 'RESTARTING_ICE_TIMER'
            };
          }, {
            delay: 16000,
            id: 'RESTARTING_ICE_TIMER'
          })],
          exit: [/*#__PURE__*/cancel('RESTARTING_ICE_TIMER'), /*#__PURE__*/cancel('RETRY_491_TIMER'), /*#__PURE__*/assign({
            isIceRestartRequired: function isIceRestartRequired() {
              return false;
            }
          })],
          on: {
            RETRY_491: {
              target: 'restartingIce',
              internal: false
            },
            // wrong state shall be treated as 491 invite error
            SIP_ERROR: {
              actions: /*#__PURE__*/raise({
                type: 'INVITE_ERROR',
                result: {
                  code: 491
                }
              }),
              cond: function cond(context, event) {
                return event.error_code === 447;
              }
            },
            INVITE_ERROR: [// no more than 3 retries in a row
            {
              actions: 'doHangupAction',
              cond: function cond(context, event) {
                return event.result["code"] !== 491 || context.retry491Count >= 3;
              }
            }, {
              actions: [/*#__PURE__*/cancel('RESTARTING_ICE_TIMER'), /*#__PURE__*/send(function (context, event) {
                return {
                  type: 'RETRY_491'
                };
              }, {
                delay: function delay(context) {
                  var max = context.isCallee ? 600 : 300;
                  var min = context.isCallee ? 310 : 0;
                  var delay = 10 * Math.floor(Math.random() * (max - min + 1) + min);
                  Janus.log("Delaying handling of INVITE_ERROR by " + delay + " ms");
                  return delay;
                },
                id: 'RETRY_491_TIMER'
              })]
            }],
            DO_HOLD: undefined,
            DO_RESUME: undefined,
            DO_SEND_DTMF: undefined,
            REMOTE_SDP_HANDLING_SUCCEEDED: {
              target: 'notHold',
              actions: [/*#__PURE__*/sendParent(function (context, event) {
                return {
                  type: 'CALL_STATE_CONNECTED',
                  instanceId: context.instanceId,
                  isInitial: false,
                  hasLocalAudio: event.canSendAudio,
                  hasRemoteAudio: event.canRecvAudio,
                  hasLocalVideo: event.canSendVideo,
                  hasRemoteVideo: event.canRecvVideo,
                  localVideoSource: event.enabledVideoSource
                };
              }), /*#__PURE__*/assign({
                isIceRestartRequired: function isIceRestartRequired(context) {
                  return false;
                }
              })]
            },
            ICE_RESTART_FAILED: {
              target: 'notHold',
              actions: [/*#__PURE__*/sendParent(function (context, event) {
                return {
                  type: 'CALL_STATE_ERROR',
                  instanceId: context.instanceId,
                  errorCode: GetErrorMessage(event).toLowerCase().includes('permission') ? CallStatusErrorCode.ERROR_MIDCALL_PERMISSION : CallStatusErrorCode.ERROR_MIDCALL,
                  errorMessage: 'Mid-call signalling failure:' + GetErrorMessage(event)
                };
              }), /*#__PURE__*/sendParent(function (context, event) {
                return {
                  type: 'CALL_STATE_CONNECTED',
                  instanceId: context.instanceId,
                  isInitial: false,
                  hasLocalAudio: context.canSendAudio,
                  hasRemoteAudio: context.canRecvAudio,
                  hasLocalVideo: context.canSendVideo,
                  hasRemoteVideo: context.canRecvVideo,
                  localVideoSource: context.enabledVideoSource
                };
              })]
            }
          }
        },
        updatingVideo: {
          invoke: {
            id: 'updateMedia',
            src: 'updateVideoService',
            onError: {
              target: 'notHold',
              actions: /*#__PURE__*/sendParent(function (context, event) {
                return {
                  type: 'CALL_STATE_CONNECTED',
                  instanceId: context.instanceId,
                  isInitial: false,
                  hasLocalAudio: context.canSendAudio,
                  hasRemoteAudio: context.canRecvAudio,
                  hasLocalVideo: context.canSendVideo,
                  hasRemoteVideo: context.canRecvVideo,
                  localVideoSource: context.enabledVideoSource
                };
              })
            }
          },
          entry: [/*#__PURE__*/assign({
            isVideoProcessingComplete: function isVideoProcessingComplete() {
              return false;
            }
          }), /*#__PURE__*/assign({
            doVideoProcessed: function doVideoProcessed(context) {
              return context.doVideo;
            },
            videoSourceProcessed: function videoSourceProcessed(context) {
              return context.videoSource;
            },
            enabledVideoSource: function enabledVideoSource() {
              return undefined;
            }
          }), /*#__PURE__*/assign({
            retry491Count: function retry491Count(context, event) {
              return event.type == 'RETRY_491' ? context.retry491Count + 1 : 0;
            }
          }), /*#__PURE__*/send(function (context, event) {
            return {
              type: 'DO_HANGUP'
            };
          }, {
            delay: 16000,
            id: 'UPDATING_VIDEO_TIMER'
          })],
          exit: [/*#__PURE__*/cancel('UPDATING_VIDEO_TIMER'), /*#__PURE__*/cancel('RETRY_491_TIMER')],
          on: {
            RETRY_491: {
              target: 'updatingVideo',
              internal: false
            },
            // wrong state shall be treated as 491 invite error
            SIP_ERROR: {
              actions: /*#__PURE__*/raise({
                type: 'INVITE_ERROR',
                result: {
                  code: 491
                }
              }),
              cond: function cond(context, event) {
                return event.error_code === 447;
              }
            },
            INVITE_ERROR: [// no more than 3 retries in a row
            {
              actions: 'doHangupAction',
              cond: function cond(context, event) {
                return event.result["code"] !== 491 || context.retry491Count >= 3;
              }
            }, {
              actions: [/*#__PURE__*/cancel('UPDATING_VIDEO_TIMER'), /*#__PURE__*/send(function (context, event) {
                return {
                  type: 'RETRY_491'
                };
              }, {
                delay: function delay(context) {
                  var max = context.isCallee ? 600 : 300;
                  var min = context.isCallee ? 310 : 0;
                  var delay = 10 * Math.floor(Math.random() * (max - min + 1) + min);
                  Janus.log("Delaying handling of INVITE_ERROR by " + delay + " ms");
                  return delay;
                },
                id: 'RETRY_491_TIMER'
              })]
            }],
            DO_HOLD: undefined,
            DO_RESUME: undefined,
            DO_SEND_DTMF: undefined,
            UPDATING_MEDIA: {
              target: undefined,
              actions: /*#__PURE__*/assign({
                preferSendAudio: function preferSendAudio(context, event) {
                  return event.preferSendAudio;
                },
                preferRecvAudio: function preferRecvAudio(context, event) {
                  return event.preferRecvAudio;
                },
                preferSendVideo: function preferSendVideo(context, event) {
                  return event.preferSendVideo;
                },
                preferRecvVideo: function preferRecvVideo(context, event) {
                  return event.preferRecvVideo;
                }
              })
            },
            REMOTE_SDP_HANDLING_SUCCEEDED: {
              target: 'notHold',
              actions: [/*#__PURE__*/sendParent(function (context, event) {
                return {
                  type: 'CALL_STATE_CONNECTED',
                  instanceId: context.instanceId,
                  isInitial: false,
                  hasLocalAudio: event.canSendAudio,
                  hasRemoteAudio: event.canRecvAudio,
                  hasLocalVideo: event.canSendVideo,
                  hasRemoteVideo: event.canRecvVideo,
                  localVideoSource: event.enabledVideoSource
                };
              }), /*#__PURE__*/assign({
                isVideoProcessingComplete: function isVideoProcessingComplete() {
                  return true;
                },
                canSendAudio: function canSendAudio(context, event) {
                  return event.canSendAudio;
                },
                canRecvAudio: function canRecvAudio(context, event) {
                  return event.canRecvAudio;
                },
                canSendVideo: function canSendVideo(context, event) {
                  return event.canSendVideo;
                },
                canRecvVideo: function canRecvVideo(context, event) {
                  return event.canRecvVideo;
                },
                enabledVideoSource: function enabledVideoSource(context, event) {
                  return event.canSendVideo && context.videoSourceProcessed;
                },
                isIceRestartRequired: function isIceRestartRequired(context) {
                  return false;
                }
              })]
            },
            UPDATE_MEDIA_FAILED: {
              target: 'notHold',
              actions: [/*#__PURE__*/sendParent(function (context, event) {
                return {
                  type: 'CALL_STATE_ERROR',
                  instanceId: context.instanceId,
                  errorCode: GetErrorMessage(event).toLowerCase().includes('permission') ? CallStatusErrorCode.ERROR_MIDCALL_PERMISSION : CallStatusErrorCode.ERROR_MIDCALL,
                  errorMessage: 'Mid-call signalling failure:' + GetErrorMessage(event)
                };
              }), /*#__PURE__*/sendParent(function (context, event) {
                return {
                  type: 'CALL_STATE_CONNECTED',
                  instanceId: context.instanceId,
                  isInitial: false,
                  hasLocalAudio: context.canSendAudio,
                  hasRemoteAudio: context.canRecvAudio,
                  hasLocalVideo: context.canSendVideo,
                  hasRemoteVideo: context.canRecvVideo,
                  localVideoSource: context.enabledVideoSource
                };
              })]
            }
          }
        },
        tryingHold: {
          invoke: {
            id: 'holdCall',
            src: 'holdCallService',
            onError: {
              target: 'notHold',
              actions: /*#__PURE__*/sendParent(function (context, event) {
                return {
                  type: 'CALL_STATE_CONNECTED',
                  instanceId: context.instanceId,
                  isInitial: false,
                  hasLocalAudio: context.canSendAudio,
                  hasRemoteAudio: context.canRecvAudio,
                  hasLocalVideo: context.canSendVideo,
                  hasRemoteVideo: context.canRecvVideo,
                  localVideoSource: context.enabledVideoSource
                };
              })
            }
          },
          entry: [/*#__PURE__*/assign({
            retry491Count: function retry491Count(context, event) {
              return event.type == 'RETRY_491' ? context.retry491Count + 1 : 0;
            }
          }), /*#__PURE__*/send(function (context, event) {
            return {
              type: 'DO_HANGUP'
            };
          }, {
            delay: 8000,
            id: 'TRYING_HOLD_TIMER'
          })],
          exit: [/*#__PURE__*/cancel('TRYING_HOLD_TIMER'), /*#__PURE__*/cancel('RETRY_491_TIMER')],
          on: {
            RETRY_491: {
              target: 'tryingHold',
              internal: false
            },
            // wrong state shall be treated as 491 invite error
            SIP_ERROR: {
              actions: /*#__PURE__*/raise({
                type: 'INVITE_ERROR',
                result: {
                  code: 491
                }
              }),
              cond: function cond(context, event) {
                return event.error_code === 447;
              }
            },
            INVITE_ERROR: [// no more than 3 retries in a row
            {
              actions: 'doHangupAction',
              cond: function cond(context, event) {
                return event.result["code"] !== 491 || context.retry491Count >= 3;
              }
            }, {
              actions: [/*#__PURE__*/cancel('TRYING_HOLD_TIMER'), /*#__PURE__*/send(function (context, event) {
                return {
                  type: 'RETRY_491'
                };
              }, {
                delay: function delay(context) {
                  var max = context.isCallee ? 400 : 200;
                  var min = context.isCallee ? 210 : 0;
                  var delay = 10 * Math.floor(Math.random() * (max - min + 1) + min);
                  Janus.log("Delaying handling of INVITE_ERROR by " + delay + " ms");
                  return delay;
                },
                id: 'RETRY_491_TIMER'
              })]
            }],
            DO_HOLD: undefined,
            DO_RESUME: undefined,
            DO_SEND_DTMF: undefined,
            HOLDING: {
              target: undefined,
              actions: /*#__PURE__*/assign({
                preferSendAudio: function preferSendAudio(context, event) {
                  return event.preferSendAudio;
                },
                preferRecvAudio: function preferRecvAudio(context, event) {
                  return event.preferRecvAudio;
                },
                preferSendVideo: function preferSendVideo(context, event) {
                  return event.preferSendVideo;
                },
                preferRecvVideo: function preferRecvVideo(context, event) {
                  return event.preferRecvVideo;
                },
                canSendAudio: function canSendAudio(context, event) {
                  return event.canSendAudio;
                },
                canRecvAudio: function canRecvAudio(context, event) {
                  return event.canRecvAudio;
                },
                canSendVideo: function canSendVideo(context, event) {
                  return event.canSendVideo;
                },
                canRecvVideo: function canRecvVideo(context, event) {
                  return event.canRecvVideo;
                }
              })
            },
            REMOTE_SDP_HANDLING_SUCCEEDED: {
              target: 'holding',
              actions: [/*#__PURE__*/assign({
                isVideoProcessingComplete: function isVideoProcessingComplete() {
                  return true;
                },
                canSendAudio: function canSendAudio(context, event) {
                  return event.canSendAudio;
                },
                canRecvAudio: function canRecvAudio(context, event) {
                  return event.canRecvAudio;
                },
                canSendVideo: function canSendVideo(context, event) {
                  return event.canSendVideo;
                },
                canRecvVideo: function canRecvVideo(context, event) {
                  return event.canRecvVideo;
                },
                isIceRestartRequired: function isIceRestartRequired(context) {
                  return false;
                }
              })]
            },
            DO_HOLD_FAILED: {
              target: 'notHold',
              actions: [/*#__PURE__*/sendParent(function (context, event) {
                return {
                  type: 'CALL_STATE_ERROR',
                  instanceId: context.instanceId,
                  errorCode: GetErrorMessage(event).toLowerCase().includes('permission') ? CallStatusErrorCode.ERROR_HOLD_PERMISSION : CallStatusErrorCode.ERROR_HOLD,
                  errorMessage: 'Mid-call signalling failure:' + GetErrorMessage(event)
                };
              }), /*#__PURE__*/sendParent(function (context, event) {
                return {
                  type: 'CALL_STATE_CONNECTED',
                  instanceId: context.instanceId,
                  isInitial: false,
                  hasLocalAudio: context.canSendAudio,
                  hasRemoteAudio: context.canRecvAudio,
                  hasLocalVideo: context.canSendVideo,
                  hasRemoteVideo: context.canRecvVideo,
                  localVideoSource: context.enabledVideoSource
                };
              })]
            }
          }
        },
        holding: {
          entry: [/*#__PURE__*/assign({
            isHolding: function isHolding() {
              return true;
            }
          }), /*#__PURE__*/sendParent(function (context, event) {
            return {
              type: 'CALL_STATE_ONHOLD',
              instanceId: context.instanceId,
              hasLocalAudio: context.canSendAudio,
              hasRemoteAudio: context.canRecvAudio,
              hasLocalVideo: context.canSendVideo,
              hasRemoteVideo: context.canRecvVideo,
              localVideoSource: context.enabledVideoSource
            };
          })],
          exit: /*#__PURE__*/assign({
            isHolding: function isHolding() {
              return false;
            }
          }),
          on: {
            DO_HOLD: undefined,
            DO_RESUME: 'tryingResume',
            DO_SEND_DTMF: undefined,
            DO_BLIND_XFER: {
              actions: [/*#__PURE__*/forwardTo('executeBlindXfer'), /*#__PURE__*/assign({
                isLastXferBlind: function isLastXferBlind() {
                  return true;
                },
                isLastXferSuper: function isLastXferSuper() {
                  return false;
                }
              })]
            },
            DO_XFER: {
              actions: [/*#__PURE__*/forwardTo('executeXfer'), /*#__PURE__*/assign({
                isLastXferBlind: function isLastXferBlind() {
                  return false;
                },
                isLastXferSuper: function isLastXferSuper() {
                  return true;
                }
              })]
            },
            TRANSFER: {
              actions: /*#__PURE__*/sendParent(function (context, event) {
                return {
                  type: 'HANDLE_REFER',
                  instanceId: context.instanceId,
                  refer_event: event
                };
              })
            }
          }
        },
        tryingResume: {
          invoke: {
            id: 'resumeCall',
            src: 'resumeCallService',
            onError: {
              target: 'holding'
            }
          },
          entry: [/*#__PURE__*/assign({
            isVideoProcessingComplete: function isVideoProcessingComplete() {
              return false;
            }
          }), /*#__PURE__*/assign({
            doVideoProcessed: function doVideoProcessed(context) {
              return context.doVideo;
            },
            videoSourceProcessed: function videoSourceProcessed(context) {
              return context.videoSource;
            }
          }), /*#__PURE__*/assign({
            retry491Count: function retry491Count(context, event) {
              return event.type == 'RETRY_491' ? context.retry491Count + 1 : 0;
            }
          }), /*#__PURE__*/send(function (context, event) {
            return {
              type: 'DO_HANGUP'
            };
          }, {
            delay: 8000,
            id: 'TRYING_RESUME_TIMER'
          })],
          exit: [/*#__PURE__*/cancel('TRYING_RESUME_TIMER'), /*#__PURE__*/cancel('RETRY_491_TIMER')],
          on: {
            RETRY_491: {
              target: 'tryingResume',
              internal: false
            },
            // wrong state shall be treated as 491 invite error
            SIP_ERROR: {
              actions: /*#__PURE__*/raise({
                type: 'INVITE_ERROR',
                result: {
                  code: 491
                }
              }),
              cond: function cond(context, event) {
                return event.error_code === 447;
              }
            },
            INVITE_ERROR: [// no more than 3 retries in a row
            {
              actions: 'doHangupAction',
              cond: function cond(context, event) {
                return event.result["code"] !== 491 || context.retry491Count >= 3;
              }
            }, {
              actions: [/*#__PURE__*/cancel('TRYING_RESUME_TIMER'), /*#__PURE__*/send(function (context, event) {
                return {
                  type: 'RETRY_491'
                };
              }, {
                delay: function delay(context) {
                  var max = context.isCallee ? 400 : 200;
                  var min = context.isCallee ? 210 : 0;
                  var delay = 10 * Math.floor(Math.random() * (max - min + 1) + min);
                  Janus.log("Delaying handling of INVITE_ERROR by " + delay + " ms");
                  return delay;
                },
                id: 'RETRY_491_TIMER'
              })]
            }],
            DO_HOLD: undefined,
            DO_RESUME: undefined,
            DO_SEND_DTMF: undefined,
            RESUMING: {
              target: undefined,
              actions: /*#__PURE__*/assign({
                preferSendAudio: function preferSendAudio(context, event) {
                  return event.preferSendAudio;
                },
                preferRecvAudio: function preferRecvAudio(context, event) {
                  return event.preferRecvAudio;
                },
                preferSendVideo: function preferSendVideo(context, event) {
                  return event.preferSendVideo;
                },
                preferRecvVideo: function preferRecvVideo(context, event) {
                  return event.preferRecvVideo;
                },
                canSendAudio: function canSendAudio(context, event) {
                  return event.canSendAudio;
                },
                canRecvAudio: function canRecvAudio(context, event) {
                  return event.canRecvAudio;
                },
                canSendVideo: function canSendVideo(context, event) {
                  return event.canSendVideo;
                },
                canRecvVideo: function canRecvVideo(context, event) {
                  return event.canRecvVideo;
                }
              })
            },
            REMOTE_SDP_HANDLING_SUCCEEDED: {
              target: 'notHold',
              actions: [/*#__PURE__*/sendParent(function (context, event) {
                return {
                  type: 'CALL_STATE_CONNECTED',
                  instanceId: context.instanceId,
                  isInitial: false,
                  hasLocalAudio: event.canSendAudio,
                  hasRemoteAudio: event.canRecvAudio,
                  hasLocalVideo: event.canSendVideo,
                  hasRemoteVideo: event.canRecvVideo,
                  localVideoSource: event.enabledVideoSource,
                  isIceRestartRequired: function isIceRestartRequired(context) {
                    return false;
                  }
                };
              }), /*#__PURE__*/assign({
                isVideoProcessingComplete: function isVideoProcessingComplete() {
                  return true;
                },
                canSendAudio: function canSendAudio(context, event) {
                  return event.canSendAudio;
                },
                canRecvAudio: function canRecvAudio(context, event) {
                  return event.canRecvAudio;
                },
                canSendVideo: function canSendVideo(context, event) {
                  return event.canSendVideo;
                },
                canRecvVideo: function canRecvVideo(context, event) {
                  return event.canRecvVideo;
                },
                localVideoSource: function localVideoSource(context, event) {
                  return event.enabledVideoSource;
                }
              })]
            },
            DO_RESUME_FAILED: [/*#__PURE__*/sendParent(function (context, event) {
              return {
                type: 'CALL_STATE_ERROR',
                instanceId: context.instanceId,
                errorCode: GetErrorMessage(event).toLowerCase().includes('permission') ? CallStatusErrorCode.ERROR_RESUME_PERMISSION : CallStatusErrorCode.ERROR_RESUME,
                errorMessage: 'Mid-call signalling failure:' + GetErrorMessage(event)
              };
            }), 'holding']
          }
        }
      }
    }
  } // states

}, {
  guards: {
    xferOk: function xferOk(context, event) {
      Janus.log("Checking xferOK condition, isLastXferBlind=", context.isLastXferBlind, "isLastXferSuper=", context.isLastXferSuper);

      if ((context.isLastXferBlind || context.isLastXferSuper) && event.result["notify"] === "refer" && event.result["content"] !== undefined) {
        var splitContent = event.result["content"].split(" ");

        if (splitContent.length > 1 && splitContent[1] >= +180 && splitContent[1] < +300) {
          Janus.log("xferOK condition is true");
          return true;
        }
      }

      Janus.log("xferOK condition is false");
      return false;
    },
    blindXferFailed: function blindXferFailed(context, event) {
      Janus.log("Checking blindXferFailed condition...");

      if (context.isLastXferBlind && event.result["notify"] === "refer" && event.result["content"] !== undefined) {
        var splitContent = event.result["content"].split(" ");

        if (splitContent.length > 1 && splitContent[1] >= +300) {
          Janus.log("blindXferFailed condition is true");
          return true;
        }
      }

      Janus.log("blindXferFailed condition is false");
      return false;
    },
    xferFailed: function xferFailed(context, event) {
      Janus.log("Checking xferFailed condition...");

      if (context.isLastXferSuper && event.result["notify"] === "refer" && event.result["content"] !== undefined) {
        var splitContent = event.result["content"].split(" ");

        if (splitContent.length > 1 && splitContent[1] >= +300) {
          Janus.log("xferFailed condition is true");
          return true;
        }
      }

      Janus.log("xferFailed condition is false");
      return false;
    },
    xferProgress: function xferProgress(context, event) {
      Janus.log("Checking xferProgress condition...");

      if ((context.isLastXferBlind || context.isLastXferSuper) && event.result["notify"] === "refer" && event.result["content"] !== undefined) {
        Janus.log("xferProgress condition is true");
        return true;
      }

      Janus.log("xferProgress condition is false");
      return false;
    }
  },
  actions: {
    doHangupAction: function doHangupAction(context, event) {
      if (event.message !== undefined) {
        Janus.debug("hanging up with message:", GetErrorMessage(event));
      }

      Janus.log("doHangupAction with event:", event);
      context.pluginHandle.hangup(true);
    },
    doSendDtmfAction: function doSendDtmfAction(context, event) {
      context.pluginHandle.dtmf({
        dtmf: {
          tones: event.dtmf
        }
      });
    },
    logEvent: function logEvent(context, event) {
      Janus.log("!!! Context: ", context);
      Janus.log("!!! Event: ", event);
    },
    declineTransferAction: function declineTransferAction(context, event) {
      Janus.log("Declining transfer request");
      var referId = event.result["refer_id"];
      var body = {
        request: "decline",
        refer_id: referId,
        code: 403
      };
      context.pluginHandle.send({
        "message": body
      });
    },
    messageAckIncomingCallAction: function messageAckIncomingCallAction(context, event) {
      Janus.log("Sending message to ack incoming call");
      var body = {
        request: "message",
        content: "Your call is important to us!"
      };
      context.pluginHandle.send({
        "message": body
      });
    },
    logDoMakeCallAction: function logDoMakeCallAction(context, event) {
      Janus.log("DO_MAKE_CALL Context: ", context);
      Janus.log("DO_MAKE_CALL Event: ", event);
    },
    logJanusSessionEnded: function logJanusSessionEnded(context, event) {
      Janus.log("JANUS_SESSION_ENDED Context: ", context);
      Janus.log("JANUS_SESSION_ENDED Event: ", event);
    },
    logContext: function logContext(context, event) {
      Janus.log("Log Context: ", context);
      Janus.log("Log Event: ", event);
    }
  },
  services: {
    restartIceService: function restartIceService(context, event) {
      return function (callback, onReceive) {
        try {
          var _defaultMediaConstrai, _defaultMediaConstrai2, _defaultMediaConstrai3, _defaultMediaConstrai4, _defaultMediaConstrai5, _defaultMediaConstrai6, _defaultMediaConstrai7, _defaultMediaConstrai8, _defaultMediaConstrai9;

          Janus.log("Restart ICE service with event:", event);
          var sendAudio = context.canSendAudio;
          var recvAudio = context.canRecvAudio;
          var sendVideo = context.doVideo;
          var recvVideo = context.canRecvVideo;
          Janus.log("Restarting ICE with: ", "sendAudio=", sendAudio, "recvAudio=", recvAudio);
          Janus.log("Restarting ICE with: ", "sendVideo=", sendVideo, "recvVideo=", recvVideo);
          context.pluginHandle.createOffer({
            media: {
              audioSend: sendAudio,
              audioRecv: recvAudio,
              videoSend: sendVideo,
              videoRecv: recvVideo,
              audio: {
                autoGainControl: (_defaultMediaConstrai = (_defaultMediaConstrai2 = defaultMediaConstraints) == null ? void 0 : _defaultMediaConstrai2.autoGainControl) != null ? _defaultMediaConstrai : false,
                echoCancellation: (_defaultMediaConstrai3 = (_defaultMediaConstrai4 = defaultMediaConstraints) == null ? void 0 : _defaultMediaConstrai4.echoCancellation) != null ? _defaultMediaConstrai3 : false,
                noiseSuppression: (_defaultMediaConstrai5 = (_defaultMediaConstrai6 = defaultMediaConstraints) == null ? void 0 : _defaultMediaConstrai6.noiseSuppression) != null ? _defaultMediaConstrai5 : false,
                channelCount: (_defaultMediaConstrai7 = defaultMediaConstraints) == null ? void 0 : _defaultMediaConstrai7.channelCount,
                sampleRate: (_defaultMediaConstrai8 = defaultMediaConstraints) == null ? void 0 : _defaultMediaConstrai8.sampleRate,
                sampleSize: (_defaultMediaConstrai9 = defaultMediaConstraints) == null ? void 0 : _defaultMediaConstrai9.sampleSize
              },
              video: context.videoSource,
              // can be 'screen', 'window' or undefined
              captureDesktopAudio: context.videoSource === 'screen',
              screenshareFrameRate: context.videoSource === 'screen' ? context.srFrameRate : undefined,
              screenshareWidth: context.videoSource === 'screen' ? context.srScreenWidth : undefined,
              screenshareHeight: context.videoSource === 'screen' ? context.srScreenHeight : undefined
            },
            iceRestart: true,
            customizeSdp: function customizeSdp(jsep) {
              Janus.log("customizeSdp before:", jsep);
              FixInactiveSdpAttr(jsep, sendAudio, recvAudio, sendVideo, recvVideo);

              if (context.videoSource === 'screen') {
                EnableStereoAudio(jsep);
              }

              Janus.log("customizeSdp after:", jsep);
            },
            success: function success(jsep) {
              try {
                Janus.debug("Got SDP!");
                Janus.debug(jsep);
                var body = {
                  request: "update"
                };
                context.pluginHandle.send({
                  "message": body,
                  "jsep": jsep
                });
              } catch (error) {
                Janus.log("Error restarting ICE, error: ", error.message);
                callback({
                  type: 'ICE_RESTART_FAILED',
                  message: error.message
                });
              }
            },
            error: function error(message) {
              Janus.log("Error restarting ICE, error: ", message);
              callback({
                type: 'ICE_RESTART_FAILED',
                message: message
              });
            }
          });
        } catch (error) {
          Janus.log("Error restarting ICE, error: ", error.message);
          callback({
            type: 'ICE_RESTART_FAILED',
            message: error.message
          });
        }
      };
    },
    updateVideoService: function updateVideoService(context, event) {
      return function (callback, onReceive) {
        try {
          var _defaultMediaConstrai10, _defaultMediaConstrai11, _defaultMediaConstrai12, _defaultMediaConstrai13, _defaultMediaConstrai14, _defaultMediaConstrai15, _defaultMediaConstrai16, _defaultMediaConstrai17, _defaultMediaConstrai18;

          Janus.log("Update video service with event:", event);
          var sendAudio = context.canSendAudio;
          var recvAudio = context.canRecvAudio;
          var sendVideo = context.doVideo;
          var recvVideo = context.canRecvVideo || context.doVideo;
          var addVideo = context.doVideo && context.retry491Count == 0;
          var removeVideo = !sendVideo;
          Janus.log("Updating video with: ", "sendAudio=", sendAudio, "recvAudio=", recvAudio);
          Janus.log("Updating video with: ", "sendVideo=", sendVideo, "recvVideo=", recvVideo);

          if (context.isIceRestartRequired) {
            Janus.log("Updating video with ICE restart");
          }

          context.pluginHandle.createOffer({
            media: {
              audioSend: sendAudio,
              audioRecv: recvAudio,
              videoSend: sendVideo,
              videoRecv: recvVideo,
              addVideo: addVideo,
              removeVideo: removeVideo,
              audio: {
                autoGainControl: (_defaultMediaConstrai10 = (_defaultMediaConstrai11 = defaultMediaConstraints) == null ? void 0 : _defaultMediaConstrai11.autoGainControl) != null ? _defaultMediaConstrai10 : false,
                echoCancellation: (_defaultMediaConstrai12 = (_defaultMediaConstrai13 = defaultMediaConstraints) == null ? void 0 : _defaultMediaConstrai13.echoCancellation) != null ? _defaultMediaConstrai12 : false,
                noiseSuppression: (_defaultMediaConstrai14 = (_defaultMediaConstrai15 = defaultMediaConstraints) == null ? void 0 : _defaultMediaConstrai15.noiseSuppression) != null ? _defaultMediaConstrai14 : false,
                channelCount: (_defaultMediaConstrai16 = defaultMediaConstraints) == null ? void 0 : _defaultMediaConstrai16.channelCount,
                sampleRate: (_defaultMediaConstrai17 = defaultMediaConstraints) == null ? void 0 : _defaultMediaConstrai17.sampleRate,
                sampleSize: (_defaultMediaConstrai18 = defaultMediaConstraints) == null ? void 0 : _defaultMediaConstrai18.sampleSize
              },
              video: context.videoSource,
              // can be 'screen', 'window' or undefined
              captureDesktopAudio: context.videoSource === 'screen',
              screenshareFrameRate: context.videoSource === 'screen' ? context.srFrameRate : undefined,
              screenshareWidth: context.videoSource === 'screen' ? context.srScreenWidth : undefined,
              screenshareHeight: context.videoSource === 'screen' ? context.srScreenHeight : undefined
            },
            iceRestart: context.isIceRestartRequired,
            customizeSdp: function customizeSdp(jsep) {
              Janus.log("customizeSdp before:", jsep);
              FixInactiveSdpAttr(jsep, sendAudio, recvAudio, sendVideo, recvVideo);

              if (context.videoSource === 'screen') {
                EnableStereoAudio(jsep);
              }

              Janus.log("customizeSdp after:", jsep);
            },
            success: function success(jsep) {
              try {
                Janus.debug("Got SDP!");
                Janus.debug(jsep);
                var body = {
                  request: "update"
                };
                context.pluginHandle.send({
                  "message": body,
                  "jsep": jsep
                });
                callback({
                  type: 'UPDATING_MEDIA',
                  preferSendAudio: sendAudio,
                  preferRecvAudio: recvAudio,
                  preferSendVideo: sendVideo,
                  preferRecvVideo: recvVideo
                });
              } catch (error) {
                Janus.log("Error updating call media, error: ", error.message);
                callback({
                  type: 'UPDATE_MEDIA_FAILED',
                  message: error.message
                });
              }
            },
            error: function error(message) {
              Janus.log("Error updating call media, error: ", message);
              callback({
                type: 'UPDATE_MEDIA_FAILED',
                message: message
              });
            }
          });
        } catch (error) {
          callback({
            type: 'UPDATE_MEDIA_FAILED',
            message: error.message
          });
        }
      };
    },
    holdCallService: function holdCallService(context, event) {
      return function (callback, onReceive) {
        try {
          Janus.log("Hold call service with event:", event);
          var sendAudio = false;
          var recvAudio = false;
          var sendVideo = false;
          var recvVideo = false;
          var removeVideo = true;
          Janus.log("Holding with: ", "sendAudio=", sendAudio, "recvAudio=", recvAudio);
          Janus.log("Holding with: ", "sendVideo=", sendVideo, "recvVideo=", recvVideo);

          if (context.isIceRestartRequired) {
            Janus.log("Holding with ICE restart");
          }

          context.pluginHandle.createOffer({
            media: {
              audioSend: sendAudio,
              audioRecv: recvAudio,
              videoSend: sendVideo,
              videoRecv: recvVideo,
              removeVideo: removeVideo
            },
            iceRestart: context.isIceRestartRequired,
            customizeSdp: function customizeSdp(jsep) {
              FixInactiveSdpAttr(jsep, sendAudio, recvAudio, sendVideo, recvVideo);
            },
            success: function success(jsep) {
              try {
                Janus.debug("Got SDP!");
                Janus.debug(jsep);
                var body = {
                  request: "update"
                };
                context.pluginHandle.send({
                  "message": body,
                  "jsep": jsep
                });
                callback({
                  type: 'HOLDING',
                  preferSendAudio: sendAudio,
                  preferRecvAudio: recvAudio,
                  preferSendVideo: sendVideo,
                  preferRecvVideo: recvVideo,
                  canSendAudio: sendAudio,
                  canRecvAudio: recvAudio,
                  canSendVideo: sendVideo,
                  canRecvVideo: recvVideo
                });
              } catch (error) {
                Janus.log("Error holding call, error: ", error.message);
                callback({
                  type: 'DO_HOLD_FAILED',
                  message: error.message
                });
              }
            },
            error: function error(message) {
              Janus.log("Error holding call, error: ", message);
              callback({
                type: 'DO_HOLD_FAILED',
                message: message
              });
            }
          });
        } catch (error) {
          callback({
            type: 'DO_HOLD_FAILED',
            message: error.message
          });
        }
      };
    },
    resumeCallService: function resumeCallService(context, event) {
      return function (callback, onReceive) {
        try {
          var _defaultMediaConstrai19, _defaultMediaConstrai20, _defaultMediaConstrai21, _defaultMediaConstrai22, _defaultMediaConstrai23, _defaultMediaConstrai24, _defaultMediaConstrai25, _defaultMediaConstrai26, _defaultMediaConstrai27;

          Janus.log("Resume call service with event:", event, ", context: ", context);
          var sendAudio = true;
          var recvAudio = true;
          var sendVideo = context.doVideo;
          var recvVideo = context.preferRecvVideo || context.canRecvVideo || context.doVideo;
          Janus.log("Resuming with: ", "sendAudio=", sendAudio, "recvAudio=", recvAudio);
          Janus.log("Resuming with: ", "sendVideo=", sendVideo, "recvVideo=", recvVideo);

          if (context.isIceRestartRequired) {
            Janus.log("Resuming with ICE restart");
          }

          context.pluginHandle.createOffer({
            media: {
              audioSend: sendAudio,
              audioRecv: recvAudio,
              videoSend: sendVideo,
              videoRecv: recvVideo,
              audio: {
                autoGainControl: (_defaultMediaConstrai19 = (_defaultMediaConstrai20 = defaultMediaConstraints) == null ? void 0 : _defaultMediaConstrai20.autoGainControl) != null ? _defaultMediaConstrai19 : false,
                echoCancellation: (_defaultMediaConstrai21 = (_defaultMediaConstrai22 = defaultMediaConstraints) == null ? void 0 : _defaultMediaConstrai22.echoCancellation) != null ? _defaultMediaConstrai21 : false,
                noiseSuppression: (_defaultMediaConstrai23 = (_defaultMediaConstrai24 = defaultMediaConstraints) == null ? void 0 : _defaultMediaConstrai24.noiseSuppression) != null ? _defaultMediaConstrai23 : false,
                channelCount: (_defaultMediaConstrai25 = defaultMediaConstraints) == null ? void 0 : _defaultMediaConstrai25.channelCount,
                sampleRate: (_defaultMediaConstrai26 = defaultMediaConstraints) == null ? void 0 : _defaultMediaConstrai26.sampleRate,
                sampleSize: (_defaultMediaConstrai27 = defaultMediaConstraints) == null ? void 0 : _defaultMediaConstrai27.sampleSize
              },
              video: sendVideo ? context.enabledVideoSource : undefined,
              captureDesktopAudio: sendVideo && context.videoSource === 'screen',
              screenshareFrameRate: sendVideo && context.videoSource === 'screen' ? context.srFrameRate : undefined,
              screenshareWidth: context.videoSource === 'screen' ? context.srScreenWidth : undefined,
              screenshareHeight: context.videoSource === 'screen' ? context.srScreenHeight : undefined
            },
            iceRestart: context.isIceRestartRequired,
            customizeSdp: function customizeSdp(jsep) {
              FixInactiveSdpAttr(jsep, sendAudio, recvAudio, sendVideo, recvVideo);

              if (sendVideo && context.videoSource === 'screen') {
                EnableStereoAudio(jsep);
              }
            },
            success: function success(jsep) {
              try {
                Janus.debug("Got SDP!");
                Janus.debug(jsep);
                var body = {
                  request: "update"
                };
                context.pluginHandle.send({
                  "message": body,
                  "jsep": jsep
                });
                callback({
                  type: 'RESUMING',
                  preferSendAudio: sendAudio,
                  preferRecvAudio: recvAudio,
                  preferSendVideo: sendVideo,
                  preferRecvVideo: recvVideo,
                  canSendAudio: sendAudio,
                  canRecvAudio: recvAudio,
                  canSendVideo: sendVideo,
                  canRecvVideo: recvVideo
                });
              } catch (error) {
                Janus.log("Error resuming call, error: ", error.message);
                callback({
                  type: 'DO_RESUME_FAILED',
                  message: error.message
                });
              }
            },
            error: function error(message) {
              Janus.log("Error resuming call, error: ", message);
              callback({
                type: 'DO_RESUME_FAILED',
                message: message
              });
            }
          });
        } catch (error) {
          callback({
            type: 'DO_RESUME_FAILED',
            message: error.message
          });
        }
      };
    },
    // get SDP offer
    makeCallService: function makeCallService(context, event) {
      return function (callback, onReceive) {
        try {
          var _defaultMediaConstrai28, _defaultMediaConstrai29, _defaultMediaConstrai30, _defaultMediaConstrai31, _defaultMediaConstrai32, _defaultMediaConstrai33, _defaultMediaConstrai34, _defaultMediaConstrai35, _defaultMediaConstrai36;

          Janus.log("Creating offer with event:", event, ", video has been requested: ", context.doVideo);
          context.preferSendAudio = true; //context.preferRecvAudio = true;

          context.preferRecvAudio = !(context.doVideo && context.videoSource === 'screen');
          context.preferSendVideo = context.doVideo; //context.preferRecvVideo = context.doVideo;

          context.preferRecvVideo = context.doVideo && context.videoSource !== 'screen';
          Janus.log("Offering with: ", "preferSendAudio=", context.preferSendAudio, "preferRecvAudio=", context.preferRecvAudio);
          Janus.log("Offering with: ", "preferSendVideo=", context.preferSendVideo, "preferRecvVideo=", context.preferRecvVideo);
          context.pluginHandle.createOffer({
            media: {
              audioSend: context.preferSendAudio,
              audioRecv: context.preferRecvAudio,
              videoSend: context.preferSendVideo,
              videoRecv: context.preferRecvVideo,
              audio: {
                autoGainControl: (_defaultMediaConstrai28 = (_defaultMediaConstrai29 = defaultMediaConstraints) == null ? void 0 : _defaultMediaConstrai29.autoGainControl) != null ? _defaultMediaConstrai28 : false,
                echoCancellation: (_defaultMediaConstrai30 = (_defaultMediaConstrai31 = defaultMediaConstraints) == null ? void 0 : _defaultMediaConstrai31.echoCancellation) != null ? _defaultMediaConstrai30 : false,
                noiseSuppression: (_defaultMediaConstrai32 = (_defaultMediaConstrai33 = defaultMediaConstraints) == null ? void 0 : _defaultMediaConstrai33.noiseSuppression) != null ? _defaultMediaConstrai32 : false,
                channelCount: (_defaultMediaConstrai34 = defaultMediaConstraints) == null ? void 0 : _defaultMediaConstrai34.channelCount,
                sampleRate: (_defaultMediaConstrai35 = defaultMediaConstraints) == null ? void 0 : _defaultMediaConstrai35.sampleRate,
                sampleSize: (_defaultMediaConstrai36 = defaultMediaConstraints) == null ? void 0 : _defaultMediaConstrai36.sampleSize
              },
              video: context.doVideo ? context.videoSource : undefined,
              captureDesktopAudio: context.doVideo && context.videoSource === 'screen',
              screenshareFrameRate: context.doVideo && context.videoSource === 'screen' ? context.srFrameRate : undefined,
              screenshareWidth: context.videoSource === 'screen' ? context.srScreenWidth : undefined,
              screenshareHeight: context.videoSource === 'screen' ? context.srScreenHeight : undefined
            },
            customizeSdp: function customizeSdp(jsep) {
              if (context.doVideo && context.videoSource === 'screen') {
                EnableStereoAudio(jsep);
              }
            },
            success: function success(jsep) {
              try {
                Janus.debug("Got SDP!");
                Janus.debug(jsep);
                var body = {
                  request: "call",
                  uri: event.target
                };

                if (context.instanceId !== 0) {
                  body["headers"] = {
                    "Janus-Helper-Id": "C" + context.instanceId
                  };
                }

                if (event.referId) {
                  // In case we're originating this call because of a call
                  // transfer, we need to provide the internal reference ID
                  body["refer_id"] = event.referId;
                }

                if (event.callId) {
                  body["call_id"] = event.callId;
                }

                body["autoaccept_reinvites"] = false;
                context.pluginHandle.send({
                  "message": body,
                  "jsep": jsep
                });
                callback({
                  type: 'DO_MAKE_CALL_SUCCEEDED',
                  jsep: jsep,
                  preferSendAudio: context.preferSendAudio,
                  preferRecvAudio: context.preferRecvAudio,
                  preferSendVideo: context.preferSendVideo,
                  preferRecvVideo: context.preferRecvVideo
                });
              } catch (error) {
                callback({
                  type: 'DO_MAKE_CALL_FAILED',
                  message: error.message
                });
              }
            },
            error: function error(message) {
              callback({
                type: 'DO_MAKE_CALL_FAILED',
                message: message
              });
            }
          });
        } catch (error) {
          callback({
            type: 'DO_MAKE_CALL_FAILED',
            message: error.message
          });
        }
      };
    },
    handleRemoteMediaService: function handleRemoteMediaService(context, event) {
      return function (callback, onReceive) {
        onReceive(function (event) {
          var e = event.event;
          var context = event.context;
          var local_context = event.context;
          local_context.preferRecvVideo = e.jsep && e.jsep.sdp && e.jsep.sdp.includes("m=video") || context.doVideo;
          local_context.canRecvVideo = local_context.canRecvVideo || local_context.preferRecvVideo;

          if (e.type === 'UPDATINGCALL') {
            // create answer SDP
            try {
              var offerless = !e.jsep || !e.jsep.sdp;
              Janus.log("Got re-INVITE ", offerless ? "without" : "with", " SDP offer, context:", local_context);
              local_context.preferSendVideo = local_context.doVideo;
              AdjustMediaMode(local_context, offerless ? null : e.jsep.sdp, true);
              Janus.log("preferSendAudio=", local_context.preferSendAudio, "preferRecvAudio=", local_context.preferRecvAudio);
              Janus.log("preferSendVideo=", local_context.preferSendVideo, "preferRecvVideo=", local_context.preferRecvVideo);

              if (offerless) {
                Janus.log("Offering with: ", "canSendAudio=", local_context.canSendAudio, "canRecvAudio=", local_context.canRecvAudio);
                Janus.log("Offering with: ", "canSendVideo=", local_context.canSendVideo, "canRecvVideo=", local_context.canRecvVideo);
              } else {
                Janus.log("Answering with: ", "canSendAudio=", local_context.canSendAudio, "canRecvAudio=", local_context.canRecvAudio);
                Janus.log("Answering with: ", "canSendVideo=", local_context.canSendVideo, "canRecvVideo=", local_context.canRecvVideo);
              }

              FixInactiveSdpAttr(e.jsep, local_context.canSendAudio, local_context.canRecvAudio, local_context.canSendVideo, local_context.canRecvVideo);
              var sipcallAction = offerless ? local_context.pluginHandle.createOffer : local_context.pluginHandle.createAnswer;
              sipcallAction({
                jsep: e.jsep,
                media: {
                  audioSend: local_context.canSendAudio,
                  audioRecv: local_context.canRecvAudio,
                  videoSend: local_context.canSendVideo,
                  videoRecv: local_context.canRecvVideo,
                  video: local_context.canSendVideo ? local_context.videoSource : undefined,
                  captureDesktopAudio: local_context.canSendVideo && local_context.videoSource === 'screen',
                  screenshareFrameRate: local_context.canSendVideo && context.videoSource === 'screen' ? context.srFrameRate : undefined,
                  screenshareWidth: context.videoSource === 'screen' ? context.srScreenWidth : undefined,
                  screenshareHeight: context.videoSource === 'screen' ? context.srScreenHeight : undefined
                },
                customizeSdp: function customizeSdp(jsep) {
                  FixInactiveSdpAttr(jsep, local_context.canSendAudio, local_context.canRecvAudio, local_context.canSendVideo, local_context.canRecvVideo);

                  if (local_context.canSendVideo && local_context.videoSource === 'screen') {
                    EnableStereoAudio(jsep);
                  }
                },
                success: function success(jsep) {
                  try {
                    var body = {
                      request: "update"
                    };
                    context.pluginHandle.send({
                      "message": body,
                      "jsep": jsep
                    });

                    if (!offerless) {
                      callback({
                        type: 'UPDATINGCALL_SUCCEEDED',
                        preferSendAudio: local_context.preferSendAudio,
                        preferRecvAudio: local_context.preferRecvAudio,
                        preferSendVideo: local_context.preferSendVideo,
                        preferRecvVideo: local_context.preferRecvVideo,
                        canSendAudio: local_context.canSendAudio,
                        canRecvAudio: local_context.canRecvAudio,
                        canSendVideo: local_context.canSendVideo,
                        canRecvVideo: local_context.canRecvVideo,
                        enabledVideoSource: local_context.canSendVideo ? local_context.videoSourceProcessed : undefined
                      });
                    }
                  } catch (error) {
                    Janus.error("Failed to update with answer, error", error);
                    callback({
                      type: 'UPDATINGCALL_FAILED',
                      message: error
                    });
                  }
                },
                error: function error(message) {
                  Janus.error("WebRTC error:", message);
                  callback({
                    type: 'UPDATINGCALL_FAILED',
                    message: message
                  });
                }
              });
            } catch (error) {
              callback({
                type: 'UPDATINGCALL_FAILED',
                message: error.message
              });
            }
          } else if (e.type === 'ACCEPTED') {
            try {
              if (!e.jsep || !e.jsep.sdp) {
                Janus.log("Got re-INVITE answer without SDP answer");
                callback({
                  type: 'REMOTE_SDP_HANDLING_FAILED',
                  message: 'No SDP found'
                });
                return;
              }

              Janus.log("Got hold/resume answer");
              Janus.log("preferSendAudio=", local_context.preferSendAudio, "preferRecvAudio=", local_context.preferRecvAudio);
              Janus.log("preferSendVideo=", local_context.preferSendVideo, "preferRecvVideo=", local_context.preferRecvVideo);
              AdjustMediaMode(local_context, e.jsep.sdp);
              Janus.log("Accepting with: ", "canSendAudio=", local_context.canSendAudio, "canRecvAudio=", local_context.canRecvAudio);
              Janus.log("Accepting with: ", "canSendVideo=", local_context.canSendVideo, "canRecvVideo=", local_context.canRecvVideo);
              FixInactiveSdpAttr(e.jsep, local_context.canSendAudio, local_context.canRecvAudio, local_context.canSendVideo, local_context.canRecvVideo);
              context.pluginHandle.handleRemoteJsep({
                jsep: e.jsep,
                success: function success() {
                  callback({
                    type: 'REMOTE_SDP_HANDLING_SUCCEEDED',
                    canSendAudio: local_context.canSendAudio,
                    canRecvAudio: local_context.canRecvAudio,
                    canSendVideo: local_context.canSendVideo,
                    canRecvVideo: local_context.canRecvVideo,
                    enabledVideoSource: local_context.canSendVideo ? local_context.videoSourceProcessed : undefined
                  });
                },
                error: function error(message) {
                  callback({
                    type: 'REMOTE_SDP_HANDLING_FAILED',
                    message: message
                  });
                }
              });
            } catch (error) {
              callback({
                type: 'REMOTE_SDP_HANDLING_FAILED',
                message: error.message
              });
            }
          }
        }); // handle remote SDP

        if (event.jsep && event.jsep.sdp) {
          try {
            var local_context = {
              preferSendAudio: context.preferSendAudio,
              preferRecvAudio: context.preferRecvAudio,
              preferSendVideo: context.doVideo,
              preferRecvVideo: context.preferRecvVideo,
              canSendAudio: context.canSendAudio,
              canRecvAudio: context.canRecvAudio,
              canSendVideo: context.canSendVideo,
              canRecvVideo: context.canRecvVideo,
              videoSourceProcessed: context.videoSourceProcessed
            };
            Janus.log("preferSendAudio=", local_context.preferSendAudio, "preferRecvAudio=", local_context.preferRecvAudio);
            Janus.log("preferSendVideo=", local_context.preferSendVideo, "preferRecvVideo=", local_context.preferRecvVideo);
            AdjustMediaMode(local_context, event.jsep.sdp);
            Janus.log("Accepting with: ", "canSendAudio=", local_context.canSendAudio, "canRecvAudio=", local_context.canRecvAudio);
            Janus.log("Accepting with: ", "canSendVideo=", local_context.canSendVideo, "canRecvVideo=", local_context.canRecvVideo);
            FixInactiveSdpAttr(event.jsep, local_context.canSendAudio, local_context.canRecvAudio, local_context.canSendVideo, local_context.canRecvVideo);
            context.pluginHandle.handleRemoteJsep({
              jsep: event.jsep,
              success: function success() {
                callback({
                  type: 'REMOTE_SDP_HANDLING_SUCCEEDED',
                  canSendAudio: local_context.canSendAudio,
                  canRecvAudio: local_context.canRecvAudio,
                  canSendVideo: local_context.canSendVideo,
                  canRecvVideo: local_context.canRecvVideo,
                  enabledVideoSource: local_context.canSendVideo ? local_context.videoSourceProcessed : undefined
                });
              },
              error: function error(message) {
                callback({
                  type: 'REMOTE_SDP_HANDLING_FAILED',
                  message: message
                });
              }
            });
          } catch (error) {
            callback({
              type: 'REMOTE_SDP_HANDLING_FAILED',
              message: error.message
            });
          }
        }
      };
    },
    handleIncomingCallService: function handleIncomingCallService(context, event) {
      return function (callback, onReceive) {
        onReceive(function (e) {
          if (e.type === "DO_ACCEPT") {
            // accepting call
            try {
              var _defaultMediaConstrai37, _defaultMediaConstrai38, _defaultMediaConstrai39, _defaultMediaConstrai40, _defaultMediaConstrai41, _defaultMediaConstrai42, _defaultMediaConstrai43, _defaultMediaConstrai44, _defaultMediaConstrai45;

              var jsep = context.incomingCallJsep;
              var offerless = !jsep || !jsep.sdp;
              context.preferSendAudio = true;
              context.preferRecvAudio = true;
              context.preferSendVideo = context.doVideo;
              context.preferRecvVideo = jsep && jsep.sdp && jsep.sdp.includes("m=video") || context.doVideo;
              context.canSendAudio = context.preferSendAudio;
              context.canRecvAudio = context.preferRecvAudio;
              context.canSendVideo = context.preferSendVideo;
              context.canRecvVideo = context.preferRecvVideo;
              AdjustMediaMode(context, offerless ? null : jsep.sdp);

              if (offerless) {
                Janus.log("Offering with: ", "preferSendAudio=", context.preferSendAudio, "preferRecvAudio=", context.preferRecvAudio);
                Janus.log("Offering with: ", "preferSendVideo=", context.preferSendVideo, "preferRecvVideo=", context.preferRecvVideo);
              } else {
                Janus.log("Answering with: ", "canSendAudio=", context.canSendAudio, "preferRecvAudio=", context.preferRecvAudio);
                Janus.log("Answering with: ", "canSendVideo=", context.canSendVideo, "canRecvVideo=", context.canRecvVideo);

                if (context.doVideo && !context.canSendVideo) {
                  Janus.log("Scheduling reINVITE when connected to enable send video");
                  callback('DO_POST_ENABLE_VIDEO');
                }
              }

              var sipcallAction = offerless ? context.pluginHandle.createOffer : context.pluginHandle.createAnswer;
              sipcallAction({
                jsep: jsep,
                media: {
                  audioSend: context.canSendAudio,
                  audioRecv: context.canRecvAudio,
                  videoSend: context.canSendVideo,
                  videoRecv: context.canRecvVideo,
                  audio: {
                    autoGainControl: (_defaultMediaConstrai37 = (_defaultMediaConstrai38 = defaultMediaConstraints) == null ? void 0 : _defaultMediaConstrai38.autoGainControl) != null ? _defaultMediaConstrai37 : false,
                    echoCancellation: (_defaultMediaConstrai39 = (_defaultMediaConstrai40 = defaultMediaConstraints) == null ? void 0 : _defaultMediaConstrai40.echoCancellation) != null ? _defaultMediaConstrai39 : false,
                    noiseSuppression: (_defaultMediaConstrai41 = (_defaultMediaConstrai42 = defaultMediaConstraints) == null ? void 0 : _defaultMediaConstrai42.noiseSuppression) != null ? _defaultMediaConstrai41 : false,
                    channelCount: (_defaultMediaConstrai43 = defaultMediaConstraints) == null ? void 0 : _defaultMediaConstrai43.channelCount,
                    sampleRate: (_defaultMediaConstrai44 = defaultMediaConstraints) == null ? void 0 : _defaultMediaConstrai44.sampleRate,
                    sampleSize: (_defaultMediaConstrai45 = defaultMediaConstraints) == null ? void 0 : _defaultMediaConstrai45.sampleSize
                  },
                  video: context.canSendVideo ? context.videoSourceProcessed : undefined,
                  captureDesktopAudio: context.canSendVideo && context.videoSource === 'screen',
                  screenshareFrameRate: context.canSendVideo && context.videoSource === 'screen' ? context.srFrameRate : undefined,
                  screenshareWidth: context.videoSource === 'screen' ? context.srScreenWidth : undefined,
                  screenshareHeight: context.videoSource === 'screen' ? context.srScreenHeight : undefined
                },
                customizeSdp: function customizeSdp(jsep) {
                  if (context.canSendVideo && context.videoSource === 'screen') {
                    EnableStereoAudio(jsep);
                  }
                },
                success: function success(jsep) {
                  try {
                    Janus.debug(jsep);
                    var body = {
                      request: "accept",
                      autoaccept_reinvites: false
                    };

                    if (context.instanceId !== 0) {
                      body["headers"] = {
                        "Janus-Helper-Id": "C" + context.instanceId
                      };
                    }

                    context.pluginHandle.send({
                      "message": body,
                      "jsep": jsep
                    });
                    callback('DO_ACCEPT_SUCCEEDED');
                  } catch (error) {
                    callback({
                      type: 'DO_ACCEPT_FAILED',
                      message: error.message
                    });
                  }
                },
                error: function error(message) {
                  // accept failed
                  try {
                    Janus.error("WebRTC error:", message);
                    var body = {
                      "request": "decline",
                      "code": 480
                    };
                    context.pluginHandle.send({
                      "message": body
                    });
                    callback({
                      type: 'DO_ACCEPT_FAILED',
                      message: message
                    });
                  } catch (err) {
                    callback({
                      type: 'DO_ACCEPT_FAILED',
                      message: message + "," + err.message
                    });
                  }
                }
              });
            } catch (error) {
              callback({
                type: 'DO_ACCEPT_FAILED',
                message: error.message
              });
            }
          } else if (e.type === "DO_DECLINE") {
            // declining call
            try {
              var body = {
                "request": "decline"
              };

              if (e.code !== undefined && !isNaN(e.code)) {
                body["code"] = e.code;
              }

              context.pluginHandle.send({
                "message": body
              });
              callback('DO_DECLINE_SUCCEEDED');
            } catch (error) {
              callback({
                type: 'DO_DECLINE_FAILED',
                message: error.message
              });
            }
          }
        });
      };
    },
    executeXferService: function executeXferService(context, event) {
      return function (callback, onReceive) {
        onReceive(function (e) {
          if (e.type === 'DO_BLIND_XFER') {
            try {
              var body = {
                "request": "transfer",
                "uri": e.refer_to
              };
              context.pluginHandle.send({
                "message": body
              });
              context.isLastXferBlind = true;
              context.isLastXferSuper = false;
              callback('DO_BLIND_XFER_SUCCEEDED');
            } catch (error) {
              callback({
                type: 'DO_BLIND_XFER_FAILED',
                message: error.message
              });
            }
          } else if (e.type === 'DO_XFER') {
            try {
              var _body = {
                "request": "transfer",
                "uri": e.refer_to,
                "replace": e.replaces_call_id
              };
              context.pluginHandle.send({
                "message": _body
              });
              context.isLastXferBlind = false;
              context.isLastXferSuper = true;
              callback('DO_XFER_SUCCEEDED');
            } catch (error) {
              callback({
                type: 'DO_XFER_FAILED',
                message: error.message
              });
            }
          }
        });
      };
    }
  }
});

function FixInactiveSdpAttr(jsep, preferSendAudio, preferRecvAudio, preferSendVideo, preferRecvVideo) {
  // the order of m-lines must be preserved or it will be rejected by PC (if order of m-lines
  // doesn't match the order of m-lines in the offer)
  if (!jsep || !jsep.sdp) return;

  if (!preferSendAudio && !preferRecvAudio || !preferSendVideo && !preferRecvVideo) {
    // find m=audio
    var maudio_index = jsep.sdp.indexOf("m=audio ");
    var mvideo_index = jsep.sdp.indexOf("m=video ");
    var maudio = '';
    var mvideo = '';
    var mindex = -1;

    if (maudio_index > -1) {
      if (mvideo_index == -1) {
        mindex = maudio_index;
        maudio = jsep.sdp.substring(maudio_index);
      } else if (maudio_index < mvideo_index) {
        mindex = maudio_index;
        maudio = jsep.sdp.substring(maudio_index, mvideo_index);
        mvideo = jsep.sdp.substring(mvideo_index);
      } else {
        mindex = mvideo_index;
        mvideo = jsep.sdp.substring(mvideo_index, maudio_index);
        maudio = jsep.sdp.substring(maudio_index);
      }
    } else if (mvideo_index > -1) {
      mindex = mvideo_index;
      mvideo = jsep.sdp.substring(mvideo_index);
    }

    var newSdp;

    if (mindex > -1) {
      newSdp = jsep.sdp.substring(0, mindex);
    }

    if (maudio && !preferSendAudio && !preferRecvAudio) {
      maudio = maudio.replace("a=sendonly\r\n", "a=inactive\r\n");
      maudio = maudio.replace("a=recvonly\r\n", "a=inactive\r\n");
      maudio = maudio.replace("a=sendrecv\r\n", "a=inactive\r\n");
      if (maudio.indexOf("a=inactive\r\n") < -1) maudio += "a=inactive\r\n";
    }

    if (mvideo && !preferSendVideo && !preferRecvVideo) {
      mvideo = mvideo.replace("a=sendonly\r\n", "a=inactive\r\n");
      mvideo = mvideo.replace("a=recvonly\r\n", "a=inactive\r\n");
      mvideo = mvideo.replace("a=sendrecv\r\n", "a=inactive\r\n");
      if (mvideo.indexOf("a=inactive\r\n") < -1) mvideo += "a=inactive\r\n";
    }

    if (maudio_index < mvideo_index) {
      newSdp += maudio;
      newSdp += mvideo;
    } else {
      newSdp += mvideo;
      newSdp += maudio;
    }

    jsep.sdp = newSdp;
  }
}

function calculateUserName(context, event) {
  if (context.pbxPlatform === 'cucm') {
    if (context.incomingCallUserName) return context.incomingCallUserName;

    if (event.result["headers"] && event.result["headers"]["Remote-Party-Id"] && event.result["headers"]["Remote-Party-Id"].includes("sip:")) {
      var header = event.result["headers"]["Remote-Party-Id"];
      var callerId = header.indexOf("@") < 0 ? "anonymous" : header.substring(header.indexOf("sip:") + 4, header.indexOf("@"));
      if (callerId) return callerId;
    }
  }

  return event.result["username"] !== undefined ? event.result["username"] : context.remote_uri;
}

function calculateDisplayName(context, event) {
  if (context.pbxPlatform === 'cucm') {
    if (context.incomingCallDisplayName) return context.incomingCallDisplayName;

    if (event.result["headers"] && event.result["headers"]["Remote-Party-Id"]) {
      var trimmed = event.result["headers"]["Remote-Party-Id"];

      if (trimmed.indexOf("\"") === 0 && trimmed.indexOf("\"", 1) > 1) {
        return trimmed.substring(1, trimmed.indexOf("\"", 1));
      }
    }
  }

  return event.result["displayname"] !== undefined ? event.result["displayname"] : undefined;
}

function setDefaultAudioConstraints(constraints) {
  defaultMediaConstraints = constraints;
}

function AdjustMediaMode(context, sdp) {
  var attrContext = {
    answerSend: false,
    answerRecv: false
  };
  DetermineAnswerMediaAttr("audio", attrContext, sdp);
  context.canSendAudio = context.preferSendAudio && attrContext.answerSend;
  context.canRecvAudio = context.preferRecvAudio && attrContext.answerRecv;
  attrContext.answerSend = false;
  attrContext.answerRecv = false;
  DetermineAnswerMediaAttr("video", attrContext, sdp);
  context.canSendVideo = context.preferSendVideo && attrContext.answerSend;
  context.canRecvVideo = attrContext.answerRecv;
}

function DetermineAnswerMediaAttr(mediaType, attrContext, sdp) {
  if (!sdp) {
    attrContext.answerSend = false;
    attrContext.answerRecv = false;
    return;
  }

  var mediaLine = "m=" + mediaType + " ";
  var mediaIndex = sdp.indexOf(mediaLine);
  var answerSend = mediaIndex > -1;
  var answerRecv = mediaIndex > -1;
  var fromIndex = mediaIndex;
  var mCount = 0;

  while (fromIndex > -1 && (mediaIndex = sdp.indexOf(mediaLine, fromIndex)) > -1) {
    // prefer active md's over inactives
    if (++mCount > 1 && (answerSend || answerRecv)) break;
    answerSend = true;
    answerRecv = true; // determine the end pos of the current md

    var end_of_md = sdp.indexOf("\r\nm=", mediaIndex + 1); // determine attribute index within the current md, there must be only one

    var sendOnlyModeIndex = -1;
    var recvOnlyModeIndex = -1;
    var inactiveModeIndex = -1;
    var sendrecvModeIndex = sdp.indexOf("a=sendrecv\r\n", fromIndex);
    if (sendrecvModeIndex < mediaIndex || end_of_md > -1 && sendrecvModeIndex > end_of_md) sendrecvModeIndex = -1;

    if (sendrecvModeIndex < 0) {
      sendOnlyModeIndex = sdp.indexOf("a=sendonly\r\n", fromIndex);
      if (sendOnlyModeIndex < mediaIndex || end_of_md > -1 && sendOnlyModeIndex > end_of_md) sendOnlyModeIndex = -1;

      if (sendOnlyModeIndex < 0) {
        recvOnlyModeIndex = sdp.indexOf("a=recvonly\r\n", fromIndex);
        if (recvOnlyModeIndex < mediaIndex || end_of_md > -1 && recvOnlyModeIndex > end_of_md) recvOnlyModeIndex = -1;

        if (recvOnlyModeIndex < 0) {
          inactiveModeIndex = sdp.indexOf("a=inactive\r\n", fromIndex);
          if (inactiveModeIndex < mediaIndex || end_of_md > -1 && inactiveModeIndex > end_of_md) inactiveModeIndex = -1;
        }
      }
    }

    if (sendOnlyModeIndex > -1) {
      answerSend = false;
      answerRecv = true;
    } else if (recvOnlyModeIndex > -1) {
      answerSend = true;
      answerRecv = false;
    } else if (inactiveModeIndex > -1) {
      answerSend = false;
      answerRecv = false;
    } // advance fromIndex for the next iteration


    fromIndex = end_of_md;
  }

  attrContext.answerSend = answerSend;
  attrContext.answerRecv = answerRecv;
}

function EnableStereoAudio(jsep) {
  // add 'sprop-stereo=1' to make sure desktop audio and microphone are seperated in channels
  if (!jsep || !jsep.sdp) return;

  if (jsep.sdp.includes('useinbandfec=')) {
    jsep.sdp = jsep.sdp.replace('useinbandfec=', 'sprop-stereo=1;useinbandfec=');
  }
}

function GetErrorMessage(event) {
  if (event.message instanceof Error) return event.message.message;else return event.message;
}

var _DETACH;
var escalate$1 = actions$1.escalate; // top

var sipPluginSession = /*#__PURE__*/Machine({
  id: 'ipfxSipPluginSession',
  initial: 'unknown',
  context: {
    sessionService: null,
    janusSession: null,
    pluginHandle: null,
    opaqueId: null,
    instanceId: null,
    queuedDetach: false,
    masterId: null,
    registerSipserver: null,
    registerUsername: null,
    registerDisplayname: null,
    registerSecret: null,
    registerHeaders: {},
    isCallAnswered: false,
    pushToken: null,
    alertPushToken: null,
    pushPlatformName: null,
    pbxPlatform: null,
    monitorTarget: null,
    disabledPlugin: false
  },
  states: {
    inactive: {
      type: 'final'
    },
    unknown: {
      always: [{
        target: 'inactive',
        cond: function cond(context) {
          return context.disabledPlugin;
        }
      }, {
        target: 'attaching',
        cond: function cond(context) {
          return context.instanceId === 0;
        }
      }, 'waitingForMasterId'],
      on: {
        DETACH: 'inactive'
      }
    },
    waitingForMasterId: {
      on: {
        ATTACH: {
          target: 'attaching',
          actions: /*#__PURE__*/assign({
            masterId: function masterId(context, event) {
              return event.masterId;
            },
            registerUsername: function registerUsername(context, event) {
              return event.registerUsername;
            }
          })
        },
        DETACH: 'inactive',
        CLEANUP: undefined,
        DETACHED: 'inactive'
      }
    },
    attaching: {
      invoke: {
        id: 'pluginAttach',
        src: 'pluginAttachService'
      },
      on: {
        ATTACHED: [{
          cond: function cond(context, event) {
            return context.queuedDetach;
          },
          actions: 'detachAction'
        }, {
          target: 'attached',
          actions: /*#__PURE__*/send$1('DO_REGISTER'),
          cond: function cond(context) {
            return context.instanceId !== 0;
          }
        }, 'attached'],
        SERVICE_ERROR: {
          target: 'inactive',
          actions: /*#__PURE__*/escalate$1(function (context, event) {
            return {
              reason: 'PLUGIN_ATTACH_FAILED',
              message: event.message
            };
          })
        },
        DETACH: {
          actions: function actions(context) {
            return context.queuedDetach = true;
          }
        },
        CLEANUP: undefined,
        DETACHED: 'inactive'
      }
    },
    attached: /*#__PURE__*/_extends({
      invoke: {
        id: 'callControl',
        src: callStateMachine,
        data: {
          pluginHandle: function pluginHandle(context, event) {
            return event.handle;
          },
          opaqueId: function opaqueId(context, event) {
            return context.opaqueId;
          },
          instanceId: function instanceId(context, event) {
            return context.instanceId;
          },
          pbxPlatform: function pbxPlatform(context, event) {
            return context.pbxPlatform;
          },
          doVideo: function doVideo() {
            return false;
          },
          videoSource: function videoSource() {
            return undefined;
          }
        },
        onError: {
          actions: [function (context, event) {
            Janus.error("callControl.OnError:, ", event.data.message);
          }, /*#__PURE__*/sendParent$1(function (context, event) {
            return {
              type: 'CALL_STATE_ERROR',
              instanceId: context.instanceId,
              error: event.data.message
            };
          })]
        },
        onDone: 'inactive'
      },
      entry: ['onPluginStartedAction', /*#__PURE__*/send$1('DO_AUTOREGISTER')],
      on: {
        // invoke registration service
        DETACH: (_DETACH = {
          actions: 'detachAction'
        }, _DETACH["actions"] = /*#__PURE__*/send$1(function (context, event) {
          return {
            type: 'JANUS_SESSION_ENDED'
          };
        }, {
          to: 'callControl'
        }), _DETACH),
        DETACHED: {
          actions: /*#__PURE__*/send$1(function (context, event) {
            return {
              type: 'JANUS_SESSION_ENDED'
            };
          }, {
            to: 'callControl'
          })
        },
        SERVICE_ERROR: {
          target: 'inactive',
          actions: /*#__PURE__*/escalate$1(function (context, event) {
            return {
              reason: 'PLUGIN_ATTACH_FAILED',
              message: event.message
            };
          })
        },
        // call related control events
        SIP_ERROR: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        },
        INVITE_ERROR: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        },
        DO_ENABLE_VIDEO: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        },
        DO_GET_STATS: {
          actions: function actions(context, event) {
            var _context$pluginHandle, _context$pluginHandle2;

            var pc = (_context$pluginHandle = context.pluginHandle) == null ? void 0 : (_context$pluginHandle2 = _context$pluginHandle.webrtcStuff) == null ? void 0 : _context$pluginHandle2.pc;

            if (pc) {
              OnStatsUpdate(pc, context);
            }
          }
        },
        DO_MAKE_CALL: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        },
        DO_HANGUP: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        },
        DO_HOLD: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        },
        DO_ICE_RESTART: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        },
        DO_RESUME: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        },
        DO_ACCEPT: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        },
        DO_DECLINE: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        },
        DO_SEND_DTMF: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        },
        DO_REJECT_REFER: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        },
        DO_BLIND_XFER: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        },
        DO_XFER: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        },
        DO_START_SR: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        },
        DO_STOP_SR: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        },
        // call states events from callControl
        CALL_STATE_IDLE: {
          actions: [/*#__PURE__*/sendParent$1(function (context, event) {
            return event;
          }), /*#__PURE__*/assign({
            isCallAnswered: function isCallAnswered() {
              return false;
            }
          })]
        },
        CALL_STATE_DEEP_IDLE: {
          actions: [/*#__PURE__*/sendParent$1(function (context, event) {
            return event;
          }), /*#__PURE__*/assign({
            isCallAnswered: function isCallAnswered() {
              return false;
            }
          })]
        },
        CALL_STATE_TRYING_OUT: {
          actions: [/*#__PURE__*/sendParent$1(function (context, event) {
            return event;
          }), /*#__PURE__*/assign({
            isCallAnswered: function isCallAnswered() {
              return false;
            }
          })]
        },
        CALL_STATE_CALLING_OUT: {
          actions: [/*#__PURE__*/sendParent$1(function (context, event) {
            return event;
          }), /*#__PURE__*/assign({
            isCallAnswered: function isCallAnswered() {
              return false;
            }
          })]
        },
        CALL_STATE_RINGING_OUT: {
          actions: [/*#__PURE__*/sendParent$1(function (context, event) {
            return event;
          }), /*#__PURE__*/assign({
            isCallAnswered: function isCallAnswered() {
              return false;
            }
          })]
        },
        CALL_STATE_PROCEEDING_OUT: {
          actions: [/*#__PURE__*/sendParent$1(function (context, event) {
            return event;
          }), /*#__PURE__*/assign({
            isCallAnswered: function isCallAnswered() {
              return false;
            }
          })]
        },
        CALL_STATE_PROGRESS_OUT: {
          actions: [/*#__PURE__*/sendParent$1(function (context, event) {
            return event;
          }), /*#__PURE__*/assign({
            isCallAnswered: function isCallAnswered() {
              return false;
            }
          })]
        },
        CALL_STATE_CONNECTING: {
          actions: [/*#__PURE__*/sendParent$1(function (context, event) {
            return event;
          }), /*#__PURE__*/assign({
            isCallAnswered: function isCallAnswered() {
              return false;
            }
          })]
        },
        CALL_STATE_CONNECTED: {
          actions: [/*#__PURE__*/sendParent$1(function (context, event) {
            return event;
          }), /*#__PURE__*/assign({
            isCallAnswered: function isCallAnswered() {
              return true;
            }
          })]
        },
        CALL_STATE_HANGINGUP: {
          actions: [/*#__PURE__*/sendParent$1(function (context, event) {
            return event;
          }), /*#__PURE__*/assign({
            isCallAnswered: function isCallAnswered() {
              return false;
            }
          })]
        },
        CALL_STATE_ONHOLD: {
          actions: [/*#__PURE__*/sendParent$1(function (context, event) {
            return event;
          }), /*#__PURE__*/assign({
            isCallAnswered: function isCallAnswered() {
              return true;
            }
          })]
        },
        CALL_STATE_INCOMING_CALL: {
          actions: [/*#__PURE__*/sendParent$1(function (context, event) {
            return event;
          }), /*#__PURE__*/assign({
            isCallAnswered: function isCallAnswered() {
              return false;
            }
          })]
        },
        CALL_STATE_DO_XFERRING: {
          actions: [/*#__PURE__*/sendParent$1(function (context, event) {
            return event;
          }), /*#__PURE__*/assign({
            isCallAnswered: function isCallAnswered() {
              return true;
            }
          })]
        },
        CALL_STATE_ERROR: {
          actions: /*#__PURE__*/sendParent$1(function (context, event) {
            return event;
          })
        },
        HANDLE_REFER: {
          actions: /*#__PURE__*/sendParent$1(function (context, event) {
            return event;
          })
        },
        DO_BLIND_XFER_FAILED: {
          actions: /*#__PURE__*/sendParent$1(function (context, event) {
            return event;
          })
        },
        DO_BLIND_XFER_SUCCEEDED: {
          actions: /*#__PURE__*/sendParent$1(function (context, event) {
            return event;
          })
        },
        DO_XFER_FAILED: {
          actions: /*#__PURE__*/sendParent$1(function (context, event) {
            return event;
          })
        },
        DO_XFER_SUCCEEDED: {
          actions: /*#__PURE__*/sendParent$1(function (context, event) {
            return event;
          })
        },
        // media
        MEDIA_ON_LOCAL_STREAM: {
          actions: /*#__PURE__*/sendParent$1(function (context, event) {
            return event;
          })
        },
        MEDIA_ON_REMOTE_STREAM: {
          actions: /*#__PURE__*/sendParent$1(function (context, event) {
            return event;
          })
        },
        SLOWLINK: {
          actions: /*#__PURE__*/sendParent$1(function (context, event) {
            return event;
          })
        },
        ON_STATS_UPDATED: {
          actions: /*#__PURE__*/sendParent$1(function (context, event) {
            return event;
          })
        },
        // SIP plugin call events
        INCOMINGCALL: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        },
        DECLINING: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        },
        DECLINED: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        },
        ACCEPTING: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        },
        CALLING: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        },
        PROCEEDING: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        },
        RINGING: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        },
        PROGRESS: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        },
        ACCEPTED: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        },
        UPDATING: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        },
        UPDATED: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        },
        TRANSFERRING: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        },
        TRANSFER: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        },
        HOLDING: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        },
        RESUMING: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        },
        DTMFSENT: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        },
        UPDATINGCALL: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        },
        HANGINGUP: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        },
        HANGUP: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        },
        CLEANUP: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        },
        NOTIFY: {
          actions: /*#__PURE__*/forwardTo$1('callControl'),
          cond: function cond(context, event) {
            return event.result["notify"] === "refer";
          }
        },
        REQUEST_TO_RECONNECT: {
          actions: /*#__PURE__*/sendParent$1(function (context, event) {
            return event;
          })
        },
        JANUS_SESSION_ENDED: {
          actions: /*#__PURE__*/forwardTo$1('callControl')
        }
      }
    }, sipRegisterStates),
    detached: {
      always: 'inactive'
    }
  } // states

}, {
  services: {
    pluginAttachService: function pluginAttachService(context, event) {
      return function (callback, onReceive) {
        try {
          context.pluginHandle = null;
          context.queuedDetach = false;
          context.janusSession.attach({
            plugin: "janus.plugin.sip",
            opaqueId: context.opaqueId,
            error: function error(_error) {
              return callback({
                type: 'SERVICE_ERROR',
                message: _error.message
              });
            },
            success: function success(pluginHandle) {
              return callback({
                type: 'ATTACHED',
                handle: pluginHandle
              });
            },
            consentDialog: function consentDialog() {},
            onmessage: function onmessage(msg, jsep) {
              return OnMessage(msg, jsep, context);
            },
            onlocalstream: function onlocalstream(stream) {
              return OnLocalStream(stream, context);
            },
            onremotestream: function onremotestream(stream) {
              return OnRemoteStream(stream, context);
            },
            mediaState: function mediaState(medium, on) {
              Janus.log("Janus " + (on ? "started" : "stopped") + " receiving our " + medium);
            },
            slowLink: function slowLink(uplink, lost) {
              return OnSlowLink(uplink, "audio", lost, context);
            },
            inLinkStatus: function inLinkStatus(status, media) {
              return OnInLinkStatus(status, media, context);
            },
            oncleanup: function oncleanup(error) {
              return OnPluginCleanup(error, context);
            },
            ondetached: function ondetached() {
              return OnPluginDetached(undefined, context);
            },
            onreconnect: function onreconnect() {
              return OnReconnectRequested(context);
            }
          });
        } catch (error) {
          callback({
            type: 'SERVICE_ERROR',
            message: error.message
          });
        }
      };
    }
  },
  actions: {
    detachAction: function detachAction(context, event) {
      if (context.pluginHandle !== undefined) {
        context.pluginHandle.detach();
      }
    },
    onPluginStartedAction: function onPluginStartedAction(context, event) {
      var this_plugin;

      for (var _iterator = _createForOfIteratorHelperLoose(context.sessionService.children.values()), _step; !(_step = _iterator()).done;) {
        var value = _step.value;

        if (value.state.context.instanceId == context.instanceId) {
          this_plugin = value;
          break;
        }
      }

      if (this_plugin.state.children.callControl !== undefined && this_plugin.state.children.callControl.listeners.size < 1) {
        this_plugin.state.children.callControl.listeners.add(function (state) {
          if (state.history === undefined) Janus.log("Machine callControl(", context.instanceId, ") state change: ", state.history, "-->", state.value, ", event: ", state.event);else Janus.log("Machine callControl(", context.instanceId, ") state change: ", state.history.value, "-->", state.value, ", event: ", state.event);
        });
      }

      context.pluginHandle = event.handle;
    }
  }
}); //function ForwardEventToServiceInstance(context, event) {
//	for (let value of sessionService.children.values()) {
//		if (value.machine.config.id === "ipfxSipPluginSession" && value.machine.context.opaqueId === context.opaqueId) {
//            value.send(event);
//        }
//	}
//}

function ForwardEventToServiceInstance(context, event, serviceId, service) {
  if (service.machine === undefined) {
    return false;
  }

  if (service.machine.config.id === serviceId && service.machine.context.instanceId == context.instanceId) {
    try {
      service.send(event);
    } catch (err) {
      Janus.warn('Failed to handle event', event, ", reason:", err.message);
    }

    return true;
  }

  for (var _iterator2 = _createForOfIteratorHelperLoose(service.children.values()), _step2; !(_step2 = _iterator2()).done;) {
    var value = _step2.value;

    if (ForwardEventToServiceInstance(context, event, serviceId, value)) {
      return true;
    }
  }

  return false;
}

function OnRemoteStream(stream, context) {
  try {
    ForwardEventToServiceInstance(context, {
      type: 'MEDIA_ON_REMOTE_STREAM',
      instanceId: context.instanceId,
      stream: stream
    }, "ipfxSipPluginSession", context.sessionService);
  } catch (err) {
    Janus.error("OnRemoteStream: ", err);
    ForwardEventToServiceInstance(context, {
      type: 'SERVICE_ERROR',
      message: err.message
    }, "ipfxSipPluginSession", context.sessionService);
  }
}

function OnLocalStream(stream, context) {
  try {
    ForwardEventToServiceInstance(context, {
      type: 'MEDIA_ON_LOCAL_STREAM',
      instanceId: context.instanceId,
      stream: stream
    }, "ipfxSipPluginSession", context.sessionService);
  } catch (err) {
    Janus.error("OnLocalStream: ", err);
    ForwardEventToServiceInstance(context, {
      type: 'SERVICE_ERROR',
      message: err.message
    }, "ipfxSipPluginSession", context.sessionService);
  }
}

function OnMessage(msg, jsep, context) {
  try {
    Janus.debug(" ::: Got a message :::");
    Janus.debug(msg); // check for errors

    var error = msg["error"];

    if (error !== null && error !== undefined) {
      ForwardEventToServiceInstance(context, {
        type: 'SIP_ERROR',
        message: error,
        error_code: msg["error_code"]
      }, "ipfxSipPluginSession", context.sessionService);
      return;
    }

    var result = msg["result"];

    if (result !== null && result !== undefined && result["event"] !== undefined && result["event"] !== null) {
      var sip_event = result["event"];
      ForwardEventToServiceInstance(context, {
        type: sip_event.toUpperCase(),
        jsep: jsep,
        result: msg["result"],
        call_id: msg["call_id"]
      }, "ipfxSipPluginSession", context.sessionService);
    } else {
      Janus.warn("OnMessage: random message!");
    }
  } catch (err) {
    Janus.error("OnMessage: ", err);
    ForwardEventToServiceInstance(context, {
      type: 'SERVICE_ERROR',
      message: err.message
    }, "ipfxSipPluginSession", context.sessionService);
  }
}

function OnPluginCleanup(error, context) {
  ForwardEventToServiceInstance(context, {
    type: 'CLEANUP',
    message: error
  }, "ipfxSipPluginSession", context.sessionService);
}

function OnPluginDetached(error, context) {
  ForwardEventToServiceInstance(context, {
    type: 'DETACHED',
    message: error
  }, "ipfxSipPluginSession", context.sessionService);
}

function OnSlowLink(uplink, media, lost, context) {
  ForwardEventToServiceInstance(context, {
    type: 'SLOWLINK',
    instanceId: context.instanceId,
    uplink: uplink,
    media: media,
    lost: lost
  }, "ipfxSipPluginSession", context.sessionService);
}

function OnInLinkStatus(status, media, context) {
  if (!status && media == "audio") {
    ForwardEventToServiceInstance(context, {
      type: 'DO_ICE_RESTART',
      instanceId: context.instanceId
    }, "ipfxSipPluginSession", context.sessionService);
  }
}

function OnReconnectRequested(context) {
  if (context.instanceId === 0) {
    ForwardEventToServiceInstance(context, {
      type: 'REQUEST_TO_RECONNECT',
      instanceId: context.instanceId
    }, "ipfxSipPluginSession", context.sessionService);
  }
}

function OnStatsUpdate(_x, _x2) {
  return _OnStatsUpdate.apply(this, arguments);
}

function _OnStatsUpdate() {
  _OnStatsUpdate = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(pc, context) {
    var stats;
    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return pc.getStats(null);

          case 2:
            stats = _context.sent;
            ForwardEventToServiceInstance(context, {
              type: 'ON_STATS_UPDATED',
              instanceId: context.instanceId,
              stats: stats
            }, "ipfxSipPluginSession", context.sessionService);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _OnStatsUpdate.apply(this, arguments);
}

var endpointView;
var CallView = /*#__PURE__*/function () {
  function CallView() {
    this.uiCallbacks = {};
    this.instanceId = undefined;
    this.referInstanceId = undefined;
    this.sipserver = undefined;
    this.username = undefined;
    this.localStream = undefined;
    this.remoteStream = undefined;
    this.pbxPlatform = undefined;
    this.direction = undefined;
    this.state = 'idle';
    this.stateDesc = undefined;
    this.statusErrorCode = undefined;
    this.statusErrorDescription = undefined;
    this.peerUsername = undefined;
    this.peerDisplay = undefined;
    this.lastCallerUsername = undefined;
    this.lastCallerDisplay = undefined;
    this.lastCalleeUsername = undefined;
    this.lastCalleeDisplay = undefined;
    this.localStreamActive = false;
    this.remoteStreamActive = false;
    this.videoRequested = false;
    this.videoSource = undefined;
    this.lastHangupCode = undefined;
    this.lastHangupReason = undefined;
    this.lastHangupTone = undefined;
    this.lastDirection = undefined;
    this.canPlayBusyTone = false;
    this.canPlayReorderTone = false;
    this.canPlayNuTone = false;
    this.stats = undefined;
    this.isSlowAudioDownlink = false;
    this.isSlowAudioUplink = false;
    this.lineRegistered = false;
    this.callId = undefined;
    this.xferInstanceId = undefined;
    this.answerRequested = false;
    this.slowAudioUplinkTimer = undefined;
    this.slowAudioDownlinkTimer = undefined;
    this.canMakeCall = false;
    this.canHangup = false;
    this.canAnswer = false;
    this.canRingOut = false;
    this.featureHoldResume = true;
    this.canHold = false;
    this.canResume = false;
    this.canBlindXfer = false;
    this.canXfer = false;
    this.canSendDtmf = false;
    this.isMuted = false;
    this.hasLocalAudio = false;
    this.hasRemoteAudio = false;
    this.hasLocalVideo = false;
    this.hasRemoteVideo = false;
    this.enabledVideoSource = undefined;
  }

  var _proto = CallView.prototype;

  _proto.ToDialUri = function ToDialUri(userpart) {
    var dialUri = userpart;

    if (userpart.indexOf("sip:") < 0 && userpart.indexOf("@") < 0) {
      dialUri = this.sipserver.slice(0, 4) + userpart + "@" + this.sipserver.slice(4);
    }

    return dialUri;
  } //////////////////////////////////////////
  // public UI commands
  //////////////////////////////////////////
  ;

  _proto.doMakeCall = function doMakeCall(target) {
    var _this = this;

    this.clearError();

    if (!this.canMakeCall) {
      setTimeout(function () {
        return _this.onCallStatusError(CallStatusErrorCode.ERROR_MAKE_CALL, "Unable to make call: line busy");
      }, 0);
      return;
    }

    if (target.length === 0) {
      setTimeout(function () {
        return _this.onCallStatusError(CallStatusErrorCode.ERROR_MAKE_CALL, "Unable to make call: target empty");
      }, 0);
      return;
    }

    try {
      var targetUri = this.ToDialUri(target);

      _sessionService.send({
        type: 'FORWARD_TO_PLUGIN',
        event: {
          type: 'DO_MAKE_CALL',
          target: targetUri,
          referId: "",
          instanceId: this.instanceId
        }
      });
    } catch (err) {
      setTimeout(function () {
        return _this.onCallStatusError(CallStatusErrorCode.ERROR_MAKE_CALL, "Unable to make call: " + err.message);
      }, 0);
      return;
    }

    if (typeof this.uiCallbacks.onCallStatusChange === "function") this.uiCallbacks.onCallStatusChange(this.sipserver, this.username);
  };

  _proto.doAnswer = function doAnswer() {
    this.clearError();
    Janus.log("Answering call on instance ID: ", this.instanceId);

    if (this.answerRequested) {
      Janus.log("Answer already requested");
      return;
    }

    if (!this.canAnswer) {
      Janus.log("Unabled to answer, instance ID: ", this.instanceId); // setTimeout(() => this.onCallStatusError("Unable to answer"), 0);

      return;
    }

    try {
      JanusAnswerCall(this.instanceId);
      this.answerRequested = true;
    } catch (err) {
      Janus.log("Unabled to answer:", err.message); // setTimeout(() => this.onCallStatusError("Unable to answer call: " + err.message), 0);
    }
  };

  _proto.doHangup = function doHangup() {
    var _this2 = this;

    this.clearError();

    try {
      JanusHangupCall(this.instanceId);
      this.canHangup = false;
      this.canMakeCall = false;
      this.canAnswer = false;
      this.canRingOut = false;
      this.canHold = false;
      this.canResume = false;
      this.canBlindXfer = false;
      this.canXfer = false;
      this.canSendDtmf = false;
      this.isMuted = false;
    } catch (err) {
      setTimeout(function () {
        return _this2.onCallStatusError(CallStatusErrorCode.ERROR_HANG_UP, "Unable to hangup call: " + err.message);
      }, 0);
      return;
    }

    if (typeof this.uiCallbacks.onCallStatusChange === "function") this.uiCallbacks.onCallStatusChange(this.sipserver, this.username);
  };

  _proto.doIceRestart = function doIceRestart() {
    Janus.log('ICE Restart requested');

    _sessionService.send({
      type: 'FORWARD_TO_PLUGIN',
      event: {
        type: 'DO_ICE_RESTART',
        instanceId: this.instanceId
      }
    });
  };

  _proto.doHold = function doHold() {
    var _this3 = this;

    this.clearError();

    if (!this.canHold) {
      setTimeout(function () {
        return _this3.onCallStatusError(CallStatusErrorCode.ERROR_HOLD, "Unable to hold");
      }, 0);
      return;
    }

    try {
      _sessionService.send({
        type: 'FORWARD_TO_PLUGIN',
        event: {
          type: 'DO_HOLD',
          instanceId: this.instanceId
        }
      });
    } catch (err) {
      setTimeout(function () {
        return _this3.onCallStatusError(CallStatusErrorCode.ERROR_HOLD, "Unable to hold call: " + err.message);
      }, 0);
      return;
    }

    if (typeof this.uiCallbacks.onCallStatusChange === "function") this.uiCallbacks.onCallStatusChange(this.sipserver, this.username);
  };

  _proto.doResume = function doResume() {
    var _this4 = this;

    this.clearError();

    if (!this.canResume) {
      setTimeout(function () {
        return _this4.onCallStatusError(CallStatusErrorCode.ERROR_RESUME, "Unable to resume");
      }, 0);
      return;
    }

    try {
      _sessionService.send({
        type: 'FORWARD_TO_PLUGIN',
        event: {
          type: 'DO_RESUME',
          instanceId: this.instanceId
        }
      });
    } catch (err) {
      setTimeout(function () {
        return _this4.onCallStatusError(CallStatusErrorCode.ERROR_RESUME, "Unable to resume call: " + err.message);
      }, 0);
      return;
    }

    if (typeof this.uiCallbacks.onCallStatusChange === "function") this.uiCallbacks.onCallStatusChange(this.sipserver, this.username);
  };

  _proto.doBlindXfer = function doBlindXfer(refer_to) {
    var _this5 = this;

    this.clearError();

    if (!this.canBlindXfer || !refer_to) {
      setTimeout(function () {
        return _this5.onCallStatusError(CallStatusErrorCode.ERROR_TRANSFER, "Unable to blind transfer");
      }, 0);
      return;
    }

    try {
      var sip_refer_to = _sessionService.state.context.sipserver.replace("sip:", "sip:" + refer_to + "@");

      _sessionService.send({
        type: 'FORWARD_TO_PLUGIN',
        event: {
          type: 'DO_BLIND_XFER',
          instanceId: this.instanceId,
          refer_to: sip_refer_to
        }
      });
    } catch (err) {
      setTimeout(function () {
        return _this5.onCallStatusError(CallStatusErrorCode.ERROR_TRANSFER, "Unable to blind transfer call: " + err.message);
      }, 0);
      return;
    }

    if (typeof this.uiCallbacks.onCallStatusChange === "function") this.uiCallbacks.onCallStatusChange(this.sipserver, this.username);
  };

  _proto.doXfer = function doXfer() {
    var _this6 = this;

    this.clearError();

    if (!this.canXfer || this.xferInstanceId === undefined) {
      setTimeout(function () {
        return _this6.onCallStatusError(CallStatusErrorCode.ERROR_TRANSFER, "Unable to complete transfer");
      }, 0);
      return;
    }

    try {
      JanusCompleteTransfer(this.xferInstanceId);
    } catch (err) {
      setTimeout(function () {
        return _this6.onCallStatusError(CallStatusErrorCode.ERROR_TRANSFER, "Unable to complete transfer: " + err.message);
      }, 0);
      return;
    }

    if (typeof this.uiCallbacks.onCallStatusChange === "function") this.uiCallbacks.onCallStatusChange(this.sipserver, this.username);
  };

  _proto.doSendDtmf = function doSendDtmf(digit) {
    var _this7 = this;

    this.clearError();

    if (!this.canSendDtmf) {
      setTimeout(function () {
        return _this7.onCallStatusError(CallStatusErrorCode.ERROR_DTMF, "Unable to send DTMF");
      }, 0);
      return;
    }

    if (!digit.match(/^[0-9*#]$/)) {
      setTimeout(function () {
        return _this7.onCallStatusError(CallStatusErrorCode.ERROR_DTMF, "Unable to send DTMF: invalid dtmf value:[" + digit + "]");
      }, 0);
      return;
    }

    try {
      _sessionService.send({
        type: 'FORWARD_TO_PLUGIN',
        event: {
          type: 'DO_SEND_DTMF',
          instanceId: this.instanceId,
          dtmf: digit
        }
      });
    } catch (err) {
      setTimeout(function () {
        return _this7.onCallStatusError(CallStatusErrorCode.ERROR_DTMF, "Unable to send dtmf: [" + digit + "], " + err.message);
      }, 0);
    }
  };

  _proto.doEnableVideo = function doEnableVideo(doVideo, videoSource) {
    var _this8 = this;

    if (videoSource === void 0) {
      videoSource = undefined;
    }

    this.clearError();
    Janus.log("Video requested: ", doVideo);
    this.videoRequested = doVideo;
    this.videoSource = videoSource;

    try {
      _sessionService.send({
        type: 'FORWARD_TO_PLUGIN',
        event: {
          type: 'DO_ENABLE_VIDEO',
          doVideo: doVideo,
          videoSource: videoSource,
          instanceId: this.instanceId
        }
      });
    } catch (err) {
      setTimeout(function () {
        return _this8.onCallStatusError(CallStatusErrorCode.ERROR_VIDEO, "Unable to enable video " + err.message);
      }, 0);
    }
  };

  _proto.doGetStats = function doGetStats() {
    var _this9 = this;

    this.clearError();

    try {
      _sessionService.send({
        type: 'FORWARD_TO_PLUGIN',
        event: {
          type: 'DO_GET_STATS',
          instanceId: this.instanceId
        }
      });
    } catch (err) {
      setTimeout(function () {
        return _this9.onCallStatusError(CallStatusErrorCode.ERROR_STATS, "Unable to get statistics " + err.message);
      }, 0);
    }
  };

  _proto.doMuteMicrophone = function doMuteMicrophone(mute) {
    var _this10 = this;

    try {
      Janus.log('Mute microphone requested:', mute, ', local stream:', this.localStream);
      var tracks = this.localStream && this.localStream.getAudioTracks();

      if (tracks == null) {
        Janus.warn('no local audio tracks to mute microphone');
        return;
      }

      for (var _iterator = _createForOfIteratorHelperLoose(tracks), _step; !(_step = _iterator()).done;) {
        var track = _step.value;
        track.enabled = !mute;
      }

      this.onCallStatusChange();

      if (typeof this.uiCallbacks.onCallStatusChange === 'function') {
        this.uiCallbacks.onCallStatusChange(this.sipserver, this.username);
      }
    } catch (err) {
      setTimeout(function () {
        return _this10.onCallStatusError(CallStatusErrorCode.ERROR_AUDIO, 'Unable to mute/unmute microphone ' + err.message);
      }, 0);
    }
  };

  _proto.clearError = function clearError() {
    this.statusErrorCode = undefined;
    this.statusErrorDescription = undefined;
    if (typeof this.uiCallbacks.onCallStatusChange === "function") this.uiCallbacks.onCallStatusChange(this.sipserver, this.username);
  } //////////////////////////////////////////
  // callbacks
  //////////////////////////////////////////
  ;

  _proto.onLineRegistered = function onLineRegistered() {
    this.lineRegistered = true;
    this.onCallStatusChange();
    if (typeof this.uiCallbacks.onCallStatusChange === "function") this.uiCallbacks.onCallStatusChange(this.sipserver, this.username);
  };

  _proto.onLineUnregistered = function onLineUnregistered() {
    this.lineRegistered = false;
    this.onCallStatusChange();
    if (typeof this.uiCallbacks.onCallStatusChange === "function") this.uiCallbacks.onCallStatusChange(this.sipserver, this.username);
  };

  _proto.onCallStatusError = function onCallStatusError(errorCode, errorMessage) {
    this.statusErrorCode = errorCode;
    this.statusErrorDescription = errorMessage;
    if (typeof this.uiCallbacks.onCallStatusChange === "function") this.uiCallbacks.onCallStatusChange(this.sipserver, this.username, errorMessage);
  };

  _proto.onLocalStream = function onLocalStream(stream, isActive) {
    var _this11 = this;

    this.localStream = isActive ? stream : undefined;
    this.localStreamActive = isActive;

    if (this.localStream) {
      var videoTrack = this.localStream.getVideoTracks()[0]; // do this.doEnableVideo(false) BS for none-SR calls only as it severly intefers with SR restart process

      if (this.SetupCallCaps.instanceId < 4 && videoTrack && videoTrack.readyState === 'live' && videoTrack.onended == null) {
        videoTrack.onended = function () {
          Janus.log('Video track ended. Updating statemachine to video disabled');

          _this11.doEnableVideo(false);
        };
      }
    }

    this.onCallStatusChange();
    if (typeof this.uiCallbacks.onCallStatusChange === "function") this.uiCallbacks.onMediaStatusChange(this.sipserver, this.username);
  };

  _proto.onRemoteStream = function onRemoteStream(stream, isActive) {
    this.remoteStream = isActive ? stream : undefined;
    this.remoteStreamActive = isActive;
    this.onCallStatusChange();
    if (typeof this.uiCallbacks.onMediaStatusChange === "function") this.uiCallbacks.onMediaStatusChange(this.sipserver, this.username);
  };

  _proto.onStatsUpdated = function onStatsUpdated(stats) {
    this.stats = stats;
    if (typeof this.uiCallbacks.onStatsUpdated === "function") this.uiCallbacks.onStatsUpdated(stats);
  };

  _proto.onSlowLink = function onSlowLink(uplink, media, lost) {
    var _this12 = this;

    // Janus reports the direction of uplink wrong
    if (media == "audio" && !uplink && typeof this.uiCallbacks.onSlowAudioUpLink === "function") {
      if (this.slowAudioUplinkTimer) clearTimeout(this.slowAudioUplinkTimer);
      this.slowAudioUplinkTimer = undefined;
      this.isSlowAudioUplink = true;
      this.uiCallbacks.onSlowAudioUpLink(true);
      this.slowAudioUplinkTimer = setTimeout(function () {
        _this12.isSlowAudioUplink = false;

        _this12.uiCallbacks.onSlowAudioUpLink(false);
      }, 4000);
    } else if (media == "audio" && uplink && typeof this.uiCallbacks.onSlowAudioDownLink === "function") {
      if (this.slowAudioDownlinkTimer) clearTimeout(this.slowAudioDownlinkTimer);
      this.slowAudioDownlinkTimer = undefined;
      this.isSlowAudioDownlink = true;
      this.uiCallbacks.onSlowAudioDownLink(true);
      this.slowAudioDownlinkTimer = setTimeout(function () {
        _this12.isSlowAudioDownlink = false;

        _this12.uiCallbacks.onSlowAudioDownLink(false);
      }, 4000);
    }
  };

  _proto.onCallStatusIdle = function onCallStatusIdle(code, reason) {
    this.lastHangupCode = code;
    this.lastHangupReason = reason;
    this.lastHangupTone = undefined;
    this.canPlayBusyTone = false;
    this.canPlayReorderTone = false;
    this.canPlayNuTone = false;
    if (this.slowAudioDownlinkTimer) clearTimeout(this.slowAudioDownlinkTimer);
    if (this.slowAudioUplinkTimer) clearTimeout(this.slowAudioUplinkTimer);
    this.slowAudioDownlinkTimer = undefined;
    this.slowAudioUplinkTimer = undefined;
    this.isSlowAudioUplink = false;
    this.isSlowAudioDownlink = false;
    this.hasLocalAudio = false;
    this.hasRemoteAudio = false;
    this.hasLocalVideo = false;
    this.hasRemoteAudio = false;
    this.enabledVideoSource = undefined; // do this.doEnableVideo(false) BS for none-SR calls only as it severly intefers with SR restart process

    if (this.instanceId < 3) this.doEnableVideo(false);

    if (code && (this.direction === 'outgoing' || this.state === 'connected' || this.state === 'reconnected')) {
      if (code === 404) {
        this.lastHangupTone = 'nu';
        this.canPlayNuTone = true;
      } else if (code == 486) {
        this.lastHangupTone = 'busy';
        this.canPlayBusyTone = true;
      } else if (code > 0) {
        this.lastHangupTone = 'reorder';
        this.canPlayReorderTone = true;
      }
    }
  };

  _proto.onCallStatusDeepIdle = function onCallStatusDeepIdle() {
    this.canPlayBusyTone = false;
    this.canPlayReorderTone = false;
    this.canPlayNuTone = false;
  };

  _proto.onCallStatusChange = function onCallStatusChange(callState, callStateDesc, remoteUri, remoteDisplay, media_caps) {
    var oldState = this.state;
    this.state = callState ? callState : oldState;

    if (callState) {
      if (this.state === 'idle') {
        // going idle
        this.lastDirection = this.direction;
        this.direction = undefined;
        this.callId = undefined;
        this.referInstanceId = undefined;
        this.localStreamActive = false;
        this.remoteStreamActive = false;
        this.localStream = undefined;
        this.remoteStream = undefined;

        if (this.lastDirection === 'incoming') {
          this.lastCallerUsername = this.peerUsername;
          this.lastCallerDisplay = this.peerDisplay;
        }

        if (this.lastDirection === 'outgoing') {
          this.lastCalleeUsername = this.peerUsername;
          this.lastCalleeDisplay = this.peerDisplay;
        }

        this.peerUsername = undefined;
        this.peerDisplay = undefined;
        this.answerRequested = false;
      } else if (oldState === 'idle') {
        // going non-idle
        this.direction = callState === 'incomingcall' || callState === 'incomingcallReplaces' || callState === 'connected' ? 'incoming' : 'outgoing';
        this.stateDesc = undefined;
        this.statusErrorCode = undefined;
        this.statusErrorDescription = undefined;
        this.lastHangupCode = undefined;
        this.lastHangupReason = undefined;
        this.lastHangupTone = undefined;
        this.canPlayBusyTone = false;
        this.canPlayReorderTone = false;
        this.canPlayNuTone = false;
      }
    }

    this.stateDesc = callStateDesc;

    if (remoteUri && remoteUri.indexOf("sip:") >= 0) {
      this.peerUsername = remoteUri.indexOf("@") < 0 ? "anonymous" : remoteUri.substring(remoteUri.indexOf("sip:") + 4, remoteUri.indexOf("@"));
    } else if (remoteUri) {
      this.peerUsername = remoteUri;
    }

    if (remoteDisplay) this.peerDisplay = remoteDisplay;
    this.SetupCallCaps();

    try {
      this.isMuted = this.localStreamActive && this.localStream != null && !this.localStream.getAudioTracks()[0].enabled;
    } catch (err) {
      Janus.warn('unable to determine isMuted state', err);
      this.isMuted = false;
    }

    if (media_caps) {
      if (this.hasLocalAudio !== media_caps.hasLocalAudio || this.hasRemoteAudio !== media_caps.hasRemoteAudio || this.hasLocalVideo !== media_caps.hasLocalVideo || this.hasRemoteVideo !== media_caps.hasRemoteVideo || this.enabledVideoSource !== media_caps.enabledVideoSource) {
        Janus.log('Media caps change:\n', '    local audio: [', this.hasLocalAudio, '] --> [', media_caps.hasLocalAudio, ']\n', '   remote audio: [', this.hasRemoteAudio, '] --> [', media_caps.hasRemoteAudio, ']\n', '    local video: [', this.hasLocalVideo, '] --> [', media_caps.hasLocalVideo, ']\n', '   remote video: [', this.hasRemoteVideo, '] --> [', media_caps.hasRemoteVideo, ']\n', '   video source: [', this.enabledVideoSource, '] --> [', media_caps.enabledVideoSource, ']\n');
      }

      this.hasLocalAudio = media_caps.hasLocalAudio;
      this.hasRemoteAudio = media_caps.hasRemoteAudio;
      this.hasLocalVideo = media_caps.hasLocalVideo;
      this.hasRemoteVideo = media_caps.hasRemoteVideo;
      this.enabledVideoSource = media_caps.enabledVideoSource;
    }
  };

  _proto.SetupCallCaps = function SetupCallCaps() {
    this.canMakeCall = this.lineRegistered && this.state === 'idle';
    this.canHangup = this.state !== 'idle';
    this.canAnswer = this.state === 'incomingcall' || this.state === 'incomingcallReplaces';
    this.canRingOut = this.state === 'ringingOut'; // this.featureHoldResume = this.pbxPlatform !== 'cucm'

    this.canHold = this.featureHoldResume && (this.state === 'connected' || this.state === 'reconnected');
    this.canResume = this.featureHoldResume && this.state === 'hold';
    this.canBlindXfer = this.pbxPlatform !== 'cucm' && this.state === 'hold';
    this.canSendDtmf = this.remoteStreamActive && (this.state === 'connected' || this.state === 'reconnected');
  };

  return CallView;
}();
var SrCallView = /*#__PURE__*/function (_CallView) {
  _inheritsLoose(SrCallView, _CallView);

  function SrCallView() {
    var _this13;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this13 = _CallView.call.apply(_CallView, [this].concat(args)) || this;
    _this13.srRequested = false;
    _this13.srTarget = undefined;
    _this13.srFrameRate = undefined;
    return _this13;
  }

  var _proto2 = SrCallView.prototype;

  _proto2.doStartScreenRecording = function doStartScreenRecording(target, callId, frameRate, screenWidth, screenHeight) {
    var _this14 = this;

    if (!this.srTarget) {
      setTimeout(function () {
        return _this14.onCallStatusError(CallStatusErrorCode.ERROR_SCREEN_RECORDING, "Unable to start screen recording (no target)");
      }, 0);
      return;
    }

    this.srRequested = true;

    _CallView.prototype.doEnableVideo.call(this, true, 'screen');

    try {
      _sessionService.send({
        type: 'FORWARD_TO_PLUGIN',
        event: {
          type: 'DO_START_SR',
          instanceId: this.instanceId,
          callId: callId,
          frameRate: frameRate === undefined ? this.srFrameRate : frameRate,
          screenWidth: screenWidth,
          screenHeight: screenHeight,
          target: this.ToDialUri(target ? target : this.srTarget)
        }
      });
    } catch (err) {
      Janus.error('Unable to start screen recording', err);
      setTimeout(function () {
        return _this14.onCallStatusError(CallStatusErrorCode.ERROR_SCREEN_RECORDING, "Unable to start screen recording: " + err.message);
      }, 0);
    }
  };

  _proto2.doStopScreenRecording = function doStopScreenRecording() {
    var _this15 = this;

    this.srRequested = false;

    try {
      _sessionService.send({
        type: 'FORWARD_TO_PLUGIN',
        event: {
          type: 'DO_STOP_SR',
          instanceId: this.instanceId
        }
      });
    } catch (err) {
      Janus.error('Unable to stop screen recording', err);
      setTimeout(function () {
        return _this15.onCallStatusError(CallStatusErrorCode.ERROR_SCREEN_RECORDING, "Unable to start screen recording: " + err.message);
      }, 0);
    }
  };

  _proto2.onLineRegistered = function onLineRegistered() {
    Janus.log('SR call: line registered');

    _CallView.prototype.onLineRegistered.call(this);
  };

  _proto2.onLineUnregistered = function onLineUnregistered() {
    Janus.log('SR call: line unregistered');

    _CallView.prototype.onLineUnregistered.call(this);
  };

  _proto2.onCallStatusError = function onCallStatusError(errorCode, errorMessage) {};

  _proto2.onLocalStream = function onLocalStream(stream, isActive) {};

  _proto2.onRemoteStream = function onRemoteStream(stream, isActive) {};

  _proto2.onStatsUpdated = function onStatsUpdated(stats) {};

  _proto2.SetupCallCaps = function SetupCallCaps() {
    this.canMakeCall = this.lineRegistered && this.state === 'idle';
    this.canHangup = this.state !== 'idle';
    this.canAnswer = false;
    this.canRingOut = this.state === 'ringingOut';
    this.featureHoldResume = false;
    this.canHold = false;
    this.canResume = false;
    this.canBlindXfer = false;
    this.canSendDtmf = false;
  };

  return SrCallView;
}(CallView);
var SmCallView = /*#__PURE__*/function (_CallView2) {
  _inheritsLoose(SmCallView, _CallView2);

  function SmCallView() {
    return _CallView2.apply(this, arguments) || this;
  }

  var _proto3 = SmCallView.prototype;

  _proto3.SetupCallCaps = function SetupCallCaps() {
    this.canMakeCall = this.lineRegistered && this.state === 'idle';
    this.canHangup = this.state !== 'idle';
    this.canAnswer = false;
    this.canRingOut = false;
    this.featureHoldResume = false;
    this.canHold = false;
    this.canResume = false;
    this.canBlindXfer = false;
    this.canSendDtmf = false;
  };

  _proto3.onCallStatusChange = function onCallStatusChange(callState, callStateDesc, remoteUri, remoteDisplay, media_caps) {
    var oldState = this.state;

    _CallView2.prototype.onCallStatusChange.call(this, callState, callStateDesc, remoteUri, remoteDisplay, media_caps);

    if (oldState != this.state && this.state === 'incomingcall' && !this.answerRequested) {
      try {
        JanusAnswerCall(this.instanceId);
        this.answerRequested = true;
      } catch (err) {
        Janus.warn("Unabled to answer:", err.message);

        _CallView2.prototype.doHangup.call(this);
      }
    } else if (this.state === 'incomingcall' || this.state === 'connected' || this.direction === 'outgoing' || this.state === 'idle') ; else {
      Janus.warn("Invalid SM call state [", this.state, "] hanging up");

      _CallView2.prototype.doHangup.call(this);
    }
  };

  return SmCallView;
}(CallView);
var LineView = /*#__PURE__*/function () {
  function LineView() {
    this.uiCallbacks = null;
    this.sipserver = undefined;
    this.username = undefined;
    this.displayName = undefined;
    this.secret = undefined;
    this.is_ha1_secret = false;
    this.bgCalls = undefined;
    this.autoregister = false;
    this.pbxPlatform = undefined;
    this.srCall = undefined;
    this.srRequested = false;
    this.srTarget = undefined;
    this.canSrStart = false;
    this.canSrStop = false;
    this.calls = undefined;
    this.callIndex = 0;
    this.registerStatus = 'unregistered';
    this.registerStatusError = undefined;
    this.mwiStatus = undefined;
    this.canRequestRegister = false;
    this.canRequestUnregister = false;
    this.canToogle = false;
  }

  var _proto4 = LineView.prototype;

  //////////////////////////////////////////
  // public UI commands
  //////////////////////////////////////////
  _proto4.doStartScreenRecording = function doStartScreenRecording(target, callId, frameRate, screenWidth, screenHeight) {
    this.srRequested = true;
    this.canSrStart = !this.srRequested;
    this.canSrStop = this.srRequested;
    Janus.log("Requested to start screen recording to target [", target, "]");

    if (this.srCall) {
      this.srCall.doStartScreenRecording(target, callId, frameRate, screenWidth, screenHeight);
    }
  };

  _proto4.doStopScreenRecording = function doStopScreenRecording() {
    this.srRequested = false;
    this.canSrStart = !this.srRequested;
    this.canSrStop = this.srRequested;
    Janus.log("Requested to stop screen recording");
    if (this.srCall) this.srCall.doStopScreenRecording();
  };

  _proto4.doRequestRegister = function doRequestRegister() {
    var _this16 = this;

    if (!this.canRequestRegister || this.autoregister) {
      setTimeout(function () {
        return _this16.onLineRequestRegisterFailed("Cannot request register ");
      }, 0);
      return;
    }

    this.canRequestRegister = false;
    this.canRequestUnregister = false;

    try {
      JanusActivateSipRegistration(true, this.sipserver, this.username, this.secret, this.is_ha1_secret, this.displayName, this.smTarget);
      this.canRequestUnregister = true;
      setTimeout(function () {
        return _this16.onLineRegisterRequested();
      }, 0);
    } catch (error) {
      this.canRequestRegister = true;
      setTimeout(function () {
        return _this16.onLineRequestRegisterFailed(error.message);
      }, 0);
    }
  };

  _proto4.doRequestUnregister = function doRequestUnregister() {
    var _this17 = this;

    if (!this.canRequestUnregister || this.autoregister) {
      setTimeout(function () {
        return _this17.onLineRequestUnregisterFailed("Cannot request unregister ");
      }, 0);
      return;
    }

    this.canRequestRegister = false;
    this.canRequestUnregister = false;

    try {
      JanusDeactivateSipRegistration(false);
      this.canRequestRegister = true;
      setTimeout(function () {
        return _this17.onLineUnregisterRequested();
      }, 0);
    } catch (error) {
      this.canRequestUnregister = true;
      setTimeout(function () {
        return _this17.onLineRequestUnregisterFailed(error.message);
      }, 0);
    }
  };

  _proto4.doToogle = function doToogle() {
    var _this18 = this;

    if (!this.canToogle) {
      setTimeout(function () {
        return _this18.onCallStatusError(_this18.callIndex, CallStatusErrorCode.ERROR_TOGGLE_CALL, "Unable to alternate call");
      }, 0);
      return;
    }

    try {
      if (this.calls[this.callIndex].state !== 'hold') {
        _sessionService.send({
          type: 'FORWARD_TO_PLUGIN',
          event: {
            type: 'DO_HOLD',
            instanceId: this.calls[this.callIndex].instanceId
          }
        });
      }

      this.callIndex = this.callIndex === 0 ? 1 : 0;
      setTimeout(function () {
        return _this18.onCallStatusChange(_this18.callIndex);
      }, 0);
    } catch (error) {
      setTimeout(function () {
        return _this18.onCallStatusError(_this18.callIndex, CallStatusErrorCode.ERROR_TOGGLE_CALL, "Unable to alternate call:" + error.message);
      }, 0);
    }
  };

  _proto4.doMaintainCallFocus = function doMaintainCallFocus() {
    var _this19 = this;

    var activeCallIndex = this.calls.findIndex(function (call) {
      return (call.state === 'connected' || call.state === 'reconnected') && call.referInstanceId !== _this19.callIndex;
    });
    Janus.log('Index of active call=', activeCallIndex, ', current call index=', this.callIndex);

    if (activeCallIndex >= 0 & activeCallIndex != this.callIndex) {
      // make sure the current call is sent on hold (best effort)			
      try {
        if (this.calls[this.callIndex].state !== 'hold') {
          _sessionService.send({
            type: 'FORWARD_TO_PLUGIN',
            event: {
              type: 'DO_HOLD',
              instanceId: this.calls[this.callIndex].instanceId
            }
          });
        }

        this.callIndex = this.callIndex === 0 ? 1 : 0;
      } catch (error) {
        // fail fast
        Janus.error('Unable to hold call with index', this.callIndex, 'hanging up the call');
        setTimeout(function () {
          return _this19.calls[_this19.callIndex].doHangup();
        });
      }
    }
  } ///////////////////////////////////////////
  // callbacks
  ///////////////////////////////////////////
  ;

  _proto4.onEndpointReconnecting = function onEndpointReconnecting() {
    this.canRequestRegister = false;
    this.canRequestUnregister = false;
    this.canToogle = false;
    this.onUnregistered();
  };

  _proto4.onEndpointConnected = function onEndpointConnected() {
    this.canRequestRegister = !this.autoregister;
    this.canRequestUnregister = false;
  };

  _proto4.onLineRequestRegisterFailed = function onLineRequestRegisterFailed(message) {
    if (typeof this.uiCallbacks.onLineRequestegisterFailed === "function") this.uiCallbacks.onLineRequestRegisterFailed(message, this.sipserver, this.username);
  };

  _proto4.onLineRequestUnregisterFailed = function onLineRequestUnregisterFailed(message) {
    if (typeof this.uiCallbacks.onLineRequestUnregisterFailed === "function") this.uiCallbacks.onLineRequestUnregisterFailed(message, this.sipserver, this.username);
  };

  _proto4.onLineRegisterRequested = function onLineRegisterRequested() {
    if (typeof this.uiCallbacks.onLineRegisterRequested === "function") this.uiCallbacks.onLineRegisterRequested(this.sipserver, this.username);
  };

  _proto4.onLineUnregisterRequested = function onLineUnregisterRequested() {
    if (typeof this.uiCallbacks.onLineUnregisterRequested === "function") this.uiCallbacks.onLineUnregisterRequested(this.sipserver, this.username);
  };

  _proto4.onRegistrationError = function onRegistrationError(message) {
    this.displayName = undefined;
    this.registerStatus = 'unregistered';
    this.registerStatusError = message;

    for (var _iterator2 = _createForOfIteratorHelperLoose(this.calls), _step2; !(_step2 = _iterator2()).done;) {
      var call = _step2.value;
      call.onLineUnregistered();
    }

    for (var _iterator3 = _createForOfIteratorHelperLoose(this.bgCalls), _step3; !(_step3 = _iterator3()).done;) {
      var _call = _step3.value;

      _call.onLineUnregistered();
    }

    if (this.srCall) this.srCall.onLineUnregistered();
    if (typeof this.uiCallbacks.onLineRegisterStatusChange === "function") this.uiCallbacks.onLineRegisterStatusChange(this.sipserver, this.username);
  };

  _proto4.onRegistrationTrying = function onRegistrationTrying() {
    this.registerStatus = 'registering';
    if (typeof this.uiCallbacks.onLineRegisterStatusChange === "function") this.uiCallbacks.onLineRegisterStatusChange(this.sipserver, this.username);
  };

  _proto4.onUnregistrationTrying = function onUnregistrationTrying() {
    this.registerStatus = 'unregistering';

    for (var _iterator4 = _createForOfIteratorHelperLoose(this.calls), _step4; !(_step4 = _iterator4()).done;) {
      var call = _step4.value;
      call.onLineUnregistered();
      this.onCallStatusChange(call.instanceId);
    }

    for (var _iterator5 = _createForOfIteratorHelperLoose(this.bgCalls), _step5; !(_step5 = _iterator5()).done;) {
      var _call2 = _step5.value;

      _call2.onLineUnregistered();

      this.onCallStatusChange(_call2.instanceId);
    }

    if (typeof this.uiCallbacks.onLineRegisterStatusChange === "function") this.uiCallbacks.onLineRegisterStatusChange(this.sipserver, this.username);
  };

  _proto4.onUnregistered = function onUnregistered() {
    this.displayName = undefined;
    this.registerStatus = 'unregistered';
    this.registerStatusError = undefined;

    for (var _iterator6 = _createForOfIteratorHelperLoose(this.calls), _step6; !(_step6 = _iterator6()).done;) {
      var call = _step6.value;
      call.onLineUnregistered();
      this.onCallStatusChange(call.instanceId);
    }

    for (var _iterator7 = _createForOfIteratorHelperLoose(this.bgCalls), _step7; !(_step7 = _iterator7()).done;) {
      var _call3 = _step7.value;

      _call3.onLineUnregistered();

      this.onCallStatusChange(_call3.instanceId);
    }

    if (this.srCall) this.srCall.onLineUnregistered();
    this.canSrStart = false;
    this.canSrStop = this.srRequested;
    if (this.srCall) this.onCallStatusChange(this.srCall.instanceId);
    if (typeof this.uiCallbacks.onLineRegisterStatusChange === "function") this.uiCallbacks.onLineRegisterStatusChange(this.sipserver, this.username);
  };

  _proto4.onRegistered = function onRegistered(displayName) {
    this.displayName = displayName;
    this.registerStatus = 'registered';
    this.registerStatusError = undefined;

    for (var _iterator8 = _createForOfIteratorHelperLoose(this.calls), _step8; !(_step8 = _iterator8()).done;) {
      var call = _step8.value;
      call.onLineRegistered();
      this.onCallStatusChange(call.instanceId);
    }

    for (var _iterator9 = _createForOfIteratorHelperLoose(this.bgCalls), _step9; !(_step9 = _iterator9()).done;) {
      var _call4 = _step9.value;

      _call4.onLineRegistered();

      this.onCallStatusChange(_call4.instanceId);
    }

    if (this.srCall) this.srCall.onLineRegistered();
    this.canSrStart = !this.srRequested;
    this.canSrStop = false;
    if (this.srCall) this.onCallStatusChange(this.srCall.instanceId);
    if (typeof this.uiCallbacks.onLineRegisterStatusChange === "function") this.uiCallbacks.onLineRegisterStatusChange(this.sipserver, this.username);
  };

  _proto4.onMwiStatusChange = function onMwiStatusChange(on) {
    this.mwiStatus = on;
    if (typeof this.uiCallbacks.onLineRegisterStatusChange === "function") this.uiCallbacks.onMwiStatusChange(this.sipserver, this.username);
  };

  _proto4.onPendingCallCanceled = function onPendingCallCanceled(callId) {
    if (typeof this.uiCallbacks.onPendingCallCanceled === "function") this.uiCallbacks.onPendingCallCanceled(callId);
  };

  _proto4.onCallStatusError = function onCallStatusError(instanceId, errorCode, errorMessage) {
    var call = this.calls.find(function (call) {
      return call.instanceId == instanceId;
    });

    if (!call) {
      call = this.bgCalls.find(function (call) {
        return call.instanceId == instanceId;
      });
    }

    if (!call && this.srCall && instanceId == this.srCall.instanceId) {
      call = this.srCall;
    }

    if (call) {
      call.onCallStatusError(errorCode, errorMessage);
    } else {
      Janus.error("Call instanceId:", instanceId, " not found");
    }
  } // Line call status
  ;

  _proto4.onCallStatusIdle = function onCallStatusIdle(instanceId, code, reason) {
    var call = this.calls.find(function (call) {
      return call.instanceId == instanceId;
    });

    if (!call) {
      call = this.bgCalls.find(function (call) {
        return call.instanceId == instanceId;
      });
    }

    if (!call && this.srCall && instanceId === this.srCall.instanceId) {
      call = this.srCall;
      this.canSrStart = true;
      this.canSrStop = false;
    }

    if (call) {
      call.onCallStatusIdle(code, reason);
    }

    this.onCallStatusChange(instanceId, 'idle');
  };

  _proto4.onCallStatusDeepIdle = function onCallStatusDeepIdle(instanceId) {
    var call = this.calls.find(function (call) {
      return call.instanceId == instanceId;
    });

    if (!call) {
      call = this.bgCalls.find(function (call) {
        return call.instanceId == instanceId;
      });
    }

    if (!call && this.srCall && instanceId === this.srCall.instanceId) {
      call = this.srCall;
    }

    if (call) {
      call.onCallStatusDeepIdle();
    }

    this.onCallStatusChange(instanceId);
  };

  _proto4.onCallStatusChange = function onCallStatusChange(instanceId, callState, callStateDesc, remoteUri, remoteDisplay, media_caps) {
    var oldState = 'idle';
    var call = this.calls.find(function (call) {
      return call.instanceId == instanceId;
    });

    if (!call) {
      call = this.bgCalls.find(function (call) {
        return call.instanceId == instanceId;
      });
    }

    if (!call && this.srCall && instanceId === this.srCall.instanceId) {
      call = this.srCall;
      call.onCallStatusChange(callState, callStateDesc, remoteUri, remoteDisplay, media_caps);
      return;
    }

    if (call) {
      oldState = call.state;
      call.onCallStatusChange(callState, callStateDesc, remoteUri, remoteDisplay, media_caps);
    } else {
      Janus.error("Call instanceId:", instanceId, " not found");
      return;
    }

    if (instanceId === this.srCall) return; // re-arrange

    if (this.calls[0].state === 'idle' && this.calls[1].state !== 'idle') {
      var callTemp = this.calls[0];
      this.calls[0] = this.calls[1];
      this.calls[1] = callTemp;
      this.callIndex = 0;
    }

    var fgIdleCallIndex = this.calls.findIndex(function (call) {
      return call.state === 'idle';
    });

    if (fgIdleCallIndex >= 0) {
      // both foreground call are idle
      var bgActiveCallIndex = this.bgCalls.findIndex(function (call) {
        return call.state !== 'idle';
      });

      if (bgActiveCallIndex >= 0) {
        var _callTemp = this.calls[fgIdleCallIndex];
        this.calls[fgIdleCallIndex] = this.bgCalls[bgActiveCallIndex];
        this.bgCalls[bgActiveCallIndex] = _callTemp;
        fgIdleCallIndex = this.calls.findIndex(function (call) {
          return call.state === 'idle';
        });
        bgActiveCallIndex = this.bgCalls.findIndex(function (call) {
          return call.state !== 'idle';
        });

        if (bgActiveCallIndex >= 0) {
          var _callTemp2 = this.calls[fgIdleCallIndex];
          this.calls[fgIdleCallIndex] = this.bgCalls[bgActiveCallIndex];
          this.bgCalls[bgActiveCallIndex] = _callTemp2;
        }
      }
    }

    var isCallConnected = [this.calls[0].state === 'hold' || this.calls[0].state === 'connected' || this.calls[0].state === 'reconnected', this.calls[1].state === 'hold' || this.calls[1].state === 'connected' || this.calls[1].state === 'reconnected'];
    this.canToogle = this.pbxPlatform !== 'cucm' && (this.callIndex === 0 && isCallConnected[0] || this.callIndex === 1 && (isCallConnected[1] || this.calls[1].state === 'idle'));
    this.calls[0].canXfer = false;
    this.calls[0].xferInstanceId = undefined;
    this.calls[1].canXfer = false;
    this.calls[1].xferInstanceId = undefined;

    if (this.calls[0].state !== 'idle' && this.calls[1].state !== 'idle') {
      if (isCallConnected[0]) {
        if (this.calls[1].state === 'callingOut' || this.calls[1].state === 'progressOut' || this.calls[1].state === 'ringingOut' || this.calls[1].state === 'hold' || this.calls[1].state === 'connected' || this.calls[1].state === 'reconnected') {
          // 1 - can complete xfer, self is replaces
          this.calls[1].canXfer = true;
          this.calls[1].xferInstanceId = this.calls[0].instanceId;
        }
      }

      if (isCallConnected[1]) {
        if (this.calls[0].state === 'callingOut' || this.calls[0].state === 'progressOut' || this.calls[0].state === 'ringingOut' || this.calls[0].state === 'hold' || this.calls[0].state === 'connected' || this.calls[0].state === 'reconnected') {
          // 1 - can complete xfer, self is replaces
          this.calls[0].canXfer = this.pbxPlatform !== 'cucm' && true;
          this.calls[0].xferInstanceId = this.calls[0].instanceId;
        }
      }
    } else if (this.calls[0].state === 'idle' && this.calls[1].state === 'idle') {
      // all calls are idle
      this.callIndex = 0;
      this.canToogle = false;
    }

    if (this.calls[0].state == 'incomingcallReplaces' || this.calls[0].state == 'callingOut') this.callIndex = 0;else if (this.calls[1].state == 'incomingcallReplaces' || this.calls[1].state == 'callingOut') this.callIndex = 1;

    if (oldState !== call.state && (call.state === 'connected' || call.state === 'reconnected')) {
      this.doMaintainCallFocus();
    }

    if (typeof this.uiCallbacks.onCallStatusChange === "function") this.uiCallbacks.onCallStatusChange(this.sipserver, this.username);
  };

  _proto4.onCallIdUpdate = function onCallIdUpdate(instanceId, callId) {
    var call = this.calls.find(function (call) {
      return call.instanceId == instanceId;
    });

    if (call) {
      call.callId = callId;
    }
  };

  _proto4.onMediaStatusChange = function onMediaStatusChange(instanceId, event, stream) {
    var call = this.calls.find(function (call) {
      return call.instanceId == instanceId;
    });

    if (call) {
      if (event === 'localstream') {
        call.onLocalStream(stream, stream.active);
      } else if (event === 'remotestream') {
        call.onRemoteStream(stream, stream.active);
      }
    } else if (this.srCall && instanceId === this.srCall.instanceId) {
      if (event === 'localstream') {
        this.srCall.onLocalStream(stream, stream.active);
      } else if (event === 'remotestream') {
        this.srCall.onRemoteStream(stream, stream.active);
      }
    }
  };

  _proto4.onStatsUpdated = function onStatsUpdated(instanceId, stats) {
    // stats is RTCStatsReport
    var call = this.calls.find(function (call) {
      return call.instanceId == instanceId;
    });

    if (call) {
      call.onStatsUpdated(stats);
    } else if (this.srCall && instanceId === this.srCall.instanceId) {
      this.srCall.onStatsUpdated(stats);
    }
  };

  _proto4.onSlowLink = function onSlowLink(instanceId, uplink, media, lost) {
    var call = this.calls.find(function (call) {
      return call.instanceId == instanceId;
    });

    if (call) {
      call.onSlowLink(uplink, media, lost);
    } else if (this.srCall && instanceId === this.srCall.instanceId) {
      this.srCall.onSlowLink(uplink, media, lost);
    }
  };

  _proto4.onReferHandled = function onReferHandled(instanceId, referInstanceId) {
    var call = this.calls.find(function (call) {
      return call.instanceId == instanceId;
    });

    if (call) {
      call.referInstanceId = referInstanceId;
      Janus.log("Call instanceId:", instanceId, " has handled REFER, REFER dial is by instance: ", referInstanceId);
    }
  };

  return LineView;
}();
var SmLineView = /*#__PURE__*/function (_LineView) {
  _inheritsLoose(SmLineView, _LineView);

  function SmLineView(smTarget) {
    var _this20;

    _this20 = _LineView.call(this) || this;
    _this20.smTarget = undefined;
    _this20.smTarget = smTarget;
    return _this20;
  }

  var _proto5 = SmLineView.prototype;

  _proto5.doStartScreenRecording = function doStartScreenRecording(target, callId, frameRate, screenWidth, screenHeight) {};

  _proto5.doStopScreenRecording = function doStopScreenRecording() {};

  _proto5.doRequestRegister = function doRequestRegister() {
    var _this21 = this;

    if (!this.canRequestRegister || this.autoregister) {
      setTimeout(function () {
        return _this21.onLineRequestRegisterFailed("Cannot request register ");
      }, 0);
      return;
    }

    this.canRequestRegister = false;
    this.canRequestUnregister = false;

    try {
      JanusActivateSipRegistration(true, this.sipserver, this.username, this.secret, this.is_ha1_secret, this.displayName, this.smTarget);
      this.canRequestUnregister = true;
      setTimeout(function () {
        return _this21.onLineRegisterRequested();
      }, 0);
    } catch (error) {
      this.canRequestRegister = true;
      setTimeout(function () {
        return _this21.onLineRequestRegisterFailed(error.message);
      }, 0);
    }
  };

  _proto5.doToogle = function doToogle() {
    var _this22 = this;

    setTimeout(function () {
      return _this22.onCallStatusError(_this22.callIndex, CallStatusErrorCode.ERROR_TOGGLE_CALL, "Unable to alternate call");
    }, 0);
    return;
  };

  _proto5.doMaintainCallFocus = function doMaintainCallFocus() {
    this.callIndex = 0;
    this.canToogle = false;
  };

  _proto5.onCallStatusChange = function onCallStatusChange(instanceId, callState, callStateDesc, remoteUri, remoteDisplay, media_caps) {
    var call = this.calls.find(function (call) {
      return call.instanceId == instanceId;
    });

    if (call) {
      call.onCallStatusChange(callState, callStateDesc, remoteUri, remoteDisplay, media_caps);
    } else {
      Janus.error("Call instanceId:", instanceId, " not found");
      return;
    }

    this.callIndex = 0;
    this.canToogle = false;
    if (typeof this.uiCallbacks.onCallStatusChange === "function") this.uiCallbacks.onCallStatusChange(this.sipserver, this.username);
  };

  return SmLineView;
}(LineView); // endpointView:
//      // UI status
//		canConnect:		true/false,
//		canDisconnect:	true/false,
//
//		// commands
//		connect(janusServerUri):	connect to janus server where janusServerUri "https://your.janus.server.org:8089/janus,
//		disconnect():				disconnect from janus server
//	
//
//

var _sessionService = null;
var EndpointView = /*#__PURE__*/function () {
  function EndpointView() {
    this.uiCallbacks = null;
    this.janusServerUri = undefined;
    this.autoregister = false;
    this.pbxPlatform = undefined;
    this.lineView = undefined;
    this.status = 'offline';
    this.statusError = undefined;
    this.canConnect = false;
    this.canDisconnect = false;
  }

  var _proto6 = EndpointView.prototype;

  // public
  _proto6.init = function init() {
    var _this23 = this;

    this.janusServerUri = undefined;
    this.lineView = undefined;
    this.status = 'offline';
    this.statusError = undefined;
    this.canConnect = true;
    this.canDisconnect = false;
    if (typeof this.uiCallbacks.onEndpointStatusChange === "function") setTimeout(function () {
      return _this23.uiCallbacks.onEndpointStatusChange();
    }, 0);
  } //////////////////////////////////////////
  // UI commands
  //////////////////////////////////////////
  ;

  _proto6.doConnectGuest = function doConnectGuest(janusServerUri, turnServers, sipDomain, guestId, guestPasskey, pbxPlatformId, sipRealm, displayName) {
    this.doConnect(janusServerUri, sipDomain, "guest-" + Janus.randomString(6), "", turnServers, guestId, guestPasskey, true, null, null, null, pbxPlatformId, sipRealm, guestId, guestPasskey, displayName);
  };

  _proto6.doConnect = function doConnect(janusServerUri, sipDomain, username, password, turnServers, turnUsername, turnPassword, autoregister, pushToken, alertPushToken, pushPlatformName, pbxPlatformId, sipRealm, janusServerUsername, janusServerPassword, displayName) {
    var _this24 = this;

    if (!this.canConnect) {
      Janus.error("Cannot connect");
      return;
    }

    if (this.lineView) {
      setTimeout(function () {
        return _this24.onEndpointConnectFailed("Line already added", sipserver, username);
      }, 0);
      return;
    }

    var pbxPlatform = undefined;

    if (!isNaN(parseInt(pbxPlatformId)) && parseInt(pbxPlatformId) === 3) {
      pbxPlatform = 'cucm';
    }

    var sipserver = "sip:" + (sipDomain ? sipDomain : "ipfx.pbx") + ":5060";

    if (username.length === 0) {
      setTimeout(function () {
        return _this24.onEndpointConnectFailed("Invalid username", sipserver, username);
      }, 0);
      return;
    }

    this.autoregister = autoregister;
    this.canConnect = false;
    this.canDisconnect = false;

    try {
      this.janusServerUri = janusServerUri; // Make sure the browser supports WebRTC

      if (!Janus.isWebrtcSupported()) {
        setTimeout(function () {
          return _this24.onEndpointConnectFailed("No WebRTC support... ");
        }, 0);
        return;
      }

      this.addLine(sipDomain, sipserver, username, password, pbxPlatform, sipRealm, displayName, 'webrtc-recorder-sink');
      this.setupSessionService(janusServerUri, turnServers, turnUsername, turnPassword, autoregister, pushToken, alertPushToken, pushPlatformName, janusServerUsername, janusServerPassword, displayName, pbxPlatform);
    } catch (error) {
      this.lineView = undefined;
      setTimeout(function () {
        return _this24.onEndpointConnectFailed(error.message);
      }, 0);
    }
  } //////////////////////////////////////////
  ;

  _proto6.doConnectScreenMonitor = function doConnectScreenMonitor(janusServerUri, sipDomain, username, password, turnServers, turnUsername, turnPassword, pushPlatformName, pbxPlatformId, sipRealm, janusServerUsername, janusServerPassword, displayName, monitorTarget) {
    var _this25 = this;

    if (!this.canConnect) {
      Janus.error("Cannot connect screen monitor");
      return;
    }

    if (this.lineView) {
      setTimeout(function () {
        return _this25.onEndpointConnectFailed("Screen monitor line already added", sipserver, username);
      }, 0);
      return;
    }

    var pbxPlatform = undefined;

    if (isNaN(parseInt(pbxPlatformId)) && parseInt(pbxPlatformId) === 3) {
      pbxPlatform = 'cucm';
      setTimeout(function () {
        return _this25.onEndpointConnectFailed("Screen monitor not supported on CUCM platform", sipserver, username);
      }, 0);
      return;
    }

    var sipserver = "sip:" + (sipDomain ? sipDomain : "ipfx.pbx") + ":5060";

    if (!monitorTarget || monitorTarget.length === 0) {
      setTimeout(function () {
        return _this25.onEndpointConnectFailed("Invalid monitor target", sipserver, username);
      }, 0);
      return;
    }

    if (username.length === 0) {
      setTimeout(function () {
        return _this25.onEndpointConnectFailed("Invalid username", sipserver, username);
      }, 0);
      return;
    }

    this.autoregister = true;
    this.canConnect = false;
    this.canDisconnect = false;

    try {
      this.janusServerUri = janusServerUri; // Make sure the browser supports WebRTC

      if (!Janus.isWebrtcSupported()) {
        setTimeout(function () {
          return _this25.onEndpointConnectFailed("No WebRTC support... ");
        }, 0);
        return;
      }

      this.addScreenMonitorLine(sipDomain, sipserver, username, password, pbxPlatform, sipRealm, displayName, monitorTarget);
      this.setupSessionService(janusServerUri, turnServers, turnUsername, turnPassword, this.autoregister, undefined, undefined, pushPlatformName, janusServerUsername, janusServerPassword, displayName, pbxPlatform, monitorTarget);
    } catch (error) {
      this.lineView = undefined;
      setTimeout(function () {
        return _this25.onEndpointConnectFailed(error.message);
      }, 0);
    }
  };

  _proto6.setupSessionService = function setupSessionService(janusServerUri, turnServers, turnUsername, turnPassword, autoregister, pushToken, alertPushToken, pushPlatformName, janusServerUsername, janusServerPassword, displayName, pbxPlatform, monitorTarget) {
    if (_sessionService === null) {
      _sessionService = interpret(janusSession);

      _sessionService.onTransition(function (state) {
        if (state.history === undefined) Janus.log("Machine session state change: ", state.history, "-->", state.value, ", event: ", state.event);else Janus.log("Machine session state change: ", state.history.value, "-->", state.value, ", event: ", state.event);
      });

      _sessionService.machine.context.endpointView = this;

      _sessionService.start();
    } else {
      _sessionService.machine.context.endpointView = this;
    }

    if (turnServers && turnServers.length > 0) {
      _sessionService.send({
        type: 'DO_CONNECT',
        autoregister: autoregister,
        janusServer: janusServerUri,
        janusServerUsername: janusServerUsername,
        janusServerPassword: janusServerPassword,
        pushToken: pushToken,
        alertPushToken: alertPushToken,
        pushPlatformName: pushPlatformName,
        sipserver: this.lineView.sipserver,
        username: this.lineView.username,
        secret: this.lineView.secret,
        is_ha1_secret: this.lineView.is_ha1_secret,
        iceServers: [{
          'urls': turnServers,
          'credential': turnPassword,
          'username': turnUsername
        }],
        pbxPlatform: pbxPlatform,
        displayName: this.lineView.displayName,
        monitorTarget: monitorTarget
      });
    } else {
      _sessionService.send({
        type: 'DO_CONNECT',
        autoregister: autoregister,
        janusServer: janusServerUri,
        janusServerUsername: janusServerUsername,
        janusServerPassword: janusServerPassword,
        pushToken: pushToken,
        alertPushToken: alertPushToken,
        pushPlatformName: pushPlatformName,
        sipserver: this.lineView.sipserver,
        username: this.lineView.username,
        secret: this.lineView.secret,
        is_ha1_secret: this.lineView.is_ha1_secret,
        pbxPlatform: pbxPlatform,
        displayName: this.lineView.displayName,
        monitorTarget: monitorTarget
      });
    }
  } //////////////////////////////////////////
  ;

  _proto6.doDisconnect = function doDisconnect(removeToken) {
    if (!this.canDisconnect) {
      Janus.error("Cannot disconnect");
      return;
    }

    if (!this.lineView) {
      this.canConnect = true;
      this.canDisconnect = false;
      return;
    }

    this.canConnect = false;
    this.canDisconnect = false;

    try {
      this.removeLine(removeToken);

      if (_sessionService !== null) {
        _sessionService.send('DO_DISCONNECT');
      }
    } catch (error) {
      Janus.error("Failed to disconnect endpoint:", error.message);
    }
  } //////////////////////////////////////////
  ;

  _proto6.addLine = function addLine(sipDomain, sipserver, username, password, pbxPlatform, sipRealm, displayName, srTarget) {
    this.pbxPlatform = pbxPlatform;
    this.lineView = new LineView();
    this.lineView.uiCallbacks = this.uiCallbacks;
    this.lineView.sipserver = sipserver;
    this.lineView.username = username;
    this.lineView.secret = sipRealm ? md5(this.lineView.username + ':' + sipRealm + ':' + password) : password;
    this.lineView.is_ha1_secret = sipRealm ? true : false;
    this.lineView.canRequestRegister = false;
    this.lineView.canRequestUnregister = false;
    this.lineView.calls = [new CallView(), new CallView()];
    this.lineView.autoregister = this.autoregister;
    this.lineView.pbxPlatform = pbxPlatform;
    this.lineView.displayName = displayName;
    var i = 0;

    for (var _iterator10 = _createForOfIteratorHelperLoose(this.lineView.calls), _step10; !(_step10 = _iterator10()).done;) {
      var call = _step10.value;
      call.uiCallbacks = this.uiCallbacks;
      call.sipserver = sipserver;
      call.username = username;
      call.instanceId = i++;
      call.pbxPlatform = pbxPlatform;
    }

    this.lineView.bgCalls = [new CallView(), new CallView()];

    for (var _iterator11 = _createForOfIteratorHelperLoose(this.lineView.bgCalls), _step11; !(_step11 = _iterator11()).done;) {
      var _call5 = _step11.value;
      _call5.uiCallbacks = this.uiCallbacks;
      _call5.sipserver = sipserver;
      _call5.username = username;
      _call5.instanceId = i++;
      _call5.pbxPlatform = pbxPlatform;
    }

    this.lineView.callIndex = 0;
    this.lineView.srCall = new SrCallView();
    this.lineView.srCall.srTarget = srTarget;
    this.srTarget = srTarget;
    this.lineView.srCall.srFrameRate = {
      ideal: 3
    };
    if (this.srRequested) this.doStartScreenRecording();
    this.lineView.srCall.sipserver = sipserver;
    this.lineView.srCall.username = username;
    this.lineView.srCall.instanceId = i++;
    this.lineView.srCall.pbxPlatform = pbxPlatform;
  } //////////////////////////////////////////
  ;

  _proto6.addScreenMonitorLine = function addScreenMonitorLine(sipDomain, sipserver, username, password, pbxPlatform, sipRealm, displayName, smTarget) {
    this.pbxPlatform = pbxPlatform;
    this.lineView = new SmLineView(smTarget);
    this.lineView.uiCallbacks = this.uiCallbacks;
    this.lineView.sipserver = sipserver;
    this.lineView.username = username;
    this.lineView.secret = sipRealm ? md5(this.lineView.username + ':' + sipRealm + ':' + password) : password;
    this.lineView.is_ha1_secret = sipRealm ? true : false;
    this.lineView.canRequestRegister = false;
    this.lineView.canRequestUnregister = false;
    this.lineView.calls = [new SmCallView()];
    this.lineView.autoregister = this.autoregister;
    this.lineView.pbxPlatform = pbxPlatform;
    this.lineView.displayName = displayName;
    var i = 0;

    for (var _iterator12 = _createForOfIteratorHelperLoose(this.lineView.calls), _step12; !(_step12 = _iterator12()).done;) {
      var call = _step12.value;
      call.uiCallbacks = this.uiCallbacks;
      call.sipserver = sipserver;
      call.username = username;
      call.instanceId = i++;
      call.pbxPlatform = pbxPlatform;
    }

    this.lineView.bgCalls = [];
    this.lineView.callIndex = 0;
    this.lineView.srCall = undefined;
  } //////////////////////////////////////////
  ;

  _proto6.removeLine = function removeLine(removeToken) {
    var lineView = this.lineView;
    this.lineView = undefined;

    if (lineView) {
      try {
        lineView.canRequestUnregister = false;
        JanusDeactivateSipRegistration(removeToken);
      } catch (error1) {
        Janus.warn("Failed to unregister:", error1.message);
      }

      for (var _iterator13 = _createForOfIteratorHelperLoose(lineView.calls), _step13; !(_step13 = _iterator13()).done;) {
        var call = _step13.value;

        try {
          JanusHangupCall(call.instanceId);
        } catch (error1) {
          Janus.warn("Failed to hangup call:", call.instanceId, ": ", error1.message);
        }
      }

      for (var _iterator14 = _createForOfIteratorHelperLoose(lineView.bgCalls), _step14; !(_step14 = _iterator14()).done;) {
        var _call6 = _step14.value;

        try {
          JanusHangupCall(_call6.instanceId);
        } catch (error1) {
          Janus.warn("Failed to hangup call:", _call6.instanceId, ": ", error1.message);
        }
      }
    }
  } ///////////////////////////////////////////
  // callbacks
  ///////////////////////////////////////////
  ;

  _proto6.onEndpointConnectFailed = function onEndpointConnectFailed(message) {
    Janus.warn("Failed to connect endpoint: ", message);
    this.status = 'offline';
    this.statusError = message;
    this.canConnect = true;
    this.canDisconnect = false;
    if (typeof this.uiCallbacks.onEndpointStatusChange === "function") this.uiCallbacks.onEndpointStatusChange();
  };

  _proto6.onEndpointDisconnected = function onEndpointDisconnected(message) {
    var _this26 = this;

    Janus.log("Endpoint disconnected");
    this.status = 'offline';
    this.statusError = message;
    this.canConnect = true;
    this.canDisconnect = false;
    var lineViewCopy = this.lineView;
    this.lineView = undefined;
    if (lineViewCopy && typeof this.uiCallbacks.onEndpointLineRemoved === "function") setTimeout(function () {
      return _this26.uiCallbacks.onEndpointLineRemoved(lineViewCopy.sipserver, lineViewCopy.username);
    }, 0);
    if (typeof this.uiCallbacks.onEndpointStatusChange === "function") setTimeout(function () {
      return _this26.uiCallbacks.onEndpointStatusChange();
    }, 0);
  };

  _proto6.onEndpointReconnecting = function onEndpointReconnecting() {
    var _this27 = this;

    // Reconnecting will see the client state momentarily going through online->offline->online.
    // Client can still initiate connect or disconnect during the reconnection
    Janus.log("Endpoint now reconnecting to a another server");
    this.status = 'offline';
    this.statusError = undefined;
    this.canConnect = false;
    this.canDisconnect = true; // can still interrupt reconnecting process

    this.lineView.onEndpointReconnecting();
    if (typeof this.uiCallbacks.onEndpointStatusChange === "function") setTimeout(function () {
      return _this27.uiCallbacks.onEndpointStatusChange();
    }, 0);
  } ///////////////////////////////////////////
  ;

  _proto6.onEndpointConnecting = function onEndpointConnecting() {
    var _this28 = this;

    Janus.log("Endpoint connecting...");
    this.status = 'connecting';
    this.statusError = undefined;
    this.canConnect = false;
    this.canDisconnect = false;
    if (typeof this.uiCallbacks.onEndpointStatusChange === "function") setTimeout(function () {
      return _this28.uiCallbacks.onEndpointStatusChange();
    }, 0);
  } ///////////////////////////////////////////
  ;

  _proto6.onEndpointConnected = function onEndpointConnected() {
    var _this29 = this;

    Janus.log("Endpoint connected");
    this.status = 'online';
    this.statusError = undefined;
    this.canConnect = false;
    this.canDisconnect = true;
    this.lineView.onEndpointConnected();
    if (typeof this.uiCallbacks.onEndpointStatusChange === "function") setTimeout(function () {
      return _this29.uiCallbacks.onEndpointStatusChange();
    }, 0);
  } ///////////////////////////////////////////
  ;

  _proto6.onEndpointRemoveLineFailed = function onEndpointRemoveLineFailed(message, sipserver, username) {
    Janus.warn("Endpoint remove failed:", message);
    this.canConnect = false;
    this.canDisconnect = this.status === 'online';
    if (typeof this.uiCallbacks.onEndpointStatusChange === "function") this.uiCallbacks.onEndpointRemoveLineFailed(message, sipserver, username);
  } ///////////////////////////////////////////
  ;

  _proto6.onEndpointLineRemoved = function onEndpointLineRemoved(sipserver, username) {
    Janus.log("Endpoint line removed:");
    this.canConnect = this.status === 'online';
    this.canDisconnect = false;
    if (typeof this.uiCallbacks.onEndpointLineAdded === "function") this.uiCallbacks.onEndpointLineRemoved(sipserver, username);
  };

  return EndpointView;
}();

function CreateEndpointView(uiCallbacks) {
  endpointView = new EndpointView();
  endpointView.uiCallbacks = uiCallbacks;
  window.endpointView = endpointView;
  window.janusSession = janusSession;
  return endpointView;
} ////////////////////////////////////////////////////////////////////////////////////

var janusSession = /*#__PURE__*/Machine({
  id: 'ipfxJanusSession',
  initial: 'inactive',
  context: {
    janusSession: null,
    janusServer: null,
    janusServerUsername: undefined,
    janusServerPassword: undefined,
    queuedStop: false,
    error: "",
    sipserver: "",
    username: "",
    secret: "",
    is_ha1_secret: false,
    idlePlugins: /*#__PURE__*/new Set([0, 1, 2, 3]),
    idleSrPlugins: /*#__PURE__*/new Set([4]),
    endpointView: null,
    autoregister: false,
    pushToken: null,
    alertPushToken: null,
    pushPlatformName: null,
    pbxPlatform: null,
    displayName: undefined,
    serverRequestToReconnect: false,
    iceServers: undefined,
    monitorTarget: undefined,
    isMonitorSession: false
  },
  on: {
    DO_CONNECT: {
      actions: function actions() {
        endpointView.onEndpointConnectFailed("Session machine in the wrong state for DO_CONNECT request");
      }
    },
    DO_DISCONNECT: {
      actions: /*#__PURE__*/assign({
        queuedStop: function queuedStop() {
          return true;
        }
      })
    }
  },
  states: {
    inactive: {
      entry: 'onJanusSessionStoppedAction',
      on: {
        DO_CONNECT: {
          target: 'pending',
          actions: /*#__PURE__*/assign({
            autoregister: function autoregister(context, event) {
              return event.autoregister;
            },
            janusServer: function janusServer(context, event) {
              return event.janusServer;
            },
            janusServerUsername: function janusServerUsername(context, event) {
              return event.janusServerUsername;
            },
            janusServerPassword: function janusServerPassword(context, event) {
              return event.janusServerPassword;
            },
            pushToken: function pushToken(context, event) {
              return event.pushToken;
            },
            alertPushToken: function alertPushToken(context, event) {
              return event.alertPushToken;
            },
            pushPlatformName: function pushPlatformName(context, event) {
              return event.pushPlatformName;
            },
            sipserver: function sipserver(context, event) {
              return event.sipserver;
            },
            username: function username(context, event) {
              return event.sipserver.replace("sip:", "sip:" + event.username + "@");
            },
            secret: function secret(context, event) {
              return event.secret;
            },
            is_ha1_secret: function is_ha1_secret(context, event) {
              return event.is_ha1_secret;
            },
            pbxPlatform: function pbxPlatform(context, event) {
              return event.pbxPlatform;
            },
            displayName: function displayName(context, event) {
              return event.displayName;
            },
            iceServers: function iceServers(context, event) {
              return event.iceServers;
            },
            monitorTarget: function monitorTarget(context, event) {
              return event.monitorTarget;
            },
            isMonitorSession: function isMonitorSession(context, event) {
              return event.monitorTarget != undefined;
            }
          })
        }
      }
    },
    reconnecting: {
      after: {
        15000: 'inactive'
      },
      // if we are stuck in reconnecting - bail out
      entry: ['onJanusSessionReconnectingAction', 'stopJanusSessionAction'],
      on: {
        DO_DISCONNECT: 'inactive',
        DO_RECONNECT: 'pending',
        // use saved context set by DO_CONNECT event
        DO_CONNECT: {
          actions: /*#__PURE__*/assign({
            autoregister: function autoregister(context, event) {
              return event.autoregister;
            },
            janusServer: function janusServer(context, event) {
              return event.janusServer;
            },
            janusServerUsername: function janusServerUsername(context, event) {
              return event.janusServerUsername;
            },
            janusServerPassword: function janusServerPassword(context, event) {
              return event.janusServerPassword;
            },
            pushToken: function pushToken(context, event) {
              return event.pushToken;
            },
            alertPushToken: function alertPushToken(context, event) {
              return event.alertPushToken;
            },
            pushPlatformName: function pushPlatformName(context, event) {
              return event.pushPlatformName;
            },
            sipserver: function sipserver(context, event) {
              return event.sipserver;
            },
            username: function username(context, event) {
              return event.sipserver.replace("sip:", "sip:" + event.username + "@");
            },
            secret: function secret(context, event) {
              return event.secret;
            },
            is_ha1_secret: function is_ha1_secret(context, event) {
              return event.is_ha1_secret;
            },
            pbxPlatform: function pbxPlatform(context, event) {
              return event.pbxPlatform;
            },
            displayName: function displayName(context, event) {
              return event.displayName;
            },
            iceServers: function iceServers(context, event) {
              return event.iceServers;
            },
            monitorTarget: function monitorTarget(context, event) {
              return event.monitorTarget;
            },
            isMonitorSession: function isMonitorSession(context, event) {
              return event.monitorTarget != undefined;
            }
          })
        },
        JANUS_SESSION_ERROR: 'pending',
        JANUS_SESSION_DESTROYED: 'pending'
      }
    },
    pending: {
      invoke: {
        id: 'sessionControl',
        src: 'sessionControlService'
      },
      entry: /*#__PURE__*/assign({
        opaqueSessionId: function opaqueSessionId() {
          return Janus.randomString(12);
        }
      }),
      exit: /*#__PURE__*/assign({
        serverRequestToReconnect: function serverRequestToReconnect() {
          return false;
        }
      }),
      on: {
        JANUS_SESSION_SUCCESS: [{
          cond: function cond(context, event) {
            return context.queuedStop;
          },
          actions: 'stopJanusSessionAction'
        }, {
          cond: function cond(context, event) {
            return context.serverRequestToReconnect;
          },
          target: 'reconnecting'
        }, {
          target: 'active'
        }],
        JANUS_SESSION_PROGRESS: {
          actions: function actions() {
            endpointView.onEndpointConnecting();
          }
        },
        JANUS_SESSION_ERROR: {
          target: 'inactive',
          actions: 'onJanusSessionErrorAction'
        },
        JANUS_SESSION_DESTROYED: 'inactive',
        REQUEST_TO_RECONNECT: {
          actions: /*#__PURE__*/assign({
            serverRequestToReconnect: function serverRequestToReconnect() {
              return true;
            }
          })
        }
      }
    },
    active: {
      initial: 'connected',
      states: {
        disconnecting: {
          entry: /*#__PURE__*/choose$1([{
            cond: function cond(context) {
              return !context.isMonitorSession;
            },
            actions: [/*#__PURE__*/send$1('DETACH', {
              to: 'masterPlugin'
            }), /*#__PURE__*/send$1('DETACH', {
              to: 'helperPlugin1'
            }), /*#__PURE__*/send$1('DETACH', {
              to: 'helperPlugin2'
            }), /*#__PURE__*/send$1('DETACH', {
              to: 'helperPlugin3'
            }), /*#__PURE__*/send$1('DETACH', {
              to: 'srPlugin'
            })]
          }, {
            cond: function cond(context) {
              return context.isMonitorSession;
            },
            actions: [/*#__PURE__*/send$1('DETACH', {
              to: 'masterPlugin'
            })]
          }]),
          after: {
            4000: {
              target: 'destroying_session'
            }
          }
        },
        destroying_session: {
          after: {
            2000: 'destroying_session_expired'
          },
          entry: 'stopJanusSessionAction'
        },
        destroying_session_expired: {
          entry: /*#__PURE__*/send$1('JANUS_SESSION_DESTROYED')
        },
        connected: {
          on: {
            DO_DISCONNECT: 'disconnecting'
          }
        }
      },
      invoke: [{
        id: 'masterPlugin',
        src: sipPluginSession,
        onError: {
          target: '.destroying_session'
        },
        data: {
          sessionService: function sessionService(context, event) {
            return _sessionService;
          },
          janusSession: function janusSession(context, event) {
            return context.janusSession;
          },
          opaqueId: function opaqueId(context, event) {
            return "janus-sip-plugin-" + context.opaqueSessionId;
          },
          instanceId: 0,
          autoregister: function autoregister(context, event) {
            return context.autoregister;
          },
          pushToken: function pushToken(context, event) {
            return context.pushToken;
          },
          alertPushToken: function alertPushToken(context, event) {
            return context.alertPushToken;
          },
          pushPlatformName: function pushPlatformName(context, event) {
            return context.pushPlatformName;
          },
          registerSipserver: function registerSipserver(context, event) {
            return context.sipserver;
          },
          registerUsername: function registerUsername(context, event) {
            return context.username;
          },
          registerSecret: function registerSecret(context, event) {
            return context.secret;
          },
          registerIsHa1Secret: function registerIsHa1Secret(context, event) {
            return context.is_ha1_secret;
          },
          pbxPlatform: function pbxPlatform(context, event) {
            return context.pbxPlatform;
          },
          registerDisplayname: function registerDisplayname(context, event) {
            return context.displayName;
          },
          monitorTarget: function monitorTarget(context, event) {
            return context.monitorTarget;
          },
          disabledPlugin: function disabledPlugin() {
            return false;
          }
        },
        onDone: {
          target: '.destroying_session',
          cond: function cond(context) {
            return context.idlePlugins.size == 4 && context.idleSrPlugins.size == 1;
          }
        }
      }, {
        id: 'helperPlugin1',
        src: sipPluginSession,
        onError: {
          target: '.destroying_session',
          cond: function cond(context) {
            return !context.isMonitorSession;
          }
        },
        data: {
          sessionService: function sessionService(context, event) {
            return _sessionService;
          },
          janusSession: function janusSession(context, event) {
            return context.janusSession;
          },
          opaqueId: function opaqueId(context, event) {
            return "janus-helper-sip-plugin-1-" + context.opaqueSessionId;
          },
          instanceId: 1,
          pbxPlatform: function pbxPlatform(context, event) {
            return context.pbxPlatform;
          },
          disabledPlugin: function disabledPlugin(context, event) {
            return context.isMonitorSession;
          }
        },
        onDone: {
          target: '.destroying_session',
          cond: function cond(context) {
            return !context.isMonitorSession && context.idlePlugins.size == 4 && context.idleSrPlugins.size == 1;
          }
        }
      }, {
        id: 'helperPlugin2',
        src: sipPluginSession,
        onError: {
          target: '.destroying_session',
          cond: function cond(context) {
            return !context.isMonitorSession;
          }
        },
        data: {
          sessionService: function sessionService(context, event) {
            return _sessionService;
          },
          janusSession: function janusSession(context, event) {
            return context.janusSession;
          },
          opaqueId: function opaqueId(context, event) {
            return "janus-helper-sip-plugin-2-" + context.opaqueSessionId;
          },
          instanceId: 2,
          pbxPlatform: function pbxPlatform(context, event) {
            return context.pbxPlatform;
          },
          disabledPlugin: function disabledPlugin(context, event) {
            return context.isMonitorSession;
          }
        },
        onDone: {
          target: '.destroying_session',
          cond: function cond(context) {
            return !context.isMonitorSession && context.idlePlugins.size == 4 && context.idleSrPlugins.size == 1;
          }
        }
      }, {
        id: 'helperPlugin3',
        src: sipPluginSession,
        onError: {
          target: '.destroying_session',
          cond: function cond(context) {
            return !context.isMonitorSession;
          }
        },
        data: {
          sessionService: function sessionService(context, event) {
            return _sessionService;
          },
          janusSession: function janusSession(context, event) {
            return context.janusSession;
          },
          opaqueId: function opaqueId(context, event) {
            return "janus-helper-sip-plugin-3-" + context.opaqueSessionId;
          },
          instanceId: 3,
          pbxPlatform: function pbxPlatform(context, event) {
            return context.pbxPlatform;
          },
          disabledPlugin: function disabledPlugin(context, event) {
            return context.isMonitorSession;
          }
        },
        onDone: {
          target: '.destroying_session',
          cond: function cond(context) {
            return !context.isMonitorSession && context.idlePlugins.size == 4 && context.idleSrPlugins.size == 1;
          }
        }
      }, {
        id: 'srPlugin',
        src: sipPluginSession,
        onError: {
          target: '.destroying_session',
          cond: function cond(context) {
            return !context.isMonitorSession;
          }
        },
        data: {
          sessionService: function sessionService(context, event) {
            return _sessionService;
          },
          janusSession: function janusSession(context, event) {
            return context.janusSession;
          },
          opaqueId: function opaqueId(context, event) {
            return "janus-helper-sr-plugin-" + context.opaqueSessionId;
          },
          instanceId: 4,
          pbxPlatform: function pbxPlatform(context, event) {
            return context.pbxPlatform;
          },
          disabledPlugin: function disabledPlugin(context, event) {
            return context.isMonitorSession;
          }
        },
        onDone: {
          target: '.destroying_session',
          cond: function cond(context) {
            return !context.isMonitorSession && context.idlePlugins.size == 4 && context.idleSrPlugins.size == 1;
          }
        }
      }],
      entry: 'onJanusSessionStartedAction',
      exit: /*#__PURE__*/assign({
        serverRequestToReconnect: function serverRequestToReconnect() {
          return false;
        }
      }),
      on: {
        JANUS_SESSION_DESTROYED: 'inactive',
        JANUS_SESSION_ERROR: {
          actions: [/*#__PURE__*/send$1(function (context, event) {
            return {
              type: 'JANUS_SESSION_ENDED'
            };
          }, {
            to: 'masterPlugin'
          }), /*#__PURE__*/send$1(function (context, event) {
            return {
              type: 'JANUS_SESSION_ENDED'
            };
          }, {
            to: 'helperPlugin1'
          }), /*#__PURE__*/send$1(function (context, event) {
            return {
              type: 'JANUS_SESSION_ENDED'
            };
          }, {
            to: 'helperPlugin2'
          }), /*#__PURE__*/send$1(function (context, event) {
            return {
              type: 'JANUS_SESSION_ENDED'
            };
          }, {
            to: 'helperPlugin3'
          }), /*#__PURE__*/send$1(function (context, event) {
            return {
              type: 'JANUS_SESSION_ENDED'
            };
          }, {
            to: 'srPlugin'
          })]
        },
        PLUGIN_REGISTRATION_FAILED: {
          actions: 'notifyRegistrationFailedAction',
          cond: function cond(context, event) {
            return event.instanceId == 0;
          }
        },
        PLUGIN_RETRYING_REGISTER: {
          actions: 'notifyRetryingRegistrationAction',
          cond: function cond(context, event) {
            return event.instanceId == 0;
          }
        },
        PLUGIN_TRYING_UNREGISTER: {
          actions: 'notifyTryingUnregistrationAction',
          cond: function cond(context, event) {
            return event.instanceId == 0;
          }
        },
        PLUGIN_UNREGISTERED: {
          actions: 'notifyUnregisteredAction',
          cond: function cond(context, event) {
            return event.instanceId == 0;
          }
        },
        PLUGIN_REGISTERED: {
          actions: ['notifyRegisteredAction', /*#__PURE__*/send$1(function (context, event) {
            return {
              type: 'ATTACH',
              masterId: event.masterId,
              registerUsername: event.registerUsername
            };
          }, {
            to: 'helperPlugin1'
          }), /*#__PURE__*/send$1(function (context, event) {
            return {
              type: 'ATTACH',
              masterId: event.masterId,
              registerUsername: event.registerUsername
            };
          }, {
            to: 'helperPlugin2'
          }), /*#__PURE__*/send$1(function (context, event) {
            return {
              type: 'ATTACH',
              masterId: event.masterId,
              registerUsername: event.registerUsername
            };
          }, {
            to: 'helperPlugin3'
          }), /*#__PURE__*/send$1(function (context, event) {
            return {
              type: 'ATTACH',
              masterId: event.masterId,
              registerUsername: event.registerUsername
            };
          }, {
            to: 'srPlugin'
          }), /*#__PURE__*/send$1(function (context, event) {
            return {
              type: 'SUBSCRIBE'
            };
          }, {
            to: 'masterPlugin'
          })],
          cond: function cond(context, event) {
            return event.instanceId == 0 && !context.isMonitorSession;
          }
        },
        CTI_MWI: {
          actions: 'notifyMwiAction'
        },
        CANCEL_PENDING_CALL: {
          actions: 'cancelPendingCallAction'
        },
        CTI_HOLD: {
          actions: /*#__PURE__*/send$1(function (context, event) {
            return {
              type: 'FORWARD_TO_PLUGIN',
              event: {
                type: 'DO_HOLD',
                instanceId: event.instanceId
              }
            };
          })
        },
        CTI_ANSWER: {
          actions: /*#__PURE__*/send$1(function (context, event) {
            return {
              type: 'FORWARD_TO_PLUGIN',
              event: {
                type: 'DO_ACCEPT',
                instanceId: event.instanceId
              }
            };
          })
        },
        CTI_RESUME: {
          actions: /*#__PURE__*/send$1(function (context, event) {
            return {
              type: 'FORWARD_TO_PLUGIN',
              event: {
                type: 'DO_RESUME',
                instanceId: event.instanceId
              }
            };
          })
        },
        CTI_DIAL: [{
          actions: /*#__PURE__*/send$1(function (context, event) {
            return {
              type: 'FORWARD_TO_PLUGIN',
              event: {
                type: 'DO_MAKE_CALL',
                target: event.dialUri,
                referId: "",
                instanceId: Array.from(context.idlePlugins).sort(function (a, b) {
                  return a - b;
                })[0]
              }
            };
          }),
          cond: function cond(context) {
            return context.idlePlugins.size > 0;
          }
        }, {
          target: undefined
        } // consume
        ],
        START_CAPTURE: {
          actions: 'notifyStartMediaCapture'
        },
        STOP_CAPTURE: {
          actions: 'notifyStopMediaCapture'
        },
        SUSPEND_CAPTURE: {
          actions: 'notifySuspendMediaCapture'
        },
        RESUME_CAPTURE: {
          actions: 'notifyResumeMediaCapture'
        },
        CALL_STATE_ERROR: {
          actions: 'notifyCallStateErrorAction'
        },
        DO_REGISTER: {
          actions: [/*#__PURE__*/assign({
            sipserver: function sipserver(context, event) {
              return event.sipserver;
            }
          }), /*#__PURE__*/forwardTo$1('masterPlugin')]
        },
        DO_UNREGISTER: {
          actions: [/*#__PURE__*/send$1(function (context, event) {
            return {
              type: 'UNSUBSCRIBE',
              removeToken: event.removeToken
            };
          }, {
            to: 'masterPlugin'
          }), /*#__PURE__*/forwardTo$1('masterPlugin')]
        },
        // call commands
        FORWARD_TO_PLUGIN: [{
          actions: /*#__PURE__*/send$1(function (context, event) {
            return event.event;
          }, {
            to: 'masterPlugin'
          }),
          cond: function cond(context, event) {
            return event.event.instanceId == 0;
          }
        }, {
          actions: /*#__PURE__*/send$1(function (context, event) {
            return event.event;
          }, {
            to: 'helperPlugin1'
          }),
          cond: function cond(context, event) {
            return event.event.instanceId == 1;
          }
        }, {
          actions: /*#__PURE__*/send$1(function (context, event) {
            return event.event;
          }, {
            to: 'helperPlugin2'
          }),
          cond: function cond(context, event) {
            return event.event.instanceId == 2;
          }
        }, {
          actions: /*#__PURE__*/send$1(function (context, event) {
            return event.event;
          }, {
            to: 'helperPlugin3'
          }),
          cond: function cond(context, event) {
            return event.event.instanceId == 3;
          }
        }, {
          actions: /*#__PURE__*/send$1(function (context, event) {
            return event.event;
          }, {
            to: 'srPlugin'
          }),
          cond: function cond(context, event) {
            return event.event.instanceId == 4;
          }
        }],
        // call states
        CALL_STATE_IDLE: {
          actions: [/*#__PURE__*/assign({
            idlePlugins: function idlePlugins(context, event) {
              return event.instanceId < 4 ? context.idlePlugins.add(event.instanceId) : context.idlePlugins;
            }
          }), /*#__PURE__*/assign({
            idleSrPlugins: function idleSrPlugins(context, event) {
              return event.instanceId >= 4 ? context.idleSrPlugins.add(event.instanceId) : context.idleSrPlugins;
            }
          }), 'notifyCallStateIdleAction']
        },
        CALL_STATE_DEEP_IDLE: [{
          // make sure all calls are idle
          target: 'reconnecting',
          cond: 'canReconnect'
        }, {
          actions: 'notifyCallStateDeepIdleAction'
        }],
        CALL_STATE_TRYING_OUT: {
          actions: ['setPluginBusyAction', 'notifyCallStateTryingOutAction']
        },
        CALL_STATE_CALLING_OUT: {
          actions: 'notifyCallStateCallingOutAction'
        },
        CALL_STATE_RINGING_OUT: {
          actions: 'notifyCallStateRingingOutAction'
        },
        CALL_STATE_PROCEEDING_OUT: {
          actions: 'notifyCallStateProceedingOutAction'
        },
        CALL_STATE_PROGRESS_OUT: {
          actions: 'notifyCallStateProgressOutAction'
        },
        CALL_STATE_CONNECTING: {
          actions: 'notifyCallStateConnectingAction'
        },
        CALL_STATE_CONNECTED: {
          actions: 'notifyCallStateConnectedAction'
        },
        CALL_STATE_HANGINGUP: {
          actions: 'notifyCallStateHangingUpAction'
        },
        CALL_STATE_ONHOLD: {
          actions: 'notifyCallStateOnHoldAction'
        },
        CALL_STATE_INCOMING_CALL: {
          actions: ['setPluginBusyAction', 'handleCallStateIncomingCallAction']
        },
        CALL_STATE_DO_XFERRING: {
          actions: 'handleCallStateXferringtAction'
        },
        HANDLE_REFER: {
          actions: 'handleReferAction'
        },
        DO_BLIND_XFER_FAILED: {
          actions: 'notifyBlindXferFailedAction'
        },
        DO_BLIND_XFER_SUCCEEDED: {
          actions: 'notifyBlindXferSucceededAction'
        },
        DO_XFER_FAILED: {
          actions: 'notifyXferFailedAction'
        },
        DO_XFER_SUCCEEDED: {
          actions: 'notifyXferSucceededAction'
        },
        // media
        MEDIA_ON_LOCAL_STREAM: {
          actions: 'notifyMediaOnLocalStreamAction'
        },
        MEDIA_ON_REMOTE_STREAM: {
          actions: 'notifyMediaOnRemoteStreamAction'
        },
        SLOWLINK: {
          actions: 'notifySlowLinkAction'
        },
        ON_STATS_UPDATED: {
          actions: 'notifyOnStatsUpdatedAction'
        },
        REQUEST_TO_RECONNECT: [{
          // make sure all calls are idle
          target: 'reconnecting',
          cond: function cond(context) {
            return context.idlePlugins.size == 4 && context.idleSrPlugins.size == 1;
          }
        }, {
          actions: /*#__PURE__*/assign({
            serverRequestToReconnect: function serverRequestToReconnect() {
              return true;
            }
          }),
          cond: function cond(context) {
            return context.idlePlugins.size < 4 || context.idleSrPlugins.size < 1;
          }
        }]
      }
    },
    destroyed: {
      always: 'inactive'
    }
  }
}, {
  guards: {
    canReconnect: function canReconnect(context, event) {
      return context.serverRequestToReconnect && context.idlePlugins.size == 4 && context.idleSrPlugins.size == 1;
    }
  },
  actions: {
    logEvent: function logEvent(context, event) {
      Janus.log("!!! Context: ", context);
      Janus.log("!!! Event: ", event);
    },
    onJanusSessionStoppedAction: function onJanusSessionStoppedAction(context, event) {
      if (event.type === "xstate.init") return;
      context.endpointView.onEndpointDisconnected(event.message);
    },
    onJanusSessionReconnectingAction: function onJanusSessionReconnectingAction(context, event) {
      context.endpointView.onEndpointReconnecting();
    },
    onJanusSessionStartedAction: function onJanusSessionStartedAction(context, event) {
      var plugins = [];
      if (_sessionService.state.children.masterPlugin !== undefined) plugins.push(_sessionService.state.children.masterPlugin);
      if (_sessionService.state.children.helperPlugin1 !== undefined) plugins.push(_sessionService.state.children.helperPlugin1);
      if (_sessionService.state.children.helperPlugin2 !== undefined) plugins.push(_sessionService.state.children.helperPlugin2);
      if (_sessionService.state.children.helperPlugin3 !== undefined) plugins.push(_sessionService.state.children.helperPlugin3);
      if (_sessionService.state.children.srPlugin !== undefined) plugins.push(_sessionService.state.children.srPlugin);

      var _loop = function _loop() {
        var plugin = _plugins[_i];
        var instanceId = plugin.state.context.instanceId;
        if (plugin.listeners.size >= 4) return "break";
        plugin.listeners.add(function (state) {
          if (state.history === undefined) Janus.log("Machine plugin(", instanceId, ") state change: ", state.history, "-->", state.value, ", event: ", state.event);else Janus.log("Machine plugin(", instanceId, ") state change: ", state.history.value, "-->", state.value, ", event: ", state.event);
        });
      };

      for (var _i = 0, _plugins = plugins; _i < _plugins.length; _i++) {
        var _ret = _loop();

        if (_ret === "break") break;
      }

      context.endpointView.onEndpointConnected();
    },
    onJanusSessionErrorAction: function onJanusSessionErrorAction(context, event) {// nothing
    },
    stopJanusSessionAction: function stopJanusSessionAction(context, event) {
      context.janusSession.destroy();
    },
    onMasterPluginError: function onMasterPluginError(context, error) {},
    notifyRegistrationFailedAction: function notifyRegistrationFailedAction(context, event) {
      if (context.endpointView.lineView) {
        context.endpointView.lineView.onRegistrationError(event.error);
      }
    },
    notifyRetryingRegistrationAction: function notifyRetryingRegistrationAction(context, event) {
      if (context.endpointView.lineView) {
        context.endpointView.lineView.onRegistrationTrying();
      }
    },
    notifyTryingUnregistrationAction: function notifyTryingUnregistrationAction(context, event) {
      if (context.endpointView.lineView) {
        context.endpointView.lineView.onUnregistrationTrying();
      }
    },
    notifyUnregisteredAction: function notifyUnregisteredAction(context, event) {
      if (context.endpointView.lineView) {
        context.endpointView.lineView.onUnregistered();
      }
    },
    notifyRegisteredAction: function notifyRegisteredAction(context, event) {
      if (context.endpointView.lineView && event.instanceId == 0) {
        context.endpointView.lineView.onRegistered(event.displayName);
      }
    },
    notifyMwiAction: function notifyMwiAction(context, event) {
      if (context.endpointView.lineView) {
        context.endpointView.lineView.onMwiStatusChange(event.mwi);
      }
    },
    cancelPendingCallAction: function cancelPendingCallAction(context, event) {
      if (context.endpointView.lineView) {
        context.endpointView.lineView.onPendingCallCanceled(event.callId);
      }
    },
    notifyCallStateErrorAction: function notifyCallStateErrorAction(context, event) {
      if (context.endpointView.lineView) {
        context.endpointView.lineView.onCallStatusError(event.instanceId, event.errorCode, event.errorMessage);
      }
    },
    notifyCallStateIdleAction: function notifyCallStateIdleAction(context, event) {
      if (context.endpointView.lineView) {
        context.endpointView.lineView.onCallStatusIdle(event.instanceId, event.code, event.reason);
      }
    },
    notifyCallStateDeepIdleAction: function notifyCallStateDeepIdleAction(context, event) {
      if (context.endpointView.lineView) {
        context.endpointView.lineView.onCallStatusDeepIdle(event.instanceId);
      }
    },
    notifyCallStateTryingOutAction: function notifyCallStateTryingOutAction(context, event) {},
    notifyCallStateCallingOutAction: function notifyCallStateCallingOutAction(context, event) {
      if (context.endpointView.lineView) {
        if (event.callId) context.endpointView.lineView.onCallIdUpdate(event.instanceId, event.callId);
        context.endpointView.lineView.onCallStatusChange(event.instanceId, 'callingOut', undefined, event.remoteUri);
      }
    },
    notifyCallStateRingingOutAction: function notifyCallStateRingingOutAction(context, event) {
      if (context.endpointView.lineView) {
        context.endpointView.lineView.onCallStatusChange(event.instanceId, 'ringingOut', undefined, event.remoteUri, event.remoteDisplay);
      }
    },
    notifyCallStateProceedingOutAction: function notifyCallStateProceedingOutAction(context, event) {
      if (context.endpointView.lineView) {
        context.endpointView.lineView.onCallStatusChange(event.instanceId, 'ringingOut');
      }
    },
    notifyCallStateProgressOutAction: function notifyCallStateProgressOutAction(context, event) {
      if (context.endpointView.lineView) {
        context.endpointView.lineView.onCallStatusChange(event.instanceId, 'progressOut', undefined, event.remoteUri, event.remoteDisplay);
      }
    },
    notifyCallStateConnectingAction: function notifyCallStateConnectingAction(context, event) {},
    notifyCallStateConnectedAction: function notifyCallStateConnectedAction(context, event) {
      if (context.endpointView.lineView) {
        var media_caps = {
          hasLocalAudio: event.hasLocalAudio,
          hasRemoteAudio: event.hasRemoteAudio,
          hasLocalVideo: event.hasLocalVideo,
          hasRemoteVideo: event.hasRemoteVideo,
          enabledVideoSource: event.enabledVideoSource
        };
        context.endpointView.lineView.onCallStatusChange(event.instanceId, event.isInitial ? 'connected' : 'reconnected', undefined, // call state desc
        event.remoteUri, event.remoteDisplay, media_caps);
      }
    },
    notifyCallStateHangingUpAction: function notifyCallStateHangingUpAction(context, event) {},
    notifyCallStateOnHoldAction: function notifyCallStateOnHoldAction(context, event) {
      if (context.endpointView.lineView) {
        var media_caps = {
          hasLocalAudio: event.hasLocalAudio,
          hasRemoteAudio: event.hasRemoteAudio,
          hasLocalVideo: event.hasLocalVideo,
          hasRemoteVideo: event.hasRemoteVideo,
          enabledVideoSource: event.enabledVideoSource
        };
        context.endpointView.lineView.onCallStatusChange(event.instanceId, 'hold', undefined, // call state desc
        undefined, // remte uri
        undefined, // remote display
        media_caps);
      }
    },
    setPluginBusyAction: function setPluginBusyAction(context, event) {
      if (event.instanceId < 4) context.idlePlugins["delete"](event.instanceId);else context.idleSrPlugins["delete"](event.instanceId);
    },
    handleCallStateIncomingCallAction: function handleCallStateIncomingCallAction(context, event) {
      if (event.replaces) {
        // handle replaces without user input
        Janus.log("Replaces incoming call, replaces sip-call-id", event.replaces);
        var replaces_plugin = null;
        var replacing_plugin = null;

        for (var _iterator15 = _createForOfIteratorHelperLoose(_sessionService.children.values()), _step15; !(_step15 = _iterator15()).done;) {
          var value = _step15.value;

          if (value.state.context.instanceId == event.instanceId) {
            replacing_plugin = value;
            break;
          }
        }

        for (var _iterator16 = _createForOfIteratorHelperLoose(_sessionService.children.values()), _step16; !(_step16 = _iterator16()).done;) {
          var _value = _step16.value;

          if (_value.state.children.callControl.state.context.sip_call_id === event.replaces) {
            replaces_plugin = _value;
            break;
          }
        }

        if (replaces_plugin !== null && replacing_plugin !== null) {
          Janus.log("Replaces instance ID:", replaces_plugin.state.context.instanceId);
          Janus.log("Replacing instance ID:", replacing_plugin.state.context.instanceId); // answer replacing call and hangup replaces call

          if (context.endpointView.lineView) {
            context.endpointView.lineView.onCallStatusChange(event.instanceId, 'incomingcallReplaces', undefined, event.callerUsername, event.callerDisplay);

            if (replaces_plugin.state.context.isCallAnswered) {
              JanusAnswerCall(event.instanceId);
              JanusHangupCall(replaces_plugin.state.context.instanceId);
            } else {
              //JanusHangupCall(replaces_plugin.state.context.instanceId);
              if (event.callId) context.endpointView.lineView.onCallIdUpdate(event.instanceId, event.callId);
            }
          }
        } else {
          Janus.warn("Replaces call-id: ", event.replaces, " doesn't match other session call-id");
          JanusDeclineCall(event.instanceId, 481);
        }
      } else if (context.endpointView.lineView) {
        if (event.callId) context.endpointView.lineView.onCallIdUpdate(event.instanceId, event.callId);
        context.endpointView.lineView.onCallStatusChange(event.instanceId, 'incomingcall', undefined, event.callerUsername, event.callerDisplay);
      }
    },
    notifyMediaOnLocalStreamAction: function notifyMediaOnLocalStreamAction(context, event) {
      if (context.endpointView.lineView) {
        context.endpointView.lineView.onMediaStatusChange(event.instanceId, 'localstream', event.stream);
      }
    },
    notifyMediaOnRemoteStreamAction: function notifyMediaOnRemoteStreamAction(context, event) {
      if (context.endpointView.lineView) {
        context.endpointView.lineView.onMediaStatusChange(event.instanceId, 'remotestream', event.stream);
      }
    },
    notifyOnStatsUpdatedAction: function notifyOnStatsUpdatedAction(context, event) {
      if (context.endpointView.lineView) {
        context.endpointView.lineView.onStatsUpdated(event.instanceId, event.stats);
      }
    },
    notifySlowLinkAction: function notifySlowLinkAction(context, event) {
      if (context.endpointView.lineView) {
        context.endpointView.lineView.onSlowLink(event.instanceId, event.uplink, event.media, event.lost);
      }
    },
    handleReferAction: function handleReferAction(context, event) {
      // find idle plugin
      var idleArr = Array.from(context.idlePlugins).sort(function (a, b) {
        return a - b;
      });

      if (event.instanceId < 4 && idleArr.length > 0) {
        Janus.log("Refer dial to [", event.refer_event.result["refer_to"], "] is to be performed by plugin instance ", idleArr[0]);

        _sessionService.send({
          type: 'FORWARD_TO_PLUGIN',
          event: {
            type: 'DO_MAKE_CALL',
            target: event.refer_event.result["refer_to"],
            referId: event.refer_event.result["refer_id"],
            instanceId: idleArr[0]
          }
        });

        context.endpointView.lineView.onReferHandled(event.instanceId, idleArr[0]);
      } else {
        // reject REFER
        _sessionService.send({
          type: 'FORWARD_TO_PLUGIN',
          event: {
            type: 'DO_REJECT_REFER',
            instanceId: event.instanceId,
            result: event.refer_event.result
          }
        });
      }
    },
    notifyBlindXferFailedAction: function notifyBlindXferFailedAction(context, event) {
      if (context.endpointView.lineView) {
        context.endpointView.lineView.onCallStatusError(event.instanceId, CallStatusErrorCode.ERROR_TRANSFER, event.message);
        context.endpointView.lineView.onCallStatusChange(event.instanceId, 'blindtransferfailed');
      }
    },
    notifyXferFailedAction: function notifyXferFailedAction(context, event) {
      if (context.endpointView.lineView) {
        context.endpointView.lineView.onCallStatusError(event.instanceId, CallStatusErrorCode.ERROR_TRANSFER, event.message);
        context.endpointView.lineView.onCallStatusChange(event.instanceId, 'transferfailed');
      }
    },
    notifyBlindXferSucceededAction: function notifyBlindXferSucceededAction(context, event) {
      if (context.endpointView.lineView) {
        context.endpointView.lineView.onCallStatusChange(event.instanceId, 'blindtransferok');
      }
    },
    notifyXferSucceededAction: function notifyXferSucceededAction(context, event) {
      if (context.endpointView.lineView) {
        context.endpointView.lineView.onCallStatusChange(event.instanceId, 'transferok');
      }
    },
    handleCallStateXferringtAction: function handleCallStateXferringtAction(context, event) {
      if (context.endpointView.lineView) {
        context.endpointView.lineView.onCallStatusChange(event.instanceId, 'transferring');
      }
    },
    notifyStartMediaCapture: function notifyStartMediaCapture(context, event) {
      if (context.endpointView.lineView) {
        context.endpointView.lineView.doStartScreenRecording(event.target, event.callId, event.frameRate, event.screenWidth, event.screenHeight);
      }
    },
    notifyStopMediaCapture: function notifyStopMediaCapture(context, event) {
      if (context.endpointView.lineView) {
        context.endpointView.lineView.doStopScreenRecording();
      }
    },
    notifySuspendMediaCapture: function notifySuspendMediaCapture(context, event) {
      if (!context.endpointView.lineView.srCall) Janus.error('Unable to suspend screen recording (no call)');

      try {
        _sessionService.send({
          type: 'FORWARD_TO_PLUGIN',
          event: {
            type: 'DO_HOLD',
            instanceId: context.endpointView.lineView.srCall.instanceId
          }
        });
      } catch (err) {
        Janus.error('Unable to suspend screen recording', err);
      }
    },
    notifyResumeMediaCapture: function notifyResumeMediaCapture(context, event) {
      if (!context.endpointView.lineView.srCall) Janus.error('Unable to resume screen recording (no call)');

      try {
        _sessionService.send({
          type: 'FORWARD_TO_PLUGIN',
          event: {
            type: 'DO_RESUME',
            instanceId: context.endpointView.lineView.srCall.instanceId
          }
        });
      } catch (err) {
        Janus.error('Unable to resume screen recording', err);
      }
    }
  },
  // Services
  services: {
    sessionControlService: function sessionControlService(context, event) {
      return function (callback, onReceive) {
        try {
          context.error = "";
          context.queuedStop = false;
          context.janusSession = new Janus({
            server: context.janusServer,
            janusServerUsername: context.janusServerUsername,
            janusServerPassword: context.janusServerPassword,
            iceServers: context.iceServers,
            longPollTimeout: 60000,
            // change that to 20000 once the janus service default is set to 15
            success: function success() {
              Janus.log("Janus session created");
              callback('JANUS_SESSION_SUCCESS');
            },
            error: function error(_error) {
              Janus.error("Failed to create Janus session", _error);

              if (_sessionService !== null) {
                context.error = _error.includes("network error") ? "Unable to connect due to a network error" : _error;

                try {
                  _sessionService.send({
                    type: 'JANUS_SESSION_ERROR',
                    message: context.error
                  });
                } catch (error) {
                  // don't care
                  Janus.warn("Error while sending JANUS_SESSION_ERROR:", error.message);
                }
              }
            },
            destroyed: function destroyed() {
              Janus.log("Janus session destroyed");

              _sessionService.send('JANUS_SESSION_DESTROYED');
            }
          });
          callback('JANUS_SESSION_PROGRESS');
        } catch (error) {
          callback({
            type: 'JANUS_SESSION_ERROR',
            message: error.message
          });
        }
      };
    }
  }
});

function JanusActivateSipRegistration(on, sipserver, username, secret, is_ha1_secret, displayName, smTarget) {
  if (_sessionService !== null && on) {
    _sessionService.send({
      type: 'DO_REGISTER',
      sipserver: sipserver,
      username: username,
      secret: secret,
      is_ha1_secret: is_ha1_secret,
      displayName: displayName,
      smTarget: smTarget
    });
  } else if (!on) {
    _sessionService.send('DO_UNREGISTER');
  }
}

function JanusDeactivateSipRegistration(removeToken) {
  _sessionService.send({
    type: 'DO_UNREGISTER',
    removeToken: removeToken
  });
}

function JanusHangupCall(instanceId) {
  if (_sessionService !== null) {
    _sessionService.send({
      type: 'FORWARD_TO_PLUGIN',
      event: {
        type: 'DO_HANGUP',
        instanceId: instanceId
      }
    });
  }
}

function JanusAnswerCall(instanceId) {
  if (_sessionService !== null) {
    _sessionService.send({
      type: 'FORWARD_TO_PLUGIN',
      event: {
        type: 'DO_ACCEPT',
        instanceId: instanceId
      }
    });
  }
}

function JanusDeclineCall(instanceId, code) {
  if (_sessionService !== null) {
    _sessionService.send({
      type: 'FORWARD_TO_PLUGIN',
      event: {
        type: 'DO_DECLINE',
        instanceId: instanceId,
        code: code
      }
    });
  }
}

function JanusCompleteTransfer(instanceId) {
  if (_sessionService !== null) {
    // determine replaces call-id
    var replaces_call_id = "";
    var refer_to = "";

    for (var _iterator17 = _createForOfIteratorHelperLoose(_sessionService.children.values()), _step17; !(_step17 = _iterator17()).done;) {
      var value = _step17.value;

      if (value.state.context.instanceId !== instanceId && !_sessionService.state.context.idlePlugins.has(value.state.context.instanceId)) {
        replaces_call_id = value.state.children.callControl.state.context.sip_call_id;
        refer_to = value.state.children.callControl.state.context.remote_uri;
        break;
      }
    }

    if (!replaces_call_id || !refer_to) {
      _sessionService.send({
        type: 'XFER_FAILED',
        instanceId: instanceId,
        message: 'Consulation call not found'
      });

      return;
    }

    Janus.log("Completing transfer to [", refer_to, "], replaces-call-id [", replaces_call_id, "]");

    _sessionService.send({
      type: 'FORWARD_TO_PLUGIN',
      event: {
        type: 'DO_XFER',
        instanceId: instanceId,
        refer_to: refer_to,
        replaces_call_id: replaces_call_id
      }
    });
  }
}

var endpointView$1;

function lineView() {
  return endpointView$1.lineView;
}

function callView(index) {
  return lineView().calls[index];
}

function getActiveCallView() {
  var lv = lineView();
  return lv.calls[lv.callIndex];
}

var onInit = /*#__PURE__*/takeEvery(initApp, /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(ctx) {
    var onLineStatusChanged, onCallStatusChanged;
    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            onCallStatusChanged = function _onCallStatusChanged() {
              var lv = lineView();
              var calls = lv.calls;
              var tsCalls = calls.map(function (_value, index) {
                return getCall(index);
              });
              ctx.dispatch(callStatusChanged(lv.callIndex, tsCalls));
            };

            onLineStatusChanged = function _onLineStatusChanged() {
              var line = getLine();
              ctx.dispatch(lineStatusChanged(line));
            };

            window.citrixVdaSupport ? console.log('Initialising Janus with Citrix') : console.log('Initialising Janus');
            Janus.init({
              debug: true,
              dependencies: Janus.useDefaultDependencies({
                adapter: adapter$1
              }),
              callback: function callback() {
                endpointView$1 = CreateEndpointView({
                  onEndpointStatusChange: function onEndpointStatusChange() {
                    // add the created call
                    if (lineView() && !selectCall(ctx.getState())) {
                      onCallStatusChanged();
                    }

                    ctx.dispatch(endpointStatusChanged(getEndpoint()));

                    if (getEndpoint().status === 'online') {
                      onLineStatusChanged();
                    }
                  },
                  onLineRequestRegisterFailed: onLineStatusChanged,
                  onLineRequestUregisterFailed: onLineStatusChanged,
                  onLineRegisterRequested: onLineStatusChanged,
                  onLineUnregisterRequested: onLineStatusChanged,
                  onLineRegisterStatusChange: onLineStatusChanged,
                  onMwiStatusChange: onLineStatusChanged,
                  onCallStatusChange: function onCallStatusChange(_sipserver, _username, _errorCode, _errorMessage) {
                    onCallStatusChanged();
                  },
                  onMediaStatusChange: function onMediaStatusChange(_sipserver, _username) {
                    onCallStatusChanged();
                  },
                  onStatsUpdated: function onStatsUpdated(_stats) {
                    onCallStatusChanged();
                  },
                  onSlowAudioUpLink: function onSlowAudioUpLink(_slow) {
                    onCallStatusChanged();
                  },
                  onSlowAudioDownLink: function onSlowAudioDownLink(_slow) {
                    onCallStatusChanged();
                  }
                });
                endpointView$1.init();
              }
            });
            setDefaultAudioConstraints(ctx.getState().janus.mediaConstraint);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());
var connectEndpoint$1 = /*#__PURE__*/takeEvery(connectEndpoint, /*#__PURE__*/function () {
  var _ref3 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(ctx, _ref2) {
    var extension, pin, settings, turnServers, turnUsername, turnPassword, sipRealm, serverUsername, serverPassword;
    return runtime_1.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            extension = _ref2.extension, pin = _ref2.pin;
            settings = selectSettings(ctx.getState()); //const Url = 'https://mobility-dev.ipfx.com:8089/janus'
            //const SipDomain = 'NZVOIP02_001'
            //const TurnServers = ['turn:mobility-dev.ipfx.com:3473?transport=udp','turn:mobility-dev.ipfx.com:3473?transport=tcp']

            turnServers = [];

            if (settings.turnServer != null && settings.turnServer.length > 0) {
              if (settings.turnServerUdpPort !== '') {
                turnServers.push('turn:' + settings.turnServer + ':' + settings.turnServerUdpPort + '?transport=udp');
              }

              if (settings.turnServerTcpPort !== '') {
                turnServers.push('turn:' + settings.turnServer + ':' + settings.turnServerTcpPort + '?transport=tcp');
              }
            }

            turnUsername = settings.turnUsername ? settings.turnUsername : extension;
            turnPassword = settings.turnPassword ? settings.turnPassword : pin;
            sipRealm = settings.sipRealm ? settings.sipRealm : undefined; // empty string, null and undefined --> undefined

            serverUsername = settings.serverUsername ? settings.serverUsername : undefined; // empty string, null and undefined --> undefined

            serverPassword = settings.serverPassword ? settings.serverPassword : undefined; // empty string, null and undefined --> undefined
            // 4 for director

            endpointView$1.doConnect(settings.janus, settings.sipDomain, extension, pin, turnServers, turnUsername, turnPassword, true, null, null, null, 4, sipRealm, serverUsername, serverPassword, null);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x2, _x3) {
    return _ref3.apply(this, arguments);
  };
}());
var connectEndpointGuest$1 = /*#__PURE__*/takeEvery(connectEndpointGuest, /*#__PURE__*/function () {
  var _ref5 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee3(ctx, _ref4) {
    var guestId, guestPasskey, displayName, settings, turnServers, sipRealm;
    return runtime_1.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            guestId = _ref4.guestId, guestPasskey = _ref4.guestPasskey, displayName = _ref4.displayName;
            settings = selectSettings(ctx.getState()); //const TurnServers = ['turn:mobility-dev.ipfx.com:3473?transport=udp','turn:mobility-dev.ipfx.com:3473?transport=tcp']

            turnServers = [];

            if (settings.turnServer != null && settings.turnServer.length > 0) {
              if (settings.turnServerUdpPort !== '') {
                turnServers.push('turn:' + settings.turnServer + ':' + settings.turnServerUdpPort + '?transport=udp');
              }

              if (settings.turnServerTcpPort !== '') {
                turnServers.push('turn:' + settings.turnServer + ':' + settings.turnServerTcpPort + '?transport=tcp');
              }
            }

            sipRealm = settings.sipRealm ? settings.sipRealm : 'guest.ipfx.pbx'; // 4 for director

            endpointView$1.doConnectGuest(settings.janus, turnServers, settings.sipDomain, guestId, guestPasskey, 4, sipRealm, displayName);

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function (_x4, _x5) {
    return _ref5.apply(this, arguments);
  };
}());
var disconnectEndpoint$1 = /*#__PURE__*/takeEvery(disconnectEndpoint, /*#__PURE__*/function () {
  var _ref6 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee4(_ctx) {
    return runtime_1.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            endpointView$1.doDisconnect(undefined);

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function (_x6) {
    return _ref6.apply(this, arguments);
  };
}()); // const register = takeEvery(actions.register, async () => {
//   lineView().doRequestRegister()
// })
// const unregister = takeEvery(actions.unregister, async () => {
//   lineView().doRequestUnregister()
// })

var configureMediaConstraints$1 = /*#__PURE__*/takeEvery(configureMediaConstraints, /*#__PURE__*/function () {
  var _ref7 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee5(_ctx, payload) {
    return runtime_1.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            setDefaultAudioConstraints(payload);

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function (_x7, _x8) {
    return _ref7.apply(this, arguments);
  };
}());
var dial$1 = /*#__PURE__*/takeEvery(dial, /*#__PURE__*/function () {
  var _ref8 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee6(_ctx, payload) {
    return runtime_1.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            getActiveCallView().doMakeCall(payload);

          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function (_x9, _x10) {
    return _ref8.apply(this, arguments);
  };
}());
var hangUp$1 = /*#__PURE__*/takeEvery(hangUp, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee7() {
  return runtime_1.wrap(function _callee7$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          getActiveCallView().doHangup();

        case 1:
        case "end":
          return _context7.stop();
      }
    }
  }, _callee7);
})));
var muteMicrophone$1 = /*#__PURE__*/takeEvery(muteMicrophone, /*#__PURE__*/function () {
  var _ref10 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee8(_ctx, payload) {
    return runtime_1.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            getActiveCallView().doMuteMicrophone(payload);

          case 1:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function (_x11, _x12) {
    return _ref10.apply(this, arguments);
  };
}());
var dtmf$1 = /*#__PURE__*/takeEvery(dtmf, /*#__PURE__*/function () {
  var _ref11 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee9(_ctx, payload) {
    return runtime_1.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            getActiveCallView().doSendDtmf(payload);

          case 1:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function (_x13, _x14) {
    return _ref11.apply(this, arguments);
  };
}());
var answer$1 = /*#__PURE__*/takeEvery(answer, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee10() {
  return runtime_1.wrap(function _callee10$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          getActiveCallView().doAnswer();

        case 1:
        case "end":
          return _context10.stop();
      }
    }
  }, _callee10);
})));
var hold$1 = /*#__PURE__*/takeEvery(hold, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee11() {
  return runtime_1.wrap(function _callee11$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          getActiveCallView().doHold();

        case 1:
        case "end":
          return _context11.stop();
      }
    }
  }, _callee11);
})));
var resume$1 = /*#__PURE__*/takeEvery(resume, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee12() {
  return runtime_1.wrap(function _callee12$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          getActiveCallView().doResume();

        case 1:
        case "end":
          return _context12.stop();
      }
    }
  }, _callee12);
})));
var toggleVideo$1 = /*#__PURE__*/takeEvery(toggleVideo, /*#__PURE__*/function () {
  var _ref15 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee13(_ctx, payload) {
    return runtime_1.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            console.info('toggling video to', payload);
            getActiveCallView().doEnableVideo(payload.enable, payload.videoSource);

          case 2:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));

  return function (_x15, _x16) {
    return _ref15.apply(this, arguments);
  };
}());

function setPtz(ctx, key, payload) {
  var call = selectCall(ctx.getState());

  if (!call.ptz) {
    console.warn(key + " feature is not available");
    return;
  }

  var settings = call.ptz[key];

  if (call.hasLocalVideo && settings && payload >= settings.min && payload <= settings.max) {
    try {
      var _call$localStream, _constraintSet;

      var track = (_call$localStream = call.localStream) == null ? void 0 : _call$localStream.getVideoTracks()[0];
      var constraintSet = (_constraintSet = {}, _constraintSet[key] = payload, _constraintSet);
      track == null ? void 0 : track.applyConstraints({
        advanced: [constraintSet]
      });
    } catch (ex) {
      console.warn("failed to set " + key + " to " + payload, ex);
    }
  }
}

var setVideoPan$1 = /*#__PURE__*/takeEvery(setVideoPan, /*#__PURE__*/function () {
  var _ref16 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee14(ctx, payload) {
    return runtime_1.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            setPtz(ctx, 'pan', payload);

          case 1:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));

  return function (_x17, _x18) {
    return _ref16.apply(this, arguments);
  };
}());
var setVideoTilt$1 = /*#__PURE__*/takeEvery(setVideoTilt, /*#__PURE__*/function () {
  var _ref17 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee15(ctx, payload) {
    return runtime_1.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            setPtz(ctx, 'tilt', payload);

          case 1:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));

  return function (_x19, _x20) {
    return _ref17.apply(this, arguments);
  };
}());
var setVideoZoom$1 = /*#__PURE__*/takeEvery(setVideoZoom, /*#__PURE__*/function () {
  var _ref18 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee16(ctx, payload) {
    return runtime_1.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            setPtz(ctx, 'zoom', payload);

          case 1:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));

  return function (_x21, _x22) {
    return _ref18.apply(this, arguments);
  };
}());
var transfer$1 = /*#__PURE__*/takeEvery(transfer, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee17() {
  return runtime_1.wrap(function _callee17$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          getActiveCallView().doXfer();

        case 1:
        case "end":
          return _context17.stop();
      }
    }
  }, _callee17);
})));
var lineStatusChanged$1 = /*#__PURE__*/takeEvery(lineStatusChanged, /*#__PURE__*/function () {
  var _ref20 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee18(ctx, payload) {
    var line;
    return runtime_1.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            line = payload; // the registration will automatically retry by entering 'registering' state. Wait for 30s and then perform the retry.
            // we don't want to do this when it is forbidden, as the credentials are incorrect.

            if (line.statusError === '403 Forbidden' && line.status === 'registering') {
              console.warn('Incorrect registration credentials. Disconnecting endpoint');
              ctx.dispatch(disconnectEndpoint());
            }

          case 2:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));

  return function (_x23, _x24) {
    return _ref20.apply(this, arguments);
  };
}());
var getCallStats$1 = /*#__PURE__*/takeEvery(getCallStats, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee19() {
  return runtime_1.wrap(function _callee19$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          getActiveCallView().doGetStats();

        case 1:
        case "end":
          return _context19.stop();
      }
    }
  }, _callee19);
})));

function getEndpoint() {
  var _endpointView = endpointView$1,
      canConnect = _endpointView.canConnect,
      canDisconnect = _endpointView.canDisconnect,
      status = _endpointView.status,
      statusError = _endpointView.statusError;
  return {
    canConnect: canConnect,
    canDisconnect: canDisconnect,
    status: status,
    statusError: statusError
  };
}

function getLine() {
  var _lineView = lineView(),
      canRequestRegister = _lineView.canRequestRegister,
      canRequestUnregister = _lineView.canRequestUnregister,
      registerStatus = _lineView.registerStatus,
      registerStatusError = _lineView.registerStatusError,
      mwiStatus = _lineView.mwiStatus,
      username = _lineView.username,
      displayName = _lineView.displayName;

  return {
    canRegister: canRequestRegister,
    canUnregister: canRequestUnregister,
    status: registerStatus,
    statusError: registerStatusError,
    mwiStatus: mwiStatus,
    username: username,
    displayName: trimQuotes(displayName)
  };
}

function constructPtzCapability(videoTrack) {
  if (!videoTrack) return undefined;
  var caps = videoTrack.getCapabilities();
  var settings = videoTrack.getSettings();

  if (settings.pan !== undefined || settings.tilt !== undefined || settings.zoom !== undefined) {
    return {
      pan: caps.pan ? _extends({}, caps.pan, {
        current: settings.pan
      }) : undefined,
      tilt: caps.tilt ? _extends({}, caps.tilt, {
        current: settings.tilt
      }) : undefined,
      zoom: caps.zoom ? _extends({}, caps.zoom, {
        current: settings.zoom
      }) : undefined
    };
  }

  return undefined;
}

function getCall(index) {
  var _localStream$getVideo, _ref22, _remoteStream$getVide;

  var _callView = callView(index),
      callId = _callView.callId,
      state = _callView.state,
      statusErrorCode = _callView.statusErrorCode,
      statusErrorDescription = _callView.statusErrorDescription,
      localStream = _callView.localStream,
      remoteStream = _callView.remoteStream,
      canMakeCall = _callView.canMakeCall,
      canRingOut = _callView.canRingOut,
      canHangup = _callView.canHangup,
      canAnswer = _callView.canAnswer,
      answerRequested = _callView.answerRequested,
      featureHoldResume = _callView.featureHoldResume,
      canHold = _callView.canHold,
      canResume = _callView.canResume,
      canBlindXfer = _callView.canBlindXfer,
      canXfer = _callView.canXfer,
      canSendDtmf = _callView.canSendDtmf,
      isMuted = _callView.isMuted,
      videoSource = _callView.videoSource,
      peerUsername = _callView.peerUsername,
      peerDisplay = _callView.peerDisplay,
      stats = _callView.stats,
      canPlayBusyTone = _callView.canPlayBusyTone,
      canPlayReorderTone = _callView.canPlayReorderTone,
      canPlayNuTone = _callView.canPlayNuTone,
      lastHangupCode = _callView.lastHangupCode,
      isSlowAudioDownlink = _callView.isSlowAudioDownlink,
      isSlowAudioUplink = _callView.isSlowAudioUplink; // we're overriding this because because


  var videoTrack = (localStream == null ? void 0 : (_localStream$getVideo = localStream.getVideoTracks()) == null ? void 0 : _localStream$getVideo.length) > 0 ? localStream.getVideoTracks()[0] : null;
  var hasRemoteVideo = (_ref22 = (remoteStream == null ? void 0 : (_remoteStream$getVide = remoteStream.getVideoTracks()) == null ? void 0 : _remoteStream$getVide.length) > 0) != null ? _ref22 : false;
  var hasLocalVideo = videoTrack != null;
  var ptz = constructPtzCapability(videoTrack);
  return {
    callId: callId,
    status: state,
    statusErrorCode: statusErrorCode,
    statusErrorDescription: statusErrorDescription == null ? undefined : typeof statusErrorDescription === 'object' ? JSON.stringify(statusErrorDescription) : statusErrorDescription,
    localStream: localStream,
    remoteStream: remoteStream,
    canDial: canMakeCall,
    canRingOut: canRingOut,
    canHangUp: canHangup,
    canAnswer: canAnswer,
    answerRequested: answerRequested,
    featureHoldResume: featureHoldResume,
    canHold: canHold,
    canResume: canResume,
    canBlindXfer: canBlindXfer,
    canXfer: canXfer,
    canSendDtmf: canSendDtmf,
    isMuted: isMuted,
    hasRemoteVideo: hasRemoteVideo,
    hasLocalVideo: hasLocalVideo,
    videoSource: videoSource,
    ptz: ptz,
    peerUsername: peerUsername,
    peerDisplayName: trimQuotes(peerDisplay),
    canPlayBusyTone: canPlayBusyTone,
    canPlayReorderTone: canPlayReorderTone,
    canPlayNuTone: canPlayNuTone,
    lastHangupCode: lastHangupCode,
    isSlowAudioDownlink: isSlowAudioDownlink,
    isSlowAudioUplink: isSlowAudioUplink,
    stats: stats,
    isScreenSharing: function isScreenSharing() {
      return hasLocalVideo && (videoSource === 'window' || videoSource === 'screen');
    }
  };
}

var janus$1 = /*#__PURE__*/all(onInit, connectEndpoint$1, connectEndpointGuest$1, disconnectEndpoint$1, // register,
// unregister,
configureMediaConstraints$1, dial$1, hangUp$1, muteMicrophone$1, dtmf$1, answer$1, hold$1, resume$1, toggleVideo$1, setVideoPan$1, setVideoTilt$1, setVideoZoom$1, transfer$1, lineStatusChanged$1, getCallStats$1);
var TrimQuotesRegExp = /^"|"$/g;

function trimQuotes(peerDisplay) {
  return String(peerDisplay).replace(TrimQuotesRegExp, '');
}

function script(_x) {
  return _script.apply(this, arguments);
}

function _script() {
  _script = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(ctx) {
    var onIncomingCall, script, ac, action, state, call, _ac, _ac2;

    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            onIncomingCall = new URLSearchParams(window.location.search).get('onIncomingCall');

            if (onIncomingCall) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return");

          case 3:
            _context.prev = 3;
            script = parseScript(onIncomingCall, ctx.dispatch);
            _context.next = 11;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](3);
            console.error(_context.t0);
            return _context.abrupt("return");

          case 11:
            _context.next = 13;
            return ctx.takeAny();

          case 13:
            action = _context.sent;
            state = ctx.getState();

            switch (action.type) {
              case getType(callStatusChanged):
                {
                  call = selectCall(state);

                  if (call && call.canAnswer && !call.answerRequested) {
                    (_ac = ac) == null ? void 0 : _ac.abort();
                    ac = new AbortController(); // forking (without await)

                    run(script, ac.signal);
                  } else if (call.status === 'idle') {
                    (_ac2 = ac) == null ? void 0 : _ac2.abort();
                  }
                }
            }

          case 16:
            _context.next = 11;
            break;

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 7]]);
  }));
  return _script.apply(this, arguments);
}

function parseScript(script, dispatch) {
  return script.split(',').map(function (cmd) {
    switch (cmd[0]) {
      case 'a':
        return function () {
          return dispatch(answer());
        };

      case 'w':
        return function () {
          return delay(parseInt(cmd.substr(1)));
        };

      case 'h':
        return function () {
          return dispatch(hold());
        };

      case 'r':
        return function () {
          return dispatch(resume());
        };

      case 'u':
        return function () {
          return dispatch(hangUp());
        };
    }

    throw new Error('Unable to parse: ' + cmd);
  });
}

function run(_x2, _x3) {
  return _run.apply(this, arguments);
}

function _run() {
  _run = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(script, signal) {
    var _iterator, _step, cmd;

    return runtime_1.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _iterator = _createForOfIteratorHelperLoose(script);

          case 1:
            if ((_step = _iterator()).done) {
              _context2.next = 9;
              break;
            }

            cmd = _step.value;

            if (!signal.aborted) {
              _context2.next = 5;
              break;
            }

            return _context2.abrupt("return");

          case 5:
            _context2.next = 7;
            return cmd();

          case 7:
            _context2.next = 1;
            break;

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _run.apply(this, arguments);
}

function delay(ms) {
  return new Promise(function (resolve) {
    window.setTimeout(function () {
      return resolve();
    }, ms);
  });
}

var index = /*#__PURE__*/all(janus$1, script);

function useSelector(selector, equalityFn) {
  return useSelector$1(selector, equalityFn);
}

var css = {"app":"WebRtcClient-module_app__22wH-","settings":"WebRtcClient-module_settings__3fAdw","register":"WebRtcClient-module_register__2i_VU","error":"WebRtcClient-module_error__7evte","logout":"WebRtcClient-module_logout__3RYCu"};

function Audio() {
  var audioRef = useRef(null);
  var call = useSelector(selectCall);
  useEffect(function () {
    if (!audioRef.current) {
      return;
    }

    try {
      var _call$remoteStream;

      audioRef.current.srcObject = (_call$remoteStream = call.remoteStream) != null ? _call$remoteStream : null;
    } catch (err) {
      console.error('failed to set srcObject for call', call.remoteStream, err);
    }
  }, [call.remoteStream]);
  return React__default.createElement("audio", {
    id: 'remoteAudio',
    autoPlay: true,
    loop: true,
    ref: audioRef
  });
}

var css$1 = {"connectScreen":"ConnectScreen-module_connectScreen__2a2TX","status":"ConnectScreen-module_status__2rUfy","error":"ConnectScreen-module_error__2SB_R"};

function ConnectScreen(props) {
  var _useState = useState(false),
      triedAutoConnect = _useState[0],
      setTriedAutoConnect = _useState[1];

  var _useState2 = useState(props.extension),
      extension = _useState2[0],
      setExtension = _useState2[1];

  var _useState3 = useState(props.pin),
      pin = _useState3[0],
      setPin = _useState3[1];

  var endpoint = useSelector(selectEndpoint);
  var line = useSelector(selectLine);
  var dispatch = useDispatch();
  useEffect(function () {
    return setPin(props.pin);
  }, [props.pin]);
  useEffect(function () {
    return setExtension(props.extension);
  }, [props.extension]); //if offline and password is passed in the props

  useEffect(function () {
    if (!props.enabled) return;

    if (!triedAutoConnect && props.extension && props.pin && endpoint.status === 'offline' && endpoint.canConnect) {
      console.log('Auto connecting account using temp password');
      setTriedAutoConnect(true);
      dispatch(connectEndpoint(props.extension, props.pin));
      setPin(undefined);
    }

    if (props.pin == null || props.pin.length === 0) {
      setTriedAutoConnect(false);
    }
  }, [dispatch, endpoint.canConnect, endpoint.status, props.extension, props.pin, triedAutoConnect, props.enabled]);
  useEffect(function () {
    if (line.statusError === '403 Forbidden' && line.status === 'registering') {
      setPin('');
    }
  }, [line.statusError, line.status]);
  useEffect(function () {
    if (!props.enabled && endpoint.canDisconnect) {
      console.log('Softphone is being disabled, disconnecting...');
      dispatch(disconnectEndpoint());
    }

    if (!props.enabled) {
      // unset so we can retry next time it gets enabled
      setTriedAutoConnect(false);
    }
  }, [dispatch, endpoint.canDisconnect, props.enabled]);

  function onSubmit(e) {
    e.preventDefault();
    if (!pin || !extension) return;
    dispatch(connectEndpoint(extension, pin));
  }

  return React__default.createElement("form", {
    autoComplete: 'on',
    className: css$1.connectScreen,
    onSubmit: onSubmit
  }, React__default.createElement("label", null, "Extension #", React__default.createElement("input", {
    value: extension != null ? extension : '',
    onChange: function onChange(e) {
      return setExtension(e.currentTarget.value);
    }
  })), React__default.createElement("label", null, "PIN", React__default.createElement("input", {
    type: 'password',
    value: pin != null ? pin : '',
    onChange: function onChange(e) {
      return setPin(e.currentTarget.value);
    }
  })), React__default.createElement("button", {
    disabled: !endpoint.canConnect || endpoint.status === 'connecting' || !extension || !pin
  }, "Connect"), React__default.createElement("div", {
    className: css$1.status
  }, "Endpoint Status: ", endpoint.status), endpoint.statusError && React__default.createElement("div", {
    className: css$1.error
  }, endpoint.statusError), line.statusError && React__default.createElement("div", {
    className: css$1.error
  }, line.statusError));
}

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _ref2 = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z"
});

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/forwardRef(SvgBack);

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

function _objectWithoutProperties$1(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$1(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _ref2$1 = /*#__PURE__*/createElement("path", {
  className: "icons-unfilled",
  d: "M23.96,19.84c0,0.28-0.06,0.55-0.18,0.8s-0.27,0.47-0.47,0.66s-0.42,0.34-0.68,0.45s-0.52,0.16-0.8,0.16H13.5      c-0.31,0-0.61-0.06-0.89-0.19s-0.53-0.3-0.73-0.54l-3.34-3.9c-0.16-0.18-0.28-0.39-0.36-0.62c-0.09-0.23-0.13-0.47-0.13-0.71      c0-0.24,0.04-0.48,0.13-0.71c0.09-0.23,0.21-0.44,0.37-0.62l3.34-3.89c0.2-0.23,0.44-0.42,0.73-0.54c0.29-0.13,0.59-0.19,0.89-0.19      h8.34c0.28,0,0.55,0.05,0.8,0.16s0.48,0.26,0.68,0.45s0.35,0.41,0.47,0.66s0.18,0.52,0.18,0.8V19.84z M23.04,19.84v-7.8      c0-0.16-0.03-0.3-0.1-0.45s-0.16-0.26-0.27-0.36s-0.24-0.18-0.38-0.24c-0.14-0.06-0.29-0.09-0.45-0.09H13.5      c-0.18,0-0.35,0.04-0.51,0.11c-0.16,0.07-0.3,0.17-0.42,0.31l-3.34,3.9c-0.09,0.1-0.16,0.21-0.2,0.34s-0.07,0.26-0.07,0.39      c0,0.27,0.09,0.51,0.27,0.73l3.34,3.9c0.11,0.14,0.25,0.24,0.42,0.31s0.33,0.11,0.5,0.11h8.34c0.16,0,0.31-0.03,0.45-0.09      c0.14-0.06,0.27-0.14,0.38-0.24s0.2-0.22,0.27-0.36S23.04,19.99,23.04,19.84z M20.3,13.44c0,0.14-0.05,0.25-0.15,0.35l-2.2,2.2      l2.2,2.2c0.1,0.1,0.15,0.22,0.15,0.35c0,0.14-0.05,0.25-0.15,0.35c-0.1,0.1-0.22,0.15-0.35,0.15c-0.13,0-0.25-0.05-0.35-0.14      l-2.2-2.2l-2.2,2.2c-0.1,0.09-0.22,0.14-0.35,0.14c-0.14,0-0.25-0.05-0.35-0.15c-0.1-0.1-0.15-0.22-0.15-0.35      c0-0.13,0.05-0.25,0.15-0.35l2.2-2.2l-2.2-2.2c-0.1-0.1-0.15-0.22-0.15-0.35c0-0.14,0.05-0.25,0.15-0.35      c0.1-0.1,0.22-0.15,0.35-0.15c0.14,0,0.25,0.05,0.35,0.15l2.2,2.2l2.2-2.2c0.1-0.1,0.22-0.15,0.35-0.15s0.25,0.05,0.35,0.15      C20.25,13.19,20.3,13.3,20.3,13.44z"
});

var _ref3 = /*#__PURE__*/createElement("path", {
  className: "icons-filled",
  d: "M23.98,12.06v7.8c0,0.28-0.06,0.55-0.18,0.8s-0.27,0.47-0.47,0.66s-0.42,0.34-0.68,0.45c-0.25,0.11-0.52,0.16-0.8,0.16      h-8.34c-0.31,0-0.61-0.06-0.9-0.19s-0.53-0.3-0.73-0.54l-3.34-3.9c-0.16-0.18-0.28-0.39-0.36-0.62s-0.13-0.47-0.13-0.72      c0-0.25,0.04-0.49,0.13-0.72c0.09-0.23,0.21-0.43,0.37-0.62l3.34-3.89c0.2-0.23,0.44-0.42,0.73-0.54c0.29-0.13,0.59-0.19,0.9-0.19      h8.34c0.28,0,0.55,0.05,0.8,0.16c0.26,0.11,0.48,0.26,0.68,0.45s0.35,0.41,0.47,0.66S23.98,11.77,23.98,12.06z M20.31,13.45      c0-0.14-0.05-0.25-0.15-0.35c-0.1-0.1-0.21-0.15-0.35-0.15c-0.13,0-0.25,0.05-0.35,0.15l-2.2,2.2l-2.2-2.2      c-0.1-0.1-0.22-0.15-0.35-0.15S14.47,13,14.37,13.1c-0.1,0.1-0.15,0.22-0.15,0.35c0,0.14,0.05,0.25,0.15,0.35l2.2,2.19l-2.2,2.2      c-0.1,0.1-0.15,0.22-0.15,0.35s0.05,0.25,0.15,0.35s0.22,0.15,0.35,0.15c0.14,0,0.26-0.05,0.35-0.14l2.2-2.2l2.2,2.2      c0.09,0.09,0.21,0.14,0.35,0.14c0.14,0,0.25-0.05,0.35-0.15c0.1-0.1,0.15-0.22,0.15-0.35s-0.05-0.25-0.15-0.35l-2.2-2.2l2.2-2.19      C20.26,13.71,20.31,13.59,20.31,13.45z"
});

function SvgBackspace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties$1(_ref, ["title", "titleId"]);

  return /*#__PURE__*/createElement("svg", _extends$2({
    viewBox: "0 0 32 32",
    role: "presentation",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/createElement("title", {
    id: titleId
  }, title) : null, _ref2$1, _ref3);
}

var ForwardRef$1 = /*#__PURE__*/forwardRef(SvgBackspace);

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

function _objectWithoutProperties$2(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$2(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$2(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _ref2$2 = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M11,6H13V14L16.5,10.5L17.92,11.92L12,17.84L6.08,11.92L7.5,10.5L11,14V6M12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22M12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20Z"
});

function SvgConnectionDownLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties$2(_ref, ["title", "titleId"]);

  return /*#__PURE__*/createElement("svg", _extends$3({
    style: {
      width: 24,
      height: 24
    },
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/createElement("title", {
    id: titleId
  }, title) : null, _ref2$2);
}

var ForwardRef$2 = /*#__PURE__*/forwardRef(SvgConnectionDownLink);

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

function _objectWithoutProperties$3(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$3(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$3(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _ref2$3 = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M18,11H14.82C14.4,9.84 13.3,9 12,9C10.7,9 9.6,9.84 9.18,11H6C5.67,11 4,10.9 4,9V8C4,6.17 5.54,6 6,6H16.18C16.6,7.16 17.7,8 19,8A3,3 0 0,0 22,5A3,3 0 0,0 19,2C17.7,2 16.6,2.84 16.18,4H6C4.39,4 2,5.06 2,8V9C2,11.94 4.39,13 6,13H9.18C9.6,14.16 10.7,15 12,15C13.3,15 14.4,14.16 14.82,13H18C18.33,13 20,13.1 20,15V16C20,17.83 18.46,18 18,18H7.82C7.4,16.84 6.3,16 5,16A3,3 0 0,0 2,19A3,3 0 0,0 5,22C6.3,22 7.4,21.16 7.82,20H18C19.61,20 22,18.93 22,16V15C22,12.07 19.61,11 18,11M19,4A1,1 0 0,1 20,5A1,1 0 0,1 19,6A1,1 0 0,1 18,5A1,1 0 0,1 19,4M5,20A1,1 0 0,1 4,19A1,1 0 0,1 5,18A1,1 0 0,1 6,19A1,1 0 0,1 5,20Z"
});

function SvgConnectionStatus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties$3(_ref, ["title", "titleId"]);

  return /*#__PURE__*/createElement("svg", _extends$4({
    style: {
      width: 24,
      height: 24
    },
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/createElement("title", {
    id: titleId
  }, title) : null, _ref2$3);
}

var ForwardRef$3 = /*#__PURE__*/forwardRef(SvgConnectionStatus);

function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

function _objectWithoutProperties$4(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$4(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$4(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _ref2$4 = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M13,18H11V10L7.5,13.5L6.08,12.08L12,6.16L17.92,12.08L16.5,13.5L13,10V18M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z"
});

function SvgConnectionUpLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties$4(_ref, ["title", "titleId"]);

  return /*#__PURE__*/createElement("svg", _extends$5({
    style: {
      width: 24,
      height: 24
    },
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/createElement("title", {
    id: titleId
  }, title) : null, _ref2$4);
}

var ForwardRef$4 = /*#__PURE__*/forwardRef(SvgConnectionUpLink);

function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

function _objectWithoutProperties$5(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$5(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$5(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _ref2$5 = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M16,17V14H9V10H16V7L21,12L16,17M14,2A2,2 0 0,1 16,4V6H14V4H5V20H14V18H16V20A2,2 0 0,1 14,22H5A2,2 0 0,1 3,20V4A2,2 0 0,1 5,2H14Z"
});

function SvgLogOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties$5(_ref, ["title", "titleId"]);

  return /*#__PURE__*/createElement("svg", _extends$6({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/createElement("title", {
    id: titleId
  }, title) : null, _ref2$5);
}

var ForwardRef$5 = /*#__PURE__*/forwardRef(SvgLogOut);

function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

function _objectWithoutProperties$6(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$6(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$6(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _ref2$6 = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z"
});

function SvgPhoneDial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties$6(_ref, ["title", "titleId"]);

  return /*#__PURE__*/createElement("svg", _extends$7({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/createElement("title", {
    id: titleId
  }, title) : null, _ref2$6);
}

var ForwardRef$6 = /*#__PURE__*/forwardRef(SvgPhoneDial);

function _extends$8() { _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

function _objectWithoutProperties$7(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$7(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$7(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _ref2$7 = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M17,10.5V7A1,1 0 0,0 16,6H4A1,1 0 0,0 3,7V17A1,1 0 0,0 4,18H16A1,1 0 0,0 17,17V13.5L21,17.5V6.5L17,10.5Z"
});

function SvgPhoneDialVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties$7(_ref, ["title", "titleId"]);

  return /*#__PURE__*/createElement("svg", _extends$8({
    style: {
      width: 24,
      height: 24
    },
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/createElement("title", {
    id: titleId
  }, title) : null, _ref2$7);
}

var ForwardRef$7 = /*#__PURE__*/forwardRef(SvgPhoneDialVideo);

function _extends$9() { _extends$9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }

function _objectWithoutProperties$8(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$8(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$8(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _ref2$8 = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M12,9C10.4,9 8.85,9.25 7.4,9.72V12.82C7.4,13.22 7.17,13.56 6.84,13.72C5.86,14.21 4.97,14.84 4.17,15.57C4,15.75 3.75,15.86 3.5,15.86C3.2,15.86 2.95,15.74 2.77,15.56L0.29,13.08C0.11,12.9 0,12.65 0,12.38C0,12.1 0.11,11.85 0.29,11.67C3.34,8.77 7.46,7 12,7C16.54,7 20.66,8.77 23.71,11.67C23.89,11.85 24,12.1 24,12.38C24,12.65 23.89,12.9 23.71,13.08L21.23,15.56C21.05,15.74 20.8,15.86 20.5,15.86C20.25,15.86 20,15.75 19.82,15.57C19.03,14.84 18.14,14.21 17.16,13.72C16.83,13.56 16.6,13.22 16.6,12.82V9.72C15.15,9.25 13.6,9 12,9Z"
});

function SvgPhoneHangUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties$8(_ref, ["title", "titleId"]);

  return /*#__PURE__*/createElement("svg", _extends$9({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/createElement("title", {
    id: titleId
  }, title) : null, _ref2$8);
}

var ForwardRef$8 = /*#__PURE__*/forwardRef(SvgPhoneHangUp);

function _extends$a() { _extends$a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }

function _objectWithoutProperties$9(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$9(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$9(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _ref2$9 = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M14,19H18V5H14M6,19H10V5H6V19Z"
});

function SvgPhoneHold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties$9(_ref, ["title", "titleId"]);

  return /*#__PURE__*/createElement("svg", _extends$a({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/createElement("title", {
    id: titleId
  }, title) : null, _ref2$9);
}

var ForwardRef$9 = /*#__PURE__*/forwardRef(SvgPhoneHold);

function _extends$b() { _extends$b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }

function _objectWithoutProperties$a(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$a(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$a(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _ref2$a = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M12,19A2,2 0 0,0 10,21A2,2 0 0,0 12,23A2,2 0 0,0 14,21A2,2 0 0,0 12,19M6,1A2,2 0 0,0 4,3A2,2 0 0,0 6,5A2,2 0 0,0 8,3A2,2 0 0,0 6,1M6,7A2,2 0 0,0 4,9A2,2 0 0,0 6,11A2,2 0 0,0 8,9A2,2 0 0,0 6,7M6,13A2,2 0 0,0 4,15A2,2 0 0,0 6,17A2,2 0 0,0 8,15A2,2 0 0,0 6,13M18,5A2,2 0 0,0 20,3A2,2 0 0,0 18,1A2,2 0 0,0 16,3A2,2 0 0,0 18,5M12,13A2,2 0 0,0 10,15A2,2 0 0,0 12,17A2,2 0 0,0 14,15A2,2 0 0,0 12,13M18,13A2,2 0 0,0 16,15A2,2 0 0,0 18,17A2,2 0 0,0 20,15A2,2 0 0,0 18,13M18,7A2,2 0 0,0 16,9A2,2 0 0,0 18,11A2,2 0 0,0 20,9A2,2 0 0,0 18,7M12,7A2,2 0 0,0 10,9A2,2 0 0,0 12,11A2,2 0 0,0 14,9A2,2 0 0,0 12,7M12,1A2,2 0 0,0 10,3A2,2 0 0,0 12,5A2,2 0 0,0 14,3A2,2 0 0,0 12,1Z"
});

function SvgPhoneKeypad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties$a(_ref, ["title", "titleId"]);

  return /*#__PURE__*/createElement("svg", _extends$b({
    style: {
      width: 24,
      height: 24
    },
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/createElement("title", {
    id: titleId
  }, title) : null, _ref2$a);
}

var ForwardRef$a = /*#__PURE__*/forwardRef(SvgPhoneKeypad);

function _extends$c() { _extends$c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }

function _objectWithoutProperties$b(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$b(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$b(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _ref2$b = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M12,2A3,3 0 0,1 15,5V11A3,3 0 0,1 12,14A3,3 0 0,1 9,11V5A3,3 0 0,1 12,2M19,11C19,14.53 16.39,17.44 13,17.93V21H11V17.93C7.61,17.44 5,14.53 5,11H7A5,5 0 0,0 12,16A5,5 0 0,0 17,11H19Z"
});

function SvgPhoneMicrophone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties$b(_ref, ["title", "titleId"]);

  return /*#__PURE__*/createElement("svg", _extends$c({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/createElement("title", {
    id: titleId
  }, title) : null, _ref2$b);
}

var ForwardRef$b = /*#__PURE__*/forwardRef(SvgPhoneMicrophone);

function _extends$d() { _extends$d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }

function _objectWithoutProperties$c(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$c(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$c(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _ref2$c = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M19,11C19,12.19 18.66,13.3 18.1,14.28L16.87,13.05C17.14,12.43 17.3,11.74 17.3,11H19M15,11.16L9,5.18V5A3,3 0 0,1 12,2A3,3 0 0,1 15,5V11L15,11.16M4.27,3L21,19.73L19.73,21L15.54,16.81C14.77,17.27 13.91,17.58 13,17.72V21H11V17.72C7.72,17.23 5,14.41 5,11H6.7C6.7,14 9.24,16.1 12,16.1C12.81,16.1 13.6,15.91 14.31,15.58L12.65,13.92L12,14A3,3 0 0,1 9,11V10.28L3,4.27L4.27,3Z"
});

function SvgPhoneMicrophoneMuted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties$c(_ref, ["title", "titleId"]);

  return /*#__PURE__*/createElement("svg", _extends$d({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/createElement("title", {
    id: titleId
  }, title) : null, _ref2$c);
}

var ForwardRef$c = /*#__PURE__*/forwardRef(SvgPhoneMicrophoneMuted);

function _extends$e() { _extends$e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }

function _objectWithoutProperties$d(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$d(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$d(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _ref2$d = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M8,5.14V19.14L19,12.14L8,5.14Z"
});

function SvgPhoneResume(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties$d(_ref, ["title", "titleId"]);

  return /*#__PURE__*/createElement("svg", _extends$e({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/createElement("title", {
    id: titleId
  }, title) : null, _ref2$d);
}

var ForwardRef$d = /*#__PURE__*/forwardRef(SvgPhoneResume);

function _extends$f() { _extends$f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }

function _objectWithoutProperties$e(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$e(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$e(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _ref2$e = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M11,6.82H1.7V17.41H20.63V12.13l1.61-1.73v7.51A1.11,1.11,0,0,1,21.14,19H12.77v1.67H15.6a1.09,1.09,0,0,1,1.11,1.08v1.09H5.54V21.77a1.08,1.08,0,0,1,1.1-1.08H9.46V19H1.11A1.11,1.11,0,0,1,0,17.91V6.29A1.16,1.16,0,0,1,1.11,5.12H13A9.1,9.1,0,0,0,11,6.82Z",
  transform: "translate(0 -1)"
});

var _ref3$1 = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M24,6.79l-5.79,5.79V9.19c-4.14,0-7,1.33-9,4.22.83-4.14,3.26-8.27,9.05-9.1V1Z",
  transform: "translate(0 -1)"
});

function SvgPhoneShareScreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties$e(_ref, ["title", "titleId"]);

  return /*#__PURE__*/createElement("svg", _extends$f({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: 24,
      height: 24
    },
    viewBox: "0 0 24 21.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/createElement("title", {
    id: titleId
  }, title) : null, _ref2$e, _ref3$1);
}

var ForwardRef$e = /*#__PURE__*/forwardRef(SvgPhoneShareScreen);

function _extends$g() { _extends$g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }

function _objectWithoutProperties$f(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$f(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$f(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _ref2$f = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M17,10.5V7A1,1 0 0,0 16,6H4A1,1 0 0,0 3,7V17A1,1 0 0,0 4,18H16A1,1 0 0,0 17,17V13.5L21,17.5V6.5L17,10.5Z"
});

function SvgPhoneVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties$f(_ref, ["title", "titleId"]);

  return /*#__PURE__*/createElement("svg", _extends$g({
    style: {
      width: 24,
      height: 24
    },
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/createElement("title", {
    id: titleId
  }, title) : null, _ref2$f);
}

var ForwardRef$f = /*#__PURE__*/forwardRef(SvgPhoneVideo);

var css$2 = {"buttons":"InCallControl-module_buttons__2rwFd","active":"InCallControl-module_active__2RCmG","callButtons":"InCallControl-module_callButtons__SF5B_","hangUp":"InCallControl-module_hangUp__2MEXv","keypadDismiss":"InCallControl-module_keypadDismiss__3XESZ"};

function mapAudio(audioObject) {
  if (typeof audioObject === 'object' && audioObject["default"]) {
    return audioObject["default"];
  } else {
    return audioObject;
  }
}

var css$3 = {"dialpad":"Keypad-module_dialpad__1WxWP","disabled":"Keypad-module_disabled__3L8jX","big":"Keypad-module_big__2Adm3"};

function Keypad(props) {
  var audioRef = useRef(null);

  function handleDtmfClick(digit) {
    props.onKeyPressed(digit);

    if (!audioRef.current) {
      return;
    }

    try {
      if (digit === '*') {
        audioRef.current.src = mapAudio(require('./sounds/dtmf-star.mp3'));
      } else if (digit === '#') {
        audioRef.current.src = mapAudio(require('./sounds/dtmf-hash.mp3'));
      } else {
        audioRef.current.src = mapAudio(require("./sounds/dtmf-" + digit + ".mp3"));
      }
    } catch (err) {
      console.error('failed to set dtmf audio for', digit, err);
    }
  }

  function renderButton(digit, footer, bigFooter) {
    if (footer === void 0) {
      footer = null;
    }

    if (bigFooter === void 0) {
      bigFooter = false;
    }

    return React__default.createElement("button", {
      onClick: function onClick() {
        return handleDtmfClick(digit);
      }
    }, digit, React__default.createElement("div", {
      className: classNames(bigFooter && css$3.big)
    }, footer));
  }

  return React__default.createElement("div", {
    className: classNames(props.className, css$3.dialpad)
  }, renderButton('1'), renderButton('2', 'ABC'), renderButton('3', 'DEF'), renderButton('4', 'GHI'), renderButton('5', 'JKL'), renderButton('6', 'MNO'), renderButton('7', 'PQRS'), renderButton('8', 'TUV'), renderButton('9', 'WXYZ'), renderButton('*'), renderButton('0', '+', true), renderButton('#'), React__default.createElement("audio", {
    autoPlay: true,
    ref: audioRef
  }));
}

function isCallConnected(call) {
  return call.status === 'connected' || call.status === 'reconnected';
}

function InCallControl() {
  var dispatch = useDispatch();
  var call = useSelector(selectCall);
  var prevCanDial = useRef(false);

  var _useState = useState(true),
      showDialpad = _useState[0],
      setShowDialpad = _useState[1];

  useEffect(function () {
    if (call.canHangUp) {
      setShowDialpad(false);
    } else if (!call.canDial && prevCanDial.current) {
      setShowDialpad(false);
    } else if (call.canDial && !prevCanDial.current) {
      setShowDialpad(true);
    }

    prevCanDial.current = call.canDial;
  }, [call.canDial, call.canHangUp]);

  function onDigit(digit) {
    if (call.canSendDtmf) {
      dispatch(dtmf(digit));
    }
  }

  function toggleVideo$1(isScreenSharing) {
    dispatch(toggleVideo(!call.hasLocalVideo, isScreenSharing ? 'window' : 'fhdres'));
  }

  return React__default.createElement("div", null, showDialpad ? React__default.createElement("div", null, React__default.createElement(Keypad, {
    onKeyPressed: onDigit
  }), React__default.createElement("button", {
    className: css$2.keypadDismiss,
    onClick: function onClick() {
      return setShowDialpad(false);
    }
  }, React__default.createElement(ForwardRef, null))) : React__default.createElement("div", {
    className: css$2.buttons
  }, React__default.createElement("button", {
    onClick: function onClick() {
      return setShowDialpad(true);
    }
  }, React__default.createElement(ForwardRef$a, null)), React__default.createElement("button", {
    onClick: function onClick() {
      dispatch(muteMicrophone(!call.isMuted));
    },
    className: classNames(call.isMuted && css$2.active)
  }, React__default.createElement(ForwardRef$c, null)), React__default.createElement("button", {
    onClick: function onClick() {
      if (call.canHold) {
        dispatch(hold());
      } else if (call.canResume) {
        dispatch(resume());
      }
    },
    disabled: !call.featureHoldResume || !call.canHold && !call.canResume,
    className: classNames(call.canResume && css$2.active)
  }, React__default.createElement(ForwardRef$9, null)), React__default.createElement("button", {
    onClick: function onClick() {
      return toggleVideo$1(false);
    },
    className: classNames(call.hasLocalVideo && !call.isScreenSharing() && css$2.active),
    disabled: !isCallConnected(call) || call.hasLocalVideo && call.isScreenSharing()
  }, React__default.createElement(ForwardRef$f, null)), React__default.createElement("button", {
    onClick: function onClick() {
      return toggleVideo$1(true);
    },
    className: classNames(call.hasLocalVideo && call.isScreenSharing() && css$2.active),
    disabled: !isCallConnected(call) || call.hasLocalVideo && !call.isScreenSharing()
  }, React__default.createElement(ForwardRef$e, null))), React__default.createElement("div", {
    className: css$2.callButtons
  }, call.canAnswer && React__default.createElement("button", {
    onClick: function onClick() {
      return dispatch(answer());
    }
  }, React__default.createElement(ForwardRef$6, null)), call.canHangUp && React__default.createElement("button", {
    className: css$2.hangUp,
    onClick: function onClick() {
      return dispatch(hangUp());
    }
  }, React__default.createElement(ForwardRef$8, null))));
}

var css$4 = {"phone":"Phone-module_phone__1-ZNG","closeDialpad":"Phone-module_closeDialpad__3AaFb","callButtons":"Phone-module_callButtons__2P_P5","hangUp":"Phone-module_hangUp__2wPhZ","number":"Phone-module_number__3Rjhi","phoneNumber":"Phone-module_phoneNumber__cXeKr","backspace":"Phone-module_backspace___fW_C","statsContainer":"Phone-module_statsContainer__1nfje"};

var css$5 = {"toggle":"MediaConstraintSetup-module_toggle__1qIKB","mediaConstraintsContainer":"MediaConstraintSetup-module_mediaConstraintsContainer__2XUzt","audioQualityContainer":"MediaConstraintSetup-module_audioQualityContainer__3AWzb"};

var css$6 = {"toggle":"Toggle-module_toggle__2VY7s","icon":"Toggle-module_icon__uAP-S","checked":"Toggle-module_checked__2OX0i"};

function Toggle(_ref) {
  var className = _ref.className,
      value = _ref.value,
      onChange = _ref.onChange,
      children = _ref.children,
      disabled = _ref.disabled;
  var onClick = useCallback(function () {
    onChange && onChange(!value);
  }, [value, onChange]);
  return React__default.createElement("button", {
    disabled: disabled,
    className: classNames(css$6.toggle, className, value && css$6.checked),
    onClick: onClick
  }, React__default.createElement("div", {
    className: css$6.icon
  }), children);
}

function MediaConstraintSetup() {
  var mediaConstraints = useSelector(function (s) {
    return s.janus.mediaConstraint;
  });
  var dispatch = useDispatch();

  function input(prop, label, type, inputProps) {
    if (type === void 0) {
      type = 'text';
    }

    return React__default.createElement("label", null, label, React__default.createElement("div", null, React__default.createElement("input", Object.assign({
      type: type,
      value: String(mediaConstraints[prop]),
      onChange: function onChange(e) {
        var _extends2;

        var numberValue = parseInt(e.currentTarget.value);
        dispatch(configureMediaConstraints(_extends({}, mediaConstraints, (_extends2 = {}, _extends2[prop] = numberValue, _extends2))));
      }
    }, inputProps))));
  }

  function toggle(prop, label) {
    return React__default.createElement(Toggle, {
      className: css$5.toggle,
      value: Boolean(mediaConstraints[prop]),
      onChange: function onChange(value) {
        var _extends3;

        return dispatch(configureMediaConstraints(_extends({}, mediaConstraints, (_extends3 = {}, _extends3[prop] = value, _extends3))));
      }
    }, label);
  }

  return React__default.createElement("div", {
    className: css$5.mediaConstraintsContainer
  }, React__default.createElement("div", {
    className: css$5.audioQualityContainer
  }, input('channelCount', 'Channels', 'number', {
    min: 0,
    max: 2,
    step: 1
  }), input('sampleRate', 'Sampling Rate', 'number'), input('sampleSize', 'Bit Depth', 'number', {
    min: 8,
    max: 16,
    step: 8
  })), toggle('autoGainControl', 'Auto Gain Control'), toggle('echoCancellation', 'Echo Cancellation'), toggle('noiseSuppression', 'Noise Supression'));
}

var css$7 = {"display":"PhoneDisplay-module_display__1LlKH","video":"PhoneDisplay-module_video__3lqh7","caller":"PhoneDisplay-module_caller__1A2iz","loggedInUser":"PhoneDisplay-module_loggedInUser__xRRuX","connectionStatusContainer":"PhoneDisplay-module_connectionStatusContainer__jguPZ","connectionStatusIcon":"PhoneDisplay-module_connectionStatusIcon__38XKm","connectionIcon":"PhoneDisplay-module_connectionIcon__1K1il","slow":"PhoneDisplay-module_slow__3jFKt","warning":"PhoneDisplay-module_warning__yWXBt"};

var css$8 = {"videoContainer":"Video-module_videoContainer__OCeFl","remote":"Video-module_remote__KwRFb","local":"Video-module_local__3MERJ"};

function Video(_ref) {
  var className = _ref.className,
      remoteVideoClassName = _ref.remoteVideoClassName,
      localVideoClassName = _ref.localVideoClassName;
  var call = useSelector(selectCall);
  var remoteVideoRef = useCallback(function (element) {
    var _call$remoteStream;

    if (!element) {
      return;
    }

    element.srcObject = (_call$remoteStream = call == null ? void 0 : call.remoteStream) != null ? _call$remoteStream : null;
  }, [call == null ? void 0 : call.remoteStream]);
  var localVideoRef = useCallback(function (element) {
    var _call$localStream;

    if (!element) {
      return;
    }

    element.srcObject = (_call$localStream = call == null ? void 0 : call.localStream) != null ? _call$localStream : null;
  }, [call == null ? void 0 : call.localStream]);
  return React__default.createElement("div", {
    className: classNames(css$8.videoContainer, className)
  }, (call == null ? void 0 : call.hasRemoteVideo) && isCallConnected(call) && React__default.createElement("video", {
    className: classNames(css$8.remote, remoteVideoClassName),
    autoPlay: true,
    ref: remoteVideoRef,
    muted: true
  }), (call == null ? void 0 : call.hasLocalVideo) && isCallConnected(call) && React__default.createElement("video", {
    className: classNames(css$8.local, localVideoClassName),
    autoPlay: true,
    ref: localVideoRef,
    muted: true
  }));
}

var callStatusMap = /*#__PURE__*/new Map();
callStatusMap.set('idle', 'Idling');
callStatusMap.set('incomingcall', 'Incoming Call');
callStatusMap.set('connected', 'Connected');
callStatusMap.set('reconnected', 'Reconnected');
callStatusMap.set('callingOut', 'Calling Out');
callStatusMap.set('ringingOut', 'Ringing Out');
callStatusMap.set('progressOut', 'Progress Out');
callStatusMap.set('hold', 'On Hold');
callStatusMap.set('transferring', 'Transferring');
function PhoneDisplay() {
  var _call$peerDisplayName;

  var line = useSelector(selectLine);
  var call = useSelector(selectCall);
  return React__default.createElement("div", {
    className: css$7.display
  }, React__default.createElement(Video, {
    className: css$7.video
  }), React__default.createElement("div", {
    className: css$7.loggedInUser
  }, "Logged in as ", line.displayName, " - ", line.username), call.status !== 'idle' && React__default.createElement("div", {
    className: css$7.caller
  }, (_call$peerDisplayName = call.peerDisplayName) != null ? _call$peerDisplayName : call.peerUsername, React__default.createElement("div", null, callStatusMap.get(call.status))), call.canDial && React__default.createElement(MediaConstraintSetup, null), call.canHangUp && React__default.createElement("div", {
    className: css$7.connectionStatusContainer
  }, React__default.createElement(ForwardRef$2, {
    className: classNames(css$7.connectionIcon, call.isSlowAudioDownlink && css$7.slow)
  }), React__default.createElement(ForwardRef$3, {
    className: css$7.connectionStatusIcon
  }), React__default.createElement(ForwardRef$4, {
    className: classNames(css$7.connectionIcon, call.isSlowAudioUplink && css$7.slow)
  })));
}

function Phone() {
  var _useState = useState(''),
      number = _useState[0],
      setNumber = _useState[1];

  var inputRef = useRef(null);
  var dispatch = useDispatch();
  var line = useSelector(selectLine);
  var call = useSelector(selectCall);

  var _useState2 = useState(false),
      showStats = _useState2[0];

  useEffect(function () {
    console.log('stats have changed');
  }, [call.stats]);
  useEffect(function () {
    var timeout = setTimeout(function () {
      if (showStats) {
        dispatch(getCallStats());
      }
    }, 100);
    return function () {
      return clearTimeout(timeout);
    };
  });

  function onBackspace() {
    setNumber(number.substr(0, number.length - 1));
  }

  function onDigit(digit) {
    setNumber(function (n) {
      return n + digit;
    });
  }

  function shouldShowInCallControl() {
    if (call == null) {
      return false;
    }

    return call.canHangUp;
  }

  return React__default.createElement("div", {
    className: css$4.phone
  }, React__default.createElement(PhoneDisplay, null), shouldShowInCallControl() ? React__default.createElement(InCallControl, null) : renderDialler(), call.canHangUp && showStats && call.stats != null ? React__default.createElement("div", {
    className: css$4.statsContainer
  }, stringifyStats(call)) : null);

  function renderDialler() {
    return React__default.createElement("div", null, React__default.createElement("div", {
      className: css$4.number
    }, React__default.createElement("input", {
      id: css$4.phoneNumber,
      ref: inputRef,
      value: number,
      onChange: function onChange(e) {
        return setNumber(e.currentTarget.value);
      }
    }), React__default.createElement("button", {
      className: css$4.backspace,
      onClick: onBackspace
    }, React__default.createElement(ForwardRef$1, null))), React__default.createElement(Keypad, {
      onKeyPressed: onDigit
    }), React__default.createElement("div", {
      className: css$4.callButtons
    }, call.canDial && React__default.createElement("button", {
      disabled: !number,
      onClick: function onClick() {
        dispatch(toggleVideo(false));
        dispatch(dial(number));
      }
    }, React__default.createElement(ForwardRef$6, null)), call.canDial && React__default.createElement("button", {
      disabled: !number,
      onClick: function onClick() {
        dispatch(toggleVideo(true, 'fhdres'));
        dispatch(dial(number));
      }
    }, React__default.createElement(ForwardRef$7, null))));
  }

  function stringifyStats(call) {
    if (call.stats == null) return '';
    var statsOutput = "";
    call.stats.forEach(function (report) {
      if (report.type.indexOf('inbound') === -1 && report.type.indexOf('outbound') === -1) return;
      statsOutput += "\r\nReport: " + report.type + "\r\nID: " + report.id + "\r\n" + ("Timestamp: " + report.timestamp + "\r\n"); // Now the statistics for this report; we intentially drop the ones we
      // sorted to the top above

      Object.keys(report).forEach(function (statName) {
        if (statName !== "id" && statName !== "timestamp" && statName !== "type") {
          statsOutput += statName + ": " + report[statName] + "\n";
        }
      });
    });
    return statsOutput;
  }
}

function Ringer() {
  var call = useSelector(selectCall);
  var secondaryRingerDeviceId = useSelector(selectSecondaryRingerDeviceId);
  var setSyncId = useCallback(function (audio) {
    if (!audio) {
      return;
    }

    if (supportsSinkApi(audio)) {
      audio.setSinkId(secondaryRingerDeviceId);
    }
  }, [secondaryRingerDeviceId]);
  return React__default.createElement(React__default.Fragment, null, call.canAnswer ? React__default.createElement("audio", {
    autoPlay: true,
    loop: true,
    src: mapAudio(require('./sounds/incoming-call.wav'))
  }) : null, call.canAnswer && secondaryRingerDeviceId ? React__default.createElement("audio", {
    id: 'secondaryRinger',
    autoPlay: true,
    loop: true,
    src: mapAudio(require('./sounds/incoming-call.wav')),
    ref: setSyncId
  }) : null, call.canRingOut ? React__default.createElement("audio", {
    autoPlay: true,
    loop: true,
    src: mapAudio(require('./sounds/ringback-tone-nz.mp3'))
  }) : null, call.canPlayReorderTone ? React__default.createElement("audio", {
    autoPlay: true,
    loop: true,
    src: mapAudio(require('./sounds/reorder-tone-nz.mp3'))
  }) : null, call.canPlayBusyTone ? React__default.createElement("audio", {
    autoPlay: true,
    loop: true,
    src: mapAudio(require('./sounds/busy-tone-nz.mp3'))
  }) : null, call.canPlayNuTone ? React__default.createElement("audio", {
    autoPlay: true,
    loop: true,
    src: mapAudio(require('./sounds/nu-tone-nz.mp3'))
  }) : null);
}

function supportsSinkApi(audio) {
  return 'setSinkId' in audio;
}

function initCitrixWebRTC() {
  !function (e, r) {
    "object" == typeof exports && "object" == typeof module ? module.exports = r() : "function" == typeof define && define.amd ? define([], r) : "object" == typeof exports ? exports.CitrixWebRTC = r() : e.CitrixWebRTC = r();
  }({}, function () {
    return function (e) {
      var r = {};

      function n(t) {
        if (r[t]) return r[t].exports;
        var i = r[t] = {
          i: t,
          l: !1,
          exports: {}
        };
        return e[t].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
      }

      return n.m = e, n.c = r, n.d = function (e, r, t) {
        n.o(e, r) || Object.defineProperty(e, r, {
          enumerable: !0,
          get: t
        });
      }, n.r = function (e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      }, n.t = function (e, r) {
        if (1 & r && (e = n(e)), 8 & r) return e;
        if (4 & r && "object" == typeof e && e && e.__esModule) return e;
        var t = Object.create(null);
        if (n.r(t), Object.defineProperty(t, "default", {
          enumerable: !0,
          value: e
        }), 2 & r && "string" != typeof e) for (var i in e) {
          n.d(t, i, function (r) {
            return e[r];
          }.bind(null, i));
        }
        return t;
      }, n.n = function (e) {
        var r = e && e.__esModule ? function () {
          return e["default"];
        } : function () {
          return e;
        };
        return n.d(r, "a", r), r;
      }, n.o = function (e, r) {
        return Object.prototype.hasOwnProperty.call(e, r);
      }, n.p = "", n(n.s = "../../../out/shim/sdk/int/sdk/vdiCitrixWebRTC_sdk.js");
    }({
      "../../../out/shim/sdk/int/sdk/audioelement.js":
      /*!**************************************************************************!*\
        !*** E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/audioelement.js ***!
        \**************************************************************************/

      /*! no static exports found */
      function outShimSdkIntSdkAudioelementJs(module, exports, __webpack_require__) {

        eval("\r\nvar __extends = (this && this.__extends) || (function () {\r\n    var extendStatics = function (d, b) {\r\n        extendStatics = Object.setPrototypeOf ||\r\n            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||\r\n            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };\r\n        return extendStatics(d, b);\r\n    }\r\n    return function (d, b) {\r\n        extendStatics(d, b);\r\n        function __() { this.constructor = d; }\r\n        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());\r\n    };\r\n})();\r\nObject.defineProperty(exports, \"__esModule\", { value: true });\r\nvar proxyobject_1 = __webpack_require__(/*! ./proxyobject */ \"../../../out/shim/sdk/int/sdk/proxyobject.js\");\r\nvar lib = __webpack_require__(/*! ./webrpcclassinfo */ \"../../../out/shim/sdk/int/sdk/webrpcclassinfo.js\");\r\nvar logger_1 = __webpack_require__(/*! ./logger */ \"../../../out/shim/sdk/int/sdk/logger.js\");\r\nvar hdxms_1 = __webpack_require__(/*! ./hdxms */ \"../../../out/shim/sdk/int/sdk/hdxms.js\");\r\nvar AudioElement = /** @class */ (function (_super) {\r\n    __extends(AudioElement, _super);\r\n    function AudioElement() {\r\n        var _this = _super.call(this, null, lib.class_id_t.AudioElement, 0, proxyobject_1.ProxyMode.Local) || this;\r\n        _this.sinkId_ = '';\r\n        _this.srcObject_ = null;\r\n        return _this;\r\n    }\r\n    AudioElement.prototype.setSinkId = function (value) {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + '.setSinkId: set sinkId to ' + value);\r\n        return new Promise(function (resolve, reject) {\r\n            _this.waitUntilConnected('AudioElement.sinkId')\r\n                .then(function () {\r\n                var result = _this.remoteInvoke(true, lib.method_id_AudioElement_t.sinkId, value);\r\n                // support backward compatibility with old HdxTeams\r\n                if (!hdxms_1.getRedirector().getFeatureValue(lib.FEATURE_ms_teams_pstn)) {\r\n                    _this.sinkId_ = value;\r\n                    resolve();\r\n                }\r\n                return result;\r\n            })\r\n                .then(function () {\r\n                _this.sinkId_ = value;\r\n                resolve();\r\n            })\r\n                .catch(function () {\r\n                logger_1.logger.log(_this.user_friendly_id() + '.sinkId setter: failed to connect!');\r\n                reject();\r\n            });\r\n        });\r\n    };\r\n    AudioElement.prototype.sinkId = function () {\r\n        return this.sinkId_;\r\n    };\r\n    Object.defineProperty(AudioElement.prototype, \"srcObject\", {\r\n        get: function () {\r\n            return this.srcObject_;\r\n        },\r\n        set: function (value) {\r\n            var _this = this;\r\n            logger_1.logger.log(this.user_friendly_id() + '.srcObject: set srcObject to ' + JSON.stringify(value));\r\n            if (value === this.srcObject_) {\r\n                return;\r\n            }\r\n            var stream = value;\r\n            var remoteValue = ((stream !== null && stream !== undefined) ? stream.object_id() : \"null\");\r\n            this.waitUntilConnected('AudioElement.srcObject')\r\n                .then(function () { return _this.remoteInvoke(true, lib.method_id_AudioElement_t.srcObject, remoteValue); })\r\n                .then(function () {\r\n                _this.srcObject_ = stream;\r\n                if (stream === null) {\r\n                    _this.release();\r\n                }\r\n            })\r\n                .catch(function () {\r\n                logger_1.logger.log(_this.user_friendly_id() + '.srcObject setter: failed to connect!');\r\n                if (stream === null) {\r\n                    _this.release();\r\n                }\r\n            });\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    Object.defineProperty(AudioElement.prototype, \"src\", {\r\n        get: function () {\r\n            return this.src_;\r\n        },\r\n        set: function (value) {\r\n            var _this = this;\r\n            logger_1.logger.log(this.user_friendly_id() + '.src: set src to ' + value);\r\n            this.src_ = value;\r\n            this.waitUntilConnected('AudioElement.src')\r\n                .then(function () { _this.remoteInvoke(true, lib.method_id_AudioElement_t.src, value); })\r\n                .catch(function () { logger_1.logger.log(_this.user_friendly_id() + '.src setter: failed to connect!'); });\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    AudioElement.prototype.play = function () {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + '.play() called.');\r\n        this.waitUntilConnected('AudioElement.play')\r\n            .then(function () { _this.remoteInvoke(false, lib.method_id_AudioElement_t.play, []); })\r\n            .catch(function () { logger_1.logger.log(_this.user_friendly_id() + '.play: failed to connect!'); });\r\n    };\r\n    AudioElement.prototype.pause = function () {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + '.pause() called.');\r\n        this.waitUntilConnected('AudioElement.pause')\r\n            .then(function () { _this.remoteInvoke(false, lib.method_id_AudioElement_t.pause, []); })\r\n            .catch(function () { logger_1.logger.log(_this.user_friendly_id() + '.pause: failed to connect!'); });\r\n    };\r\n    return AudioElement;\r\n}(proxyobject_1.ProxyObject));\r\nexports.AudioElement = AudioElement;\r\n\n\n//# sourceURL=webpack://CitrixWebRTC/E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/audioelement.js?");
      },
      "../../../out/shim/sdk/int/sdk/enginecontrol.js":
      /*!***************************************************************************!*\
        !*** E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/enginecontrol.js ***!
        \***************************************************************************/

      /*! no static exports found */
      function outShimSdkIntSdkEnginecontrolJs(module, exports, __webpack_require__) {

        eval('\r\nvar __extends = (this && this.__extends) || (function () {\r\n    var extendStatics = function (d, b) {\r\n        extendStatics = Object.setPrototypeOf ||\r\n            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||\r\n            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };\r\n        return extendStatics(d, b);\r\n    }\r\n    return function (d, b) {\r\n        extendStatics(d, b);\r\n        function __() { this.constructor = d; }\r\n        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());\r\n    };\r\n})();\r\nObject.defineProperty(exports, "__esModule", { value: true });\r\nvar webrpcclassinfo_1 = __webpack_require__(/*! ./webrpcclassinfo */ "../../../out/shim/sdk/int/sdk/webrpcclassinfo.js");\r\nvar hdxms_1 = __webpack_require__(/*! ./hdxms */ "../../../out/shim/sdk/int/sdk/hdxms.js");\r\nvar proxyobject_1 = __webpack_require__(/*! ./proxyobject */ "../../../out/shim/sdk/int/sdk/proxyobject.js");\r\nvar logger_1 = __webpack_require__(/*! ./logger */ "../../../out/shim/sdk/int/sdk/logger.js");\r\nvar VersionType;\r\n(function (VersionType) {\r\n    VersionType[VersionType["Webrpc"] = 0] = "Webrpc";\r\n    VersionType[VersionType["WebrtcCodecs"] = 1] = "WebrtcCodecs";\r\n    VersionType[VersionType["Receiver"] = 2] = "Receiver";\r\n    VersionType[VersionType["Vda"] = 3] = "Vda";\r\n    VersionType[VersionType["Endpoint"] = 4] = "Endpoint";\r\n    VersionType[VersionType["TypeScript"] = 5] = "TypeScript";\r\n    VersionType[VersionType["Max"] = 6] = "Max";\r\n})(VersionType = exports.VersionType || (exports.VersionType = {}));\r\nvar EngineControl = /** @class */ (function (_super) {\r\n    __extends(EngineControl, _super);\r\n    function EngineControl() {\r\n        return _super.call(this, null, webrpcclassinfo_1.class_id_t.EngineControl, 0, proxyobject_1.ProxyMode.Local) || this;\r\n    }\r\n    EngineControl.prototype.bind = function () {\r\n        logger_1.logger.log(this.user_friendly_id() + \'.bind() called.\');\r\n        this.reconstructor(null, webrpcclassinfo_1.class_id_t.EngineControl, 0);\r\n    };\r\n    // syncBarrier is used because methods on this interface return synchronously and we cant block in JavaScript\r\n    EngineControl.prototype.syncBarrier = function () {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + \'.syncBarrier() called.\');\r\n        return new Promise(function (resolve, reject) {\r\n            _this.waitUntilConnected(\'EngineControl.syncBarrier\')\r\n                .then(function () {\r\n                //release-1905 client\r\n                return Promise.all([\r\n                    _this.remoteInvoke(false, webrpcclassinfo_1.method_id_EngineControl_t.version, { "major": 0, "minor": 0, "revision": 0, "build": 0 }),\r\n                    _this.remoteInvoke(false, webrpcclassinfo_1.method_id_EngineControl_t.feature_flags, [])\r\n                ]);\r\n            })\r\n                .then(function (results) {\r\n                var _a;\r\n                logger_1.logger.log(_this.user_friendly_id() + \'received webrpc version and supported feature list.\');\r\n                _a = results.map(function (result) { return _this.param0(result); }), _this.version_ = _a[0], _this.features_ = _a[1];\r\n                //update feature list that is supported by webrpc\r\n                hdxms_1.getRedirector().setFeatures(_this.features_);\r\n                var requests = [];\r\n                //release-1906 client: supports new feature \'ms_teams_desktop_sharing\'\r\n                for (var _i = 0, _b = _this.features_; _i < _b.length; _i++) {\r\n                    var f = _b[_i];\r\n                    if (f.name === "ms_teams_desktop_sharing" && f.value) {\r\n                        requests.push(_this.remoteInvoke(false, webrpcclassinfo_1.method_id_EngineControl_t.version_info, []));\r\n                    }\r\n                    else if (f.name === "ms_teams_osinfo" && f.value) {\r\n                        requests.push(_this.remoteInvoke(false, webrpcclassinfo_1.method_id_EngineControl_t.osinfo, { "family": "", "version": "", "architecture": "", "distro": "", "edition": "" }));\r\n                    }\r\n                    else if (f.name === "ms_teams_sessionidentifier" && f.value) {\r\n                        requests.push(_this.remoteInvoke(false, webrpcclassinfo_1.method_id_EngineControl_t.session_identifier, { "machine_id": "", "user_id": "" }));\r\n                    }\r\n                }\r\n                if (requests.length > 0) {\r\n                    return Promise.all(requests);\r\n                }\r\n            })\r\n                .then(function (results) {\r\n                if (results === undefined) {\r\n                    logger_1.logger.log(_this.user_friendly_id() + \'release-1905 client.\');\r\n                }\r\n                else {\r\n                    logger_1.logger.log(_this.user_friendly_id() + \'release-1906 or later client: received detailed client version list.\');\r\n                    for (var _i = 0, results_1 = results; _i < results_1.length; _i++) {\r\n                        var result = results_1[_i];\r\n                        if (result.hdr.proc.iid == webrpcclassinfo_1.class_id_t.EngineControl && result.hdr.proc.methodid == webrpcclassinfo_1.method_id_EngineControl_t.version_info) {\r\n                            _this.versions_ = _this.param0(result);\r\n                        }\r\n                        else if (result.hdr.proc.iid == webrpcclassinfo_1.class_id_t.EngineControl && result.hdr.proc.methodid == webrpcclassinfo_1.method_id_EngineControl_t.osinfo) {\r\n                            _this.osinfo_ = _this.param0(result);\r\n                        }\r\n                        else if (result.hdr.proc.iid == webrpcclassinfo_1.class_id_t.EngineControl && result.hdr.proc.methodid == webrpcclassinfo_1.method_id_EngineControl_t.session_identifier) {\r\n                            _this.sessionidentifier_ = _this.param0(result);\r\n                        }\r\n                    }\r\n                }\r\n                //this must be release-1906 or later client, we are done\r\n                resolve(_this);\r\n            })\r\n                .catch(function () {\r\n                //this must be from release-1904 or earlier client\r\n                logger_1.logger.log(_this.user_friendly_id() + \'failure to retrieve version/feature related client info.\');\r\n                reject();\r\n            });\r\n        });\r\n    };\r\n    return EngineControl;\r\n}(proxyobject_1.ProxyObject));\r\nexports.EngineControl = EngineControl;\r\n\n\n//# sourceURL=webpack://CitrixWebRTC/E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/enginecontrol.js?');
      },
      "../../../out/shim/sdk/int/sdk/frametracker.js":
      /*!**************************************************************************!*\
        !*** E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/frametracker.js ***!
        \**************************************************************************/

      /*! no static exports found */
      function outShimSdkIntSdkFrametrackerJs(module, exports, __webpack_require__) {

        eval("\r\nObject.defineProperty(exports, \"__esModule\", { value: true });\r\nvar logger_1 = __webpack_require__(/*! ./logger */ \"../../../out/shim/sdk/int/sdk/logger.js\");\r\nvar hdxms_1 = __webpack_require__(/*! ./hdxms */ \"../../../out/shim/sdk/int/sdk/hdxms.js\");\r\nvar FrameTracker = /** @class */ (function () {\r\n    function FrameTracker() {\r\n        var _this = this;\r\n        this.running_ = false;\r\n        this.elements_ = [];\r\n        this.clipRects = new Set(); // active clip rectangles\r\n        //call update on scroll\r\n        this.wheelEventHandler = function (event) {\r\n            //allow time between mouse event and actual scroll in Teams\r\n            setTimeout(function () { _this.updateAll(); }, 10);\r\n        };\r\n        //call update on navigation keys\r\n        this.keyupEventHandler = function (event) {\r\n            if (event.code == 'Tab' ||\r\n                event.code == 'ArrowUp' || event.code == 'ArrowDown' ||\r\n                event.code == 'ArrowLeft' || event.code == 'ArrowRight' ||\r\n                event.code == 'PageUp' || event.code == 'PageDown' ||\r\n                event.code == 'Home' || event.code == 'End') {\r\n                _this.updateAll();\r\n            }\r\n        };\r\n        FrameTracker.sendOverlayInfo();\r\n        this.observer_ = new MutationObserver(function (mutations) {\r\n            _this.updateAll();\r\n        });\r\n    }\r\n    FrameTracker.sendOverlayInfo = function () {\r\n        var getWindowHandle = window['getWindowHandleAsHex'];\r\n        if (getWindowHandle === undefined || getWindowHandle === null) {\r\n            logger_1.logger.log('FrameTracker.sendOverlayInfo: getWindowHandle method is undefined or null');\r\n            return;\r\n        }\r\n        var hdxms = hdxms_1.getRedirector();\r\n        Promise.all([\r\n            getWindowHandle(),\r\n            hdxms.startRedirection(false, 'sendOverlayInfo')\r\n        ]).then(function (results) {\r\n            logger_1.logger.log('FrameTracker.sendOverlayInfo: set window handle: ' + results[0]);\r\n            // tell WebSocketAgent about our window so it can start tracking it.\r\n            hdxms.WSSendObject({\r\n                /**@nocollapse*/ v: 'overlay',\r\n                /**@nocollapse*/ command: 'window',\r\n                /**@nocollapse*/ windowHandle: results[0]\r\n            });\r\n        });\r\n    };\r\n    /// returns true iff the two rectangles intersect each other.\r\n    FrameTracker.prototype.rectanglesIntersect = function (r1, r2) {\r\n        if (r1.x < r2.x + r2.width &&\r\n            r1.x + r1.width > r2.x &&\r\n            r1.y < r2.y + r2.height &&\r\n            r1.y + r1.height > r2.y) {\r\n            return true;\r\n        }\r\n        return false;\r\n    };\r\n    /// return the intersection of rectangles assuming that they actually do intersect.\r\n    FrameTracker.prototype.intersectingRect = function (r1, r2) {\r\n        var r = {\r\n            left: Math.max(r1.left, r2.left),\r\n            right: Math.min(r1.right, r2.right),\r\n            top: Math.max(r1.top, r2.top),\r\n            bottom: Math.min(r1.bottom, r2.bottom)\r\n        };\r\n        return new DOMRect(r.left, r.top, r.right - r.left, r.bottom - r.top);\r\n    };\r\n    /// figure out how close the specified element is to the specified ancestor.\r\n    FrameTracker.prototype.pedigreeCount = function (element, ancestor) {\r\n        var pedigree = 0;\r\n        var parent = element.parentElement;\r\n        while (parent != null && parent != ancestor) {\r\n            pedigree++;\r\n            parent = parent.parentElement;\r\n        }\r\n        return {\r\n            'isAncestor': (parent != null),\r\n            'pedigree': pedigree\r\n        };\r\n    };\r\n    /// return whichever of the two elements is on top of the other.\r\n    FrameTracker.prototype.selectTopmost = function (itemA, itemB) {\r\n        var rA = itemA.getBoundingClientRect();\r\n        var rB = itemB.getBoundingClientRect();\r\n        // compute the intersecting rectangle.\r\n        var rect = this.intersectingRect(rA, rB);\r\n        // compute the center of the intersecting rectangle.\r\n        var pt = {\r\n            x: (rect.left + (rect.width / 2)),\r\n            y: (rect.top + (rect.height / 2))\r\n        };\r\n        // do a hit-test to see which one is on top.\r\n        var topmost = document.elementFromPoint(pt.x, pt.y);\r\n        if (topmost == itemA) {\r\n            return itemA;\r\n        }\r\n        else if (topmost == itemB) {\r\n            return itemB;\r\n        }\r\n        // this happens sometimes. see if we can resolve it by checking the parent.\r\n        var pedigreeA = this.pedigreeCount(itemA, topmost);\r\n        var pedigreeB = this.pedigreeCount(itemB, topmost);\r\n        if (pedigreeA['isAncestor'] && pedigreeB['isAncestor']) {\r\n            // both itemA and itemB are children of topmost.\r\n            // see if one of them is a closer relative.\r\n            if (pedigreeA['pedigree'] < pedigreeB['pedigree']) {\r\n                return itemA;\r\n            }\r\n            else if (pedigreeB['pedigree'] < pedigreeA['pedigree']) {\r\n                return itemB;\r\n            }\r\n        }\r\n        else if (pedigreeA['isAncestor']) {\r\n            // itemA is a child of topmost and itemB is not.\r\n            return itemA;\r\n        }\r\n        else if (pedigreeB['isAncestor']) {\r\n            // itemB is a child of topmost and itemA is not.\r\n            return itemB;\r\n        }\r\n        return undefined;\r\n    };\r\n    FrameTracker.prototype.checkOverlappingVideos = function (item) {\r\n        var _this = this;\r\n        var currentRect = item.target.getBoundingClientRect();\r\n        // purge (invalidate) any clip rects for item\r\n        item.overlaps.forEach(function (o) { item.target['remoteVideoElement'].removeClipRect(o['rect']); });\r\n        item.overlaps = [];\r\n        // check if this new position overlaps another video.\r\n        this.elements_.forEach(function (el) {\r\n            // skip ourselves.\r\n            if (el != item) {\r\n                // check if this element used to overlap and clear clip rectangle if so.\r\n                var overlappingElements = el.overlaps.map(function (o) { return o['element']; });\r\n                var idx = overlappingElements.indexOf(item.target);\r\n                if (idx != -1) {\r\n                    var ovlp = el.overlaps.splice(idx, 1)[0];\r\n                    el.target['remoteVideoElement'].removeClipRect(ovlp['rect']);\r\n                }\r\n                // get the bounding rectangle for this element.\r\n                var elRect = el.target.getBoundingClientRect();\r\n                // if it intersects the current element...\r\n                if (_this.rectanglesIntersect(currentRect, elRect)) {\r\n                    // ...check which one is on top.\r\n                    var topmost = _this.selectTopmost(item.target, el.target);\r\n                    if (topmost == item.target) {\r\n                        // cache the rect so we can clear the clip rect when it moves to another spot.\r\n                        el.overlaps.push({ 'element': item.target, 'rect': currentRect });\r\n                        // add the occlusion\r\n                        el.target['remoteVideoElement'].addClipRect(currentRect);\r\n                    }\r\n                    else if (topmost == el.target) {\r\n                        // the item is being added or moved into a spot which contains an overlapping\r\n                        // element which should appear on top.\r\n                        item.overlaps.push({ 'element': el.target, 'rect': elRect });\r\n                        item.target['remoteVideoElement'].addClipRect(elRect);\r\n                    }\r\n                }\r\n            }\r\n        });\r\n    };\r\n    FrameTracker.prototype.updateAll = function () {\r\n        var _this = this;\r\n        this.elements_.forEach(function (item) {\r\n            var currentRect = item.target.getBoundingClientRect();\r\n            if (currentRect === undefined) {\r\n                return;\r\n            }\r\n            var lastRect = item.clientRect;\r\n            if (lastRect === undefined\r\n                || lastRect.x !== currentRect.x\r\n                || lastRect.y !== currentRect.y\r\n                || lastRect.width !== currentRect.width\r\n                || lastRect.height !== currentRect.height) {\r\n                item.clientRect = currentRect;\r\n                item.callback(currentRect);\r\n                _this.checkOverlappingVideos(item);\r\n            }\r\n        });\r\n    };\r\n    FrameTracker.prototype.track = function (element, cb) {\r\n        var _this = this;\r\n        var rect = element.getBoundingClientRect();\r\n        logger_1.logger.log('Track element frame', element, JSON.stringify(rect));\r\n        console.log(element);\r\n        this.elements_.push({\r\n            target: element,\r\n            clientRect: undefined,\r\n            callback: cb,\r\n            overlaps: []\r\n        });\r\n        // initialize clip rectangles for the new video Element\r\n        try {\r\n            logger_1.logger.log('[HdxWebRTC.js] Initializing occlusion for new videoElement');\r\n            this.clipRects.forEach(function (r) { _this.applyOcclusion(element, JSON.parse(r)); });\r\n        }\r\n        catch (error) {\r\n            logger_1.logger.log('[HdxWebRTC.js] addOcclusionInit failed! ' + error);\r\n        }\r\n        if (!this.running_) {\r\n            logger_1.logger.log('Start FrameTracker observer...');\r\n            this.observer_.observe(document.body, {\r\n                attributes: true,\r\n                childList: true,\r\n                subtree: true\r\n            });\r\n            window.addEventListener('wheel', this.wheelEventHandler);\r\n            window.addEventListener('keyup', this.keyupEventHandler);\r\n            this.running_ = true;\r\n        }\r\n        this.updateAll();\r\n    };\r\n    FrameTracker.prototype.untrack = function (element) {\r\n        logger_1.logger.log('Untrack element frame', element);\r\n        var idx = -1;\r\n        this.elements_.forEach(function (item, index) {\r\n            if (item.target === element) {\r\n                idx = index;\r\n                return;\r\n            }\r\n        });\r\n        if (idx >= 0) {\r\n            this.elements_.splice(idx, 1);\r\n            if (this.elements_.length === 0) {\r\n                logger_1.logger.log('Stop FrameTracker observer...');\r\n                this.observer_.disconnect();\r\n                window.removeEventListener('wheel', this.wheelEventHandler);\r\n                window.removeEventListener('keyup', this.keyupEventHandler);\r\n                this.running_ = false;\r\n            }\r\n        }\r\n    };\r\n    FrameTracker.prototype.applyOcclusion = function (element, rect) {\r\n        var r1 = rect;\r\n        var r2 = element.getBoundingClientRect();\r\n        if (this.rectanglesIntersect(r1, r2)) {\r\n            if (element.remoteVideoElement !== undefined) {\r\n                element.remoteVideoElement.addClipRect(r1);\r\n            }\r\n        }\r\n    };\r\n    /// add an occlusion that is global (applies to all video elements)\r\n    FrameTracker.prototype.addOcclusion = function (rect) {\r\n        var _this = this;\r\n        logger_1.logger.log('[HdxWebRTC.js] Adding occlusion ' + JSON.stringify(rect));\r\n        logger_1.logger.log(\"[HdxWebRTC.js] Tracking '\" + this.elements_.length + \"' elements.\");\r\n        this.clipRects.add(JSON.stringify(rect));\r\n        this.elements_.forEach(function (e) {\r\n            _this.applyOcclusion(e.target, rect);\r\n        });\r\n    };\r\n    /// remove a global occlusion.\r\n    FrameTracker.prototype.removeOcclusion = function (rect) {\r\n        logger_1.logger.log('[HdxWebRTC.js] Removing occlusion ' + JSON.stringify(rect));\r\n        logger_1.logger.log(\"[HdxWebRTC.js] Tracking '\" + this.elements_.length + \"' elements.\");\r\n        this.clipRects.delete(JSON.stringify(rect));\r\n        this.elements_.forEach(function (e) {\r\n            var r1 = rect;\r\n            if (e.target.remoteVideoElement !== undefined) {\r\n                e.target.remoteVideoElement.removeClipRect(r1);\r\n            }\r\n        });\r\n    };\r\n    return FrameTracker;\r\n}());\r\nexports.FrameTracker = FrameTracker;\r\n\n\n//# sourceURL=webpack://CitrixWebRTC/E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/frametracker.js?");
      },
      "../../../out/shim/sdk/int/sdk/garbagecollector.js":
      /*!******************************************************************************!*\
        !*** E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/garbagecollector.js ***!
        \******************************************************************************/

      /*! no static exports found */
      function outShimSdkIntSdkGarbagecollectorJs(module, exports, __webpack_require__) {

        eval('\r\nObject.defineProperty(exports, "__esModule", { value: true });\r\nvar Node = /** @class */ (function () {\r\n    function Node(obj) {\r\n        this.object_ = null;\r\n        this.parent_ = null;\r\n        this.children_ = [];\r\n        this.object_ = obj;\r\n    }\r\n    //add child and set child\'s parent to this\r\n    Node.prototype.addChild = function (child) {\r\n        if (child.parent_ == this) {\r\n            return;\r\n        }\r\n        child.parent_ = this;\r\n        this.children_.push(child);\r\n    };\r\n    //remove child\r\n    Node.prototype.removeChild = function (child) {\r\n        var index = this.children_.indexOf(child);\r\n        this.children_.splice(index, 1);\r\n        child.parent_ = null;\r\n    };\r\n    return Node;\r\n}());\r\nvar GC = /** @class */ (function () {\r\n    function GC() {\r\n        this.root_ = new Node(null);\r\n    }\r\n    //register object\r\n    GC.prototype.trackObject = function (obj, parent) {\r\n        if (parent === void 0) { parent = null; }\r\n        if (this.findNode(obj, this.root_) !== null) {\r\n            //object is already tracked\r\n            return;\r\n        }\r\n        var parentNode = this.findNode(parent, this.root_);\r\n        var n = new Node(obj);\r\n        parentNode.addChild(n);\r\n        //print for debugging\r\n        //console.log("GC addnode");\r\n        //console.log(this.root_);\r\n    };\r\n    //release object and children\r\n    GC.prototype.releaseObject = function (obj) {\r\n        var n = this.findNode(obj, this.root_);\r\n        if (n === null || n === this.root_) {\r\n            return false;\r\n        }\r\n        this.destroyNodeObjectRecurse(n);\r\n        //unlink node from parent\r\n        n.parent_.removeChild(n);\r\n        //print for debugging\r\n        //console.log("GC removenode");\r\n        //console.log(this.root_);\r\n        return true;\r\n    };\r\n    //recursive destroy\r\n    GC.prototype.destroyNodeObjectRecurse = function (node) {\r\n        for (var _i = 0, _a = node.children_; _i < _a.length; _i++) {\r\n            var c = _a[_i];\r\n            this.destroyNodeObjectRecurse(c);\r\n        }\r\n        node.object_.destroy();\r\n    };\r\n    GC.prototype.setParent = function (obj, parent) {\r\n        var n = this.findNode(obj, this.root_);\r\n        if (n === null) {\r\n            return false;\r\n        }\r\n        var p = this.findNode(parent, this.root_);\r\n        if (p === null) {\r\n            return false;\r\n        }\r\n        //if already the same parent\r\n        if (n.parent_ === p)\r\n            return true;\r\n        //break existing parent-child relation\r\n        n.parent_.removeChild(n);\r\n        //create new relation\r\n        p.addChild(n);\r\n        return true;\r\n    };\r\n    //clear garbage collection tree\r\n    GC.prototype.reset = function () {\r\n        this.root_.children_ = [];\r\n    };\r\n    //node = Node to start search at\r\n    // returns null if node not found\r\n    GC.prototype.findNode = function (obj, searchNode) {\r\n        if (searchNode.object_ === obj) {\r\n            return searchNode;\r\n        }\r\n        var result = null;\r\n        for (var _i = 0, _a = searchNode.children_; _i < _a.length; _i++) {\r\n            var c = _a[_i];\r\n            result = this.findNode(obj, c);\r\n            if (result !== null) {\r\n                break;\r\n            }\r\n        }\r\n        return result;\r\n    };\r\n    return GC;\r\n}());\r\nexports.GC = GC;\r\nexports.gc = new GC();\r\n\n\n//# sourceURL=webpack://CitrixWebRTC/E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/garbagecollector.js?');
      },
      "../../../out/shim/sdk/int/sdk/hdxms.js":
      /*!*******************************************************************!*\
        !*** E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/hdxms.js ***!
        \*******************************************************************/

      /*! no static exports found */
      function outShimSdkIntSdkHdxmsJs(module, exports, __webpack_require__) {

        eval("\r\nObject.defineProperty(exports, \"__esModule\", { value: true });\r\nvar proxyobject_1 = __webpack_require__(/*! ./proxyobject */ \"../../../out/shim/sdk/int/sdk/proxyobject.js\");\r\nvar logger_1 = __webpack_require__(/*! ./logger */ \"../../../out/shim/sdk/int/sdk/logger.js\");\r\nvar webrpcclassinfo_1 = __webpack_require__(/*! ./webrpcclassinfo */ \"../../../out/shim/sdk/int/sdk/webrpcclassinfo.js\");\r\nvar wsjsonutil_1 = __webpack_require__(/*! ./wsjsonutil */ \"../../../out/shim/sdk/int/sdk/wsjsonutil.js\");\r\nvar telemetry_1 = __webpack_require__(/*! ./telemetry */ \"../../../out/shim/sdk/int/sdk/telemetry.js\");\r\nvar completion = /** @class */ (function () {\r\n    function completion(resolve, reject, iid, oid, cbid, oneShot, mid) {\r\n        this.resolve = resolve;\r\n        this.reject = reject;\r\n        this.iid = iid;\r\n        this.oid = oid;\r\n        this.cbid = cbid;\r\n        this.oneShot = oneShot;\r\n        this.mid = mid;\r\n    }\r\n    return completion;\r\n}());\r\nvar RedirectionStatus;\r\n(function (RedirectionStatus) {\r\n    RedirectionStatus[RedirectionStatus[\"NotRedirected\"] = 0] = \"NotRedirected\";\r\n    RedirectionStatus[RedirectionStatus[\"Connecting\"] = 1] = \"Connecting\";\r\n    RedirectionStatus[RedirectionStatus[\"Binding\"] = 2] = \"Binding\";\r\n    RedirectionStatus[RedirectionStatus[\"Redirected\"] = 3] = \"Redirected\"; //websocket connection is established, and sessioninfo handshaking is complete\r\n})(RedirectionStatus = exports.RedirectionStatus || (exports.RedirectionStatus = {}));\r\nvar HdxMediaStream = /** @class */ (function () {\r\n    function HdxMediaStream() {\r\n        this.pingactive = false;\r\n        this.status = RedirectionStatus.NotRedirected;\r\n        this.reqs = [];\r\n        this.cbs = [];\r\n        this.deferredActions = new Array();\r\n        this.telemetry_ = new telemetry_1.Telemetry();\r\n        this.stateChangeNotifcations = [];\r\n    }\r\n    Object.defineProperty(HdxMediaStream.prototype, \"telemetry\", {\r\n        get: function () {\r\n            return this.telemetry_;\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    HdxMediaStream.prototype.setRemoteSessionInfoCb = function (remoteSessionInfoCb) {\r\n        this.remoteSessionInfoCb = remoteSessionInfoCb;\r\n    };\r\n    HdxMediaStream.prototype.setFeatures = function (features) {\r\n        this.features = features;\r\n    };\r\n    HdxMediaStream.prototype.getFeatureValue = function (featureName) {\r\n        var result = this.features.find(function (value) { return value.name === featureName; });\r\n        return result !== undefined ? result.value : false;\r\n    };\r\n    HdxMediaStream.prototype.onRedirectionComplete = function () {\r\n        while (this.deferredActions && this.deferredActions.length > 0) {\r\n            this.deferredActions.shift().post(this.status == RedirectionStatus.Redirected);\r\n        }\r\n    };\r\n    HdxMediaStream.prototype.connectToService = function () {\r\n        // change our status to connecting...\r\n        logger_1.logger.log('Redirection status: Connecting...');\r\n        this.status = RedirectionStatus.Connecting;\r\n        // create the websocket.\r\n        return new Promise(function (resolve, reject) {\r\n            var sock = new WebSocket('wss://127.0.0.1:9002');\r\n            sock.onopen = function () {\r\n                resolve(sock);\r\n            };\r\n            sock.onerror = function (err) {\r\n                logger_1.logger.log('websocket connection error: ' + err.type);\r\n                reject(err);\r\n            };\r\n        });\r\n    };\r\n    HdxMediaStream.prototype.waitUntilRedirected = function (count) {\r\n        var self = this;\r\n        return new Promise(function (resolve, reject) {\r\n            if (self.status == RedirectionStatus.Redirected) {\r\n                resolve();\r\n            }\r\n            else {\r\n                if (count <= 0) {\r\n                    reject();\r\n                }\r\n                else {\r\n                    setTimeout(function () {\r\n                        logger_1.logger.log('waitUntilRedirected() timeout. count=' + count);\r\n                        if (self.status != RedirectionStatus.Redirected) {\r\n                            self.waitUntilRedirected(--count).then(function () {\r\n                                resolve();\r\n                            }).catch(function () {\r\n                                reject();\r\n                            });\r\n                        }\r\n                        else {\r\n                            //todo: push a completion so the promise can be resolved when the configure response is received\r\n                            resolve();\r\n                        }\r\n                    }, 2000); //2seconds each time\r\n                }\r\n            }\r\n        });\r\n    };\r\n    HdxMediaStream.prototype.handleRemoteSessionInfo = function () {\r\n        var _this = this;\r\n        logger_1.logger.log('handleRemoteSessionInfo called.');\r\n        var self = this;\r\n        if (self.remoteSessionInfoCb) {\r\n            self.remoteSessionInfoCb().then(function (info) {\r\n                logger_1.logger.log('remoteSessionInfo success! info:' + JSON.stringify(info));\r\n                logger_1.logger.log('Redirection status: Redirected');\r\n                self.status = RedirectionStatus.Redirected;\r\n                //stop connection ping timer\r\n                self.pingConnectionEnd();\r\n                //notify MS Teams about connection status\r\n                var vdiClientConnected = window['onVdiClientConnected'];\r\n                vdiClientConnected();\r\n                // send telemetry init request data to websocket agent\r\n                _this.telemetry.SendTelemetryInit();\r\n                //dispatch all delayed redirection requests\r\n                self.onRedirectionComplete();\r\n            })\r\n                .catch(function () {\r\n                logger_1.logger.log('remoteSessionInfo failure!');\r\n                // unable to connect to service for some reason.\r\n                self.suspendRedirection(true);\r\n                //dispatch all delayed redirection requests\r\n                self.onRedirectionComplete();\r\n            });\r\n        }\r\n        else {\r\n            logger_1.logger.log('remoteSessionInfoCb is invalid!');\r\n            // unable to connect to service for some reason.\r\n            self.suspendRedirection(true);\r\n            //dispatch all delayed redirection requests\r\n            self.onRedirectionComplete();\r\n        }\r\n    };\r\n    HdxMediaStream.prototype.startRedirection = function (sessioninfo, name) {\r\n        var self = this;\r\n        //notify MS Teams about connection failure\r\n        var vdiClientDisconnected = window['onVdiClientDisconnected'];\r\n        return new Promise(function (resolve, reject) {\r\n            if (self.status != RedirectionStatus.Redirected) {\r\n                logger_1.logger.log('Attempting to start redirection: ' + name);\r\n                if (sessioninfo === false) {\r\n                    //delay anything that is not related to sessioninfo\r\n                    self.deferredActions.push(new proxyobject_1.deferred_action(resolve, reject, name));\r\n                }\r\n                else {\r\n                    self.connectToService().then(function (sock) {\r\n                        logger_1.logger.log('Redirection status: Binding...');\r\n                        self.status = RedirectionStatus.Binding;\r\n                        self.websocket = sock;\r\n                        // connected to Citrix WebSocket Service!!! setup handlers...\r\n                        self.websocket.onmessage = function (obj) { self.onWSMessage(obj); }; //self.onWSMessage;\r\n                        self.websocket.onclose = function (closeEvent) { self.onWSClose(closeEvent); }; //self.onWSClose;\r\n                        //this.onWSOpen();\r\n                        resolve();\r\n                        self.handleRemoteSessionInfo();\r\n                    }).catch(function (err) {\r\n                        logger_1.logger.log('Unable to connect to websocket service!');\r\n                        reject();\r\n                        // unable to connect to service for some reason.\r\n                        self.suspendRedirection(true);\r\n                        //dispatch all delayed redirection requests\r\n                        self.onRedirectionComplete();\r\n                        //notify MS Teams about connection failure\r\n                        vdiClientDisconnected(true);\r\n                    });\r\n                }\r\n            }\r\n            else {\r\n                logger_1.logger.log('Redirection already started.');\r\n                resolve();\r\n            }\r\n        });\r\n    };\r\n    HdxMediaStream.prototype.suspendRedirection = function (svrender) {\r\n        var _this = this;\r\n        logger_1.logger.log('Suspending redirection.');\r\n        //this.hdxvr.suspend(svrender);\r\n        //this.hdxbcr.suspend(svrender);\r\n        //notify MS Teams about connection status\r\n        var vdiClientDisconnected = window['onVdiClientDisconnected'];\r\n        vdiClientDisconnected(false);\r\n        var regkeyexists = false;\r\n        var CitrixMSTeamsRedir = window['getCitrixMSTeamsRedir'];\r\n        var regkey = CitrixMSTeamsRedir();\r\n        regkey.then(function (value) {\r\n            logger_1.logger.log(\"sucesss on disconnect\" + value);\r\n            if ((value == 1) && (value !== \"\")) {\r\n                regkeyexists = true;\r\n                logger_1.logger.log(\"Reg key exists while disconnecting\");\r\n            }\r\n            //need to start reconnect timer only if we were previously connected\r\n            if (_this.status === RedirectionStatus.Redirected && (regkeyexists == true)) {\r\n                logger_1.logger.log(\"Calling ping not normal disconnect\");\r\n                _this.pingConnectionBegin(false);\r\n            }\r\n            logger_1.logger.log('Redirection status: NotRedirected');\r\n            _this.status = RedirectionStatus.NotRedirected;\r\n        });\r\n        this.dispatchStateChangeNotifications();\r\n    };\r\n    HdxMediaStream.prototype.onWSOpen = function () {\r\n        //var eUri = encodeURI((typeof HDX_DO_PAGE_REDIRECTION === 'string') ? HDX_DO_PAGE_REDIRECTION : document.location.href)\r\n        //this.WSSendObject({\r\n        //    /**@expose*/ v: 'pageurl',\r\n        //    /**@expose*/ url: eUri\r\n        //});\r\n        //hdxMediaStream.getOrigin();\r\n        //hdxMediaStream.onVisibilityChange();\r\n        //hdxMediaStream.onResize();\r\n    };\r\n    HdxMediaStream.prototype.onWSClose = function (closeEvent) {\r\n        logger_1.logger.log('disconnected from websocket service.');\r\n        try {\r\n            this.suspendRedirection(true);\r\n        }\r\n        catch (exc) {\r\n            logger_1.logger.log('suspendRedirection(): exception closing WebSocket: ' + exc.message);\r\n        }\r\n    };\r\n    HdxMediaStream.prototype.onWSError = function () {\r\n        try {\r\n            this.suspendRedirection(true);\r\n        }\r\n        catch (exc) {\r\n            logger_1.logger.log('suspendRedirection(): exception on WebSocket error: ' + exc.message);\r\n        }\r\n    };\r\n    HdxMediaStream.prototype.WSSendObjectWrapper = function (feature, iid, mid, obj) {\r\n        var check = true;\r\n        if ((iid == webrpcclassinfo_1.class_id_t.EngineControl) &&\r\n            (mid == webrpcclassinfo_1.method_id_EngineControl_t.ctor || mid == webrpcclassinfo_1.method_id_EngineControl_t.version || mid == webrpcclassinfo_1.method_id_EngineControl_t.feature_flags)) {\r\n            //always skip check for this case\r\n            check = false;\r\n        }\r\n        //need to check against features?\r\n        var send = true;\r\n        if (check) {\r\n            //by default set this iid/mid is not supported in the current feature list\r\n            send = false;\r\n            if (this.features != undefined) {\r\n                for (var _i = 0, _a = this.features; _i < _a.length; _i++) {\r\n                    var f = _a[_i];\r\n                    if (f.value === true && f.name == feature) {\r\n                        //all good to send\r\n                        send = true;\r\n                        break;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n        if (send == true) {\r\n            return this.WSSendObject(obj);\r\n        }\r\n        else {\r\n            return Promise.reject('Cannot invoke method that is not supported by webrpc: iid(' + iid + ') mid(' + mid + ')');\r\n        }\r\n    };\r\n    HdxMediaStream.prototype.WSSendObject = function (obj) {\r\n        var _this = this;\r\n        return new Promise(function (resolve, reject) {\r\n            if (obj['v'] == 'webrtc') {\r\n                var iid = obj['hdr']['proc']['iid'];\r\n                var mid = obj['hdr']['proc']['methodid'];\r\n                var oid = obj['objref']['oid'];\r\n                var destroy = obj['hdr']['destroy'];\r\n                if (!destroy) {\r\n                    var comp = new completion(resolve, reject, iid, oid, 0, true, mid);\r\n                    _this.reqs.push(comp);\r\n                }\r\n                var message = JSON.stringify(obj);\r\n                logger_1.logger.trace('WSSendObject: >>> ' + webrpcclassinfo_1.WebrpcClassLibInfoUtil.composeClassInfoData(obj) + ' ' + message);\r\n                try {\r\n                    _this.websocket.send(message);\r\n                }\r\n                catch (exc) {\r\n                    //ToDo: remove promise from the queue\r\n                    logger_1.logger.log('WSSendObject(): exception: ' + exc.message);\r\n                    reject(exc.message);\r\n                }\r\n            }\r\n            else if (obj['v'] == 'overlay') {\r\n                var message = JSON.stringify(obj);\r\n                logger_1.logger.log('HDXMS: SendOverlayData: >>> ' + message + \"'\");\r\n                _this.websocket.send(message);\r\n            }\r\n            else if (obj['v'] == 'telemetry') {\r\n                var message = JSON.stringify(obj);\r\n                logger_1.logger.log('HDXMS: SendTelemetryData: >>> ' + message + \"'\");\r\n                _this.websocket.send(message);\r\n            }\r\n            else {\r\n                logger_1.logger.log(\"HDXMS: Unknown protocol: '\" + JSON.stringify(obj) + \"'\");\r\n            }\r\n        });\r\n    };\r\n    HdxMediaStream.prototype.onWSMessage = function (messageEvent) {\r\n        var data = messageEvent['data'];\r\n        var v;\r\n        try {\r\n            v = JSON.parse(data);\r\n        }\r\n        catch (err) {\r\n            console.log('invalid JSON!!!');\r\n            console.log(err);\r\n            console.log(data);\r\n        }\r\n        if (v['v'] == 'webrtc') {\r\n            logger_1.logger.trace('onWSMessage: <<< ' + webrpcclassinfo_1.WebrpcClassLibInfoUtil.composeClassInfoData(v) + ' ' + data);\r\n            var iid_1 = v['hdr']['proc']['iid'];\r\n            var mid_1 = v['hdr']['proc']['methodid'];\r\n            var oid_1 = v['objref']['oid'];\r\n            var status_1 = v['status'];\r\n            if (v['hdr']['msg_type'] == wsjsonutil_1.WsJsonUtil.getMsgType(wsjsonutil_1.ws_msg_type_t.reply)) {\r\n                var idx = this.reqs.findIndex(function (req) { return req.iid == iid_1 && req.oid == oid_1 && req.mid == mid_1; });\r\n                if (idx >= 0) {\r\n                    if (status_1 == 0) { //success\r\n                        this.reqs.splice(idx, 1).shift().resolve(v);\r\n                    }\r\n                    else {\r\n                        this.reqs.splice(idx, 1).shift().reject();\r\n                    }\r\n                }\r\n                else {\r\n                    logger_1.logger.log('HDXMS didnt find this one. (reqs)');\r\n                    logger_1.logger.log(this.reqs);\r\n                }\r\n            }\r\n            else if (v['hdr']['msg_type'] == wsjsonutil_1.WsJsonUtil.getMsgType(wsjsonutil_1.ws_msg_type_t.event_req)) {\r\n                var cbid_1 = v['func']['id'];\r\n                var idx = this.cbs.findIndex(function (cb) { return cb.iid == iid_1 && cb.oid == oid_1 && cb.cbid == (cbid_1 >> 16); });\r\n                if (idx >= 0) {\r\n                    if ((cbid_1 & 0xffff) == 0) {\r\n                        this.cbs[idx].resolve(v);\r\n                    }\r\n                    else {\r\n                        this.cbs[idx].reject(v);\r\n                    }\r\n                    if (this.cbs[idx].oneShot == true) {\r\n                        this.cbs.splice(idx, 1);\r\n                    }\r\n                }\r\n                else {\r\n                    logger_1.logger.log('HDXMS didnt find this one. (cbs)');\r\n                    logger_1.logger.log(this.cbs);\r\n                }\r\n            }\r\n            else {\r\n                // not valid. not expected.\r\n                logger_1.logger.log('HDXMS Received bogus message: ' + data + \"'\");\r\n            }\r\n        }\r\n        else if (v['v'] == 'telemetry') {\r\n            var status_2 = v['status'];\r\n            if (status_2 == 0) {\r\n                var command = v['hdr']['command'];\r\n                if ((command & 0x7fffffff) == 2) {\r\n                    var id = v['hdr']['id'];\r\n                    this.telemetry.onInitialized(id);\r\n                    logger_1.logger.log('Telemetry init response received');\r\n                }\r\n            }\r\n        }\r\n        else {\r\n            logger_1.logger.log('HDXMS: Unknown protocol: ' + data + \"'\");\r\n        }\r\n    };\r\n    HdxMediaStream.prototype.registerHandler = function (iid, oid, cb) {\r\n        var comp = new completion(cb.resolve.bind(cb), cb.reject.bind(cb), iid, oid, cb.id, cb.oneShot, 0);\r\n        this.cbs.push(comp);\r\n    };\r\n    HdxMediaStream.prototype.unregisterHandler = function (iid, oid, id) {\r\n        //logger.log('HDXMS unregister handler for iid=' + iid + ', oid=' + oid + ', id=' + id);\r\n        var idx = this.cbs.findIndex(function (cb) { return cb.iid == iid && cb.oid == oid && cb.cbid == id; });\r\n        if (idx >= 0) {\r\n            this.cbs.splice(idx, 1);\r\n        }\r\n        else {\r\n            logger_1.logger.log('HDXMS Didnt find this callback in the list!');\r\n            console.log(this.cbs);\r\n        }\r\n    };\r\n    HdxMediaStream.prototype.isRedirected = function () {\r\n        return (this.status === RedirectionStatus.Redirected ||\r\n            this.status === RedirectionStatus.Binding ||\r\n            this.status === RedirectionStatus.Connecting);\r\n    };\r\n    HdxMediaStream.prototype.isPingActive = function () {\r\n        return this.pingactive;\r\n    };\r\n    HdxMediaStream.prototype.pingConnectionBegin = function (immediate) {\r\n        logger_1.logger.log(\"Started timer\");\r\n        this.pingactive = true;\r\n        var VdiClientDisconnectedTimer = window['onVdiClientDisconnectedTimer'];\r\n        if (immediate == true) {\r\n            logger_1.logger.log('checking if we are connected...');\r\n            VdiClientDisconnectedTimer();\r\n        }\r\n        else {\r\n            this.conntimer = setTimeout(function () {\r\n                //need to wait for another round\r\n                logger_1.logger.log('checking if we are connected...');\r\n                VdiClientDisconnectedTimer();\r\n            }, 15000); //first ping starts after 15seconds\r\n        }\r\n    };\r\n    HdxMediaStream.prototype.pingConnectionEnd = function () {\r\n        this.pingactive = false;\r\n        //clearInterval(this.conntimer);\r\n        clearTimeout(this.conntimer);\r\n    };\r\n    HdxMediaStream.prototype.SendTelemetryData_Speaker = function (speaker) {\r\n        this.telemetry.SendTelemetryData(telemetry_1.tel_cmd.Data, telemetry_1.tel_key_SpeakerDeviceUsed, speaker, 0);\r\n    };\r\n    HdxMediaStream.prototype.registerStateChangeNotification = function (f) {\r\n        this.stateChangeNotifcations.push(f);\r\n    };\r\n    HdxMediaStream.prototype.unregisterStateChangeNotification = function (f) {\r\n        this.stateChangeNotifcations = this.stateChangeNotifcations.filter(function (item) {\r\n            return item != f;\r\n        });\r\n    };\r\n    HdxMediaStream.prototype.dispatchStateChangeNotifications = function () {\r\n        this.stateChangeNotifcations.forEach(function (e) {\r\n            e();\r\n        });\r\n    };\r\n    return HdxMediaStream;\r\n}());\r\nexports.HdxMediaStream = HdxMediaStream;\r\n/*export*/ var hdxMediaStream = new HdxMediaStream();\r\nfunction getRedirector() {\r\n    return hdxMediaStream;\r\n}\r\nexports.getRedirector = getRedirector;\r\n\n\n//# sourceURL=webpack://CitrixWebRTC/E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/hdxms.js?");
      },
      "../../../out/shim/sdk/int/sdk/icecandidate.js":
      /*!**************************************************************************!*\
        !*** E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/icecandidate.js ***!
        \**************************************************************************/

      /*! no static exports found */
      function outShimSdkIntSdkIcecandidateJs(module, exports, __webpack_require__) {

        eval('\r\nvar __extends = (this && this.__extends) || (function () {\r\n    var extendStatics = function (d, b) {\r\n        extendStatics = Object.setPrototypeOf ||\r\n            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||\r\n            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };\r\n        return extendStatics(d, b);\r\n    }\r\n    return function (d, b) {\r\n        extendStatics(d, b);\r\n        function __() { this.constructor = d; }\r\n        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());\r\n    };\r\n})();\r\nObject.defineProperty(exports, "__esModule", { value: true });\r\nvar proxyobject_1 = __webpack_require__(/*! ./proxyobject */ "../../../out/shim/sdk/int/sdk/proxyobject.js");\r\nvar webrpcclassinfo_1 = __webpack_require__(/*! ./webrpcclassinfo */ "../../../out/shim/sdk/int/sdk/webrpcclassinfo.js");\r\nvar logger_1 = __webpack_require__(/*! ./logger */ "../../../out/shim/sdk/int/sdk/logger.js");\r\n//RTCIceCandidate wrapper\r\nvar IceCandidate = /** @class */ (function (_super) {\r\n    __extends(IceCandidate, _super);\r\n    function IceCandidate(parent, oid) {\r\n        return _super.call(this, parent, webrpcclassinfo_1.class_id_t.RTCIceCandidate, oid, proxyobject_1.ProxyMode.Remote) || this;\r\n    }\r\n    Object.defineProperty(IceCandidate.prototype, "candidate", {\r\n        get: function () {\r\n            return this.candidate_;\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    Object.defineProperty(IceCandidate.prototype, "sdpMid", {\r\n        get: function () {\r\n            return this.sdpMid_;\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    Object.defineProperty(IceCandidate.prototype, "sdpMLineIndex", {\r\n        get: function () {\r\n            return this.sdpMLineIndex_;\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    IceCandidate.prototype.syncBarrier = function () {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + \'.syncBarrier() called.\');\r\n        return new Promise(function (resolve, reject) {\r\n            _this.waitUntilConnected(\'IceCandidate.syncBarrier\')\r\n                .then(function () {\r\n                return Promise.all([\r\n                    _this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCIceCandidate_t.candidate, ""),\r\n                    _this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCIceCandidate_t.sdpMid, ""),\r\n                    _this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCIceCandidate_t.sdpMLineIndex, 0)\r\n                ]);\r\n            })\r\n                .then(function (results) {\r\n                var _a;\r\n                _a = results.map(function (result) { return _this.param0(result); }), _this.candidate_ = _a[0], _this.sdpMid_ = _a[1], _this.sdpMLineIndex_ = _a[2];\r\n                resolve(_this);\r\n            })\r\n                .catch(function () { reject(); });\r\n        });\r\n    };\r\n    return IceCandidate;\r\n}(proxyobject_1.ProxyObject));\r\nexports.IceCandidate = IceCandidate;\r\n//RTCIceCandidatePair wrapper\r\nvar IceCandidatePair = /** @class */ (function (_super) {\r\n    __extends(IceCandidatePair, _super);\r\n    function IceCandidatePair(parent, oid) {\r\n        return _super.call(this, parent, webrpcclassinfo_1.class_id_t.RTCIceCandidatePair, oid, proxyobject_1.ProxyMode.Remote) || this;\r\n    }\r\n    Object.defineProperty(IceCandidatePair.prototype, "local", {\r\n        get: function () {\r\n            return this.local_;\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    Object.defineProperty(IceCandidatePair.prototype, "remote", {\r\n        get: function () {\r\n            return this.remote_;\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    IceCandidatePair.prototype.syncBarrier = function () {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + \'.syncBarrier() called.\');\r\n        return new Promise(function (resolve, reject) {\r\n            _this.waitUntilConnected(\'IceCandidatePair.syncBarrier\')\r\n                .then(function () {\r\n                return Promise.all([\r\n                    _this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCIceCandidatePair_t.local, {}),\r\n                    _this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCIceCandidatePair_t.remote, {}),\r\n                ]);\r\n            })\r\n                .then(function (results) {\r\n                var _a;\r\n                _a = results.map(function (result) { return _this.param0(result); }), _this.local_ = _a[0], _this.remote_ = _a[1];\r\n                resolve(_this);\r\n            })\r\n                .catch(function () { reject(); });\r\n        });\r\n    };\r\n    return IceCandidatePair;\r\n}(proxyobject_1.ProxyObject));\r\nexports.IceCandidatePair = IceCandidatePair;\r\n\n\n//# sourceURL=webpack://CitrixWebRTC/E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/icecandidate.js?');
      },
      "../../../out/shim/sdk/int/sdk/logger.js":
      /*!********************************************************************!*\
        !*** E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/logger.js ***!
        \********************************************************************/

      /*! no static exports found */
      function outShimSdkIntSdkLoggerJs(module, exports, __webpack_require__) {

        eval("\r\nObject.defineProperty(exports, \"__esModule\", { value: true });\r\nvar Logger = /** @class */ (function () {\r\n    function Logger(tag) {\r\n        this.tracing = false;\r\n        this.mslogger_ = undefined;\r\n        this.tag = tag;\r\n        this.enabled = true;\r\n    }\r\n    Logger.prototype.setMSLogger = function (mslogger) {\r\n        this.mslogger_ = mslogger;\r\n    };\r\n    Logger.prototype.log = function () {\r\n        var args = [];\r\n        for (var _i = 0; _i < arguments.length; _i++) {\r\n            args[_i] = arguments[_i];\r\n        }\r\n        if (this.enabled) {\r\n            if (this.mslogger_ != undefined) {\r\n                this.mslogger_.info(this.tag + ' ' + args);\r\n            }\r\n            else {\r\n                console.log(this.tag + ' ' + args);\r\n            }\r\n        }\r\n    };\r\n    Logger.prototype.trace = function () {\r\n        var args = [];\r\n        for (var _i = 0; _i < arguments.length; _i++) {\r\n            args[_i] = arguments[_i];\r\n        }\r\n        if (this.tracing) {\r\n            this.log.apply(this, args);\r\n        }\r\n    };\r\n    return Logger;\r\n}());\r\nexports.Logger = Logger;\r\nexports.logger = new Logger('[HdxWebRTC.js]');\r\nexports.logger.enabled = true; // Enabled for now\r\n\n\n//# sourceURL=webpack://CitrixWebRTC/E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/logger.js?");
      },
      "../../../out/shim/sdk/int/sdk/peerconnection.js":
      /*!****************************************************************************!*\
        !*** E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/peerconnection.js ***!
        \****************************************************************************/

      /*! no static exports found */
      function outShimSdkIntSdkPeerconnectionJs(module, exports, __webpack_require__) {

        eval("\r\nvar __extends = (this && this.__extends) || (function () {\r\n    var extendStatics = function (d, b) {\r\n        extendStatics = Object.setPrototypeOf ||\r\n            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||\r\n            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };\r\n        return extendStatics(d, b);\r\n    }\r\n    return function (d, b) {\r\n        extendStatics(d, b);\r\n        function __() { this.constructor = d; }\r\n        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());\r\n    };\r\n})();\r\nvar __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {\r\n    return new (P || (P = Promise))(function (resolve, reject) {\r\n        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }\r\n        function rejected(value) { try { step(generator[\"throw\"](value)); } catch (e) { reject(e); } }\r\n        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }\r\n        step((generator = generator.apply(thisArg, _arguments || [])).next());\r\n    });\r\n};\r\nvar __generator = (this && this.__generator) || function (thisArg, body) {\r\n    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;\r\n    return g = { next: verb(0), \"throw\": verb(1), \"return\": verb(2) }, typeof Symbol === \"function\" && (g[Symbol.iterator] = function() { return this; }), g;\r\n    function verb(n) { return function (v) { return step([n, v]); }; }\r\n    function step(op) {\r\n        if (f) throw new TypeError(\"Generator is already executing.\");\r\n        while (_) try {\r\n            if (f = 1, y && (t = op[0] & 2 ? y[\"return\"] : op[0] ? y[\"throw\"] || ((t = y[\"return\"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;\r\n            if (y = 0, t) op = [op[0] & 2, t.value];\r\n            switch (op[0]) {\r\n                case 0: case 1: t = op; break;\r\n                case 4: _.label++; return { value: op[1], done: false };\r\n                case 5: _.label++; y = op[1]; op = [0]; continue;\r\n                case 7: op = _.ops.pop(); _.trys.pop(); continue;\r\n                default:\r\n                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }\r\n                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }\r\n                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }\r\n                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }\r\n                    if (t[2]) _.ops.pop();\r\n                    _.trys.pop(); continue;\r\n            }\r\n            op = body.call(thisArg, _);\r\n        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }\r\n        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };\r\n    }\r\n};\r\nObject.defineProperty(exports, \"__esModule\", { value: true });\r\nvar hdxms_1 = __webpack_require__(/*! ./hdxms */ \"../../../out/shim/sdk/int/sdk/hdxms.js\");\r\nvar remotemedia_1 = __webpack_require__(/*! ./remotemedia */ \"../../../out/shim/sdk/int/sdk/remotemedia.js\");\r\nvar rtpsender_1 = __webpack_require__(/*! ./rtpsender */ \"../../../out/shim/sdk/int/sdk/rtpsender.js\");\r\nvar proxyobject_1 = __webpack_require__(/*! ./proxyobject */ \"../../../out/shim/sdk/int/sdk/proxyobject.js\");\r\nvar icecandidate_1 = __webpack_require__(/*! ./icecandidate */ \"../../../out/shim/sdk/int/sdk/icecandidate.js\");\r\nvar rtptransceiver_1 = __webpack_require__(/*! ./rtptransceiver */ \"../../../out/shim/sdk/int/sdk/rtptransceiver.js\");\r\nvar webrpcclassinfo_1 = __webpack_require__(/*! ./webrpcclassinfo */ \"../../../out/shim/sdk/int/sdk/webrpcclassinfo.js\");\r\nvar logger_1 = __webpack_require__(/*! ./logger */ \"../../../out/shim/sdk/int/sdk/logger.js\");\r\nvar stats_1 = __webpack_require__(/*! ./stats */ \"../../../out/shim/sdk/int/sdk/stats.js\");\r\nvar telemetry_1 = __webpack_require__(/*! ./telemetry */ \"../../../out/shim/sdk/int/sdk/telemetry.js\");\r\nfunction ensure_config_defined(v) {\r\n    if (v != undefined) {\r\n        return v;\r\n    }\r\n    return {};\r\n}\r\n//RTCIceCandidateEvent wrapper\r\nvar IceCandidateEvent = /** @class */ (function (_super) {\r\n    __extends(IceCandidateEvent, _super);\r\n    //private url_: string;\r\n    function IceCandidateEvent(parent, oid, target) {\r\n        var _this = _super.call(this, parent, webrpcclassinfo_1.class_id_t.RTCIceCandidateEvent, oid, proxyobject_1.ProxyMode.Remote) || this;\r\n        _this.target = target;\r\n        _this.type = \"icecandidate\";\r\n        return _this;\r\n    }\r\n    Object.defineProperty(IceCandidateEvent.prototype, \"candidate\", {\r\n        get: function () {\r\n            return this.candidate_;\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    /*\r\n    public get url(): string {\r\n        logger.log('IceCandidateEvent.url() called.');\r\n        return this.url_;\r\n    } */\r\n    IceCandidateEvent.prototype.syncBarrier = function () {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + '.syncBarrier() called.');\r\n        return new Promise(function (resolve, reject) {\r\n            _this.waitUntilConnected(_this.user_friendly_id() + '.syncBarrier')\r\n                .then(function () { return _this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCIceCandidateEvent_t.candidate, { \"oid\": 0 }); })\r\n                .then(function (obj) {\r\n                var reply = _this.param0(obj);\r\n                if (reply['is_null'] === false) {\r\n                    var ice = new icecandidate_1.IceCandidate(_this, reply['oid']);\r\n                    return ice.syncBarrier();\r\n                }\r\n                return Promise.resolve(null);\r\n            })\r\n                .then(function (ice) {\r\n                logger_1.logger.log(_this.user_friendly_id() + '.onicecandidate: icecandidate available!');\r\n                _this.candidate_ = ice;\r\n                resolve(_this);\r\n            })\r\n                .catch(function () {\r\n                logger_1.logger.log(_this.user_friendly_id() + '.onicecandidate() failed.');\r\n                reject();\r\n            });\r\n        });\r\n    };\r\n    return IceCandidateEvent;\r\n}(proxyobject_1.ProxyObject));\r\nexports.IceCandidateEvent = IceCandidateEvent;\r\nvar IceGatherer = /** @class */ (function () {\r\n    function IceGatherer(pc) {\r\n        this.state_ = \"new\";\r\n        this.candidates_ = [];\r\n        this.pc_ = pc;\r\n    }\r\n    IceGatherer.prototype.pushState = function (state) {\r\n        logger_1.logger.log(this.pc_.user_friendly_id() + '.onicegatheringstatechange: new state is ' + state);\r\n        this.state_ = state;\r\n        if (this.state_ == \"gathering\") {\r\n            this.candidates_ = [];\r\n            this.postUpdate();\r\n        }\r\n        else {\r\n            this.processRemaining();\r\n        }\r\n    };\r\n    IceGatherer.prototype.addIceCandidate = function (ice_event) {\r\n        var _this = this;\r\n        // add it to the tracking list\r\n        this.candidates_.push(ice_event);\r\n        // begin the synchronization process\r\n        ice_event.syncBarrier()\r\n            .then(function (evt) {\r\n            // object has been synchronized, update the local description before posting\r\n            logger_1.logger.log(_this.pc_.user_friendly_id() + '.onicecandidate: icecandidate available!');\r\n            return Promise.all([\r\n                _this.pc_.updateLocalDescription(),\r\n                Promise.resolve(evt)\r\n            ]);\r\n        })\r\n            .then(function (results) {\r\n            // local description updated, post the ice candidate now.\r\n            _this.postIceCandidate(results[1]);\r\n        });\r\n    };\r\n    IceGatherer.prototype.postIceCandidate = function (evt) {\r\n        logger_1.logger.log(this.pc_.user_friendly_id() + '.onicecandidate: posting ice candidate now!');\r\n        if (this.pc_.onicecandidate != null) {\r\n            this.pc_.onicecandidate(evt);\r\n        }\r\n        else {\r\n            logger_1.logger.log(this.pc_.user_friendly_id() + 'onicecandidate is NULL!!!');\r\n        }\r\n        //remove the ice candidate from the tracking list.\r\n        this.candidates_.shift();\r\n        this.processRemaining();\r\n    };\r\n    IceGatherer.prototype.postUpdate = function () {\r\n        logger_1.logger.log(this.pc_.user_friendly_id() + '.onicegatheringstatechange: posting event now!');\r\n        var new_evt = new PeerConnectionEvent('onicegatheringstatechange', this.pc_);\r\n        this.pc_.onicegatheringstatechange(new_evt);\r\n    };\r\n    IceGatherer.prototype.processRemaining = function () {\r\n        if (this.candidates_.length == 0 && this.state_ == \"complete\") {\r\n            // Teams doesn't actually use the ice gathering state to decide when ice candidate gathering\r\n            // is complete. They apparently rely on on getting a null ice candidate instead, which seems\r\n            // to be another way to signal it. This fixes delay on incoming calls.\r\n            this.pc_.onicecandidate({ candidate: null, target: this });\r\n            this.postUpdate();\r\n        }\r\n        else {\r\n            logger_1.logger.log(this.pc_.user_friendly_id() + '.onicecandidate: candidates remaining=[' + this.candidates_.map(function (ice) { return ice.object_id(); }) + '], state=' + this.state_);\r\n        }\r\n    };\r\n    return IceGatherer;\r\n}());\r\n//RTCSessionDescription  wrapper\r\nvar SessionDescription = /** @class */ (function (_super) {\r\n    __extends(SessionDescription, _super);\r\n    function SessionDescription(parent, oid, mode) {\r\n        var args = [];\r\n        for (var _i = 3; _i < arguments.length; _i++) {\r\n            args[_i - 3] = arguments[_i];\r\n        }\r\n        return _super.apply(this, [parent, webrpcclassinfo_1.class_id_t.RTCSessionDescription, oid, mode, null].concat(args)) || this;\r\n    }\r\n    SessionDescription.prototype.toJSON = function () {\r\n        return { \"type\": this.type_, \"sdp\": this.sdp_ };\r\n    };\r\n    Object.defineProperty(SessionDescription.prototype, \"sdp\", {\r\n        get: function () {\r\n            return this.sdp_;\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    Object.defineProperty(SessionDescription.prototype, \"type\", {\r\n        get: function () {\r\n            return this.type_;\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    SessionDescription.prototype.syncBarrier = function () {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + '.syncBarrier() called.');\r\n        return new Promise(function (resolve, reject) {\r\n            _this.waitUntilConnected(_this.user_friendly_id() + '.syncBarrier')\r\n                .then(function () {\r\n                return Promise.all([\r\n                    _this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCSessionDescription_t.type, 0),\r\n                    _this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCSessionDescription_t.sdp, \"\")\r\n                ]);\r\n            })\r\n                .then(function (results) {\r\n                _this.type_ = _this.convertType(_this.param0(results[0]));\r\n                _this.sdp_ = _this.param0(results[1]);\r\n                resolve(_this);\r\n            })\r\n                .catch(function () { reject(); });\r\n        });\r\n    };\r\n    SessionDescription.prototype.convertType = function (id) {\r\n        if (id == 0) {\r\n            return \"offer\";\r\n        }\r\n        else if (id == 1) {\r\n            return \"pranswer\";\r\n        }\r\n        else {\r\n            return \"answer\";\r\n        }\r\n    };\r\n    SessionDescription.convertC2H = function (type) {\r\n        if (type == \"offer\") {\r\n            return 0;\r\n        }\r\n        else if (type == \"pranswer\") {\r\n            return 1;\r\n        }\r\n        else {\r\n            return 2;\r\n        }\r\n    };\r\n    return SessionDescription;\r\n}(proxyobject_1.ProxyObject));\r\nexports.SessionDescription = SessionDescription;\r\n/**@nocollapse*/\r\nvar PeerConnectionEvent = /** @class */ (function () {\r\n    function PeerConnectionEvent(type, obj) {\r\n        this.type = type;\r\n        this.target = obj;\r\n    }\r\n    return PeerConnectionEvent;\r\n}());\r\n/**@nocollapse*/\r\nvar TrackEvent = /** @class */ (function () {\r\n    function TrackEvent() {\r\n    }\r\n    return TrackEvent;\r\n}());\r\n/**@nocollapse*/\r\nvar CallStatus = /** @class */ (function () {\r\n    function CallStatus(local, remote) {\r\n        this.local = local;\r\n        this.remote = remote;\r\n    }\r\n    Object.defineProperty(CallStatus.prototype, \"active\", {\r\n        get: function () {\r\n            var rv = false;\r\n            if (this.local == true || this.remote == true) {\r\n                rv = true;\r\n            }\r\n            return rv;\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    return CallStatus;\r\n}());\r\n/**@nocollapse*/\r\nvar PeerConnection = /** @class */ (function (_super) {\r\n    __extends(PeerConnection, _super);\r\n    /// construct a new peer connection object\r\n    function PeerConnection(configuration) {\r\n        var _this = _super.call(this, null, webrpcclassinfo_1.class_id_t.RTCPeerConnection, 0, proxyobject_1.ProxyMode.Local, null, ensure_config_defined(configuration), {}) || this;\r\n        _this.timeerstarted_ = false;\r\n        _this.firsttimeremoteoffer_ = false;\r\n        _this.firststable_ = false;\r\n        _this.firsttimelocaloffer_ = false;\r\n        _this.audiocall_ = new CallStatus(false, false);\r\n        _this.videocall_ = new CallStatus(false, false);\r\n        _this.screensharingcall_ = new CallStatus(false, false);\r\n        _this.conferencecall_ = false;\r\n        _this.incomingcall_ = false;\r\n        _this.outgoingcall_ = false;\r\n        logger_1.logger.log(_this.user_friendly_id() + '.constructor');\r\n        _this.localStreams = [];\r\n        _this.remoteStreams = [];\r\n        _this.onaddstream_ = null;\r\n        _this.signalingState_ = \"stable\";\r\n        _this.iceConnectionState_ = \"new\";\r\n        _this.iceGatheringState_ = \"new\";\r\n        _this.iceQ_ = new IceGatherer(_this);\r\n        _this.receivers_ = [];\r\n        _this.senders_ = [];\r\n        _this.registerStateChangeNotification(_this.onStateChange);\r\n        return _this;\r\n    }\r\n    PeerConnection.prototype.onStateChange = function () {\r\n        var evt = new PeerConnectionEvent('iceconnectionstatechange', this);\r\n        if (this.oniceconnectionstatechange_) {\r\n            this.oniceconnectionstatechange_(evt); // not sure if this is the best way to post the event.\r\n        }\r\n    };\r\n    PeerConnection.prototype.addIceCandidate = function () {\r\n        logger_1.logger.log(this.user_friendly_id() + '.addIceCandidate');\r\n        logger_1.logger.log(arguments);\r\n    };\r\n    Object.defineProperty(PeerConnection.prototype, \"onicecandidate\", {\r\n        get: function () {\r\n            return this.onicecandidate_;\r\n        },\r\n        set: function (cb) {\r\n            var _this = this;\r\n            logger_1.logger.log(this.user_friendly_id() + '.set_onicecandidate() called.');\r\n            this.onicecandidate_ = cb;\r\n            this.waitUntilConnected(this.user_friendly_id() + '.onicecandidate')\r\n                .then(function () {\r\n                var callbacks = _this.registerCallbacks(false, _this.isNullCallback(cb), webrpcclassinfo_1.method_id_RTCPeerConnection_t.onicecandidate);\r\n                callbacks.then(function (obj) {\r\n                    logger_1.logger.log(_this.user_friendly_id() + '.onicecandidate callback received!!!');\r\n                    var ice_event = new IceCandidateEvent(_this, _this.param0(obj)['oid'], _this);\r\n                    if (_this.iceQ_ != null) {\r\n                        _this.iceQ_.addIceCandidate(ice_event);\r\n                    }\r\n                });\r\n                return _this.remoteInvoke(true, webrpcclassinfo_1.method_id_RTCPeerConnection_t.onicecandidate, callbacks['success']);\r\n            })\r\n                .catch(function () {\r\n                logger_1.logger.log(_this.user_friendly_id() + '.set_onicecandidate() failed.');\r\n            });\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    //*****************************\r\n    //native side enum value:\r\n    //enum class IceConnectionState {\r\n    //    New,\r\n    //    Checking,\r\n    //    Connected,\r\n    //    Completed,\r\n    //    Failed,\r\n    //    Disconnected,\r\n    //    Closed,\r\n    //    Max\r\n    //};\r\n    //*****************************\r\n    //JS side enum value\r\n    //enum RTCIceConnectionState {\r\n    //\"new\",\r\n    //\"checking\",\r\n    //\"connected\",\r\n    //\"completed\",\r\n    //\"disconnected\",\r\n    //\"failed\",\r\n    //\"closed\"\r\n    //};\r\n    PeerConnection.prototype.convertIceConnectionState = function (id) {\r\n        if (id == 0) {\r\n            return \"new\";\r\n        }\r\n        else if (id == 1) {\r\n            return \"checking\";\r\n        }\r\n        else if (id == 2) {\r\n            return \"connected\";\r\n        }\r\n        else if (id == 3) {\r\n            return \"completed\";\r\n        }\r\n        else if (id == 4) {\r\n            return \"failed\";\r\n        }\r\n        else if (id == 5) {\r\n            return \"disconnected\";\r\n        }\r\n        else if (id == 6) {\r\n            return \"closed\";\r\n        }\r\n        return \"closed\";\r\n    };\r\n    Object.defineProperty(PeerConnection.prototype, \"oniceconnectionstatechange\", {\r\n        get: function () {\r\n            return this.oniceconnectionstatechange_;\r\n        },\r\n        set: function (cb) {\r\n            var _this = this;\r\n            logger_1.logger.log(this.user_friendly_id() + '.set_oniceconnectionstatechange() called.');\r\n            this.oniceconnectionstatechange_ = cb;\r\n            this.waitUntilConnected(this.user_friendly_id() + '.oniceconnectionstatechange')\r\n                .then(function () {\r\n                var callbacks = _this.registerCallbacks(false, _this.isNullCallback(cb), webrpcclassinfo_1.method_id_RTCPeerConnection_t.oniceconnectionstatechange);\r\n                callbacks.then(function (obj) {\r\n                    logger_1.logger.log(_this.user_friendly_id() + '.oniceconnectionstatechange(): success callback received!!!');\r\n                    // when we get the callback, we just update the property and post a notification.\r\n                    _this.iceConnectionState_ = _this.convertIceConnectionState(_this.param0(obj)); // return val is enum (int) so convert to appropriate string value\r\n                    var evt = new PeerConnectionEvent('iceconnectionstatechange', _this);\r\n                    _this.oniceconnectionstatechange_(evt); // not sure if this is the best way to post the event.\r\n                });\r\n                return _this.remoteInvoke(true, webrpcclassinfo_1.method_id_RTCPeerConnection_t.oniceconnectionstatechange, callbacks.success);\r\n            })\r\n                .catch(function () {\r\n                logger_1.logger.log(_this.user_friendly_id() + '.set_oniceconnectionstatechange() failed.');\r\n            });\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    Object.defineProperty(PeerConnection.prototype, \"iceConnectionState\", {\r\n        // iceConnectionState\r\n        get: function () {\r\n            logger_1.logger.log(this.user_friendly_id() + '.get_iceConnectionState() called, value = ' + this.iceConnectionState_);\r\n            if (this.isRedirected()) {\r\n                return this.iceConnectionState_;\r\n            }\r\n            else {\r\n                return \"failed\";\r\n            }\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    //*****************************\r\n    //native side enum value:\r\n    //enum class IceGatheringState {\r\n    //    New,\r\n    //    Gathering,\r\n    //    Complete\r\n    //};\r\n    //*****************************\r\n    //JS side enum value    \r\n    //enum RTCIceGatheringState {\r\n    //\"new\",\r\n    //\"gathering\",\r\n    //\"complete\"\r\n    //};\r\n    PeerConnection.prototype.convertIceGatheringState = function (id) {\r\n        if (id == 0) {\r\n            return \"new\";\r\n        }\r\n        else if (id == 1) {\r\n            return \"gathering\";\r\n        }\r\n        else if (id == 2) {\r\n            return \"complete\";\r\n        }\r\n        return \"complete\";\r\n    };\r\n    Object.defineProperty(PeerConnection.prototype, \"onicegatheringstatechange\", {\r\n        get: function () {\r\n            return this.onicegatheringstatechange_;\r\n        },\r\n        set: function (cb) {\r\n            var _this = this;\r\n            logger_1.logger.log(this.user_friendly_id() + '.set_onicegatheringstatechange() called.');\r\n            this.onicegatheringstatechange_ = cb;\r\n            this.waitUntilConnected(this.user_friendly_id() + '.onicegatheringstatechange')\r\n                .then(function () {\r\n                var callbacks = _this.registerCallbacks(false, _this.isNullCallback(cb), webrpcclassinfo_1.method_id_RTCPeerConnection_t.onicegatheringstatechange);\r\n                callbacks.then(function (obj) {\r\n                    logger_1.logger.log(_this.user_friendly_id() + '.onicegatheringstatechange(): callback received!!!');\r\n                    // when we get the callback, we just update the property and post a notification.\r\n                    _this.iceGatheringState_ = _this.convertIceGatheringState(_this.param0(obj)); // return val is enum (int) so convert to appropriate string value\r\n                    if (_this.iceQ_ != null) {\r\n                        _this.iceQ_.pushState(_this.iceGatheringState_);\r\n                    }\r\n                });\r\n                return _this.remoteInvoke(true, webrpcclassinfo_1.method_id_RTCPeerConnection_t.onicegatheringstatechange, callbacks.success);\r\n            })\r\n                .catch(function () {\r\n                logger_1.logger.log(_this.user_friendly_id() + '.set_onicegatheringstatechange() failed.');\r\n            });\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    Object.defineProperty(PeerConnection.prototype, \"iceGatheringState\", {\r\n        // iceGatheringState\r\n        get: function () {\r\n            logger_1.logger.log(this.user_friendly_id() + '.get_iceGatheringState() called, value = ' + this.iceGatheringState_);\r\n            return this.iceGatheringState_;\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    //*****************************\r\n    //native side enum value:\r\n    //enum class SignalingState {\r\n    //    Stable,\r\n    //    HaveLocalOffer,\r\n    //    HaveLocalPrAnswer,\r\n    //    HaveRemoteOffer,\r\n    //    HaveRemotePrAnswer,\r\n    //    Closed\r\n    //};\r\n    //*****************************\r\n    //JS side enum value\r\n    //enum RTCSignalingState {\r\n    //    \"stable\",\r\n    //    \"have-local-offer\",\r\n    //    \"have-remote-offer\",\r\n    //    \"have-local-pranswer\",\r\n    //    \"have-remote-pranswer\",\r\n    //    \"closed\"\r\n    //};\r\n    PeerConnection.prototype.convertSignalState = function (id) {\r\n        if (id == 0) {\r\n            return \"stable\";\r\n        }\r\n        else if (id == 1) {\r\n            return \"have-local-offer\";\r\n        }\r\n        else if (id == 2) {\r\n            return \"have-local-pranswer\";\r\n        }\r\n        else if (id == 3) {\r\n            return \"have-remote-offer\";\r\n        }\r\n        else if (id == 4) {\r\n            return \"have-remote-pranswer\";\r\n        }\r\n        else if (id == 5) {\r\n            return \"closed\";\r\n        }\r\n        return \"closed\";\r\n    };\r\n    PeerConnection.prototype.TelemtryReadings_ = function () {\r\n        if ((this.signalingState_ == \"have-local-offer\") && (this.firsttimelocaloffer_ == false) && (this.firsttimeremoteoffer_ == false)) {\r\n            this.outgoingcallstart_ = (new Date()).getTime();\r\n            if (this.outgoingcall_ == false) {\r\n                //Perf: we are about to start outgoing call\r\n                this.SendTelemetryData(telemetry_1.tel_key_PerfCallState, telemetry_1.tel_CallState.active, 1);\r\n                this.SendTelemetryData(telemetry_1.tel_key_PerfCallDirection, telemetry_1.tel_CallDirection.outgoing, 1);\r\n                this.outgoingcall_ = true;\r\n            }\r\n            this.firsttimelocaloffer_ = true;\r\n        }\r\n        if ((this.signalingState_ == \"have-remote-offer\") && (this.firsttimeremoteoffer_ == false) && (this.firsttimelocaloffer_ == false)) {\r\n            this.incomingcallstart_ = (new Date()).getTime();\r\n            if (this.incomingcall_ == false) {\r\n                //Perf: we are about to start incoming call\r\n                this.SendTelemetryData(telemetry_1.tel_key_PerfCallState, telemetry_1.tel_CallState.active, 1);\r\n                this.SendTelemetryData(telemetry_1.tel_key_PerfCallDirection, telemetry_1.tel_CallDirection.incoming, 1);\r\n                this.incomingcall_ = true;\r\n            }\r\n            this.firsttimeremoteoffer_ = true;\r\n        }\r\n        if ((this.signalingState_ == \"stable\") && (this.firststable_ == false)) {\r\n            this.callstartTime_ = (new Date()).getTime();\r\n            this.timeerstarted_ = true;\r\n            this.firststable_ = true;\r\n        }\r\n        if (this.signalingState_ == \"stable\") {\r\n            for (var _i = 0, _a = this.localStreams; _i < _a.length; _i++) {\r\n                var s = _a[_i];\r\n                var localaud = s.getAudioTracks();\r\n                if (localaud.length >= 1) {\r\n                    if (this.audiocall_.local == false) {\r\n                        //Perf: audio channel is active\r\n                        this.SendTelemetryData(telemetry_1.tel_key_PerfCallType, telemetry_1.tel_CallType.audio, 1);\r\n                        this.audiocall_.local = true;\r\n                        //console.log(\"local Audio call\");\r\n                    }\r\n                }\r\n                var localvid = s.getVideoTracks();\r\n                if (localvid.length >= 1) {\r\n                    for (var _b = 0, localvid_1 = localvid; _b < localvid_1.length; _b++) {\r\n                        var track = localvid_1[_b];\r\n                        var deviceid = track.getSettings().deviceId;\r\n                        var screensharingdeviceid = \"display\";\r\n                        var outscreensharing = deviceid.includes(screensharingdeviceid);\r\n                        if (outscreensharing == true) {\r\n                            if (this.screensharingcall_.local == false) {\r\n                                //Perf: conference is active\r\n                                this.SendTelemetryData(telemetry_1.tel_key_PerfCallType, telemetry_1.tel_CallType.dshare, 1);\r\n                                this.screensharingcall_.local = true;\r\n                                // console.log(\"Outgoing Desktop ScreenSharing\");\r\n                            }\r\n                        }\r\n                        else {\r\n                            if (this.videocall_.local == false) {\r\n                                //Perf: video channel is active\r\n                                this.SendTelemetryData(telemetry_1.tel_key_PerfCallType, telemetry_1.tel_CallType.video, 1);\r\n                                this.videocall_.local = true;\r\n                                // console.log(\"local Video Call\");\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n            for (var _c = 0, _d = this.remoteStreams; _c < _d.length; _c++) {\r\n                var track = _d[_c];\r\n                var remoteaud = track.getAudioTracks();\r\n                if (remoteaud.length >= 1) {\r\n                    if (this.audiocall_.remote == false) {\r\n                        //Perf: audio channel is active\r\n                        this.SendTelemetryData(telemetry_1.tel_key_PerfCallType, telemetry_1.tel_CallType.audio, 1);\r\n                        this.audiocall_.remote = true;\r\n                        //console.log(\"remote Audio call\");\r\n                    }\r\n                }\r\n                var remotevid = track.getVideoTracks();\r\n                if (remotevid.length >= 1) {\r\n                    for (var _e = 0, remotevid_1 = remotevid; _e < remotevid_1.length; _e++) {\r\n                        var track_1 = remotevid_1[_e];\r\n                        var id = track_1.id;\r\n                        var screensharingid = \"applicationsharingVideo\";\r\n                        var inscreensharing = id.includes(screensharingid);\r\n                        if (inscreensharing == true) {\r\n                            if (this.screensharingcall_.remote == false) {\r\n                                //Perf: conference is active\r\n                                this.SendTelemetryData(telemetry_1.tel_key_PerfCallType, telemetry_1.tel_CallType.dshare, 1);\r\n                                this.screensharingcall_.remote = true;\r\n                                //console.log(\"Incoming Desktop ScreenSharing\");\r\n                            }\r\n                        }\r\n                        else {\r\n                            if (this.videocall_.remote == false) {\r\n                                //Perf: video channel is active\r\n                                this.SendTelemetryData(telemetry_1.tel_key_PerfCallType, telemetry_1.tel_CallType.video, 1);\r\n                                this.videocall_.remote = true;\r\n                                // console.log(\"remote Video Call\");\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n            var conferncecall = this.getReceivers();\r\n            if (conferncecall.length > 2) {\r\n                if (this.conferencecall_ == false) {\r\n                    //Perf: conference is active\r\n                    this.SendTelemetryData(telemetry_1.tel_key_PerfCallType, telemetry_1.tel_CallType.multi, 1);\r\n                    this.conferencecall_ = true;\r\n                }\r\n            }\r\n        }\r\n    };\r\n    Object.defineProperty(PeerConnection.prototype, \"onsignalingstatechange\", {\r\n        set: function (f) {\r\n            var _this = this;\r\n            logger_1.logger.log(this.user_friendly_id() + '.set_onsignalingstatechange() called.');\r\n            this.onsignalingstatechange_ = f;\r\n            this.waitUntilConnected(this.user_friendly_id() + '.onsignalingstatechanged')\r\n                .then(function () {\r\n                var callbacks = _this.registerCallbacks(false, _this.isNullCallback(f), webrpcclassinfo_1.method_id_RTCPeerConnection_t.onsignalingstatechange);\r\n                callbacks.then(function (obj) {\r\n                    logger_1.logger.log(_this.user_friendly_id() + '.onsignalingstatechange(): callback received!!!');\r\n                    // when we get the callback, we just update the property and post a notification.\r\n                    _this.signalingState_ = _this.convertSignalState(_this.param0(obj)); // return val is enum (int) so convert to appropriate string value\r\n                    var evt = new PeerConnectionEvent('onsignalingstatechange', _this);\r\n                    _this.onsignalingstatechange_(evt); // not sure if this is the best way to post the event.\r\n                    _this.TelemtryReadings_();\r\n                });\r\n                return _this.remoteInvoke(true, webrpcclassinfo_1.method_id_RTCPeerConnection_t.onsignalingstatechange, callbacks.success);\r\n            })\r\n                .catch(function () {\r\n                logger_1.logger.log(_this.user_friendly_id() + '.set_onsignalingstatechange(): failed.');\r\n            });\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    Object.defineProperty(PeerConnection.prototype, \"onsignalingstatechanged\", {\r\n        get: function () {\r\n            return this.onsignalingstatechange_;\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    Object.defineProperty(PeerConnection.prototype, \"ontrack\", {\r\n        get: function () {\r\n            return this.ontrack_;\r\n        },\r\n        set: function (f) {\r\n            var _this = this;\r\n            logger_1.logger.log(this.user_friendly_id() + '.set_ontrack() called.');\r\n            this.ontrack_ = f;\r\n            this.waitUntilConnected(this.user_friendly_id() + '.ontrack')\r\n                .then(function () {\r\n                var callbacks = _this.registerCallbacks(false, _this.isNullCallback(f), webrpcclassinfo_1.method_id_RTCPeerConnection_t.ontrack);\r\n                callbacks.then(function (obj) { return __awaiter(_this, void 0, void 0, function () {\r\n                    var track_event, receiver, remote_streams, _loop_1, this_1, _i, _a, s, evt;\r\n                    return __generator(this, function (_b) {\r\n                        switch (_b.label) {\r\n                            case 0:\r\n                                logger_1.logger.log(this.user_friendly_id() + '.ontrack(): callback received!!!');\r\n                                track_event = this.param0(obj);\r\n                                receiver = this.receivers_.find(function (r) { return (track_event.receiver['is_null'] === false && r.object_id() === track_event.receiver['oid']); });\r\n                                if (!(receiver === undefined)) return [3 /*break*/, 2];\r\n                                receiver = new rtpsender_1.RtpReceiver(this, track_event.receiver['oid']);\r\n                                return [4 /*yield*/, receiver.syncBarrier()];\r\n                            case 1:\r\n                                _b.sent();\r\n                                this.receivers_.push(receiver);\r\n                                _b.label = 2;\r\n                            case 2:\r\n                                if (!(track_event.transceiver['is_null'] === false && (this.transceiver_ === null || this.transceiver_ === undefined || this.transceiver_.object_id() != track_event.transceiver['oid']))) return [3 /*break*/, 4];\r\n                                this.transceiver_ = new rtptransceiver_1.RtpTransceiver(this, track_event.transceiver['oid']);\r\n                                return [4 /*yield*/, this.transceiver_.syncBarrier()];\r\n                            case 3:\r\n                                _b.sent();\r\n                                _b.label = 4;\r\n                            case 4:\r\n                                remote_streams = [];\r\n                                _loop_1 = function (s) {\r\n                                    var stream;\r\n                                    return __generator(this, function (_a) {\r\n                                        switch (_a.label) {\r\n                                            case 0:\r\n                                                stream = this_1.remoteStreams.find(function (r) { return (s['is_null'] === false && r.object_id() === s['oid']); });\r\n                                                if (!(stream === undefined)) return [3 /*break*/, 2];\r\n                                                stream = new remotemedia_1.RemoteStream(this_1, s['oid']);\r\n                                                return [4 /*yield*/, stream.syncBarrier()];\r\n                                            case 1:\r\n                                                _a.sent();\r\n                                                _a.label = 2;\r\n                                            case 2:\r\n                                                remote_streams.push(stream);\r\n                                                return [2 /*return*/];\r\n                                        }\r\n                                    });\r\n                                };\r\n                                this_1 = this;\r\n                                _i = 0, _a = track_event.streams;\r\n                                _b.label = 5;\r\n                            case 5:\r\n                                if (!(_i < _a.length)) return [3 /*break*/, 8];\r\n                                s = _a[_i];\r\n                                return [5 /*yield**/, _loop_1(s)];\r\n                            case 6:\r\n                                _b.sent();\r\n                                _b.label = 7;\r\n                            case 7:\r\n                                _i++;\r\n                                return [3 /*break*/, 5];\r\n                            case 8:\r\n                                this.remoteStreams = remote_streams;\r\n                                evt = new TrackEvent();\r\n                                evt.receiver = receiver;\r\n                                evt.streams = this.remoteStreams;\r\n                                evt.transceiver = this.transceiver_;\r\n                                evt.track = receiver.track;\r\n                                logger_1.logger.log(this.user_friendly_id() + '.ontrack(): notified!!!');\r\n                                this.ontrack_(evt);\r\n                                return [2 /*return*/];\r\n                        }\r\n                    });\r\n                }); });\r\n                return _this.remoteInvoke(true, webrpcclassinfo_1.method_id_RTCPeerConnection_t.ontrack, callbacks.success);\r\n            })\r\n                .catch(function () {\r\n                logger_1.logger.log(_this.user_friendly_id() + '.set_ontrack(): failed.');\r\n            });\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    Object.defineProperty(PeerConnection.prototype, \"signalingState\", {\r\n        // signalingState\r\n        get: function () {\r\n            logger_1.logger.log(this.user_friendly_id() + '.get_signalingState() called, value = ' + this.signalingState_);\r\n            return this.signalingState_;\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    Object.defineProperty(PeerConnection.prototype, \"onnegotiationneeded\", {\r\n        get: function () {\r\n            return this.onnegotiationneeded_;\r\n        },\r\n        // on renegotiation needed event\r\n        set: function (f) {\r\n            var _this = this;\r\n            logger_1.logger.log(this.user_friendly_id() + '.set_onnegotiationneeded() called.');\r\n            this.onnegotiationneeded_ = f;\r\n            this.waitUntilConnected(this.user_friendly_id() + '.onnegotiationneeded')\r\n                .then(function () {\r\n                var callbacks = _this.registerCallbacks(false, _this.isNullCallback(f), webrpcclassinfo_1.method_id_RTCPeerConnection_t.onnegotiationneeded);\r\n                callbacks.then(function () {\r\n                    logger_1.logger.log(_this.user_friendly_id() + '.onnegotiationneeded(): callback received!!!');\r\n                    var evt = new PeerConnectionEvent('negotiationneeded', _this);\r\n                    _this.onnegotiationneeded_(evt); // not sure if this is the best way to post the event.\r\n                });\r\n                return _this.remoteInvoke(true, webrpcclassinfo_1.method_id_RTCPeerConnection_t.onnegotiationneeded, callbacks['success']);\r\n            })\r\n                .catch(function () {\r\n                logger_1.logger.log(_this.user_friendly_id() + '.set_onnegotiationneeded(): failed.');\r\n            });\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    PeerConnection.prototype.fix_constraints = function (constraints) {\r\n        var av = { audio: true, video: true };\r\n        if (constraints) {\r\n            if (typeof constraints.video !== undefined)\r\n                av['video'] = constraints['offerToReceiveVideo'];\r\n            if (typeof constraints.audio !== undefined)\r\n                av['audio'] = constraints['offerToReceiveAudio'];\r\n        }\r\n        return av;\r\n    };\r\n    PeerConnection.prototype.createOffer = function (successCallback, errorCallback, constraints) {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + '.createOffer() called.', JSON.stringify(constraints));\r\n        this.waitUntilConnected(this.user_friendly_id() + '.createOffer')\r\n            .then(function () {\r\n            var callbacks = _this.registerCallbacks(true, false, webrpcclassinfo_1.method_id_RTCPeerConnection_t.createOffer);\r\n            _this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCPeerConnection_t.createOffer, callbacks.success, callbacks.fail, _this.fix_constraints(constraints));\r\n            return callbacks.prom();\r\n        })\r\n            .then(function (obj) {\r\n            logger_1.logger.log(_this.user_friendly_id() + '.createOffer(): success callback received!!!');\r\n            var sdp = new SessionDescription(_this, _this.param0(obj)['oid'], proxyobject_1.ProxyMode.Remote);\r\n            return sdp.syncBarrier();\r\n        })\r\n            .then(function (sdp) {\r\n            if (successCallback) {\r\n                successCallback(sdp);\r\n            }\r\n        })\r\n            .catch(function (err) {\r\n            if ((err) != undefined) {\r\n                logger_1.logger.log(_this.user_friendly_id() + '.createOffer() failed, with error' + _this.param0(err));\r\n                if (errorCallback) {\r\n                    errorCallback(new DOMException('PeerConnection.createOffer() failed with error' + _this.param0(err), 'PeerConnection'));\r\n                }\r\n            }\r\n        });\r\n    };\r\n    PeerConnection.prototype.createAnswer = function (successCallback, errorCallback, constraints) {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + '.createAnswer() called.', JSON.stringify(constraints));\r\n        this.waitUntilConnected(this.user_friendly_id() + '.createAnswer')\r\n            .then(function () {\r\n            var callbacks = _this.registerCallbacks(true, false, webrpcclassinfo_1.method_id_RTCPeerConnection_t.createAnswer);\r\n            _this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCPeerConnection_t.createAnswer, callbacks.success, callbacks.fail, _this.fix_constraints(constraints), {});\r\n            return callbacks.prom();\r\n        })\r\n            .then(function (obj) {\r\n            logger_1.logger.log(_this.user_friendly_id() + '.createAnswer(): success callback received!!!');\r\n            var sdp = new SessionDescription(_this, _this.param0(obj)['oid'], proxyobject_1.ProxyMode.Remote);\r\n            return sdp.syncBarrier();\r\n        })\r\n            .then(function (sdp) {\r\n            if (successCallback) {\r\n                successCallback(sdp);\r\n            }\r\n        })\r\n            .catch(function () {\r\n            logger_1.logger.log(_this.user_friendly_id() + '.createAnswer() failed.');\r\n            if (errorCallback) {\r\n                errorCallback('PeerConnection::createAnswer() failed.');\r\n            }\r\n        });\r\n    };\r\n    PeerConnection.prototype.updateLocalDescription = function () {\r\n        return __awaiter(this, void 0, void 0, function () {\r\n            var obj, sdp, updated_sdp;\r\n            var _this = this;\r\n            return __generator(this, function (_a) {\r\n                switch (_a.label) {\r\n                    case 0:\r\n                        logger_1.logger.log(this.user_friendly_id() + '.updateLocalDescription() called.');\r\n                        return [4 /*yield*/, this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCPeerConnection_t.localDescription, { \"oid\": this.object_id() })];\r\n                    case 1:\r\n                        obj = _a.sent();\r\n                        sdp = new SessionDescription(this, this.param0(obj)['oid'], proxyobject_1.ProxyMode.Remote);\r\n                        return [4 /*yield*/, sdp.syncBarrier()\r\n                                .catch(function () {\r\n                                logger_1.logger.log(_this.user_friendly_id() + 'sdp.syncBarrier(): failed!');\r\n                                return null;\r\n                            })];\r\n                    case 2:\r\n                        updated_sdp = _a.sent();\r\n                        this.localDescription = updated_sdp;\r\n                        return [2 /*return*/];\r\n                }\r\n            });\r\n        });\r\n    };\r\n    PeerConnection.prototype.setLocalDescription = function (description, successCallback, errorCallback) {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + '.setLocalDescription() called.');\r\n        // I was expecting description to be one our SessionDescription objects but it is really a RTCSessionDescription object.\r\n        // Teams/Electron must have constructed a RTCSessionDescription object from what we returned.\r\n        this.waitUntilConnected(this.user_friendly_id() + '.setLocalDescription')\r\n            .then(function () {\r\n            // create a new session description (RPC engine side) for the RTCSessionDescription\r\n            var ldesc = new SessionDescription(_this, 0, proxyobject_1.ProxyMode.Local, { \"type\": SessionDescription.convertC2H(description.type), \"sdp\": description.sdp });\r\n            // synchronize it\r\n            return ldesc.syncBarrier();\r\n        })\r\n            .then(function (sdp) {\r\n            var callbacks = _this.registerCallbacks(true, false, webrpcclassinfo_1.method_id_RTCPeerConnection_t.setLocalDescription);\r\n            _this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCPeerConnection_t.setLocalDescription, { \"oid\": sdp.object_id() }, callbacks.success, callbacks.fail);\r\n            callbacks.prom().then(function () {\r\n                logger_1.logger.log(_this.user_friendly_id() + '.setLocalDescription(): success callback received!!!');\r\n                _this.localDescription = sdp;\r\n                if (successCallback) {\r\n                    successCallback();\r\n                }\r\n                //to support createDTMFSender\r\n                //this.getSenders();\r\n            });\r\n        })\r\n            .catch(function () {\r\n            logger_1.logger.log(_this.user_friendly_id() + '.setLocalDescription() failed.');\r\n            if (errorCallback) {\r\n                errorCallback('PeerConnection::setLocalDescription() failed.');\r\n            }\r\n        });\r\n    };\r\n    PeerConnection.prototype.setRemoteDescription = function (description, successCallback, errorCallback) {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + '.setRemoteDescription() called.');\r\n        this.waitUntilConnected(this.user_friendly_id() + '.setRemoteDescription')\r\n            .then(function () {\r\n            // create a new session description (RPC engine side) for the RTCSessionDescription\r\n            var rdesc = new SessionDescription(_this, 0, proxyobject_1.ProxyMode.Local, { \"type\": SessionDescription.convertC2H(description.type), \"sdp\": description.sdp });\r\n            // synchronize it\r\n            return rdesc.syncBarrier();\r\n        })\r\n            .then(function (sdp) {\r\n            var callbacks = _this.registerCallbacks(true, false, webrpcclassinfo_1.method_id_RTCPeerConnection_t.setRemoteDescription);\r\n            _this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCPeerConnection_t.setRemoteDescription, { \"oid\": sdp.object_id() }, callbacks.success, callbacks.fail);\r\n            callbacks.prom().then(function () {\r\n                logger_1.logger.log(_this.user_friendly_id() + '.setRemoteDescription(): success callback received!!!');\r\n                _this.remoteDescription = sdp;\r\n                if (successCallback) {\r\n                    successCallback();\r\n                }\r\n                //to support createDTMFSender\r\n                _this.getSenders();\r\n            });\r\n        })\r\n            .catch(function () {\r\n            logger_1.logger.log(_this.user_friendly_id() + '.setRemoteDescription() failed.');\r\n            if (errorCallback) {\r\n                errorCallback('PeerConnection::setRemoteDescription() failed.');\r\n            }\r\n        });\r\n    };\r\n    // getLocalStreams: what do we do here?\r\n    PeerConnection.prototype.getLocalStreams = function () {\r\n        logger_1.logger.log('PeerConnection.getLocalStreams() called. [oid=' + this.object_id() + ']');\r\n        for (var _i = 0, _a = this.localStreams; _i < _a.length; _i++) {\r\n            var s = _a[_i];\r\n            logger_1.logger.log(JSON.stringify(s));\r\n        }\r\n        return this.localStreams;\r\n    };\r\n    PeerConnection.prototype.getRemoteStreams = function () {\r\n        logger_1.logger.log(this.user_friendly_id() + '.getRemoteStreams() called.');\r\n        for (var _i = 0, _a = this.remoteStreams; _i < _a.length; _i++) {\r\n            var s = _a[_i];\r\n            logger_1.logger.log(JSON.stringify(s));\r\n        }\r\n        return this.remoteStreams;\r\n    };\r\n    PeerConnection.prototype.addTrack = function (track, streams) {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + '.addTrack() called: ' + JSON.stringify(streams));\r\n        var streamids = [];\r\n        if (streams instanceof remotemedia_1.RemoteStream) {\r\n            streamids.push(streams.id);\r\n        }\r\n        else {\r\n            for (var i = 0; i < streams.length; i++) {\r\n                streamids.push(streams[i].id);\r\n            }\r\n        }\r\n        var sender = new rtpsender_1.RtpSender(this, 0, proxyobject_1.ProxyMode.Pseudo); //create TS side pseudo object first\r\n        this.senders_.push(sender);\r\n        this.waitUntilConnected(this.user_friendly_id() + '.addTrack')\r\n            .then(function () {\r\n            return _this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCPeerConnection_t.addTrack, { \"oid\": track.object_id() }, streamids);\r\n        })\r\n            .then(function (obj) {\r\n            logger_1.logger.log(_this.user_friendly_id() + '.addTrack() success with oid: ' + _this.param0(obj)['oid']);\r\n            sender.bind(_this, _this.param0(obj)['oid']);\r\n            sender.syncBarrier()\r\n                .catch(function () {\r\n                logger_1.logger.log(_this.user_friendly_id() + 'sender.syncBarrier(): failed!');\r\n            });\r\n        })\r\n            .catch(function (obj) {\r\n            var err = _this.param0(obj);\r\n            logger_1.logger.log(_this.user_friendly_id() + '.addTrack() failed with error: ' + err);\r\n        });\r\n        logger_1.logger.log(this.user_friendly_id() + '.addTrack() returning: ' + sender);\r\n        return sender;\r\n    };\r\n    PeerConnection.prototype.removeTrack = function (sender) {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + '.removeTrack() called.');\r\n        for (var i = 0; i < this.senders_.length; i++) {\r\n            if (this.senders_[i] == sender) {\r\n                this.senders_.splice(i, 1);\r\n            }\r\n        }\r\n        this.waitUntilConnected(this.user_friendly_id() + '.removeTrack')\r\n            .then(function () {\r\n            return _this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCPeerConnection_t.removeTrack, { \"oid\": sender.object_id() });\r\n        })\r\n            .then(function () {\r\n            logger_1.logger.log(_this.user_friendly_id() + '.removeTrack() success.');\r\n        })\r\n            .catch(function () {\r\n            logger_1.logger.log(_this.user_friendly_id() + '.removeTrack() failed.');\r\n        });\r\n    };\r\n    PeerConnection.prototype.addStream = function (stream /*, constraints: MediaConstraints*/) {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + '.addStream() called: ' + JSON.stringify(stream));\r\n        stream.dumpTrackInfo();\r\n        this.localStreams.push(stream);\r\n        this.waitUntilConnected(this.user_friendly_id() + '.addStream')\r\n            .then(function () { return _this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCPeerConnection_t.addStream, { \"oid\": stream.object_id() }, {}); })\r\n            .then(function () { logger_1.logger.log(_this.user_friendly_id() + '.addStream() success.'); })\r\n            .catch(function () { logger_1.logger.log(_this.user_friendly_id() + '.addStream() failed.'); });\r\n    };\r\n    PeerConnection.prototype.removeStream = function (stream) {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + '.removeStream() called: ' + JSON.stringify(stream));\r\n        for (var i = 0; i < this.localStreams.length; i++) {\r\n            if (this.localStreams[i] == stream) {\r\n                this.localStreams.splice(i, 1);\r\n            }\r\n        }\r\n        this.waitUntilConnected(this.user_friendly_id() + '.removeStream')\r\n            .then(function () { return _this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCPeerConnection_t.removeStream, { \"oid\": stream.object_id() }); })\r\n            .then(function () { logger_1.logger.log(_this.user_friendly_id() + '.removeStream() success.'); })\r\n            .catch(function () { logger_1.logger.log(_this.user_friendly_id() + '.removeStream() failed.'); });\r\n    };\r\n    Object.defineProperty(PeerConnection.prototype, \"onaddstream\", {\r\n        get: function () {\r\n            return this.onaddstream_;\r\n        },\r\n        set: function (f) {\r\n            var _this = this;\r\n            logger_1.logger.log(this.user_friendly_id() + '.set_onaddstream() called.');\r\n            this.onaddstream_ = f;\r\n            this.waitUntilConnected(this.user_friendly_id() + '.onaddstream')\r\n                .then(function () {\r\n                var callbacks = _this.registerCallbacks(false, _this.isNullCallback(f), webrpcclassinfo_1.method_id_RTCPeerConnection_t.onaddstream);\r\n                callbacks.then(function (obj) {\r\n                    var streamEvent = new remotemedia_1.RemoteStreamEvent(_this, _this.param0(obj)['oid']);\r\n                    streamEvent.syncBarrier().then(function (evt) {\r\n                        logger_1.logger.log(_this.user_friendly_id() + '.onaddstream callback received!');\r\n                        var stream = _this.remoteStreams.find(function (r) { return (evt.stream != undefined && r.object_id() === evt.stream.object_id()); });\r\n                        if (stream === undefined) {\r\n                            _this.remoteStreams.push(evt.stream);\r\n                        }\r\n                        if (_this.onaddstream_ != undefined) {\r\n                            _this.onaddstream_(evt);\r\n                        }\r\n                    });\r\n                });\r\n                return _this.remoteInvoke(true, webrpcclassinfo_1.method_id_RTCPeerConnection_t.onaddstream, callbacks.success);\r\n            })\r\n                .catch(function () { logger_1.logger.log(_this.user_friendly_id() + '.set_onaddstream(): failed!'); });\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    Object.defineProperty(PeerConnection.prototype, \"onremovestream\", {\r\n        get: function () {\r\n            return this.onremovestream_;\r\n        },\r\n        set: function (f) {\r\n            var _this = this;\r\n            logger_1.logger.log(this.user_friendly_id() + '.set_onremovestream() called.');\r\n            this.onremovestream_ = f;\r\n            this.waitUntilConnected(this.user_friendly_id() + '.onremovestream')\r\n                .then(function () {\r\n                var cbs = _this.registerCallbacks(false, _this.isNullCallback(f), webrpcclassinfo_1.method_id_RTCPeerConnection_t.onremovestream);\r\n                cbs.then(function (obj) {\r\n                    var event = new remotemedia_1.RemoteStreamEvent(_this, _this.param0(obj)['oid']);\r\n                    event.syncBarrier().then(function (e) {\r\n                        logger_1.logger.log(_this.user_friendly_id() + '.onremovestream callback received!');\r\n                        var idx = _this.remoteStreams.findIndex(function (item) { return item.id == e.stream.id; });\r\n                        if (idx >= 0) {\r\n                            _this.remoteStreams.splice(idx, 1);\r\n                        }\r\n                        _this.onremovestream_(e);\r\n                    });\r\n                });\r\n                return _this.remoteInvoke(true, webrpcclassinfo_1.method_id_RTCPeerConnection_t.onremovestream, cbs.success);\r\n            })\r\n                .catch(function () { logger_1.logger.log(_this.user_friendly_id() + '.set_onremovestream(): failed!'); });\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    //https://www.w3.org/TR/webrtc-stats/#dfn-stats-object\r\n    //a collection of stats objects, which is dictionary type RTCStats\r\n    PeerConnection.prototype.getStats = function (cb) {\r\n        //too verbose\r\n        //logger.log(this.user_friendly_id() + '.getStats');\r\n        var self = this;\r\n        return new Promise(function (resolve, reject) {\r\n            if (!self.isRedirected()) {\r\n                logger_1.logger.log(self.user_friendly_id() + '.getStats(): not in active redirection!');\r\n                cb({});\r\n                resolve();\r\n            }\r\n            else {\r\n                self.waitUntilConnected(self.user_friendly_id() + '.getStats')\r\n                    .then(function () {\r\n                    var callback = self.registerCallbacks(true, false, webrpcclassinfo_1.method_id_RTCPeerConnection_t.getStats);\r\n                    callback.then(function (obj) {\r\n                        if (obj['params'] === undefined || obj['params'].length === 0) {\r\n                            return;\r\n                        }\r\n                        cb(stats_1.StatsReport.fromJSON(JSON.parse(obj['params'][0])));\r\n                        resolve();\r\n                    });\r\n                    return self.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCPeerConnection_t.getStats, callback.success);\r\n                })\r\n                    .catch(function () {\r\n                    logger_1.logger.log(self.user_friendly_id() + '.getStats(): failed!');\r\n                    reject();\r\n                });\r\n            }\r\n        });\r\n    };\r\n    PeerConnection.prototype.SendTelemetryData = function (key_, value_, flags_) {\r\n        hdxms_1.getRedirector().telemetry.SendTelemetryData(telemetry_1.tel_cmd.Data, key_, value_, flags_);\r\n    };\r\n    PeerConnection.prototype.MillisecondstoDisplayformat_ = function (time) {\r\n        var day, hour, minute, seconds;\r\n        seconds = Math.floor(time / 1000);\r\n        minute = Math.floor(seconds / 60);\r\n        seconds = seconds % 60;\r\n        hour = Math.floor(minute / 60);\r\n        minute = minute % 60;\r\n        day = Math.floor(hour / 24);\r\n        hour = hour % 24;\r\n        logger_1.logger.log(day + ':' + hour + ':' + minute + ':' + seconds);\r\n    };\r\n    PeerConnection.prototype.CalculateCallDurationandType_ = function () {\r\n        if (this.timeerstarted_ == true) {\r\n            this.timeerstarted_ = false;\r\n            this.callendTime_ = (new Date()).getTime();\r\n            var timeelapsed = ((this.callendTime_) - (this.callstartTime_));\r\n            this.MillisecondstoDisplayformat_(timeelapsed);\r\n            timeelapsed = Math.round(timeelapsed / 1000);\r\n            //call durations\r\n            logger_1.logger.log(\"Call Duration \" + timeelapsed);\r\n            if (this.conferencecall_ == true) {\r\n                this.SendTelemetryData(telemetry_1.tel_key_ConferenceCallDuration, timeelapsed, 1);\r\n            }\r\n            //If Conference call, do not caluculate audio,video or screensharing\r\n            else {\r\n                if (this.audiocall_.active == true) {\r\n                    this.SendTelemetryData(telemetry_1.tel_key_AudioCallDuration, timeelapsed, 1);\r\n                }\r\n                if (this.videocall_.active == true) {\r\n                    this.SendTelemetryData(telemetry_1.tel_key_VideoCallDuration, timeelapsed, 1);\r\n                }\r\n                if (this.screensharingcall_.active == true) {\r\n                    this.SendTelemetryData(telemetry_1.tel_key_ScreensharingCallDuration, timeelapsed, 1);\r\n                }\r\n            }\r\n            //call establishment time\r\n            var callestablishtime;\r\n            if (this.firsttimelocaloffer_ == true) {\r\n                callestablishtime = ((this.callstartTime_) - (this.outgoingcallstart_));\r\n            }\r\n            if (this.firsttimeremoteoffer_ == true) {\r\n                callestablishtime = ((this.callstartTime_) - (this.incomingcallstart_));\r\n            }\r\n            this.MillisecondstoDisplayformat_(callestablishtime);\r\n            callestablishtime = Math.round(callestablishtime / 1000);\r\n            logger_1.logger.log(\"Call Establish Time \" + callestablishtime);\r\n            if (this.incomingcall_ == true) {\r\n                this.SendTelemetryData(telemetry_1.tel_key_CallEstIncoming, callestablishtime, 1);\r\n            }\r\n            else if (this.outgoingcall_ == true) {\r\n                this.SendTelemetryData(telemetry_1.tel_key_CallEstOutgoing, callestablishtime, 1);\r\n            }\r\n            //call state\r\n            this.SendTelemetryData(telemetry_1.tel_key_PerfCallState, telemetry_1.tel_CallState.idle, 1);\r\n        }\r\n    };\r\n    PeerConnection.prototype.close = function () {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + '.close() called.');\r\n        this.CalculateCallDurationandType_();\r\n        this.unregisterStateChangeNotification(this.onStateChange);\r\n        // release event handlers in case the app doesn't.\r\n        this.onaddstream = null;\r\n        this.onicecandidate = null;\r\n        this.oniceconnectionstatechange = null;\r\n        this.onicegatheringstatechange = null;\r\n        this.onsignalingstatechange = null;\r\n        this.onnegotiationneeded = null;\r\n        this.waitUntilConnected(this.user_friendly_id() + '.close')\r\n            .then(function () { return _this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCPeerConnection_t.close); })\r\n            .then(function () {\r\n            _this.iceQ_ = null;\r\n            _this.release();\r\n            logger_1.logger.log(_this.user_friendly_id() + '.close() success.');\r\n        })\r\n            .catch(function () {\r\n            _this.iceQ_ = null;\r\n            _this.release();\r\n            logger_1.logger.log(_this.user_friendly_id() + '.close() failed.');\r\n        });\r\n    };\r\n    //this is old API that is deprecated in newer webrtc web api.\r\n    //this method returns correct DtmfSender object, however,\r\n    //DtmfSender::insertDtmf() fails later on when DTMF keys are pressed\r\n    //therefore, should disable this API call from the shim\r\n    PeerConnection.prototype.createDTMFSender = function (track) {\r\n        logger_1.logger.log(this.user_friendly_id() + '.createDTMFSender() called.');\r\n        var rv;\r\n        var senders = this.senders_;\r\n        if (senders === undefined || senders.length === 0) {\r\n            senders = this.getSenders();\r\n        }\r\n        if (senders != undefined) {\r\n            var s = senders.find(function (r) { return r.track.id === track.id; });\r\n            if (s != undefined) {\r\n                logger_1.logger.log(this.user_friendly_id() + ' returning RtpSender with oid:' + s.object_id());\r\n                rv = s.dtmf;\r\n            }\r\n        }\r\n        return rv;\r\n    };\r\n    PeerConnection.prototype.getSenders = function () {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + '.getSenders() called.');\r\n        //refresh senders from native side\r\n        this.waitUntilConnected(this.user_friendly_id() + '.getSenders')\r\n            .then(function () {\r\n            return _this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCPeerConnection_t.getSenders, []);\r\n        })\r\n            .then(function (obj) {\r\n            var promises = [];\r\n            obj.params[0].forEach(function (item) {\r\n                var sender = _this.senders_.find(function (r) { return r.object_id() === item.oid; });\r\n                if (sender === undefined) {\r\n                    logger_1.logger.log(_this.user_friendly_id() + ' adding a RtpSender with oid:' + item.oid);\r\n                    sender = new rtpsender_1.RtpSender(_this, item.oid, proxyobject_1.ProxyMode.Remote);\r\n                    promises.push(sender.syncBarrier());\r\n                }\r\n                else {\r\n                    promises.push(sender);\r\n                }\r\n            });\r\n            return Promise.all(promises);\r\n        })\r\n            .then(function (senders) {\r\n            logger_1.logger.log(_this.user_friendly_id() + '.getSenders: returning senders with ids [' + senders.map(function (r) { return r.object_id(); }) + ']');\r\n            //save new senders\r\n            _this.senders_ = senders;\r\n        })\r\n            .catch(function () {\r\n            logger_1.logger.log(_this.user_friendly_id() + '.getSenders() didnt get response.');\r\n            _this.senders_ = [];\r\n        });\r\n        return this.senders_;\r\n    };\r\n    //this function is syncronous call, therefore, it always return the value from previous remoteInvoke\r\n    PeerConnection.prototype.getReceivers = function () {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + '.getReceivers() called.');\r\n        this.waitUntilConnected(this.user_friendly_id() + '.getReceivers')\r\n            .then(function () {\r\n            return _this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCPeerConnection_t.getReceivers, []);\r\n        })\r\n            .then(function (obj) {\r\n            var promises = [];\r\n            obj.params[0].forEach(function (item) {\r\n                var receiver = _this.receivers_.find(function (r) { return r.object_id() === item.oid; });\r\n                if (receiver === undefined) {\r\n                    logger_1.logger.log(_this.user_friendly_id() + ' adding a RtpReceiver with oid:' + item.oid);\r\n                    receiver = new rtpsender_1.RtpReceiver(_this, item.oid);\r\n                    promises.push(receiver.syncBarrier());\r\n                }\r\n                else {\r\n                    promises.push(receiver);\r\n                }\r\n            });\r\n            return Promise.all(promises);\r\n        })\r\n            .then(function (receivers) {\r\n            logger_1.logger.log(_this.user_friendly_id() + '.getReceivers: returning receiver with ids [' + receivers.map(function (r) { return r.object_id(); }) + ']');\r\n            //note: commenting out the following explicit memory release, however, \r\n            //activate if this causes too big memory impact\r\n            //release receivers that are no longer on the client\r\n            /*this.receivers_.forEach(item => {\r\n                let receiver = receivers.find(r => r.object_id() === item.object_id());\r\n                if (receiver === undefined) {\r\n                    item.release();\r\n                }\r\n            });*/\r\n            //save new receivers\r\n            _this.receivers_ = receivers;\r\n        })\r\n            .catch(function () {\r\n            logger_1.logger.log(_this.user_friendly_id() + '.getReceivers() didnt get response.');\r\n            _this.receivers_ = [];\r\n        });\r\n        return this.receivers_;\r\n    };\r\n    return PeerConnection;\r\n}(proxyobject_1.ProxyObject));\r\nexports.PeerConnection = PeerConnection;\r\n\n\n//# sourceURL=webpack://CitrixWebRTC/E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/peerconnection.js?");
      },
      "../../../out/shim/sdk/int/sdk/proxyobject.js":
      /*!*************************************************************************!*\
        !*** E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/proxyobject.js ***!
        \*************************************************************************/

      /*! no static exports found */
      function outShimSdkIntSdkProxyobjectJs(module, exports, __webpack_require__) {

        eval("\r\nObject.defineProperty(exports, \"__esModule\", { value: true });\r\nvar hdxms_1 = __webpack_require__(/*! ./hdxms */ \"../../../out/shim/sdk/int/sdk/hdxms.js\");\r\nvar logger_1 = __webpack_require__(/*! ./logger */ \"../../../out/shim/sdk/int/sdk/logger.js\");\r\nvar wsjsonutil_1 = __webpack_require__(/*! ./wsjsonutil */ \"../../../out/shim/sdk/int/sdk/wsjsonutil.js\");\r\nvar garbagecollector_1 = __webpack_require__(/*! ./garbagecollector */ \"../../../out/shim/sdk/int/sdk/garbagecollector.js\");\r\nvar webrpcclassinfo_1 = __webpack_require__(/*! ./webrpcclassinfo */ \"../../../out/shim/sdk/int/sdk/webrpcclassinfo.js\");\r\nvar deferred_action = /** @class */ (function () {\r\n    function deferred_action(resolve, reject, name) {\r\n        this.resolve = resolve;\r\n        this.reject = reject;\r\n        this.name = name;\r\n    }\r\n    deferred_action.prototype.post = function (success) {\r\n        if (success == true) {\r\n            logger_1.logger.log('deferred_action.post(): resolving \"' + this.name + '\"');\r\n            this.resolve();\r\n        }\r\n        else {\r\n            logger_1.logger.log('deferred_action.post(): rejecting \"' + this.name + '\"');\r\n            this.reject();\r\n        }\r\n    };\r\n    return deferred_action;\r\n}());\r\nexports.deferred_action = deferred_action;\r\nvar rpc_callback = /** @class */ (function () {\r\n    function rpc_callback(id, is_null) {\r\n        this.id = id;\r\n        this.is_null = is_null;\r\n    }\r\n    return rpc_callback;\r\n}());\r\nexports.rpc_callback = rpc_callback;\r\nvar callback = /** @class */ (function () {\r\n    function callback(id, isNull, oneShot) {\r\n        this.success = new rpc_callback(id << 16, isNull);\r\n        this.fail = new rpc_callback((id << 16) | 1, isNull);\r\n        this.id = id;\r\n        this.oneShot = oneShot;\r\n    }\r\n    callback.prototype.resolve = function (obj) {\r\n        logger_1.logger.trace('callback.resolve() called. [id=' + this.id + ']');\r\n        if (this.handler != null) {\r\n            this.handler(obj);\r\n        }\r\n    };\r\n    callback.prototype.reject = function (obj) {\r\n        if (this.err_handler != null) {\r\n            this.err_handler(obj);\r\n        }\r\n    };\r\n    callback.prototype.then = function (f) {\r\n        this.handler = f;\r\n    };\r\n    callback.prototype.prom = function () {\r\n        var _this = this;\r\n        return new Promise(function (resolve, reject) {\r\n            _this.handler = resolve;\r\n            _this.err_handler = reject;\r\n        });\r\n    };\r\n    return callback;\r\n}());\r\nexports.callback = callback;\r\nvar ProxyReadyState;\r\n(function (ProxyReadyState) {\r\n    ProxyReadyState[ProxyReadyState[\"NotConfigured\"] = 0] = \"NotConfigured\";\r\n    ProxyReadyState[ProxyReadyState[\"Configured\"] = 1] = \"Configured\";\r\n    ProxyReadyState[ProxyReadyState[\"Error\"] = 2] = \"Error\";\r\n    ProxyReadyState[ProxyReadyState[\"Destroyed\"] = 3] = \"Destroyed\"; //means the object is destroyed\r\n})(ProxyReadyState || (ProxyReadyState = {}));\r\nvar ProxyMode;\r\n(function (ProxyMode) {\r\n    ProxyMode[ProxyMode[\"Local\"] = 0] = \"Local\";\r\n    ProxyMode[ProxyMode[\"Remote\"] = 1] = \"Remote\";\r\n    ProxyMode[ProxyMode[\"Pseudo\"] = 2] = \"Pseudo\";\r\n})(ProxyMode = exports.ProxyMode || (exports.ProxyMode = {}));\r\nvar ProxyObject = /** @class */ (function () {\r\n    function ProxyObject(parent, iid, oid, mode, configcb) {\r\n        if (configcb === void 0) { configcb = null; }\r\n        var args = [];\r\n        for (var _i = 5; _i < arguments.length; _i++) {\r\n            args[_i - 5] = arguments[_i];\r\n        }\r\n        var _this = this;\r\n        this.hdxms = hdxms_1.getRedirector();\r\n        this.iid = iid;\r\n        this.oid = oid;\r\n        this.mode = mode;\r\n        this.state = ProxyReadyState.NotConfigured;\r\n        this.deferredActions = new Array();\r\n        this.cbs = new Map();\r\n        if (mode === ProxyMode.Local) {\r\n            //EngineControl will query sessioninfo, thus we will treat it specially in terms of redirection status\r\n            var sessioninfo = false;\r\n            if (this.iid === webrpcclassinfo_1.class_id_t.EngineControl) {\r\n                sessioninfo = true;\r\n            }\r\n            this.hdxms.startRedirection(sessioninfo, this.user_friendly_id())\r\n                .then(function () {\r\n                // set a temporary oid for construction and bump the counter\r\n                _this.oid = ProxyObject.nextId++;\r\n                logger_1.logger.log(_this.user_friendly_id() + ' assigned local oid:' + _this.oid);\r\n                var feature = webrpcclassinfo_1.WebrpcClassLibInfoUtil.getMethodFeatureByid(iid, 0);\r\n                return _this.hdxms.WSSendObjectWrapper(feature, iid, 0, wsjsonutil_1.WsJsonUtil.createMessageByid.apply(wsjsonutil_1.WsJsonUtil, [false, false, wsjsonutil_1.ws_msg_type_t.req, iid, 0, _this.oid].concat(args)));\r\n            })\r\n                .then(function (obj) {\r\n                logger_1.logger.trace('ProxyObject: setting state to configured. (iid: ' + _this.iid + ' oid: ' + _this.oid + ')');\r\n                var local_oid = _this.oid;\r\n                _this.state = ProxyReadyState.Configured;\r\n                _this.oid = _this.param0(obj); // save the oid allocated by the constructor.\r\n                logger_1.logger.log(_this.user_friendly_id() + ' assigned remote oid for local oid:' + local_oid);\r\n                _this.onConnected();\r\n                if (configcb) {\r\n                    configcb();\r\n                }\r\n                garbagecollector_1.gc.trackObject(_this, parent);\r\n            })\r\n                .catch(function () {\r\n                _this.state = ProxyReadyState.Error;\r\n                _this.onConnected();\r\n            });\r\n        }\r\n        else if (mode === ProxyMode.Remote) {\r\n            this.state = ProxyReadyState.Configured;\r\n            garbagecollector_1.gc.trackObject(this, parent);\r\n        }\r\n    }\r\n    ProxyObject.prototype.bind = function (parent, oid) {\r\n        logger_1.logger.trace('ProxyObject: binding object. (iid: ' + this.iid + ' oid: ' + oid + ' mode: ' + this.mode + ')');\r\n        if (this.mode === ProxyMode.Pseudo) {\r\n            this.state = ProxyReadyState.Configured;\r\n            var local_oid = this.oid;\r\n            this.oid = oid;\r\n            logger_1.logger.log(this.user_friendly_id() + ' assigned remote oid for local oid:' + local_oid);\r\n            this.onConnected();\r\n            garbagecollector_1.gc.trackObject(this, parent);\r\n            //update mode to prevent subsequent binding.\r\n            this.mode = ProxyMode.Remote;\r\n        }\r\n        else {\r\n            logger_1.logger.log('ProxyObject: binding failure. incorrect mode!');\r\n        }\r\n    };\r\n    ProxyObject.prototype.reconstructor = function (parent, iid, oid) {\r\n        var _this = this;\r\n        var args = [];\r\n        for (var _i = 3; _i < arguments.length; _i++) {\r\n            args[_i - 3] = arguments[_i];\r\n        }\r\n        //reset state\r\n        this.state = ProxyReadyState.NotConfigured;\r\n        //clear deferred actions\r\n        this.deferredActions = [];\r\n        //invoke remote constructor\r\n        var feature = webrpcclassinfo_1.WebrpcClassLibInfoUtil.getMethodFeatureByid(iid, 0);\r\n        this.hdxms.WSSendObjectWrapper(feature, iid, 0, wsjsonutil_1.WsJsonUtil.createMessageByid.apply(wsjsonutil_1.WsJsonUtil, [false, false, wsjsonutil_1.ws_msg_type_t.req, iid, 0, this.oid].concat(args)))\r\n            .then(function (obj) {\r\n            logger_1.logger.trace('ProxyObject: setting state to configured. (iid: ' + _this.iid + ' oid: ' + _this.oid + ')');\r\n            var local_oid = _this.oid;\r\n            _this.state = ProxyReadyState.Configured;\r\n            _this.oid = _this.param0(obj); // save the oid allocated by the constructor.\r\n            logger_1.logger.log(_this.user_friendly_id() + ' assigned remote oid for local oid:' + local_oid);\r\n            _this.onConnected();\r\n            garbagecollector_1.gc.trackObject(_this, parent);\r\n        })\r\n            .catch(function () {\r\n            _this.state = ProxyReadyState.Error;\r\n            _this.onConnected();\r\n        });\r\n    };\r\n    ProxyObject.prototype.setParent = function (parent) {\r\n        garbagecollector_1.gc.setParent(this, parent);\r\n    };\r\n    ProxyObject.prototype.release = function () {\r\n        logger_1.logger.log(this.user_friendly_id() + '.release() called.');\r\n        garbagecollector_1.gc.releaseObject(this);\r\n    };\r\n    ProxyObject.prototype.destroy = function () {\r\n        this.state = ProxyReadyState.Destroyed;\r\n        var feature = webrpcclassinfo_1.WebrpcClassLibInfoUtil.getMethodFeatureByid(this.iid, 0);\r\n        this.hdxms.WSSendObjectWrapper(feature, this.iid, 0, wsjsonutil_1.WsJsonUtil.createMessageByid(false, true, wsjsonutil_1.ws_msg_type_t.req, this.iid, 0, this.oid)); //invoke destructor\r\n    };\r\n    ProxyObject.prototype.onConnected = function () {\r\n        while (this.deferredActions && this.deferredActions.length > 0) {\r\n            this.deferredActions.shift().post(this.state == ProxyReadyState.Configured);\r\n        }\r\n    };\r\n    ProxyObject.prototype.checkState = function (count, delay) {\r\n        var self = this;\r\n        if (count <= 0) {\r\n            logger_1.logger.log('ProxyObject.checkState() timeout waiting for connection response! failed. (iid: ' + self.iid + ' oid: ' + self.oid + ')');\r\n            self.onConnected();\r\n        }\r\n        else {\r\n            setTimeout(function () {\r\n                if (self.state == ProxyReadyState.Configured) {\r\n                    self.onConnected();\r\n                }\r\n                else if (self.state == ProxyReadyState.Error) {\r\n                    self.onConnected();\r\n                }\r\n                else if (self.state == ProxyReadyState.Destroyed) {\r\n                    self.onConnected();\r\n                }\r\n                else {\r\n                    //need to wait for another round\r\n                    logger_1.logger.log('ProxyObject.checkState(): count= \"' + count + '\". (iid: ' + self.iid + ' oid: ' + self.oid + ')');\r\n                    self.checkState(--count, delay);\r\n                }\r\n            }, delay);\r\n        }\r\n    };\r\n    ProxyObject.prototype.waitUntilConnected = function (name) {\r\n        var self = this;\r\n        return new Promise(function (resolve, reject) {\r\n            logger_1.logger.trace('ProxyObject.waitUntilConnected(): readyState=' + self.state + '. (iid: ' + self.iid + ' oid: ' + self.oid + ')');\r\n            if (self.state == ProxyReadyState.Destroyed) {\r\n                self.onConnected();\r\n                reject('Object already destroyed :' + self.user_friendly_id());\r\n            }\r\n            if (self.state == ProxyReadyState.Configured) {\r\n                self.onConnected();\r\n                resolve();\r\n            }\r\n            else if (self.state == ProxyReadyState.Error) {\r\n                logger_1.logger.trace('ProxyObject.waitUntilConnected(): readyState=' + self.state + '. (iid: ' + self.iid + ' oid: ' + self.oid + ')');\r\n                self.onConnected();\r\n                reject();\r\n            }\r\n            else {\r\n                logger_1.logger.log('ProxyObject.waitUntilConnected(): deferring action \"' + name + '\". (iid: ' + self.iid + ' oid: ' + self.oid + ')');\r\n                self.deferredActions.push(new deferred_action(resolve, reject, name));\r\n                self.checkState(15, 1000); //increase time out for debugging\r\n            }\r\n        });\r\n    };\r\n    ProxyObject.prototype.remoteInvoke = function (modifier, mid) {\r\n        var args = [];\r\n        for (var _i = 2; _i < arguments.length; _i++) {\r\n            args[_i - 2] = arguments[_i];\r\n        }\r\n        if (this.state == ProxyReadyState.Destroyed)\r\n            return Promise.reject('Cannot invoke destroyed object :' + this.user_friendly_id());\r\n        if (this.state == ProxyReadyState.Error)\r\n            return Promise.reject('Cannot invoke object in Error state:' + this.user_friendly_id());\r\n        var feature = webrpcclassinfo_1.WebrpcClassLibInfoUtil.getMethodFeatureByid(this.iid, mid);\r\n        return this.hdxms.WSSendObjectWrapper(feature, this.iid, mid, wsjsonutil_1.WsJsonUtil.createMessageByid.apply(wsjsonutil_1.WsJsonUtil, [modifier, false, wsjsonutil_1.ws_msg_type_t.req, this.iid, mid, this.oid].concat(args)));\r\n    };\r\n    ProxyObject.prototype.registerCallbacks = function (oneShot, isNull, mid) {\r\n        // unregister old one.\r\n        this.unregisterCallbacks(mid);\r\n        // create a new callback.\r\n        var id = ProxyObject.nextcbid++;\r\n        var cb = new callback(id, isNull, oneShot);\r\n        if (!isNull) {\r\n            // keep track of it if it is not one shot.\r\n            if (!oneShot) {\r\n                //logger.log('registering callback for mid: ' + mid + ' with id: ' + id);\r\n                this.cbs.set(mid, id);\r\n            }\r\n            // register it.\r\n            this.hdxms.registerHandler(this.iid, this.oid, cb);\r\n        }\r\n        // return it.\r\n        return cb;\r\n    };\r\n    ProxyObject.prototype.unregisterCallbacks = function (mid) {\r\n        if (this.cbs.has(mid)) {\r\n            //logger.log('unregistering callback handler for mid: ' + mid);\r\n            this.hdxms.unregisterHandler(this.iid, this.oid, this.cbs.get(mid));\r\n            this.cbs.delete(mid);\r\n        }\r\n        else {\r\n            //logger.log('ProxyObject: Cant find callback handler registration for mid: ' + mid);\r\n            logger_1.logger.trace(this.cbs);\r\n        }\r\n    };\r\n    ProxyObject.prototype.object_id = function () {\r\n        return this.oid;\r\n    };\r\n    ProxyObject.prototype.param0 = function (obj) {\r\n        return obj['params'][0];\r\n    };\r\n    ProxyObject.prototype.isNullCallback = function (f) {\r\n        return f == undefined || f == null;\r\n    };\r\n    ProxyObject.prototype.user_friendly_id = function () {\r\n        return this.constructor.name + '[' + this.oid + ']';\r\n    };\r\n    ProxyObject.prototype.isRedirected = function () {\r\n        return this.hdxms.isRedirected();\r\n    };\r\n    ProxyObject.prototype.isValid = function () {\r\n        return !(this.state === ProxyReadyState.Error || this.state === ProxyReadyState.Destroyed);\r\n    };\r\n    ProxyObject.prototype.registerStateChangeNotification = function (f) {\r\n        this.hdxms.registerStateChangeNotification(f);\r\n    };\r\n    ProxyObject.prototype.unregisterStateChangeNotification = function (f) {\r\n        this.hdxms.unregisterStateChangeNotification(f);\r\n    };\r\n    //next available oid\r\n    ProxyObject.nextId = 0;\r\n    //next available callback id\r\n    ProxyObject.nextcbid = 0;\r\n    return ProxyObject;\r\n}());\r\nexports.ProxyObject = ProxyObject;\r\n\n\n//# sourceURL=webpack://CitrixWebRTC/E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/proxyobject.js?");
      },
      "../../../out/shim/sdk/int/sdk/remotemedia.js":
      /*!*************************************************************************!*\
        !*** E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/remotemedia.js ***!
        \*************************************************************************/

      /*! no static exports found */
      function outShimSdkIntSdkRemotemediaJs(module, exports, __webpack_require__) {

        eval("\r\nvar __extends = (this && this.__extends) || (function () {\r\n    var extendStatics = function (d, b) {\r\n        extendStatics = Object.setPrototypeOf ||\r\n            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||\r\n            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };\r\n        return extendStatics(d, b);\r\n    }\r\n    return function (d, b) {\r\n        extendStatics(d, b);\r\n        function __() { this.constructor = d; }\r\n        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());\r\n    };\r\n})();\r\nvar __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {\r\n    return new (P || (P = Promise))(function (resolve, reject) {\r\n        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }\r\n        function rejected(value) { try { step(generator[\"throw\"](value)); } catch (e) { reject(e); } }\r\n        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }\r\n        step((generator = generator.apply(thisArg, _arguments || [])).next());\r\n    });\r\n};\r\nvar __generator = (this && this.__generator) || function (thisArg, body) {\r\n    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;\r\n    return g = { next: verb(0), \"throw\": verb(1), \"return\": verb(2) }, typeof Symbol === \"function\" && (g[Symbol.iterator] = function() { return this; }), g;\r\n    function verb(n) { return function (v) { return step([n, v]); }; }\r\n    function step(op) {\r\n        if (f) throw new TypeError(\"Generator is already executing.\");\r\n        while (_) try {\r\n            if (f = 1, y && (t = op[0] & 2 ? y[\"return\"] : op[0] ? y[\"throw\"] || ((t = y[\"return\"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;\r\n            if (y = 0, t) op = [op[0] & 2, t.value];\r\n            switch (op[0]) {\r\n                case 0: case 1: t = op; break;\r\n                case 4: _.label++; return { value: op[1], done: false };\r\n                case 5: _.label++; y = op[1]; op = [0]; continue;\r\n                case 7: op = _.ops.pop(); _.trys.pop(); continue;\r\n                default:\r\n                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }\r\n                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }\r\n                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }\r\n                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }\r\n                    if (t[2]) _.ops.pop();\r\n                    _.trys.pop(); continue;\r\n            }\r\n            op = body.call(thisArg, _);\r\n        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }\r\n        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };\r\n    }\r\n};\r\nObject.defineProperty(exports, \"__esModule\", { value: true });\r\nvar webrpcclassinfo_1 = __webpack_require__(/*! ./webrpcclassinfo */ \"../../../out/shim/sdk/int/sdk/webrpcclassinfo.js\");\r\nvar proxyobject_1 = __webpack_require__(/*! ./proxyobject */ \"../../../out/shim/sdk/int/sdk/proxyobject.js\");\r\nvar logger_1 = __webpack_require__(/*! ./logger */ \"../../../out/shim/sdk/int/sdk/logger.js\");\r\nvar hdxms_1 = __webpack_require__(/*! ./hdxms */ \"../../../out/shim/sdk/int/sdk/hdxms.js\");\r\nvar telemetry_1 = __webpack_require__(/*! ./telemetry */ \"../../../out/shim/sdk/int/sdk/telemetry.js\");\r\nvar enumerateddecices;\r\nexports.enumerateddecices = enumerateddecices;\r\nvar SimpleEvent = /** @class */ (function () {\r\n    function SimpleEvent(type, obj) {\r\n        this.type = type;\r\n        this.target = obj;\r\n    }\r\n    return SimpleEvent;\r\n}());\r\nvar CloneState = /** @class */ (function () {\r\n    /// constructor. construct default state.\r\n    function CloneState() {\r\n        this.is_local_clone = false;\r\n        this.clone_count = 0;\r\n        this.clone_id = 0;\r\n    }\r\n    /// clone our state and return the new one.\r\n    CloneState.prototype.clone = function () {\r\n        this.clone_count++;\r\n        var newState = new CloneState();\r\n        newState.is_local_clone = true;\r\n        newState.clone_id = this.clone_count;\r\n        return newState;\r\n    };\r\n    /// synchronize the local object with the remotely cloned object.\r\n    CloneState.prototype.synchronize = function (original /* T */) {\r\n        return __awaiter(this, void 0, void 0, function () {\r\n            return __generator(this, function (_a) {\r\n                // first check if this is even a clone.\r\n                if (this.is_local_clone) {\r\n                    //let cloned_object: T = await original.asyncClone();\r\n                    //original.impersonate(cloned_object);\r\n                    //original.synchronize(original, cloned_object); // original <= cloned\r\n                    return [2 /*return*/, original.asyncClone()];\r\n                }\r\n                // not a clone so just return the original object.\r\n                return [2 /*return*/, original];\r\n            });\r\n        });\r\n    };\r\n    return CloneState;\r\n}());\r\n/// MediaStreamTrack implementation\r\nvar RemoteMediaTrack = /** @class */ (function (_super) {\r\n    __extends(RemoteMediaTrack, _super);\r\n    function RemoteMediaTrack(parent, oid) {\r\n        var _this = _super.call(this, parent, webrpcclassinfo_1.class_id_t.MediaStreamTrack, oid, proxyobject_1.ProxyMode.Remote) || this;\r\n        _this.refCount_ = 0;\r\n        _this.refCount_++;\r\n        _this.clone_state = new CloneState();\r\n        return _this;\r\n    }\r\n    Object.defineProperty(RemoteMediaTrack.prototype, \"refcount\", {\r\n        get: function () {\r\n            return this.refCount_;\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    RemoteMediaTrack.prototype.addRef = function () {\r\n        this.refCount_++;\r\n        logger_1.logger.log(this.user_friendly_id() + '.addRef() called. [id=' + this.id + ']' + ' refcount=' + this.refCount_);\r\n    };\r\n    Object.defineProperty(RemoteMediaTrack.prototype, \"onended\", {\r\n        get: function () {\r\n            logger_1.logger.log(this.user_friendly_id() + '.get_onended() called. [id=' + this.id + ']');\r\n            return this.onended_;\r\n        },\r\n        //onended\r\n        set: function (f) {\r\n            var _this = this;\r\n            logger_1.logger.log(this.user_friendly_id() + '.set_onended() called. [id=' + this.id + ']');\r\n            this.onended_ = f;\r\n            this.waitUntilConnected('MediaStreamTrack.onended')\r\n                .then(function () {\r\n                var callbacks = _this.registerCallbacks(false, _this.isNullCallback(f), webrpcclassinfo_1.method_id_MediaStreamTrack_t.onended);\r\n                callbacks.then(function (obj) {\r\n                    logger_1.logger.log(_this.user_friendly_id() + 'onended event received!!!');\r\n                    var evt = new SimpleEvent('ended', _this);\r\n                    _this.readyState_ = \"ended\";\r\n                    _this.onended_(evt); // not sure if this is the best way to post the event.\r\n                });\r\n                return _this.remoteInvoke(true, webrpcclassinfo_1.method_id_MediaStreamTrack_t.onended, callbacks.success);\r\n            })\r\n                .catch(function () {\r\n                logger_1.logger.log(_this.user_friendly_id() + '.onended failed!!!');\r\n            });\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    Object.defineProperty(RemoteMediaTrack.prototype, \"onmute\", {\r\n        get: function () {\r\n            logger_1.logger.log(this.user_friendly_id() + '.get_onmute() called. [id=' + this.id + ']');\r\n            return this.onmute_;\r\n        },\r\n        //onmute\r\n        set: function (f) {\r\n            var _this = this;\r\n            logger_1.logger.log(this.user_friendly_id() + '.set_onmute() called. [id=' + this.id + ']');\r\n            this.onmute_ = f;\r\n            this.waitUntilConnected('MediaStreamTrack.onmute')\r\n                .then(function () {\r\n                var callbacks = _this.registerCallbacks(false, _this.isNullCallback(f), webrpcclassinfo_1.method_id_MediaStreamTrack_t.onmute);\r\n                callbacks.then(function (obj) {\r\n                    logger_1.logger.log(_this.user_friendly_id() + 'onmute event received!!!');\r\n                    var evt = new SimpleEvent('mute', _this);\r\n                    _this.muted = true;\r\n                    _this.onmute_(evt);\r\n                });\r\n                return _this.remoteInvoke(true, webrpcclassinfo_1.method_id_MediaStreamTrack_t.onmute, callbacks.success);\r\n            })\r\n                .catch(function () {\r\n                logger_1.logger.log(_this.user_friendly_id() + '.onmute failed!!!');\r\n            });\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    Object.defineProperty(RemoteMediaTrack.prototype, \"onunmute\", {\r\n        get: function () {\r\n            logger_1.logger.log(this.user_friendly_id() + '.get_onunmute() called. [id=' + this.id + ']');\r\n            return this.onunmute_;\r\n        },\r\n        //onunmute\r\n        set: function (f) {\r\n            var _this = this;\r\n            logger_1.logger.log(this.user_friendly_id() + '.set_onunmute() called. [id=' + this.id + ']');\r\n            this.onunmute_ = f;\r\n            this.waitUntilConnected('MediaStreamTrack.onunmute')\r\n                .then(function () {\r\n                var callbacks = _this.registerCallbacks(false, _this.isNullCallback(f), webrpcclassinfo_1.method_id_MediaStreamTrack_t.onunmute);\r\n                callbacks.then(function (obj) {\r\n                    logger_1.logger.log('onunmute event received!!!');\r\n                    var evt = new SimpleEvent('unmute', _this);\r\n                    _this.muted = false;\r\n                    _this.onunmute_(evt);\r\n                });\r\n                return _this.remoteInvoke(true, webrpcclassinfo_1.method_id_MediaStreamTrack_t.onunmute, callbacks.success);\r\n            })\r\n                .catch(function () {\r\n                logger_1.logger.log(_this.user_friendly_id() + '.onunmute failed!!!');\r\n            });\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    Object.defineProperty(RemoteMediaTrack.prototype, \"onstop\", {\r\n        set: function (f) {\r\n            this.onstop_ = f;\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    Object.defineProperty(RemoteMediaTrack.prototype, \"enabled\", {\r\n        //enabled\r\n        get: function () {\r\n            logger_1.logger.log(this.user_friendly_id() + '.get_enabled() called. [id=' + this.id + ', value=' + this.enabled_ + ']');\r\n            return this.enabled_;\r\n        },\r\n        set: function (value) {\r\n            logger_1.logger.log(this.user_friendly_id() + '.set_enabled() called. [id=' + this.id + ', value=' + value + ']');\r\n            this.enabled_ = value;\r\n            this.remoteInvoke(true, webrpcclassinfo_1.method_id_MediaStreamTrack_t.enabled, value);\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    Object.defineProperty(RemoteMediaTrack.prototype, \"readyState\", {\r\n        //readyState\r\n        get: function () {\r\n            logger_1.logger.log(this.user_friendly_id() + '.get_readyState() called. [id=' + this.id + ']');\r\n            return this.readyState_;\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    /// perform an asynchronous clone. [Citrix extension API for clone]\r\n    RemoteMediaTrack.prototype.asyncClone = function () {\r\n        return __awaiter(this, void 0, void 0, function () {\r\n            var reply, objref, track;\r\n            return __generator(this, function (_a) {\r\n                switch (_a.label) {\r\n                    case 0: \r\n                    // await stable state for websocket communications.\r\n                    return [4 /*yield*/, this.waitUntilConnected(\"RemoteMediaTrack.asyncClone\")];\r\n                    case 1:\r\n                        // await stable state for websocket communications.\r\n                        _a.sent();\r\n                        return [4 /*yield*/, this.remoteInvoke(false, webrpcclassinfo_1.method_id_MediaStreamTrack_t.clone, [])];\r\n                    case 2:\r\n                        reply = _a.sent();\r\n                        objref = this.param0(reply);\r\n                        track = new RemoteMediaTrack(this, objref['oid']);\r\n                        // synchronize it.\r\n                        return [2 /*return*/, track.syncBarrier()];\r\n                }\r\n            });\r\n        });\r\n    };\r\n    RemoteMediaTrack.prototype.clone = function () {\r\n        logger_1.logger.log(this.user_friendly_id() + '.clone() called. [id=' + this.id + ']');\r\n        var cloned_state = this.clone_state.clone();\r\n        var track = new RemoteMediaTrack(this, this.object_id());\r\n        track.id = this.id + '.' + cloned_state.clone_id.toString();\r\n        track.label = this.label;\r\n        track.kind = this.kind;\r\n        track.enabled_ = this.enabled_;\r\n        track.muted = this.muted;\r\n        track.readyState_ = this.readyState_;\r\n        track.trackSettings_ = this.trackSettings_;\r\n        track.clone_state = cloned_state;\r\n        track.constraints_ = this.constraints_;\r\n        track.capabilities_ = this.capabilities_;\r\n        return track;\r\n    };\r\n    RemoteMediaTrack.prototype.stop = function () {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + '.stop() called. [id=' + this.id + ']' + ' refcount=' + this.refCount_);\r\n        this.readyState_ = \"ended\";\r\n        if (this.refCount_ > 0) {\r\n            this.refCount_--;\r\n            if (this.refCount_ === 0) {\r\n                logger_1.logger.log(this.user_friendly_id() + '.stop() called. [id=' + this.id + ']' + ' remote invoking...');\r\n                //stop remote media stream\r\n                this.remoteInvoke(false, webrpcclassinfo_1.method_id_MediaStreamTrack_t.stop)\r\n                    .catch(function (e) { logger_1.logger.log(_this.user_friendly_id() + '.stop() failed with:' + e); });\r\n                if (this.onstop_ !== null && this.onstop_ != undefined) {\r\n                    this.onstop_(); //notify Stream that the Track is stopped\r\n                }\r\n            }\r\n        }\r\n    };\r\n    RemoteMediaTrack.prototype.getCapabilities = function () {\r\n        return this.capabilities_;\r\n    };\r\n    RemoteMediaTrack.prototype.getConstraints = function () {\r\n        return this.constraints_;\r\n    };\r\n    RemoteMediaTrack.prototype.getSettings = function () {\r\n        if (this.kind == 'audio') {\r\n            return (function (_a) {\r\n                var deviceId = _a.deviceId, echoCancellation = _a.echoCancellation;\r\n                return ({ deviceId: deviceId, echoCancellation: echoCancellation });\r\n            })(this.trackSettings_);\r\n        }\r\n        else {\r\n            return (function (_a) {\r\n                var aspectRatio = _a.aspectRatio, deviceId = _a.deviceId, frameRate = _a.frameRate, height = _a.height, width = _a.width;\r\n                return ({ aspectRatio: aspectRatio, deviceId: deviceId, frameRate: frameRate, height: height, width: width });\r\n            })(this.trackSettings_);\r\n        }\r\n    };\r\n    RemoteMediaTrack.prototype.applyConstraints = function (constraints) {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + '.applyConstraints() called.');\r\n        return new Promise(function (resolve, reject) {\r\n            _this.waitUntilConnected('MediaStreamTrack.applyConstraints')\r\n                .then(function () {\r\n                return Promise.all([\r\n                    _this.remoteInvoke(false, webrpcclassinfo_1.method_id_MediaStreamTrack_t.applyConstraints, constraints),\r\n                    _this.syncBarrier()\r\n                ]);\r\n            })\r\n                .catch(function () { reject({ name: \"OverconstrainedError\", message: \"Failed to apply constraints.\" }); }) // reject with MediaStreamError\r\n                .then(function () {\r\n                // fallback. save current input object as constraint and try to sync it with a client side values\r\n                _this.constraints_ = constraints;\r\n                return _this.remoteInvoke(false, webrpcclassinfo_1.method_id_MediaStreamTrack_t.getConstraints);\r\n            })\r\n                .then(function (result) { _this.constraints_ = _this.param0(result); })\r\n                .catch(function () {\r\n                // do not reject in currecyt case due to not all of clients can support getConstraints.\r\n                logger_1.logger.log(_this.user_friendly_id() + '.syncBarrier() remote client doesn\\'t support getConstraints method. Ignore it');\r\n            })\r\n                .then(function () { return resolve(); });\r\n        });\r\n    };\r\n    RemoteMediaTrack.convertReadyState = function (id) {\r\n        if (id == 0)\r\n            return \"live\";\r\n        else\r\n            return \"ended\";\r\n    };\r\n    // syncBarrier is used because methods on this interface return synchronously and we cant block in JavaScript\r\n    RemoteMediaTrack.prototype.syncBarrier = function () {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + '.syncBarrier() called.');\r\n        return new Promise(function (resolve, reject) {\r\n            _this.waitUntilConnected('MediaStreamTrack.syncBarrier')\r\n                .then(function () {\r\n                return Promise.all([\r\n                    _this.remoteInvoke(false, webrpcclassinfo_1.method_id_MediaStreamTrack_t.kind, \"\"),\r\n                    _this.remoteInvoke(false, webrpcclassinfo_1.method_id_MediaStreamTrack_t.id, \"\"),\r\n                    _this.remoteInvoke(false, webrpcclassinfo_1.method_id_MediaStreamTrack_t.label, \"\"),\r\n                    _this.remoteInvoke(false, webrpcclassinfo_1.method_id_MediaStreamTrack_t.enabled, false),\r\n                    _this.remoteInvoke(false, webrpcclassinfo_1.method_id_MediaStreamTrack_t.muted, false),\r\n                    _this.remoteInvoke(false, webrpcclassinfo_1.method_id_MediaStreamTrack_t.readyState, 0),\r\n                    _this.remoteInvoke(false, webrpcclassinfo_1.method_id_MediaStreamTrack_t.getSettings),\r\n                    _this.remoteInvoke(false, webrpcclassinfo_1.method_id_MediaStreamTrack_t.getCapabilities)\r\n                ]);\r\n            })\r\n                .then(function (results) {\r\n                var _a;\r\n                var readyState = 0;\r\n                // destructuring assignment\r\n                _a = results.map(function (result) { return _this.param0(result); }), _this.kind = _a[0], _this.id = _a[1], _this.label = _a[2], _this.enabled_ = _a[3], _this.muted = _a[4], readyState = _a[5], _this.trackSettings_ = _a[6], _this.capabilities_ = _a[7];\r\n                _this.readyState_ = RemoteMediaTrack.convertReadyState(readyState);\r\n                resolve(_this);\r\n            })\r\n                .catch(function () { reject(); });\r\n        });\r\n    };\r\n    return RemoteMediaTrack;\r\n}(proxyobject_1.ProxyObject));\r\nexports.RemoteMediaTrack = RemoteMediaTrack;\r\nvar StreamInfo = /** @class */ (function () {\r\n    function StreamInfo() {\r\n    }\r\n    return StreamInfo;\r\n}());\r\n/// MediaStream implementation\r\nvar RemoteStream = /** @class */ (function (_super) {\r\n    __extends(RemoteStream, _super);\r\n    function RemoteStream(parent, oid) {\r\n        var _this = _super.call(this, parent, webrpcclassinfo_1.class_id_t.MediaStream, oid, proxyobject_1.ProxyMode.Remote) || this;\r\n        _this.clone_state = new CloneState();\r\n        return _this;\r\n    }\r\n    RemoteStream.prototype.dumpTrackInfo = function () {\r\n        logger_1.logger.log(this.user_friendly_id() + '.dumpTrackInfo() called. [id=' + this.id + ']');\r\n        for (var _i = 0, _a = this.tracks_; _i < _a.length; _i++) {\r\n            var track = _a[_i];\r\n            logger_1.logger.log(track.user_friendly_id() + ' [id=' + track.id + ']' + ' refcount=' + track.refcount);\r\n        }\r\n    };\r\n    RemoteStream.prototype.toJSON = function () {\r\n        var info = new StreamInfo();\r\n        info.id = this.id;\r\n        info.active = this.active;\r\n        info.oid = this.object_id();\r\n        return \"RemoteStream:\" + JSON.stringify(info);\r\n    };\r\n    RemoteStream.prototype.getAudioTracks = function () {\r\n        logger_1.logger.log(this.user_friendly_id() + '.getAudioTracks() called. [id=' + this.id + ']');\r\n        var auds = new Array();\r\n        for (var _i = 0, _a = this.tracks_; _i < _a.length; _i++) {\r\n            var track = _a[_i];\r\n            if (track.kind == 'audio') {\r\n                auds.push(track);\r\n            }\r\n        }\r\n        //logger.log(this.user_friendly_id() + '.getAudioTracks() returning ' + auds.length + ' tracks.');\r\n        return auds;\r\n    };\r\n    RemoteStream.prototype.getVideoTracks = function () {\r\n        logger_1.logger.log(this.user_friendly_id() + '.getVideoTracks() called. [id=' + this.id + ']');\r\n        var vids = new Array();\r\n        for (var _i = 0, _a = this.tracks_; _i < _a.length; _i++) {\r\n            var track = _a[_i];\r\n            if (track.kind == 'video') {\r\n                vids.push(track);\r\n            }\r\n        }\r\n        //logger.log(this.user_friendly_id() + '.getVideoTracks() returning ' + vids.length + ' tracks.');\r\n        return vids;\r\n    };\r\n    RemoteStream.prototype.getTracks = function () {\r\n        logger_1.logger.log(this.user_friendly_id() + '.getTracks() called. [id=' + this.id + ']');\r\n        return this.tracks_;\r\n    };\r\n    RemoteStream.prototype.getTrackById = function (trackId) {\r\n        logger_1.logger.log(this.user_friendly_id() + '.getTrackById() called. [id=' + this.id + ']');\r\n        for (var _i = 0, _a = this.tracks_; _i < _a.length; _i++) {\r\n            var next = _a[_i];\r\n            if (next.id == trackId) {\r\n                return next;\r\n            }\r\n        }\r\n        return undefined;\r\n    };\r\n    RemoteStream.prototype.addTrack = function (track) {\r\n        logger_1.logger.log(this.user_friendly_id() + '.addTrack() called. [id=' + this.id + ']');\r\n        this.tracks_.push(track);\r\n        this.remoteInvoke(false, webrpcclassinfo_1.method_id_MediaStream_t.addTrack, { 'oid': track.object_id() });\r\n    };\r\n    RemoteStream.prototype.removeTrack = function (track) {\r\n        logger_1.logger.log(this.user_friendly_id() + '.removeTrack() called. [id=' + this.id + ']');\r\n        var idx = this.tracks_.indexOf(track);\r\n        this.tracks_.splice(idx, 1);\r\n        this.remoteInvoke(false, webrpcclassinfo_1.method_id_MediaStream_t.removeTrack, { 'oid': track.object_id() });\r\n    };\r\n    /// perform an asynchronous clone. [Citrix extension API for clone]\r\n    RemoteStream.prototype.asyncClone = function () {\r\n        return __awaiter(this, void 0, void 0, function () {\r\n            var reply, objref, stream;\r\n            return __generator(this, function (_a) {\r\n                switch (_a.label) {\r\n                    case 0:\r\n                        logger_1.logger.log(this.user_friendly_id() + '.asyncClone() called. [id=' + this.id + ']');\r\n                        // await stable state.\r\n                        return [4 /*yield*/, this.waitUntilConnected(\"asyncClone\")];\r\n                    case 1:\r\n                        // await stable state.\r\n                        _a.sent();\r\n                        return [4 /*yield*/, this.remoteInvoke(false, webrpcclassinfo_1.method_id_MediaStream_t.clone, [])];\r\n                    case 2:\r\n                        reply = _a.sent();\r\n                        console.log(reply);\r\n                        objref = this.param0(reply);\r\n                        stream = new RemoteStream(this, objref['oid']);\r\n                        // synchronize it.\r\n                        return [2 /*return*/, stream.syncBarrier()];\r\n                }\r\n            });\r\n        });\r\n    };\r\n    RemoteStream.prototype.clone = function () {\r\n        logger_1.logger.log(this.user_friendly_id() + '.clone() called. [id=' + this.id + ']');\r\n        var cloned_state = this.clone_state.clone();\r\n        var stream = new RemoteStream(this, this.object_id());\r\n        stream.id = this.id + '.' + cloned_state.clone_id.toString();\r\n        this.tracks_.forEach(function (track) { track.addRef(); }); //++refCount since we use the same tracks in the clone\r\n        stream.tracks_ = this.tracks_;\r\n        //stream.tracks_ = this.tracks_.map((track) => { return track.clone(); });\r\n        stream.clone_state = cloned_state;\r\n        return stream;\r\n    };\r\n    // syncBarrier is used because methods on this interface return synchronously and we cant block in JavaScript\r\n    RemoteStream.prototype.syncBarrier = function () {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + '.syncBarrier() called. [id=' + this.id + ']');\r\n        return new Promise(function (resolve, reject) {\r\n            _this.waitUntilConnected('MediaStream.syncBarrier')\r\n                .then(function () {\r\n                return Promise.all([\r\n                    _this.remoteInvoke(false, webrpcclassinfo_1.method_id_MediaStream_t.id, \"\"),\r\n                    _this.remoteInvoke(false, webrpcclassinfo_1.method_id_MediaStream_t.active, false),\r\n                    _this.remoteInvoke(false, webrpcclassinfo_1.method_id_MediaStream_t.getTracks, [])\r\n                ]);\r\n            })\r\n                .then(function (results) {\r\n                var _a;\r\n                var objs;\r\n                _a = results.map(function (result) { return _this.param0(result); }), _this.id = _a[0], _this.active = _a[1], objs = _a[2];\r\n                var promises = [];\r\n                for (var _i = 0, objs_1 = objs; _i < objs_1.length; _i++) {\r\n                    var trackRef = objs_1[_i];\r\n                    var track = new RemoteMediaTrack(_this, trackRef['oid']);\r\n                    promises.push(track.syncBarrier());\r\n                }\r\n                return Promise.all(promises);\r\n                //return Promise.all(objs.map((trackRef) => {\r\n                //    let track: RemoteMediaTrack = new RemoteMediaTrack(trackRef['oid']);\r\n                //    return track.syncBarrier();\r\n                //}));\r\n            })\r\n                .then(function (tracks) {\r\n                _this.tracks_ = [];\r\n                tracks.forEach(function (track) {\r\n                    track.onstop = (function () {\r\n                        var allstopped_ = true;\r\n                        _this.tracks_.forEach(function (t) {\r\n                            if (t.readyState != \"ended\") {\r\n                                allstopped_ = false;\r\n                            }\r\n                        });\r\n                        if (allstopped_)\r\n                            _this.release();\r\n                    }); //end callback\r\n                    _this.tracks_.push(track);\r\n                });\r\n                resolve(_this);\r\n            })\r\n                .catch(function () { reject(); });\r\n        });\r\n    };\r\n    return RemoteStream;\r\n}(proxyobject_1.ProxyObject));\r\nexports.RemoteStream = RemoteStream;\r\nvar RemoteStreamEvent = /** @class */ (function (_super) {\r\n    __extends(RemoteStreamEvent, _super);\r\n    function RemoteStreamEvent(parent, oid) {\r\n        return _super.call(this, parent, webrpcclassinfo_1.class_id_t.MediaStreamEvent, oid, proxyobject_1.ProxyMode.Remote) || this;\r\n    }\r\n    RemoteStreamEvent.prototype.syncBarrier = function () {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + '.syncBarrier() called.');\r\n        return new Promise(function (resolve, reject) {\r\n            _this.waitUntilConnected('MediaStreamEvent.syncBarrier')\r\n                .then(function () { return _this.remoteInvoke(false, webrpcclassinfo_1.method_id_MediaStreamEvent_t.stream, { \"oid\": 0 }); })\r\n                .then(function (obj) {\r\n                var stream = new RemoteStream(_this, obj['params'][0]['oid']);\r\n                return stream.syncBarrier();\r\n            })\r\n                .then(function (stream) {\r\n                _this.stream = stream;\r\n                resolve(_this);\r\n            })\r\n                .catch(function () { reject(); });\r\n        });\r\n    };\r\n    return RemoteStreamEvent;\r\n}(proxyobject_1.ProxyObject));\r\nexports.RemoteStreamEvent = RemoteStreamEvent;\r\nvar RemoteDeviceInfo = /** @class */ (function (_super) {\r\n    __extends(RemoteDeviceInfo, _super);\r\n    function RemoteDeviceInfo(oid) {\r\n        return _super.call(this, null, webrpcclassinfo_1.class_id_t.MediaDeviceInfo, oid, proxyobject_1.ProxyMode.Remote) || this;\r\n    }\r\n    RemoteDeviceInfo.prototype.convertKind = function (id) {\r\n        if (id == 0) {\r\n            return \"audioinput\";\r\n        }\r\n        else if (id == 1) {\r\n            return \"audiooutput\";\r\n        }\r\n        else {\r\n            return \"videoinput\";\r\n        }\r\n    };\r\n    // syncBarrier is used because methods on this interface return synchronously and we cant block in JavaScript\r\n    RemoteDeviceInfo.prototype.syncBarrier = function () {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + '.syncBarrier() called.');\r\n        return new Promise(function (resolve, reject) {\r\n            _this.waitUntilConnected('RemoteDeviceInfo.syncBarrier')\r\n                .then(function () {\r\n                return Promise.all([\r\n                    _this.remoteInvoke(false, webrpcclassinfo_1.method_id_MediaDeviceInfo_t.deviceId, \"\"),\r\n                    _this.remoteInvoke(false, webrpcclassinfo_1.method_id_MediaDeviceInfo_t.kind, 0),\r\n                    _this.remoteInvoke(false, webrpcclassinfo_1.method_id_MediaDeviceInfo_t.label, \"\"),\r\n                    _this.remoteInvoke(false, webrpcclassinfo_1.method_id_MediaDeviceInfo_t.groupId, \"\")\r\n                ]);\r\n            })\r\n                .then(function (results) {\r\n                var _a;\r\n                _this.kind = _this.convertKind(_this.param0(results.splice(1, 1)[0]));\r\n                _a = results.map(function (result) { return _this.param0(result); }), _this.deviceId = _a[0], _this.label = _a[1], _this.groupId = _a[2];\r\n                resolve(_this);\r\n            })\r\n                .catch(function () {\r\n                logger_1.logger.log(_this.user_friendly_id() + '.syncBarrier(): rejected.');\r\n                reject();\r\n            });\r\n        });\r\n    };\r\n    return RemoteDeviceInfo;\r\n}(proxyobject_1.ProxyObject));\r\nexports.RemoteDeviceInfo = RemoteDeviceInfo;\r\nvar RemoteDevices = /** @class */ (function (_super) {\r\n    __extends(RemoteDevices, _super);\r\n    function RemoteDevices() {\r\n        var _this = _super.call(this, null, webrpcclassinfo_1.class_id_t.MediaDevices, 0, proxyobject_1.ProxyMode.Local, function () {\r\n            _this.setDeviceChangeCallback();\r\n        }) || this;\r\n        _this.devices_ = [];\r\n        return _this;\r\n    }\r\n    RemoteDevices.prototype.enumerateDevices = function () {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + '.enumerateDevices() called');\r\n        return new Promise(function (resolve, reject) {\r\n            _this.waitUntilConnected('RemoteDevices.enumerateDevices')\r\n                .then(function () {\r\n                return _this.remoteInvoke(false, webrpcclassinfo_1.method_id_MediaDevices_t.enumerateDevices, []);\r\n            })\r\n                .then(function (obj) {\r\n                var promises = [];\r\n                obj.params[0].forEach(function (item) {\r\n                    var device = _this.devices_.find(function (d) { return d.object_id() === item.oid; });\r\n                    if (device === undefined) {\r\n                        device = new RemoteDeviceInfo(item.oid);\r\n                        promises.push(device.syncBarrier());\r\n                    }\r\n                    else {\r\n                        promises.push(device);\r\n                    }\r\n                });\r\n                return Promise.all(promises);\r\n            })\r\n                .then(function (devices) {\r\n                logger_1.logger.log(_this.user_friendly_id() + '.enumerateDevices: returning enumerated devices with ids [' + devices.map(function (dev) { return dev.object_id(); }) + ']');\r\n                resolve(devices);\r\n                //release devices that are no longer on the client\r\n                _this.devices_.forEach(function (oldDevice) {\r\n                    var dispose = true;\r\n                    for (var _i = 0, devices_1 = devices; _i < devices_1.length; _i++) {\r\n                        var newDevice = devices_1[_i];\r\n                        if (oldDevice === newDevice) {\r\n                            dispose = false;\r\n                            break;\r\n                        }\r\n                    }\r\n                    if (dispose) {\r\n                        oldDevice.release();\r\n                    }\r\n                });\r\n                //save new devices\r\n                _this.devices_ = devices;\r\n                exports.enumerateddecices = enumerateddecices = devices;\r\n            })\r\n                .catch(function () {\r\n                logger_1.logger.log(_this.user_friendly_id() + '.enumerateDevices() didnt get response.');\r\n                _this.devices_ = [];\r\n                reject();\r\n            });\r\n        });\r\n    };\r\n    RemoteDevices.prototype.getDisplayMedia = function (constraints) {\r\n        var _this = this;\r\n        return new Promise(function (resolve, reject) {\r\n            _this.waitUntilConnected('RemoteDevices.getDisplayMedia')\r\n                .then(function () {\r\n                // prepare internal constraints because WebRTC media constraints supported started from 1.3.0.5 version only\r\n                var internalConstraints = _this.prepareDisplayConstraints(constraints);\r\n                return _this.remoteInvoke(false, webrpcclassinfo_1.method_id_MediaDevices_t.getDisplayMedia, internalConstraints);\r\n            })\r\n                .then(function (obj) {\r\n                var displayStream = new RemoteStream(null, obj.params[0].oid);\r\n                return displayStream.syncBarrier();\r\n            })\r\n                .then(function (stream) {\r\n                resolve(stream);\r\n            })\r\n                .catch(function () {\r\n                logger_1.logger.log(_this.user_friendly_id() + '.getDisplayMedia() returned an error.');\r\n                reject(new DOMException(\"Unable to get a display stream.\", \"NotReadableError\"));\r\n            });\r\n        });\r\n    };\r\n    RemoteDevices.prototype.setDeviceChangeCallback = function () {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + '.set_DeviceChangeCallback() called.');\r\n        this.waitUntilConnected('MediaDevices.ondevicechange')\r\n            .then(function () {\r\n            var callbacks = _this.registerCallbacks(false, false, webrpcclassinfo_1.method_id_MediaDevices_t.ondevicechange);\r\n            callbacks.then(function () {\r\n                logger_1.logger.log(_this.user_friendly_id() + '.ondevicechange(): callback received!!!');\r\n                navigator.mediaDevices.dispatchEvent(new CustomEvent('devicechange'));\r\n            });\r\n            return _this.remoteInvoke(true, webrpcclassinfo_1.method_id_MediaDevices_t.ondevicechange, callbacks['success']);\r\n        })\r\n            .catch(function () {\r\n            logger_1.logger.log(_this.user_friendly_id() + '.set_ondevicechange(): failed.');\r\n        });\r\n    };\r\n    RemoteDevices.prototype.prepareDisplayConstraints = function (constraints) {\r\n        if (hdxms_1.getRedirector().getFeatureValue(webrpcclassinfo_1.FEATURE_ms_teams_common_media_constraints)) {\r\n            return constraints;\r\n        }\r\n        // support custom media constraints structures\r\n        // prepare default constraints value\r\n        var video_constraints = {\r\n            frameRate: 15,\r\n            width: {\r\n                max: 1920\r\n            },\r\n            height: {\r\n                max: 1080\r\n            }\r\n        };\r\n        // replace if the original ine is exists\r\n        if (constraints.video !== undefined && constraints.video !== null) {\r\n            var video = constraints.video;\r\n            if (video.frameRate !== undefined && video.width !== undefined && video.height !== undefined) {\r\n                video_constraints.frameRate = video.frameRate;\r\n                video_constraints.width['max'] = video.width['max'] || video.width;\r\n                video_constraints.height['max'] = video.height['max'] || video.height;\r\n            }\r\n        }\r\n        return { video: video_constraints };\r\n    };\r\n    return RemoteDevices;\r\n}(proxyobject_1.ProxyObject));\r\nexports.RemoteDevices = RemoteDevices;\r\n/**@nocollapse*/\r\nvar NavigatorUserMedia = /** @class */ (function (_super) {\r\n    __extends(NavigatorUserMedia, _super);\r\n    function NavigatorUserMedia() {\r\n        return _super.call(this, null, webrpcclassinfo_1.class_id_t.NavigatorUserMedia, 0, proxyobject_1.ProxyMode.Local) || this;\r\n    }\r\n    NavigatorUserMedia.prototype.webkitGetUserMedia = function (constraints, successCallback, errorCallback) {\r\n        this.getUserMedia(constraints, successCallback, errorCallback);\r\n    };\r\n    NavigatorUserMedia.prototype.LogTelemetryDevice_ = function (constraints) {\r\n        try {\r\n            var audioundefined = constraints.audio;\r\n            if (typeof (audioundefined) !== 'undefined') {\r\n                var audio = constraints.audio;\r\n                var audiosrc_1 = audio.deviceId;\r\n                var MatchedAudioDevice_1;\r\n                enumerateddecices.forEach(function (enumerateddecices) {\r\n                    if (audiosrc_1 == enumerateddecices.deviceId) {\r\n                        MatchedAudioDevice_1 = enumerateddecices.label;\r\n                    }\r\n                });\r\n                logger_1.logger.log(MatchedAudioDevice_1);\r\n                //send audiomatched device to websocket service\r\n                this.SendTelemetryData(telemetry_1.tel_key_AudioDeviceUsed, MatchedAudioDevice_1, 0);\r\n            }\r\n            var videoundefined = constraints.video;\r\n            if (typeof (videoundefined) !== 'undefined') {\r\n                var video = constraints.video;\r\n                var videosrc_1 = video.mandatory.sourceId;\r\n                var MatchedVideoDevice_1;\r\n                enumerateddecices.forEach(function (enumerateddecices) {\r\n                    if (videosrc_1 == enumerateddecices.deviceId) {\r\n                        MatchedVideoDevice_1 = enumerateddecices.label;\r\n                    }\r\n                });\r\n                logger_1.logger.log(MatchedVideoDevice_1);\r\n                //send audiomatched device to websocket service\r\n                this.SendTelemetryData(telemetry_1.tel_key_VideoDeviceUsed, MatchedVideoDevice_1, 0);\r\n            }\r\n        }\r\n        catch (err) {\r\n            logger_1.logger.log(err);\r\n        }\r\n    };\r\n    NavigatorUserMedia.prototype.getUserMedia = function (constraints, successCallback, errorCallback) {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + '.getUserMedia() called: ' + JSON.stringify(constraints));\r\n        this.waitUntilConnected('NavigatorUserMedia.getUserMedia')\r\n            .then(function () {\r\n            var callbacks = _this.registerCallbacks(true, false, webrpcclassinfo_1.method_id_NavigatorUserMedia_t.getUserMedia);\r\n            if (typeof constraints.audio !== 'undefined') {\r\n                if (Object.keys(constraints.audio).length == 0)\r\n                    constraints.audio = { dummy: 1 }; //for cases where audio:{}, add a dummy element so we can unmarshall audio\r\n            }\r\n            if (typeof constraints.video !== 'undefined') {\r\n                var vids = constraints.video;\r\n                if (vids.mandatory.maxFrameRate == undefined) {\r\n                    vids.mandatory.maxFrameRate = 30;\r\n                }\r\n                if (vids.mandatory.minWidth == undefined) {\r\n                    vids.mandatory.minWidth = 360;\r\n                }\r\n                if (vids.mandatory.maxWidth == undefined) {\r\n                    vids.mandatory.maxWidth = 1920;\r\n                }\r\n                if (vids.mandatory.minHeight == undefined) {\r\n                    vids.mandatory.minHeight = 180;\r\n                }\r\n                if (vids.mandatory.maxHeight == undefined) {\r\n                    vids.mandatory.maxHeight = 1080;\r\n                }\r\n            }\r\n            _this.remoteInvoke(false, webrpcclassinfo_1.method_id_NavigatorUserMedia_t.getUserMedia, constraints, callbacks.success, callbacks.fail);\r\n            return callbacks.prom();\r\n        })\r\n            .then(function (obj) {\r\n            logger_1.logger.log(_this.user_friendly_id() + '.getUserMedia: received success callback!');\r\n            var stream = new RemoteStream(null, _this.param0(obj)['oid']);\r\n            return stream.syncBarrier();\r\n        })\r\n            .then(function (stream) {\r\n            var s = stream;\r\n            logger_1.logger.log(_this.user_friendly_id() + '.getUserMedia: MediaStream ready to deliver', JSON.stringify(s));\r\n            if (s.getTracks().length == 0) {\r\n                logger_1.logger.log(_this.user_friendly_id() + '.getUserMedia: reporting no tracks as error.');\r\n                errorCallback({ constraintName: \"\", name: \"OverconstrainedError\", message: \"\" });\r\n            }\r\n            else {\r\n                _this.LogTelemetryDevice_(constraints);\r\n                successCallback(s);\r\n            }\r\n        })\r\n            .catch(function (err) {\r\n            if (hdxms_1.getRedirector().getFeatureValue(webrpcclassinfo_1.FEATURE_ms_teams_1912)) {\r\n                errorCallback(_this.param0(err));\r\n            }\r\n            else {\r\n                errorCallback({ constraintName: \"\", name: \"OverconstrainedError\", message: \"\" });\r\n            }\r\n        });\r\n    };\r\n    NavigatorUserMedia.prototype.SendTelemetryData = function (key_, value_, flags_) {\r\n        hdxms_1.getRedirector().telemetry.SendTelemetryData(telemetry_1.tel_cmd.Data, key_, value_, flags_);\r\n    };\r\n    return NavigatorUserMedia;\r\n}(proxyobject_1.ProxyObject));\r\nexports.NavigatorUserMedia = NavigatorUserMedia;\r\n\n\n//# sourceURL=webpack://CitrixWebRTC/E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/remotemedia.js?");
      },
      "../../../out/shim/sdk/int/sdk/remotesession.js":
      /*!***************************************************************************!*\
        !*** E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/remotesession.js ***!
        \***************************************************************************/

      /*! no static exports found */
      function outShimSdkIntSdkRemotesessionJs(module, exports, __webpack_require__) {

        eval('\r\nObject.defineProperty(exports, "__esModule", { value: true });\r\nvar hdxms_1 = __webpack_require__(/*! ./hdxms */ "../../../out/shim/sdk/int/sdk/hdxms.js");\r\nvar webrpcclassinfo_1 = __webpack_require__(/*! ./webrpcclassinfo */ "../../../out/shim/sdk/int/sdk/webrpcclassinfo.js");\r\nvar enginecontrol_1 = __webpack_require__(/*! ./enginecontrol */ "../../../out/shim/sdk/int/sdk/enginecontrol.js");\r\nvar logger_1 = __webpack_require__(/*! ./logger */ "../../../out/shim/sdk/int/sdk/logger.js");\r\nvar webrpcclassinfo_2 = __webpack_require__(/*! ./webrpcclassinfo */ "../../../out/shim/sdk/int/sdk/webrpcclassinfo.js");\r\nvar telemetry_1 = __webpack_require__(/*! ./telemetry */ "../../../out/shim/sdk/int/sdk/telemetry.js");\r\nvar RemoteType;\r\n(function (RemoteType) {\r\n    RemoteType[RemoteType["Unknown"] = 0] = "Unknown";\r\n    RemoteType[RemoteType["Windows"] = 1] = "Windows";\r\n    RemoteType[RemoteType["Linux"] = 2] = "Linux";\r\n})(RemoteType = exports.RemoteType || (exports.RemoteType = {}));\r\nvar SessionInfo = /** @class */ (function () {\r\n    function SessionInfo() {\r\n    }\r\n    return SessionInfo;\r\n}());\r\nexports.SessionInfo = SessionInfo;\r\nvar RemoteSession = /** @class */ (function () {\r\n    function RemoteSession() {\r\n        var _this = this;\r\n        this.isremote_ = false;\r\n        this.isremote_ = true; //set default to remote\r\n        this.type_ = RemoteType.Windows; //set default to windows\r\n        this.address_ = "0.0.0.0"; //not supported yet\r\n        this.sessioninfo_ = null;\r\n        hdxms_1.getRedirector().setRemoteSessionInfoCb(function () { return _this.remoteSessionInfo(); });\r\n        this.enginecontrol_ = new enginecontrol_1.EngineControl();\r\n    }\r\n    RemoteSession.prototype.release = function () {\r\n        hdxms_1.getRedirector().setRemoteSessionInfoCb(null);\r\n    };\r\n    RemoteSession.prototype.user_friendly_id = function () {\r\n        return \'[RemoteSession]\';\r\n    };\r\n    RemoteSession.prototype.getFeatureFlags = function () {\r\n        var features = {};\r\n        if (this.enginecontrol_ !== null && this.enginecontrol_.features_ !== null && this.enginecontrol_.features_ !== undefined) {\r\n            this.enginecontrol_.features_.forEach(function (e) {\r\n                features[e.name] = e.value;\r\n            });\r\n        }\r\n        return features;\r\n    };\r\n    /*\r\n     * Check feature_flags against a list of sub-features that make up a ms feature from the featureNameMap. Returns true if all sub features\r\n     * are present in feature_flags and their values are true.\r\n     */\r\n    RemoteSession.prototype.isFeatureSupported = function (feature) {\r\n        // TODO : implement proper feature support check for "video"\r\n        if (feature === "video") {\r\n            return true;\r\n        }\r\n        // this feature is not in our feature_flags list\r\n        if (!(feature in webrpcclassinfo_2.featureNameMap)) {\r\n            return false;\r\n        }\r\n        // get list of all sub-features for this feature\r\n        var subFeatures = webrpcclassinfo_2.featureNameMap[feature];\r\n        // get a hash map of feature_flags\r\n        var featureFlags = this.getFeatureFlags();\r\n        for (var i = 0; i < subFeatures.length; i++) {\r\n            if (!(subFeatures[i] in featureFlags) || (featureFlags[subFeatures[i]] !== true)) {\r\n                return false;\r\n            }\r\n        }\r\n        return true;\r\n    };\r\n    RemoteSession.isFeaturePstnSupported = function () {\r\n        return RemoteSession.pstn_;\r\n    };\r\n    // syncBarrier is used because methods on this interface return synchronously and we cant block in JavaScript\r\n    RemoteSession.prototype.getSessionInfo = function () {\r\n        logger_1.logger.log(this.user_friendly_id() + \'.getSessionInfo() called.\');\r\n        //we already have session info\r\n        if (this.sessioninfo_ != null) {\r\n            return Promise.resolve(this.sessioninfo_);\r\n        }\r\n        else {\r\n            return Promise.reject();\r\n        }\r\n    };\r\n    RemoteSession.prototype.remoteSessionInfo = function () {\r\n        var _this = this;\r\n        var self = this;\r\n        logger_1.logger.log(self.user_friendly_id() + \'.remoteSessionInfo() called.\');\r\n        //retrieve sessioninfo\r\n        return new Promise(function (resolve, reject) {\r\n            //webrpc engine version\r\n            self.enginecontrol_.syncBarrier().then(function (e) {\r\n                logger_1.logger.log(self.user_friendly_id() + \'enginecontrol info received!\');\r\n                self.sessioninfo_ = new SessionInfo();\r\n                //TypeScript version\r\n                self.sessioninfo_.type_script = webrpcclassinfo_1.HDXMS_VERSION;\r\n                //webrpc default version that is returned from e.version_\r\n                var webrpc_version = e.version_.major.toString() + "." + e.version_.minor.toString() + "." + e.version_.revision.toString() + "." + e.version_.build.toString();\r\n                self.sessioninfo_.webrpc = webrpc_version;\r\n                //convert version to string format\r\n                //e.versions_ contains valid value only if the client is 1906 or later (ds feature)\r\n                if (e.versions_ != undefined && e.versions_ != null) {\r\n                    //Perf data\r\n                    self.SendTelemetryData(telemetry_1.tel_key_VerTypeScript, webrpcclassinfo_1.HDXMS_VERSION, 0);\r\n                    var i = 0;\r\n                    for (var _i = 0, _a = e.versions_; _i < _a.length; _i++) {\r\n                        var v = _a[_i];\r\n                        var version_str = v.major.toString() + "." + v.minor.toString() + "." + v.revision.toString() + "." + v.build.toString();\r\n                        switch (i) {\r\n                            case enginecontrol_1.VersionType.Webrpc:\r\n                                self.sessioninfo_.webrpc = version_str;\r\n                                //Perf data\r\n                                self.SendTelemetryData(telemetry_1.tel_key_VerWebrpc, version_str, 0);\r\n                                break;\r\n                            case enginecontrol_1.VersionType.WebrtcCodecs:\r\n                                self.sessioninfo_.webrtc_codecs = version_str;\r\n                                //Perf data\r\n                                self.SendTelemetryData(telemetry_1.tel_key_VerWebrtcCodecs, version_str, 0);\r\n                                break;\r\n                            case enginecontrol_1.VersionType.Receiver:\r\n                                self.sessioninfo_.receiver = version_str;\r\n                                //Perf data\r\n                                self.SendTelemetryData(telemetry_1.tel_key_VerReceiver, version_str, 0);\r\n                                break;\r\n                            case enginecontrol_1.VersionType.Vda:\r\n                                self.sessioninfo_.vda = version_str;\r\n                                self.SendTelemetryData(telemetry_1.tel_key_VerVda, version_str, 0);\r\n                                break;\r\n                            case enginecontrol_1.VersionType.Endpoint:\r\n                                self.sessioninfo_.endpoint = version_str;\r\n                                //Perf data\r\n                                self.SendTelemetryData(telemetry_1.tel_key_VerEndpoint, version_str, 0);\r\n                                break;\r\n                            default:\r\n                                logger_1.logger.log(self.user_friendly_id() + \'Unknown version type!\');\r\n                                break;\r\n                        }\r\n                        i++;\r\n                    }\r\n                }\r\n                if (e.osinfo_ != undefined && e.osinfo_ != null) {\r\n                    self.sessioninfo_.osinfo = e.osinfo_;\r\n                    self.SendTelemetryData(telemetry_1.tel_key_OSFamily, e.osinfo_.family, 0);\r\n                    self.SendTelemetryData(telemetry_1.tel_key_OSVersion, e.osinfo_.version, 0);\r\n                    self.SendTelemetryData(telemetry_1.tel_key_OSArchitecture, e.osinfo_.architecture, 0);\r\n                    self.SendTelemetryData(telemetry_1.tel_key_OSDistro, e.osinfo_.distro, 0);\r\n                    self.SendTelemetryData(telemetry_1.tel_key_OSEdition, e.osinfo_.edition, 0);\r\n                }\r\n                if (e.sessionidentifier_ != undefined && e.sessionidentifier_ != null) {\r\n                    self.sessioninfo_.session_identifier = e.sessionidentifier_;\r\n                }\r\n                RemoteSession.pstn_ = _this.isFeatureSupported(webrpcclassinfo_1.FEATURE_public_pstn);\r\n                resolve(self.sessioninfo_);\r\n                //cleanup\r\n                self.enginecontrol_.release();\r\n            })\r\n                .catch(function () {\r\n                //start timer to re-try if ping is active\r\n                if (hdxms_1.getRedirector().isPingActive()) {\r\n                    self.retrySessionInfo();\r\n                }\r\n                else {\r\n                    //reject current promise\r\n                    reject();\r\n                    //cleanup\r\n                    self.enginecontrol_.release();\r\n                    self.enginecontrol_ = null;\r\n                }\r\n            });\r\n        });\r\n    };\r\n    RemoteSession.prototype.retrySessionInfo = function () {\r\n        var self = this;\r\n        setTimeout(function () {\r\n            //need to wait for another round\r\n            logger_1.logger.log(\'checking if we are connected...\');\r\n            self.enginecontrol_.bind();\r\n            hdxms_1.getRedirector().handleRemoteSessionInfo();\r\n        }, 15000);\r\n    };\r\n    RemoteSession.prototype.SendTelemetryData = function (key_, value_, flags_) {\r\n        hdxms_1.getRedirector().telemetry.SendTelemetryData(telemetry_1.tel_cmd.Data, key_, value_, flags_);\r\n    };\r\n    RemoteSession.pstn_ = false;\r\n    return RemoteSession;\r\n}());\r\nexports.RemoteSession = RemoteSession;\r\n\n\n//# sourceURL=webpack://CitrixWebRTC/E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/remotesession.js?');
      },
      "../../../out/shim/sdk/int/sdk/rtpsender.js":
      /*!***********************************************************************!*\
        !*** E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/rtpsender.js ***!
        \***********************************************************************/

      /*! no static exports found */
      function outShimSdkIntSdkRtpsenderJs(module, exports, __webpack_require__) {

        eval("\r\nvar __extends = (this && this.__extends) || (function () {\r\n    var extendStatics = function (d, b) {\r\n        extendStatics = Object.setPrototypeOf ||\r\n            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||\r\n            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };\r\n        return extendStatics(d, b);\r\n    }\r\n    return function (d, b) {\r\n        extendStatics(d, b);\r\n        function __() { this.constructor = d; }\r\n        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());\r\n    };\r\n})();\r\nvar __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {\r\n    return new (P || (P = Promise))(function (resolve, reject) {\r\n        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }\r\n        function rejected(value) { try { step(generator[\"throw\"](value)); } catch (e) { reject(e); } }\r\n        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }\r\n        step((generator = generator.apply(thisArg, _arguments || [])).next());\r\n    });\r\n};\r\nvar __generator = (this && this.__generator) || function (thisArg, body) {\r\n    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;\r\n    return g = { next: verb(0), \"throw\": verb(1), \"return\": verb(2) }, typeof Symbol === \"function\" && (g[Symbol.iterator] = function() { return this; }), g;\r\n    function verb(n) { return function (v) { return step([n, v]); }; }\r\n    function step(op) {\r\n        if (f) throw new TypeError(\"Generator is already executing.\");\r\n        while (_) try {\r\n            if (f = 1, y && (t = op[0] & 2 ? y[\"return\"] : op[0] ? y[\"throw\"] || ((t = y[\"return\"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;\r\n            if (y = 0, t) op = [op[0] & 2, t.value];\r\n            switch (op[0]) {\r\n                case 0: case 1: t = op; break;\r\n                case 4: _.label++; return { value: op[1], done: false };\r\n                case 5: _.label++; y = op[1]; op = [0]; continue;\r\n                case 7: op = _.ops.pop(); _.trys.pop(); continue;\r\n                default:\r\n                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }\r\n                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }\r\n                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }\r\n                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }\r\n                    if (t[2]) _.ops.pop();\r\n                    _.trys.pop(); continue;\r\n            }\r\n            op = body.call(thisArg, _);\r\n        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }\r\n        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };\r\n    }\r\n};\r\nObject.defineProperty(exports, \"__esModule\", { value: true });\r\nvar proxyobject_1 = __webpack_require__(/*! ./proxyobject */ \"../../../out/shim/sdk/int/sdk/proxyobject.js\");\r\nvar webrpcclassinfo_1 = __webpack_require__(/*! ./webrpcclassinfo */ \"../../../out/shim/sdk/int/sdk/webrpcclassinfo.js\");\r\nvar logger_1 = __webpack_require__(/*! ./logger */ \"../../../out/shim/sdk/int/sdk/logger.js\");\r\nvar remotemedia_1 = __webpack_require__(/*! ./remotemedia */ \"../../../out/shim/sdk/int/sdk/remotemedia.js\");\r\nvar stats_1 = __webpack_require__(/*! ./stats */ \"../../../out/shim/sdk/int/sdk/stats.js\");\r\nvar remotesession_1 = __webpack_require__(/*! ./remotesession */ \"../../../out/shim/sdk/int/sdk/remotesession.js\");\r\nvar DTMFToneChangeEvent = /** @class */ (function (_super) {\r\n    __extends(DTMFToneChangeEvent, _super);\r\n    function DTMFToneChangeEvent(parent, oid) {\r\n        var _this = _super.call(this, parent, webrpcclassinfo_1.class_id_t.RTCDTMFToneChangeEvent, oid, proxyobject_1.ProxyMode.Remote) || this;\r\n        logger_1.logger.log(_this.user_friendly_id() + '.constructor');\r\n        return _this;\r\n    }\r\n    DTMFToneChangeEvent.prototype.syncBarrier = function () {\r\n        return __awaiter(this, void 0, void 0, function () {\r\n            var _a, promises;\r\n            var _this = this;\r\n            return __generator(this, function (_b) {\r\n                switch (_b.label) {\r\n                    case 0:\r\n                        logger_1.logger.log(this.user_friendly_id() + '.syncBarrier() called.');\r\n                        return [4 /*yield*/, this.waitUntilConnected('DTMFToneChangeEvent.syncBarrier')];\r\n                    case 1:\r\n                        _b.sent();\r\n                        return [4 /*yield*/, Promise.all([\r\n                                this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCDTMFToneChangeEvent_t.tone, \"\"),\r\n                                this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCDTMFToneChangeEvent_t.tone_buffer, \"\")\r\n                            ])];\r\n                    case 2:\r\n                        promises = _b.sent();\r\n                        _a = promises.map(function (result) { return _this.param0(result); }), this.tone = _a[0], this.tone_buffer_ = _a[1];\r\n                        return [2 /*return*/, this];\r\n                }\r\n            });\r\n        });\r\n    };\r\n    Object.defineProperty(DTMFToneChangeEvent.prototype, \"tone_buffer\", {\r\n        get: function () {\r\n            return this.tone_buffer_;\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    return DTMFToneChangeEvent;\r\n}(proxyobject_1.ProxyObject));\r\nexports.DTMFToneChangeEvent = DTMFToneChangeEvent;\r\nvar DtmfSender = /** @class */ (function (_super) {\r\n    __extends(DtmfSender, _super);\r\n    function DtmfSender(parent, oid) {\r\n        var _this = _super.call(this, parent, webrpcclassinfo_1.class_id_t.RTCDTMFSender, oid, proxyobject_1.ProxyMode.Remote) || this;\r\n        logger_1.logger.log(_this.user_friendly_id() + '.constructor');\r\n        _this.canInsertDTMF = true;\r\n        _this.toneBuffer_ = \"\";\r\n        return _this;\r\n    }\r\n    DtmfSender.prototype.insertDTMF = function (tones, duration, interToneGap) {\r\n        var _this = this;\r\n        if (duration === void 0) { duration = 100; }\r\n        if (interToneGap === void 0) { interToneGap = 70; }\r\n        logger_1.logger.log(this.user_friendly_id() + '.insertDTMF() called, tones: ' + tones);\r\n        this.waitUntilConnected('DtmfSender.insertDTMF')\r\n            .then(function () {\r\n            return _this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCDTMFSender_t.insertDTMF, tones, duration, interToneGap);\r\n        })\r\n            .then(function () {\r\n            logger_1.logger.log(_this.user_friendly_id() + '.insertDTMF() success, tones: ' + tones);\r\n        })\r\n            .catch(function () {\r\n            logger_1.logger.log(_this.user_friendly_id() + '.insertDTMF() failed, tones: ' + tones);\r\n        });\r\n    };\r\n    Object.defineProperty(DtmfSender.prototype, \"ontonechange\", {\r\n        get: function () {\r\n            return this.ontonechange_;\r\n        },\r\n        set: function (f) {\r\n            var _this = this;\r\n            logger_1.logger.log(this.user_friendly_id() + '.set_ontonechange() called.');\r\n            this.ontonechange_ = f;\r\n            this.waitUntilConnected('DtmfSender.ontonechange')\r\n                .then(function () {\r\n                var callbacks = _this.registerCallbacks(false, _this.isNullCallback(f), webrpcclassinfo_1.method_id_RTCDTMFSender_t.ontonechange);\r\n                callbacks.then(function (obj) {\r\n                    logger_1.logger.log(_this.user_friendly_id() + '.ontonechange callback received!');\r\n                    var toneEvt = new DTMFToneChangeEvent(_this, _this.param0(obj)['oid']);\r\n                    toneEvt.syncBarrier()\r\n                        .then(function (evt) {\r\n                        logger_1.logger.log(_this.user_friendly_id() + 'tone: ' + evt.tone + ' tone_buffer: ' + evt.tone_buffer);\r\n                        _this.toneBuffer_ = evt.tone_buffer;\r\n                        _this.ontonechange_(evt);\r\n                    })\r\n                        .catch(function () {\r\n                        logger_1.logger.log(_this.user_friendly_id() + 'toneEvt.syncBarrier(): failed!');\r\n                    });\r\n                });\r\n                return _this.remoteInvoke(true, webrpcclassinfo_1.method_id_RTCDTMFSender_t.ontonechange, callbacks.success);\r\n            })\r\n                .catch(function () { logger_1.logger.log(_this.user_friendly_id() + '.set_ontonechange(): failed!'); });\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    Object.defineProperty(DtmfSender.prototype, \"toneBuffer\", {\r\n        get: function () {\r\n            logger_1.logger.log(this.user_friendly_id() + '.toneBuffer() called.');\r\n            return this.toneBuffer_;\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    return DtmfSender;\r\n}(proxyobject_1.ProxyObject));\r\nexports.DtmfSender = DtmfSender;\r\nvar IceTransport = /** @class */ (function (_super) {\r\n    __extends(IceTransport, _super);\r\n    function IceTransport(parent, oid) {\r\n        var _this = _super.call(this, parent, webrpcclassinfo_1.class_id_t.RTCIceTransport, oid, proxyobject_1.ProxyMode.Remote) || this;\r\n        logger_1.logger.log(_this.user_friendly_id() + '.constructor');\r\n        _this.selectedPair = null;\r\n        _this.localCandidates_ = [];\r\n        _this.remoteCandidates_ = [];\r\n        return _this;\r\n    }\r\n    IceTransport.prototype.syncBarrier = function () {\r\n        return __awaiter(this, void 0, void 0, function () {\r\n            var _a, promises, stateIdx, gatherStateIdx;\r\n            var _this = this;\r\n            return __generator(this, function (_b) {\r\n                switch (_b.label) {\r\n                    case 0:\r\n                        logger_1.logger.log(this.user_friendly_id() + '.syncBarrier() called.');\r\n                        return [4 /*yield*/, this.waitUntilConnected('IceTransport.syncBarrier')];\r\n                    case 1:\r\n                        _b.sent();\r\n                        return [4 /*yield*/, Promise.all([\r\n                                this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCIceTransport_t.role, 0),\r\n                                this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCIceTransport_t.component, 0),\r\n                                this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCIceTransport_t.state, 0),\r\n                                this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCIceTransport_t.gatheringState, 0)\r\n                            ])];\r\n                    case 2:\r\n                        promises = _b.sent();\r\n                        stateIdx = 0;\r\n                        gatherStateIdx = 0;\r\n                        _a = promises.map(function (result) { return _this.param0(result); }), this.role_ = _a[0], this.component_ = _a[1], stateIdx = _a[2], gatherStateIdx = _a[3];\r\n                        this.state_ = IceTransport.convertState(stateIdx);\r\n                        this.gatheringState_ = IceTransport.convertGatheringState(gatherStateIdx);\r\n                        //sync candidates\r\n                        this.syncCandidates().then(function (e) {\r\n                            logger_1.logger.log(_this.user_friendly_id() + 'received updated ice candidates!');\r\n                        });\r\n                        return [2 /*return*/, this];\r\n                }\r\n            });\r\n        });\r\n    };\r\n    IceTransport.prototype.syncCandidates = function () {\r\n        return __awaiter(this, void 0, void 0, function () {\r\n            var _a, promises;\r\n            var _this = this;\r\n            return __generator(this, function (_b) {\r\n                switch (_b.label) {\r\n                    case 0:\r\n                        logger_1.logger.log(this.user_friendly_id() + '.syncCandidates() called.');\r\n                        return [4 /*yield*/, this.waitUntilConnected('IceTransport.syncCandidates')];\r\n                    case 1:\r\n                        _b.sent();\r\n                        return [4 /*yield*/, Promise.all([\r\n                                this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCIceTransport_t.localcandidates, []),\r\n                                this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCIceTransport_t.remotecandidates, [])\r\n                            ])];\r\n                    case 2:\r\n                        promises = _b.sent();\r\n                        _a = promises.map(function (result) { return _this.param0(result); }), this.localCandidates_ = _a[0], this.remoteCandidates_ = _a[1];\r\n                        return [2 /*return*/, this];\r\n                }\r\n            });\r\n        });\r\n    };\r\n    Object.defineProperty(IceTransport.prototype, \"role\", {\r\n        get: function () {\r\n            return this.role_;\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    Object.defineProperty(IceTransport.prototype, \"component\", {\r\n        get: function () {\r\n            return this.component_;\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    Object.defineProperty(IceTransport.prototype, \"State\", {\r\n        get: function () {\r\n            return this.state_;\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    Object.defineProperty(IceTransport.prototype, \"gatheringState\", {\r\n        get: function () {\r\n            return this.gatheringState_;\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    Object.defineProperty(IceTransport.prototype, \"onstatechange\", {\r\n        get: function () {\r\n            return this.onstatechange_;\r\n        },\r\n        set: function (f) {\r\n            var _this = this;\r\n            logger_1.logger.log(this.user_friendly_id() + '.set_onstatechange() called.');\r\n            this.onstatechange_ = f;\r\n            this.waitUntilConnected('IceTransport.onstatechange')\r\n                .then(function () {\r\n                var callbacks = _this.registerCallbacks(false, _this.isNullCallback(f), webrpcclassinfo_1.method_id_RTCIceTransport_t.onstatechange);\r\n                callbacks.then(function (obj) {\r\n                    logger_1.logger.log(_this.user_friendly_id() + '.onstatechange callback received!');\r\n                    //sync candidates\r\n                    _this.syncCandidates().then(function (e) {\r\n                        logger_1.logger.log(_this.user_friendly_id() + 'received updated ice candidates!');\r\n                    });\r\n                    //notify state change\r\n                    _this.state_ = IceTransport.convertState(_this.param0(obj));\r\n                    logger_1.logger.log(_this.user_friendly_id() + 'state: ' + _this.state_);\r\n                    _this.onstatechange_();\r\n                });\r\n                return _this.remoteInvoke(true, webrpcclassinfo_1.method_id_RTCIceTransport_t.onstatechange, callbacks.success);\r\n            })\r\n                .catch(function () { logger_1.logger.log(_this.user_friendly_id() + '.set_onstatechange failed!'); });\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    Object.defineProperty(IceTransport.prototype, \"ongatheringstatechange\", {\r\n        get: function () {\r\n            return this.ongatheringstatechange_;\r\n        },\r\n        set: function (f) {\r\n            var _this = this;\r\n            logger_1.logger.log(this.user_friendly_id() + '.set_ongatheringstatechange() called.');\r\n            this.ongatheringstatechange_ = f;\r\n            this.waitUntilConnected('IceTransport.ongatheringstatechange')\r\n                .then(function () {\r\n                var callbacks = _this.registerCallbacks(false, _this.isNullCallback(f), webrpcclassinfo_1.method_id_RTCIceTransport_t.ongatheringstatechange);\r\n                callbacks.then(function (obj) {\r\n                    logger_1.logger.log(_this.user_friendly_id() + '.ongatheringstatechange callback received!');\r\n                    //sync candidates\r\n                    _this.syncCandidates().then(function (e) {\r\n                        logger_1.logger.log(_this.user_friendly_id() + 'received updated ice candidates!');\r\n                    });\r\n                    //notify gathering state change\r\n                    _this.gatheringState_ = IceTransport.convertGatheringState(_this.param0(obj));\r\n                    logger_1.logger.log(_this.user_friendly_id() + 'gatheringState: ' + _this.gatheringState_);\r\n                    _this.ongatheringstatechange_();\r\n                });\r\n                return _this.remoteInvoke(true, webrpcclassinfo_1.method_id_RTCIceTransport_t.ongatheringstatechange, callbacks.success);\r\n            })\r\n                .catch(function () { logger_1.logger.log(_this.user_friendly_id() + '.set_ongatheringstatechange failed!'); });\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    Object.defineProperty(IceTransport.prototype, \"onselectedcandidatepairchange\", {\r\n        get: function () {\r\n            return this.onselectedcandidatepairchange_;\r\n        },\r\n        set: function (f) {\r\n            var _this = this;\r\n            logger_1.logger.log(this.user_friendly_id() + '.set_onselectedcandidatepairchange() called.');\r\n            this.onselectedcandidatepairchange_ = f;\r\n            this.waitUntilConnected('IceTransport.onselectedcandidatepairchange')\r\n                .then(function () {\r\n                var callbacks = _this.registerCallbacks(false, _this.isNullCallback(f), webrpcclassinfo_1.method_id_RTCIceTransport_t.onselectedcandidatepairchange);\r\n                callbacks.then(function (obj) {\r\n                    logger_1.logger.log(_this.user_friendly_id() + '.onselectedcandidatepairchange callback received!');\r\n                    //sync candidates\r\n                    _this.syncCandidates().then(function (e) {\r\n                        logger_1.logger.log(_this.user_friendly_id() + 'received updated ice candidates!');\r\n                    });\r\n                    //notify candidate pair change\r\n                    _this.selectedPair = _this.param0(obj);\r\n                    logger_1.logger.log(_this.user_friendly_id() + 'selectedPair: ' + _this.selectedPair);\r\n                    _this.onselectedcandidatepairchange_();\r\n                });\r\n                return _this.remoteInvoke(true, webrpcclassinfo_1.method_id_RTCIceTransport_t.onselectedcandidatepairchange, callbacks.success);\r\n            })\r\n                .catch(function () { logger_1.logger.log(_this.user_friendly_id() + '.set_onselectedcandidatepairchange failed!'); });\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    IceTransport.prototype.getLocalCandidates = function () {\r\n        return this.localCandidates_;\r\n    };\r\n    IceTransport.prototype.getRemoteCandidates = function () {\r\n        return this.remoteCandidates_;\r\n    };\r\n    IceTransport.prototype.getLocalParameters = function () {\r\n        return null;\r\n    };\r\n    IceTransport.prototype.getRemoteParameters = function () {\r\n        return null;\r\n    };\r\n    IceTransport.prototype.getSelectedCandidatePair = function () {\r\n        return this.selectedPair;\r\n    };\r\n    IceTransport.convertState = function (idx) {\r\n        if (idx == 0) {\r\n            return \"new\";\r\n        }\r\n        else if (idx == 1) {\r\n            return \"checking\";\r\n        }\r\n        else if (idx == 2) {\r\n            return \"connected\";\r\n        }\r\n        else if (idx == 3) {\r\n            return \"completed\";\r\n        }\r\n        else if (idx == 4) {\r\n            return \"failed\";\r\n        }\r\n        else if (idx == 5) {\r\n            return \"disconnected\";\r\n        }\r\n        else {\r\n            return \"closed\";\r\n        }\r\n    };\r\n    IceTransport.convertGatheringState = function (idx) {\r\n        if (idx == 0) {\r\n            return \"new\";\r\n        }\r\n        else if (idx == 1) {\r\n            return \"gathering\";\r\n        }\r\n        else {\r\n            return \"complete\";\r\n        }\r\n    };\r\n    return IceTransport;\r\n}(proxyobject_1.ProxyObject));\r\nexports.IceTransport = IceTransport;\r\n//this enum value matches with native side\r\nvar DtlsTransportState;\r\n(function (DtlsTransportState) {\r\n    DtlsTransportState[DtlsTransportState[\"new\"] = 0] = \"new\";\r\n    DtlsTransportState[DtlsTransportState[\"connecting\"] = 1] = \"connecting\";\r\n    DtlsTransportState[DtlsTransportState[\"connected\"] = 2] = \"connected\";\r\n    DtlsTransportState[DtlsTransportState[\"closed\"] = 3] = \"closed\";\r\n    DtlsTransportState[DtlsTransportState[\"failed\"] = 4] = \"failed\";\r\n    DtlsTransportState[DtlsTransportState[\"max\"] = 5] = \"max\";\r\n})(DtlsTransportState || (DtlsTransportState = {}));\r\nvar DtlsTransport = /** @class */ (function (_super) {\r\n    __extends(DtlsTransport, _super);\r\n    function DtlsTransport(parent, oid) {\r\n        var _this = _super.call(this, parent, webrpcclassinfo_1.class_id_t.RTCDtlsTransport, oid, proxyobject_1.ProxyMode.Remote) || this;\r\n        logger_1.logger.log(_this.user_friendly_id() + '.constructor');\r\n        _this.state_ = \"new\";\r\n        _this.transport_ = null;\r\n        _this.remoteCertificates_ = [];\r\n        return _this;\r\n    }\r\n    DtlsTransport.prototype.syncBarrier = function () {\r\n        return __awaiter(this, void 0, void 0, function () {\r\n            var _a, promises, objRef, transport, _b;\r\n            var _this = this;\r\n            return __generator(this, function (_c) {\r\n                switch (_c.label) {\r\n                    case 0:\r\n                        logger_1.logger.log(this.user_friendly_id() + '.syncBarrier() called.');\r\n                        return [4 /*yield*/, Promise.all([\r\n                                this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCDtlsTransport_t.transport, {}),\r\n                                this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCDtlsTransport_t.getRemoteCertificates, [])\r\n                            ])];\r\n                    case 1:\r\n                        promises = _c.sent();\r\n                        _a = promises.map(function (result) { return _this.param0(result); }), objRef = _a[0], this.remoteCertificates_ = _a[1];\r\n                        if (!(objRef != undefined && objRef['is_null'] == false)) return [3 /*break*/, 3];\r\n                        transport = new IceTransport(this, objRef['oid']);\r\n                        _b = this;\r\n                        return [4 /*yield*/, transport.syncBarrier()];\r\n                    case 2:\r\n                        _b.transport_ = _c.sent();\r\n                        _c.label = 3;\r\n                    case 3: return [2 /*return*/, this];\r\n                }\r\n            });\r\n        });\r\n    };\r\n    Object.defineProperty(DtlsTransport.prototype, \"transport\", {\r\n        get: function () {\r\n            return this.transport_;\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    Object.defineProperty(DtlsTransport.prototype, \"State\", {\r\n        get: function () {\r\n            return this.state_;\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    DtlsTransport.prototype.getRemoteCertificates = function () {\r\n        return this.remoteCertificates_;\r\n    };\r\n    Object.defineProperty(DtlsTransport.prototype, \"onstatechange\", {\r\n        get: function () {\r\n            return this.onstatechange_;\r\n        },\r\n        set: function (f) {\r\n            var _this = this;\r\n            logger_1.logger.log(this.user_friendly_id() + '.set_onstatechange() called.');\r\n            this.onstatechange_ = f;\r\n            this.waitUntilConnected('DtlsTransport.onstatechange')\r\n                .then(function () {\r\n                var callbacks = _this.registerCallbacks(false, _this.isNullCallback(f), webrpcclassinfo_1.method_id_RTCDtlsTransport_t.onstatechange);\r\n                callbacks.then(function (obj) {\r\n                    logger_1.logger.log(_this.user_friendly_id() + '.onstatechange callback received!');\r\n                    _this.state_ = DtlsTransport.convertState(_this.param0(obj));\r\n                    logger_1.logger.log(_this.user_friendly_id() + 'state_: ' + _this.state_);\r\n                    _this.onstatechange_();\r\n                });\r\n                return _this.remoteInvoke(true, webrpcclassinfo_1.method_id_RTCDtlsTransport_t.onstatechange, callbacks.success);\r\n            })\r\n                .catch(function () { });\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    Object.defineProperty(DtlsTransport.prototype, \"onerror\", {\r\n        get: function () {\r\n            return this.onerror_;\r\n        },\r\n        set: function (f) {\r\n            var _this = this;\r\n            logger_1.logger.log(this.user_friendly_id() + '.set_onerror() called.');\r\n            this.onerror_ = f;\r\n            this.waitUntilConnected('DtlsTransport.onerror')\r\n                .then(function () {\r\n                var callbacks = _this.registerCallbacks(false, _this.isNullCallback(f), webrpcclassinfo_1.method_id_RTCDtlsTransport_t.onerror);\r\n                callbacks.then(function (obj) {\r\n                    logger_1.logger.log(_this.user_friendly_id() + '.onerror callback received!');\r\n                    var err = _this.param0(obj);\r\n                    logger_1.logger.log(_this.user_friendly_id() + 'error: ' + err);\r\n                    _this.onerror_(err);\r\n                });\r\n                return _this.remoteInvoke(true, webrpcclassinfo_1.method_id_RTCDtlsTransport_t.onerror, callbacks.success);\r\n            })\r\n                .catch(function () { });\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    DtlsTransport.convertState = function (idx) {\r\n        if (idx == DtlsTransportState.new) {\r\n            return \"new\";\r\n        }\r\n        else if (idx == DtlsTransportState.connecting) {\r\n            return \"connecting\";\r\n        }\r\n        else if (idx == DtlsTransportState.connected) {\r\n            return \"connected\";\r\n        }\r\n        else if (idx == DtlsTransportState.closed) {\r\n            return \"closed\";\r\n        }\r\n        else {\r\n            return \"failed\";\r\n        }\r\n    };\r\n    return DtlsTransport;\r\n}(proxyobject_1.ProxyObject));\r\nexports.DtlsTransport = DtlsTransport;\r\nvar RtpSenderReceiver = /** @class */ (function (_super) {\r\n    __extends(RtpSenderReceiver, _super);\r\n    function RtpSenderReceiver(parent, cid, oid, mode) {\r\n        var _this = _super.call(this, parent, cid, oid, mode) || this;\r\n        logger_1.logger.log(_this.user_friendly_id() + '.constructor base');\r\n        _this.track_ = null;\r\n        _this.transport_ = null;\r\n        _this.rtcpTransport_ = null;\r\n        _this.capabilities_ = null;\r\n        return _this;\r\n    }\r\n    // according to W3C specs, DTLS transports are created during setLocalDescription, setRemoteDescription\r\n    RtpSenderReceiver.prototype.syncBarrierBase = function () {\r\n        return __awaiter(this, void 0, void 0, function () {\r\n            var _a, mid_track, mid_transport, mid_rtcp_transport, mid_capabilities, promises, objRef_track, objRef_transport, objRef_rtcp_transport, _b, _c, _d;\r\n            var _this = this;\r\n            return __generator(this, function (_e) {\r\n                switch (_e.label) {\r\n                    case 0:\r\n                        logger_1.logger.log(this.user_friendly_id() + '.syncBarrierBase() called.');\r\n                        return [4 /*yield*/, this.waitUntilConnected('RtpSenderReceiver.syncBarrierBase')];\r\n                    case 1:\r\n                        _e.sent();\r\n                        if (this instanceof RtpSender) {\r\n                            mid_track = webrpcclassinfo_1.method_id_RTCRtpSender_t.track;\r\n                            mid_transport = webrpcclassinfo_1.method_id_RTCRtpSender_t.transport;\r\n                            mid_rtcp_transport = webrpcclassinfo_1.method_id_RTCRtpSender_t.rtcpTransport;\r\n                            mid_capabilities = webrpcclassinfo_1.method_id_RTCRtpSender_t.getCapabilities;\r\n                        }\r\n                        else if (this instanceof RtpReceiver) {\r\n                            mid_track = webrpcclassinfo_1.method_id_RTCRtpReceiver_t.track;\r\n                            mid_transport = webrpcclassinfo_1.method_id_RTCRtpReceiver_t.transport;\r\n                            mid_rtcp_transport = webrpcclassinfo_1.method_id_RTCRtpReceiver_t.rtcpTransport;\r\n                            mid_capabilities = webrpcclassinfo_1.method_id_RTCRtpReceiver_t.getCapabilities;\r\n                        }\r\n                        if (!remotesession_1.RemoteSession.isFeaturePstnSupported()) return [3 /*break*/, 3];\r\n                        return [4 /*yield*/, Promise.all([\r\n                                this.remoteInvoke(false, mid_track, { \"oid\": this.object_id() }),\r\n                                this.remoteInvoke(false, mid_transport, { \"oid\": this.object_id() }),\r\n                                this.remoteInvoke(false, mid_rtcp_transport, { \"oid\": this.object_id() }),\r\n                                this.remoteInvoke(false, mid_capabilities, { \"oid\": this.object_id() })\r\n                            ])];\r\n                    case 2:\r\n                        promises = _e.sent();\r\n                        return [3 /*break*/, 5];\r\n                    case 3: return [4 /*yield*/, Promise.all([\r\n                            this.remoteInvoke(false, mid_track, { \"oid\": this.object_id() })\r\n                        ])];\r\n                    case 4:\r\n                        promises = _e.sent();\r\n                        _e.label = 5;\r\n                    case 5:\r\n                        _a = promises.map(function (result) { return _this.param0(result); }), objRef_track = _a[0], objRef_transport = _a[1], objRef_rtcp_transport = _a[2], this.capabilities_ = _a[3];\r\n                        _b = this;\r\n                        return [4 /*yield*/, Promise.all(promises.map(function () {\r\n                                if (objRef_track != undefined && objRef_track['is_null'] === false && (_this.track === null || _this.track_.object_id() != objRef_track['oid'])) {\r\n                                    var track = new remotemedia_1.RemoteMediaTrack(_this, objRef_track['oid']);\r\n                                    return track.syncBarrier();\r\n                                }\r\n                                return new Promise(function (resolve, reject) { resolve(null); });\r\n                            })).catch(function () {\r\n                                logger_1.logger.log(_this.user_friendly_id() + 'track.syncBarrier(): failed!');\r\n                                return null;\r\n                            })];\r\n                    case 6:\r\n                        _b.track_ = (_e.sent())[0];\r\n                        _c = this;\r\n                        return [4 /*yield*/, Promise.all(promises.map(function () {\r\n                                if (objRef_transport != undefined && objRef_transport['is_null'] === false && (_this.transport_ === null || _this.transport_.object_id() != objRef_transport['oid'])) {\r\n                                    var transport = new DtlsTransport(_this, objRef_transport['oid']);\r\n                                    return transport.syncBarrier();\r\n                                }\r\n                                return new Promise(function (resolve, reject) { resolve(null); });\r\n                            })).catch(function () {\r\n                                logger_1.logger.log(_this.user_friendly_id() + 'transport.syncBarrier(): failed!');\r\n                                return null;\r\n                            })];\r\n                    case 7:\r\n                        _c.transport_ = (_e.sent())[0];\r\n                        _d = this;\r\n                        return [4 /*yield*/, Promise.all(promises.map(function () {\r\n                                if (objRef_rtcp_transport != undefined && objRef_rtcp_transport['is_null'] === false && (_this.rtcpTransport_ === null || _this.rtcpTransport_.object_id() != objRef_rtcp_transport['oid'])) {\r\n                                    var rtcpTransport = new DtlsTransport(_this, objRef_rtcp_transport['oid']);\r\n                                    return rtcpTransport.syncBarrier();\r\n                                }\r\n                                return new Promise(function (resolve, reject) { resolve(null); });\r\n                            })).catch(function () {\r\n                                logger_1.logger.log(_this.user_friendly_id() + 'rtcpTransport.syncBarrier(): failed!');\r\n                                return null;\r\n                            })];\r\n                    case 8:\r\n                        _d.rtcpTransport_ = (_e.sent())[0];\r\n                        return [2 /*return*/, new Promise(function (resolve) {\r\n                                resolve(_this);\r\n                            })];\r\n                }\r\n            });\r\n        });\r\n    };\r\n    Object.defineProperty(RtpSenderReceiver.prototype, \"transport\", {\r\n        get: function () {\r\n            logger_1.logger.log(this.user_friendly_id() + '.get transport() called.');\r\n            return this.transport_;\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    Object.defineProperty(RtpSenderReceiver.prototype, \"rtcpTransport\", {\r\n        get: function () {\r\n            logger_1.logger.log(this.user_friendly_id() + '.get rtcpTransport() called.');\r\n            return this.rtcpTransport_;\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    Object.defineProperty(RtpSenderReceiver.prototype, \"track\", {\r\n        get: function () {\r\n            logger_1.logger.log(this.user_friendly_id() + '.get track() called.' + 'track_: ' + this.track_);\r\n            return this.track_;\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    RtpSenderReceiver.prototype.reinitTrack = function (track) {\r\n        this.track_ = track;\r\n    };\r\n    RtpSenderReceiver.prototype.getCapabilities = function (kind) {\r\n        logger_1.logger.log(this.user_friendly_id() + '.getCapabilities() called.');\r\n        return this.capabilities_;\r\n    };\r\n    RtpSenderReceiver.prototype.getStats = function () {\r\n        logger_1.logger.log(this.user_friendly_id() + '.getStats() called.');\r\n        var self = this;\r\n        return new Promise(function (resolve, reject) {\r\n            var _this = this;\r\n            if (!self.isRedirected()) {\r\n                logger_1.logger.log(self.user_friendly_id() + '.getStats(): not in active redirection!');\r\n                resolve();\r\n            }\r\n            else {\r\n                self.waitUntilConnected('RtpReceiver.getStats')\r\n                    .then(function () {\r\n                    var mid;\r\n                    if (_this instanceof RtpSender) {\r\n                        mid = webrpcclassinfo_1.method_id_RTCRtpSender_t.getStats;\r\n                    }\r\n                    else if (_this instanceof RtpReceiver) {\r\n                        mid = webrpcclassinfo_1.method_id_RTCRtpReceiver_t.getStats;\r\n                    }\r\n                    var callback = self.registerCallbacks(true, false, mid);\r\n                    callback.then(function (obj) {\r\n                        if (obj['params'] === undefined || obj['params'].length === 0) {\r\n                            return;\r\n                        }\r\n                        resolve(stats_1.StatsReport.fromJSON(JSON.parse(obj['params'][0])));\r\n                    });\r\n                    return self.remoteInvoke(false, mid, callback.success);\r\n                })\r\n                    .catch(function () {\r\n                    logger_1.logger.log(self.user_friendly_id() + '.getStats(): failed!');\r\n                    reject();\r\n                });\r\n            }\r\n        });\r\n    };\r\n    return RtpSenderReceiver;\r\n}(proxyobject_1.ProxyObject));\r\nexports.RtpSenderReceiver = RtpSenderReceiver;\r\nvar RtpSender = /** @class */ (function (_super) {\r\n    __extends(RtpSender, _super);\r\n    function RtpSender(parent, oid, mode) {\r\n        var _this = _super.call(this, parent, webrpcclassinfo_1.class_id_t.RTCRtpSender, oid, mode) || this;\r\n        logger_1.logger.log(_this.user_friendly_id() + '.constructor');\r\n        _this.dtmf_ = null;\r\n        _this.params_ = null;\r\n        return _this;\r\n    }\r\n    RtpSender.prototype.syncBarrier = function () {\r\n        return __awaiter(this, void 0, void 0, function () {\r\n            var _a, promises, objRef;\r\n            var _this = this;\r\n            return __generator(this, function (_b) {\r\n                switch (_b.label) {\r\n                    case 0:\r\n                        logger_1.logger.log(this.user_friendly_id() + '.syncBarrier() called.');\r\n                        return [4 /*yield*/, _super.prototype.syncBarrierBase.call(this)];\r\n                    case 1:\r\n                        _b.sent();\r\n                        return [4 /*yield*/, this.waitUntilConnected('RtpSender.syncBarrier')];\r\n                    case 2:\r\n                        _b.sent();\r\n                        return [4 /*yield*/, Promise.all([\r\n                                this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCRtpSender_t.dtmf, { \"oid\": this.object_id() }),\r\n                                this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCRtpSender_t.getParameters, { \"oid\": this.object_id() })\r\n                            ])];\r\n                    case 3:\r\n                        promises = _b.sent();\r\n                        _a = promises.map(function (result) { return _this.param0(result); }), objRef = _a[0], this.params_ = _a[1];\r\n                        if (objRef != undefined && objRef['is_null'] === false && (this.dtmf_ === null || this.dtmf_.object_id() != objRef['oid'])) {\r\n                            this.dtmf_ = new DtmfSender(this, objRef['oid']);\r\n                        }\r\n                        return [2 /*return*/, new Promise(function (resolve) {\r\n                                resolve(_this);\r\n                            })];\r\n                }\r\n            });\r\n        });\r\n    };\r\n    Object.defineProperty(RtpSender.prototype, \"dtmf\", {\r\n        get: function () {\r\n            logger_1.logger.log(this.user_friendly_id() + '.get dtmf() called.');\r\n            return this.dtmf_;\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    RtpSender.prototype.setParameters = function (parameters) {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + '.setParameters() called.');\r\n        return new Promise(function (resolve, reject) {\r\n            _this.waitUntilConnected('RtpSender.setParameters')\r\n                .then(function () {\r\n                return Promise.all([\r\n                    _this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCRtpSender_t.setParameters, parameters)\r\n                ]);\r\n            })\r\n                .then(function (obj) {\r\n                logger_1.logger.log(_this.user_friendly_id() + '.setParameters(): success.');\r\n                resolve();\r\n                //update local\r\n                _this.params_ = parameters;\r\n            })\r\n                .catch(function () {\r\n                logger_1.logger.log(_this.user_friendly_id() + '.setParameters(): rejected.');\r\n                reject();\r\n            });\r\n        });\r\n    };\r\n    RtpSender.prototype.getParameters = function () {\r\n        logger_1.logger.log(this.user_friendly_id() + '.getParameters() called.');\r\n        return this.params_;\r\n    };\r\n    RtpSender.prototype.replaceTrack = function (withTrack) {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + '.replaceTrack() called.');\r\n        return new Promise(function (resolve, reject) {\r\n            _this.waitUntilConnected('RtpSender.replaceTrack')\r\n                .then(function () {\r\n                return Promise.all([\r\n                    _this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCRtpSender_t.replaceTrack, { \"oid\": withTrack.object_id() })\r\n                ]);\r\n            })\r\n                .then(function (obj) {\r\n                logger_1.logger.log(_this.user_friendly_id() + '.replaceTrack(): success.');\r\n                resolve();\r\n                _this.reinitTrack(withTrack);\r\n            })\r\n                .catch(function () {\r\n                logger_1.logger.log(_this.user_friendly_id() + '.setParameters(): rejected.');\r\n                reject();\r\n            });\r\n        });\r\n    };\r\n    return RtpSender;\r\n}(RtpSenderReceiver));\r\nexports.RtpSender = RtpSender;\r\nvar RtpReceiver = /** @class */ (function (_super) {\r\n    __extends(RtpReceiver, _super);\r\n    function RtpReceiver(parent, oid) {\r\n        var _this = _super.call(this, parent, webrpcclassinfo_1.class_id_t.RTCRtpReceiver, oid, proxyobject_1.ProxyMode.Remote) || this;\r\n        logger_1.logger.log(_this.user_friendly_id() + '.constructor');\r\n        _this.contribsources_ = [];\r\n        _this.syncsources_ = [];\r\n        _this.params_ = null;\r\n        return _this;\r\n    }\r\n    RtpReceiver.prototype.syncBarrier = function () {\r\n        return __awaiter(this, void 0, void 0, function () {\r\n            var _a, promises;\r\n            var _this = this;\r\n            return __generator(this, function (_b) {\r\n                switch (_b.label) {\r\n                    case 0:\r\n                        logger_1.logger.log(this.user_friendly_id() + '.syncBarrier() called.');\r\n                        return [4 /*yield*/, _super.prototype.syncBarrierBase.call(this)];\r\n                    case 1:\r\n                        _b.sent();\r\n                        return [4 /*yield*/, this.waitUntilConnected('RtpReceiver.syncBarrier')];\r\n                    case 2:\r\n                        _b.sent();\r\n                        if (!remotesession_1.RemoteSession.isFeaturePstnSupported()) return [3 /*break*/, 4];\r\n                        return [4 /*yield*/, Promise.all([\r\n                                this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCRtpReceiver_t.getContributingSources, []),\r\n                                this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCRtpReceiver_t.getSynchronizationSources, []),\r\n                                this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCRtpReceiver_t.getParameters, { \"oid\": this.object_id() })\r\n                            ])];\r\n                    case 3:\r\n                        promises = _b.sent();\r\n                        return [3 /*break*/, 6];\r\n                    case 4: return [4 /*yield*/, Promise.all([\r\n                            this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCRtpReceiver_t.getContributingSources, [])\r\n                        ])];\r\n                    case 5:\r\n                        promises = _b.sent();\r\n                        _b.label = 6;\r\n                    case 6:\r\n                        _a = promises.map(function (result) { return _this.param0(result); }), this.contribsources_ = _a[0], this.syncsources_ = _a[1], this.params_ = _a[2];\r\n                        return [2 /*return*/, new Promise(function (resolve) {\r\n                                resolve(_this);\r\n                            })];\r\n                }\r\n            });\r\n        });\r\n    };\r\n    RtpReceiver.prototype.getContributingSources = function () {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + '.getContributingSources() called. ' + JSON.stringify(this.contribsources_));\r\n        this.waitUntilConnected('RtpReceiver.getContributingSources')\r\n            .then(function () {\r\n            return Promise.all([\r\n                _this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCRtpReceiver_t.getContributingSources, [])\r\n            ]);\r\n        })\r\n            .then(function (results) {\r\n            var sources;\r\n            _this.contribsources_ = results.map(function (result) { return _this.param0(result); })[0];\r\n        })\r\n            .catch(function () {\r\n            logger_1.logger.log(_this.user_friendly_id() + '.getContributingSources() didnt get response.');\r\n            _this.contribsources_ = [];\r\n        });\r\n        return this.contribsources_;\r\n    };\r\n    RtpReceiver.prototype.getParameters = function () {\r\n        logger_1.logger.log(this.user_friendly_id() + '.getParameters() called.');\r\n        return this.params_;\r\n    };\r\n    RtpReceiver.prototype.getSynchronizationSources = function () {\r\n        logger_1.logger.log(this.user_friendly_id() + '.getSynchronizationSources() called.');\r\n        return this.syncsources_;\r\n    };\r\n    return RtpReceiver;\r\n}(RtpSenderReceiver));\r\nexports.RtpReceiver = RtpReceiver;\r\n\n\n//# sourceURL=webpack://CitrixWebRTC/E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/rtpsender.js?");
      },
      "../../../out/shim/sdk/int/sdk/rtptransceiver.js":
      /*!****************************************************************************!*\
        !*** E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/rtptransceiver.js ***!
        \****************************************************************************/

      /*! no static exports found */
      function outShimSdkIntSdkRtptransceiverJs(module, exports, __webpack_require__) {

        eval('\r\nvar __extends = (this && this.__extends) || (function () {\r\n    var extendStatics = function (d, b) {\r\n        extendStatics = Object.setPrototypeOf ||\r\n            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||\r\n            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };\r\n        return extendStatics(d, b);\r\n    }\r\n    return function (d, b) {\r\n        extendStatics(d, b);\r\n        function __() { this.constructor = d; }\r\n        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());\r\n    };\r\n})();\r\nvar __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {\r\n    return new (P || (P = Promise))(function (resolve, reject) {\r\n        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }\r\n        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }\r\n        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }\r\n        step((generator = generator.apply(thisArg, _arguments || [])).next());\r\n    });\r\n};\r\nvar __generator = (this && this.__generator) || function (thisArg, body) {\r\n    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;\r\n    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;\r\n    function verb(n) { return function (v) { return step([n, v]); }; }\r\n    function step(op) {\r\n        if (f) throw new TypeError("Generator is already executing.");\r\n        while (_) try {\r\n            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;\r\n            if (y = 0, t) op = [op[0] & 2, t.value];\r\n            switch (op[0]) {\r\n                case 0: case 1: t = op; break;\r\n                case 4: _.label++; return { value: op[1], done: false };\r\n                case 5: _.label++; y = op[1]; op = [0]; continue;\r\n                case 7: op = _.ops.pop(); _.trys.pop(); continue;\r\n                default:\r\n                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }\r\n                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }\r\n                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }\r\n                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }\r\n                    if (t[2]) _.ops.pop();\r\n                    _.trys.pop(); continue;\r\n            }\r\n            op = body.call(thisArg, _);\r\n        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }\r\n        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };\r\n    }\r\n};\r\nObject.defineProperty(exports, "__esModule", { value: true });\r\nvar proxyobject_1 = __webpack_require__(/*! ./proxyobject */ "../../../out/shim/sdk/int/sdk/proxyobject.js");\r\nvar webrpcclassinfo_1 = __webpack_require__(/*! ./webrpcclassinfo */ "../../../out/shim/sdk/int/sdk/webrpcclassinfo.js");\r\nvar logger_1 = __webpack_require__(/*! ./logger */ "../../../out/shim/sdk/int/sdk/logger.js");\r\nvar rtpsender_1 = __webpack_require__(/*! ./rtpsender */ "../../../out/shim/sdk/int/sdk/rtpsender.js");\r\nvar RtpTransceiver = /** @class */ (function (_super) {\r\n    __extends(RtpTransceiver, _super);\r\n    function RtpTransceiver(parent, oid) {\r\n        var _this = _super.call(this, parent, webrpcclassinfo_1.class_id_t.RTCRtpTransceiver, oid, proxyobject_1.ProxyMode.Remote) || this;\r\n        logger_1.logger.log(_this.user_friendly_id() + \'.constructor\');\r\n        _this.sender_ = null;\r\n        _this.receiver_ = null;\r\n        return _this;\r\n    }\r\n    RtpTransceiver.prototype.syncBarrier = function () {\r\n        return __awaiter(this, void 0, void 0, function () {\r\n            var _a, promises, obj_sender, obj_receiver, sender, _b, receiver, _c;\r\n            var _this = this;\r\n            return __generator(this, function (_d) {\r\n                switch (_d.label) {\r\n                    case 0:\r\n                        logger_1.logger.log(this.user_friendly_id() + \'.syncBarrier() called.\');\r\n                        return [4 /*yield*/, Promise.all([\r\n                                this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCRtpTransceiver_t.sender, {}),\r\n                                this.remoteInvoke(false, webrpcclassinfo_1.method_id_RTCRtpTransceiver_t.receiver, {})\r\n                            ])];\r\n                    case 1:\r\n                        promises = _d.sent();\r\n                        _a = promises.map(function (result) { return _this.param0(result); }), obj_sender = _a[0], obj_receiver = _a[1];\r\n                        if (!(obj_sender != undefined && obj_sender[\'is_null\'] === false && (this.sender_ === null || this.sender_.object_id() != obj_sender[\'oid\']))) return [3 /*break*/, 3];\r\n                        sender = new rtpsender_1.RtpSender(this, obj_sender[\'oid\'], proxyobject_1.ProxyMode.Remote);\r\n                        _b = this;\r\n                        return [4 /*yield*/, sender.syncBarrier()\r\n                                .catch(function () {\r\n                                logger_1.logger.log(_this.user_friendly_id() + \'sender.syncBarrier(): failed!\');\r\n                                return null;\r\n                            })];\r\n                    case 2:\r\n                        _b.sender_ = _d.sent();\r\n                        _d.label = 3;\r\n                    case 3:\r\n                        if (!(obj_receiver != undefined && obj_receiver[\'is_null\'] === false && (this.receiver_ === null || this.receiver_.object_id() != obj_receiver[\'oid\']))) return [3 /*break*/, 5];\r\n                        receiver = new rtpsender_1.RtpReceiver(this, obj_receiver[\'oid\']);\r\n                        _c = this;\r\n                        return [4 /*yield*/, receiver.syncBarrier()\r\n                                .catch(function () {\r\n                                logger_1.logger.log(_this.user_friendly_id() + \'receiver.syncBarrier(): failed!\');\r\n                                return null;\r\n                            })];\r\n                    case 4:\r\n                        _c.receiver_ = _d.sent();\r\n                        _d.label = 5;\r\n                    case 5: return [2 /*return*/, this];\r\n                }\r\n            });\r\n        });\r\n    };\r\n    Object.defineProperty(RtpTransceiver.prototype, "mid", {\r\n        get: function () {\r\n            return this.mid_;\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    Object.defineProperty(RtpTransceiver.prototype, "sender", {\r\n        get: function () {\r\n            return this.sender_;\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    Object.defineProperty(RtpTransceiver.prototype, "receiver", {\r\n        get: function () {\r\n            return this.receiver_;\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    Object.defineProperty(RtpTransceiver.prototype, "direction", {\r\n        get: function () {\r\n            return this.direction_;\r\n        },\r\n        set: function (value) {\r\n            var _this = this;\r\n            logger_1.logger.log(this.user_friendly_id() + \'.se_direction() called.\');\r\n            this.waitUntilConnected(\'RtpTransceiver.set_direction\')\r\n                .then(function () { return _this.remoteInvoke(true, webrpcclassinfo_1.method_id_RTCRtpTransceiver_t.direction, _this.toRtpDirection(value)); })\r\n                .then(function () { _this.direction_ = value; })\r\n                .catch(function () { logger_1.logger.log(_this.user_friendly_id() + \'.set_direction: failed.\'); });\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    RtpTransceiver.prototype.stop = function () {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + \'.stop() called.\');\r\n        this.waitUntilConnected(\'RtpTransceiver.stop\')\r\n            .then(function () { return _this.remoteInvoke(true, webrpcclassinfo_1.method_id_RTCRtpTransceiver_t.stop); })\r\n            .then(function () { logger_1.logger.log(_this.user_friendly_id() + \'.stop: success.\'); })\r\n            .catch(function () { logger_1.logger.log(_this.user_friendly_id() + \'.stop: failed.\'); });\r\n    };\r\n    RtpTransceiver.prototype.setCodecPreferences = function (codecs) {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + \'.setCodecPreferences() called.\');\r\n        this.waitUntilConnected(\'RtpTransceiver.setCodecPreferences\')\r\n            .then(function () { return _this.remoteInvoke(true, webrpcclassinfo_1.method_id_RTCRtpTransceiver_t.setCodecPreferences, codecs); })\r\n            .then(function () { logger_1.logger.log(_this.user_friendly_id() + \'.setCodecPreferences: success.\'); })\r\n            .catch(function () { logger_1.logger.log(_this.user_friendly_id() + \'.setCodecPreferences: failed.\'); });\r\n    };\r\n    //*****************************\r\n    //native side enum value:\r\n    //enum class RTCRtpTransceiverDirection {\r\n    //SendRecv,\r\n    //SendOnly,\r\n    //RecvOnly,\r\n    //Inactive\r\n    //};\r\n    //*****************************\r\n    //JS side enum value\r\n    //enum RTCRtpTransceiverDirection {\r\n    //"sendrecv",\r\n    //"sendonly",\r\n    //"recvonly",\r\n    //"inactive"\r\n    //};\r\n    RtpTransceiver.prototype.toRTCRtpDirection = function (id) {\r\n        var direction = "inactive";\r\n        if (id == 0) {\r\n            direction = "sendrecv";\r\n        }\r\n        else if (id == 1) {\r\n            direction = "sendonly";\r\n        }\r\n        else if (id == 2) {\r\n            direction = "recvonly";\r\n        }\r\n        else if (id == 3) {\r\n            direction = "inactive";\r\n        }\r\n        return direction;\r\n    };\r\n    RtpTransceiver.prototype.toRtpDirection = function (direction) {\r\n        var id = 3; //default to inactive\r\n        if (direction == "sendrecv") {\r\n            id = 0;\r\n        }\r\n        else if (direction == "sendonly") {\r\n            id = 1;\r\n        }\r\n        else if (direction == "recvonly") {\r\n            id = 2;\r\n        }\r\n        else if (direction == "inactive") {\r\n            id = 3;\r\n        }\r\n        return id;\r\n    };\r\n    return RtpTransceiver;\r\n}(proxyobject_1.ProxyObject));\r\nexports.RtpTransceiver = RtpTransceiver;\r\n\n\n//# sourceURL=webpack://CitrixWebRTC/E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/rtptransceiver.js?');
      },
      "../../../out/shim/sdk/int/sdk/stats.js":
      /*!*******************************************************************!*\
        !*** E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/stats.js ***!
        \*******************************************************************/

      /*! no static exports found */
      function outShimSdkIntSdkStatsJs(module, exports, __webpack_require__) {

        eval("\r\n// statistics implementation\r\nObject.defineProperty(exports, \"__esModule\", { value: true });\r\nvar StatsReport = /** @class */ (function () {\r\n    function StatsReport() {\r\n        this.items = [];\r\n    }\r\n    StatsReport.fromJSON = function (obj) {\r\n        var stats = new StatsReport();\r\n        for (var _i = 0, obj_1 = obj; _i < obj_1.length; _i++) {\r\n            var entry = obj_1[_i];\r\n            var item = Stats.fromJSON(entry);\r\n            stats.items.push(item);\r\n            //logger.log('...stat entry', item.toJSON())\r\n        }\r\n        return stats;\r\n    };\r\n    StatsReport.prototype.toJSON = function () {\r\n        return JSON.stringify(this.items);\r\n    };\r\n    StatsReport.prototype.result = function () {\r\n        return this.items;\r\n    };\r\n    return StatsReport;\r\n}());\r\nexports.StatsReport = StatsReport;\r\nvar Stats = /** @class */ (function () {\r\n    function Stats() {\r\n        this.names_ = [];\r\n        this.stat_ = new Map();\r\n        this.id = \"\";\r\n        this.timestamp = 0;\r\n        this.type = \"\";\r\n    }\r\n    Stats.fromJSON = function (obj) {\r\n        var stats = new Stats();\r\n        stats.id = obj.id || '',\r\n            stats.timestamp = obj.timestamp || '',\r\n            stats.type = obj.type || '';\r\n        Object.keys(obj).forEach(function (key) {\r\n            if (key === 'id' || key === 'timestamp' || key === 'type') {\r\n                return;\r\n            }\r\n            stats.names_.push(key);\r\n            stats.stat_.set(key, obj[key]);\r\n        });\r\n        return stats;\r\n    };\r\n    Stats.prototype.toJSON = function () {\r\n        return JSON.stringify({ \"id\": this.id, \"timestamp\": this.timestamp, \"type\": this.type, \"stat\": this.stat_ });\r\n    };\r\n    // provided stats keys\r\n    Stats.prototype.names = function () {\r\n        return this.names_;\r\n    };\r\n    Stats.prototype.stat = function (name) {\r\n        var r = this.stat_.get(name);\r\n        return r;\r\n    };\r\n    return Stats;\r\n}());\r\nexports.Stats = Stats;\r\n\n\n//# sourceURL=webpack://CitrixWebRTC/E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/stats.js?");
      },
      "../../../out/shim/sdk/int/sdk/telemetry.js":
      /*!***********************************************************************!*\
        !*** E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/telemetry.js ***!
        \***********************************************************************/

      /*! no static exports found */
      function outShimSdkIntSdkTelemetryJs(module, exports, __webpack_require__) {

        eval('\r\nObject.defineProperty(exports, "__esModule", { value: true });\r\nvar hdxms_1 = __webpack_require__(/*! ./hdxms */ "../../../out/shim/sdk/int/sdk/hdxms.js");\r\nvar logger_1 = __webpack_require__(/*! ./logger */ "../../../out/shim/sdk/int/sdk/logger.js");\r\nvar tel_CallState;\r\n(function (tel_CallState) {\r\n    tel_CallState[tel_CallState["unknown"] = 0] = "unknown";\r\n    tel_CallState[tel_CallState["active"] = 1] = "active";\r\n    tel_CallState[tel_CallState["idle"] = 2] = "idle";\r\n})(tel_CallState = exports.tel_CallState || (exports.tel_CallState = {}));\r\nvar tel_CallDirection;\r\n(function (tel_CallDirection) {\r\n    tel_CallDirection[tel_CallDirection["unknown"] = 0] = "unknown";\r\n    tel_CallDirection[tel_CallDirection["incoming"] = 1] = "incoming";\r\n    tel_CallDirection[tel_CallDirection["outgoing"] = 2] = "outgoing";\r\n})(tel_CallDirection = exports.tel_CallDirection || (exports.tel_CallDirection = {}));\r\nvar tel_CallType;\r\n(function (tel_CallType) {\r\n    tel_CallType[tel_CallType["unknown"] = 0] = "unknown";\r\n    tel_CallType[tel_CallType["audio"] = 1] = "audio";\r\n    tel_CallType[tel_CallType["video"] = 2] = "video";\r\n    tel_CallType[tel_CallType["multi"] = 3] = "multi";\r\n    tel_CallType[tel_CallType["dshare"] = 4] = "dshare"; //desktop sharing\r\n})(tel_CallType = exports.tel_CallType || (exports.tel_CallType = {}));\r\n//telemetry commands\r\nvar tel_cmd;\r\n(function (tel_cmd) {\r\n    tel_cmd[tel_cmd["Unknown"] = 0] = "Unknown";\r\n    tel_cmd[tel_cmd["Cap"] = 1] = "Cap";\r\n    tel_cmd[tel_cmd["Init"] = 2] = "Init";\r\n    tel_cmd[tel_cmd["Data"] = 3] = "Data";\r\n})(tel_cmd = exports.tel_cmd || (exports.tel_cmd = {}));\r\n//telemetry keys\r\nexports.tel_key_ConferenceCallDuration = "ConferenceCallDuration";\r\nexports.tel_key_AudioCallDuration = "AudioCallDuration";\r\nexports.tel_key_VideoCallDuration = "VideoCallDuration";\r\nexports.tel_key_ScreensharingCallDuration = "ScreensharingCallDuration";\r\nexports.tel_key_CallEstIncoming = "CallEstIncoming";\r\nexports.tel_key_CallEstOutgoing = "CallEstOutgoing";\r\nexports.tel_key_AudioDeviceUsed = "AudioDeviceUsed";\r\nexports.tel_key_VideoDeviceUsed = "VideoDeviceUsed";\r\nexports.tel_key_SpeakerDeviceUsed = "SpeakerDeviceUsed";\r\nexports.tel_key_PerfCallDirection = "PerfCallDirection";\r\nexports.tel_key_PerfCallState = "PerfCallState";\r\nexports.tel_key_PerfCallType = "PerfCallType";\r\nexports.tel_key_VerWebrpc = "VerWebrpc";\r\nexports.tel_key_VerWebrtcCodecs = "VerWebrtcCodecs";\r\nexports.tel_key_VerReceiver = "VerReceiver";\r\nexports.tel_key_VerVda = "VerVda";\r\nexports.tel_key_VerEndpoint = "VerEndpoint";\r\nexports.tel_key_VerTypeScript = "VerTypeScript";\r\nexports.tel_key_OSFamily = "OSFamily";\r\nexports.tel_key_OSVersion = "OSVersion";\r\nexports.tel_key_OSArchitecture = "OSArchitecture";\r\nexports.tel_key_OSDistro = "OSDistro";\r\nexports.tel_key_OSEdition = "OSEdition";\r\nvar TelemetryData = /** @class */ (function () {\r\n    function TelemetryData(cmd, key, value, flags) {\r\n        this.cmd = cmd;\r\n        this.key = key;\r\n        this.value = value;\r\n        this.flags = flags;\r\n    }\r\n    TelemetryData.prototype.SendTelemetryData = function (tel) {\r\n        tel.SendTelemetryData(this.cmd, this.key, this.value, this.flags);\r\n    };\r\n    return TelemetryData;\r\n}());\r\n;\r\nvar Telemetry = /** @class */ (function () {\r\n    function Telemetry() {\r\n        this.id = 0;\r\n        this.deferredData = new Array();\r\n    }\r\n    Telemetry.prototype.reset = function () {\r\n        this.id = 0;\r\n        this.deferredData = new Array();\r\n    };\r\n    Telemetry.prototype.onInitialized = function (id) {\r\n        this.id = id;\r\n        while (this.deferredData && this.deferredData.length > 0) {\r\n            this.deferredData.shift().SendTelemetryData(this);\r\n        }\r\n    };\r\n    Telemetry.prototype.SendTelemetryInit = function () {\r\n        if (this.id > 0) {\r\n            this.reset();\r\n        }\r\n        try {\r\n            // send telemetry init request data to websocket agent\r\n            hdxms_1.getRedirector().WSSendObject({\r\n                v: \'telemetry\',\r\n                hdr: {\r\n                    command: tel_cmd.Init,\r\n                    id: 0\r\n                },\r\n                init: {\r\n                    domain: "HDXMM Teams",\r\n                    subdomain: "Teams",\r\n                    feature: "msteams",\r\n                    version: "1.1.1.1"\r\n                },\r\n            });\r\n        }\r\n        catch (err) {\r\n            logger_1.logger.log(err);\r\n        }\r\n    };\r\n    Telemetry.prototype.SendTelemetryData = function (cmd, key_, value_, flags_) {\r\n        if (cmd != tel_cmd.Data) {\r\n            logger_1.logger.log("invalid telemetry command!");\r\n            return;\r\n        }\r\n        //queue commands if telemetry is not initialized yet\r\n        if (this.id == 0) {\r\n            this.deferredData.push(new TelemetryData(cmd, key_, value_, flags_));\r\n        }\r\n        else {\r\n            try {\r\n                hdxms_1.getRedirector().WSSendObject({\r\n                    /**@nocollapse*/ v: "telemetry",\r\n                    /**@nocollapse*/ hdr: {\r\n                        command: cmd,\r\n                        id: this.id,\r\n                    },\r\n                    /**@nocollapse*/ data: {\r\n                        key: key_,\r\n                        value: value_,\r\n                        flags: flags_\r\n                    },\r\n                });\r\n            }\r\n            catch (err) {\r\n                logger_1.logger.log(err);\r\n            }\r\n        }\r\n    };\r\n    return Telemetry;\r\n}());\r\nexports.Telemetry = Telemetry;\r\n\n\n//# sourceURL=webpack://CitrixWebRTC/E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/telemetry.js?');
      },
      "../../../out/shim/sdk/int/sdk/vdiCitrixWebRTC_sdk.js":
      /*!*********************************************************************************!*\
        !*** E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/vdiCitrixWebRTC_sdk.js ***!
        \*********************************************************************************/

      /*! no static exports found */
      function outShimSdkIntSdkVdiCitrixWebRTC_sdkJs(module, exports, __webpack_require__) {
        eval("var vdishim = __webpack_require__(/*! ./peerconnection */ \"../../../out/shim/sdk/int/sdk/peerconnection.js\");\r\nvar rmshim = __webpack_require__(/*! ./remotemedia */ \"../../../out/shim/sdk/int/sdk/remotemedia.js\");\r\nvar videoelem = __webpack_require__(/*! ./videoelement */ \"../../../out/shim/sdk/int/sdk/videoelement.js\");\r\nvar audioelem = __webpack_require__(/*! ./audioelement */ \"../../../out/shim/sdk/int/sdk/audioelement.js\");\r\nvar frametracker = __webpack_require__(/*! ./frametracker */ \"../../../out/shim/sdk/int/sdk/frametracker.js\");\r\nvar logger = __webpack_require__(/*! ./logger */ \"../../../out/shim/sdk/int/sdk/logger.js\").logger;\r\nvar remotesession = __webpack_require__(/*! ./remotesession */ \"../../../out/shim/sdk/int/sdk/remotesession.js\");\r\nvar garbagecollector = __webpack_require__(/*! ./garbagecollector */ \"../../../out/shim/sdk/int/sdk/garbagecollector.js\").gc;\r\nvar HdxMediaStream = __webpack_require__(/*! ./hdxms */ \"../../../out/shim/sdk/int/sdk/hdxms.js\");\r\n\r\n(function (root, factory) {\r\n    if (true) {\r\n        //define('CitrixWebRTC', [], factory);\r\n\r\n        // Tmp solution for dev build to load from script element\r\n        root.CitrixWebRTC = factory();\r\n    } else {}\r\n}(typeof self !== 'undefined' ? self : this, function () {\r\n\r\n    \"use strict\";\r\n\r\n    var CitrixPeerConnection = vdishim.PeerConnection;\r\n\r\n    // getUserMedia\r\n    var remoteUserMedia = new rmshim.NavigatorUserMedia();\r\n    function getUserMedia(constraints, onSuccess, onFail) {\r\n        // This function should return an object that implements the MediaStream interface.\r\n        // Citrix webrtc application should be able to access the underlying MediaStreamTracks.\r\n\r\n        // MediaStreamTracks should have their enabled attribute observed\r\n        // to propogate to the ThinClient MediaStreamTrack to facilitate mute.\r\n\r\n        // If the ThinClient does not support remote connections this function should return an\r\n        // the result of the local navigator.webkitGetUserMedia\r\n        ExchangeCapability();\r\n        logger.log(\"VDI Shim getUserMedia\");\r\n        if (remoteUserMedia === null || !remoteUserMedia.isValid()) {\r\n            remoteUserMedia = new rmshim.NavigatorUserMedia();\r\n        }\r\n\r\n        return remoteUserMedia.webkitGetUserMedia(constraints, onSuccess, onFail);\r\n    }\r\n\r\n    // enumerateDevices\r\n    var remoteDevices = new rmshim.RemoteDevices();\r\n    function enumerateDevices() {\r\n        // This function should return the devices available on the ThinClient.  At least one\r\n        // input and one output device must be returned.\r\n\r\n        // If the ThinCient does not support remote connections this function must\r\n        // return valid virtual devices from the VM.  At least one input and one output device\r\n        // must be returned\r\n        ExchangeCapability();\r\n        logger.log(\"VDI Shim enumerateDevices\");\r\n        if (remoteDevices === null || !remoteDevices.isValid()) {\r\n            remoteDevices = new rmshim.RemoteDevices();\r\n        }\r\n\r\n        return remoteDevices.enumerateDevices();\r\n    }\r\n\r\n    //getDisplayMedia\r\n    function getDisplayMedia(constraints) {\r\n        // This function should return an object that implements the MediaStream interface.\r\n        // Citrix webrtc application should be able to access the underlying MediaStreamTracks.\r\n        ExchangeCapability();\r\n        logger.log(\"VDI Shim getDisplayMedia\");\r\n        if (remoteDevices === null || !remoteDevices.isValid()) {\r\n            remoteDevices = new rmshim.RemoteDevices();\r\n        }\r\n\r\n        return remoteDevices.getDisplayMedia(constraints);\r\n    }\r\n\r\n    var videoElementFrameTracker = null;\r\n    function mapVideoElement(curVideoElem) {\r\n        logger.log(\"VDI New Video Element Created, Creating Mapping to VDA\");\r\n\r\n        if (videoElementFrameTracker === null) {\r\n            videoElementFrameTracker = new frametracker.FrameTracker();\r\n        }\r\n\r\n        if (curVideoElem['VDAVideoElement'] !== undefined) {\r\n            logger.log('Video element is already configured!');\r\n            return;\r\n        }\r\n\r\n        ExchangeCapability();\r\n\r\n        Object.defineProperty(curVideoElem, 'VDAVideoElement', {\r\n            writable: true,\r\n            value: null\r\n        });\r\n        curVideoElem.VDAVideoElement = new videoelem.VideoElement();\r\n\r\n        curVideoElem.VDAVideoElement.onloadedmetadata = () => {\r\n            var e = new Event('loadedmetadata');\r\n            curVideoElem.dispatchEvent(e);\r\n        };\r\n\r\n        curVideoElem.VDAVideoElement.ontimeupdate = () => {\r\n            var e = new Event('timeupdate');\r\n            curVideoElem.dispatchEvent(e);\r\n        };\r\n\r\n        curVideoElem.VDAVideoElement.onconnectionstatechange = () => {\r\n            if (curVideoElem.VDAVideoElement.connectionState === 'connected') {\r\n                videoElementFrameTracker.track(curVideoElem, (frame) => {\r\n                    curVideoElem.VDAVideoElement.setFrame(frame);\r\n                });\r\n            } else {\r\n                videoElementFrameTracker.untrack(curVideoElem);\r\n            }\r\n        };\r\n\r\n        Object.defineProperty(curVideoElem, 'sinkId', {\r\n            get: function () {\r\n                return curVideoElem.VDAVideoElement.sinkId;\r\n            },\r\n            set: function (v) {\r\n                logger.log(\"VDI Shim set video element SinkId value = \" + v);\r\n                curVideoElem.VDAVideoElement.sinkId = v;\r\n            }\r\n        });\r\n\r\n        Object.defineProperty(curVideoElem, 'srcObject', {\r\n            get: function () {\r\n                return curVideoElem.VDAVideoElement.srcObject;\r\n            },\r\n            set: function (v) {\r\n                logger.log('VDI Shim set video element srcObject');\r\n                curVideoElem.VDAVideoElement.srcObject = v;\r\n            },\r\n        });\r\n\r\n        Object.defineProperty(curVideoElem, 'videoWidth', {\r\n            get: function () {\r\n                return curVideoElem.VDAVideoElement.videoWidth;\r\n            }\r\n        });\r\n\r\n        Object.defineProperty(curVideoElem, 'videoHeight', {\r\n            get: function () {\r\n                return curVideoElem.VDAVideoElement.videoHeight;\r\n            }\r\n        });\r\n    }\r\n\r\n    function Send_Telemetry_Data(MatchedOutputAudioDevice) {\r\n        HdxMediaStream.getRedirector().SendTelemetryData_Speaker(MatchedOutputAudioDevice);\r\n    }\r\n\r\n    // newAudioElement\r\n    function mapAudioElement(curAudioElem) {\r\n        logger.log(\"VDI New Audio Element Created, Creating Mapping to VDA\");\r\n        if (curAudioElem['VDAAudioElement'] !== undefined) {\r\n            logger.log('Audio element is already configured!');\r\n            return;\r\n        }\r\n\r\n        ExchangeCapability();\r\n\r\n        Object.defineProperty(curAudioElem, 'VDAAudioElement', {\r\n            writable: true,\r\n            value: null\r\n        });\r\n        curAudioElem.VDAAudioElement = new audioelem.AudioElement();\r\n\r\n        Object.defineProperty(curAudioElem, 'sinkId', {\r\n            get: function () {\r\n                return curAudioElem.VDAAudioElement.sinkId;\r\n            },\r\n            set: function (v) {\r\n                logger.log(\"VDI Shim set audio element SinkId value = \" + v);\r\n                curAudioElem.setSinkId(v)\r\n                    .then(() => {\r\n                        logger.log(\"VDI Shim set audio element SinkId success\");\r\n                    })\r\n                    .catch(() => {\r\n                        logger.log(\"VDI Shim set audio element SinkId failure\");\r\n                    });\r\n            }\r\n        });\r\n\r\n        //returns Promise<void>\r\n        curAudioElem.setSinkId = function (v) {\r\n            logger.log(\"VDI Shim set audio element SinkId value = \" + v);\r\n            const result = curAudioElem.VDAAudioElement.setSinkId(v);\r\n            var OutputAudiodeviceid = v;\r\n            var MatchedOutputAudioDevice;\r\n            var devices = rmshim.enumerateddecices;\r\n            devices.forEach(function (devices) {\r\n                if (OutputAudiodeviceid === devices.deviceId) {\r\n                    MatchedOutputAudioDevice = devices.label;\r\n                }\r\n            });\r\n            Send_Telemetry_Data(MatchedOutputAudioDevice);\r\n            return result;\r\n        }\r\n\r\n        Object.defineProperty(curAudioElem, 'srcObject', {\r\n            get: function () {\r\n                return curAudioElem.VDAAudioElement.srcObject;\r\n            },\r\n            set: function (v) {\r\n                logger.log('VDI Shim set audio element srcObject ' + JSON.stringify(v));\r\n                if (v === null || v === undefined) {\r\n                    //TODO - delete if actually setting srcObject on AudioElement\r\n                    if (curAudioElem.VDAAudioElement.srcObject !== null) {\r\n                        let audio_tr = curAudioElem.remoteAudioElement.srcObject.getTracks();\r\n                        for (let next of audio_tr) {\r\n                            next.enabled = false;\r\n                        }\r\n                    }\r\n                    curAudioElem.VDAAudioElement.release();\r\n                }\r\n                else {\r\n                    curAudioElem.VDAAudioElement.srcObject = v;\r\n                    let audio_tr = v.getTracks();\r\n                    for (let next of audio_tr) {\r\n                        next.enabled = true;\r\n                    }\r\n                }\r\n            },\r\n        });\r\n    }\r\n\r\n    // setVMEventCallback\r\n    // initialize to window.VMEventCallback for RC timing problem\r\n    // by the time setVMEventCallback() is called, the event already happen in some cases\r\n    // therefore, caller will set window.VMEventCallback method before loading this shim JS\r\n    // then switch to real callback once shim js is fully loaded\r\n    var onVMEvent = window.VMEventCallback;\r\n    function setVMEventCallback(callbackFn) {\r\n        // Call this function to let Citrix webrtc application know about VM events like disconnect with Thin Client.\r\n        // Function takes one argument: a json payload.\r\n        // Minimally the json should contain EventType and Message\r\n        onVMEvent = callbackFn;\r\n\r\n        //window.VMEventCallback is no longer needed\r\n        window.VMEventCallback = null;\r\n        logger.log(\"VDI Event Callback Set\");\r\n    }\r\n\r\n    function ExchangeCapability() {\r\n        if (window.getCitrixWebrtcRedir !== undefined) {\r\n            let ctxreg = window.getCitrixWebrtcRedir();\r\n            ctxreg.then(function (value) {\r\n                logger.log(\"sucesss on connect\" + value);\r\n                if ((value === 1) && (value !== \"\") && (remoteSession === null)) {\r\n                    logger.log(\"supported client\");\r\n                    remoteSession = new remotesession.RemoteSession();\r\n                }\r\n            });\r\n        }\r\n    }\r\n\r\n    var remotefailure_notified = false;\r\n    window.onVdiClientDisconnected = function (failure) {\r\n        logger.log(\"VDI Event: vdiClientDisconnected\");\r\n        //cleanup\r\n        cleanup();\r\n\r\n        if ((failure === true) && (remotefailure_notified === false))\r\n        {\r\n            logger.log(\"VDI Event: vdiClientDisconnected with failure reported\");\r\n            remotefailure_notified = true;    \r\n            //notify\r\n            try {\r\n                onVMEvent({ 'event': 'vdiClientDisconnected', 'reason': 'failure', 'msg': 'Websocket Connection Failure' });\r\n            } catch (exc) {\r\n                logger.log('onVMEvent(): exception: ' + exc.message);\r\n            }\r\n        }\r\n        else {\r\n            //reset flag\r\n            remotefailure_notified = false;\r\n            //notify\r\n            try {\r\n                onVMEvent({ 'event': 'vdiClientDisconnected', 'reason': 'endpointDisconnected'  });\r\n            } catch (exc) {\r\n                logger.log('onVMEvent(): exception: ' + exc.message);\r\n            }\r\n        }\r\n    };\r\n\r\n    // RemoteSession info\r\n    var remoteSession = new remotesession.RemoteSession();\r\n    window.onVdiClientDisconnectedTimer = function () {\r\n        logger.log(\"VDI Event: onVdiClientDisconnectedTimer\");\r\n        if (remoteSession === null) {\r\n            remoteSession = new remotesession.RemoteSession();\r\n        }\r\n    };\r\n\r\n    window.onVdiClientConnected = function () {\r\n        logger.log(\"VDI Event: vdiClientConnected\");\r\n        \r\n        /// send overlay window info\r\n        frametracker.FrameTracker.sendOverlayInfo();\r\n\r\n        sendSessionInfo();\r\n\r\n        if (remoteDevices === null || !remoteDevices.isValid()) {\r\n            remoteDevices = new rmshim.RemoteDevices();\r\n        }\r\n\r\n        //fire devicechange so Citrix webrtc application can pick up any device changes between disconnect/reconnect\r\n        navigator.mediaDevices.dispatchEvent(new CustomEvent('devicechange'));\r\n    };\r\n\r\n    function StartRedirConnectReg(value) {\r\n        if ((value === 1) && (value !== \"\")) {\r\n            logger.log(\"Supported client\");\r\n            HdxMediaStream.getRedirector().pingConnectionBegin(true);\r\n        }\r\n        if ((value === 0) && (value !== \"\")) {\r\n            logger.log(\"VDI Event: Unsupported client reported\");\r\n            try {\r\n                onVMEvent({ 'event': 'vdiClientDisconnected', 'reason': 'endpointUnsupported', 'msg': 'Unsupported endpoint connected' });\r\n            } catch (exc) {\r\n                logger.log('onVMEvent(): exception: ' + exc.message);\r\n            }\r\n        }\r\n        else {\r\n            logger.log(\"Citrix Webrtc Redir Reg Key value is incorrect\");\r\n        }\r\n    }\r\n\r\n    function TimerCitrixWebrtcRedir(count) {\r\n        if (count <= 0) {\r\n            logger.log(\"VDI Event: Reg Key not Updated after timer reported, Fallback\");\r\n            try {\r\n                onVMEvent({ 'event': 'vdiClientDisconnected', 'reason': 'failure', 'msg': 'Citrix Webrtc Redir Reg Key not Present' });\r\n            } catch (exc) {\r\n                logger.log('onVMEvent(): exception: ' + exc.message);\r\n            }\r\n        }\r\n        else {\r\n            let ctxreg = window.getCitrixWebrtcRedir();\r\n            ctxreg.then(function (value) {\r\n                if (value === \"\") {\r\n                    setTimeout(function () {\r\n                        logger.log('Timer waiting for registry to be updated count :'+ count);\r\n                        TimerCitrixWebrtcRedir(--count);\r\n                    }, 1000);\r\n                }\r\n                else {\r\n                    StartRedirConnectReg(value);\r\n                }\r\n            });\r\n        }\r\n    }\r\n\r\n    function onConnectionChange(connected) {\r\n        logger.log(\"VDI : onConnectionChange to \" + connected);\r\n        if (connected === false) {\r\n            logger.log(\"Disconnecting from the VDA\");\r\n        }\r\n        else {\r\n            logger.log(\"Connecting to the VDA\");\r\n            let ctxreg = window.getCitrixWebrtcRedir();\r\n            ctxreg.then(function (value) {\r\n                logger.log(\"Sucesss on connect with Reg value :\" + value);\r\n                if (value === \"\") {\r\n                    logger.log(\"Citrix Webrtc Redir Reg key not updated - Start timer\");\r\n                    TimerCitrixWebrtcRedir(5);//increase time for debugging\r\n                }\r\n                else {\r\n                    StartRedirConnectReg(value);\r\n                }\r\n            }).\r\n            catch(function () {\r\n                logger.log(\"Failure to Read Citrix Webrtc Redir Reg Key\");\r\n            });\r\n        }\r\n    }\r\n    \r\n    function sendSessionInfo() {\r\n        logger.log(\"VDI: sendSessionInfo\");\r\n        if (remoteSession) {\r\n            remoteSession.getSessionInfo().then((info) => {\r\n                logger.log('getSessionInfo success! info:' + JSON.stringify(info));\r\n                try {\r\n                    onVMEvent({ 'event': 'vdiClientConnected', 'version': info });\r\n                } catch (exc) {\r\n                    logger.log('onVMEvent(): exception: ' + exc.message);\r\n                }\r\n            })\r\n            .catch(() => {\r\n                logger.log('getSessionInfo failure! session is not fully connected yet...');\r\n            });\r\n        }\r\n    }\r\n\r\n    function isFeatureOn(targetFeature) {\r\n        if (remoteSession === null) {\r\n            return false;\r\n        }\r\n        return remoteSession.isFeatureSupported(targetFeature);\r\n    }\r\n\r\n    function cleanup() {\r\n        logger.log(\"VDI : cleanup\");\r\n\r\n        remoteUserMedia = null;\r\n        remoteDevices = null;\r\n        videoElementFrameTracker = null;\r\n\r\n        if (remoteSession) {\r\n            remoteSession.release();\r\n        }\r\n        remoteSession = null;\r\n\r\n        garbagecollector.reset();\r\n\r\n        logger.log(\"VDI : cleanup done\");\r\n    }\r\n\r\n    function initLog(logging) {\r\n        logger.setMSLogger(logging);\r\n        logger.log(\"VDI init logger\");\r\n    }\r\n\r\n    function addClipRect(rect) {\r\n        //logger.info(\"VDI Adding Occlusion \" + JSON.stringify(elem.getBoundingClientRect()));\r\n        logger.log(\"VDI Adding Occlusion \" + JSON.stringify(rect));\r\n        if (videoElementFrameTracker === null) {\r\n            videoElementFrameTracker = new frametracker.FrameTracker();\r\n        }\r\n        videoElementFrameTracker.addOcclusion(rect);\r\n    }\r\n\r\n    function removeClipRect(rect) {\r\n        //logger.info(\"VDI Removing Occlusion \" + JSON.stringify(elem.getBoundingClientRect()));\r\n        logger.log(\"VDI Removing Occlusion \" + JSON.stringify(rect));\r\n        if (videoElementFrameTracker === null) {\r\n            videoElementFrameTracker = new frametracker.FrameTracker();\r\n        }\r\n        videoElementFrameTracker.removeOcclusion(rect);\r\n    }\r\n\r\n    return {\r\n        CitrixPeerConnection: CitrixPeerConnection,\r\n        getUserMedia: getUserMedia,\r\n        enumerateDevices: enumerateDevices,\r\n        getDisplayMedia: getDisplayMedia,\r\n        mapVideoElement: mapVideoElement,\r\n        mapAudioElement: mapAudioElement,\r\n        addClipRect: addClipRect,\r\n        removeClipRect: removeClipRect,\r\n        setVMEventCallback: setVMEventCallback,\r\n        isFeatureOn: isFeatureOn,\r\n        initLog: initLog,\r\n        onConnectionChange: onConnectionChange\r\n    };\r\n\r\n}));\r\n\n\n//# sourceURL=webpack://CitrixWebRTC/E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/vdiCitrixWebRTC_sdk.js?");
      },
      "../../../out/shim/sdk/int/sdk/videoelement.js":
      /*!**************************************************************************!*\
        !*** E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/videoelement.js ***!
        \**************************************************************************/

      /*! no static exports found */
      function outShimSdkIntSdkVideoelementJs(module, exports, __webpack_require__) {

        eval("\r\nvar __extends = (this && this.__extends) || (function () {\r\n    var extendStatics = function (d, b) {\r\n        extendStatics = Object.setPrototypeOf ||\r\n            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||\r\n            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };\r\n        return extendStatics(d, b);\r\n    }\r\n    return function (d, b) {\r\n        extendStatics(d, b);\r\n        function __() { this.constructor = d; }\r\n        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());\r\n    };\r\n})();\r\nObject.defineProperty(exports, \"__esModule\", { value: true });\r\nvar proxyobject_1 = __webpack_require__(/*! ./proxyobject */ \"../../../out/shim/sdk/int/sdk/proxyobject.js\");\r\nvar lib = __webpack_require__(/*! ./webrpcclassinfo */ \"../../../out/shim/sdk/int/sdk/webrpcclassinfo.js\");\r\nvar logger_1 = __webpack_require__(/*! ./logger */ \"../../../out/shim/sdk/int/sdk/logger.js\");\r\nvar hdxms_1 = __webpack_require__(/*! ./hdxms */ \"../../../out/shim/sdk/int/sdk/hdxms.js\");\r\nvar webrpcclassinfo_1 = __webpack_require__(/*! ./webrpcclassinfo */ \"../../../out/shim/sdk/int/sdk/webrpcclassinfo.js\");\r\nvar VideoRect = /** @class */ (function () {\r\n    function VideoRect(r) {\r\n        this.x = Math.round(r.x);\r\n        this.y = Math.round(r.y);\r\n        this.width = Math.round(r.width);\r\n        this.height = Math.round(r.height);\r\n    }\r\n    return VideoRect;\r\n}());\r\nexports.VideoRect = VideoRect;\r\nvar VideoElement = /** @class */ (function (_super) {\r\n    __extends(VideoElement, _super);\r\n    function VideoElement() {\r\n        var _this = _super.call(this, null, lib.class_id_t.VideoElement, 0, proxyobject_1.ProxyMode.Local) || this;\r\n        _this.srcObject_ = null;\r\n        _this.sinkId_ = '';\r\n        _this.videoWidth = 0;\r\n        _this.videoHeight = 0;\r\n        _this.isLoaded = false;\r\n        _this.connectionState = \"disconnected\";\r\n        _this.dispose_ = false;\r\n        _this.disposeTimer = null;\r\n        return _this;\r\n    }\r\n    Object.defineProperty(VideoElement.prototype, \"sinkId\", {\r\n        get: function () {\r\n            return this.sinkId_;\r\n        },\r\n        set: function (value) {\r\n            var _this = this;\r\n            this.waitUntilConnected('VideoElement.sinkId')\r\n                .then(function () {\r\n                return _this.remoteInvoke(true, lib.method_id_VideoElement_t.sinkId, value);\r\n            })\r\n                .then(function () {\r\n                _this.sinkId_ = value;\r\n            })\r\n                .catch(function () {\r\n                logger_1.logger.log(_this.user_friendly_id() + '.sinkId setter: failed to connect!');\r\n            });\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    Object.defineProperty(VideoElement.prototype, \"srcObject\", {\r\n        get: function () {\r\n            return this.srcObject_;\r\n        },\r\n        set: function (obj) {\r\n            logger_1.logger.log(this.user_friendly_id() + '.srcObject: set srcObject...' + ' this.srcObject:' + this.srcObject + ' obj:' + obj);\r\n            // skip if srcObject the same as obj\r\n            if (this.srcObject_ === obj) {\r\n                return;\r\n            }\r\n            //if VideoElement is being reused cancel release\r\n            if (this.dispose_ === true && this.disposeTimer !== null) {\r\n                clearTimeout(this.disposeTimer);\r\n                this.disposeTimer = null;\r\n                this.dispose_ = false;\r\n            }\r\n            // whether receiver version is equal or later than 1911\r\n            var isAfter1911 = hdxms_1.getRedirector().getFeatureValue(webrpcclassinfo_1.FEATURE_ms_teams_1911);\r\n            // disconnect first if needed\r\n            if (this.srcObject_ !== null) {\r\n                if (obj === null) {\r\n                    // video element is disposed only 5 seconds after srcObject is set to null\r\n                    this.dispose_ = true;\r\n                    // fix RFWIN-11993, only receivers with versions 1911 or after work with this fix\r\n                    if (isAfter1911) {\r\n                        this.disconnect();\r\n                    }\r\n                }\r\n                // For backward capability, receivers before version 1911 call disconnect() here\r\n                if (!isAfter1911) {\r\n                    this.disconnect();\r\n                }\r\n                this.isLoaded = false;\r\n            }\r\n            // update srcObject\r\n            this.srcObject_ = obj;\r\n            // connect new object if it is not null\r\n            if (this.srcObject_ !== null) {\r\n                this.connectTo(this.srcObject_);\r\n            }\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    Object.defineProperty(VideoElement.prototype, \"onconnectionstatechange\", {\r\n        get: function () {\r\n            return this.onconnectionstatechange_;\r\n        },\r\n        set: function (cb) {\r\n            logger_1.logger.log(this.user_friendly_id() + '.set_onconnectionstatechange() called.');\r\n            this.onconnectionstatechange_ = cb;\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    Object.defineProperty(VideoElement.prototype, \"onloadedmetadata\", {\r\n        set: function (cb) {\r\n            logger_1.logger.log(this.user_friendly_id() + '.set_onloadedmetadata() called.');\r\n            this.onloadedmetadata_ = cb;\r\n        },\r\n        enumerable: true,\r\n        configurable: true\r\n    });\r\n    VideoElement.prototype.setupOnVideoFrameChanged = function () {\r\n        var _this = this;\r\n        // setup persistent callbacks for onvideoframechanged\r\n        var handlers = this.registerCallbacks(false, false, lib.method_id_VideoElement_t.onvideoframechanged);\r\n        handlers.then(function (obj) {\r\n            logger_1.logger.log(_this.user_friendly_id() + '.onvideoframechanged', obj.params);\r\n            _this.videoWidth = obj.params[0] || 0;\r\n            _this.videoHeight = obj.params[1] || 0;\r\n            // only fire onloadedmetadata the first time.\r\n            if (!_this.isLoaded) {\r\n                _this.isLoaded = true;\r\n                _this.onloadedmetadata_ && _this.onloadedmetadata_();\r\n            }\r\n        });\r\n        // set the callback.\r\n        this.remoteInvoke(true, lib.method_id_VideoElement_t.onvideoframechanged, handlers.success);\r\n    };\r\n    VideoElement.prototype.connectTo = function (stream) {\r\n        var _this = this;\r\n        console.log(this.user_friendly_id() + '.connectTo: connect media stream with id = ' + stream.object_id() + ', clone_id = ' + stream.clone_state.clone_id);\r\n        // await stable state for websocket communications.\r\n        this.waitUntilConnected('VideoElement.connectTo')\r\n            .then(function () {\r\n            _this.setupOnVideoFrameChanged();\r\n            // if stream is a clone, synchronize the local object with the remote object.\r\n            return stream.clone_state.synchronize(stream);\r\n        })\r\n            .then(function (new_stream) {\r\n            var callbacks = _this.registerCallbacks(true, false, lib.method_id_VideoElement_t.connectTo);\r\n            // wait for either the success callback or failure callback to be received.\r\n            return Promise.all([\r\n                _this.remoteInvoke(false, lib.method_id_VideoElement_t.connectTo, { \"oid\": new_stream.object_id() }, callbacks.success, callbacks.fail),\r\n                callbacks.prom()\r\n            ]);\r\n        })\r\n            .then(function (results) {\r\n            logger_1.logger.log(_this.user_friendly_id() + '.connectTo: remote media stream is connected!');\r\n            // fire onconnected event\r\n            _this.connectionState = \"connected\";\r\n            if (_this.onconnectionstatechange_) {\r\n                _this.onconnectionstatechange_();\r\n            }\r\n            // setup timeupdate timer.\r\n            _this.updateTimer = setInterval(function () {\r\n                _this.ontimeupdate && _this.ontimeupdate();\r\n            }, 250);\r\n        })\r\n            .catch(function (msg) {\r\n            logger_1.logger.log(_this.user_friendly_id() + '.connectTo: failed to connect! msg = ', msg);\r\n        });\r\n    };\r\n    VideoElement.prototype.disconnect = function () {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + '.disconnect: disconnect from current media stream');\r\n        if (this.dispose_ === true) {\r\n            //release videoElement after 5 secs\r\n            this.disposeTimer = setTimeout(function () { _this.release(); }, 5000);\r\n        }\r\n        this.waitUntilConnected('VideoElement.disconnect')\r\n            .then(function () {\r\n            // release time update timer\r\n            if (_this.updateTimer) {\r\n                clearInterval(_this.updateTimer);\r\n            }\r\n            // remote invocer  \r\n            var callbacks = _this.registerCallbacks(false, true, lib.method_id_VideoElement_t.onvideoframechanged);\r\n            _this.remoteInvoke(true, lib.method_id_VideoElement_t.onvideoframechanged, callbacks.success);\r\n            return _this.remoteInvoke(false, lib.method_id_VideoElement_t.disconnect);\r\n        })\r\n            .then(function () {\r\n            logger_1.logger.log(_this.user_friendly_id() + '.disconnect: remote media stream is disconnected!');\r\n            // fire onconnected event\r\n            _this.connectionState = \"disconnected\";\r\n            if (_this.onconnectionstatechange_) {\r\n                _this.onconnectionstatechange_();\r\n            }\r\n        })\r\n            .catch(function () {\r\n            logger_1.logger.log(_this.user_friendly_id() + '.disconnect: failed to connect!');\r\n        });\r\n    };\r\n    VideoElement.prototype.setFrame = function (r) {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + '.setFrame: set video frame to', r.x, r.y, r.width, r.height);\r\n        this.waitUntilConnected('VideoElement.setFrame')\r\n            .then(function () {\r\n            var vr = new VideoRect(r);\r\n            return _this.remoteInvoke(false, lib.method_id_VideoElement_t.setFrame, vr);\r\n        })\r\n            .then(function () {\r\n            logger_1.logger.log(_this.user_friendly_id() + '.setFrame: success!');\r\n        })\r\n            .catch(function () {\r\n            logger_1.logger.log(_this.user_friendly_id() + '.setFrame: failed to connect!');\r\n        });\r\n    };\r\n    VideoElement.prototype.addClipRect = function (r) {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + '.addClipRect: ', JSON.stringify(r));\r\n        this.waitUntilConnected('VideoElement.addClipRect')\r\n            .then(function () {\r\n            var vr = new VideoRect(r);\r\n            return _this.remoteInvoke(false, lib.method_id_VideoElement_t.addClipRect, vr);\r\n        })\r\n            .catch(function () {\r\n            logger_1.logger.log(_this.user_friendly_id() + '.addClipRect failed!');\r\n        });\r\n    };\r\n    VideoElement.prototype.removeClipRect = function (r) {\r\n        var _this = this;\r\n        logger_1.logger.log(this.user_friendly_id() + '.removeClipRect: ', JSON.stringify(r));\r\n        this.waitUntilConnected('VideoElement.removeClipRect')\r\n            .then(function () {\r\n            var vr = new VideoRect(r);\r\n            return _this.remoteInvoke(false, lib.method_id_VideoElement_t.removeClipRect, vr);\r\n        })\r\n            .catch(function () {\r\n            logger_1.logger.log(_this.user_friendly_id() + '.removeClipRect failed!');\r\n        });\r\n    };\r\n    return VideoElement;\r\n}(proxyobject_1.ProxyObject));\r\nexports.VideoElement = VideoElement;\r\n\n\n//# sourceURL=webpack://CitrixWebRTC/E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/videoelement.js?");
      },
      "../../../out/shim/sdk/int/sdk/webrpcclassinfo.js":
      /*!*****************************************************************************!*\
        !*** E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/webrpcclassinfo.js ***!
        \*****************************************************************************/

      /*! no static exports found */
      function outShimSdkIntSdkWebrpcclassinfoJs(module, exports, __webpack_require__) {

        eval('\r\n//this class library info must match with stub library definition file:\r\n// 1. class_lib info: ../webrpc/webrpc.cpp\r\n//    json_rpc_configuration::class_lib()\r\n// 2. class_method info: ../webrpc/stubs/teams.hpp\r\n//    class::reflect()\r\nObject.defineProperty(exports, "__esModule", { value: true });\r\n/****************************************\r\n* 1.1.0.0: initial feature\r\n* 1.2.0.0: desktop sharing feature\r\n* 1.3.0.0: Phobos feature\r\n****************************************/\r\nexports.HDXMS_VERSION = "1.6.0.1";\r\n/*----------------- feature/version related definitions -----------------*/\r\nvar VersionData = /** @class */ (function () {\r\n    function VersionData(major, minor, revision, build) {\r\n        this.major = major;\r\n        this.minor = minor;\r\n        this.revision = revision;\r\n        this.build = build;\r\n    }\r\n    ;\r\n    return VersionData;\r\n}());\r\nexports.VersionData = VersionData;\r\nvar FeatureData = /** @class */ (function () {\r\n    function FeatureData() {\r\n    }\r\n    return FeatureData;\r\n}());\r\nexports.FeatureData = FeatureData;\r\nvar WebrpcFeatureInfo = /** @class */ (function () {\r\n    function WebrpcFeatureInfo(fature, version) {\r\n        this.fature = fature;\r\n        this.version = version;\r\n    }\r\n    ;\r\n    return WebrpcFeatureInfo;\r\n}());\r\nvar OSInfo = /** @class */ (function () {\r\n    function OSInfo(family, version, architecture, distro, edition) {\r\n        this.family = family;\r\n        this.version = version;\r\n        this.architecture = architecture;\r\n        this.distro = distro;\r\n        this.edition = edition;\r\n    }\r\n    ;\r\n    return OSInfo;\r\n}());\r\nexports.OSInfo = OSInfo;\r\nvar SessionIdentifier = /** @class */ (function () {\r\n    function SessionIdentifier(machine, user) {\r\n        this.machine = machine;\r\n        this.user = user;\r\n    }\r\n    ;\r\n    return SessionIdentifier;\r\n}());\r\nexports.SessionIdentifier = SessionIdentifier;\r\n/*----------------- feature::version mapping -----------------*/\r\n//note: this mappig table is currently not used, but keep this here for tracking changes\r\nexports.FEATURE_ms_teams_redirection = "ms_teams_redirection";\r\nexports.FEATURE_ms_teams_desktop_sharing = "ms_teams_desktop_sharing";\r\nexports.FEATURE_ms_teams_speaking_indicator = "ms_teams_speaking_indicator";\r\nexports.FEATURE_ms_teams_common_media_constraints = "ms_teams_common_media_constraints";\r\nexports.FEATURE_ms_teams_1911 = "ms_teams_1911";\r\nexports.FEATURE_ms_teams_pstn = "ms_teams_pstn";\r\nexports.FEATURE_ms_teams_1912 = "ms_teams_1912";\r\nexports.FEATURE_ms_teams_mstrack_constraints = "ms_teams_mstrack_constraints";\r\nexports.FEATURE_ms_teams_osinfo = "ms_teams_osinfo";\r\nexports.FEATURE_ms_teams_sessionidentifier = "ms_teams_sessionidentifier";\r\nvar feature_map = [\r\n    //EngineControl\r\n    new WebrpcFeatureInfo(exports.FEATURE_ms_teams_redirection, new VersionData(1, 1, 0, 0)),\r\n    new WebrpcFeatureInfo(exports.FEATURE_ms_teams_desktop_sharing, new VersionData(1, 2, 0, 0)),\r\n    new WebrpcFeatureInfo(exports.FEATURE_ms_teams_speaking_indicator, new VersionData(1, 2, 0, 0)),\r\n    new WebrpcFeatureInfo(exports.FEATURE_ms_teams_common_media_constraints, new VersionData(1, 4, 0, 0)),\r\n    new WebrpcFeatureInfo(exports.FEATURE_ms_teams_1911, new VersionData(1, 4, 0, 0)),\r\n    new WebrpcFeatureInfo(exports.FEATURE_ms_teams_1912, new VersionData(1, 5, 0, 0)),\r\n    new WebrpcFeatureInfo(exports.FEATURE_ms_teams_mstrack_constraints, new VersionData(1, 6, 0, 0)),\r\n    new WebrpcFeatureInfo(exports.FEATURE_ms_teams_pstn, new VersionData(1, 6, 0, 0)),\r\n    new WebrpcFeatureInfo(exports.FEATURE_ms_teams_osinfo, new VersionData(1, 7, 0, 0)),\r\n    new WebrpcFeatureInfo(exports.FEATURE_ms_teams_sessionidentifier, new VersionData(1, 7, 0, 0))\r\n];\r\n/*----------------- ms feature to feature_flags lookup -----------------*/\r\n//the following strings are public feature strings, and this is mapped to internal feature strings\r\n//notice that a public feature string can be mappaed into multiple internal feature strings\r\nexports.FEATURE_public_screenshare = "screenshare";\r\nexports.FEATURE_public_redirection = "redirection";\r\nexports.FEATURE_public_speaking_indicator = "speaking_indicator";\r\nexports.FEATURE_public_pstn = "pstn";\r\nexports.FEATURE_public_osinfo = "osinfo";\r\nexports.FEATURE_public_sessionidentifier = "sessionidentifier";\r\nexports.featureNameMap = {}; // hash map whose values are hash sets\r\nexports.featureNameMap[exports.FEATURE_public_screenshare] = [exports.FEATURE_ms_teams_desktop_sharing];\r\nexports.featureNameMap[exports.FEATURE_public_redirection] = [exports.FEATURE_ms_teams_redirection];\r\nexports.featureNameMap[exports.FEATURE_public_speaking_indicator] = [exports.FEATURE_ms_teams_speaking_indicator];\r\nexports.featureNameMap[exports.FEATURE_public_pstn] = [exports.FEATURE_ms_teams_pstn];\r\nexports.featureNameMap[exports.FEATURE_public_osinfo] = [exports.FEATURE_ms_teams_osinfo];\r\nexports.featureNameMap[exports.FEATURE_public_sessionidentifier] = [exports.FEATURE_ms_teams_sessionidentifier];\r\n/*----------------- registered class list -----------------*/\r\nvar class_id_t;\r\n(function (class_id_t) {\r\n    class_id_t[class_id_t["EngineControl"] = 0] = "EngineControl";\r\n    class_id_t[class_id_t["RTCPeerConnection"] = 1] = "RTCPeerConnection";\r\n    class_id_t[class_id_t["RTCSessionDescription"] = 2] = "RTCSessionDescription";\r\n    class_id_t[class_id_t["RTCIceCandidate"] = 3] = "RTCIceCandidate";\r\n    class_id_t[class_id_t["RTCIceCandidateEvent"] = 4] = "RTCIceCandidateEvent";\r\n    class_id_t[class_id_t["MediaDevices"] = 5] = "MediaDevices";\r\n    class_id_t[class_id_t["MediaDeviceInfo"] = 6] = "MediaDeviceInfo";\r\n    class_id_t[class_id_t["MediaStreamTrack"] = 7] = "MediaStreamTrack";\r\n    class_id_t[class_id_t["MediaStreamEvent"] = 8] = "MediaStreamEvent";\r\n    class_id_t[class_id_t["MediaStream"] = 9] = "MediaStream";\r\n    class_id_t[class_id_t["NavigatorUserMedia"] = 10] = "NavigatorUserMedia";\r\n    class_id_t[class_id_t["VideoElement"] = 11] = "VideoElement";\r\n    class_id_t[class_id_t["AudioElement"] = 12] = "AudioElement";\r\n    class_id_t[class_id_t["RTCRtpReceiver"] = 13] = "RTCRtpReceiver";\r\n    class_id_t[class_id_t["RTCRtpSender"] = 14] = "RTCRtpSender";\r\n    class_id_t[class_id_t["RTCDtlsTransport"] = 15] = "RTCDtlsTransport";\r\n    class_id_t[class_id_t["RTCIceTransport"] = 16] = "RTCIceTransport";\r\n    class_id_t[class_id_t["RTCDTMFSender"] = 17] = "RTCDTMFSender";\r\n    class_id_t[class_id_t["RTCDTMFToneChangeEvent"] = 18] = "RTCDTMFToneChangeEvent";\r\n    class_id_t[class_id_t["RTCIceCandidatePair"] = 19] = "RTCIceCandidatePair";\r\n    class_id_t[class_id_t["RTCRtpTransceiver"] = 20] = "RTCRtpTransceiver"; //20\r\n})(class_id_t = exports.class_id_t || (exports.class_id_t = {}));\r\n/*----------------- class reflection info -----------------*/\r\n//<engine_control>\r\nvar method_id_EngineControl_t;\r\n(function (method_id_EngineControl_t) {\r\n    method_id_EngineControl_t[method_id_EngineControl_t["ctor"] = 0] = "ctor";\r\n    method_id_EngineControl_t[method_id_EngineControl_t["version"] = 1] = "version";\r\n    method_id_EngineControl_t[method_id_EngineControl_t["feature_flags"] = 2] = "feature_flags";\r\n    method_id_EngineControl_t[method_id_EngineControl_t["version_info"] = 3] = "version_info";\r\n    method_id_EngineControl_t[method_id_EngineControl_t["osinfo"] = 4] = "osinfo";\r\n    method_id_EngineControl_t[method_id_EngineControl_t["session_identifier"] = 5] = "session_identifier"; //prop\r\n})(method_id_EngineControl_t = exports.method_id_EngineControl_t || (exports.method_id_EngineControl_t = {}));\r\n//<peer_connection>\r\nvar method_id_RTCPeerConnection_t;\r\n(function (method_id_RTCPeerConnection_t) {\r\n    method_id_RTCPeerConnection_t[method_id_RTCPeerConnection_t["ctor"] = 0] = "ctor";\r\n    method_id_RTCPeerConnection_t[method_id_RTCPeerConnection_t["localDescription"] = 1] = "localDescription";\r\n    method_id_RTCPeerConnection_t[method_id_RTCPeerConnection_t["remoteDescription"] = 2] = "remoteDescription";\r\n    method_id_RTCPeerConnection_t[method_id_RTCPeerConnection_t["readyState"] = 3] = "readyState";\r\n    method_id_RTCPeerConnection_t[method_id_RTCPeerConnection_t["iceState"] = 4] = "iceState";\r\n    method_id_RTCPeerConnection_t[method_id_RTCPeerConnection_t["localStreams"] = 5] = "localStreams";\r\n    method_id_RTCPeerConnection_t[method_id_RTCPeerConnection_t["remoteStreams"] = 6] = "remoteStreams";\r\n    method_id_RTCPeerConnection_t[method_id_RTCPeerConnection_t["createOffer"] = 7] = "createOffer";\r\n    method_id_RTCPeerConnection_t[method_id_RTCPeerConnection_t["createAnswer"] = 8] = "createAnswer";\r\n    method_id_RTCPeerConnection_t[method_id_RTCPeerConnection_t["setLocalDescription"] = 9] = "setLocalDescription";\r\n    method_id_RTCPeerConnection_t[method_id_RTCPeerConnection_t["setRemoteDescription"] = 10] = "setRemoteDescription";\r\n    method_id_RTCPeerConnection_t[method_id_RTCPeerConnection_t["updateIce"] = 11] = "updateIce";\r\n    method_id_RTCPeerConnection_t[method_id_RTCPeerConnection_t["addIceCandidate"] = 12] = "addIceCandidate";\r\n    method_id_RTCPeerConnection_t[method_id_RTCPeerConnection_t["addStream"] = 13] = "addStream";\r\n    method_id_RTCPeerConnection_t[method_id_RTCPeerConnection_t["removeStream"] = 14] = "removeStream";\r\n    method_id_RTCPeerConnection_t[method_id_RTCPeerConnection_t["close"] = 15] = "close";\r\n    method_id_RTCPeerConnection_t[method_id_RTCPeerConnection_t["iceConnectionState"] = 16] = "iceConnectionState";\r\n    method_id_RTCPeerConnection_t[method_id_RTCPeerConnection_t["iceGatheringState"] = 17] = "iceGatheringState";\r\n    method_id_RTCPeerConnection_t[method_id_RTCPeerConnection_t["signalingState"] = 18] = "signalingState";\r\n    //event cb\r\n    method_id_RTCPeerConnection_t[method_id_RTCPeerConnection_t["onaddstream"] = 19] = "onaddstream";\r\n    method_id_RTCPeerConnection_t[method_id_RTCPeerConnection_t["onicecandidate"] = 20] = "onicecandidate";\r\n    method_id_RTCPeerConnection_t[method_id_RTCPeerConnection_t["oniceconnectionstatechange"] = 21] = "oniceconnectionstatechange";\r\n    method_id_RTCPeerConnection_t[method_id_RTCPeerConnection_t["onicegatheringstatechange"] = 22] = "onicegatheringstatechange";\r\n    method_id_RTCPeerConnection_t[method_id_RTCPeerConnection_t["onsignalingstatechange"] = 23] = "onsignalingstatechange";\r\n    //the following props are not called by Teams for now\r\n    //ondatachannel,              //prop\r\n    method_id_RTCPeerConnection_t[method_id_RTCPeerConnection_t["onnegotiationneeded"] = 24] = "onnegotiationneeded";\r\n    method_id_RTCPeerConnection_t[method_id_RTCPeerConnection_t["onremovestream"] = 25] = "onremovestream";\r\n    method_id_RTCPeerConnection_t[method_id_RTCPeerConnection_t["getStats"] = 26] = "getStats";\r\n    method_id_RTCPeerConnection_t[method_id_RTCPeerConnection_t["getReceivers"] = 27] = "getReceivers";\r\n    method_id_RTCPeerConnection_t[method_id_RTCPeerConnection_t["getSenders"] = 28] = "getSenders";\r\n    method_id_RTCPeerConnection_t[method_id_RTCPeerConnection_t["addTrack"] = 29] = "addTrack";\r\n    method_id_RTCPeerConnection_t[method_id_RTCPeerConnection_t["removeTrack"] = 30] = "removeTrack";\r\n    method_id_RTCPeerConnection_t[method_id_RTCPeerConnection_t["ontrack"] = 31] = "ontrack"; //prop 31\r\n})(method_id_RTCPeerConnection_t = exports.method_id_RTCPeerConnection_t || (exports.method_id_RTCPeerConnection_t = {}));\r\n//<media_devices>\r\nvar method_id_MediaDevices_t;\r\n(function (method_id_MediaDevices_t) {\r\n    method_id_MediaDevices_t[method_id_MediaDevices_t["ctor"] = 0] = "ctor";\r\n    method_id_MediaDevices_t[method_id_MediaDevices_t["enumerateDevices"] = 1] = "enumerateDevices";\r\n    method_id_MediaDevices_t[method_id_MediaDevices_t["getDisplayMedia"] = 2] = "getDisplayMedia";\r\n    method_id_MediaDevices_t[method_id_MediaDevices_t["ondevicechange"] = 3] = "ondevicechange";\r\n})(method_id_MediaDevices_t = exports.method_id_MediaDevices_t || (exports.method_id_MediaDevices_t = {}));\r\n//<media_device_info>\r\nvar method_id_MediaDeviceInfo_t;\r\n(function (method_id_MediaDeviceInfo_t) {\r\n    method_id_MediaDeviceInfo_t[method_id_MediaDeviceInfo_t["ctor"] = 0] = "ctor";\r\n    method_id_MediaDeviceInfo_t[method_id_MediaDeviceInfo_t["deviceId"] = 1] = "deviceId";\r\n    method_id_MediaDeviceInfo_t[method_id_MediaDeviceInfo_t["kind"] = 2] = "kind";\r\n    method_id_MediaDeviceInfo_t[method_id_MediaDeviceInfo_t["label"] = 3] = "label";\r\n    method_id_MediaDeviceInfo_t[method_id_MediaDeviceInfo_t["groupId"] = 4] = "groupId"; //prop\r\n})(method_id_MediaDeviceInfo_t = exports.method_id_MediaDeviceInfo_t || (exports.method_id_MediaDeviceInfo_t = {}));\r\n//<session_description>\r\nvar method_id_RTCSessionDescription_t;\r\n(function (method_id_RTCSessionDescription_t) {\r\n    method_id_RTCSessionDescription_t[method_id_RTCSessionDescription_t["ctor"] = 0] = "ctor";\r\n    //to_string,\r\n    method_id_RTCSessionDescription_t[method_id_RTCSessionDescription_t["type"] = 1] = "type";\r\n    method_id_RTCSessionDescription_t[method_id_RTCSessionDescription_t["sdp"] = 2] = "sdp"; //prop\r\n})(method_id_RTCSessionDescription_t = exports.method_id_RTCSessionDescription_t || (exports.method_id_RTCSessionDescription_t = {}));\r\n//<media_stream_track>\r\nvar method_id_MediaStreamTrack_t;\r\n(function (method_id_MediaStreamTrack_t) {\r\n    method_id_MediaStreamTrack_t[method_id_MediaStreamTrack_t["ctor"] = 0] = "ctor";\r\n    method_id_MediaStreamTrack_t[method_id_MediaStreamTrack_t["kind"] = 1] = "kind";\r\n    method_id_MediaStreamTrack_t[method_id_MediaStreamTrack_t["id"] = 2] = "id";\r\n    method_id_MediaStreamTrack_t[method_id_MediaStreamTrack_t["label"] = 3] = "label";\r\n    method_id_MediaStreamTrack_t[method_id_MediaStreamTrack_t["enabled"] = 4] = "enabled";\r\n    method_id_MediaStreamTrack_t[method_id_MediaStreamTrack_t["muted"] = 5] = "muted";\r\n    method_id_MediaStreamTrack_t[method_id_MediaStreamTrack_t["readyState"] = 6] = "readyState";\r\n    method_id_MediaStreamTrack_t[method_id_MediaStreamTrack_t["onended"] = 7] = "onended";\r\n    method_id_MediaStreamTrack_t[method_id_MediaStreamTrack_t["onmute"] = 8] = "onmute";\r\n    method_id_MediaStreamTrack_t[method_id_MediaStreamTrack_t["onunmute"] = 9] = "onunmute";\r\n    method_id_MediaStreamTrack_t[method_id_MediaStreamTrack_t["clone"] = 10] = "clone";\r\n    method_id_MediaStreamTrack_t[method_id_MediaStreamTrack_t["stop"] = 11] = "stop";\r\n    method_id_MediaStreamTrack_t[method_id_MediaStreamTrack_t["getCapabilities"] = 12] = "getCapabilities";\r\n    method_id_MediaStreamTrack_t[method_id_MediaStreamTrack_t["getSettings"] = 13] = "getSettings";\r\n    method_id_MediaStreamTrack_t[method_id_MediaStreamTrack_t["applyConstraints"] = 14] = "applyConstraints";\r\n    method_id_MediaStreamTrack_t[method_id_MediaStreamTrack_t["getConstraints"] = 15] = "getConstraints";\r\n})(method_id_MediaStreamTrack_t = exports.method_id_MediaStreamTrack_t || (exports.method_id_MediaStreamTrack_t = {}));\r\n//<media_stream>\r\nvar method_id_MediaStream_t;\r\n(function (method_id_MediaStream_t) {\r\n    method_id_MediaStream_t[method_id_MediaStream_t["ctor"] = 0] = "ctor";\r\n    method_id_MediaStream_t[method_id_MediaStream_t["id"] = 1] = "id";\r\n    method_id_MediaStream_t[method_id_MediaStream_t["getAudioTracks"] = 2] = "getAudioTracks";\r\n    method_id_MediaStream_t[method_id_MediaStream_t["getVideoTracks"] = 3] = "getVideoTracks";\r\n    method_id_MediaStream_t[method_id_MediaStream_t["getTracks"] = 4] = "getTracks";\r\n    method_id_MediaStream_t[method_id_MediaStream_t["getTrackById"] = 5] = "getTrackById";\r\n    method_id_MediaStream_t[method_id_MediaStream_t["addTrack"] = 6] = "addTrack";\r\n    method_id_MediaStream_t[method_id_MediaStream_t["removeTrack"] = 7] = "removeTrack";\r\n    method_id_MediaStream_t[method_id_MediaStream_t["clone"] = 8] = "clone";\r\n    method_id_MediaStream_t[method_id_MediaStream_t["active"] = 9] = "active";\r\n})(method_id_MediaStream_t = exports.method_id_MediaStream_t || (exports.method_id_MediaStream_t = {}));\r\n//<navigator_user_media>\r\nvar method_id_NavigatorUserMedia_t;\r\n(function (method_id_NavigatorUserMedia_t) {\r\n    method_id_NavigatorUserMedia_t[method_id_NavigatorUserMedia_t["ctor"] = 0] = "ctor";\r\n    method_id_NavigatorUserMedia_t[method_id_NavigatorUserMedia_t["getUserMedia"] = 1] = "getUserMedia";\r\n})(method_id_NavigatorUserMedia_t = exports.method_id_NavigatorUserMedia_t || (exports.method_id_NavigatorUserMedia_t = {}));\r\n//<rtc_ice_candidate>\r\nvar method_id_RTCIceCandidate_t;\r\n(function (method_id_RTCIceCandidate_t) {\r\n    method_id_RTCIceCandidate_t[method_id_RTCIceCandidate_t["ctor"] = 0] = "ctor";\r\n    method_id_RTCIceCandidate_t[method_id_RTCIceCandidate_t["candidate"] = 1] = "candidate";\r\n    method_id_RTCIceCandidate_t[method_id_RTCIceCandidate_t["sdpMid"] = 2] = "sdpMid";\r\n    method_id_RTCIceCandidate_t[method_id_RTCIceCandidate_t["sdpMLineIndex"] = 3] = "sdpMLineIndex"; //prop\r\n})(method_id_RTCIceCandidate_t = exports.method_id_RTCIceCandidate_t || (exports.method_id_RTCIceCandidate_t = {}));\r\n//<rtc_ice_candidate_event>\r\nvar method_id_RTCIceCandidateEvent_t;\r\n(function (method_id_RTCIceCandidateEvent_t) {\r\n    method_id_RTCIceCandidateEvent_t[method_id_RTCIceCandidateEvent_t["ctor"] = 0] = "ctor";\r\n    method_id_RTCIceCandidateEvent_t[method_id_RTCIceCandidateEvent_t["candidate"] = 1] = "candidate"; //prop\r\n    //url\r\n})(method_id_RTCIceCandidateEvent_t = exports.method_id_RTCIceCandidateEvent_t || (exports.method_id_RTCIceCandidateEvent_t = {}));\r\n//<media_stream_event>\r\nvar method_id_MediaStreamEvent_t;\r\n(function (method_id_MediaStreamEvent_t) {\r\n    method_id_MediaStreamEvent_t[method_id_MediaStreamEvent_t["ctor"] = 0] = "ctor";\r\n    method_id_MediaStreamEvent_t[method_id_MediaStreamEvent_t["stream"] = 1] = "stream";\r\n})(method_id_MediaStreamEvent_t = exports.method_id_MediaStreamEvent_t || (exports.method_id_MediaStreamEvent_t = {}));\r\nvar method_id_VideoElement_t;\r\n(function (method_id_VideoElement_t) {\r\n    method_id_VideoElement_t[method_id_VideoElement_t["ctor"] = 0] = "ctor";\r\n    method_id_VideoElement_t[method_id_VideoElement_t["sinkId"] = 1] = "sinkId";\r\n    method_id_VideoElement_t[method_id_VideoElement_t["connectTo"] = 2] = "connectTo";\r\n    method_id_VideoElement_t[method_id_VideoElement_t["disconnect"] = 3] = "disconnect";\r\n    method_id_VideoElement_t[method_id_VideoElement_t["setFrame"] = 4] = "setFrame";\r\n    method_id_VideoElement_t[method_id_VideoElement_t["addClipRect"] = 5] = "addClipRect";\r\n    method_id_VideoElement_t[method_id_VideoElement_t["removeClipRect"] = 6] = "removeClipRect";\r\n    method_id_VideoElement_t[method_id_VideoElement_t["onerror"] = 7] = "onerror";\r\n    method_id_VideoElement_t[method_id_VideoElement_t["onvideoframechanged"] = 8] = "onvideoframechanged";\r\n})(method_id_VideoElement_t = exports.method_id_VideoElement_t || (exports.method_id_VideoElement_t = {}));\r\nvar method_id_AudioElement_t;\r\n(function (method_id_AudioElement_t) {\r\n    method_id_AudioElement_t[method_id_AudioElement_t["ctor"] = 0] = "ctor";\r\n    method_id_AudioElement_t[method_id_AudioElement_t["sinkId"] = 1] = "sinkId";\r\n    method_id_AudioElement_t[method_id_AudioElement_t["srcObject"] = 2] = "srcObject";\r\n    method_id_AudioElement_t[method_id_AudioElement_t["src"] = 3] = "src";\r\n    method_id_AudioElement_t[method_id_AudioElement_t["play"] = 4] = "play";\r\n    method_id_AudioElement_t[method_id_AudioElement_t["pause"] = 5] = "pause";\r\n})(method_id_AudioElement_t = exports.method_id_AudioElement_t || (exports.method_id_AudioElement_t = {}));\r\nvar method_id_RTCRtpReceiver_t;\r\n(function (method_id_RTCRtpReceiver_t) {\r\n    method_id_RTCRtpReceiver_t[method_id_RTCRtpReceiver_t["ctor"] = 0] = "ctor";\r\n    method_id_RTCRtpReceiver_t[method_id_RTCRtpReceiver_t["track"] = 1] = "track";\r\n    method_id_RTCRtpReceiver_t[method_id_RTCRtpReceiver_t["getContributingSources"] = 2] = "getContributingSources";\r\n    method_id_RTCRtpReceiver_t[method_id_RTCRtpReceiver_t["getSynchronizationSources"] = 3] = "getSynchronizationSources";\r\n    method_id_RTCRtpReceiver_t[method_id_RTCRtpReceiver_t["transport"] = 4] = "transport";\r\n    method_id_RTCRtpReceiver_t[method_id_RTCRtpReceiver_t["rtcpTransport"] = 5] = "rtcpTransport";\r\n    method_id_RTCRtpReceiver_t[method_id_RTCRtpReceiver_t["getCapabilities"] = 6] = "getCapabilities";\r\n    method_id_RTCRtpReceiver_t[method_id_RTCRtpReceiver_t["getParameters"] = 7] = "getParameters";\r\n    method_id_RTCRtpReceiver_t[method_id_RTCRtpReceiver_t["getStats"] = 8] = "getStats";\r\n})(method_id_RTCRtpReceiver_t = exports.method_id_RTCRtpReceiver_t || (exports.method_id_RTCRtpReceiver_t = {}));\r\nvar method_id_RTCRtpSender_t;\r\n(function (method_id_RTCRtpSender_t) {\r\n    method_id_RTCRtpSender_t[method_id_RTCRtpSender_t["ctor"] = 0] = "ctor";\r\n    method_id_RTCRtpSender_t[method_id_RTCRtpSender_t["track"] = 1] = "track";\r\n    method_id_RTCRtpSender_t[method_id_RTCRtpSender_t["transport"] = 2] = "transport";\r\n    method_id_RTCRtpSender_t[method_id_RTCRtpSender_t["rtcpTransport"] = 3] = "rtcpTransport";\r\n    method_id_RTCRtpSender_t[method_id_RTCRtpSender_t["dtmf"] = 4] = "dtmf";\r\n    method_id_RTCRtpSender_t[method_id_RTCRtpSender_t["getCapabilities"] = 5] = "getCapabilities";\r\n    method_id_RTCRtpSender_t[method_id_RTCRtpSender_t["getParameters"] = 6] = "getParameters";\r\n    method_id_RTCRtpSender_t[method_id_RTCRtpSender_t["setParameters"] = 7] = "setParameters";\r\n    method_id_RTCRtpSender_t[method_id_RTCRtpSender_t["replaceTrack"] = 8] = "replaceTrack";\r\n    method_id_RTCRtpSender_t[method_id_RTCRtpSender_t["getStats"] = 9] = "getStats";\r\n    method_id_RTCRtpSender_t[method_id_RTCRtpSender_t["setStreams"] = 10] = "setStreams";\r\n})(method_id_RTCRtpSender_t = exports.method_id_RTCRtpSender_t || (exports.method_id_RTCRtpSender_t = {}));\r\nvar method_id_RTCDtlsTransport_t;\r\n(function (method_id_RTCDtlsTransport_t) {\r\n    method_id_RTCDtlsTransport_t[method_id_RTCDtlsTransport_t["ctor"] = 0] = "ctor";\r\n    method_id_RTCDtlsTransport_t[method_id_RTCDtlsTransport_t["transport"] = 1] = "transport";\r\n    method_id_RTCDtlsTransport_t[method_id_RTCDtlsTransport_t["state"] = 2] = "state";\r\n    method_id_RTCDtlsTransport_t[method_id_RTCDtlsTransport_t["getRemoteCertificates"] = 3] = "getRemoteCertificates";\r\n    method_id_RTCDtlsTransport_t[method_id_RTCDtlsTransport_t["onstatechange"] = 4] = "onstatechange";\r\n    method_id_RTCDtlsTransport_t[method_id_RTCDtlsTransport_t["onerror"] = 5] = "onerror";\r\n})(method_id_RTCDtlsTransport_t = exports.method_id_RTCDtlsTransport_t || (exports.method_id_RTCDtlsTransport_t = {}));\r\nvar method_id_RTCIceTransport_t;\r\n(function (method_id_RTCIceTransport_t) {\r\n    method_id_RTCIceTransport_t[method_id_RTCIceTransport_t["ctor"] = 0] = "ctor";\r\n    method_id_RTCIceTransport_t[method_id_RTCIceTransport_t["role"] = 1] = "role";\r\n    method_id_RTCIceTransport_t[method_id_RTCIceTransport_t["component"] = 2] = "component";\r\n    method_id_RTCIceTransport_t[method_id_RTCIceTransport_t["state"] = 3] = "state";\r\n    method_id_RTCIceTransport_t[method_id_RTCIceTransport_t["gatheringState"] = 4] = "gatheringState";\r\n    method_id_RTCIceTransport_t[method_id_RTCIceTransport_t["localcandidates"] = 5] = "localcandidates";\r\n    method_id_RTCIceTransport_t[method_id_RTCIceTransport_t["remotecandidates"] = 6] = "remotecandidates";\r\n    method_id_RTCIceTransport_t[method_id_RTCIceTransport_t["onstatechange"] = 7] = "onstatechange";\r\n    method_id_RTCIceTransport_t[method_id_RTCIceTransport_t["ongatheringstatechange"] = 8] = "ongatheringstatechange";\r\n    method_id_RTCIceTransport_t[method_id_RTCIceTransport_t["onselectedcandidatepairchange"] = 9] = "onselectedcandidatepairchange";\r\n})(method_id_RTCIceTransport_t = exports.method_id_RTCIceTransport_t || (exports.method_id_RTCIceTransport_t = {}));\r\nvar method_id_RTCDTMFSender_t;\r\n(function (method_id_RTCDTMFSender_t) {\r\n    method_id_RTCDTMFSender_t[method_id_RTCDTMFSender_t["ctor"] = 0] = "ctor";\r\n    method_id_RTCDTMFSender_t[method_id_RTCDTMFSender_t["insertDTMF"] = 1] = "insertDTMF";\r\n    method_id_RTCDTMFSender_t[method_id_RTCDTMFSender_t["ontonechange"] = 2] = "ontonechange";\r\n    method_id_RTCDTMFSender_t[method_id_RTCDTMFSender_t["canInsertDTMF"] = 3] = "canInsertDTMF";\r\n    method_id_RTCDTMFSender_t[method_id_RTCDTMFSender_t["toneBuffer"] = 4] = "toneBuffer";\r\n})(method_id_RTCDTMFSender_t = exports.method_id_RTCDTMFSender_t || (exports.method_id_RTCDTMFSender_t = {}));\r\nvar method_id_RTCDTMFToneChangeEvent_t;\r\n(function (method_id_RTCDTMFToneChangeEvent_t) {\r\n    method_id_RTCDTMFToneChangeEvent_t[method_id_RTCDTMFToneChangeEvent_t["ctor"] = 0] = "ctor";\r\n    method_id_RTCDTMFToneChangeEvent_t[method_id_RTCDTMFToneChangeEvent_t["tone"] = 1] = "tone";\r\n    method_id_RTCDTMFToneChangeEvent_t[method_id_RTCDTMFToneChangeEvent_t["tone_buffer"] = 2] = "tone_buffer";\r\n})(method_id_RTCDTMFToneChangeEvent_t = exports.method_id_RTCDTMFToneChangeEvent_t || (exports.method_id_RTCDTMFToneChangeEvent_t = {}));\r\nvar method_id_RTCIceCandidatePair_t;\r\n(function (method_id_RTCIceCandidatePair_t) {\r\n    method_id_RTCIceCandidatePair_t[method_id_RTCIceCandidatePair_t["ctor"] = 0] = "ctor";\r\n    method_id_RTCIceCandidatePair_t[method_id_RTCIceCandidatePair_t["local"] = 1] = "local";\r\n    method_id_RTCIceCandidatePair_t[method_id_RTCIceCandidatePair_t["remote"] = 2] = "remote";\r\n})(method_id_RTCIceCandidatePair_t = exports.method_id_RTCIceCandidatePair_t || (exports.method_id_RTCIceCandidatePair_t = {}));\r\nvar method_id_RTCRtpTransceiver_t;\r\n(function (method_id_RTCRtpTransceiver_t) {\r\n    method_id_RTCRtpTransceiver_t[method_id_RTCRtpTransceiver_t["ctor"] = 0] = "ctor";\r\n    method_id_RTCRtpTransceiver_t[method_id_RTCRtpTransceiver_t["mid"] = 1] = "mid";\r\n    method_id_RTCRtpTransceiver_t[method_id_RTCRtpTransceiver_t["sender"] = 2] = "sender";\r\n    method_id_RTCRtpTransceiver_t[method_id_RTCRtpTransceiver_t["receiver"] = 3] = "receiver";\r\n    method_id_RTCRtpTransceiver_t[method_id_RTCRtpTransceiver_t["direction"] = 4] = "direction";\r\n    method_id_RTCRtpTransceiver_t[method_id_RTCRtpTransceiver_t["currentDirection"] = 5] = "currentDirection";\r\n    method_id_RTCRtpTransceiver_t[method_id_RTCRtpTransceiver_t["stop"] = 6] = "stop";\r\n    method_id_RTCRtpTransceiver_t[method_id_RTCRtpTransceiver_t["setCodecPreferences"] = 7] = "setCodecPreferences";\r\n})(method_id_RTCRtpTransceiver_t = exports.method_id_RTCRtpTransceiver_t || (exports.method_id_RTCRtpTransceiver_t = {}));\r\n/*----------------- internal structures -----------------*/\r\nvar WebrpcMethodInfo = /** @class */ (function () {\r\n    function WebrpcMethodInfo(iid, mid, name, prop, feature) {\r\n        if (feature === void 0) { feature = exports.FEATURE_ms_teams_redirection; }\r\n        this.iid = iid;\r\n        this.mid = mid;\r\n        this.name = name;\r\n        this.isprop = prop;\r\n        this.feature = feature;\r\n    }\r\n    ;\r\n    return WebrpcMethodInfo;\r\n}());\r\nexports.WebrpcMethodInfo = WebrpcMethodInfo;\r\nvar WebrpcClassInfo = /** @class */ (function () {\r\n    function WebrpcClassInfo(id, name, methods) {\r\n        this.id = id;\r\n        this.name = name;\r\n        this.methods = methods;\r\n    }\r\n    ;\r\n    return WebrpcClassInfo;\r\n}());\r\nexports.WebrpcClassInfo = WebrpcClassInfo;\r\nvar WebrpcClassLibInfo = /** @class */ (function () {\r\n    function WebrpcClassLibInfo(name, classes) {\r\n        this.name = name;\r\n        this.classes = classes;\r\n    }\r\n    ;\r\n    return WebrpcClassLibInfo;\r\n}());\r\n/*----------------- class_lib info static table -----------------*/\r\nvar class_lib_info = new WebrpcClassLibInfo("msteams_class_library", [\r\n    //EngineControl\r\n    new WebrpcClassInfo(class_id_t.EngineControl, "EngineControl", [\r\n        new WebrpcMethodInfo(class_id_t.EngineControl, method_id_EngineControl_t.ctor, "ctor", false),\r\n        new WebrpcMethodInfo(class_id_t.EngineControl, method_id_EngineControl_t.version, "version", true),\r\n        new WebrpcMethodInfo(class_id_t.EngineControl, method_id_EngineControl_t.feature_flags, "feature_flags", true),\r\n        new WebrpcMethodInfo(class_id_t.EngineControl, method_id_EngineControl_t.version_info, "version_info", true, exports.FEATURE_ms_teams_desktop_sharing),\r\n        new WebrpcMethodInfo(class_id_t.EngineControl, method_id_EngineControl_t.osinfo, "osinfo", true, exports.FEATURE_ms_teams_osinfo),\r\n        new WebrpcMethodInfo(class_id_t.EngineControl, method_id_EngineControl_t.session_identifier, "session_identifier", true, exports.FEATURE_ms_teams_sessionidentifier)\r\n    ]),\r\n    //RTCPeerConnection\r\n    new WebrpcClassInfo(class_id_t.RTCPeerConnection, "RTCPeerConnection", [\r\n        new WebrpcMethodInfo(class_id_t.RTCPeerConnection, method_id_RTCPeerConnection_t.ctor, "ctor", false),\r\n        new WebrpcMethodInfo(class_id_t.RTCPeerConnection, method_id_RTCPeerConnection_t.localDescription, "localDescription", true),\r\n        new WebrpcMethodInfo(class_id_t.RTCPeerConnection, method_id_RTCPeerConnection_t.remoteDescription, "remoteDescription", true),\r\n        new WebrpcMethodInfo(class_id_t.RTCPeerConnection, method_id_RTCPeerConnection_t.readyState, "readyState", true),\r\n        new WebrpcMethodInfo(class_id_t.RTCPeerConnection, method_id_RTCPeerConnection_t.iceState, "iceState", true),\r\n        new WebrpcMethodInfo(class_id_t.RTCPeerConnection, method_id_RTCPeerConnection_t.localStreams, "localStreams", true),\r\n        new WebrpcMethodInfo(class_id_t.RTCPeerConnection, method_id_RTCPeerConnection_t.remoteStreams, "remoteStreams", true),\r\n        new WebrpcMethodInfo(class_id_t.RTCPeerConnection, method_id_RTCPeerConnection_t.createOffer, "createOffer", false),\r\n        new WebrpcMethodInfo(class_id_t.RTCPeerConnection, method_id_RTCPeerConnection_t.createAnswer, "createAnswer", false),\r\n        new WebrpcMethodInfo(class_id_t.RTCPeerConnection, method_id_RTCPeerConnection_t.setLocalDescription, "setLocalDescription", false),\r\n        new WebrpcMethodInfo(class_id_t.RTCPeerConnection, method_id_RTCPeerConnection_t.setRemoteDescription, "setRemoteDescription", false),\r\n        new WebrpcMethodInfo(class_id_t.RTCPeerConnection, method_id_RTCPeerConnection_t.updateIce, "updateIce", true),\r\n        new WebrpcMethodInfo(class_id_t.RTCPeerConnection, method_id_RTCPeerConnection_t.addIceCandidate, "addIceCandidate", true),\r\n        new WebrpcMethodInfo(class_id_t.RTCPeerConnection, method_id_RTCPeerConnection_t.addStream, "addStream", true),\r\n        new WebrpcMethodInfo(class_id_t.RTCPeerConnection, method_id_RTCPeerConnection_t.removeStream, "removeStream", true),\r\n        new WebrpcMethodInfo(class_id_t.RTCPeerConnection, method_id_RTCPeerConnection_t.close, "close", true),\r\n        new WebrpcMethodInfo(class_id_t.RTCPeerConnection, method_id_RTCPeerConnection_t.iceConnectionState, "iceConnectionState", true),\r\n        new WebrpcMethodInfo(class_id_t.RTCPeerConnection, method_id_RTCPeerConnection_t.iceGatheringState, "iceGatheringState", true),\r\n        new WebrpcMethodInfo(class_id_t.RTCPeerConnection, method_id_RTCPeerConnection_t.signalingState, "signalingState", true),\r\n        new WebrpcMethodInfo(class_id_t.RTCPeerConnection, method_id_RTCPeerConnection_t.onaddstream, "onaddstream", true),\r\n        new WebrpcMethodInfo(class_id_t.RTCPeerConnection, method_id_RTCPeerConnection_t.onicecandidate, "onicecandidate", true),\r\n        new WebrpcMethodInfo(class_id_t.RTCPeerConnection, method_id_RTCPeerConnection_t.oniceconnectionstatechange, "oniceconnectionstatechange", true),\r\n        new WebrpcMethodInfo(class_id_t.RTCPeerConnection, method_id_RTCPeerConnection_t.onicegatheringstatechange, "onicegatheringstatechange", true),\r\n        new WebrpcMethodInfo(class_id_t.RTCPeerConnection, method_id_RTCPeerConnection_t.onsignalingstatechange, "onsignalingstatechange", true),\r\n        //the following props are not called by Teams for now\r\n        //new WebrpcMethodInfo(class_id_t.RTCPeerConnection, method_id_RTCPeerConnection_t.ondatachannel, "ondatachannel", true),\r\n        new WebrpcMethodInfo(class_id_t.RTCPeerConnection, method_id_RTCPeerConnection_t.onnegotiationneeded, "onnegotiationneeded", true),\r\n        new WebrpcMethodInfo(class_id_t.RTCPeerConnection, method_id_RTCPeerConnection_t.onremovestream, "onremovestream", true),\r\n        new WebrpcMethodInfo(class_id_t.RTCPeerConnection, method_id_RTCPeerConnection_t.getStats, "getStats", false),\r\n        new WebrpcMethodInfo(class_id_t.RTCPeerConnection, method_id_RTCPeerConnection_t.getReceivers, "getReceivers", false, exports.FEATURE_ms_teams_speaking_indicator),\r\n        new WebrpcMethodInfo(class_id_t.RTCPeerConnection, method_id_RTCPeerConnection_t.getSenders, "getSenders", false, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCPeerConnection, method_id_RTCPeerConnection_t.addTrack, "addTrack", false, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCPeerConnection, method_id_RTCPeerConnection_t.removeTrack, "removeTrack", false, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCPeerConnection, method_id_RTCPeerConnection_t.ontrack, "ontrack", true, exports.FEATURE_ms_teams_pstn)\r\n    ]),\r\n    //RTCSessionDescription\r\n    new WebrpcClassInfo(class_id_t.RTCSessionDescription, "RTCSessionDescription", [\r\n        new WebrpcMethodInfo(class_id_t.RTCSessionDescription, method_id_RTCSessionDescription_t.ctor, "ctor", false),\r\n        //new WebrpcMethodInfo(class_id_t.RTCSessionDescription, method_id_RTCSessionDescription_t.to_string, "to_string", false),\r\n        new WebrpcMethodInfo(class_id_t.RTCSessionDescription, method_id_RTCSessionDescription_t.type, "type", true),\r\n        new WebrpcMethodInfo(class_id_t.RTCSessionDescription, method_id_RTCSessionDescription_t.sdp, "sdp", true)\r\n    ]),\r\n    //RTCIceCandidate\r\n    new WebrpcClassInfo(class_id_t.RTCIceCandidate, "RTCIceCandidate", [\r\n        new WebrpcMethodInfo(class_id_t.RTCIceCandidate, method_id_RTCIceCandidate_t.ctor, "ctor", false),\r\n        new WebrpcMethodInfo(class_id_t.RTCIceCandidate, method_id_RTCIceCandidate_t.candidate, "candidate", true),\r\n        new WebrpcMethodInfo(class_id_t.RTCIceCandidate, method_id_RTCIceCandidate_t.sdpMid, "sdpMid", true),\r\n        new WebrpcMethodInfo(class_id_t.RTCIceCandidate, method_id_RTCIceCandidate_t.sdpMLineIndex, "sdpMLineIndex", true)\r\n    ]),\r\n    //RTCIceCandidateEvent\r\n    new WebrpcClassInfo(class_id_t.RTCIceCandidateEvent, "RTCIceCandidateEvent", [\r\n        new WebrpcMethodInfo(class_id_t.RTCIceCandidateEvent, method_id_RTCIceCandidateEvent_t.ctor, "ctor", false),\r\n        new WebrpcMethodInfo(class_id_t.RTCIceCandidateEvent, method_id_RTCIceCandidateEvent_t.candidate, "candidate", true)\r\n        //new WebrpcMethodInfo(class_id_t.RTCIceCandidateEvent, method_id_RTCIceCandidateEvent_t.url, "url", true)\r\n    ]),\r\n    //MediaDevices\r\n    new WebrpcClassInfo(class_id_t.MediaDevices, "MediaDevices", [\r\n        new WebrpcMethodInfo(class_id_t.MediaDevices, method_id_MediaDevices_t.ctor, "ctor", false),\r\n        new WebrpcMethodInfo(class_id_t.MediaDevices, method_id_MediaDevices_t.enumerateDevices, "enumerateDevices", false),\r\n        new WebrpcMethodInfo(class_id_t.MediaDevices, method_id_MediaDevices_t.getDisplayMedia, "getDisplayMedia", false, exports.FEATURE_ms_teams_desktop_sharing),\r\n        new WebrpcMethodInfo(class_id_t.MediaDevices, method_id_MediaDevices_t.ondevicechange, "ondevicechange", true, exports.FEATURE_ms_teams_speaking_indicator)\r\n    ]),\r\n    //MediaDeviceInfo\r\n    new WebrpcClassInfo(class_id_t.MediaDeviceInfo, "MediaDeviceInfo", [\r\n        new WebrpcMethodInfo(class_id_t.MediaDeviceInfo, method_id_MediaDeviceInfo_t.ctor, "ctor", false),\r\n        new WebrpcMethodInfo(class_id_t.MediaDeviceInfo, method_id_MediaDeviceInfo_t.deviceId, "deviceId", true),\r\n        new WebrpcMethodInfo(class_id_t.MediaDeviceInfo, method_id_MediaDeviceInfo_t.kind, "kind", true),\r\n        new WebrpcMethodInfo(class_id_t.MediaDeviceInfo, method_id_MediaDeviceInfo_t.label, "label", true),\r\n        new WebrpcMethodInfo(class_id_t.MediaDeviceInfo, method_id_MediaDeviceInfo_t.groupId, "groupId", true)\r\n    ]),\r\n    //MediaStreamTrack\r\n    new WebrpcClassInfo(class_id_t.MediaStreamTrack, "MediaStreamTrack", [\r\n        new WebrpcMethodInfo(class_id_t.MediaStreamTrack, method_id_MediaStreamTrack_t.ctor, "ctor", false),\r\n        new WebrpcMethodInfo(class_id_t.MediaStreamTrack, method_id_MediaStreamTrack_t.clone, "clone", false),\r\n        new WebrpcMethodInfo(class_id_t.MediaStreamTrack, method_id_MediaStreamTrack_t.stop, "stop", false),\r\n        new WebrpcMethodInfo(class_id_t.MediaStreamTrack, method_id_MediaStreamTrack_t.getCapabilities, "getCapabilities", false),\r\n        new WebrpcMethodInfo(class_id_t.MediaStreamTrack, method_id_MediaStreamTrack_t.getSettings, "getSettings", false),\r\n        new WebrpcMethodInfo(class_id_t.MediaStreamTrack, method_id_MediaStreamTrack_t.applyConstraints, "applyConstraints", false, exports.FEATURE_ms_teams_desktop_sharing),\r\n        new WebrpcMethodInfo(class_id_t.MediaStreamTrack, method_id_MediaStreamTrack_t.kind, "kind", true),\r\n        new WebrpcMethodInfo(class_id_t.MediaStreamTrack, method_id_MediaStreamTrack_t.id, "id", true),\r\n        new WebrpcMethodInfo(class_id_t.MediaStreamTrack, method_id_MediaStreamTrack_t.label, "label", true),\r\n        new WebrpcMethodInfo(class_id_t.MediaStreamTrack, method_id_MediaStreamTrack_t.enabled, "enabled", true),\r\n        new WebrpcMethodInfo(class_id_t.MediaStreamTrack, method_id_MediaStreamTrack_t.muted, "muted", true),\r\n        new WebrpcMethodInfo(class_id_t.MediaStreamTrack, method_id_MediaStreamTrack_t.readyState, "readyState", true),\r\n        new WebrpcMethodInfo(class_id_t.MediaStreamTrack, method_id_MediaStreamTrack_t.onended, "onended", true),\r\n        new WebrpcMethodInfo(class_id_t.MediaStreamTrack, method_id_MediaStreamTrack_t.onmute, "onmute", true),\r\n        new WebrpcMethodInfo(class_id_t.MediaStreamTrack, method_id_MediaStreamTrack_t.onunmute, "onunmute", true),\r\n        new WebrpcMethodInfo(class_id_t.MediaStreamTrack, method_id_MediaStreamTrack_t.getConstraints, "getConstraints", false, exports.FEATURE_ms_teams_mstrack_constraints)\r\n    ]),\r\n    //MediaStream\r\n    new WebrpcClassInfo(class_id_t.MediaStream, "MediaStream", [\r\n        new WebrpcMethodInfo(class_id_t.MediaStream, method_id_MediaStream_t.ctor, "ctor", false),\r\n        new WebrpcMethodInfo(class_id_t.MediaStream, method_id_MediaStream_t.id, "id", true),\r\n        new WebrpcMethodInfo(class_id_t.MediaStream, method_id_MediaStream_t.getAudioTracks, "getAudioTracks", false),\r\n        new WebrpcMethodInfo(class_id_t.MediaStream, method_id_MediaStream_t.getVideoTracks, "getVideoTracks", false),\r\n        new WebrpcMethodInfo(class_id_t.MediaStream, method_id_MediaStream_t.getTracks, "getTracks", false),\r\n        new WebrpcMethodInfo(class_id_t.MediaStream, method_id_MediaStream_t.getTrackById, "getTrackById", false),\r\n        new WebrpcMethodInfo(class_id_t.MediaStream, method_id_MediaStream_t.addTrack, "addTrack", false),\r\n        new WebrpcMethodInfo(class_id_t.MediaStream, method_id_MediaStream_t.removeTrack, "removeTrack", false),\r\n        new WebrpcMethodInfo(class_id_t.MediaStream, method_id_MediaStream_t.clone, "clone", true),\r\n        new WebrpcMethodInfo(class_id_t.MediaStream, method_id_MediaStream_t.active, "active", true)\r\n    ]),\r\n    //NavigatorUserMedia\r\n    new WebrpcClassInfo(class_id_t.NavigatorUserMedia, "NavigatorUserMedia", [\r\n        new WebrpcMethodInfo(class_id_t.NavigatorUserMedia, method_id_NavigatorUserMedia_t.ctor, "ctor", false),\r\n        new WebrpcMethodInfo(class_id_t.NavigatorUserMedia, method_id_NavigatorUserMedia_t.getUserMedia, "getUserMedia", false)\r\n    ]),\r\n    //MediaStreamEvent\r\n    new WebrpcClassInfo(class_id_t.MediaStreamEvent, "MediaStreamEvent", [\r\n        new WebrpcMethodInfo(class_id_t.MediaStreamEvent, method_id_MediaStreamEvent_t.ctor, "ctor", false),\r\n        new WebrpcMethodInfo(class_id_t.MediaStreamEvent, method_id_MediaStreamEvent_t.stream, "stream", true)\r\n    ]),\r\n    //VideoElement\r\n    new WebrpcClassInfo(class_id_t.VideoElement, "VideoElement", [\r\n        new WebrpcMethodInfo(class_id_t.VideoElement, method_id_VideoElement_t.ctor, "ctor", false),\r\n        new WebrpcMethodInfo(class_id_t.VideoElement, method_id_VideoElement_t.sinkId, "sinkId", true),\r\n        new WebrpcMethodInfo(class_id_t.VideoElement, method_id_VideoElement_t.connectTo, "connectTo", false),\r\n        new WebrpcMethodInfo(class_id_t.VideoElement, method_id_VideoElement_t.disconnect, "disconnect", false),\r\n        new WebrpcMethodInfo(class_id_t.VideoElement, method_id_VideoElement_t.setFrame, "setFrame", false),\r\n        new WebrpcMethodInfo(class_id_t.VideoElement, method_id_VideoElement_t.addClipRect, "addClipRect", false),\r\n        new WebrpcMethodInfo(class_id_t.VideoElement, method_id_VideoElement_t.removeClipRect, "removeClipRect", false),\r\n        new WebrpcMethodInfo(class_id_t.VideoElement, method_id_VideoElement_t.onerror, "onerror", true),\r\n        new WebrpcMethodInfo(class_id_t.VideoElement, method_id_VideoElement_t.onvideoframechanged, "onvideoframechanged", true)\r\n    ]),\r\n    //AudioElement\r\n    new WebrpcClassInfo(class_id_t.AudioElement, "AudioElement", [\r\n        new WebrpcMethodInfo(class_id_t.AudioElement, method_id_AudioElement_t.ctor, "ctor", false),\r\n        new WebrpcMethodInfo(class_id_t.AudioElement, method_id_AudioElement_t.sinkId, "sinkId", true),\r\n        new WebrpcMethodInfo(class_id_t.AudioElement, method_id_AudioElement_t.srcObject, "srcObject", true),\r\n        new WebrpcMethodInfo(class_id_t.AudioElement, method_id_AudioElement_t.src, "src", true),\r\n        new WebrpcMethodInfo(class_id_t.AudioElement, method_id_AudioElement_t.play, "play", false),\r\n        new WebrpcMethodInfo(class_id_t.AudioElement, method_id_AudioElement_t.pause, "pause", false)\r\n    ]),\r\n    //RTCRtpReceiver\r\n    new WebrpcClassInfo(class_id_t.RTCRtpReceiver, "RTCRtpReceiver", [\r\n        new WebrpcMethodInfo(class_id_t.RTCRtpReceiver, method_id_RTCRtpReceiver_t.ctor, "ctor", false, exports.FEATURE_ms_teams_speaking_indicator),\r\n        new WebrpcMethodInfo(class_id_t.RTCRtpReceiver, method_id_RTCRtpReceiver_t.track, "track", true, exports.FEATURE_ms_teams_speaking_indicator),\r\n        new WebrpcMethodInfo(class_id_t.RTCRtpReceiver, method_id_RTCRtpReceiver_t.getContributingSources, "getContributingSources", false, exports.FEATURE_ms_teams_speaking_indicator),\r\n        new WebrpcMethodInfo(class_id_t.RTCRtpReceiver, method_id_RTCRtpReceiver_t.getSynchronizationSources, "getSynchronizationSources", false, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCRtpReceiver, method_id_RTCRtpReceiver_t.transport, "transport", true, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCRtpReceiver, method_id_RTCRtpReceiver_t.rtcpTransport, "rtcptransport", true, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCRtpReceiver, method_id_RTCRtpReceiver_t.getCapabilities, "getCapabilities", false, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCRtpReceiver, method_id_RTCRtpReceiver_t.getParameters, "getParameters", false, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCRtpReceiver, method_id_RTCRtpReceiver_t.getStats, "getStats", false, exports.FEATURE_ms_teams_pstn)\r\n    ]),\r\n    //RTCRtpSender\r\n    new WebrpcClassInfo(class_id_t.RTCRtpSender, "RTCRtpSender", [\r\n        new WebrpcMethodInfo(class_id_t.RTCRtpSender, method_id_RTCRtpSender_t.ctor, "ctor", false, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCRtpSender, method_id_RTCRtpSender_t.track, "track", true, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCRtpSender, method_id_RTCRtpSender_t.transport, "transport", true, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCRtpSender, method_id_RTCRtpSender_t.rtcpTransport, "rtcpTransport", true, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCRtpSender, method_id_RTCRtpSender_t.dtmf, "dtmf", true, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCRtpSender, method_id_RTCRtpSender_t.getCapabilities, "getCapabilities", false, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCRtpSender, method_id_RTCRtpSender_t.getParameters, "getParameters", false, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCRtpSender, method_id_RTCRtpSender_t.setParameters, "setParameters", false, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCRtpSender, method_id_RTCRtpSender_t.replaceTrack, "replaceTrack", false, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCRtpSender, method_id_RTCRtpSender_t.getStats, "getStats", false, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCRtpSender, method_id_RTCRtpSender_t.setStreams, "setStreams", false, exports.FEATURE_ms_teams_pstn),\r\n    ]),\r\n    //RTCDtlsTransport\r\n    new WebrpcClassInfo(class_id_t.RTCDtlsTransport, "RTCDtlsTransport", [\r\n        new WebrpcMethodInfo(class_id_t.RTCDtlsTransport, method_id_RTCDtlsTransport_t.ctor, "ctor", false, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCDtlsTransport, method_id_RTCDtlsTransport_t.transport, "transport", true, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCDtlsTransport, method_id_RTCDtlsTransport_t.state, "state", true, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCDtlsTransport, method_id_RTCDtlsTransport_t.getRemoteCertificates, "getRemoteCertificates", false, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCDtlsTransport, method_id_RTCDtlsTransport_t.onstatechange, "onstatechange", true, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCDtlsTransport, method_id_RTCDtlsTransport_t.onerror, "onerror", true, exports.FEATURE_ms_teams_pstn)\r\n    ]),\r\n    //RTCIceTransport\r\n    new WebrpcClassInfo(class_id_t.RTCIceTransport, "RTCIceTransport", [\r\n        new WebrpcMethodInfo(class_id_t.RTCIceTransport, method_id_RTCIceTransport_t.ctor, "ctor", false, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCIceTransport, method_id_RTCIceTransport_t.role, "role", true, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCIceTransport, method_id_RTCIceTransport_t.component, "component", true, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCIceTransport, method_id_RTCIceTransport_t.state, "state", true, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCIceTransport, method_id_RTCIceTransport_t.gatheringState, "gatheringState", true, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCIceTransport, method_id_RTCIceTransport_t.localcandidates, "localcandidates", true, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCIceTransport, method_id_RTCIceTransport_t.remotecandidates, "remotecandidates", true, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCIceTransport, method_id_RTCIceTransport_t.onstatechange, "onstatechange", true, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCIceTransport, method_id_RTCIceTransport_t.ongatheringstatechange, "ongatheringstatechange", true, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCIceTransport, method_id_RTCIceTransport_t.onselectedcandidatepairchange, "onselectedcandidatepairchange", true, exports.FEATURE_ms_teams_pstn)\r\n    ]),\r\n    //RTCDTMFSender\r\n    new WebrpcClassInfo(class_id_t.RTCDTMFSender, "RTCDTMFSender", [\r\n        new WebrpcMethodInfo(class_id_t.RTCDTMFSender, method_id_RTCDTMFSender_t.ctor, "ctor", false, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCDTMFSender, method_id_RTCDTMFSender_t.insertDTMF, "insertDTMF", false, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCDTMFSender, method_id_RTCDTMFSender_t.ontonechange, "ontonechange", true, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCDTMFSender, method_id_RTCDTMFSender_t.canInsertDTMF, "canInsertDTMF", true, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCDTMFSender, method_id_RTCDTMFSender_t.toneBuffer, "toneBuffer", true, exports.FEATURE_ms_teams_pstn)\r\n    ]),\r\n    //RTCDTMFToneChangeEvent\r\n    new WebrpcClassInfo(class_id_t.RTCDTMFToneChangeEvent, "RTCDTMFToneChangeEvent", [\r\n        new WebrpcMethodInfo(class_id_t.RTCDTMFToneChangeEvent, method_id_RTCDTMFToneChangeEvent_t.ctor, "ctor", false, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCDTMFToneChangeEvent, method_id_RTCDTMFToneChangeEvent_t.tone, "tone", true, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCDTMFToneChangeEvent, method_id_RTCDTMFToneChangeEvent_t.tone_buffer, "tone_buffer", true, exports.FEATURE_ms_teams_pstn)\r\n    ]),\r\n    //RTCDTMFToneChangeEvent\r\n    new WebrpcClassInfo(class_id_t.RTCIceCandidatePair, "RTCIceCandidatePair", [\r\n        new WebrpcMethodInfo(class_id_t.RTCIceCandidatePair, method_id_RTCIceCandidatePair_t.ctor, "ctor", false, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCIceCandidatePair, method_id_RTCIceCandidatePair_t.local, "local", true, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCIceCandidatePair, method_id_RTCIceCandidatePair_t.remote, "remote", true, exports.FEATURE_ms_teams_pstn)\r\n    ]),\r\n    //RTCRtpTransceiver\r\n    new WebrpcClassInfo(class_id_t.RTCRtpTransceiver, "RTCRtpTransceiver", [\r\n        new WebrpcMethodInfo(class_id_t.RTCRtpTransceiver, method_id_RTCRtpTransceiver_t.ctor, "ctor", false, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCRtpTransceiver, method_id_RTCRtpTransceiver_t.mid, "mid", true, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCRtpTransceiver, method_id_RTCRtpTransceiver_t.sender, "sender", true, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCRtpTransceiver, method_id_RTCRtpTransceiver_t.receiver, "receiver", true, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCRtpTransceiver, method_id_RTCRtpTransceiver_t.direction, "direction", true, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCRtpTransceiver, method_id_RTCRtpTransceiver_t.currentDirection, "currentDirection", true, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCRtpTransceiver, method_id_RTCRtpTransceiver_t.stop, "stop", false, exports.FEATURE_ms_teams_pstn),\r\n        new WebrpcMethodInfo(class_id_t.RTCRtpTransceiver, method_id_RTCRtpTransceiver_t.setCodecPreferences, "setCodecPreferences", false, exports.FEATURE_ms_teams_pstn),\r\n    ])\r\n]);\r\n/*----------------- utility methods -----------------*/\r\nvar WebrpcClassLibInfoUtil = /** @class */ (function () {\r\n    function WebrpcClassLibInfoUtil() {\r\n    }\r\n    WebrpcClassLibInfoUtil.getInterfaceByid = function (iid) {\r\n        for (var _i = 0, _a = class_lib_info.classes; _i < _a.length; _i++) {\r\n            var cl = _a[_i];\r\n            if (cl.id == iid) {\r\n                return cl;\r\n            }\r\n        }\r\n        return null;\r\n    };\r\n    //oid is optional parameter\r\n    WebrpcClassLibInfoUtil.getMethodByid = function (iid, mid) {\r\n        var intface = this.getInterfaceByid(iid);\r\n        if (intface != null) {\r\n            for (var _i = 0, _a = intface.methods; _i < _a.length; _i++) {\r\n                var method = _a[_i];\r\n                if (method.mid == mid) {\r\n                    return method;\r\n                }\r\n            }\r\n        }\r\n        return null;\r\n    };\r\n    //oid is optional parameter\r\n    WebrpcClassLibInfoUtil.getMethodFeatureByid = function (iid, mid) {\r\n        var intface = this.getInterfaceByid(iid);\r\n        if (intface != null) {\r\n            for (var _i = 0, _a = intface.methods; _i < _a.length; _i++) {\r\n                var method = _a[_i];\r\n                if (method.mid == mid) {\r\n                    return method.feature;\r\n                }\r\n            }\r\n        }\r\n        return null;\r\n    };\r\n    WebrpcClassLibInfoUtil.composeClassInfoData = function (obj) {\r\n        var hdr = obj[\'hdr\'];\r\n        if (hdr == undefined) {\r\n            return "*** Invalid packet: Couldn\'t find hdr object ***";\r\n        }\r\n        var proc = hdr[\'proc\'];\r\n        if (proc == undefined) {\r\n            return "";\r\n        }\r\n        var iid = proc[\'iid\'];\r\n        var mid = proc[\'methodid\'];\r\n        for (var _i = 0, _a = class_lib_info.classes; _i < _a.length; _i++) {\r\n            var iface = _a[_i];\r\n            if (iface.id != iid) {\r\n                continue;\r\n            }\r\n            for (var _b = 0, _c = iface.methods; _b < _c.length; _b++) {\r\n                var method = _c[_b];\r\n                if (method.mid == mid) {\r\n                    return iface.name + "::" + method.name;\r\n                }\r\n            }\r\n        }\r\n        return "";\r\n    };\r\n    return WebrpcClassLibInfoUtil;\r\n}());\r\nexports.WebrpcClassLibInfoUtil = WebrpcClassLibInfoUtil;\r\n\n\n//# sourceURL=webpack://CitrixWebRTC/E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/webrpcclassinfo.js?');
      },
      "../../../out/shim/sdk/int/sdk/wsjsonutil.js":
      /*!************************************************************************!*\
        !*** E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/wsjsonutil.js ***!
        \************************************************************************/

      /*! no static exports found */
      function outShimSdkIntSdkWsjsonutilJs(module, exports, __webpack_require__) {

        eval('\r\n// general JSON message format:\r\n//\r\n// {\r\n//     "v": "webrtc",\r\n//     "hdr": {\r\n//         "version": 1,\r\n//         "msg_type": "req", // one of: "req", "reply", "event_req", "event_reply"\r\n//         "modifier": false,\r\n//         "proc": {\r\n//             "iid": 0,\r\n//             "methodid": 0\r\n//         }\r\n//     },\r\n//     "objref": {\r\n//         "oid": 0\r\n//     },\r\n//     "params": []\r\n// }\r\nObject.defineProperty(exports, "__esModule", { value: true });\r\nvar webrpcclassinfo_1 = __webpack_require__(/*! ./webrpcclassinfo */ "../../../out/shim/sdk/int/sdk/webrpcclassinfo.js");\r\nvar ws_msg_type_t;\r\n(function (ws_msg_type_t) {\r\n    ws_msg_type_t[ws_msg_type_t["req"] = 0] = "req";\r\n    ws_msg_type_t[ws_msg_type_t["reply"] = 1] = "reply";\r\n    ws_msg_type_t[ws_msg_type_t["event_req"] = 2] = "event_req";\r\n    ws_msg_type_t[ws_msg_type_t["event_reply"] = 3] = "event_reply";\r\n})(ws_msg_type_t = exports.ws_msg_type_t || (exports.ws_msg_type_t = {}));\r\nvar WsJsonUtil = /** @class */ (function () {\r\n    function WsJsonUtil() {\r\n    }\r\n    WsJsonUtil.createMessageByid = function (modifier, //true for set prop, false for get prop\r\n    destroy, mt, //ws msg type\r\n    iid, //interface id\r\n    mid, //method id\r\n    oid) {\r\n        var args = []; //parameters\r\n        for (var _i = 6 //parameters\r\n        ; _i < arguments.length //parameters\r\n        ; _i++ //parameters\r\n        ) {\r\n            args[_i - 6] = arguments[_i]; //parameters\r\n        }\r\n        var mInfo = webrpcclassinfo_1.WebrpcClassLibInfoUtil.getMethodByid(iid, mid);\r\n        if (!mInfo || !mInfo.isprop) {\r\n            modifier = false;\r\n        }\r\n        return this.createMessage.apply(this, [mt, modifier, destroy, iid, mid, oid].concat(args));\r\n    };\r\n    WsJsonUtil.createMessage = function (mt, rwprop, release, iid, mid, oid) {\r\n        var args = [];\r\n        for (var _i = 6; _i < arguments.length; _i++) {\r\n            args[_i - 6] = arguments[_i];\r\n        }\r\n        return {\r\n            /**@nocollapse*/ v: \'webrtc\',\r\n            /**@nocollapse*/ hdr: {\r\n                /**@nocollapse*/ version: this._version,\r\n                /**@nocollapse*/ msg_type: this.getMsgType(mt),\r\n                /**@nocollapse*/ modifier: rwprop,\r\n                /**@nocollapse*/ destroy: release,\r\n                /**@nocollapse*/ proc: {\r\n                    /**@nocollapse*/ iid: iid,\r\n                    /**@nocollapse*/ methodid: mid\r\n                }\r\n            },\r\n            /**@nocollapse*/ objref: {\r\n                /**@nocollapse*/ "oid": oid\r\n            },\r\n            /**@nocollapse*/ params: args.slice()\r\n        };\r\n    };\r\n    WsJsonUtil.getMsgType = function (mt) {\r\n        var mts = \'\';\r\n        switch (mt) {\r\n            case ws_msg_type_t.req:\r\n            default:\r\n                mts = \'req\';\r\n                break;\r\n            case ws_msg_type_t.reply:\r\n                mts = \'reply\';\r\n                break;\r\n            case ws_msg_type_t.event_req:\r\n                mts = \'event-req\';\r\n                break;\r\n            case ws_msg_type_t.event_reply:\r\n                mts = \'event-reply\';\r\n                break;\r\n        }\r\n        return mts;\r\n    };\r\n    WsJsonUtil._version = 1;\r\n    return WsJsonUtil;\r\n}());\r\nexports.WsJsonUtil = WsJsonUtil;\r\n\n\n//# sourceURL=webpack://CitrixWebRTC/E:/work/6e71a05e16fb6ac6/MTOP/out/shim/sdk/int/sdk/wsjsonutil.js?');
      }
    });
  });
}

var vdiCitrix = null;
var originalGetUserMedia;
var originalEnumerateDevices;
var originalPeerConnection; // this is purely only used for debugging by simulating citrix VDI connection events.

window.handleCitrixEventCallback = handleCitrixEventCallback;

function registerWebRtcGlobals() {
  console.log('Registering WebRTC Globals');
  initCitrixWebRTC();
  vdiCitrix = window.CitrixWebRTC;
  originalGetUserMedia = navigator.mediaDevices.getUserMedia;
  originalEnumerateDevices = navigator.mediaDevices.enumerateDevices;
  originalPeerConnection = global.RTCPeerConnection; // Should not happen. React Native has a global navigator object.

  if (typeof navigator !== 'object') {
    throw new Error('navigator is not an object');
  }

  console.log('VDICitrix', vdiCitrix);
  vdiCitrix.setVMEventCallback(handleCitrixEventCallback);
}

function restoreOriginalWebRtc() {
  window.citrixVdaSupport = false;
  Janus.setUnifiedPlan(true);
  navigator.mediaDevices.getUserMedia = originalGetUserMedia;
  navigator.mediaDevices.enumerateDevices = originalEnumerateDevices;
  global.RTCPeerConnection = originalPeerConnection;
}

function replaceWebRtcWithCitrix() {
  function getUserMedia(constraints) {
    return new Promise(function (resolve, reject) {
      return vdiCitrix.getUserMedia(constraints, resolve, reject);
    });
  }

  var AsyncPeerConnection = /*#__PURE__*/function (_vdiCitrix$CitrixPeer) {
    _inheritsLoose(AsyncPeerConnection, _vdiCitrix$CitrixPeer);

    function AsyncPeerConnection() {
      return _vdiCitrix$CitrixPeer.apply(this, arguments) || this;
    }

    var _proto = AsyncPeerConnection.prototype;

    _proto.createOffer = function createOffer(options) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        _vdiCitrix$CitrixPeer.prototype.createOffer.call(_this, resolve, reject, options);
      });
    };

    _proto.createAnswer = function createAnswer(options) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        _vdiCitrix$CitrixPeer.prototype.createAnswer.call(_this2, resolve, reject, options);
      });
    };

    _proto.setLocalDescription = function setLocalDescription(description) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        _vdiCitrix$CitrixPeer.prototype.setLocalDescription.call(_this3, description, resolve, reject);
      });
    };

    _proto.setRemoteDescription = function setRemoteDescription(description) {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        _vdiCitrix$CitrixPeer.prototype.setRemoteDescription.call(_this4, description, resolve, reject);
      });
    };

    return AsyncPeerConnection;
  }(vdiCitrix.CitrixPeerConnection);

  window.citrixVdaSupport = true; // we can assume true because register should only be called when it was true.

  Janus.setUnifiedPlan(false);

  if (!navigator.mediaDevices) {
    // @ts-ignore
    navigator.mediaDevices = {};
  }

  navigator.mediaDevices.getUserMedia = getUserMedia;
  navigator.mediaDevices.enumerateDevices = vdiCitrix.enumerateDevices.bind(vdiCitrix);
  global.RTCPeerConnection = AsyncPeerConnection; // global.RTCIceCandidate = RTCIceCandidate;
  // global.RTCSessionDescription = vdiCitrix.RTCSessionDescription;
  // global.MediaStream = MediaStream;
  // global.MediaStreamTrack = MediaStreamTrack;     
}

function handleCitrixEventCallback(event) {
  console.info('VM Event Callback', event);

  if (event.event === 'vdiClientDisconnected') {
    console.warn('Citrix VDI client disconnected, falling back to standard WebRTC implementation');
    restoreOriginalWebRtc();
  } else if (event.event === 'vdiClientConnected') {
    console.info('Citrix VDI Client connected, switching to Citrix WebRTC implementation');
    replaceWebRtcWithCitrix();
  }
}

function WebRtcClient(props) {
  var endpoint = useSelector(selectEndpoint);
  var line = useSelector(selectLine);
  var call = useSelector(selectCall);

  var _useState = useState(false),
      initialised = _useState[0],
      setInitialised = _useState[1];

  var dispatch = useDispatch();
  useEffect(function () {
    if (endpoint.status === 'offline' && !initialised) {
      dispatch(initApp());

      if (window.citrixVdaSupport === true) {
        console.info('Citrix Vda Support, overriding WebRTC implementation');
        registerWebRtcGlobals();
      }

      setInitialised(true);
    }
  }, [dispatch, endpoint.status, initialised]);
  useEffect(function () {
    dispatch(configureEndpoint(props.settings));
  }, [dispatch, props.settings]);
  useEffect(function () {
    if (!props.enabled && endpoint.canDisconnect) {
      console.log('Softphone is being disabled, disconnecting...');
      dispatch(disconnectEndpoint());
    }
  }, [dispatch, endpoint.canDisconnect, props.enabled]);
  return React__default.createElement("div", {
    className: classNames(css.app, props.className)
  }, renderApp());

  function renderApp() {
    if (endpoint.status !== 'online' || endpoint.statusError || line.statusError || line.status === 'registering' || line.status === 'unregistered') {
      return React__default.createElement(ConnectScreen, {
        enabled: props.enabled,
        extension: props.extension,
        pin: props.pin
      });
    }

    return React__default.createElement(React__default.Fragment, null, React__default.createElement(Phone, null), React__default.createElement(Audio, null), React__default.createElement(Ringer, null), React__default.createElement("div", {
      className: css.logout
    }, !call.canHangUp && endpoint.canDisconnect && React__default.createElement("button", {
      onClick: function onClick() {
        return dispatch(disconnectEndpoint());
      }
    }, React__default.createElement(ForwardRef$5, null))), props.children);
  }
}

var css$9 = {"automationTestContainer":"AutomationTest-module_automationTestContainer__D8jnx","toggle":"AutomationTest-module_toggle__234Wf","startStopContainer":"AutomationTest-module_startStopContainer__1s6Es","allowActionsList":"AutomationTest-module_allowActionsList__1p_RH","status":"AutomationTest-module_status__19HaR","error":"AutomationTest-module_error__1L87T"};

var _window$ipcRenderer;
var ipcRenderer = (_window$ipcRenderer = window.ipcRenderer) != null ? _window$ipcRenderer : null;
var ChannelName = 'automation-test';
var ActionType;

(function (ActionType) {
  ActionType["Dial"] = "Dial";
  ActionType["WaitForAnswer"] = "Wait For Answer";
  ActionType["Answer"] = "Answer";
  ActionType["HangUp"] = "Hang Up";
  ActionType["Hold"] = "Hold";
  ActionType["Resume"] = "Resume";
  ActionType["Idle"] = "Idle";
})(ActionType || (ActionType = {}));

function getRandomInt(max) {
  return Math.floor(Math.random() * Math.floor(max));
}

function AutomationTest() {
  var endpoint = useSelector(selectEndpoint);
  var line = useSelector(selectLine);
  var call = useSelector(selectCall);
  var dispatch = useDispatch();

  var _useState = useState(false),
      endpointOnline = _useState[0],
      setEndpointOnline = _useState[1];

  var _useState2 = useState(null),
      nextAction = _useState2[0],
      setNextAction = _useState2[1];

  var _useState3 = useState(0),
      nextActionRemainingTime = _useState3[0],
      setNextActionRemainingTime = _useState3[1];

  var _useState4 = useState(false),
      isRunning = _useState4[0],
      setIsRunning = _useState4[1];

  var retryCount = useRef(0);
  var extension = useRef(null);
  var pin = useRef(null);

  var _useState5 = useState(),
      allowableActions = _useState5[0],
      setAllowableActions = _useState5[1];

  var _useState6 = useState(''),
      autoDialNumber = _useState6[0],
      setAutoDialNumber = _useState6[1];

  var _useState7 = useState(true),
      autoAnswer = _useState7[0],
      setAutoAnswer = _useState7[1];

  var _useState8 = useState(true),
      allowHoldResume = _useState8[0],
      setAllowHoldResume = _useState8[1];

  var _useState9 = useState(true),
      allowHangUp = _useState9[0],
      setAllowHangUp = _useState9[1];

  var _useState10 = useState(true),
      allowIdle = _useState10[0],
      setAllowIdle = _useState10[1];

  var _useState11 = useState(2000),
      minDelayMs = _useState11[0],
      setMinDelayMs = _useState11[1];

  var _useState12 = useState(8000),
      maxDelayMs = _useState12[0],
      setMaxDelayMs = _useState12[1];

  var scheduleNextAction = useCallback(function (action, work, delayMs) {
    if (nextAction == null) {
      console.log("Scheduling Automation Work: " + action);

      var performWork = function performWork() {
        console.log("Performing Automation Work: " + action);
        work();
        setNextAction(null);
        setNextActionRemainingTime(0);
      };

      var workAction = {
        Action: action,
        PerformWork: performWork,
        DelayMs: delayMs
      };
      setNextActionRemainingTime(delayMs);
      setNextAction(workAction);
    }
  }, [nextAction]);
  var configureAutoAnswerMode = useCallback(function () {
    setAutoDialNumber('');
    setAutoAnswer(true);
    setAllowHoldResume(false);
    setAllowHangUp(false);
    setAllowIdle(false);
    setMinDelayMs(0);
    setMaxDelayMs(0);
  }, []);
  useEffect(function () {
    // by default we configure to nzvoip02
    var queryParams = new URLSearchParams(window.location.search);
    if (queryParams == null) return;
    extension.current = queryParams.get('extension');
    pin.current = queryParams.get('pin');
    var autoAnswerMode = queryParams.get('autoAnswerMode');

    if (queryParams.get('onIncomingCall')) {
      setAutoAnswer(false);
    }

    if (extension.current != null && pin.current != null) {
      dispatch(connectEndpoint(extension.current, pin.current));
    }

    if (autoAnswerMode != null) {
      configureAutoAnswerMode();
      setIsRunning(true);
    }
  }, [configureAutoAnswerMode, dispatch]);
  useEffect(function () {
    if (ipcRenderer === null) return;

    var onAutomationTestCommandEvent = function onAutomationTestCommandEvent(_, args) {
      console.log(ChannelName, args);

      switch (args.Command) {
        case 'connect':
          dispatch(configureEndpoint(args.Settings));
          dispatch(connectEndpoint(args.Extension, args.Pin));
          args.Result = true;
          ipcRenderer.send(ChannelName + "-result", args);
          break;

        case 'disconnect':
          args.Result = false;
          ipcRenderer.send(ChannelName + "-result", args);
          break;

        case 'auto-answer-mode':
          configureAutoAnswerMode();
          setIsRunning(true);
          args.Result = true;
          ipcRenderer.send(ChannelName + "-result", args);
          break;
      }
    };

    ipcRenderer.on(ChannelName, onAutomationTestCommandEvent);
    return function () {
      ipcRenderer.removeListener("{ChannelName}-result", onAutomationTestCommandEvent);
    };
  }, [configureAutoAnswerMode, dispatch]);
  useEffect(function () {
    if (nextActionRemainingTime > 0) {
      // not exactly the most accurate, but good enough for the purpose.
      setTimeout(function () {
        return setNextActionRemainingTime(nextActionRemainingTime - 100);
      }, 100);
    } else if (nextAction != null) {
      nextAction.PerformWork();
    }
  }, [nextAction, nextActionRemainingTime]);
  useEffect(function () {
    if (isRunning) return; // no longer running

    if (nextAction != null) {
      console.log('clearing next action');

      if (call != null && call.canHangUp) {
        dispatch(hangUp());
      }

      setNextAction(null);
    }
  }, [call, dispatch, isRunning, nextAction]);
  useEffect(function () {
    var isOnline = line.status === 'registered' && endpoint.status === 'online';

    if (isOnline && retryCount.current > 0) {
      retryCount.current = 0;
    }

    if (ipcRenderer != null && !endpointOnline && isOnline) {
      console.log('sending endpoint online');
      ipcRenderer.send('endpoint-online', true);
      setEndpointOnline(true);
    } else if (ipcRenderer != null && endpointOnline && (line.status !== 'registered' || endpoint.status !== 'online')) {
      console.log('sending endpoint offline');
      ipcRenderer.send('endpoint-online', false);
      setEndpointOnline(false);
    }

    if (!isRunning) return;

    if (line.statusError === '403 Forbidden' && line.status === 'registering') {
      retryCount.current = 999;
    }

    if (retryCount.current < 3 && endpoint.canConnect && extension.current != null && pin.current != null && (line.status !== 'registered' || endpoint.status !== 'online')) {
      console.log('Not connected, will try in 5s');
      retryCount.current += 1;
      setTimeout(function () {
        console.log('Attempt to auto reconnect, retryCount', retryCount.current);

        if (endpoint.canConnect && (line.status !== 'registered' || endpoint.status !== 'online')) {
          dispatch(connectEndpoint(extension.current, pin.current));
        } else {
          console.log('Endpoint says we cannot connect yet');
        }
      }, 5000);
    }
  }, [dispatch, endpoint.canConnect, endpoint.status, endpointOnline, isRunning, line.status, line.statusError]);
  useEffect(function () {
    var interval = setInterval(function () {
      if (!isRunning) return;
      if (nextAction != null) return;
      if (line.status !== 'registered' || endpoint.status === 'offline') return;
      if (line.statusError != null || endpoint.statusError != null) return;
      var allowableActions = [];

      if (allowIdle) {
        allowableActions.push(ActionType.Idle);
      }

      if (call != null && call.canDial && autoDialNumber.length > 0) {
        allowableActions.push(ActionType.Dial);
      }

      if (call.canAnswer && !call.answerRequested) {
        allowableActions.push(ActionType.Answer);
      }

      if (call.canHold && allowHoldResume) {
        allowableActions.push(ActionType.Hold);
      }

      if (call.canResume && allowHoldResume) {
        allowableActions.push(ActionType.Resume);
      }

      if (call.canHangUp && allowHangUp) {
        allowableActions.push(ActionType.HangUp);
      }

      if (allowableActions.length === 0) {
        setAllowableActions(allowableActions);
        return;
      }

      var index = getRandomInt(allowableActions.length);
      var minDelay = Number.isNaN(minDelayMs) ? 0 : minDelayMs;
      var maxDelay = Number.isNaN(maxDelayMs) ? 0 : maxDelayMs;
      var delay = maxDelay < minDelay ? minDelay : minDelay + getRandomInt(maxDelay - minDelay);

      switch (allowableActions[index]) {
        case ActionType.Dial:
          scheduleNextAction(ActionType.Dial, function () {
            if (call != null && call.canDial && autoDialNumber.length > 0) {
              dispatch(dial(autoDialNumber));
            }
          }, delay);
          break;

        case ActionType.Answer:
          scheduleNextAction(ActionType.Answer, function () {
            if (call != null && call.canAnswer) {
              dispatch(answer());
            }
          }, delay);
          break;

        case ActionType.Hold:
          scheduleNextAction(allowableActions[index], function () {
            if (call.canHold) {
              dispatch(hold());
            }
          }, delay);
          break;

        case ActionType.Resume:
          scheduleNextAction(allowableActions[index], function () {
            if (call.canResume) {
              dispatch(resume());
            }
          }, delay);
          break;

        case ActionType.HangUp:
          scheduleNextAction(allowableActions[index], function () {
            if (call.canHangUp) {
              dispatch(hangUp());
            }
          }, delay);
          break;

        case ActionType.Idle:
          scheduleNextAction(allowableActions[index], function () {}, delay);
          break;
      }

      setAllowableActions(allowableActions);
    }, 1000);
    return function () {
      return clearInterval(interval);
    };
  }, [allowHangUp, allowHoldResume, allowIdle, autoDialNumber, call, dispatch, endpoint.status, endpoint.statusError, isRunning, line.status, line.statusError, maxDelayMs, minDelayMs, nextAction, scheduleNextAction]);
  return React__default.createElement("div", null, React__default.createElement("div", {
    className: css$9.automationTestContainer
  }, React__default.createElement("h2", null, "WebRTC Softphone Test"), React__default.createElement("div", {
    className: css$9.status
  }, "Endpoint Status: ", endpoint.status), endpoint.statusError && React__default.createElement("div", {
    className: css$9.error
  }, endpoint.statusError), line.statusError && React__default.createElement("div", {
    className: css$9.error
  }, line.statusError), React__default.createElement("div", {
    className: css$9.status
  }, "Line Status: ", line.status), React__default.createElement("label", null, "Auto Dial", React__default.createElement("input", {
    type: 'number',
    value: autoDialNumber,
    onChange: function onChange(e) {
      return setAutoDialNumber(e.currentTarget.value);
    }
  })), React__default.createElement(Toggle, {
    className: css$9.toggle,
    value: autoAnswer,
    onChange: function onChange(value) {
      return setAutoAnswer(value);
    }
  }, "Auto Answer Calls"), React__default.createElement(Toggle, {
    className: css$9.toggle,
    value: allowHangUp,
    onChange: function onChange(value) {
      return setAllowHangUp(value);
    }
  }, "Allow Hang Up"), React__default.createElement(Toggle, {
    className: css$9.toggle,
    value: allowHoldResume,
    onChange: function onChange(value) {
      return setAllowHoldResume(value);
    }
  }, "Allow Hold/Resume"), React__default.createElement(Toggle, {
    className: css$9.toggle,
    value: allowIdle,
    onChange: function onChange(value) {
      return setAllowIdle(value);
    }
  }, "Allow Idle"), React__default.createElement("label", null, "Min Delay", React__default.createElement("input", {
    type: 'number',
    value: minDelayMs,
    onChange: function onChange(e) {
      return setMinDelayMs(e.currentTarget.valueAsNumber);
    },
    min: 1000
  })), React__default.createElement("label", null, "Max Delay", React__default.createElement("input", {
    type: 'number',
    value: maxDelayMs,
    onChange: function onChange(e) {
      return setMaxDelayMs(e.currentTarget.valueAsNumber);
    },
    min: 1000
  })), React__default.createElement("div", {
    className: css$9.status
  }, "Allowable Actions:"), allowableActions && React__default.createElement("ul", {
    className: css$9.allowActionsList
  }, allowableActions.map(function (action) {
    return React__default.createElement("li", null, action);
  })), React__default.createElement("div", {
    className: css$9.status
  }, "Next Action: ", nextAction == null ? 'None' : nextAction.Action + " in " + nextActionRemainingTime + "ms", " "), React__default.createElement("div", {
    className: css$9.startStopContainer
  }, React__default.createElement("button", {
    disabled: isRunning,
    onClick: function onClick() {
      return setIsRunning(true);
    }
  }, "Start"), React__default.createElement("button", {
    disabled: !isRunning,
    onClick: function onClick() {
      return setIsRunning(false);
    }
  }, "Stop"))));
}

var css$a = {"deviceSelectionContainer":"DeviceSelection-module_deviceSelectionContainer__RXpuv"};

function DeviceSelection() {
  var dispatch = useDispatch();

  var _useState = useState([]),
      devices = _useState[0],
      setDevices = _useState[1];

  useEffect(function () {
    navigator.mediaDevices.enumerateDevices().then(function (devices) {
      var d = devices.filter(function (info) {
        return info.kind === 'audiooutput';
      }).map(function (info) {
        return {
          id: info.deviceId,
          displayName: info.label
        };
      });
      setDevices([{
        id: '',
        displayName: 'No Secondary Ringer'
      }].concat(d));
    })["catch"](function (reason) {
      console.error('failed to enumerate devices', reason);
    });
  }, []);
  return React__default.createElement("div", null, React__default.createElement("div", {
    className: css$a.deviceSelectionContainer
  }, React__default.createElement("h2", null, "Devices"), React__default.createElement("h3", null, "Secondary Ringer Device"), React__default.createElement("select", {
    id: 'secondaryRingerAudioDeviceId',
    onChange: function onChange(e) {
      console.info('onchanged called', e.currentTarget.value);
      dispatch(configureSecondaryRinger(e.currentTarget.value));
    }
  }, devices.map(function (device) {
    return React__default.createElement("option", {
      key: device.id,
      value: device.id
    }, device.displayName);
  }))));
}

var css$b = {"webRtcClientConfiguratorContainer":"WebRtcClientConfigurator-module_webRtcClientConfiguratorContainer__s_Cpv","toggle":"WebRtcClientConfigurator-module_toggle__1C6Ah","applyContainer":"WebRtcClientConfigurator-module_applyContainer__DZUWj"};

function WebRtcClientConfigurator() {
  var _useSelector = useSelector(function (s) {
    return s.janus;
  }),
      endpoint = _useSelector.endpoint,
      line = _useSelector.line,
      settings = _useSelector.settings;

  var dispatch = useDispatch();

  var _useState = useState(settings),
      settingsState = _useState[0],
      setSettingsState = _useState[1];

  function commitConfiguration() {
    dispatch(configureEndpoint(settingsState));
  }

  useEffect(function () {
    setSettingsState(settings);
  }, [settings]);

  function input(prop, label, type) {
    if (type === void 0) {
      type = 'text';
    }

    return React__default.createElement("label", null, label, React__default.createElement("input", {
      type: type,
      value: settingsState[prop],
      onChange: function onChange(e) {
        var value = e.currentTarget.value;
        setSettingsState(function (s) {
          var _extends2;

          return _extends({}, s, (_extends2 = {}, _extends2[prop] = value, _extends2));
        });
      }
    }));
  }

  return React__default.createElement("div", null, React__default.createElement("div", {
    className: css$b.webRtcClientConfiguratorContainer
  }, React__default.createElement("h2", null, "WebRTC Softphone Configuration"), React__default.createElement("div", {
    className: css$b.status
  }, "Endpoint Status: ", endpoint.status), endpoint.statusError && React__default.createElement("div", {
    className: css$b.error
  }, endpoint.statusError), line.statusError && React__default.createElement("div", {
    className: css$b.error
  }, line.statusError), React__default.createElement("div", {
    className: css$b.status
  }, "Line Status: ", line.status), input('janus', 'Janus Server'), input('sipRealm', 'Sip Realm'), input('serverUsername', 'Server Username'), input('serverPassword', 'Server Password'), input('turnServer', 'Turn Server'), input('turnServerUdpPort', 'Turn UDP Port', 'number'), input('turnServerTcpPort', 'Turn TCP Port', 'number'), input('turnUsername', 'Turn Username'), input('turnPassword', 'Turn Password'), React__default.createElement("div", {
    className: css$b.applyContainer
  }, React__default.createElement("button", {
    onClick: function onClick() {
      return commitConfiguration();
    }
  }, "Apply"))));
}

function setWindowHandlerAccessor(accessor) {
  window.getWindowHandleAsHex = accessor;
}

export { Audio, AutomationTest, ForwardRef as BackIcon, ForwardRef$1 as BackspaceIcon, CallStatusErrorCode, ForwardRef$2 as ConnectionDownLinkIcon, ForwardRef$3 as ConnectionStatusIcon, ForwardRef$4 as ConnectionUpLinkIcon, CreateEndpointView, DeviceSelection, Janus, Keypad, ForwardRef$5 as LogOutIcon, ForwardRef$6 as PhoneDialIcon, ForwardRef$7 as PhoneDialVideoIcon, ForwardRef$8 as PhoneHangUpIcon, ForwardRef$9 as PhoneHoldIcon, ForwardRef$a as PhoneKeypadIcon, ForwardRef$b as PhoneMicrophoneIcon, ForwardRef$c as PhoneMicrophoneMutedIcon, ForwardRef$d as PhoneResumeIcon, ForwardRef$e as PhoneShareScreenIcon, ForwardRef$f as PhoneVideoIcon, Ringer, Video, WebRtcClient, WebRtcClientConfigurator, createRootReducer as createWebRtcReducer, isCallConnected, selectCall, selectEndpoint, selectJanus, selectLine, selectSettings, setWindowHandlerAccessor, actions as webrtcActions, index as webrtcSaga };
//# sourceMappingURL=webrtc-client-janus.esm.js.map
